"use strict";
/* Auto-generated icon map */
Object.defineProperty(exports, "__esModule", { value: true });
const _500px_svg_1 = require("../src/icons/brands/500px.svg");
const accessible_icon_svg_1 = require("../src/icons/brands/accessible-icon.svg");
const accusoft_svg_1 = require("../src/icons/brands/accusoft.svg");
const acquisitions_incorporated_svg_1 = require("../src/icons/brands/acquisitions-incorporated.svg");
const adn_svg_1 = require("../src/icons/brands/adn.svg");
const adversal_svg_1 = require("../src/icons/brands/adversal.svg");
const affiliatetheme_svg_1 = require("../src/icons/brands/affiliatetheme.svg");
const airbnb_svg_1 = require("../src/icons/brands/airbnb.svg");
const algolia_svg_1 = require("../src/icons/brands/algolia.svg");
const alipay_svg_1 = require("../src/icons/brands/alipay.svg");
const amazon_pay_svg_1 = require("../src/icons/brands/amazon-pay.svg");
const amazon_svg_1 = require("../src/icons/brands/amazon.svg");
const amilia_svg_1 = require("../src/icons/brands/amilia.svg");
const android_svg_1 = require("../src/icons/brands/android.svg");
const angellist_svg_1 = require("../src/icons/brands/angellist.svg");
const angrycreative_svg_1 = require("../src/icons/brands/angrycreative.svg");
const angular_svg_1 = require("../src/icons/brands/angular.svg");
const app_store_ios_svg_1 = require("../src/icons/brands/app-store-ios.svg");
const app_store_svg_1 = require("../src/icons/brands/app-store.svg");
const apper_svg_1 = require("../src/icons/brands/apper.svg");
const apple_pay_svg_1 = require("../src/icons/brands/apple-pay.svg");
const apple_svg_1 = require("../src/icons/brands/apple.svg");
const artstation_svg_1 = require("../src/icons/brands/artstation.svg");
const asymmetrik_svg_1 = require("../src/icons/brands/asymmetrik.svg");
const atlassian_svg_1 = require("../src/icons/brands/atlassian.svg");
const audible_svg_1 = require("../src/icons/brands/audible.svg");
const autoprefixer_svg_1 = require("../src/icons/brands/autoprefixer.svg");
const avianex_svg_1 = require("../src/icons/brands/avianex.svg");
const aviato_svg_1 = require("../src/icons/brands/aviato.svg");
const aws_svg_1 = require("../src/icons/brands/aws.svg");
const bandcamp_svg_1 = require("../src/icons/brands/bandcamp.svg");
const battle_net_svg_1 = require("../src/icons/brands/battle-net.svg");
const behance_square_svg_1 = require("../src/icons/brands/behance-square.svg");
const behance_svg_1 = require("../src/icons/brands/behance.svg");
const bimobject_svg_1 = require("../src/icons/brands/bimobject.svg");
const bitbucket_svg_1 = require("../src/icons/brands/bitbucket.svg");
const bitcoin_svg_1 = require("../src/icons/brands/bitcoin.svg");
const bity_svg_1 = require("../src/icons/brands/bity.svg");
const black_tie_svg_1 = require("../src/icons/brands/black-tie.svg");
const blackberry_svg_1 = require("../src/icons/brands/blackberry.svg");
const blogger_b_svg_1 = require("../src/icons/brands/blogger-b.svg");
const blogger_svg_1 = require("../src/icons/brands/blogger.svg");
const bluetooth_b_svg_1 = require("../src/icons/brands/bluetooth-b.svg");
const bluetooth_svg_1 = require("../src/icons/brands/bluetooth.svg");
const bootstrap_svg_1 = require("../src/icons/brands/bootstrap.svg");
const btc_svg_1 = require("../src/icons/brands/btc.svg");
const buffer_svg_1 = require("../src/icons/brands/buffer.svg");
const buromobelexperte_svg_1 = require("../src/icons/brands/buromobelexperte.svg");
const buy_n_large_svg_1 = require("../src/icons/brands/buy-n-large.svg");
const buysellads_svg_1 = require("../src/icons/brands/buysellads.svg");
const canadian_maple_leaf_svg_1 = require("../src/icons/brands/canadian-maple-leaf.svg");
const cc_amazon_pay_svg_1 = require("../src/icons/brands/cc-amazon-pay.svg");
const cc_amex_svg_1 = require("../src/icons/brands/cc-amex.svg");
const cc_apple_pay_svg_1 = require("../src/icons/brands/cc-apple-pay.svg");
const cc_diners_club_svg_1 = require("../src/icons/brands/cc-diners-club.svg");
const cc_discover_svg_1 = require("../src/icons/brands/cc-discover.svg");
const cc_jcb_svg_1 = require("../src/icons/brands/cc-jcb.svg");
const cc_mastercard_svg_1 = require("../src/icons/brands/cc-mastercard.svg");
const cc_paypal_svg_1 = require("../src/icons/brands/cc-paypal.svg");
const cc_stripe_svg_1 = require("../src/icons/brands/cc-stripe.svg");
const cc_visa_svg_1 = require("../src/icons/brands/cc-visa.svg");
const centercode_svg_1 = require("../src/icons/brands/centercode.svg");
const centos_svg_1 = require("../src/icons/brands/centos.svg");
const chrome_svg_1 = require("../src/icons/brands/chrome.svg");
const chromecast_svg_1 = require("../src/icons/brands/chromecast.svg");
const cloudflare_svg_1 = require("../src/icons/brands/cloudflare.svg");
const cloudscale_svg_1 = require("../src/icons/brands/cloudscale.svg");
const cloudsmith_svg_1 = require("../src/icons/brands/cloudsmith.svg");
const cloudversify_svg_1 = require("../src/icons/brands/cloudversify.svg");
const codepen_svg_1 = require("../src/icons/brands/codepen.svg");
const codiepie_svg_1 = require("../src/icons/brands/codiepie.svg");
const confluence_svg_1 = require("../src/icons/brands/confluence.svg");
const connectdevelop_svg_1 = require("../src/icons/brands/connectdevelop.svg");
const contao_svg_1 = require("../src/icons/brands/contao.svg");
const cotton_bureau_svg_1 = require("../src/icons/brands/cotton-bureau.svg");
const cpanel_svg_1 = require("../src/icons/brands/cpanel.svg");
const creative_commons_by_svg_1 = require("../src/icons/brands/creative-commons-by.svg");
const creative_commons_nc_eu_svg_1 = require("../src/icons/brands/creative-commons-nc-eu.svg");
const creative_commons_nc_jp_svg_1 = require("../src/icons/brands/creative-commons-nc-jp.svg");
const creative_commons_nc_svg_1 = require("../src/icons/brands/creative-commons-nc.svg");
const creative_commons_nd_svg_1 = require("../src/icons/brands/creative-commons-nd.svg");
const creative_commons_pd_alt_svg_1 = require("../src/icons/brands/creative-commons-pd-alt.svg");
const creative_commons_pd_svg_1 = require("../src/icons/brands/creative-commons-pd.svg");
const creative_commons_remix_svg_1 = require("../src/icons/brands/creative-commons-remix.svg");
const creative_commons_sa_svg_1 = require("../src/icons/brands/creative-commons-sa.svg");
const creative_commons_sampling_plus_svg_1 = require("../src/icons/brands/creative-commons-sampling-plus.svg");
const creative_commons_sampling_svg_1 = require("../src/icons/brands/creative-commons-sampling.svg");
const creative_commons_share_svg_1 = require("../src/icons/brands/creative-commons-share.svg");
const creative_commons_zero_svg_1 = require("../src/icons/brands/creative-commons-zero.svg");
const creative_commons_svg_1 = require("../src/icons/brands/creative-commons.svg");
const critical_role_svg_1 = require("../src/icons/brands/critical-role.svg");
const css3_alt_svg_1 = require("../src/icons/brands/css3-alt.svg");
const css3_svg_1 = require("../src/icons/brands/css3.svg");
const cuttlefish_svg_1 = require("../src/icons/brands/cuttlefish.svg");
const d_and_d_beyond_svg_1 = require("../src/icons/brands/d-and-d-beyond.svg");
const d_and_d_svg_1 = require("../src/icons/brands/d-and-d.svg");
const dailymotion_svg_1 = require("../src/icons/brands/dailymotion.svg");
const dashcube_svg_1 = require("../src/icons/brands/dashcube.svg");
const deezer_svg_1 = require("../src/icons/brands/deezer.svg");
const delicious_svg_1 = require("../src/icons/brands/delicious.svg");
const deploydog_svg_1 = require("../src/icons/brands/deploydog.svg");
const deskpro_svg_1 = require("../src/icons/brands/deskpro.svg");
const dev_svg_1 = require("../src/icons/brands/dev.svg");
const deviantart_svg_1 = require("../src/icons/brands/deviantart.svg");
const dhl_svg_1 = require("../src/icons/brands/dhl.svg");
const diaspora_svg_1 = require("../src/icons/brands/diaspora.svg");
const digg_svg_1 = require("../src/icons/brands/digg.svg");
const digital_ocean_svg_1 = require("../src/icons/brands/digital-ocean.svg");
const discord_svg_1 = require("../src/icons/brands/discord.svg");
const discourse_svg_1 = require("../src/icons/brands/discourse.svg");
const dochub_svg_1 = require("../src/icons/brands/dochub.svg");
const docker_svg_1 = require("../src/icons/brands/docker.svg");
const draft2digital_svg_1 = require("../src/icons/brands/draft2digital.svg");
const dribbble_square_svg_1 = require("../src/icons/brands/dribbble-square.svg");
const dribbble_svg_1 = require("../src/icons/brands/dribbble.svg");
const dropbox_svg_1 = require("../src/icons/brands/dropbox.svg");
const drupal_svg_1 = require("../src/icons/brands/drupal.svg");
const dyalog_svg_1 = require("../src/icons/brands/dyalog.svg");
const earlybirds_svg_1 = require("../src/icons/brands/earlybirds.svg");
const ebay_svg_1 = require("../src/icons/brands/ebay.svg");
const edge_legacy_svg_1 = require("../src/icons/brands/edge-legacy.svg");
const edge_svg_1 = require("../src/icons/brands/edge.svg");
const elementor_svg_1 = require("../src/icons/brands/elementor.svg");
const ello_svg_1 = require("../src/icons/brands/ello.svg");
const ember_svg_1 = require("../src/icons/brands/ember.svg");
const empire_svg_1 = require("../src/icons/brands/empire.svg");
const envira_svg_1 = require("../src/icons/brands/envira.svg");
const erlang_svg_1 = require("../src/icons/brands/erlang.svg");
const ethereum_svg_1 = require("../src/icons/brands/ethereum.svg");
const etsy_svg_1 = require("../src/icons/brands/etsy.svg");
const evernote_svg_1 = require("../src/icons/brands/evernote.svg");
const expeditedssl_svg_1 = require("../src/icons/brands/expeditedssl.svg");
const facebook_f_svg_1 = require("../src/icons/brands/facebook-f.svg");
const facebook_messenger_svg_1 = require("../src/icons/brands/facebook-messenger.svg");
const facebook_square_svg_1 = require("../src/icons/brands/facebook-square.svg");
const facebook_svg_1 = require("../src/icons/brands/facebook.svg");
const fantasy_flight_games_svg_1 = require("../src/icons/brands/fantasy-flight-games.svg");
const fedex_svg_1 = require("../src/icons/brands/fedex.svg");
const fedora_svg_1 = require("../src/icons/brands/fedora.svg");
const figma_svg_1 = require("../src/icons/brands/figma.svg");
const firefox_browser_svg_1 = require("../src/icons/brands/firefox-browser.svg");
const firefox_svg_1 = require("../src/icons/brands/firefox.svg");
const first_order_alt_svg_1 = require("../src/icons/brands/first-order-alt.svg");
const first_order_svg_1 = require("../src/icons/brands/first-order.svg");
const firstdraft_svg_1 = require("../src/icons/brands/firstdraft.svg");
const flickr_svg_1 = require("../src/icons/brands/flickr.svg");
const flipboard_svg_1 = require("../src/icons/brands/flipboard.svg");
const fly_svg_1 = require("../src/icons/brands/fly.svg");
const font_awesome_svg_1 = require("../src/icons/brands/font-awesome.svg");
const fonticons_fi_svg_1 = require("../src/icons/brands/fonticons-fi.svg");
const fonticons_svg_1 = require("../src/icons/brands/fonticons.svg");
const fort_awesome_alt_svg_1 = require("../src/icons/brands/fort-awesome-alt.svg");
const fort_awesome_svg_1 = require("../src/icons/brands/fort-awesome.svg");
const forumbee_svg_1 = require("../src/icons/brands/forumbee.svg");
const foursquare_svg_1 = require("../src/icons/brands/foursquare.svg");
const free_code_camp_svg_1 = require("../src/icons/brands/free-code-camp.svg");
const freebsd_svg_1 = require("../src/icons/brands/freebsd.svg");
const fulcrum_svg_1 = require("../src/icons/brands/fulcrum.svg");
const galactic_republic_svg_1 = require("../src/icons/brands/galactic-republic.svg");
const galactic_senate_svg_1 = require("../src/icons/brands/galactic-senate.svg");
const get_pocket_svg_1 = require("../src/icons/brands/get-pocket.svg");
const gg_circle_svg_1 = require("../src/icons/brands/gg-circle.svg");
const gg_svg_1 = require("../src/icons/brands/gg.svg");
const git_alt_svg_1 = require("../src/icons/brands/git-alt.svg");
const git_square_svg_1 = require("../src/icons/brands/git-square.svg");
const git_svg_1 = require("../src/icons/brands/git.svg");
const github_alt_svg_1 = require("../src/icons/brands/github-alt.svg");
const github_square_svg_1 = require("../src/icons/brands/github-square.svg");
const github_svg_1 = require("../src/icons/brands/github.svg");
const gitkraken_svg_1 = require("../src/icons/brands/gitkraken.svg");
const gitlab_svg_1 = require("../src/icons/brands/gitlab.svg");
const gitter_svg_1 = require("../src/icons/brands/gitter.svg");
const glide_g_svg_1 = require("../src/icons/brands/glide-g.svg");
const glide_svg_1 = require("../src/icons/brands/glide.svg");
const gofore_svg_1 = require("../src/icons/brands/gofore.svg");
const goodreads_g_svg_1 = require("../src/icons/brands/goodreads-g.svg");
const goodreads_svg_1 = require("../src/icons/brands/goodreads.svg");
const google_drive_svg_1 = require("../src/icons/brands/google-drive.svg");
const google_pay_svg_1 = require("../src/icons/brands/google-pay.svg");
const google_play_svg_1 = require("../src/icons/brands/google-play.svg");
const google_plus_g_svg_1 = require("../src/icons/brands/google-plus-g.svg");
const google_plus_square_svg_1 = require("../src/icons/brands/google-plus-square.svg");
const google_plus_svg_1 = require("../src/icons/brands/google-plus.svg");
const google_wallet_svg_1 = require("../src/icons/brands/google-wallet.svg");
const google_svg_1 = require("../src/icons/brands/google.svg");
const gratipay_svg_1 = require("../src/icons/brands/gratipay.svg");
const grav_svg_1 = require("../src/icons/brands/grav.svg");
const gripfire_svg_1 = require("../src/icons/brands/gripfire.svg");
const grunt_svg_1 = require("../src/icons/brands/grunt.svg");
const guilded_svg_1 = require("../src/icons/brands/guilded.svg");
const gulp_svg_1 = require("../src/icons/brands/gulp.svg");
const hacker_news_square_svg_1 = require("../src/icons/brands/hacker-news-square.svg");
const hacker_news_svg_1 = require("../src/icons/brands/hacker-news.svg");
const hackerrank_svg_1 = require("../src/icons/brands/hackerrank.svg");
const hips_svg_1 = require("../src/icons/brands/hips.svg");
const hire_a_helper_svg_1 = require("../src/icons/brands/hire-a-helper.svg");
const hive_svg_1 = require("../src/icons/brands/hive.svg");
const hooli_svg_1 = require("../src/icons/brands/hooli.svg");
const hornbill_svg_1 = require("../src/icons/brands/hornbill.svg");
const hotjar_svg_1 = require("../src/icons/brands/hotjar.svg");
const houzz_svg_1 = require("../src/icons/brands/houzz.svg");
const html5_svg_1 = require("../src/icons/brands/html5.svg");
const hubspot_svg_1 = require("../src/icons/brands/hubspot.svg");
const ideal_svg_1 = require("../src/icons/brands/ideal.svg");
const imdb_svg_1 = require("../src/icons/brands/imdb.svg");
const innosoft_svg_1 = require("../src/icons/brands/innosoft.svg");
const instagram_square_svg_1 = require("../src/icons/brands/instagram-square.svg");
const instagram_svg_1 = require("../src/icons/brands/instagram.svg");
const instalod_svg_1 = require("../src/icons/brands/instalod.svg");
const intercom_svg_1 = require("../src/icons/brands/intercom.svg");
const internet_explorer_svg_1 = require("../src/icons/brands/internet-explorer.svg");
const invision_svg_1 = require("../src/icons/brands/invision.svg");
const ioxhost_svg_1 = require("../src/icons/brands/ioxhost.svg");
const itch_io_svg_1 = require("../src/icons/brands/itch-io.svg");
const itunes_note_svg_1 = require("../src/icons/brands/itunes-note.svg");
const itunes_svg_1 = require("../src/icons/brands/itunes.svg");
const java_svg_1 = require("../src/icons/brands/java.svg");
const jedi_order_svg_1 = require("../src/icons/brands/jedi-order.svg");
const jenkins_svg_1 = require("../src/icons/brands/jenkins.svg");
const jira_svg_1 = require("../src/icons/brands/jira.svg");
const joget_svg_1 = require("../src/icons/brands/joget.svg");
const joomla_svg_1 = require("../src/icons/brands/joomla.svg");
const js_square_svg_1 = require("../src/icons/brands/js-square.svg");
const js_svg_1 = require("../src/icons/brands/js.svg");
const jsfiddle_svg_1 = require("../src/icons/brands/jsfiddle.svg");
const kaggle_svg_1 = require("../src/icons/brands/kaggle.svg");
const keybase_svg_1 = require("../src/icons/brands/keybase.svg");
const keycdn_svg_1 = require("../src/icons/brands/keycdn.svg");
const kickstarter_k_svg_1 = require("../src/icons/brands/kickstarter-k.svg");
const kickstarter_svg_1 = require("../src/icons/brands/kickstarter.svg");
const korvue_svg_1 = require("../src/icons/brands/korvue.svg");
const laravel_svg_1 = require("../src/icons/brands/laravel.svg");
const lastfm_square_svg_1 = require("../src/icons/brands/lastfm-square.svg");
const lastfm_svg_1 = require("../src/icons/brands/lastfm.svg");
const leanpub_svg_1 = require("../src/icons/brands/leanpub.svg");
const less_svg_1 = require("../src/icons/brands/less.svg");
const line_svg_1 = require("../src/icons/brands/line.svg");
const linkedin_in_svg_1 = require("../src/icons/brands/linkedin-in.svg");
const linkedin_svg_1 = require("../src/icons/brands/linkedin.svg");
const linode_svg_1 = require("../src/icons/brands/linode.svg");
const linux_svg_1 = require("../src/icons/brands/linux.svg");
const lyft_svg_1 = require("../src/icons/brands/lyft.svg");
const magento_svg_1 = require("../src/icons/brands/magento.svg");
const mailchimp_svg_1 = require("../src/icons/brands/mailchimp.svg");
const mandalorian_svg_1 = require("../src/icons/brands/mandalorian.svg");
const markdown_svg_1 = require("../src/icons/brands/markdown.svg");
const mastodon_svg_1 = require("../src/icons/brands/mastodon.svg");
const maxcdn_svg_1 = require("../src/icons/brands/maxcdn.svg");
const mdb_svg_1 = require("../src/icons/brands/mdb.svg");
const medapps_svg_1 = require("../src/icons/brands/medapps.svg");
const medium_svg_1 = require("../src/icons/brands/medium.svg");
const medrt_svg_1 = require("../src/icons/brands/medrt.svg");
const meetup_svg_1 = require("../src/icons/brands/meetup.svg");
const megaport_svg_1 = require("../src/icons/brands/megaport.svg");
const mendeley_svg_1 = require("../src/icons/brands/mendeley.svg");
const microblog_svg_1 = require("../src/icons/brands/microblog.svg");
const microsoft_svg_1 = require("../src/icons/brands/microsoft.svg");
const mix_svg_1 = require("../src/icons/brands/mix.svg");
const mixcloud_svg_1 = require("../src/icons/brands/mixcloud.svg");
const mixer_svg_1 = require("../src/icons/brands/mixer.svg");
const mizuni_svg_1 = require("../src/icons/brands/mizuni.svg");
const modx_svg_1 = require("../src/icons/brands/modx.svg");
const monero_svg_1 = require("../src/icons/brands/monero.svg");
const napster_svg_1 = require("../src/icons/brands/napster.svg");
const neos_svg_1 = require("../src/icons/brands/neos.svg");
const nimblr_svg_1 = require("../src/icons/brands/nimblr.svg");
const node_js_svg_1 = require("../src/icons/brands/node-js.svg");
const node_svg_1 = require("../src/icons/brands/node.svg");
const npm_svg_1 = require("../src/icons/brands/npm.svg");
const ns8_svg_1 = require("../src/icons/brands/ns8.svg");
const nutritionix_svg_1 = require("../src/icons/brands/nutritionix.svg");
const octopus_deploy_svg_1 = require("../src/icons/brands/octopus-deploy.svg");
const odnoklassniki_square_svg_1 = require("../src/icons/brands/odnoklassniki-square.svg");
const odnoklassniki_svg_1 = require("../src/icons/brands/odnoklassniki.svg");
const old_republic_svg_1 = require("../src/icons/brands/old-republic.svg");
const opencart_svg_1 = require("../src/icons/brands/opencart.svg");
const openid_svg_1 = require("../src/icons/brands/openid.svg");
const opera_svg_1 = require("../src/icons/brands/opera.svg");
const optin_monster_svg_1 = require("../src/icons/brands/optin-monster.svg");
const orcid_svg_1 = require("../src/icons/brands/orcid.svg");
const osi_svg_1 = require("../src/icons/brands/osi.svg");
const page4_svg_1 = require("../src/icons/brands/page4.svg");
const pagelines_svg_1 = require("../src/icons/brands/pagelines.svg");
const palfed_svg_1 = require("../src/icons/brands/palfed.svg");
const patreon_svg_1 = require("../src/icons/brands/patreon.svg");
const paypal_svg_1 = require("../src/icons/brands/paypal.svg");
const penny_arcade_svg_1 = require("../src/icons/brands/penny-arcade.svg");
const perbyte_svg_1 = require("../src/icons/brands/perbyte.svg");
const periscope_svg_1 = require("../src/icons/brands/periscope.svg");
const phabricator_svg_1 = require("../src/icons/brands/phabricator.svg");
const phoenix_framework_svg_1 = require("../src/icons/brands/phoenix-framework.svg");
const phoenix_squadron_svg_1 = require("../src/icons/brands/phoenix-squadron.svg");
const php_svg_1 = require("../src/icons/brands/php.svg");
const pied_piper_alt_svg_1 = require("../src/icons/brands/pied-piper-alt.svg");
const pied_piper_hat_svg_1 = require("../src/icons/brands/pied-piper-hat.svg");
const pied_piper_pp_svg_1 = require("../src/icons/brands/pied-piper-pp.svg");
const pied_piper_square_svg_1 = require("../src/icons/brands/pied-piper-square.svg");
const pied_piper_svg_1 = require("../src/icons/brands/pied-piper.svg");
const pinterest_p_svg_1 = require("../src/icons/brands/pinterest-p.svg");
const pinterest_square_svg_1 = require("../src/icons/brands/pinterest-square.svg");
const pinterest_svg_1 = require("../src/icons/brands/pinterest.svg");
const playstation_svg_1 = require("../src/icons/brands/playstation.svg");
const product_hunt_svg_1 = require("../src/icons/brands/product-hunt.svg");
const pushed_svg_1 = require("../src/icons/brands/pushed.svg");
const python_svg_1 = require("../src/icons/brands/python.svg");
const qq_svg_1 = require("../src/icons/brands/qq.svg");
const quinscape_svg_1 = require("../src/icons/brands/quinscape.svg");
const quora_svg_1 = require("../src/icons/brands/quora.svg");
const r_project_svg_1 = require("../src/icons/brands/r-project.svg");
const raspberry_pi_svg_1 = require("../src/icons/brands/raspberry-pi.svg");
const ravelry_svg_1 = require("../src/icons/brands/ravelry.svg");
const react_svg_1 = require("../src/icons/brands/react.svg");
const reacteurope_svg_1 = require("../src/icons/brands/reacteurope.svg");
const readme_svg_1 = require("../src/icons/brands/readme.svg");
const rebel_svg_1 = require("../src/icons/brands/rebel.svg");
const red_river_svg_1 = require("../src/icons/brands/red-river.svg");
const reddit_alien_svg_1 = require("../src/icons/brands/reddit-alien.svg");
const reddit_square_svg_1 = require("../src/icons/brands/reddit-square.svg");
const reddit_svg_1 = require("../src/icons/brands/reddit.svg");
const redhat_svg_1 = require("../src/icons/brands/redhat.svg");
const renren_svg_1 = require("../src/icons/brands/renren.svg");
const replyd_svg_1 = require("../src/icons/brands/replyd.svg");
const researchgate_svg_1 = require("../src/icons/brands/researchgate.svg");
const resolving_svg_1 = require("../src/icons/brands/resolving.svg");
const rev_svg_1 = require("../src/icons/brands/rev.svg");
const rocketchat_svg_1 = require("../src/icons/brands/rocketchat.svg");
const rockrms_svg_1 = require("../src/icons/brands/rockrms.svg");
const rust_svg_1 = require("../src/icons/brands/rust.svg");
const safari_svg_1 = require("../src/icons/brands/safari.svg");
const salesforce_svg_1 = require("../src/icons/brands/salesforce.svg");
const sass_svg_1 = require("../src/icons/brands/sass.svg");
const schlix_svg_1 = require("../src/icons/brands/schlix.svg");
const scribd_svg_1 = require("../src/icons/brands/scribd.svg");
const searchengin_svg_1 = require("../src/icons/brands/searchengin.svg");
const sellcast_svg_1 = require("../src/icons/brands/sellcast.svg");
const sellsy_svg_1 = require("../src/icons/brands/sellsy.svg");
const servicestack_svg_1 = require("../src/icons/brands/servicestack.svg");
const shirtsinbulk_svg_1 = require("../src/icons/brands/shirtsinbulk.svg");
const shopify_svg_1 = require("../src/icons/brands/shopify.svg");
const shopware_svg_1 = require("../src/icons/brands/shopware.svg");
const simplybuilt_svg_1 = require("../src/icons/brands/simplybuilt.svg");
const sistrix_svg_1 = require("../src/icons/brands/sistrix.svg");
const sith_svg_1 = require("../src/icons/brands/sith.svg");
const sketch_svg_1 = require("../src/icons/brands/sketch.svg");
const skyatlas_svg_1 = require("../src/icons/brands/skyatlas.svg");
const skype_svg_1 = require("../src/icons/brands/skype.svg");
const slack_svg_1 = require("../src/icons/brands/slack.svg");
const slideshare_svg_1 = require("../src/icons/brands/slideshare.svg");
const snapchat_square_svg_1 = require("../src/icons/brands/snapchat-square.svg");
const snapchat_svg_1 = require("../src/icons/brands/snapchat.svg");
const soundcloud_svg_1 = require("../src/icons/brands/soundcloud.svg");
const sourcetree_svg_1 = require("../src/icons/brands/sourcetree.svg");
const speakap_svg_1 = require("../src/icons/brands/speakap.svg");
const speaker_deck_svg_1 = require("../src/icons/brands/speaker-deck.svg");
const spotify_svg_1 = require("../src/icons/brands/spotify.svg");
const square_font_awesome_stroke_svg_1 = require("../src/icons/brands/square-font-awesome-stroke.svg");
const square_font_awesome_svg_1 = require("../src/icons/brands/square-font-awesome.svg");
const squarespace_svg_1 = require("../src/icons/brands/squarespace.svg");
const stack_exchange_svg_1 = require("../src/icons/brands/stack-exchange.svg");
const stack_overflow_svg_1 = require("../src/icons/brands/stack-overflow.svg");
const stackpath_svg_1 = require("../src/icons/brands/stackpath.svg");
const staylinked_svg_1 = require("../src/icons/brands/staylinked.svg");
const steam_square_svg_1 = require("../src/icons/brands/steam-square.svg");
const steam_symbol_svg_1 = require("../src/icons/brands/steam-symbol.svg");
const steam_svg_1 = require("../src/icons/brands/steam.svg");
const sticker_mule_svg_1 = require("../src/icons/brands/sticker-mule.svg");
const strava_svg_1 = require("../src/icons/brands/strava.svg");
const stripe_s_svg_1 = require("../src/icons/brands/stripe-s.svg");
const stripe_svg_1 = require("../src/icons/brands/stripe.svg");
const studiovinari_svg_1 = require("../src/icons/brands/studiovinari.svg");
const stumbleupon_circle_svg_1 = require("../src/icons/brands/stumbleupon-circle.svg");
const stumbleupon_svg_1 = require("../src/icons/brands/stumbleupon.svg");
const superpowers_svg_1 = require("../src/icons/brands/superpowers.svg");
const supple_svg_1 = require("../src/icons/brands/supple.svg");
const suse_svg_1 = require("../src/icons/brands/suse.svg");
const swift_svg_1 = require("../src/icons/brands/swift.svg");
const symfony_svg_1 = require("../src/icons/brands/symfony.svg");
const teamspeak_svg_1 = require("../src/icons/brands/teamspeak.svg");
const telegram_svg_1 = require("../src/icons/brands/telegram.svg");
const tencent_weibo_svg_1 = require("../src/icons/brands/tencent-weibo.svg");
const the_red_yeti_svg_1 = require("../src/icons/brands/the-red-yeti.svg");
const themeco_svg_1 = require("../src/icons/brands/themeco.svg");
const themeisle_svg_1 = require("../src/icons/brands/themeisle.svg");
const think_peaks_svg_1 = require("../src/icons/brands/think-peaks.svg");
const tiktok_svg_1 = require("../src/icons/brands/tiktok.svg");
const trade_federation_svg_1 = require("../src/icons/brands/trade-federation.svg");
const trello_svg_1 = require("../src/icons/brands/trello.svg");
const tripadvisor_svg_1 = require("../src/icons/brands/tripadvisor.svg");
const tumblr_square_svg_1 = require("../src/icons/brands/tumblr-square.svg");
const tumblr_svg_1 = require("../src/icons/brands/tumblr.svg");
const twitch_svg_1 = require("../src/icons/brands/twitch.svg");
const twitter_square_svg_1 = require("../src/icons/brands/twitter-square.svg");
const twitter_svg_1 = require("../src/icons/brands/twitter.svg");
const typo3_svg_1 = require("../src/icons/brands/typo3.svg");
const uber_svg_1 = require("../src/icons/brands/uber.svg");
const ubuntu_svg_1 = require("../src/icons/brands/ubuntu.svg");
const uikit_svg_1 = require("../src/icons/brands/uikit.svg");
const umbraco_svg_1 = require("../src/icons/brands/umbraco.svg");
const uncharted_svg_1 = require("../src/icons/brands/uncharted.svg");
const uniregistry_svg_1 = require("../src/icons/brands/uniregistry.svg");
const unity_svg_1 = require("../src/icons/brands/unity.svg");
const unsplash_svg_1 = require("../src/icons/brands/unsplash.svg");
const untappd_svg_1 = require("../src/icons/brands/untappd.svg");
const ups_svg_1 = require("../src/icons/brands/ups.svg");
const usb_svg_1 = require("../src/icons/brands/usb.svg");
const usps_svg_1 = require("../src/icons/brands/usps.svg");
const ussunnah_svg_1 = require("../src/icons/brands/ussunnah.svg");
const vaadin_svg_1 = require("../src/icons/brands/vaadin.svg");
const viacoin_svg_1 = require("../src/icons/brands/viacoin.svg");
const viadeo_square_svg_1 = require("../src/icons/brands/viadeo-square.svg");
const viadeo_svg_1 = require("../src/icons/brands/viadeo.svg");
const viber_svg_1 = require("../src/icons/brands/viber.svg");
const vimeo_square_svg_1 = require("../src/icons/brands/vimeo-square.svg");
const vimeo_v_svg_1 = require("../src/icons/brands/vimeo-v.svg");
const vimeo_svg_1 = require("../src/icons/brands/vimeo.svg");
const vine_svg_1 = require("../src/icons/brands/vine.svg");
const vk_svg_1 = require("../src/icons/brands/vk.svg");
const vnv_svg_1 = require("../src/icons/brands/vnv.svg");
const vuejs_svg_1 = require("../src/icons/brands/vuejs.svg");
const watchman_monitoring_svg_1 = require("../src/icons/brands/watchman-monitoring.svg");
const waze_svg_1 = require("../src/icons/brands/waze.svg");
const weebly_svg_1 = require("../src/icons/brands/weebly.svg");
const weibo_svg_1 = require("../src/icons/brands/weibo.svg");
const weixin_svg_1 = require("../src/icons/brands/weixin.svg");
const whatsapp_square_svg_1 = require("../src/icons/brands/whatsapp-square.svg");
const whatsapp_svg_1 = require("../src/icons/brands/whatsapp.svg");
const whmcs_svg_1 = require("../src/icons/brands/whmcs.svg");
const wikipedia_w_svg_1 = require("../src/icons/brands/wikipedia-w.svg");
const windows_svg_1 = require("../src/icons/brands/windows.svg");
const wix_svg_1 = require("../src/icons/brands/wix.svg");
const wizards_of_the_coast_svg_1 = require("../src/icons/brands/wizards-of-the-coast.svg");
const wodu_svg_1 = require("../src/icons/brands/wodu.svg");
const wolf_pack_battalion_svg_1 = require("../src/icons/brands/wolf-pack-battalion.svg");
const wordpress_simple_svg_1 = require("../src/icons/brands/wordpress-simple.svg");
const wordpress_svg_1 = require("../src/icons/brands/wordpress.svg");
const wpbeginner_svg_1 = require("../src/icons/brands/wpbeginner.svg");
const wpexplorer_svg_1 = require("../src/icons/brands/wpexplorer.svg");
const wpforms_svg_1 = require("../src/icons/brands/wpforms.svg");
const wpressr_svg_1 = require("../src/icons/brands/wpressr.svg");
const xbox_svg_1 = require("../src/icons/brands/xbox.svg");
const xing_square_svg_1 = require("../src/icons/brands/xing-square.svg");
const xing_svg_1 = require("../src/icons/brands/xing.svg");
const y_combinator_svg_1 = require("../src/icons/brands/y-combinator.svg");
const yahoo_svg_1 = require("../src/icons/brands/yahoo.svg");
const yammer_svg_1 = require("../src/icons/brands/yammer.svg");
const yandex_international_svg_1 = require("../src/icons/brands/yandex-international.svg");
const yandex_svg_1 = require("../src/icons/brands/yandex.svg");
const yarn_svg_1 = require("../src/icons/brands/yarn.svg");
const yelp_svg_1 = require("../src/icons/brands/yelp.svg");
const yoast_svg_1 = require("../src/icons/brands/yoast.svg");
const youtube_square_svg_1 = require("../src/icons/brands/youtube-square.svg");
const youtube_svg_1 = require("../src/icons/brands/youtube.svg");
const zhihu_svg_1 = require("../src/icons/brands/zhihu.svg");
const _0_svg_1 = require("../src/icons/regular/0.svg");
const _1_svg_1 = require("../src/icons/regular/1.svg");
const _2_svg_1 = require("../src/icons/regular/2.svg");
const _3_svg_1 = require("../src/icons/regular/3.svg");
const _4_svg_1 = require("../src/icons/regular/4.svg");
const _5_svg_1 = require("../src/icons/regular/5.svg");
const _6_svg_1 = require("../src/icons/regular/6.svg");
const _7_svg_1 = require("../src/icons/regular/7.svg");
const _8_svg_1 = require("../src/icons/regular/8.svg");
const _9_svg_1 = require("../src/icons/regular/9.svg");
const a_svg_1 = require("../src/icons/regular/a.svg");
const abacus_svg_1 = require("../src/icons/regular/abacus.svg");
const acorn_svg_1 = require("../src/icons/regular/acorn.svg");
const address_book_svg_1 = require("../src/icons/regular/address-book.svg");
const address_card_svg_1 = require("../src/icons/regular/address-card.svg");
const air_conditioner_svg_1 = require("../src/icons/regular/air-conditioner.svg");
const air_freshener_svg_1 = require("../src/icons/regular/air-freshener.svg");
const airplay_svg_1 = require("../src/icons/regular/airplay.svg");
const alarm_clock_svg_1 = require("../src/icons/regular/alarm-clock.svg");
const alarm_exclamation_svg_1 = require("../src/icons/regular/alarm-exclamation.svg");
const alarm_plus_svg_1 = require("../src/icons/regular/alarm-plus.svg");
const alarm_snooze_svg_1 = require("../src/icons/regular/alarm-snooze.svg");
const album_collection_svg_1 = require("../src/icons/regular/album-collection.svg");
const album_svg_1 = require("../src/icons/regular/album.svg");
const alicorn_svg_1 = require("../src/icons/regular/alicorn.svg");
const alien_8bit_svg_1 = require("../src/icons/regular/alien-8bit.svg");
const alien_svg_1 = require("../src/icons/regular/alien.svg");
const align_center_svg_1 = require("../src/icons/regular/align-center.svg");
const align_justify_svg_1 = require("../src/icons/regular/align-justify.svg");
const align_left_svg_1 = require("../src/icons/regular/align-left.svg");
const align_right_svg_1 = require("../src/icons/regular/align-right.svg");
const align_slash_svg_1 = require("../src/icons/regular/align-slash.svg");
const alt_svg_1 = require("../src/icons/regular/alt.svg");
const amp_guitar_svg_1 = require("../src/icons/regular/amp-guitar.svg");
const ampersand_svg_1 = require("../src/icons/regular/ampersand.svg");
const anchor_svg_1 = require("../src/icons/regular/anchor.svg");
const angel_svg_1 = require("../src/icons/regular/angel.svg");
const angle_90_svg_1 = require("../src/icons/regular/angle-90.svg");
const angle_down_svg_1 = require("../src/icons/regular/angle-down.svg");
const angle_left_svg_1 = require("../src/icons/regular/angle-left.svg");
const angle_right_svg_1 = require("../src/icons/regular/angle-right.svg");
const angle_up_svg_1 = require("../src/icons/regular/angle-up.svg");
const angle_svg_1 = require("../src/icons/regular/angle.svg");
const angles_down_svg_1 = require("../src/icons/regular/angles-down.svg");
const angles_left_svg_1 = require("../src/icons/regular/angles-left.svg");
const angles_right_svg_1 = require("../src/icons/regular/angles-right.svg");
const angles_up_svg_1 = require("../src/icons/regular/angles-up.svg");
const ankh_svg_1 = require("../src/icons/regular/ankh.svg");
const aperture_svg_1 = require("../src/icons/regular/aperture.svg");
const apple_core_svg_1 = require("../src/icons/regular/apple-core.svg");
const apple_crate_svg_1 = require("../src/icons/regular/apple-crate.svg");
const apple_whole_svg_1 = require("../src/icons/regular/apple-whole.svg");
const archway_svg_1 = require("../src/icons/regular/archway.svg");
const arrow_down_1_9_svg_1 = require("../src/icons/regular/arrow-down-1-9.svg");
const arrow_down_9_1_svg_1 = require("../src/icons/regular/arrow-down-9-1.svg");
const arrow_down_a_z_svg_1 = require("../src/icons/regular/arrow-down-a-z.svg");
const arrow_down_arrow_up_svg_1 = require("../src/icons/regular/arrow-down-arrow-up.svg");
const arrow_down_big_small_svg_1 = require("../src/icons/regular/arrow-down-big-small.svg");
const arrow_down_from_dotted_line_svg_1 = require("../src/icons/regular/arrow-down-from-dotted-line.svg");
const arrow_down_from_line_svg_1 = require("../src/icons/regular/arrow-down-from-line.svg");
const arrow_down_left_and_arrow_up_right_to_center_svg_1 = require("../src/icons/regular/arrow-down-left-and-arrow-up-right-to-center.svg");
const arrow_down_left_svg_1 = require("../src/icons/regular/arrow-down-left.svg");
const arrow_down_long_svg_1 = require("../src/icons/regular/arrow-down-long.svg");
const arrow_down_right_svg_1 = require("../src/icons/regular/arrow-down-right.svg");
const arrow_down_short_wide_svg_1 = require("../src/icons/regular/arrow-down-short-wide.svg");
const arrow_down_small_big_svg_1 = require("../src/icons/regular/arrow-down-small-big.svg");
const arrow_down_square_triangle_svg_1 = require("../src/icons/regular/arrow-down-square-triangle.svg");
const arrow_down_to_bracket_svg_1 = require("../src/icons/regular/arrow-down-to-bracket.svg");
const arrow_down_to_dotted_line_svg_1 = require("../src/icons/regular/arrow-down-to-dotted-line.svg");
const arrow_down_to_line_svg_1 = require("../src/icons/regular/arrow-down-to-line.svg");
const arrow_down_to_square_svg_1 = require("../src/icons/regular/arrow-down-to-square.svg");
const arrow_down_triangle_square_svg_1 = require("../src/icons/regular/arrow-down-triangle-square.svg");
const arrow_down_wide_short_svg_1 = require("../src/icons/regular/arrow-down-wide-short.svg");
const arrow_down_z_a_svg_1 = require("../src/icons/regular/arrow-down-z-a.svg");
const arrow_down_svg_1 = require("../src/icons/regular/arrow-down.svg");
const arrow_left_from_line_svg_1 = require("../src/icons/regular/arrow-left-from-line.svg");
const arrow_left_long_svg_1 = require("../src/icons/regular/arrow-left-long.svg");
const arrow_left_rotate_svg_1 = require("../src/icons/regular/arrow-left-rotate.svg");
const arrow_left_to_line_svg_1 = require("../src/icons/regular/arrow-left-to-line.svg");
const arrow_left_svg_1 = require("../src/icons/regular/arrow-left.svg");
const arrow_pointer_svg_1 = require("../src/icons/regular/arrow-pointer.svg");
const arrow_right_arrow_left_svg_1 = require("../src/icons/regular/arrow-right-arrow-left.svg");
const arrow_right_from_bracket_svg_1 = require("../src/icons/regular/arrow-right-from-bracket.svg");
const arrow_right_from_line_svg_1 = require("../src/icons/regular/arrow-right-from-line.svg");
const arrow_right_long_svg_1 = require("../src/icons/regular/arrow-right-long.svg");
const arrow_right_to_bracket_svg_1 = require("../src/icons/regular/arrow-right-to-bracket.svg");
const arrow_right_to_line_svg_1 = require("../src/icons/regular/arrow-right-to-line.svg");
const arrow_right_svg_1 = require("../src/icons/regular/arrow-right.svg");
const arrow_rotate_forward_svg_1 = require("../src/icons/regular/arrow-rotate-forward.svg");
const arrow_trend_down_svg_1 = require("../src/icons/regular/arrow-trend-down.svg");
const arrow_trend_up_svg_1 = require("../src/icons/regular/arrow-trend-up.svg");
const arrow_turn_down_svg_1 = require("../src/icons/regular/arrow-turn-down.svg");
const arrow_turn_up_svg_1 = require("../src/icons/regular/arrow-turn-up.svg");
const arrow_up_1_9_svg_1 = require("../src/icons/regular/arrow-up-1-9.svg");
const arrow_up_9_1_svg_1 = require("../src/icons/regular/arrow-up-9-1.svg");
const arrow_up_a_z_svg_1 = require("../src/icons/regular/arrow-up-a-z.svg");
const arrow_up_arrow_down_svg_1 = require("../src/icons/regular/arrow-up-arrow-down.svg");
const arrow_up_big_small_svg_1 = require("../src/icons/regular/arrow-up-big-small.svg");
const arrow_up_from_bracket_svg_1 = require("../src/icons/regular/arrow-up-from-bracket.svg");
const arrow_up_from_dotted_line_svg_1 = require("../src/icons/regular/arrow-up-from-dotted-line.svg");
const arrow_up_from_line_svg_1 = require("../src/icons/regular/arrow-up-from-line.svg");
const arrow_up_from_square_svg_1 = require("../src/icons/regular/arrow-up-from-square.svg");
const arrow_up_left_from_circle_svg_1 = require("../src/icons/regular/arrow-up-left-from-circle.svg");
const arrow_up_left_svg_1 = require("../src/icons/regular/arrow-up-left.svg");
const arrow_up_long_svg_1 = require("../src/icons/regular/arrow-up-long.svg");
const arrow_up_right_and_arrow_down_left_from_center_svg_1 = require("../src/icons/regular/arrow-up-right-and-arrow-down-left-from-center.svg");
const arrow_up_right_from_square_svg_1 = require("../src/icons/regular/arrow-up-right-from-square.svg");
const arrow_up_right_svg_1 = require("../src/icons/regular/arrow-up-right.svg");
const arrow_up_short_wide_svg_1 = require("../src/icons/regular/arrow-up-short-wide.svg");
const arrow_up_small_big_svg_1 = require("../src/icons/regular/arrow-up-small-big.svg");
const arrow_up_square_triangle_svg_1 = require("../src/icons/regular/arrow-up-square-triangle.svg");
const arrow_up_to_dotted_line_svg_1 = require("../src/icons/regular/arrow-up-to-dotted-line.svg");
const arrow_up_to_line_svg_1 = require("../src/icons/regular/arrow-up-to-line.svg");
const arrow_up_triangle_square_svg_1 = require("../src/icons/regular/arrow-up-triangle-square.svg");
const arrow_up_wide_short_svg_1 = require("../src/icons/regular/arrow-up-wide-short.svg");
const arrow_up_z_a_svg_1 = require("../src/icons/regular/arrow-up-z-a.svg");
const arrow_up_svg_1 = require("../src/icons/regular/arrow-up.svg");
const arrows_cross_svg_1 = require("../src/icons/regular/arrows-cross.svg");
const arrows_from_dotted_line_svg_1 = require("../src/icons/regular/arrows-from-dotted-line.svg");
const arrows_from_line_svg_1 = require("../src/icons/regular/arrows-from-line.svg");
const arrows_left_right_svg_1 = require("../src/icons/regular/arrows-left-right.svg");
const arrows_maximize_svg_1 = require("../src/icons/regular/arrows-maximize.svg");
const arrows_minimize_svg_1 = require("../src/icons/regular/arrows-minimize.svg");
const arrows_repeat_1_svg_1 = require("../src/icons/regular/arrows-repeat-1.svg");
const arrows_repeat_svg_1 = require("../src/icons/regular/arrows-repeat.svg");
const arrows_retweet_svg_1 = require("../src/icons/regular/arrows-retweet.svg");
const arrows_rotate_svg_1 = require("../src/icons/regular/arrows-rotate.svg");
const arrows_to_dotted_line_svg_1 = require("../src/icons/regular/arrows-to-dotted-line.svg");
const arrows_to_line_svg_1 = require("../src/icons/regular/arrows-to-line.svg");
const arrows_up_down_left_right_svg_1 = require("../src/icons/regular/arrows-up-down-left-right.svg");
const arrows_up_down_svg_1 = require("../src/icons/regular/arrows-up-down.svg");
const asterisk_svg_1 = require("../src/icons/regular/asterisk.svg");
const at_svg_1 = require("../src/icons/regular/at.svg");
const atom_simple_svg_1 = require("../src/icons/regular/atom-simple.svg");
const atom_svg_1 = require("../src/icons/regular/atom.svg");
const audio_description_slash_svg_1 = require("../src/icons/regular/audio-description-slash.svg");
const audio_description_svg_1 = require("../src/icons/regular/audio-description.svg");
const austral_sign_svg_1 = require("../src/icons/regular/austral-sign.svg");
const avocado_svg_1 = require("../src/icons/regular/avocado.svg");
const award_simple_svg_1 = require("../src/icons/regular/award-simple.svg");
const award_svg_1 = require("../src/icons/regular/award.svg");
const axe_battle_svg_1 = require("../src/icons/regular/axe-battle.svg");
const axe_svg_1 = require("../src/icons/regular/axe.svg");
const b_svg_1 = require("../src/icons/regular/b.svg");
const baby_carriage_svg_1 = require("../src/icons/regular/baby-carriage.svg");
const baby_svg_1 = require("../src/icons/regular/baby.svg");
const backpack_svg_1 = require("../src/icons/regular/backpack.svg");
const backward_fast_svg_1 = require("../src/icons/regular/backward-fast.svg");
const backward_step_svg_1 = require("../src/icons/regular/backward-step.svg");
const backward_svg_1 = require("../src/icons/regular/backward.svg");
const bacon_svg_1 = require("../src/icons/regular/bacon.svg");
const bacteria_svg_1 = require("../src/icons/regular/bacteria.svg");
const bacterium_svg_1 = require("../src/icons/regular/bacterium.svg");
const badge_check_svg_1 = require("../src/icons/regular/badge-check.svg");
const badge_dollar_svg_1 = require("../src/icons/regular/badge-dollar.svg");
const badge_percent_svg_1 = require("../src/icons/regular/badge-percent.svg");
const badge_sheriff_svg_1 = require("../src/icons/regular/badge-sheriff.svg");
const badge_svg_1 = require("../src/icons/regular/badge.svg");
const badger_honey_svg_1 = require("../src/icons/regular/badger-honey.svg");
const bag_shopping_svg_1 = require("../src/icons/regular/bag-shopping.svg");
const bags_shopping_svg_1 = require("../src/icons/regular/bags-shopping.svg");
const bahai_svg_1 = require("../src/icons/regular/bahai.svg");
const baht_sign_svg_1 = require("../src/icons/regular/baht-sign.svg");
const ball_pile_svg_1 = require("../src/icons/regular/ball-pile.svg");
const ballot_check_svg_1 = require("../src/icons/regular/ballot-check.svg");
const ballot_svg_1 = require("../src/icons/regular/ballot.svg");
const ban_bug_svg_1 = require("../src/icons/regular/ban-bug.svg");
const ban_parking_svg_1 = require("../src/icons/regular/ban-parking.svg");
const ban_smoking_svg_1 = require("../src/icons/regular/ban-smoking.svg");
const ban_svg_1 = require("../src/icons/regular/ban.svg");
const bandage_svg_1 = require("../src/icons/regular/bandage.svg");
const banjo_svg_1 = require("../src/icons/regular/banjo.svg");
const bank_svg_1 = require("../src/icons/regular/bank.svg");
const barcode_read_svg_1 = require("../src/icons/regular/barcode-read.svg");
const barcode_scan_svg_1 = require("../src/icons/regular/barcode-scan.svg");
const barcode_svg_1 = require("../src/icons/regular/barcode.svg");
const bars_filter_svg_1 = require("../src/icons/regular/bars-filter.svg");
const bars_progress_svg_1 = require("../src/icons/regular/bars-progress.svg");
const bars_sort_svg_1 = require("../src/icons/regular/bars-sort.svg");
const bars_staggered_svg_1 = require("../src/icons/regular/bars-staggered.svg");
const bars_svg_1 = require("../src/icons/regular/bars.svg");
const baseball_ball_svg_1 = require("../src/icons/regular/baseball-ball.svg");
const baseball_bat_ball_svg_1 = require("../src/icons/regular/baseball-bat-ball.svg");
const basket_shopping_simple_svg_1 = require("../src/icons/regular/basket-shopping-simple.svg");
const basket_shopping_svg_1 = require("../src/icons/regular/basket-shopping.svg");
const basketball_ball_svg_1 = require("../src/icons/regular/basketball-ball.svg");
const basketball_hoop_svg_1 = require("../src/icons/regular/basketball-hoop.svg");
const bat_svg_1 = require("../src/icons/regular/bat.svg");
const bath_svg_1 = require("../src/icons/regular/bath.svg");
const battery_bolt_svg_1 = require("../src/icons/regular/battery-bolt.svg");
const battery_empty_svg_1 = require("../src/icons/regular/battery-empty.svg");
const battery_exclamation_svg_1 = require("../src/icons/regular/battery-exclamation.svg");
const battery_full_svg_1 = require("../src/icons/regular/battery-full.svg");
const battery_half_svg_1 = require("../src/icons/regular/battery-half.svg");
const battery_low_svg_1 = require("../src/icons/regular/battery-low.svg");
const battery_quarter_svg_1 = require("../src/icons/regular/battery-quarter.svg");
const battery_slash_svg_1 = require("../src/icons/regular/battery-slash.svg");
const battery_three_quarters_svg_1 = require("../src/icons/regular/battery-three-quarters.svg");
const bed_bunk_svg_1 = require("../src/icons/regular/bed-bunk.svg");
const bed_empty_svg_1 = require("../src/icons/regular/bed-empty.svg");
const bed_front_svg_1 = require("../src/icons/regular/bed-front.svg");
const bed_pulse_svg_1 = require("../src/icons/regular/bed-pulse.svg");
const bed_svg_1 = require("../src/icons/regular/bed.svg");
const bee_svg_1 = require("../src/icons/regular/bee.svg");
const beer_mug_empty_svg_1 = require("../src/icons/regular/beer-mug-empty.svg");
const beer_mug_svg_1 = require("../src/icons/regular/beer-mug.svg");
const bell_concierge_svg_1 = require("../src/icons/regular/bell-concierge.svg");
const bell_exclamation_svg_1 = require("../src/icons/regular/bell-exclamation.svg");
const bell_on_svg_1 = require("../src/icons/regular/bell-on.svg");
const bell_plus_svg_1 = require("../src/icons/regular/bell-plus.svg");
const bell_school_slash_svg_1 = require("../src/icons/regular/bell-school-slash.svg");
const bell_school_svg_1 = require("../src/icons/regular/bell-school.svg");
const bell_slash_svg_1 = require("../src/icons/regular/bell-slash.svg");
const bell_svg_1 = require("../src/icons/regular/bell.svg");
const bells_svg_1 = require("../src/icons/regular/bells.svg");
const bezier_curve_svg_1 = require("../src/icons/regular/bezier-curve.svg");
const bicycle_svg_1 = require("../src/icons/regular/bicycle.svg");
const binoculars_svg_1 = require("../src/icons/regular/binoculars.svg");
const biohazard_svg_1 = require("../src/icons/regular/biohazard.svg");
const bitcoin_sign_svg_1 = require("../src/icons/regular/bitcoin-sign.svg");
const blanket_svg_1 = require("../src/icons/regular/blanket.svg");
const blender_phone_svg_1 = require("../src/icons/regular/blender-phone.svg");
const blender_svg_1 = require("../src/icons/regular/blender.svg");
const blinds_open_svg_1 = require("../src/icons/regular/blinds-open.svg");
const blinds_raised_svg_1 = require("../src/icons/regular/blinds-raised.svg");
const blinds_svg_1 = require("../src/icons/regular/blinds.svg");
const block_quote_svg_1 = require("../src/icons/regular/block-quote.svg");
const blog_svg_1 = require("../src/icons/regular/blog.svg");
const bluetooth_svg_2 = require("../src/icons/regular/bluetooth.svg");
const bold_svg_1 = require("../src/icons/regular/bold.svg");
const bolt_auto_svg_1 = require("../src/icons/regular/bolt-auto.svg");
const bolt_lightning_svg_1 = require("../src/icons/regular/bolt-lightning.svg");
const bolt_slash_svg_1 = require("../src/icons/regular/bolt-slash.svg");
const bolt_svg_1 = require("../src/icons/regular/bolt.svg");
const bomb_svg_1 = require("../src/icons/regular/bomb.svg");
const bone_break_svg_1 = require("../src/icons/regular/bone-break.svg");
const bone_svg_1 = require("../src/icons/regular/bone.svg");
const bong_svg_1 = require("../src/icons/regular/bong.svg");
const book_arrow_right_svg_1 = require("../src/icons/regular/book-arrow-right.svg");
const book_arrow_up_svg_1 = require("../src/icons/regular/book-arrow-up.svg");
const book_atlas_svg_1 = require("../src/icons/regular/book-atlas.svg");
const book_bible_svg_1 = require("../src/icons/regular/book-bible.svg");
const book_blank_svg_1 = require("../src/icons/regular/book-blank.svg");
const book_bookmark_svg_1 = require("../src/icons/regular/book-bookmark.svg");
const book_circle_arrow_right_svg_1 = require("../src/icons/regular/book-circle-arrow-right.svg");
const book_circle_arrow_up_svg_1 = require("../src/icons/regular/book-circle-arrow-up.svg");
const book_copy_svg_1 = require("../src/icons/regular/book-copy.svg");
const book_font_svg_1 = require("../src/icons/regular/book-font.svg");
const book_heart_svg_1 = require("../src/icons/regular/book-heart.svg");
const book_journal_whills_svg_1 = require("../src/icons/regular/book-journal-whills.svg");
const book_law_svg_1 = require("../src/icons/regular/book-law.svg");
const book_medical_svg_1 = require("../src/icons/regular/book-medical.svg");
const book_open_cover_svg_1 = require("../src/icons/regular/book-open-cover.svg");
const book_open_reader_svg_1 = require("../src/icons/regular/book-open-reader.svg");
const book_open_svg_1 = require("../src/icons/regular/book-open.svg");
const book_quran_svg_1 = require("../src/icons/regular/book-quran.svg");
const book_section_svg_1 = require("../src/icons/regular/book-section.svg");
const book_skull_svg_1 = require("../src/icons/regular/book-skull.svg");
const book_sparkles_svg_1 = require("../src/icons/regular/book-sparkles.svg");
const book_tanakh_svg_1 = require("../src/icons/regular/book-tanakh.svg");
const book_user_svg_1 = require("../src/icons/regular/book-user.svg");
const book_svg_1 = require("../src/icons/regular/book.svg");
const bookmark_slash_svg_1 = require("../src/icons/regular/bookmark-slash.svg");
const bookmark_svg_1 = require("../src/icons/regular/bookmark.svg");
const books_medical_svg_1 = require("../src/icons/regular/books-medical.svg");
const books_svg_1 = require("../src/icons/regular/books.svg");
const boombox_svg_1 = require("../src/icons/regular/boombox.svg");
const boot_svg_1 = require("../src/icons/regular/boot.svg");
const booth_curtain_svg_1 = require("../src/icons/regular/booth-curtain.svg");
const border_all_svg_1 = require("../src/icons/regular/border-all.svg");
const border_bottom_right_svg_1 = require("../src/icons/regular/border-bottom-right.svg");
const border_bottom_svg_1 = require("../src/icons/regular/border-bottom.svg");
const border_center_h_svg_1 = require("../src/icons/regular/border-center-h.svg");
const border_center_v_svg_1 = require("../src/icons/regular/border-center-v.svg");
const border_inner_svg_1 = require("../src/icons/regular/border-inner.svg");
const border_left_svg_1 = require("../src/icons/regular/border-left.svg");
const border_none_svg_1 = require("../src/icons/regular/border-none.svg");
const border_outer_svg_1 = require("../src/icons/regular/border-outer.svg");
const border_right_svg_1 = require("../src/icons/regular/border-right.svg");
const border_top_left_svg_1 = require("../src/icons/regular/border-top-left.svg");
const border_top_svg_1 = require("../src/icons/regular/border-top.svg");
const bow_arrow_svg_1 = require("../src/icons/regular/bow-arrow.svg");
const bowl_hot_svg_1 = require("../src/icons/regular/bowl-hot.svg");
const bowling_ball_pin_svg_1 = require("../src/icons/regular/bowling-ball-pin.svg");
const bowling_ball_svg_1 = require("../src/icons/regular/bowling-ball.svg");
const bowling_pins_svg_1 = require("../src/icons/regular/bowling-pins.svg");
const box_archive_svg_1 = require("../src/icons/regular/box-archive.svg");
const box_ballot_svg_1 = require("../src/icons/regular/box-ballot.svg");
const box_check_svg_1 = require("../src/icons/regular/box-check.svg");
const box_circle_check_svg_1 = require("../src/icons/regular/box-circle-check.svg");
const box_dollar_svg_1 = require("../src/icons/regular/box-dollar.svg");
const box_heart_svg_1 = require("../src/icons/regular/box-heart.svg");
const box_open_full_svg_1 = require("../src/icons/regular/box-open-full.svg");
const box_open_svg_1 = require("../src/icons/regular/box-open.svg");
const box_taped_svg_1 = require("../src/icons/regular/box-taped.svg");
const box_tissue_svg_1 = require("../src/icons/regular/box-tissue.svg");
const box_svg_1 = require("../src/icons/regular/box.svg");
const boxes_stacked_svg_1 = require("../src/icons/regular/boxes-stacked.svg");
const boxing_glove_svg_1 = require("../src/icons/regular/boxing-glove.svg");
const bracket_curly_right_svg_1 = require("../src/icons/regular/bracket-curly-right.svg");
const bracket_curly_svg_1 = require("../src/icons/regular/bracket-curly.svg");
const bracket_round_right_svg_1 = require("../src/icons/regular/bracket-round-right.svg");
const bracket_round_svg_1 = require("../src/icons/regular/bracket-round.svg");
const bracket_square_right_svg_1 = require("../src/icons/regular/bracket-square-right.svg");
const bracket_square_svg_1 = require("../src/icons/regular/bracket-square.svg");
const brackets_curly_svg_1 = require("../src/icons/regular/brackets-curly.svg");
const brackets_round_svg_1 = require("../src/icons/regular/brackets-round.svg");
const brackets_square_svg_1 = require("../src/icons/regular/brackets-square.svg");
const braille_svg_1 = require("../src/icons/regular/braille.svg");
const brain_arrow_curved_right_svg_1 = require("../src/icons/regular/brain-arrow-curved-right.svg");
const brain_circuit_svg_1 = require("../src/icons/regular/brain-circuit.svg");
const brain_svg_1 = require("../src/icons/regular/brain.svg");
const brake_warning_svg_1 = require("../src/icons/regular/brake-warning.svg");
const bread_loaf_svg_1 = require("../src/icons/regular/bread-loaf.svg");
const bread_slice_svg_1 = require("../src/icons/regular/bread-slice.svg");
const briefcase_arrow_right_svg_1 = require("../src/icons/regular/briefcase-arrow-right.svg");
const briefcase_clock_svg_1 = require("../src/icons/regular/briefcase-clock.svg");
const briefcase_medical_svg_1 = require("../src/icons/regular/briefcase-medical.svg");
const briefcase_svg_1 = require("../src/icons/regular/briefcase.svg");
const bring_forward_svg_1 = require("../src/icons/regular/bring-forward.svg");
const bring_front_svg_1 = require("../src/icons/regular/bring-front.svg");
const broom_svg_1 = require("../src/icons/regular/broom.svg");
const browser_svg_1 = require("../src/icons/regular/browser.svg");
const browsers_svg_1 = require("../src/icons/regular/browsers.svg");
const brush_svg_1 = require("../src/icons/regular/brush.svg");
const bug_svg_1 = require("../src/icons/regular/bug.svg");
const building_svg_1 = require("../src/icons/regular/building.svg");
const buildings_svg_1 = require("../src/icons/regular/buildings.svg");
const bullhorn_svg_1 = require("../src/icons/regular/bullhorn.svg");
const bullseye_arrow_svg_1 = require("../src/icons/regular/bullseye-arrow.svg");
const bullseye_pointer_svg_1 = require("../src/icons/regular/bullseye-pointer.svg");
const bullseye_svg_1 = require("../src/icons/regular/bullseye.svg");
const burger_cheese_svg_1 = require("../src/icons/regular/burger-cheese.svg");
const burger_fries_svg_1 = require("../src/icons/regular/burger-fries.svg");
const burger_glass_svg_1 = require("../src/icons/regular/burger-glass.svg");
const burger_soda_svg_1 = require("../src/icons/regular/burger-soda.svg");
const burger_svg_1 = require("../src/icons/regular/burger.svg");
const burrito_svg_1 = require("../src/icons/regular/burrito.svg");
const bus_school_svg_1 = require("../src/icons/regular/bus-school.svg");
const bus_simple_svg_1 = require("../src/icons/regular/bus-simple.svg");
const bus_svg_1 = require("../src/icons/regular/bus.svg");
const c_svg_1 = require("../src/icons/regular/c.svg");
const cabinet_filing_svg_1 = require("../src/icons/regular/cabinet-filing.svg");
const cable_car_svg_1 = require("../src/icons/regular/cable-car.svg");
const cactus_svg_1 = require("../src/icons/regular/cactus.svg");
const cake_candles_svg_1 = require("../src/icons/regular/cake-candles.svg");
const calculator_simple_svg_1 = require("../src/icons/regular/calculator-simple.svg");
const calculator_svg_1 = require("../src/icons/regular/calculator.svg");
const calendar_arrow_down_svg_1 = require("../src/icons/regular/calendar-arrow-down.svg");
const calendar_arrow_up_svg_1 = require("../src/icons/regular/calendar-arrow-up.svg");
const calendar_check_svg_1 = require("../src/icons/regular/calendar-check.svg");
const calendar_clock_svg_1 = require("../src/icons/regular/calendar-clock.svg");
const calendar_day_svg_1 = require("../src/icons/regular/calendar-day.svg");
const calendar_days_svg_1 = require("../src/icons/regular/calendar-days.svg");
const calendar_exclamation_svg_1 = require("../src/icons/regular/calendar-exclamation.svg");
const calendar_heart_svg_1 = require("../src/icons/regular/calendar-heart.svg");
const calendar_image_svg_1 = require("../src/icons/regular/calendar-image.svg");
const calendar_lines_svg_1 = require("../src/icons/regular/calendar-lines.svg");
const calendar_minus_svg_1 = require("../src/icons/regular/calendar-minus.svg");
const calendar_pen_svg_1 = require("../src/icons/regular/calendar-pen.svg");
const calendar_plus_svg_1 = require("../src/icons/regular/calendar-plus.svg");
const calendar_range_svg_1 = require("../src/icons/regular/calendar-range.svg");
const calendar_star_svg_1 = require("../src/icons/regular/calendar-star.svg");
const calendar_week_svg_1 = require("../src/icons/regular/calendar-week.svg");
const calendar_xmark_svg_1 = require("../src/icons/regular/calendar-xmark.svg");
const calendar_svg_1 = require("../src/icons/regular/calendar.svg");
const calendars_svg_1 = require("../src/icons/regular/calendars.svg");
const camcorder_svg_1 = require("../src/icons/regular/camcorder.svg");
const camera_cctv_svg_1 = require("../src/icons/regular/camera-cctv.svg");
const camera_movie_svg_1 = require("../src/icons/regular/camera-movie.svg");
const camera_polaroid_svg_1 = require("../src/icons/regular/camera-polaroid.svg");
const camera_retro_svg_1 = require("../src/icons/regular/camera-retro.svg");
const camera_rotate_svg_1 = require("../src/icons/regular/camera-rotate.svg");
const camera_security_svg_1 = require("../src/icons/regular/camera-security.svg");
const camera_slash_svg_1 = require("../src/icons/regular/camera-slash.svg");
const camera_viewfinder_svg_1 = require("../src/icons/regular/camera-viewfinder.svg");
const camera_web_slash_svg_1 = require("../src/icons/regular/camera-web-slash.svg");
const camera_web_svg_1 = require("../src/icons/regular/camera-web.svg");
const camera_svg_1 = require("../src/icons/regular/camera.svg");
const campfire_svg_1 = require("../src/icons/regular/campfire.svg");
const campground_svg_1 = require("../src/icons/regular/campground.svg");
const candle_holder_svg_1 = require("../src/icons/regular/candle-holder.svg");
const candy_cane_svg_1 = require("../src/icons/regular/candy-cane.svg");
const candy_corn_svg_1 = require("../src/icons/regular/candy-corn.svg");
const cannabis_svg_1 = require("../src/icons/regular/cannabis.svg");
const capsules_svg_1 = require("../src/icons/regular/capsules.svg");
const car_battery_svg_1 = require("../src/icons/regular/car-battery.svg");
const car_building_svg_1 = require("../src/icons/regular/car-building.svg");
const car_bump_svg_1 = require("../src/icons/regular/car-bump.svg");
const car_bus_svg_1 = require("../src/icons/regular/car-bus.svg");
const car_crash_svg_1 = require("../src/icons/regular/car-crash.svg");
const car_garage_svg_1 = require("../src/icons/regular/car-garage.svg");
const car_rear_svg_1 = require("../src/icons/regular/car-rear.svg");
const car_side_svg_1 = require("../src/icons/regular/car-side.svg");
const car_tilt_svg_1 = require("../src/icons/regular/car-tilt.svg");
const car_wash_svg_1 = require("../src/icons/regular/car-wash.svg");
const car_wrench_svg_1 = require("../src/icons/regular/car-wrench.svg");
const car_svg_1 = require("../src/icons/regular/car.svg");
const caravan_simple_svg_1 = require("../src/icons/regular/caravan-simple.svg");
const caravan_svg_1 = require("../src/icons/regular/caravan.svg");
const caret_down_svg_1 = require("../src/icons/regular/caret-down.svg");
const caret_left_svg_1 = require("../src/icons/regular/caret-left.svg");
const caret_right_svg_1 = require("../src/icons/regular/caret-right.svg");
const caret_up_svg_1 = require("../src/icons/regular/caret-up.svg");
const carrot_svg_1 = require("../src/icons/regular/carrot.svg");
const cars_svg_1 = require("../src/icons/regular/cars.svg");
const cart_arrow_down_svg_1 = require("../src/icons/regular/cart-arrow-down.svg");
const cart_flatbed_boxes_svg_1 = require("../src/icons/regular/cart-flatbed-boxes.svg");
const cart_flatbed_empty_svg_1 = require("../src/icons/regular/cart-flatbed-empty.svg");
const cart_flatbed_suitcase_svg_1 = require("../src/icons/regular/cart-flatbed-suitcase.svg");
const cart_flatbed_svg_1 = require("../src/icons/regular/cart-flatbed.svg");
const cart_plus_svg_1 = require("../src/icons/regular/cart-plus.svg");
const cart_shopping_fast_svg_1 = require("../src/icons/regular/cart-shopping-fast.svg");
const cart_shopping_svg_1 = require("../src/icons/regular/cart-shopping.svg");
const casette_betamax_svg_1 = require("../src/icons/regular/casette-betamax.svg");
const casette_vhs_svg_1 = require("../src/icons/regular/casette-vhs.svg");
const cash_register_svg_1 = require("../src/icons/regular/cash-register.svg");
const cassette_tape_svg_1 = require("../src/icons/regular/cassette-tape.svg");
const castle_svg_1 = require("../src/icons/regular/castle.svg");
const cat_space_svg_1 = require("../src/icons/regular/cat-space.svg");
const cat_svg_1 = require("../src/icons/regular/cat.svg");
const cauldron_svg_1 = require("../src/icons/regular/cauldron.svg");
const cedi_sign_svg_1 = require("../src/icons/regular/cedi-sign.svg");
const cent_sign_svg_1 = require("../src/icons/regular/cent-sign.svg");
const certificate_svg_1 = require("../src/icons/regular/certificate.svg");
const chair_office_svg_1 = require("../src/icons/regular/chair-office.svg");
const chair_svg_1 = require("../src/icons/regular/chair.svg");
const chalkboard_user_svg_1 = require("../src/icons/regular/chalkboard-user.svg");
const chalkboard_svg_1 = require("../src/icons/regular/chalkboard.svg");
const champagne_glass_svg_1 = require("../src/icons/regular/champagne-glass.svg");
const champagne_glasses_svg_1 = require("../src/icons/regular/champagne-glasses.svg");
const charging_station_svg_1 = require("../src/icons/regular/charging-station.svg");
const chart_area_svg_1 = require("../src/icons/regular/chart-area.svg");
const chart_bar_svg_1 = require("../src/icons/regular/chart-bar.svg");
const chart_bullet_svg_1 = require("../src/icons/regular/chart-bullet.svg");
const chart_candlestick_svg_1 = require("../src/icons/regular/chart-candlestick.svg");
const chart_column_svg_1 = require("../src/icons/regular/chart-column.svg");
const chart_gantt_svg_1 = require("../src/icons/regular/chart-gantt.svg");
const chart_line_down_svg_1 = require("../src/icons/regular/chart-line-down.svg");
const chart_line_up_svg_1 = require("../src/icons/regular/chart-line-up.svg");
const chart_line_svg_1 = require("../src/icons/regular/chart-line.svg");
const chart_mixed_svg_1 = require("../src/icons/regular/chart-mixed.svg");
const chart_network_svg_1 = require("../src/icons/regular/chart-network.svg");
const chart_pie_simple_svg_1 = require("../src/icons/regular/chart-pie-simple.svg");
const chart_pie_svg_1 = require("../src/icons/regular/chart-pie.svg");
const chart_pyramid_svg_1 = require("../src/icons/regular/chart-pyramid.svg");
const chart_radar_svg_1 = require("../src/icons/regular/chart-radar.svg");
const chart_scatter_3d_svg_1 = require("../src/icons/regular/chart-scatter-3d.svg");
const chart_scatter_bubble_svg_1 = require("../src/icons/regular/chart-scatter-bubble.svg");
const chart_scatter_svg_1 = require("../src/icons/regular/chart-scatter.svg");
const chart_tree_map_svg_1 = require("../src/icons/regular/chart-tree-map.svg");
const chart_user_svg_1 = require("../src/icons/regular/chart-user.svg");
const chart_waterfall_svg_1 = require("../src/icons/regular/chart-waterfall.svg");
const check_double_svg_1 = require("../src/icons/regular/check-double.svg");
const check_to_slot_svg_1 = require("../src/icons/regular/check-to-slot.svg");
const check_svg_1 = require("../src/icons/regular/check.svg");
const cheese_swiss_svg_1 = require("../src/icons/regular/cheese-swiss.svg");
const cheese_svg_1 = require("../src/icons/regular/cheese.svg");
const cherries_svg_1 = require("../src/icons/regular/cherries.svg");
const chess_bishop_piece_svg_1 = require("../src/icons/regular/chess-bishop-piece.svg");
const chess_bishop_svg_1 = require("../src/icons/regular/chess-bishop.svg");
const chess_board_svg_1 = require("../src/icons/regular/chess-board.svg");
const chess_clock_flip_svg_1 = require("../src/icons/regular/chess-clock-flip.svg");
const chess_clock_svg_1 = require("../src/icons/regular/chess-clock.svg");
const chess_king_piece_svg_1 = require("../src/icons/regular/chess-king-piece.svg");
const chess_king_svg_1 = require("../src/icons/regular/chess-king.svg");
const chess_knight_piece_svg_1 = require("../src/icons/regular/chess-knight-piece.svg");
const chess_knight_svg_1 = require("../src/icons/regular/chess-knight.svg");
const chess_pawn_piece_svg_1 = require("../src/icons/regular/chess-pawn-piece.svg");
const chess_pawn_svg_1 = require("../src/icons/regular/chess-pawn.svg");
const chess_queen_piece_svg_1 = require("../src/icons/regular/chess-queen-piece.svg");
const chess_queen_svg_1 = require("../src/icons/regular/chess-queen.svg");
const chess_rook_piece_svg_1 = require("../src/icons/regular/chess-rook-piece.svg");
const chess_rook_svg_1 = require("../src/icons/regular/chess-rook.svg");
const chess_svg_1 = require("../src/icons/regular/chess.svg");
const chevron_down_svg_1 = require("../src/icons/regular/chevron-down.svg");
const chevron_left_svg_1 = require("../src/icons/regular/chevron-left.svg");
const chevron_right_svg_1 = require("../src/icons/regular/chevron-right.svg");
const chevron_up_svg_1 = require("../src/icons/regular/chevron-up.svg");
const chevrons_down_svg_1 = require("../src/icons/regular/chevrons-down.svg");
const chevrons_left_svg_1 = require("../src/icons/regular/chevrons-left.svg");
const chevrons_right_svg_1 = require("../src/icons/regular/chevrons-right.svg");
const chevrons_up_svg_1 = require("../src/icons/regular/chevrons-up.svg");
const child_svg_1 = require("../src/icons/regular/child.svg");
const chimney_svg_1 = require("../src/icons/regular/chimney.svg");
const church_svg_1 = require("../src/icons/regular/church.svg");
const circle_0_svg_1 = require("../src/icons/regular/circle-0.svg");
const circle_1_svg_1 = require("../src/icons/regular/circle-1.svg");
const circle_2_svg_1 = require("../src/icons/regular/circle-2.svg");
const circle_3_svg_1 = require("../src/icons/regular/circle-3.svg");
const circle_4_svg_1 = require("../src/icons/regular/circle-4.svg");
const circle_5_svg_1 = require("../src/icons/regular/circle-5.svg");
const circle_6_svg_1 = require("../src/icons/regular/circle-6.svg");
const circle_7_svg_1 = require("../src/icons/regular/circle-7.svg");
const circle_8_svg_1 = require("../src/icons/regular/circle-8.svg");
const circle_9_svg_1 = require("../src/icons/regular/circle-9.svg");
const circle_a_svg_1 = require("../src/icons/regular/circle-a.svg");
const circle_ampersand_svg_1 = require("../src/icons/regular/circle-ampersand.svg");
const circle_arrow_down_left_svg_1 = require("../src/icons/regular/circle-arrow-down-left.svg");
const circle_arrow_down_right_svg_1 = require("../src/icons/regular/circle-arrow-down-right.svg");
const circle_arrow_down_svg_1 = require("../src/icons/regular/circle-arrow-down.svg");
const circle_arrow_left_svg_1 = require("../src/icons/regular/circle-arrow-left.svg");
const circle_arrow_right_svg_1 = require("../src/icons/regular/circle-arrow-right.svg");
const circle_arrow_up_left_svg_1 = require("../src/icons/regular/circle-arrow-up-left.svg");
const circle_arrow_up_right_svg_1 = require("../src/icons/regular/circle-arrow-up-right.svg");
const circle_arrow_up_svg_1 = require("../src/icons/regular/circle-arrow-up.svg");
const circle_b_svg_1 = require("../src/icons/regular/circle-b.svg");
const circle_bolt_svg_1 = require("../src/icons/regular/circle-bolt.svg");
const circle_book_open_svg_1 = require("../src/icons/regular/circle-book-open.svg");
const circle_bookmark_svg_1 = require("../src/icons/regular/circle-bookmark.svg");
const circle_c_svg_1 = require("../src/icons/regular/circle-c.svg");
const circle_calendar_svg_1 = require("../src/icons/regular/circle-calendar.svg");
const circle_camera_svg_1 = require("../src/icons/regular/circle-camera.svg");
const circle_caret_down_svg_1 = require("../src/icons/regular/circle-caret-down.svg");
const circle_caret_left_svg_1 = require("../src/icons/regular/circle-caret-left.svg");
const circle_caret_right_svg_1 = require("../src/icons/regular/circle-caret-right.svg");
const circle_caret_up_svg_1 = require("../src/icons/regular/circle-caret-up.svg");
const circle_check_svg_1 = require("../src/icons/regular/circle-check.svg");
const circle_chevron_down_svg_1 = require("../src/icons/regular/circle-chevron-down.svg");
const circle_chevron_left_svg_1 = require("../src/icons/regular/circle-chevron-left.svg");
const circle_chevron_right_svg_1 = require("../src/icons/regular/circle-chevron-right.svg");
const circle_chevron_up_svg_1 = require("../src/icons/regular/circle-chevron-up.svg");
const circle_d_svg_1 = require("../src/icons/regular/circle-d.svg");
const circle_dashed_svg_1 = require("../src/icons/regular/circle-dashed.svg");
const circle_divide_svg_1 = require("../src/icons/regular/circle-divide.svg");
const circle_dollar_to_slot_svg_1 = require("../src/icons/regular/circle-dollar-to-slot.svg");
const circle_dollar_svg_1 = require("../src/icons/regular/circle-dollar.svg");
const circle_dot_svg_1 = require("../src/icons/regular/circle-dot.svg");
const circle_down_left_svg_1 = require("../src/icons/regular/circle-down-left.svg");
const circle_down_right_svg_1 = require("../src/icons/regular/circle-down-right.svg");
const circle_down_svg_1 = require("../src/icons/regular/circle-down.svg");
const circle_e_svg_1 = require("../src/icons/regular/circle-e.svg");
const circle_envelope_svg_1 = require("../src/icons/regular/circle-envelope.svg");
const circle_exclamation_check_svg_1 = require("../src/icons/regular/circle-exclamation-check.svg");
const circle_exclamation_svg_1 = require("../src/icons/regular/circle-exclamation.svg");
const circle_f_svg_1 = require("../src/icons/regular/circle-f.svg");
const circle_g_svg_1 = require("../src/icons/regular/circle-g.svg");
const circle_h_svg_1 = require("../src/icons/regular/circle-h.svg");
const circle_half_stroke_svg_1 = require("../src/icons/regular/circle-half-stroke.svg");
const circle_half_svg_1 = require("../src/icons/regular/circle-half.svg");
const circle_heart_svg_1 = require("../src/icons/regular/circle-heart.svg");
const circle_i_svg_1 = require("../src/icons/regular/circle-i.svg");
const circle_info_svg_1 = require("../src/icons/regular/circle-info.svg");
const circle_j_svg_1 = require("../src/icons/regular/circle-j.svg");
const circle_k_svg_1 = require("../src/icons/regular/circle-k.svg");
const circle_l_svg_1 = require("../src/icons/regular/circle-l.svg");
const circle_left_svg_1 = require("../src/icons/regular/circle-left.svg");
const circle_location_arrow_svg_1 = require("../src/icons/regular/circle-location-arrow.svg");
const circle_m_svg_1 = require("../src/icons/regular/circle-m.svg");
const circle_microphone_lines_svg_1 = require("../src/icons/regular/circle-microphone-lines.svg");
const circle_microphone_svg_1 = require("../src/icons/regular/circle-microphone.svg");
const circle_minus_svg_1 = require("../src/icons/regular/circle-minus.svg");
const circle_n_svg_1 = require("../src/icons/regular/circle-n.svg");
const circle_notch_svg_1 = require("../src/icons/regular/circle-notch.svg");
const circle_o_svg_1 = require("../src/icons/regular/circle-o.svg");
const circle_p_svg_1 = require("../src/icons/regular/circle-p.svg");
const circle_parking_svg_1 = require("../src/icons/regular/circle-parking.svg");
const circle_pause_svg_1 = require("../src/icons/regular/circle-pause.svg");
const circle_phone_flip_svg_1 = require("../src/icons/regular/circle-phone-flip.svg");
const circle_phone_hangup_svg_1 = require("../src/icons/regular/circle-phone-hangup.svg");
const circle_phone_svg_1 = require("../src/icons/regular/circle-phone.svg");
const circle_play_svg_1 = require("../src/icons/regular/circle-play.svg");
const circle_plus_svg_1 = require("../src/icons/regular/circle-plus.svg");
const circle_q_svg_1 = require("../src/icons/regular/circle-q.svg");
const circle_quarter_svg_1 = require("../src/icons/regular/circle-quarter.svg");
const circle_question_svg_1 = require("../src/icons/regular/circle-question.svg");
const circle_r_svg_1 = require("../src/icons/regular/circle-r.svg");
const circle_radiation_svg_1 = require("../src/icons/regular/circle-radiation.svg");
const circle_right_svg_1 = require("../src/icons/regular/circle-right.svg");
const circle_s_svg_1 = require("../src/icons/regular/circle-s.svg");
const circle_small_svg_1 = require("../src/icons/regular/circle-small.svg");
const circle_sort_down_svg_1 = require("../src/icons/regular/circle-sort-down.svg");
const circle_sort_up_svg_1 = require("../src/icons/regular/circle-sort-up.svg");
const circle_sort_svg_1 = require("../src/icons/regular/circle-sort.svg");
const circle_star_svg_1 = require("../src/icons/regular/circle-star.svg");
const circle_stop_svg_1 = require("../src/icons/regular/circle-stop.svg");
const circle_t_svg_1 = require("../src/icons/regular/circle-t.svg");
const circle_three_quarters_svg_1 = require("../src/icons/regular/circle-three-quarters.svg");
const circle_trash_svg_1 = require("../src/icons/regular/circle-trash.svg");
const circle_u_svg_1 = require("../src/icons/regular/circle-u.svg");
const circle_up_left_svg_1 = require("../src/icons/regular/circle-up-left.svg");
const circle_up_right_svg_1 = require("../src/icons/regular/circle-up-right.svg");
const circle_up_svg_1 = require("../src/icons/regular/circle-up.svg");
const circle_user_svg_1 = require("../src/icons/regular/circle-user.svg");
const circle_v_svg_1 = require("../src/icons/regular/circle-v.svg");
const circle_video_svg_1 = require("../src/icons/regular/circle-video.svg");
const circle_w_svg_1 = require("../src/icons/regular/circle-w.svg");
const circle_waveform_lines_svg_1 = require("../src/icons/regular/circle-waveform-lines.svg");
const circle_x_svg_1 = require("../src/icons/regular/circle-x.svg");
const circle_xmark_svg_1 = require("../src/icons/regular/circle-xmark.svg");
const circle_y_svg_1 = require("../src/icons/regular/circle-y.svg");
const circle_z_svg_1 = require("../src/icons/regular/circle-z.svg");
const circle_svg_1 = require("../src/icons/regular/circle.svg");
const city_svg_1 = require("../src/icons/regular/city.svg");
const clapperboard_play_svg_1 = require("../src/icons/regular/clapperboard-play.svg");
const clapperboard_svg_1 = require("../src/icons/regular/clapperboard.svg");
const clarinet_svg_1 = require("../src/icons/regular/clarinet.svg");
const claw_marks_svg_1 = require("../src/icons/regular/claw-marks.svg");
const clipboard_check_svg_1 = require("../src/icons/regular/clipboard-check.svg");
const clipboard_list_check_svg_1 = require("../src/icons/regular/clipboard-list-check.svg");
const clipboard_list_svg_1 = require("../src/icons/regular/clipboard-list.svg");
const clipboard_medical_svg_1 = require("../src/icons/regular/clipboard-medical.svg");
const clipboard_prescription_svg_1 = require("../src/icons/regular/clipboard-prescription.svg");
const clipboard_user_svg_1 = require("../src/icons/regular/clipboard-user.svg");
const clipboard_svg_1 = require("../src/icons/regular/clipboard.svg");
const clock_desk_svg_1 = require("../src/icons/regular/clock-desk.svg");
const clock_rotate_left_svg_1 = require("../src/icons/regular/clock-rotate-left.svg");
const clock_svg_1 = require("../src/icons/regular/clock.svg");
const clone_svg_1 = require("../src/icons/regular/clone.svg");
const closed_captioning_slash_svg_1 = require("../src/icons/regular/closed-captioning-slash.svg");
const closed_captioning_svg_1 = require("../src/icons/regular/closed-captioning.svg");
const clothes_hanger_svg_1 = require("../src/icons/regular/clothes-hanger.svg");
const cloud_arrow_down_svg_1 = require("../src/icons/regular/cloud-arrow-down.svg");
const cloud_arrow_up_svg_1 = require("../src/icons/regular/cloud-arrow-up.svg");
const cloud_bolt_moon_svg_1 = require("../src/icons/regular/cloud-bolt-moon.svg");
const cloud_bolt_sun_svg_1 = require("../src/icons/regular/cloud-bolt-sun.svg");
const cloud_bolt_svg_1 = require("../src/icons/regular/cloud-bolt.svg");
const cloud_drizzle_svg_1 = require("../src/icons/regular/cloud-drizzle.svg");
const cloud_fog_svg_1 = require("../src/icons/regular/cloud-fog.svg");
const cloud_hail_mixed_svg_1 = require("../src/icons/regular/cloud-hail-mixed.svg");
const cloud_hail_svg_1 = require("../src/icons/regular/cloud-hail.svg");
const cloud_meatball_svg_1 = require("../src/icons/regular/cloud-meatball.svg");
const cloud_moon_rain_svg_1 = require("../src/icons/regular/cloud-moon-rain.svg");
const cloud_moon_svg_1 = require("../src/icons/regular/cloud-moon.svg");
const cloud_music_svg_1 = require("../src/icons/regular/cloud-music.svg");
const cloud_rain_svg_1 = require("../src/icons/regular/cloud-rain.svg");
const cloud_rainbow_svg_1 = require("../src/icons/regular/cloud-rainbow.svg");
const cloud_showers_heavy_svg_1 = require("../src/icons/regular/cloud-showers-heavy.svg");
const cloud_showers_svg_1 = require("../src/icons/regular/cloud-showers.svg");
const cloud_slash_svg_1 = require("../src/icons/regular/cloud-slash.svg");
const cloud_sleet_svg_1 = require("../src/icons/regular/cloud-sleet.svg");
const cloud_snow_svg_1 = require("../src/icons/regular/cloud-snow.svg");
const cloud_sun_rain_svg_1 = require("../src/icons/regular/cloud-sun-rain.svg");
const cloud_sun_svg_1 = require("../src/icons/regular/cloud-sun.svg");
const cloud_word_svg_1 = require("../src/icons/regular/cloud-word.svg");
const cloud_svg_1 = require("../src/icons/regular/cloud.svg");
const clouds_moon_svg_1 = require("../src/icons/regular/clouds-moon.svg");
const clouds_sun_svg_1 = require("../src/icons/regular/clouds-sun.svg");
const clouds_svg_1 = require("../src/icons/regular/clouds.svg");
const clover_svg_1 = require("../src/icons/regular/clover.svg");
const club_svg_1 = require("../src/icons/regular/club.svg");
const code_branch_svg_1 = require("../src/icons/regular/code-branch.svg");
const code_commit_svg_1 = require("../src/icons/regular/code-commit.svg");
const code_compare_svg_1 = require("../src/icons/regular/code-compare.svg");
const code_fork_svg_1 = require("../src/icons/regular/code-fork.svg");
const code_merge_svg_1 = require("../src/icons/regular/code-merge.svg");
const code_pull_request_svg_1 = require("../src/icons/regular/code-pull-request.svg");
const code_simple_svg_1 = require("../src/icons/regular/code-simple.svg");
const code_svg_1 = require("../src/icons/regular/code.svg");
const coffee_bean_svg_1 = require("../src/icons/regular/coffee-bean.svg");
const coffee_beans_svg_1 = require("../src/icons/regular/coffee-beans.svg");
const coffee_pot_svg_1 = require("../src/icons/regular/coffee-pot.svg");
const coffin_cross_svg_1 = require("../src/icons/regular/coffin-cross.svg");
const coffin_svg_1 = require("../src/icons/regular/coffin.svg");
const coin_svg_1 = require("../src/icons/regular/coin.svg");
const coins_svg_1 = require("../src/icons/regular/coins.svg");
const colon_sign_svg_1 = require("../src/icons/regular/colon-sign.svg");
const comet_svg_1 = require("../src/icons/regular/comet.svg");
const command_svg_1 = require("../src/icons/regular/command.svg");
const comment_arrow_down_svg_1 = require("../src/icons/regular/comment-arrow-down.svg");
const comment_arrow_up_right_svg_1 = require("../src/icons/regular/comment-arrow-up-right.svg");
const comment_arrow_up_svg_1 = require("../src/icons/regular/comment-arrow-up.svg");
const comment_captions_svg_1 = require("../src/icons/regular/comment-captions.svg");
const comment_check_svg_1 = require("../src/icons/regular/comment-check.svg");
const comment_code_svg_1 = require("../src/icons/regular/comment-code.svg");
const comment_dollar_svg_1 = require("../src/icons/regular/comment-dollar.svg");
const comment_dots_svg_1 = require("../src/icons/regular/comment-dots.svg");
const comment_exclamation_svg_1 = require("../src/icons/regular/comment-exclamation.svg");
const comment_image_svg_1 = require("../src/icons/regular/comment-image.svg");
const comment_lines_svg_1 = require("../src/icons/regular/comment-lines.svg");
const comment_medical_svg_1 = require("../src/icons/regular/comment-medical.svg");
const comment_middle_top_svg_1 = require("../src/icons/regular/comment-middle-top.svg");
const comment_middle_svg_1 = require("../src/icons/regular/comment-middle.svg");
const comment_minus_svg_1 = require("../src/icons/regular/comment-minus.svg");
const comment_music_svg_1 = require("../src/icons/regular/comment-music.svg");
const comment_pen_svg_1 = require("../src/icons/regular/comment-pen.svg");
const comment_plus_svg_1 = require("../src/icons/regular/comment-plus.svg");
const comment_question_svg_1 = require("../src/icons/regular/comment-question.svg");
const comment_quote_svg_1 = require("../src/icons/regular/comment-quote.svg");
const comment_slash_svg_1 = require("../src/icons/regular/comment-slash.svg");
const comment_smile_svg_1 = require("../src/icons/regular/comment-smile.svg");
const comment_sms_svg_1 = require("../src/icons/regular/comment-sms.svg");
const comment_text_svg_1 = require("../src/icons/regular/comment-text.svg");
const comment_xmark_svg_1 = require("../src/icons/regular/comment-xmark.svg");
const comment_svg_1 = require("../src/icons/regular/comment.svg");
const comments_dollar_svg_1 = require("../src/icons/regular/comments-dollar.svg");
const comments_question_check_svg_1 = require("../src/icons/regular/comments-question-check.svg");
const comments_question_svg_1 = require("../src/icons/regular/comments-question.svg");
const comments_svg_1 = require("../src/icons/regular/comments.svg");
const compact_disc_svg_1 = require("../src/icons/regular/compact-disc.svg");
const compass_drafting_svg_1 = require("../src/icons/regular/compass-drafting.svg");
const compass_slash_svg_1 = require("../src/icons/regular/compass-slash.svg");
const compass_svg_1 = require("../src/icons/regular/compass.svg");
const compress_wide_svg_1 = require("../src/icons/regular/compress-wide.svg");
const compress_svg_1 = require("../src/icons/regular/compress.svg");
const computer_classic_svg_1 = require("../src/icons/regular/computer-classic.svg");
const computer_mouse_scrollwheel_svg_1 = require("../src/icons/regular/computer-mouse-scrollwheel.svg");
const computer_mouse_svg_1 = require("../src/icons/regular/computer-mouse.svg");
const computer_speaker_svg_1 = require("../src/icons/regular/computer-speaker.svg");
const container_storage_svg_1 = require("../src/icons/regular/container-storage.svg");
const conveyor_belt_boxes_svg_1 = require("../src/icons/regular/conveyor-belt-boxes.svg");
const conveyor_belt_empty_svg_1 = require("../src/icons/regular/conveyor-belt-empty.svg");
const conveyor_belt_svg_1 = require("../src/icons/regular/conveyor-belt.svg");
const cookie_bite_svg_1 = require("../src/icons/regular/cookie-bite.svg");
const cookie_svg_1 = require("../src/icons/regular/cookie.svg");
const copy_svg_1 = require("../src/icons/regular/copy.svg");
const copyright_svg_1 = require("../src/icons/regular/copyright.svg");
const corn_svg_1 = require("../src/icons/regular/corn.svg");
const couch_svg_1 = require("../src/icons/regular/couch.svg");
const cow_svg_1 = require("../src/icons/regular/cow.svg");
const cowbell_circle_plus_svg_1 = require("../src/icons/regular/cowbell-circle-plus.svg");
const cowbell_svg_1 = require("../src/icons/regular/cowbell.svg");
const credit_card_blank_svg_1 = require("../src/icons/regular/credit-card-blank.svg");
const credit_card_front_svg_1 = require("../src/icons/regular/credit-card-front.svg");
const credit_card_svg_1 = require("../src/icons/regular/credit-card.svg");
const cricket_bat_ball_svg_1 = require("../src/icons/regular/cricket-bat-ball.svg");
const croissant_svg_1 = require("../src/icons/regular/croissant.svg");
const crop_simple_svg_1 = require("../src/icons/regular/crop-simple.svg");
const crop_svg_1 = require("../src/icons/regular/crop.svg");
const cross_svg_1 = require("../src/icons/regular/cross.svg");
const crosshairs_svg_1 = require("../src/icons/regular/crosshairs.svg");
const crow_svg_1 = require("../src/icons/regular/crow.svg");
const crown_svg_1 = require("../src/icons/regular/crown.svg");
const crutch_svg_1 = require("../src/icons/regular/crutch.svg");
const crutches_svg_1 = require("../src/icons/regular/crutches.svg");
const cruzeiro_sign_svg_1 = require("../src/icons/regular/cruzeiro-sign.svg");
const cube_svg_1 = require("../src/icons/regular/cube.svg");
const cubes_svg_1 = require("../src/icons/regular/cubes.svg");
const cup_togo_svg_1 = require("../src/icons/regular/cup-togo.svg");
const curling_stone_svg_1 = require("../src/icons/regular/curling-stone.svg");
const d_svg_1 = require("../src/icons/regular/d.svg");
const dagger_svg_1 = require("../src/icons/regular/dagger.svg");
const database_svg_1 = require("../src/icons/regular/database.svg");
const deer_rudolph_svg_1 = require("../src/icons/regular/deer-rudolph.svg");
const deer_svg_1 = require("../src/icons/regular/deer.svg");
const delete_left_svg_1 = require("../src/icons/regular/delete-left.svg");
const delete_right_svg_1 = require("../src/icons/regular/delete-right.svg");
const democrat_svg_1 = require("../src/icons/regular/democrat.svg");
const desktop_arrow_down_svg_1 = require("../src/icons/regular/desktop-arrow-down.svg");
const desktop_svg_1 = require("../src/icons/regular/desktop.svg");
const dharmachakra_svg_1 = require("../src/icons/regular/dharmachakra.svg");
const diagram_lean_canvas_svg_1 = require("../src/icons/regular/diagram-lean-canvas.svg");
const diagram_nested_svg_1 = require("../src/icons/regular/diagram-nested.svg");
const diagram_project_svg_1 = require("../src/icons/regular/diagram-project.svg");
const diagram_sankey_svg_1 = require("../src/icons/regular/diagram-sankey.svg");
const diagram_stankey_svg_1 = require("../src/icons/regular/diagram-stankey.svg");
const diagram_venn_svg_1 = require("../src/icons/regular/diagram-venn.svg");
const dial_high_svg_1 = require("../src/icons/regular/dial-high.svg");
const dial_low_svg_1 = require("../src/icons/regular/dial-low.svg");
const dial_max_svg_1 = require("../src/icons/regular/dial-max.svg");
const dial_med_low_svg_1 = require("../src/icons/regular/dial-med-low.svg");
const dial_med_svg_1 = require("../src/icons/regular/dial-med.svg");
const dial_min_svg_1 = require("../src/icons/regular/dial-min.svg");
const dial_svg_1 = require("../src/icons/regular/dial.svg");
const diamond_turn_right_svg_1 = require("../src/icons/regular/diamond-turn-right.svg");
const diamond_svg_1 = require("../src/icons/regular/diamond.svg");
const dice_d10_svg_1 = require("../src/icons/regular/dice-d10.svg");
const dice_d12_svg_1 = require("../src/icons/regular/dice-d12.svg");
const dice_d20_svg_1 = require("../src/icons/regular/dice-d20.svg");
const dice_d4_svg_1 = require("../src/icons/regular/dice-d4.svg");
const dice_d6_svg_1 = require("../src/icons/regular/dice-d6.svg");
const dice_d8_svg_1 = require("../src/icons/regular/dice-d8.svg");
const dice_five_svg_1 = require("../src/icons/regular/dice-five.svg");
const dice_four_svg_1 = require("../src/icons/regular/dice-four.svg");
const dice_one_svg_1 = require("../src/icons/regular/dice-one.svg");
const dice_six_svg_1 = require("../src/icons/regular/dice-six.svg");
const dice_three_svg_1 = require("../src/icons/regular/dice-three.svg");
const dice_two_svg_1 = require("../src/icons/regular/dice-two.svg");
const dice_svg_1 = require("../src/icons/regular/dice.svg");
const diploma_svg_1 = require("../src/icons/regular/diploma.svg");
const disc_drive_svg_1 = require("../src/icons/regular/disc-drive.svg");
const disease_svg_1 = require("../src/icons/regular/disease.svg");
const display_arrow_down_svg_1 = require("../src/icons/regular/display-arrow-down.svg");
const display_code_svg_1 = require("../src/icons/regular/display-code.svg");
const display_medical_svg_1 = require("../src/icons/regular/display-medical.svg");
const display_slash_svg_1 = require("../src/icons/regular/display-slash.svg");
const display_svg_1 = require("../src/icons/regular/display.svg");
const divide_svg_1 = require("../src/icons/regular/divide.svg");
const dna_svg_1 = require("../src/icons/regular/dna.svg");
const do_not_enter_svg_1 = require("../src/icons/regular/do-not-enter.svg");
const dog_leashed_svg_1 = require("../src/icons/regular/dog-leashed.svg");
const dog_svg_1 = require("../src/icons/regular/dog.svg");
const dollar_sign_svg_1 = require("../src/icons/regular/dollar-sign.svg");
const dolly_empty_svg_1 = require("../src/icons/regular/dolly-empty.svg");
const dolly_svg_1 = require("../src/icons/regular/dolly.svg");
const dolphin_svg_1 = require("../src/icons/regular/dolphin.svg");
const dong_sign_svg_1 = require("../src/icons/regular/dong-sign.svg");
const door_closed_svg_1 = require("../src/icons/regular/door-closed.svg");
const door_open_svg_1 = require("../src/icons/regular/door-open.svg");
const dove_svg_1 = require("../src/icons/regular/dove.svg");
const down_from_line_svg_1 = require("../src/icons/regular/down-from-line.svg");
const down_left_and_up_right_to_center_svg_1 = require("../src/icons/regular/down-left-and-up-right-to-center.svg");
const down_left_svg_1 = require("../src/icons/regular/down-left.svg");
const down_long_svg_1 = require("../src/icons/regular/down-long.svg");
const down_right_svg_1 = require("../src/icons/regular/down-right.svg");
const down_to_line_svg_1 = require("../src/icons/regular/down-to-line.svg");
const down_svg_1 = require("../src/icons/regular/down.svg");
const download_svg_1 = require("../src/icons/regular/download.svg");
const dragon_svg_1 = require("../src/icons/regular/dragon.svg");
const draw_circle_svg_1 = require("../src/icons/regular/draw-circle.svg");
const draw_polygon_svg_1 = require("../src/icons/regular/draw-polygon.svg");
const draw_square_svg_1 = require("../src/icons/regular/draw-square.svg");
const dreidel_svg_1 = require("../src/icons/regular/dreidel.svg");
const drone_front_svg_1 = require("../src/icons/regular/drone-front.svg");
const drone_svg_1 = require("../src/icons/regular/drone.svg");
const droplet_degree_svg_1 = require("../src/icons/regular/droplet-degree.svg");
const droplet_percent_svg_1 = require("../src/icons/regular/droplet-percent.svg");
const droplet_slash_svg_1 = require("../src/icons/regular/droplet-slash.svg");
const droplet_svg_1 = require("../src/icons/regular/droplet.svg");
const drum_steelpan_svg_1 = require("../src/icons/regular/drum-steelpan.svg");
const drum_svg_1 = require("../src/icons/regular/drum.svg");
const drumstick_bite_svg_1 = require("../src/icons/regular/drumstick-bite.svg");
const drumstick_svg_1 = require("../src/icons/regular/drumstick.svg");
const dryer_heat_svg_1 = require("../src/icons/regular/dryer-heat.svg");
const dryer_svg_1 = require("../src/icons/regular/dryer.svg");
const duck_svg_1 = require("../src/icons/regular/duck.svg");
const dumbbell_svg_1 = require("../src/icons/regular/dumbbell.svg");
const dumpster_fire_svg_1 = require("../src/icons/regular/dumpster-fire.svg");
const dumpster_svg_1 = require("../src/icons/regular/dumpster.svg");
const dungeon_svg_1 = require("../src/icons/regular/dungeon.svg");
const e_svg_1 = require("../src/icons/regular/e.svg");
const ear_deaf_svg_1 = require("../src/icons/regular/ear-deaf.svg");
const ear_listen_svg_1 = require("../src/icons/regular/ear-listen.svg");
const ear_muffs_svg_1 = require("../src/icons/regular/ear-muffs.svg");
const ear_svg_1 = require("../src/icons/regular/ear.svg");
const earth_africa_svg_1 = require("../src/icons/regular/earth-africa.svg");
const earth_americas_svg_1 = require("../src/icons/regular/earth-americas.svg");
const earth_asia_svg_1 = require("../src/icons/regular/earth-asia.svg");
const earth_europa_svg_1 = require("../src/icons/regular/earth-europa.svg");
const eclipse_svg_1 = require("../src/icons/regular/eclipse.svg");
const egg_fried_svg_1 = require("../src/icons/regular/egg-fried.svg");
const egg_svg_1 = require("../src/icons/regular/egg.svg");
const eggplant_svg_1 = require("../src/icons/regular/eggplant.svg");
const eject_svg_1 = require("../src/icons/regular/eject.svg");
const elephant_svg_1 = require("../src/icons/regular/elephant.svg");
const elevator_svg_1 = require("../src/icons/regular/elevator.svg");
const ellipsis_stroke_vertical_svg_1 = require("../src/icons/regular/ellipsis-stroke-vertical.svg");
const ellipsis_stroke_svg_1 = require("../src/icons/regular/ellipsis-stroke.svg");
const ellipsis_vertical_svg_1 = require("../src/icons/regular/ellipsis-vertical.svg");
const ellipsis_svg_1 = require("../src/icons/regular/ellipsis.svg");
const empty_set_svg_1 = require("../src/icons/regular/empty-set.svg");
const engine_warning_svg_1 = require("../src/icons/regular/engine-warning.svg");
const engine_svg_1 = require("../src/icons/regular/engine.svg");
const envelope_dot_svg_1 = require("../src/icons/regular/envelope-dot.svg");
const envelope_open_dollar_svg_1 = require("../src/icons/regular/envelope-open-dollar.svg");
const envelope_open_text_svg_1 = require("../src/icons/regular/envelope-open-text.svg");
const envelope_open_svg_1 = require("../src/icons/regular/envelope-open.svg");
const envelope_svg_1 = require("../src/icons/regular/envelope.svg");
const envelopes_bulk_svg_1 = require("../src/icons/regular/envelopes-bulk.svg");
const envelopes_svg_1 = require("../src/icons/regular/envelopes.svg");
const equals_svg_1 = require("../src/icons/regular/equals.svg");
const eraser_svg_1 = require("../src/icons/regular/eraser.svg");
const escalator_svg_1 = require("../src/icons/regular/escalator.svg");
const ethernet_svg_1 = require("../src/icons/regular/ethernet.svg");
const euro_sign_svg_1 = require("../src/icons/regular/euro-sign.svg");
const exclamation_svg_1 = require("../src/icons/regular/exclamation.svg");
const expand_wide_svg_1 = require("../src/icons/regular/expand-wide.svg");
const expand_svg_1 = require("../src/icons/regular/expand.svg");
const eye_dropper_full_svg_1 = require("../src/icons/regular/eye-dropper-full.svg");
const eye_dropper_half_svg_1 = require("../src/icons/regular/eye-dropper-half.svg");
const eye_dropper_svg_1 = require("../src/icons/regular/eye-dropper.svg");
const eye_evil_svg_1 = require("../src/icons/regular/eye-evil.svg");
const eye_low_vision_svg_1 = require("../src/icons/regular/eye-low-vision.svg");
const eye_slash_svg_1 = require("../src/icons/regular/eye-slash.svg");
const eye_svg_1 = require("../src/icons/regular/eye.svg");
const f_svg_1 = require("../src/icons/regular/f.svg");
const face_angry_svg_1 = require("../src/icons/regular/face-angry.svg");
const face_dizzy_svg_1 = require("../src/icons/regular/face-dizzy.svg");
const face_flushed_svg_1 = require("../src/icons/regular/face-flushed.svg");
const face_frown_open_svg_1 = require("../src/icons/regular/face-frown-open.svg");
const face_frown_svg_1 = require("../src/icons/regular/face-frown.svg");
const face_grimace_svg_1 = require("../src/icons/regular/face-grimace.svg");
const face_grin_beam_sweat_svg_1 = require("../src/icons/regular/face-grin-beam-sweat.svg");
const face_grin_beam_svg_1 = require("../src/icons/regular/face-grin-beam.svg");
const face_grin_hearts_svg_1 = require("../src/icons/regular/face-grin-hearts.svg");
const face_grin_squint_tears_svg_1 = require("../src/icons/regular/face-grin-squint-tears.svg");
const face_grin_squint_svg_1 = require("../src/icons/regular/face-grin-squint.svg");
const face_grin_stars_svg_1 = require("../src/icons/regular/face-grin-stars.svg");
const face_grin_tears_svg_1 = require("../src/icons/regular/face-grin-tears.svg");
const face_grin_tongue_squint_svg_1 = require("../src/icons/regular/face-grin-tongue-squint.svg");
const face_grin_tongue_wink_svg_1 = require("../src/icons/regular/face-grin-tongue-wink.svg");
const face_grin_tongue_svg_1 = require("../src/icons/regular/face-grin-tongue.svg");
const face_grin_wide_svg_1 = require("../src/icons/regular/face-grin-wide.svg");
const face_grin_wink_svg_1 = require("../src/icons/regular/face-grin-wink.svg");
const face_grin_svg_1 = require("../src/icons/regular/face-grin.svg");
const face_kiss_beam_svg_1 = require("../src/icons/regular/face-kiss-beam.svg");
const face_kiss_wink_heart_svg_1 = require("../src/icons/regular/face-kiss-wink-heart.svg");
const face_kiss_svg_1 = require("../src/icons/regular/face-kiss.svg");
const face_laugh_beam_svg_1 = require("../src/icons/regular/face-laugh-beam.svg");
const face_laugh_squint_svg_1 = require("../src/icons/regular/face-laugh-squint.svg");
const face_laugh_wink_svg_1 = require("../src/icons/regular/face-laugh-wink.svg");
const face_laugh_svg_1 = require("../src/icons/regular/face-laugh.svg");
const face_meh_blank_svg_1 = require("../src/icons/regular/face-meh-blank.svg");
const face_meh_svg_1 = require("../src/icons/regular/face-meh.svg");
const face_rolling_eyes_svg_1 = require("../src/icons/regular/face-rolling-eyes.svg");
const face_sad_cry_svg_1 = require("../src/icons/regular/face-sad-cry.svg");
const face_sad_tear_svg_1 = require("../src/icons/regular/face-sad-tear.svg");
const face_smile_beam_svg_1 = require("../src/icons/regular/face-smile-beam.svg");
const face_smile_plus_svg_1 = require("../src/icons/regular/face-smile-plus.svg");
const face_smile_wink_svg_1 = require("../src/icons/regular/face-smile-wink.svg");
const face_smile_svg_1 = require("../src/icons/regular/face-smile.svg");
const face_surprise_svg_1 = require("../src/icons/regular/face-surprise.svg");
const face_tired_svg_1 = require("../src/icons/regular/face-tired.svg");
const fan_table_svg_1 = require("../src/icons/regular/fan-table.svg");
const fan_svg_1 = require("../src/icons/regular/fan.svg");
const farm_svg_1 = require("../src/icons/regular/farm.svg");
const faucet_drip_svg_1 = require("../src/icons/regular/faucet-drip.svg");
const faucet_svg_1 = require("../src/icons/regular/faucet.svg");
const fax_svg_1 = require("../src/icons/regular/fax.svg");
const feather_pointed_svg_1 = require("../src/icons/regular/feather-pointed.svg");
const feather_svg_1 = require("../src/icons/regular/feather.svg");
const fence_svg_1 = require("../src/icons/regular/fence.svg");
const field_hockey_stick_ball_svg_1 = require("../src/icons/regular/field-hockey-stick-ball.svg");
const file_arrow_down_svg_1 = require("../src/icons/regular/file-arrow-down.svg");
const file_arrow_up_svg_1 = require("../src/icons/regular/file-arrow-up.svg");
const file_audio_svg_1 = require("../src/icons/regular/file-audio.svg");
const file_binary_svg_1 = require("../src/icons/regular/file-binary.svg");
const file_certificate_svg_1 = require("../src/icons/regular/file-certificate.svg");
const file_chart_column_svg_1 = require("../src/icons/regular/file-chart-column.svg");
const file_chart_pie_svg_1 = require("../src/icons/regular/file-chart-pie.svg");
const file_check_svg_1 = require("../src/icons/regular/file-check.svg");
const file_code_svg_1 = require("../src/icons/regular/file-code.svg");
const file_contract_svg_1 = require("../src/icons/regular/file-contract.svg");
const file_csv_svg_1 = require("../src/icons/regular/file-csv.svg");
const file_dashed_line_svg_1 = require("../src/icons/regular/file-dashed-line.svg");
const file_excel_svg_1 = require("../src/icons/regular/file-excel.svg");
const file_exclamation_svg_1 = require("../src/icons/regular/file-exclamation.svg");
const file_export_svg_1 = require("../src/icons/regular/file-export.svg");
const file_heart_svg_1 = require("../src/icons/regular/file-heart.svg");
const file_image_svg_1 = require("../src/icons/regular/file-image.svg");
const file_import_svg_1 = require("../src/icons/regular/file-import.svg");
const file_invoice_dollar_svg_1 = require("../src/icons/regular/file-invoice-dollar.svg");
const file_invoice_svg_1 = require("../src/icons/regular/file-invoice.svg");
const file_lines_svg_1 = require("../src/icons/regular/file-lines.svg");
const file_magnifying_glass_svg_1 = require("../src/icons/regular/file-magnifying-glass.svg");
const file_medical_svg_1 = require("../src/icons/regular/file-medical.svg");
const file_minus_svg_1 = require("../src/icons/regular/file-minus.svg");
const file_music_svg_1 = require("../src/icons/regular/file-music.svg");
const file_pdf_svg_1 = require("../src/icons/regular/file-pdf.svg");
const file_pen_svg_1 = require("../src/icons/regular/file-pen.svg");
const file_plus_minus_svg_1 = require("../src/icons/regular/file-plus-minus.svg");
const file_plus_svg_1 = require("../src/icons/regular/file-plus.svg");
const file_powerpoint_svg_1 = require("../src/icons/regular/file-powerpoint.svg");
const file_prescription_svg_1 = require("../src/icons/regular/file-prescription.svg");
const file_signature_svg_1 = require("../src/icons/regular/file-signature.svg");
const file_spreadsheet_svg_1 = require("../src/icons/regular/file-spreadsheet.svg");
const file_user_svg_1 = require("../src/icons/regular/file-user.svg");
const file_video_svg_1 = require("../src/icons/regular/file-video.svg");
const file_waveform_svg_1 = require("../src/icons/regular/file-waveform.svg");
const file_word_svg_1 = require("../src/icons/regular/file-word.svg");
const file_xmark_svg_1 = require("../src/icons/regular/file-xmark.svg");
const file_zipper_svg_1 = require("../src/icons/regular/file-zipper.svg");
const file_svg_1 = require("../src/icons/regular/file.svg");
const files_medical_svg_1 = require("../src/icons/regular/files-medical.svg");
const files_svg_1 = require("../src/icons/regular/files.svg");
const fill_drip_svg_1 = require("../src/icons/regular/fill-drip.svg");
const fill_svg_1 = require("../src/icons/regular/fill.svg");
const film_canister_svg_1 = require("../src/icons/regular/film-canister.svg");
const film_simple_svg_1 = require("../src/icons/regular/film-simple.svg");
const film_slash_svg_1 = require("../src/icons/regular/film-slash.svg");
const film_svg_1 = require("../src/icons/regular/film.svg");
const films_svg_1 = require("../src/icons/regular/films.svg");
const filter_circle_dollar_svg_1 = require("../src/icons/regular/filter-circle-dollar.svg");
const filter_circle_xmark_svg_1 = require("../src/icons/regular/filter-circle-xmark.svg");
const filter_list_svg_1 = require("../src/icons/regular/filter-list.svg");
const filter_slash_svg_1 = require("../src/icons/regular/filter-slash.svg");
const filter_svg_1 = require("../src/icons/regular/filter.svg");
const filters_svg_1 = require("../src/icons/regular/filters.svg");
const fingerprint_svg_1 = require("../src/icons/regular/fingerprint.svg");
const fire_extinguisher_svg_1 = require("../src/icons/regular/fire-extinguisher.svg");
const fire_flame_curved_svg_1 = require("../src/icons/regular/fire-flame-curved.svg");
const fire_flame_simple_svg_1 = require("../src/icons/regular/fire-flame-simple.svg");
const fire_flame_svg_1 = require("../src/icons/regular/fire-flame.svg");
const fire_hydrant_svg_1 = require("../src/icons/regular/fire-hydrant.svg");
const fire_smoke_svg_1 = require("../src/icons/regular/fire-smoke.svg");
const fire_svg_1 = require("../src/icons/regular/fire.svg");
const fireplace_svg_1 = require("../src/icons/regular/fireplace.svg");
const fish_cooked_svg_1 = require("../src/icons/regular/fish-cooked.svg");
const fish_svg_1 = require("../src/icons/regular/fish.svg");
const flag_checkered_svg_1 = require("../src/icons/regular/flag-checkered.svg");
const flag_pennant_svg_1 = require("../src/icons/regular/flag-pennant.svg");
const flag_swallowtail_svg_1 = require("../src/icons/regular/flag-swallowtail.svg");
const flag_usa_svg_1 = require("../src/icons/regular/flag-usa.svg");
const flag_svg_1 = require("../src/icons/regular/flag.svg");
const flashlight_svg_1 = require("../src/icons/regular/flashlight.svg");
const flask_round_poison_svg_1 = require("../src/icons/regular/flask-round-poison.svg");
const flask_round_potion_svg_1 = require("../src/icons/regular/flask-round-potion.svg");
const flask_svg_1 = require("../src/icons/regular/flask.svg");
const floppy_disk_circle_arrow_right_svg_1 = require("../src/icons/regular/floppy-disk-circle-arrow-right.svg");
const floppy_disk_circle_xmark_svg_1 = require("../src/icons/regular/floppy-disk-circle-xmark.svg");
const floppy_disk_pen_svg_1 = require("../src/icons/regular/floppy-disk-pen.svg");
const floppy_disk_svg_1 = require("../src/icons/regular/floppy-disk.svg");
const floppy_disks_svg_1 = require("../src/icons/regular/floppy-disks.svg");
const florin_sign_svg_1 = require("../src/icons/regular/florin-sign.svg");
const flower_daffodil_svg_1 = require("../src/icons/regular/flower-daffodil.svg");
const flower_tulip_svg_1 = require("../src/icons/regular/flower-tulip.svg");
const flower_svg_1 = require("../src/icons/regular/flower.svg");
const flute_svg_1 = require("../src/icons/regular/flute.svg");
const flux_capacitor_svg_1 = require("../src/icons/regular/flux-capacitor.svg");
const folder_arrow_down_svg_1 = require("../src/icons/regular/folder-arrow-down.svg");
const folder_arrow_up_svg_1 = require("../src/icons/regular/folder-arrow-up.svg");
const folder_blank_svg_1 = require("../src/icons/regular/folder-blank.svg");
const folder_bookmark_svg_1 = require("../src/icons/regular/folder-bookmark.svg");
const folder_gear_svg_1 = require("../src/icons/regular/folder-gear.svg");
const folder_grid_svg_1 = require("../src/icons/regular/folder-grid.svg");
const folder_heart_svg_1 = require("../src/icons/regular/folder-heart.svg");
const folder_image_svg_1 = require("../src/icons/regular/folder-image.svg");
const folder_magnifying_glass_svg_1 = require("../src/icons/regular/folder-magnifying-glass.svg");
const folder_medical_svg_1 = require("../src/icons/regular/folder-medical.svg");
const folder_minus_svg_1 = require("../src/icons/regular/folder-minus.svg");
const folder_music_svg_1 = require("../src/icons/regular/folder-music.svg");
const folder_open_svg_1 = require("../src/icons/regular/folder-open.svg");
const folder_plus_svg_1 = require("../src/icons/regular/folder-plus.svg");
const folder_tree_svg_1 = require("../src/icons/regular/folder-tree.svg");
const folder_user_svg_1 = require("../src/icons/regular/folder-user.svg");
const folder_xmark_svg_1 = require("../src/icons/regular/folder-xmark.svg");
const folder_svg_1 = require("../src/icons/regular/folder.svg");
const folders_svg_1 = require("../src/icons/regular/folders.svg");
const font_awesome_svg_2 = require("../src/icons/regular/font-awesome.svg");
const font_case_svg_1 = require("../src/icons/regular/font-case.svg");
const font_svg_1 = require("../src/icons/regular/font.svg");
const football_ball_svg_1 = require("../src/icons/regular/football-ball.svg");
const football_helmet_svg_1 = require("../src/icons/regular/football-helmet.svg");
const fork_knife_svg_1 = require("../src/icons/regular/fork-knife.svg");
const fork_svg_1 = require("../src/icons/regular/fork.svg");
const forklift_svg_1 = require("../src/icons/regular/forklift.svg");
const forward_fast_svg_1 = require("../src/icons/regular/forward-fast.svg");
const forward_step_svg_1 = require("../src/icons/regular/forward-step.svg");
const forward_svg_1 = require("../src/icons/regular/forward.svg");
const franc_sign_svg_1 = require("../src/icons/regular/franc-sign.svg");
const french_fries_svg_1 = require("../src/icons/regular/french-fries.svg");
const frog_svg_1 = require("../src/icons/regular/frog.svg");
const function_svg_1 = require("../src/icons/regular/function.svg");
const futbol_ball_svg_1 = require("../src/icons/regular/futbol-ball.svg");
const g_svg_1 = require("../src/icons/regular/g.svg");
const galaxy_svg_1 = require("../src/icons/regular/galaxy.svg");
const game_board_simple_svg_1 = require("../src/icons/regular/game-board-simple.svg");
const game_board_svg_1 = require("../src/icons/regular/game-board.svg");
const game_console_handheld_svg_1 = require("../src/icons/regular/game-console-handheld.svg");
const gamepad_modern_svg_1 = require("../src/icons/regular/gamepad-modern.svg");
const gamepad_svg_1 = require("../src/icons/regular/gamepad.svg");
const garage_car_svg_1 = require("../src/icons/regular/garage-car.svg");
const garage_open_svg_1 = require("../src/icons/regular/garage-open.svg");
const garage_svg_1 = require("../src/icons/regular/garage.svg");
const gas_pump_slash_svg_1 = require("../src/icons/regular/gas-pump-slash.svg");
const gas_pump_svg_1 = require("../src/icons/regular/gas-pump.svg");
const gauge_low_svg_1 = require("../src/icons/regular/gauge-low.svg");
const gauge_max_svg_1 = require("../src/icons/regular/gauge-max.svg");
const gauge_med_svg_1 = require("../src/icons/regular/gauge-med.svg");
const gauge_min_svg_1 = require("../src/icons/regular/gauge-min.svg");
const gauge_simple_low_svg_1 = require("../src/icons/regular/gauge-simple-low.svg");
const gauge_simple_max_svg_1 = require("../src/icons/regular/gauge-simple-max.svg");
const gauge_simple_med_svg_1 = require("../src/icons/regular/gauge-simple-med.svg");
const gauge_simple_min_svg_1 = require("../src/icons/regular/gauge-simple-min.svg");
const gauge_simple_svg_1 = require("../src/icons/regular/gauge-simple.svg");
const gauge_svg_1 = require("../src/icons/regular/gauge.svg");
const gavel_svg_1 = require("../src/icons/regular/gavel.svg");
const gear_svg_1 = require("../src/icons/regular/gear.svg");
const gears_svg_1 = require("../src/icons/regular/gears.svg");
const gem_svg_1 = require("../src/icons/regular/gem.svg");
const genderless_svg_1 = require("../src/icons/regular/genderless.svg");
const ghost_svg_1 = require("../src/icons/regular/ghost.svg");
const gif_svg_1 = require("../src/icons/regular/gif.svg");
const gift_card_svg_1 = require("../src/icons/regular/gift-card.svg");
const gift_svg_1 = require("../src/icons/regular/gift.svg");
const gifts_svg_1 = require("../src/icons/regular/gifts.svg");
const gingerbread_man_svg_1 = require("../src/icons/regular/gingerbread-man.svg");
const glass_citrus_svg_1 = require("../src/icons/regular/glass-citrus.svg");
const glass_empty_svg_1 = require("../src/icons/regular/glass-empty.svg");
const glass_half_svg_1 = require("../src/icons/regular/glass-half.svg");
const glass_svg_1 = require("../src/icons/regular/glass.svg");
const glasses_round_svg_1 = require("../src/icons/regular/glasses-round.svg");
const glasses_svg_1 = require("../src/icons/regular/glasses.svg");
const globe_snow_svg_1 = require("../src/icons/regular/globe-snow.svg");
const globe_stand_svg_1 = require("../src/icons/regular/globe-stand.svg");
const globe_svg_1 = require("../src/icons/regular/globe.svg");
const golf_ball_tee_svg_1 = require("../src/icons/regular/golf-ball-tee.svg");
const golf_club_svg_1 = require("../src/icons/regular/golf-club.svg");
const gopuram_svg_1 = require("../src/icons/regular/gopuram.svg");
const graduation_cap_svg_1 = require("../src/icons/regular/graduation-cap.svg");
const gramophone_svg_1 = require("../src/icons/regular/gramophone.svg");
const grate_droplet_svg_1 = require("../src/icons/regular/grate-droplet.svg");
const grate_svg_1 = require("../src/icons/regular/grate.svg");
const greater_than_equal_svg_1 = require("../src/icons/regular/greater-than-equal.svg");
const greater_than_svg_1 = require("../src/icons/regular/greater-than.svg");
const grid_2_plus_svg_1 = require("../src/icons/regular/grid-2-plus.svg");
const grid_2_svg_1 = require("../src/icons/regular/grid-2.svg");
const grid_4_svg_1 = require("../src/icons/regular/grid-4.svg");
const grid_5_svg_1 = require("../src/icons/regular/grid-5.svg");
const grid_svg_1 = require("../src/icons/regular/grid.svg");
const grip_lines_vertical_svg_1 = require("../src/icons/regular/grip-lines-vertical.svg");
const grip_lines_svg_1 = require("../src/icons/regular/grip-lines.svg");
const grip_vertical_svg_1 = require("../src/icons/regular/grip-vertical.svg");
const grip_svg_1 = require("../src/icons/regular/grip.svg");
const guarani_sign_svg_1 = require("../src/icons/regular/guarani-sign.svg");
const guitar_electric_svg_1 = require("../src/icons/regular/guitar-electric.svg");
const guitar_svg_1 = require("../src/icons/regular/guitar.svg");
const guitars_svg_1 = require("../src/icons/regular/guitars.svg");
const gun_slash_svg_1 = require("../src/icons/regular/gun-slash.svg");
const gun_squirt_svg_1 = require("../src/icons/regular/gun-squirt.svg");
const gun_svg_1 = require("../src/icons/regular/gun.svg");
const h_svg_1 = require("../src/icons/regular/h.svg");
const h1_svg_1 = require("../src/icons/regular/h1.svg");
const h2_svg_1 = require("../src/icons/regular/h2.svg");
const h3_svg_1 = require("../src/icons/regular/h3.svg");
const h4_svg_1 = require("../src/icons/regular/h4.svg");
const hammer_war_svg_1 = require("../src/icons/regular/hammer-war.svg");
const hammer_svg_1 = require("../src/icons/regular/hammer.svg");
const hamsa_svg_1 = require("../src/icons/regular/hamsa.svg");
const hand_back_point_down_svg_1 = require("../src/icons/regular/hand-back-point-down.svg");
const hand_back_point_left_svg_1 = require("../src/icons/regular/hand-back-point-left.svg");
const hand_back_point_right_svg_1 = require("../src/icons/regular/hand-back-point-right.svg");
const hand_back_point_up_svg_1 = require("../src/icons/regular/hand-back-point-up.svg");
const hand_dots_svg_1 = require("../src/icons/regular/hand-dots.svg");
const hand_fingers_crossed_svg_1 = require("../src/icons/regular/hand-fingers-crossed.svg");
const hand_fist_svg_1 = require("../src/icons/regular/hand-fist.svg");
const hand_heart_svg_1 = require("../src/icons/regular/hand-heart.svg");
const hand_holding_box_svg_1 = require("../src/icons/regular/hand-holding-box.svg");
const hand_holding_dollar_svg_1 = require("../src/icons/regular/hand-holding-dollar.svg");
const hand_holding_droplet_svg_1 = require("../src/icons/regular/hand-holding-droplet.svg");
const hand_holding_heart_svg_1 = require("../src/icons/regular/hand-holding-heart.svg");
const hand_holding_magic_svg_1 = require("../src/icons/regular/hand-holding-magic.svg");
const hand_holding_medical_svg_1 = require("../src/icons/regular/hand-holding-medical.svg");
const hand_holding_seedling_svg_1 = require("../src/icons/regular/hand-holding-seedling.svg");
const hand_holding_skull_svg_1 = require("../src/icons/regular/hand-holding-skull.svg");
const hand_holding_svg_1 = require("../src/icons/regular/hand-holding.svg");
const hand_lizard_svg_1 = require("../src/icons/regular/hand-lizard.svg");
const hand_love_svg_1 = require("../src/icons/regular/hand-love.svg");
const hand_middle_finger_svg_1 = require("../src/icons/regular/hand-middle-finger.svg");
const hand_paper_svg_1 = require("../src/icons/regular/hand-paper.svg");
const hand_peace_svg_1 = require("../src/icons/regular/hand-peace.svg");
const hand_point_down_svg_1 = require("../src/icons/regular/hand-point-down.svg");
const hand_point_left_svg_1 = require("../src/icons/regular/hand-point-left.svg");
const hand_point_right_svg_1 = require("../src/icons/regular/hand-point-right.svg");
const hand_point_up_svg_1 = require("../src/icons/regular/hand-point-up.svg");
const hand_pointer_svg_1 = require("../src/icons/regular/hand-pointer.svg");
const hand_rock_svg_1 = require("../src/icons/regular/hand-rock.svg");
const hand_scissors_svg_1 = require("../src/icons/regular/hand-scissors.svg");
const hand_sparkles_svg_1 = require("../src/icons/regular/hand-sparkles.svg");
const hand_spock_svg_1 = require("../src/icons/regular/hand-spock.svg");
const hand_wave_svg_1 = require("../src/icons/regular/hand-wave.svg");
const hands_asl_interpreting_svg_1 = require("../src/icons/regular/hands-asl-interpreting.svg");
const hands_bubbles_svg_1 = require("../src/icons/regular/hands-bubbles.svg");
const hands_clapping_svg_1 = require("../src/icons/regular/hands-clapping.svg");
const hands_holding_diamond_svg_1 = require("../src/icons/regular/hands-holding-diamond.svg");
const hands_holding_dollar_svg_1 = require("../src/icons/regular/hands-holding-dollar.svg");
const hands_holding_heart_svg_1 = require("../src/icons/regular/hands-holding-heart.svg");
const hands_holding_svg_1 = require("../src/icons/regular/hands-holding.svg");
const hands_horns_svg_1 = require("../src/icons/regular/hands-horns.svg");
const hands_praying_svg_1 = require("../src/icons/regular/hands-praying.svg");
const hands_svg_1 = require("../src/icons/regular/hands.svg");
const handshake_angle_svg_1 = require("../src/icons/regular/handshake-angle.svg");
const handshake_simple_slash_svg_1 = require("../src/icons/regular/handshake-simple-slash.svg");
const handshake_simple_svg_1 = require("../src/icons/regular/handshake-simple.svg");
const handshake_slash_svg_1 = require("../src/icons/regular/handshake-slash.svg");
const handshake_svg_1 = require("../src/icons/regular/handshake.svg");
const hanukiah_svg_1 = require("../src/icons/regular/hanukiah.svg");
const hard_drive_svg_1 = require("../src/icons/regular/hard-drive.svg");
const hashtag_svg_1 = require("../src/icons/regular/hashtag.svg");
const hat_chef_svg_1 = require("../src/icons/regular/hat-chef.svg");
const hat_cowboy_side_svg_1 = require("../src/icons/regular/hat-cowboy-side.svg");
const hat_cowboy_svg_1 = require("../src/icons/regular/hat-cowboy.svg");
const hat_santa_svg_1 = require("../src/icons/regular/hat-santa.svg");
const hat_winter_svg_1 = require("../src/icons/regular/hat-winter.svg");
const hat_witch_svg_1 = require("../src/icons/regular/hat-witch.svg");
const hat_wizard_svg_1 = require("../src/icons/regular/hat-wizard.svg");
const head_side_brain_svg_1 = require("../src/icons/regular/head-side-brain.svg");
const head_side_cough_slash_svg_1 = require("../src/icons/regular/head-side-cough-slash.svg");
const head_side_cough_svg_1 = require("../src/icons/regular/head-side-cough.svg");
const head_side_goggles_svg_1 = require("../src/icons/regular/head-side-goggles.svg");
const head_side_headphones_svg_1 = require("../src/icons/regular/head-side-headphones.svg");
const head_side_heart_svg_1 = require("../src/icons/regular/head-side-heart.svg");
const head_side_mask_svg_1 = require("../src/icons/regular/head-side-mask.svg");
const head_side_medical_svg_1 = require("../src/icons/regular/head-side-medical.svg");
const head_side_virus_svg_1 = require("../src/icons/regular/head-side-virus.svg");
const head_side_svg_1 = require("../src/icons/regular/head-side.svg");
const heading_svg_1 = require("../src/icons/regular/heading.svg");
const headphones_simple_svg_1 = require("../src/icons/regular/headphones-simple.svg");
const headphones_svg_1 = require("../src/icons/regular/headphones.svg");
const headset_svg_1 = require("../src/icons/regular/headset.svg");
const heart_crack_svg_1 = require("../src/icons/regular/heart-crack.svg");
const heart_half_stroke_svg_1 = require("../src/icons/regular/heart-half-stroke.svg");
const heart_half_svg_1 = require("../src/icons/regular/heart-half.svg");
const heart_pulse_svg_1 = require("../src/icons/regular/heart-pulse.svg");
const heart_svg_1 = require("../src/icons/regular/heart.svg");
const heat_svg_1 = require("../src/icons/regular/heat.svg");
const helicopter_svg_1 = require("../src/icons/regular/helicopter.svg");
const helmet_battle_svg_1 = require("../src/icons/regular/helmet-battle.svg");
const helmet_safety_svg_1 = require("../src/icons/regular/helmet-safety.svg");
const hexagon_divide_svg_1 = require("../src/icons/regular/hexagon-divide.svg");
const hexagon_minus_svg_1 = require("../src/icons/regular/hexagon-minus.svg");
const hexagon_plus_svg_1 = require("../src/icons/regular/hexagon-plus.svg");
const hexagon_xmark_svg_1 = require("../src/icons/regular/hexagon-xmark.svg");
const hexagon_svg_1 = require("../src/icons/regular/hexagon.svg");
const high_definition_svg_1 = require("../src/icons/regular/high-definition.svg");
const highlighter_line_svg_1 = require("../src/icons/regular/highlighter-line.svg");
const highlighter_svg_1 = require("../src/icons/regular/highlighter.svg");
const hippo_svg_1 = require("../src/icons/regular/hippo.svg");
const hockey_mask_svg_1 = require("../src/icons/regular/hockey-mask.svg");
const hockey_puck_svg_1 = require("../src/icons/regular/hockey-puck.svg");
const hockey_sticks_svg_1 = require("../src/icons/regular/hockey-sticks.svg");
const holly_berry_svg_1 = require("../src/icons/regular/holly-berry.svg");
const home_heart_svg_1 = require("../src/icons/regular/home-heart.svg");
const home_simple_svg_1 = require("../src/icons/regular/home-simple.svg");
const home_user_svg_1 = require("../src/icons/regular/home-user.svg");
const home_svg_1 = require("../src/icons/regular/home.svg");
const hood_cloak_svg_1 = require("../src/icons/regular/hood-cloak.svg");
const horizontal_rule_svg_1 = require("../src/icons/regular/horizontal-rule.svg");
const horse_head_svg_1 = require("../src/icons/regular/horse-head.svg");
const horse_saddle_svg_1 = require("../src/icons/regular/horse-saddle.svg");
const horse_svg_1 = require("../src/icons/regular/horse.svg");
const hospital_user_svg_1 = require("../src/icons/regular/hospital-user.svg");
const hospital_wide_svg_1 = require("../src/icons/regular/hospital-wide.svg");
const hospital_svg_1 = require("../src/icons/regular/hospital.svg");
const hospitals_svg_1 = require("../src/icons/regular/hospitals.svg");
const hot_tub_person_svg_1 = require("../src/icons/regular/hot-tub-person.svg");
const hotdog_svg_1 = require("../src/icons/regular/hotdog.svg");
const hotel_svg_1 = require("../src/icons/regular/hotel.svg");
const hourglass_empty_svg_1 = require("../src/icons/regular/hourglass-empty.svg");
const hourglass_end_svg_1 = require("../src/icons/regular/hourglass-end.svg");
const hourglass_start_svg_1 = require("../src/icons/regular/hourglass-start.svg");
const hourglass_svg_1 = require("../src/icons/regular/hourglass.svg");
const house_building_svg_1 = require("../src/icons/regular/house-building.svg");
const house_crack_svg_1 = require("../src/icons/regular/house-crack.svg");
const house_day_svg_1 = require("../src/icons/regular/house-day.svg");
const house_flood_svg_1 = require("../src/icons/regular/house-flood.svg");
const house_heart_svg_1 = require("../src/icons/regular/house-heart.svg");
const house_laptop_svg_1 = require("../src/icons/regular/house-laptop.svg");
const house_medical_svg_1 = require("../src/icons/regular/house-medical.svg");
const house_night_svg_1 = require("../src/icons/regular/house-night.svg");
const house_person_leave_svg_1 = require("../src/icons/regular/house-person-leave.svg");
const house_person_return_svg_1 = require("../src/icons/regular/house-person-return.svg");
const house_signal_svg_1 = require("../src/icons/regular/house-signal.svg");
const house_tree_svg_1 = require("../src/icons/regular/house-tree.svg");
const house_turret_svg_1 = require("../src/icons/regular/house-turret.svg");
const house_user_svg_1 = require("../src/icons/regular/house-user.svg");
const house_svg_1 = require("../src/icons/regular/house.svg");
const hryvnia_sign_svg_1 = require("../src/icons/regular/hryvnia-sign.svg");
const hurricane_svg_1 = require("../src/icons/regular/hurricane.svg");
const i_cursor_svg_1 = require("../src/icons/regular/i-cursor.svg");
const i_svg_1 = require("../src/icons/regular/i.svg");
const ice_cream_svg_1 = require("../src/icons/regular/ice-cream.svg");
const ice_skate_svg_1 = require("../src/icons/regular/ice-skate.svg");
const icicles_svg_1 = require("../src/icons/regular/icicles.svg");
const icons_svg_1 = require("../src/icons/regular/icons.svg");
const id_badge_svg_1 = require("../src/icons/regular/id-badge.svg");
const id_card_clip_svg_1 = require("../src/icons/regular/id-card-clip.svg");
const id_card_svg_1 = require("../src/icons/regular/id-card.svg");
const igloo_svg_1 = require("../src/icons/regular/igloo.svg");
const image_landscape_svg_1 = require("../src/icons/regular/image-landscape.svg");
const image_polaroid_user_svg_1 = require("../src/icons/regular/image-polaroid-user.svg");
const image_polaroid_svg_1 = require("../src/icons/regular/image-polaroid.svg");
const image_portrait_svg_1 = require("../src/icons/regular/image-portrait.svg");
const image_slash_svg_1 = require("../src/icons/regular/image-slash.svg");
const image_user_svg_1 = require("../src/icons/regular/image-user.svg");
const image_svg_1 = require("../src/icons/regular/image.svg");
const images_user_svg_1 = require("../src/icons/regular/images-user.svg");
const images_svg_1 = require("../src/icons/regular/images.svg");
const inbox_full_svg_1 = require("../src/icons/regular/inbox-full.svg");
const inbox_in_svg_1 = require("../src/icons/regular/inbox-in.svg");
const inbox_out_svg_1 = require("../src/icons/regular/inbox-out.svg");
const inbox_svg_1 = require("../src/icons/regular/inbox.svg");
const inboxes_svg_1 = require("../src/icons/regular/inboxes.svg");
const indent_svg_1 = require("../src/icons/regular/indent.svg");
const indian_rupee_sign_svg_1 = require("../src/icons/regular/indian-rupee-sign.svg");
const industry_windows_svg_1 = require("../src/icons/regular/industry-windows.svg");
const industry_svg_1 = require("../src/icons/regular/industry.svg");
const infinity_svg_1 = require("../src/icons/regular/infinity.svg");
const info_svg_1 = require("../src/icons/regular/info.svg");
const inhaler_svg_1 = require("../src/icons/regular/inhaler.svg");
const input_numeric_svg_1 = require("../src/icons/regular/input-numeric.svg");
const input_pipe_svg_1 = require("../src/icons/regular/input-pipe.svg");
const input_text_svg_1 = require("../src/icons/regular/input-text.svg");
const integral_svg_1 = require("../src/icons/regular/integral.svg");
const intersection_svg_1 = require("../src/icons/regular/intersection.svg");
const island_tropical_svg_1 = require("../src/icons/regular/island-tropical.svg");
const italic_svg_1 = require("../src/icons/regular/italic.svg");
const j_svg_1 = require("../src/icons/regular/j.svg");
const jack_o_lantern_svg_1 = require("../src/icons/regular/jack-o-lantern.svg");
const jedi_svg_1 = require("../src/icons/regular/jedi.svg");
const jet_fighter_svg_1 = require("../src/icons/regular/jet-fighter.svg");
const joint_svg_1 = require("../src/icons/regular/joint.svg");
const joystick_svg_1 = require("../src/icons/regular/joystick.svg");
const jug_svg_1 = require("../src/icons/regular/jug.svg");
const k_svg_1 = require("../src/icons/regular/k.svg");
const kaaba_svg_1 = require("../src/icons/regular/kaaba.svg");
const kazoo_svg_1 = require("../src/icons/regular/kazoo.svg");
const kerning_svg_1 = require("../src/icons/regular/kerning.svg");
const key_skeleton_svg_1 = require("../src/icons/regular/key-skeleton.svg");
const key_svg_1 = require("../src/icons/regular/key.svg");
const keyboard_down_svg_1 = require("../src/icons/regular/keyboard-down.svg");
const keyboard_left_svg_1 = require("../src/icons/regular/keyboard-left.svg");
const keyboard_svg_1 = require("../src/icons/regular/keyboard.svg");
const keynote_svg_1 = require("../src/icons/regular/keynote.svg");
const khanda_svg_1 = require("../src/icons/regular/khanda.svg");
const kidneys_svg_1 = require("../src/icons/regular/kidneys.svg");
const kip_sign_svg_1 = require("../src/icons/regular/kip-sign.svg");
const kit_medical_svg_1 = require("../src/icons/regular/kit-medical.svg");
const kite_svg_1 = require("../src/icons/regular/kite.svg");
const kiwi_bird_svg_1 = require("../src/icons/regular/kiwi-bird.svg");
const knife_kitchen_svg_1 = require("../src/icons/regular/knife-kitchen.svg");
const knife_svg_1 = require("../src/icons/regular/knife.svg");
const l_svg_1 = require("../src/icons/regular/l.svg");
const lambda_svg_1 = require("../src/icons/regular/lambda.svg");
const lamp_desk_svg_1 = require("../src/icons/regular/lamp-desk.svg");
const lamp_floor_svg_1 = require("../src/icons/regular/lamp-floor.svg");
const lamp_street_svg_1 = require("../src/icons/regular/lamp-street.svg");
const lamp_svg_1 = require("../src/icons/regular/lamp.svg");
const landmark_dome_svg_1 = require("../src/icons/regular/landmark-dome.svg");
const landmark_svg_1 = require("../src/icons/regular/landmark.svg");
const language_svg_1 = require("../src/icons/regular/language.svg");
const laptop_arrow_down_svg_1 = require("../src/icons/regular/laptop-arrow-down.svg");
const laptop_code_svg_1 = require("../src/icons/regular/laptop-code.svg");
const laptop_medical_svg_1 = require("../src/icons/regular/laptop-medical.svg");
const laptop_mobile_svg_1 = require("../src/icons/regular/laptop-mobile.svg");
const laptop_slash_svg_1 = require("../src/icons/regular/laptop-slash.svg");
const laptop_svg_1 = require("../src/icons/regular/laptop.svg");
const lari_sign_svg_1 = require("../src/icons/regular/lari-sign.svg");
const lasso_sparkles_svg_1 = require("../src/icons/regular/lasso-sparkles.svg");
const lasso_svg_1 = require("../src/icons/regular/lasso.svg");
const layers_minus_svg_1 = require("../src/icons/regular/layers-minus.svg");
const layers_plus_svg_1 = require("../src/icons/regular/layers-plus.svg");
const layers_svg_1 = require("../src/icons/regular/layers.svg");
const leaf_heart_svg_1 = require("../src/icons/regular/leaf-heart.svg");
const leaf_maple_svg_1 = require("../src/icons/regular/leaf-maple.svg");
const leaf_oak_svg_1 = require("../src/icons/regular/leaf-oak.svg");
const leaf_svg_1 = require("../src/icons/regular/leaf.svg");
const left_from_line_svg_1 = require("../src/icons/regular/left-from-line.svg");
const left_long_svg_1 = require("../src/icons/regular/left-long.svg");
const left_right_svg_1 = require("../src/icons/regular/left-right.svg");
const left_to_line_svg_1 = require("../src/icons/regular/left-to-line.svg");
const left_svg_1 = require("../src/icons/regular/left.svg");
const lemon_svg_1 = require("../src/icons/regular/lemon.svg");
const less_than_equal_svg_1 = require("../src/icons/regular/less-than-equal.svg");
const less_than_svg_1 = require("../src/icons/regular/less-than.svg");
const life_ring_svg_1 = require("../src/icons/regular/life-ring.svg");
const light_ceiling_svg_1 = require("../src/icons/regular/light-ceiling.svg");
const light_switch_off_svg_1 = require("../src/icons/regular/light-switch-off.svg");
const light_switch_on_svg_1 = require("../src/icons/regular/light-switch-on.svg");
const light_switch_svg_1 = require("../src/icons/regular/light-switch.svg");
const lightbulb_dollar_svg_1 = require("../src/icons/regular/lightbulb-dollar.svg");
const lightbulb_exclamation_svg_1 = require("../src/icons/regular/lightbulb-exclamation.svg");
const lightbulb_on_svg_1 = require("../src/icons/regular/lightbulb-on.svg");
const lightbulb_slash_svg_1 = require("../src/icons/regular/lightbulb-slash.svg");
const lightbulb_svg_1 = require("../src/icons/regular/lightbulb.svg");
const lights_holiday_svg_1 = require("../src/icons/regular/lights-holiday.svg");
const line_columns_svg_1 = require("../src/icons/regular/line-columns.svg");
const line_height_svg_1 = require("../src/icons/regular/line-height.svg");
const link_horizontal_slash_svg_1 = require("../src/icons/regular/link-horizontal-slash.svg");
const link_horizontal_svg_1 = require("../src/icons/regular/link-horizontal.svg");
const link_simple_slash_svg_1 = require("../src/icons/regular/link-simple-slash.svg");
const link_simple_svg_1 = require("../src/icons/regular/link-simple.svg");
const link_slash_svg_1 = require("../src/icons/regular/link-slash.svg");
const link_svg_1 = require("../src/icons/regular/link.svg");
const lips_svg_1 = require("../src/icons/regular/lips.svg");
const lira_sign_svg_1 = require("../src/icons/regular/lira-sign.svg");
const list_check_svg_1 = require("../src/icons/regular/list-check.svg");
const list_dropdown_svg_1 = require("../src/icons/regular/list-dropdown.svg");
const list_music_svg_1 = require("../src/icons/regular/list-music.svg");
const list_ol_svg_1 = require("../src/icons/regular/list-ol.svg");
const list_radio_svg_1 = require("../src/icons/regular/list-radio.svg");
const list_timeline_svg_1 = require("../src/icons/regular/list-timeline.svg");
const list_tree_svg_1 = require("../src/icons/regular/list-tree.svg");
const list_ul_svg_1 = require("../src/icons/regular/list-ul.svg");
const list_svg_1 = require("../src/icons/regular/list.svg");
const litecoin_sign_svg_1 = require("../src/icons/regular/litecoin-sign.svg");
const loader_svg_1 = require("../src/icons/regular/loader.svg");
const location_arrow_svg_1 = require("../src/icons/regular/location-arrow.svg");
const location_check_svg_1 = require("../src/icons/regular/location-check.svg");
const location_crosshairs_slash_svg_1 = require("../src/icons/regular/location-crosshairs-slash.svg");
const location_crosshairs_svg_1 = require("../src/icons/regular/location-crosshairs.svg");
const location_dot_slash_svg_1 = require("../src/icons/regular/location-dot-slash.svg");
const location_dot_svg_1 = require("../src/icons/regular/location-dot.svg");
const location_exclamation_svg_1 = require("../src/icons/regular/location-exclamation.svg");
const location_minus_svg_1 = require("../src/icons/regular/location-minus.svg");
const location_pen_svg_1 = require("../src/icons/regular/location-pen.svg");
const location_plus_svg_1 = require("../src/icons/regular/location-plus.svg");
const location_question_svg_1 = require("../src/icons/regular/location-question.svg");
const location_slash_svg_1 = require("../src/icons/regular/location-slash.svg");
const location_smile_svg_1 = require("../src/icons/regular/location-smile.svg");
const location_xmark_svg_1 = require("../src/icons/regular/location-xmark.svg");
const location_svg_1 = require("../src/icons/regular/location.svg");
const lock_keyhole_open_svg_1 = require("../src/icons/regular/lock-keyhole-open.svg");
const lock_keyhole_svg_1 = require("../src/icons/regular/lock-keyhole.svg");
const lock_open_svg_1 = require("../src/icons/regular/lock-open.svg");
const lock_svg_1 = require("../src/icons/regular/lock.svg");
const loveseat_svg_1 = require("../src/icons/regular/loveseat.svg");
const luchador_mask_svg_1 = require("../src/icons/regular/luchador-mask.svg");
const lungs_virus_svg_1 = require("../src/icons/regular/lungs-virus.svg");
const lungs_svg_1 = require("../src/icons/regular/lungs.svg");
const m_svg_1 = require("../src/icons/regular/m.svg");
const mace_svg_1 = require("../src/icons/regular/mace.svg");
const magnet_svg_1 = require("../src/icons/regular/magnet.svg");
const magnifying_glass_dollar_svg_1 = require("../src/icons/regular/magnifying-glass-dollar.svg");
const magnifying_glass_location_svg_1 = require("../src/icons/regular/magnifying-glass-location.svg");
const magnifying_glass_minus_svg_1 = require("../src/icons/regular/magnifying-glass-minus.svg");
const magnifying_glass_plus_svg_1 = require("../src/icons/regular/magnifying-glass-plus.svg");
const magnifying_glass_svg_1 = require("../src/icons/regular/magnifying-glass.svg");
const mailbox_svg_1 = require("../src/icons/regular/mailbox.svg");
const manat_sign_svg_1 = require("../src/icons/regular/manat-sign.svg");
const mandolin_svg_1 = require("../src/icons/regular/mandolin.svg");
const manhole_svg_1 = require("../src/icons/regular/manhole.svg");
const map_location_dot_svg_1 = require("../src/icons/regular/map-location-dot.svg");
const map_location_svg_1 = require("../src/icons/regular/map-location.svg");
const map_pin_svg_1 = require("../src/icons/regular/map-pin.svg");
const map_svg_1 = require("../src/icons/regular/map.svg");
const marker_svg_1 = require("../src/icons/regular/marker.svg");
const mars_double_svg_1 = require("../src/icons/regular/mars-double.svg");
const mars_stroke_right_svg_1 = require("../src/icons/regular/mars-stroke-right.svg");
const mars_stroke_up_svg_1 = require("../src/icons/regular/mars-stroke-up.svg");
const mars_stroke_svg_1 = require("../src/icons/regular/mars-stroke.svg");
const mars_svg_1 = require("../src/icons/regular/mars.svg");
const martini_glass_citrus_svg_1 = require("../src/icons/regular/martini-glass-citrus.svg");
const martini_glass_empty_svg_1 = require("../src/icons/regular/martini-glass-empty.svg");
const martini_glass_svg_1 = require("../src/icons/regular/martini-glass.svg");
const mask_face_svg_1 = require("../src/icons/regular/mask-face.svg");
const mask_svg_1 = require("../src/icons/regular/mask.svg");
const masks_theater_svg_1 = require("../src/icons/regular/masks-theater.svg");
const maximize_svg_1 = require("../src/icons/regular/maximize.svg");
const meat_svg_1 = require("../src/icons/regular/meat.svg");
const medal_svg_1 = require("../src/icons/regular/medal.svg");
const megaphone_svg_1 = require("../src/icons/regular/megaphone.svg");
const memo_circle_check_svg_1 = require("../src/icons/regular/memo-circle-check.svg");
const memo_svg_1 = require("../src/icons/regular/memo.svg");
const memory_svg_1 = require("../src/icons/regular/memory.svg");
const menorah_svg_1 = require("../src/icons/regular/menorah.svg");
const mercury_svg_1 = require("../src/icons/regular/mercury.svg");
const message_arrow_down_svg_1 = require("../src/icons/regular/message-arrow-down.svg");
const message_arrow_up_right_svg_1 = require("../src/icons/regular/message-arrow-up-right.svg");
const message_arrow_up_svg_1 = require("../src/icons/regular/message-arrow-up.svg");
const message_captions_svg_1 = require("../src/icons/regular/message-captions.svg");
const message_check_svg_1 = require("../src/icons/regular/message-check.svg");
const message_code_svg_1 = require("../src/icons/regular/message-code.svg");
const message_dollar_svg_1 = require("../src/icons/regular/message-dollar.svg");
const message_dots_svg_1 = require("../src/icons/regular/message-dots.svg");
const message_exclamation_svg_1 = require("../src/icons/regular/message-exclamation.svg");
const message_image_svg_1 = require("../src/icons/regular/message-image.svg");
const message_lines_svg_1 = require("../src/icons/regular/message-lines.svg");
const message_medical_svg_1 = require("../src/icons/regular/message-medical.svg");
const message_middle_top_svg_1 = require("../src/icons/regular/message-middle-top.svg");
const message_middle_svg_1 = require("../src/icons/regular/message-middle.svg");
const message_minus_svg_1 = require("../src/icons/regular/message-minus.svg");
const message_music_svg_1 = require("../src/icons/regular/message-music.svg");
const message_pen_svg_1 = require("../src/icons/regular/message-pen.svg");
const message_plus_svg_1 = require("../src/icons/regular/message-plus.svg");
const message_question_svg_1 = require("../src/icons/regular/message-question.svg");
const message_quote_svg_1 = require("../src/icons/regular/message-quote.svg");
const message_slash_svg_1 = require("../src/icons/regular/message-slash.svg");
const message_smile_svg_1 = require("../src/icons/regular/message-smile.svg");
const message_sms_svg_1 = require("../src/icons/regular/message-sms.svg");
const message_text_svg_1 = require("../src/icons/regular/message-text.svg");
const message_xmark_svg_1 = require("../src/icons/regular/message-xmark.svg");
const message_svg_1 = require("../src/icons/regular/message.svg");
const messages_dollar_svg_1 = require("../src/icons/regular/messages-dollar.svg");
const messages_question_svg_1 = require("../src/icons/regular/messages-question.svg");
const messages_svg_1 = require("../src/icons/regular/messages.svg");
const meteor_svg_1 = require("../src/icons/regular/meteor.svg");
const meter_bolt_svg_1 = require("../src/icons/regular/meter-bolt.svg");
const meter_droplet_svg_1 = require("../src/icons/regular/meter-droplet.svg");
const meter_fire_svg_1 = require("../src/icons/regular/meter-fire.svg");
const meter_svg_1 = require("../src/icons/regular/meter.svg");
const microchip_ai_svg_1 = require("../src/icons/regular/microchip-ai.svg");
const microchip_svg_1 = require("../src/icons/regular/microchip.svg");
const microphone_lines_slash_svg_1 = require("../src/icons/regular/microphone-lines-slash.svg");
const microphone_lines_svg_1 = require("../src/icons/regular/microphone-lines.svg");
const microphone_slash_svg_1 = require("../src/icons/regular/microphone-slash.svg");
const microphone_stand_svg_1 = require("../src/icons/regular/microphone-stand.svg");
const microphone_svg_1 = require("../src/icons/regular/microphone.svg");
const microscope_svg_1 = require("../src/icons/regular/microscope.svg");
const microwave_svg_1 = require("../src/icons/regular/microwave.svg");
const mill_sign_svg_1 = require("../src/icons/regular/mill-sign.svg");
const minimize_svg_1 = require("../src/icons/regular/minimize.svg");
const minus_svg_1 = require("../src/icons/regular/minus.svg");
const mistletoe_svg_1 = require("../src/icons/regular/mistletoe.svg");
const mitten_svg_1 = require("../src/icons/regular/mitten.svg");
const mobile_button_svg_1 = require("../src/icons/regular/mobile-button.svg");
const mobile_notch_svg_1 = require("../src/icons/regular/mobile-notch.svg");
const mobile_screen_button_svg_1 = require("../src/icons/regular/mobile-screen-button.svg");
const mobile_screen_svg_1 = require("../src/icons/regular/mobile-screen.svg");
const mobile_svg_1 = require("../src/icons/regular/mobile.svg");
const money_bill_1_wave_svg_1 = require("../src/icons/regular/money-bill-1-wave.svg");
const money_bill_1_svg_1 = require("../src/icons/regular/money-bill-1.svg");
const money_bill_simple_wave_svg_1 = require("../src/icons/regular/money-bill-simple-wave.svg");
const money_bill_simple_svg_1 = require("../src/icons/regular/money-bill-simple.svg");
const money_bill_wave_svg_1 = require("../src/icons/regular/money-bill-wave.svg");
const money_bill_svg_1 = require("../src/icons/regular/money-bill.svg");
const money_bills_simple_svg_1 = require("../src/icons/regular/money-bills-simple.svg");
const money_bills_svg_1 = require("../src/icons/regular/money-bills.svg");
const money_check_dollar_pen_svg_1 = require("../src/icons/regular/money-check-dollar-pen.svg");
const money_check_dollar_svg_1 = require("../src/icons/regular/money-check-dollar.svg");
const money_check_pen_svg_1 = require("../src/icons/regular/money-check-pen.svg");
const money_check_svg_1 = require("../src/icons/regular/money-check.svg");
const monitor_waveform_svg_1 = require("../src/icons/regular/monitor-waveform.svg");
const monkey_svg_1 = require("../src/icons/regular/monkey.svg");
const monument_svg_1 = require("../src/icons/regular/monument.svg");
const moon_cloud_svg_1 = require("../src/icons/regular/moon-cloud.svg");
const moon_over_sun_svg_1 = require("../src/icons/regular/moon-over-sun.svg");
const moon_stars_svg_1 = require("../src/icons/regular/moon-stars.svg");
const moon_svg_1 = require("../src/icons/regular/moon.svg");
const mortar_pestle_svg_1 = require("../src/icons/regular/mortar-pestle.svg");
const mosque_svg_1 = require("../src/icons/regular/mosque.svg");
const motorcycle_svg_1 = require("../src/icons/regular/motorcycle.svg");
const mountain_svg_1 = require("../src/icons/regular/mountain.svg");
const mountains_svg_1 = require("../src/icons/regular/mountains.svg");
const mp3_player_svg_1 = require("../src/icons/regular/mp3-player.svg");
const mug_hot_svg_1 = require("../src/icons/regular/mug-hot.svg");
const mug_marshmallows_svg_1 = require("../src/icons/regular/mug-marshmallows.svg");
const mug_saucer_svg_1 = require("../src/icons/regular/mug-saucer.svg");
const mug_tea_saucer_svg_1 = require("../src/icons/regular/mug-tea-saucer.svg");
const mug_tea_svg_1 = require("../src/icons/regular/mug-tea.svg");
const mug_svg_1 = require("../src/icons/regular/mug.svg");
const music_note_slash_svg_1 = require("../src/icons/regular/music-note-slash.svg");
const music_note_svg_1 = require("../src/icons/regular/music-note.svg");
const music_slash_svg_1 = require("../src/icons/regular/music-slash.svg");
const music_svg_1 = require("../src/icons/regular/music.svg");
const n_svg_1 = require("../src/icons/regular/n.svg");
const naira_sign_svg_1 = require("../src/icons/regular/naira-sign.svg");
const narwhal_svg_1 = require("../src/icons/regular/narwhal.svg");
const network_wired_svg_1 = require("../src/icons/regular/network-wired.svg");
const neuter_svg_1 = require("../src/icons/regular/neuter.svg");
const newspaper_svg_1 = require("../src/icons/regular/newspaper.svg");
const not_equal_svg_1 = require("../src/icons/regular/not-equal.svg");
const notdef_svg_1 = require("../src/icons/regular/notdef.svg");
const note_medical_svg_1 = require("../src/icons/regular/note-medical.svg");
const note_sticky_svg_1 = require("../src/icons/regular/note-sticky.svg");
const note_svg_1 = require("../src/icons/regular/note.svg");
const notes_medical_svg_1 = require("../src/icons/regular/notes-medical.svg");
const notes_svg_1 = require("../src/icons/regular/notes.svg");
const o_svg_1 = require("../src/icons/regular/o.svg");
const object_group_svg_1 = require("../src/icons/regular/object-group.svg");
const object_ungroup_svg_1 = require("../src/icons/regular/object-ungroup.svg");
const octagon_divide_svg_1 = require("../src/icons/regular/octagon-divide.svg");
const octagon_exclamation_svg_1 = require("../src/icons/regular/octagon-exclamation.svg");
const octagon_minus_svg_1 = require("../src/icons/regular/octagon-minus.svg");
const octagon_plus_svg_1 = require("../src/icons/regular/octagon-plus.svg");
const octagon_xmark_svg_1 = require("../src/icons/regular/octagon-xmark.svg");
const octagon_svg_1 = require("../src/icons/regular/octagon.svg");
const oil_can_drip_svg_1 = require("../src/icons/regular/oil-can-drip.svg");
const oil_can_svg_1 = require("../src/icons/regular/oil-can.svg");
const oil_temperature_svg_1 = require("../src/icons/regular/oil-temperature.svg");
const om_svg_1 = require("../src/icons/regular/om.svg");
const omega_svg_1 = require("../src/icons/regular/omega.svg");
const option_svg_1 = require("../src/icons/regular/option.svg");
const ornament_svg_1 = require("../src/icons/regular/ornament.svg");
const otter_svg_1 = require("../src/icons/regular/otter.svg");
const outdent_svg_1 = require("../src/icons/regular/outdent.svg");
const outlet_svg_1 = require("../src/icons/regular/outlet.svg");
const oven_svg_1 = require("../src/icons/regular/oven.svg");
const overline_svg_1 = require("../src/icons/regular/overline.svg");
const p_svg_1 = require("../src/icons/regular/p.svg");
const pager_svg_1 = require("../src/icons/regular/pager.svg");
const paint_brush_fine_svg_1 = require("../src/icons/regular/paint-brush-fine.svg");
const paint_brush_svg_1 = require("../src/icons/regular/paint-brush.svg");
const paint_roller_svg_1 = require("../src/icons/regular/paint-roller.svg");
const paintbrush_pencil_svg_1 = require("../src/icons/regular/paintbrush-pencil.svg");
const palette_boxes_svg_1 = require("../src/icons/regular/palette-boxes.svg");
const palette_svg_1 = require("../src/icons/regular/palette.svg");
const pallet_box_svg_1 = require("../src/icons/regular/pallet-box.svg");
const pallet_boxes_svg_1 = require("../src/icons/regular/pallet-boxes.svg");
const pallet_svg_1 = require("../src/icons/regular/pallet.svg");
const panorama_svg_1 = require("../src/icons/regular/panorama.svg");
const paper_plane_top_svg_1 = require("../src/icons/regular/paper-plane-top.svg");
const paper_plane_svg_1 = require("../src/icons/regular/paper-plane.svg");
const paperclip_svg_1 = require("../src/icons/regular/paperclip.svg");
const parachute_box_svg_1 = require("../src/icons/regular/parachute-box.svg");
const paragraph_left_svg_1 = require("../src/icons/regular/paragraph-left.svg");
const paragraph_svg_1 = require("../src/icons/regular/paragraph.svg");
const passport_svg_1 = require("../src/icons/regular/passport.svg");
const paste_svg_1 = require("../src/icons/regular/paste.svg");
const pause_svg_1 = require("../src/icons/regular/pause.svg");
const paw_claws_svg_1 = require("../src/icons/regular/paw-claws.svg");
const paw_simple_svg_1 = require("../src/icons/regular/paw-simple.svg");
const paw_svg_1 = require("../src/icons/regular/paw.svg");
const peace_svg_1 = require("../src/icons/regular/peace.svg");
const peach_svg_1 = require("../src/icons/regular/peach.svg");
const pear_svg_1 = require("../src/icons/regular/pear.svg");
const pedestal_svg_1 = require("../src/icons/regular/pedestal.svg");
const pegasus_svg_1 = require("../src/icons/regular/pegasus.svg");
const pen_circle_svg_1 = require("../src/icons/regular/pen-circle.svg");
const pen_clip_slash_svg_1 = require("../src/icons/regular/pen-clip-slash.svg");
const pen_clip_svg_1 = require("../src/icons/regular/pen-clip.svg");
const pen_fancy_slash_svg_1 = require("../src/icons/regular/pen-fancy-slash.svg");
const pen_fancy_svg_1 = require("../src/icons/regular/pen-fancy.svg");
const pen_field_svg_1 = require("../src/icons/regular/pen-field.svg");
const pen_line_svg_1 = require("../src/icons/regular/pen-line.svg");
const pen_nib_svg_1 = require("../src/icons/regular/pen-nib.svg");
const pen_paintbrush_svg_1 = require("../src/icons/regular/pen-paintbrush.svg");
const pen_ruler_svg_1 = require("../src/icons/regular/pen-ruler.svg");
const pen_slash_svg_1 = require("../src/icons/regular/pen-slash.svg");
const pen_swirl_svg_1 = require("../src/icons/regular/pen-swirl.svg");
const pen_to_square_svg_1 = require("../src/icons/regular/pen-to-square.svg");
const pen_svg_1 = require("../src/icons/regular/pen.svg");
const pencil_slash_svg_1 = require("../src/icons/regular/pencil-slash.svg");
const pencil_svg_1 = require("../src/icons/regular/pencil.svg");
const people_arrows_left_right_svg_1 = require("../src/icons/regular/people-arrows-left-right.svg");
const people_carry_box_svg_1 = require("../src/icons/regular/people-carry-box.svg");
const pepper_hot_svg_1 = require("../src/icons/regular/pepper-hot.svg");
const percent_svg_1 = require("../src/icons/regular/percent.svg");
const person_biking_mountain_svg_1 = require("../src/icons/regular/person-biking-mountain.svg");
const person_biking_svg_1 = require("../src/icons/regular/person-biking.svg");
const person_booth_svg_1 = require("../src/icons/regular/person-booth.svg");
const person_carry_box_svg_1 = require("../src/icons/regular/person-carry-box.svg");
const person_digging_svg_1 = require("../src/icons/regular/person-digging.svg");
const person_dolly_empty_svg_1 = require("../src/icons/regular/person-dolly-empty.svg");
const person_dolly_svg_1 = require("../src/icons/regular/person-dolly.svg");
const person_dots_from_line_svg_1 = require("../src/icons/regular/person-dots-from-line.svg");
const person_dress_simple_svg_1 = require("../src/icons/regular/person-dress-simple.svg");
const person_dress_svg_1 = require("../src/icons/regular/person-dress.svg");
const person_from_portal_svg_1 = require("../src/icons/regular/person-from-portal.svg");
const person_hiking_svg_1 = require("../src/icons/regular/person-hiking.svg");
const person_pinball_svg_1 = require("../src/icons/regular/person-pinball.svg");
const person_praying_svg_1 = require("../src/icons/regular/person-praying.svg");
const person_running_svg_1 = require("../src/icons/regular/person-running.svg");
const person_seat_reclined_svg_1 = require("../src/icons/regular/person-seat-reclined.svg");
const person_seat_svg_1 = require("../src/icons/regular/person-seat.svg");
const person_sign_svg_1 = require("../src/icons/regular/person-sign.svg");
const person_simple_svg_1 = require("../src/icons/regular/person-simple.svg");
const person_skating_svg_1 = require("../src/icons/regular/person-skating.svg");
const person_ski_jumping_svg_1 = require("../src/icons/regular/person-ski-jumping.svg");
const person_ski_lift_svg_1 = require("../src/icons/regular/person-ski-lift.svg");
const person_skiing_nordic_svg_1 = require("../src/icons/regular/person-skiing-nordic.svg");
const person_skiing_svg_1 = require("../src/icons/regular/person-skiing.svg");
const person_sledding_svg_1 = require("../src/icons/regular/person-sledding.svg");
const person_snowboarding_svg_1 = require("../src/icons/regular/person-snowboarding.svg");
const person_snowmobiling_svg_1 = require("../src/icons/regular/person-snowmobiling.svg");
const person_swimming_svg_1 = require("../src/icons/regular/person-swimming.svg");
const person_to_portal_svg_1 = require("../src/icons/regular/person-to-portal.svg");
const person_walking_with_cane_svg_1 = require("../src/icons/regular/person-walking-with-cane.svg");
const person_walking_svg_1 = require("../src/icons/regular/person-walking.svg");
const person_svg_1 = require("../src/icons/regular/person.svg");
const peseta_sign_svg_1 = require("../src/icons/regular/peseta-sign.svg");
const peso_sign_svg_1 = require("../src/icons/regular/peso-sign.svg");
const phone_arrow_down_left_svg_1 = require("../src/icons/regular/phone-arrow-down-left.svg");
const phone_arrow_up_right_svg_1 = require("../src/icons/regular/phone-arrow-up-right.svg");
const phone_flip_svg_1 = require("../src/icons/regular/phone-flip.svg");
const phone_hangup_svg_1 = require("../src/icons/regular/phone-hangup.svg");
const phone_missed_svg_1 = require("../src/icons/regular/phone-missed.svg");
const phone_office_svg_1 = require("../src/icons/regular/phone-office.svg");
const phone_plus_svg_1 = require("../src/icons/regular/phone-plus.svg");
const phone_rotary_svg_1 = require("../src/icons/regular/phone-rotary.svg");
const phone_slash_svg_1 = require("../src/icons/regular/phone-slash.svg");
const phone_volume_svg_1 = require("../src/icons/regular/phone-volume.svg");
const phone_xmark_svg_1 = require("../src/icons/regular/phone-xmark.svg");
const phone_svg_1 = require("../src/icons/regular/phone.svg");
const photo_film_music_svg_1 = require("../src/icons/regular/photo-film-music.svg");
const photo_film_svg_1 = require("../src/icons/regular/photo-film.svg");
const pi_svg_1 = require("../src/icons/regular/pi.svg");
const piano_keyboard_svg_1 = require("../src/icons/regular/piano-keyboard.svg");
const piano_svg_1 = require("../src/icons/regular/piano.svg");
const pie_svg_1 = require("../src/icons/regular/pie.svg");
const pig_svg_1 = require("../src/icons/regular/pig.svg");
const piggy_bank_svg_1 = require("../src/icons/regular/piggy-bank.svg");
const pills_svg_1 = require("../src/icons/regular/pills.svg");
const pinball_svg_1 = require("../src/icons/regular/pinball.svg");
const pizza_slice_svg_1 = require("../src/icons/regular/pizza-slice.svg");
const pizza_svg_1 = require("../src/icons/regular/pizza.svg");
const place_of_worship_svg_1 = require("../src/icons/regular/place-of-worship.svg");
const plane_arrival_svg_1 = require("../src/icons/regular/plane-arrival.svg");
const plane_departure_svg_1 = require("../src/icons/regular/plane-departure.svg");
const plane_engines_svg_1 = require("../src/icons/regular/plane-engines.svg");
const plane_prop_svg_1 = require("../src/icons/regular/plane-prop.svg");
const plane_slash_svg_1 = require("../src/icons/regular/plane-slash.svg");
const plane_tail_svg_1 = require("../src/icons/regular/plane-tail.svg");
const plane_up_slash_svg_1 = require("../src/icons/regular/plane-up-slash.svg");
const plane_up_svg_1 = require("../src/icons/regular/plane-up.svg");
const plane_svg_1 = require("../src/icons/regular/plane.svg");
const planet_moon_svg_1 = require("../src/icons/regular/planet-moon.svg");
const planet_ringed_svg_1 = require("../src/icons/regular/planet-ringed.svg");
const play_pause_svg_1 = require("../src/icons/regular/play-pause.svg");
const play_svg_1 = require("../src/icons/regular/play.svg");
const plug_svg_1 = require("../src/icons/regular/plug.svg");
const plus_minus_svg_1 = require("../src/icons/regular/plus-minus.svg");
const plus_svg_1 = require("../src/icons/regular/plus.svg");
const podcast_svg_1 = require("../src/icons/regular/podcast.svg");
const podium_star_svg_1 = require("../src/icons/regular/podium-star.svg");
const podium_svg_1 = require("../src/icons/regular/podium.svg");
const police_box_svg_1 = require("../src/icons/regular/police-box.svg");
const poll_people_svg_1 = require("../src/icons/regular/poll-people.svg");
const poo_bolt_svg_1 = require("../src/icons/regular/poo-bolt.svg");
const poo_svg_1 = require("../src/icons/regular/poo.svg");
const poop_svg_1 = require("../src/icons/regular/poop.svg");
const popcorn_svg_1 = require("../src/icons/regular/popcorn.svg");
const power_off_svg_1 = require("../src/icons/regular/power-off.svg");
const prescription_bottle_medical_svg_1 = require("../src/icons/regular/prescription-bottle-medical.svg");
const prescription_bottle_svg_1 = require("../src/icons/regular/prescription-bottle.svg");
const prescription_svg_1 = require("../src/icons/regular/prescription.svg");
const presentation_screen_svg_1 = require("../src/icons/regular/presentation-screen.svg");
const print_magnifying_glass_svg_1 = require("../src/icons/regular/print-magnifying-glass.svg");
const print_slash_svg_1 = require("../src/icons/regular/print-slash.svg");
const print_svg_1 = require("../src/icons/regular/print.svg");
const projector_svg_1 = require("../src/icons/regular/projector.svg");
const pump_medical_svg_1 = require("../src/icons/regular/pump-medical.svg");
const pump_soap_svg_1 = require("../src/icons/regular/pump-soap.svg");
const pumpkin_svg_1 = require("../src/icons/regular/pumpkin.svg");
const puzzle_piece_simple_svg_1 = require("../src/icons/regular/puzzle-piece-simple.svg");
const puzzle_piece_svg_1 = require("../src/icons/regular/puzzle-piece.svg");
const q_svg_1 = require("../src/icons/regular/q.svg");
const qrcode_svg_1 = require("../src/icons/regular/qrcode.svg");
const question_svg_1 = require("../src/icons/regular/question.svg");
const quidditch_broom_ball_svg_1 = require("../src/icons/regular/quidditch-broom-ball.svg");
const quote_left_round_svg_1 = require("../src/icons/regular/quote-left-round.svg");
const quote_left_svg_1 = require("../src/icons/regular/quote-left.svg");
const quote_right_round_svg_1 = require("../src/icons/regular/quote-right-round.svg");
const quote_right_svg_1 = require("../src/icons/regular/quote-right.svg");
const r_svg_1 = require("../src/icons/regular/r.svg");
const rabbit_running_svg_1 = require("../src/icons/regular/rabbit-running.svg");
const rabbit_svg_1 = require("../src/icons/regular/rabbit.svg");
const racquet_svg_1 = require("../src/icons/regular/racquet.svg");
const radar_svg_1 = require("../src/icons/regular/radar.svg");
const radiation_svg_1 = require("../src/icons/regular/radiation.svg");
const radio_tuner_svg_1 = require("../src/icons/regular/radio-tuner.svg");
const radio_svg_1 = require("../src/icons/regular/radio.svg");
const rainbow_svg_1 = require("../src/icons/regular/rainbow.svg");
const raindrops_svg_1 = require("../src/icons/regular/raindrops.svg");
const ram_svg_1 = require("../src/icons/regular/ram.svg");
const ramp_loading_svg_1 = require("../src/icons/regular/ramp-loading.svg");
const raygun_svg_1 = require("../src/icons/regular/raygun.svg");
const receipt_svg_1 = require("../src/icons/regular/receipt.svg");
const record_vinyl_svg_1 = require("../src/icons/regular/record-vinyl.svg");
const rectangle_ad_svg_1 = require("../src/icons/regular/rectangle-ad.svg");
const rectangle_barcode_svg_1 = require("../src/icons/regular/rectangle-barcode.svg");
const rectangle_list_svg_1 = require("../src/icons/regular/rectangle-list.svg");
const rectangle_terminal_svg_1 = require("../src/icons/regular/rectangle-terminal.svg");
const rectangle_vertical_history_svg_1 = require("../src/icons/regular/rectangle-vertical-history.svg");
const rectangle_vertical_svg_1 = require("../src/icons/regular/rectangle-vertical.svg");
const rectangle_wide_svg_1 = require("../src/icons/regular/rectangle-wide.svg");
const rectangle_xmark_svg_1 = require("../src/icons/regular/rectangle-xmark.svg");
const rectangle_svg_1 = require("../src/icons/regular/rectangle.svg");
const recycle_svg_1 = require("../src/icons/regular/recycle.svg");
const refrigerator_svg_1 = require("../src/icons/regular/refrigerator.svg");
const registered_svg_1 = require("../src/icons/regular/registered.svg");
const repeat_1_svg_1 = require("../src/icons/regular/repeat-1.svg");
const repeat_svg_1 = require("../src/icons/regular/repeat.svg");
const reply_all_svg_1 = require("../src/icons/regular/reply-all.svg");
const reply_clock_svg_1 = require("../src/icons/regular/reply-clock.svg");
const reply_svg_1 = require("../src/icons/regular/reply.svg");
const republican_svg_1 = require("../src/icons/regular/republican.svg");
const restroom_simple_svg_1 = require("../src/icons/regular/restroom-simple.svg");
const restroom_svg_1 = require("../src/icons/regular/restroom.svg");
const retweet_svg_1 = require("../src/icons/regular/retweet.svg");
const rhombus_svg_1 = require("../src/icons/regular/rhombus.svg");
const ribbon_svg_1 = require("../src/icons/regular/ribbon.svg");
const right_from_bracket_svg_1 = require("../src/icons/regular/right-from-bracket.svg");
const right_from_line_svg_1 = require("../src/icons/regular/right-from-line.svg");
const right_left_svg_1 = require("../src/icons/regular/right-left.svg");
const right_long_svg_1 = require("../src/icons/regular/right-long.svg");
const right_to_bracket_svg_1 = require("../src/icons/regular/right-to-bracket.svg");
const right_to_line_svg_1 = require("../src/icons/regular/right-to-line.svg");
const right_svg_1 = require("../src/icons/regular/right.svg");
const ring_svg_1 = require("../src/icons/regular/ring.svg");
const rings_wedding_svg_1 = require("../src/icons/regular/rings-wedding.svg");
const road_svg_1 = require("../src/icons/regular/road.svg");
const robot_svg_1 = require("../src/icons/regular/robot.svg");
const rocket_launch_svg_1 = require("../src/icons/regular/rocket-launch.svg");
const rocket_svg_1 = require("../src/icons/regular/rocket.svg");
const rotate_exclamation_svg_1 = require("../src/icons/regular/rotate-exclamation.svg");
const rotate_forward_svg_1 = require("../src/icons/regular/rotate-forward.svg");
const rotate_left_svg_1 = require("../src/icons/regular/rotate-left.svg");
const rotate_svg_1 = require("../src/icons/regular/rotate.svg");
const route_highway_svg_1 = require("../src/icons/regular/route-highway.svg");
const route_interstate_svg_1 = require("../src/icons/regular/route-interstate.svg");
const route_svg_1 = require("../src/icons/regular/route.svg");
const router_svg_1 = require("../src/icons/regular/router.svg");
const rss_svg_1 = require("../src/icons/regular/rss.svg");
const ruble_sign_svg_1 = require("../src/icons/regular/ruble-sign.svg");
const ruler_combined_svg_1 = require("../src/icons/regular/ruler-combined.svg");
const ruler_horizontal_svg_1 = require("../src/icons/regular/ruler-horizontal.svg");
const ruler_triangle_svg_1 = require("../src/icons/regular/ruler-triangle.svg");
const ruler_vertical_svg_1 = require("../src/icons/regular/ruler-vertical.svg");
const ruler_svg_1 = require("../src/icons/regular/ruler.svg");
const rupee_sign_svg_1 = require("../src/icons/regular/rupee-sign.svg");
const rupiah_sign_svg_1 = require("../src/icons/regular/rupiah-sign.svg");
const rv_svg_1 = require("../src/icons/regular/rv.svg");
const s_svg_1 = require("../src/icons/regular/s.svg");
const sack_dollar_svg_1 = require("../src/icons/regular/sack-dollar.svg");
const sack_svg_1 = require("../src/icons/regular/sack.svg");
const salad_svg_1 = require("../src/icons/regular/salad.svg");
const sandwich_svg_1 = require("../src/icons/regular/sandwich.svg");
const satellite_dish_svg_1 = require("../src/icons/regular/satellite-dish.svg");
const satellite_svg_1 = require("../src/icons/regular/satellite.svg");
const sausage_svg_1 = require("../src/icons/regular/sausage.svg");
const saxophone_fire_svg_1 = require("../src/icons/regular/saxophone-fire.svg");
const saxophone_svg_1 = require("../src/icons/regular/saxophone.svg");
const scale_balanced_svg_1 = require("../src/icons/regular/scale-balanced.svg");
const scale_unbalanced_flip_svg_1 = require("../src/icons/regular/scale-unbalanced-flip.svg");
const scale_unbalanced_svg_1 = require("../src/icons/regular/scale-unbalanced.svg");
const scalpel_line_dashed_svg_1 = require("../src/icons/regular/scalpel-line-dashed.svg");
const scalpel_svg_1 = require("../src/icons/regular/scalpel.svg");
const scanner_gun_svg_1 = require("../src/icons/regular/scanner-gun.svg");
const scanner_keyboard_svg_1 = require("../src/icons/regular/scanner-keyboard.svg");
const scanner_touchscreen_svg_1 = require("../src/icons/regular/scanner-touchscreen.svg");
const scanner_svg_1 = require("../src/icons/regular/scanner.svg");
const scarecrow_svg_1 = require("../src/icons/regular/scarecrow.svg");
const scarf_svg_1 = require("../src/icons/regular/scarf.svg");
const school_svg_1 = require("../src/icons/regular/school.svg");
const scissors_svg_1 = require("../src/icons/regular/scissors.svg");
const screen_users_svg_1 = require("../src/icons/regular/screen-users.svg");
const screencast_svg_1 = require("../src/icons/regular/screencast.svg");
const screwdriver_wrench_svg_1 = require("../src/icons/regular/screwdriver-wrench.svg");
const screwdriver_svg_1 = require("../src/icons/regular/screwdriver.svg");
const scribble_svg_1 = require("../src/icons/regular/scribble.svg");
const scroll_old_svg_1 = require("../src/icons/regular/scroll-old.svg");
const scroll_torah_svg_1 = require("../src/icons/regular/scroll-torah.svg");
const scroll_svg_1 = require("../src/icons/regular/scroll.svg");
const scrubber_svg_1 = require("../src/icons/regular/scrubber.svg");
const scythe_svg_1 = require("../src/icons/regular/scythe.svg");
const sd_card_svg_1 = require("../src/icons/regular/sd-card.svg");
const sd_cards_svg_1 = require("../src/icons/regular/sd-cards.svg");
const seal_exclamation_svg_1 = require("../src/icons/regular/seal-exclamation.svg");
const seal_question_svg_1 = require("../src/icons/regular/seal-question.svg");
const seal_svg_1 = require("../src/icons/regular/seal.svg");
const seat_airline_svg_1 = require("../src/icons/regular/seat-airline.svg");
const section_svg_1 = require("../src/icons/regular/section.svg");
const seedling_svg_1 = require("../src/icons/regular/seedling.svg");
const send_back_svg_1 = require("../src/icons/regular/send-back.svg");
const send_backward_svg_1 = require("../src/icons/regular/send-backward.svg");
const sensor_cloud_svg_1 = require("../src/icons/regular/sensor-cloud.svg");
const sensor_fire_svg_1 = require("../src/icons/regular/sensor-fire.svg");
const sensor_on_svg_1 = require("../src/icons/regular/sensor-on.svg");
const sensor_triangle_exclamation_svg_1 = require("../src/icons/regular/sensor-triangle-exclamation.svg");
const sensor_svg_1 = require("../src/icons/regular/sensor.svg");
const server_svg_1 = require("../src/icons/regular/server.svg");
const shapes_svg_1 = require("../src/icons/regular/shapes.svg");
const share_all_svg_1 = require("../src/icons/regular/share-all.svg");
const share_from_square_svg_1 = require("../src/icons/regular/share-from-square.svg");
const share_nodes_svg_1 = require("../src/icons/regular/share-nodes.svg");
const share_svg_1 = require("../src/icons/regular/share.svg");
const sheep_svg_1 = require("../src/icons/regular/sheep.svg");
const shekel_sign_svg_1 = require("../src/icons/regular/shekel-sign.svg");
const shelves_empty_svg_1 = require("../src/icons/regular/shelves-empty.svg");
const shelves_svg_1 = require("../src/icons/regular/shelves.svg");
const shield_blank_svg_1 = require("../src/icons/regular/shield-blank.svg");
const shield_check_svg_1 = require("../src/icons/regular/shield-check.svg");
const shield_cross_svg_1 = require("../src/icons/regular/shield-cross.svg");
const shield_exclamation_svg_1 = require("../src/icons/regular/shield-exclamation.svg");
const shield_keyhole_svg_1 = require("../src/icons/regular/shield-keyhole.svg");
const shield_minus_svg_1 = require("../src/icons/regular/shield-minus.svg");
const shield_plus_svg_1 = require("../src/icons/regular/shield-plus.svg");
const shield_slash_svg_1 = require("../src/icons/regular/shield-slash.svg");
const shield_virus_svg_1 = require("../src/icons/regular/shield-virus.svg");
const shield_xmark_svg_1 = require("../src/icons/regular/shield-xmark.svg");
const shield_svg_1 = require("../src/icons/regular/shield.svg");
const ship_svg_1 = require("../src/icons/regular/ship.svg");
const shish_kebab_svg_1 = require("../src/icons/regular/shish-kebab.svg");
const shoe_prints_svg_1 = require("../src/icons/regular/shoe-prints.svg");
const shop_slash_svg_1 = require("../src/icons/regular/shop-slash.svg");
const shop_svg_1 = require("../src/icons/regular/shop.svg");
const shovel_snow_svg_1 = require("../src/icons/regular/shovel-snow.svg");
const shovel_svg_1 = require("../src/icons/regular/shovel.svg");
const shower_down_svg_1 = require("../src/icons/regular/shower-down.svg");
const shower_svg_1 = require("../src/icons/regular/shower.svg");
const shredder_svg_1 = require("../src/icons/regular/shredder.svg");
const shuffle_svg_1 = require("../src/icons/regular/shuffle.svg");
const shuttle_space_svg_1 = require("../src/icons/regular/shuttle-space.svg");
const shuttlecock_svg_1 = require("../src/icons/regular/shuttlecock.svg");
const sickle_svg_1 = require("../src/icons/regular/sickle.svg");
const sidebar_flip_svg_1 = require("../src/icons/regular/sidebar-flip.svg");
const sidebar_svg_1 = require("../src/icons/regular/sidebar.svg");
const sigma_svg_1 = require("../src/icons/regular/sigma.svg");
const sign_hanging_svg_1 = require("../src/icons/regular/sign-hanging.svg");
const signal_bars_fair_svg_1 = require("../src/icons/regular/signal-bars-fair.svg");
const signal_bars_good_svg_1 = require("../src/icons/regular/signal-bars-good.svg");
const signal_bars_slash_svg_1 = require("../src/icons/regular/signal-bars-slash.svg");
const signal_bars_weak_svg_1 = require("../src/icons/regular/signal-bars-weak.svg");
const signal_bars_svg_1 = require("../src/icons/regular/signal-bars.svg");
const signal_fair_svg_1 = require("../src/icons/regular/signal-fair.svg");
const signal_good_svg_1 = require("../src/icons/regular/signal-good.svg");
const signal_slash_svg_1 = require("../src/icons/regular/signal-slash.svg");
const signal_stream_slash_svg_1 = require("../src/icons/regular/signal-stream-slash.svg");
const signal_stream_svg_1 = require("../src/icons/regular/signal-stream.svg");
const signal_strong_svg_1 = require("../src/icons/regular/signal-strong.svg");
const signal_weak_svg_1 = require("../src/icons/regular/signal-weak.svg");
const signal_svg_1 = require("../src/icons/regular/signal.svg");
const signature_svg_1 = require("../src/icons/regular/signature.svg");
const signs_post_svg_1 = require("../src/icons/regular/signs-post.svg");
const sim_card_svg_1 = require("../src/icons/regular/sim-card.svg");
const sim_cards_svg_1 = require("../src/icons/regular/sim-cards.svg");
const sink_svg_1 = require("../src/icons/regular/sink.svg");
const siren_on_svg_1 = require("../src/icons/regular/siren-on.svg");
const siren_svg_1 = require("../src/icons/regular/siren.svg");
const sitemap_svg_1 = require("../src/icons/regular/sitemap.svg");
const skeleton_svg_1 = require("../src/icons/regular/skeleton.svg");
const skull_cow_svg_1 = require("../src/icons/regular/skull-cow.svg");
const skull_crossbones_svg_1 = require("../src/icons/regular/skull-crossbones.svg");
const skull_svg_1 = require("../src/icons/regular/skull.svg");
const slash_svg_1 = require("../src/icons/regular/slash.svg");
const sleigh_svg_1 = require("../src/icons/regular/sleigh.svg");
const slider_svg_1 = require("../src/icons/regular/slider.svg");
const sliders_up_svg_1 = require("../src/icons/regular/sliders-up.svg");
const sliders_svg_1 = require("../src/icons/regular/sliders.svg");
const smog_svg_1 = require("../src/icons/regular/smog.svg");
const smoke_svg_1 = require("../src/icons/regular/smoke.svg");
const smoking_svg_1 = require("../src/icons/regular/smoking.svg");
const snake_svg_1 = require("../src/icons/regular/snake.svg");
const snooze_svg_1 = require("../src/icons/regular/snooze.svg");
const snow_blowing_svg_1 = require("../src/icons/regular/snow-blowing.svg");
const snowflake_svg_1 = require("../src/icons/regular/snowflake.svg");
const snowflakes_svg_1 = require("../src/icons/regular/snowflakes.svg");
const snowman_head_svg_1 = require("../src/icons/regular/snowman-head.svg");
const snowman_svg_1 = require("../src/icons/regular/snowman.svg");
const snowplow_svg_1 = require("../src/icons/regular/snowplow.svg");
const soap_svg_1 = require("../src/icons/regular/soap.svg");
const socks_svg_1 = require("../src/icons/regular/socks.svg");
const solar_panel_svg_1 = require("../src/icons/regular/solar-panel.svg");
const solar_system_svg_1 = require("../src/icons/regular/solar-system.svg");
const sort_down_svg_1 = require("../src/icons/regular/sort-down.svg");
const sort_up_svg_1 = require("../src/icons/regular/sort-up.svg");
const sort_svg_1 = require("../src/icons/regular/sort.svg");
const spa_svg_1 = require("../src/icons/regular/spa.svg");
const space_station_moon_construction_svg_1 = require("../src/icons/regular/space-station-moon-construction.svg");
const space_station_moon_svg_1 = require("../src/icons/regular/space-station-moon.svg");
const spade_svg_1 = require("../src/icons/regular/spade.svg");
const spaghetti_monster_flying_svg_1 = require("../src/icons/regular/spaghetti-monster-flying.svg");
const sparkles_svg_1 = require("../src/icons/regular/sparkles.svg");
const speaker_svg_1 = require("../src/icons/regular/speaker.svg");
const speakers_svg_1 = require("../src/icons/regular/speakers.svg");
const spell_check_svg_1 = require("../src/icons/regular/spell-check.svg");
const spider_black_widow_svg_1 = require("../src/icons/regular/spider-black-widow.svg");
const spider_web_svg_1 = require("../src/icons/regular/spider-web.svg");
const spider_svg_1 = require("../src/icons/regular/spider.svg");
const spinner_third_svg_1 = require("../src/icons/regular/spinner-third.svg");
const spinner_svg_1 = require("../src/icons/regular/spinner.svg");
const split_svg_1 = require("../src/icons/regular/split.svg");
const splotch_svg_1 = require("../src/icons/regular/splotch.svg");
const spoon_svg_1 = require("../src/icons/regular/spoon.svg");
const spray_can_svg_1 = require("../src/icons/regular/spray-can.svg");
const sprinkler_svg_1 = require("../src/icons/regular/sprinkler.svg");
const square_0_svg_1 = require("../src/icons/regular/square-0.svg");
const square_1_svg_1 = require("../src/icons/regular/square-1.svg");
const square_2_svg_1 = require("../src/icons/regular/square-2.svg");
const square_3_svg_1 = require("../src/icons/regular/square-3.svg");
const square_4_svg_1 = require("../src/icons/regular/square-4.svg");
const square_5_svg_1 = require("../src/icons/regular/square-5.svg");
const square_6_svg_1 = require("../src/icons/regular/square-6.svg");
const square_7_svg_1 = require("../src/icons/regular/square-7.svg");
const square_8_svg_1 = require("../src/icons/regular/square-8.svg");
const square_9_svg_1 = require("../src/icons/regular/square-9.svg");
const square_a_svg_1 = require("../src/icons/regular/square-a.svg");
const square_ampersand_svg_1 = require("../src/icons/regular/square-ampersand.svg");
const square_arrow_down_left_svg_1 = require("../src/icons/regular/square-arrow-down-left.svg");
const square_arrow_down_right_svg_1 = require("../src/icons/regular/square-arrow-down-right.svg");
const square_arrow_down_svg_1 = require("../src/icons/regular/square-arrow-down.svg");
const square_arrow_left_svg_1 = require("../src/icons/regular/square-arrow-left.svg");
const square_arrow_right_svg_1 = require("../src/icons/regular/square-arrow-right.svg");
const square_arrow_up_left_svg_1 = require("../src/icons/regular/square-arrow-up-left.svg");
const square_arrow_up_right_svg_1 = require("../src/icons/regular/square-arrow-up-right.svg");
const square_arrow_up_svg_1 = require("../src/icons/regular/square-arrow-up.svg");
const square_b_svg_1 = require("../src/icons/regular/square-b.svg");
const square_bolt_svg_1 = require("../src/icons/regular/square-bolt.svg");
const square_c_svg_1 = require("../src/icons/regular/square-c.svg");
const square_caret_down_svg_1 = require("../src/icons/regular/square-caret-down.svg");
const square_caret_left_svg_1 = require("../src/icons/regular/square-caret-left.svg");
const square_caret_right_svg_1 = require("../src/icons/regular/square-caret-right.svg");
const square_caret_up_svg_1 = require("../src/icons/regular/square-caret-up.svg");
const square_check_svg_1 = require("../src/icons/regular/square-check.svg");
const square_chevron_down_svg_1 = require("../src/icons/regular/square-chevron-down.svg");
const square_chevron_left_svg_1 = require("../src/icons/regular/square-chevron-left.svg");
const square_chevron_right_svg_1 = require("../src/icons/regular/square-chevron-right.svg");
const square_chevron_up_svg_1 = require("../src/icons/regular/square-chevron-up.svg");
const square_code_svg_1 = require("../src/icons/regular/square-code.svg");
const square_d_svg_1 = require("../src/icons/regular/square-d.svg");
const square_dashed_svg_1 = require("../src/icons/regular/square-dashed.svg");
const square_divide_svg_1 = require("../src/icons/regular/square-divide.svg");
const square_dollar_svg_1 = require("../src/icons/regular/square-dollar.svg");
const square_down_left_svg_1 = require("../src/icons/regular/square-down-left.svg");
const square_down_right_svg_1 = require("../src/icons/regular/square-down-right.svg");
const square_down_svg_1 = require("../src/icons/regular/square-down.svg");
const square_e_svg_1 = require("../src/icons/regular/square-e.svg");
const square_envelope_svg_1 = require("../src/icons/regular/square-envelope.svg");
const square_exclamation_svg_1 = require("../src/icons/regular/square-exclamation.svg");
const square_f_svg_1 = require("../src/icons/regular/square-f.svg");
const square_fragile_svg_1 = require("../src/icons/regular/square-fragile.svg");
const square_full_svg_1 = require("../src/icons/regular/square-full.svg");
const square_g_svg_1 = require("../src/icons/regular/square-g.svg");
const square_h_svg_1 = require("../src/icons/regular/square-h.svg");
const square_heart_svg_1 = require("../src/icons/regular/square-heart.svg");
const square_i_svg_1 = require("../src/icons/regular/square-i.svg");
const square_info_svg_1 = require("../src/icons/regular/square-info.svg");
const square_j_svg_1 = require("../src/icons/regular/square-j.svg");
const square_k_svg_1 = require("../src/icons/regular/square-k.svg");
const square_l_svg_1 = require("../src/icons/regular/square-l.svg");
const square_left_svg_1 = require("../src/icons/regular/square-left.svg");
const square_m_svg_1 = require("../src/icons/regular/square-m.svg");
const square_minus_svg_1 = require("../src/icons/regular/square-minus.svg");
const square_n_svg_1 = require("../src/icons/regular/square-n.svg");
const square_o_svg_1 = require("../src/icons/regular/square-o.svg");
const square_p_svg_1 = require("../src/icons/regular/square-p.svg");
const square_parking_slash_svg_1 = require("../src/icons/regular/square-parking-slash.svg");
const square_parking_svg_1 = require("../src/icons/regular/square-parking.svg");
const square_pen_svg_1 = require("../src/icons/regular/square-pen.svg");
const square_phone_flip_svg_1 = require("../src/icons/regular/square-phone-flip.svg");
const square_phone_hangup_svg_1 = require("../src/icons/regular/square-phone-hangup.svg");
const square_phone_svg_1 = require("../src/icons/regular/square-phone.svg");
const square_plus_svg_1 = require("../src/icons/regular/square-plus.svg");
const square_poll_horizontal_svg_1 = require("../src/icons/regular/square-poll-horizontal.svg");
const square_poll_vertical_svg_1 = require("../src/icons/regular/square-poll-vertical.svg");
const square_q_svg_1 = require("../src/icons/regular/square-q.svg");
const square_question_svg_1 = require("../src/icons/regular/square-question.svg");
const square_r_svg_1 = require("../src/icons/regular/square-r.svg");
const square_right_svg_1 = require("../src/icons/regular/square-right.svg");
const square_root_variable_svg_1 = require("../src/icons/regular/square-root-variable.svg");
const square_root_svg_1 = require("../src/icons/regular/square-root.svg");
const square_rss_svg_1 = require("../src/icons/regular/square-rss.svg");
const square_s_svg_1 = require("../src/icons/regular/square-s.svg");
const square_share_nodes_svg_1 = require("../src/icons/regular/square-share-nodes.svg");
const square_sliders_vertical_svg_1 = require("../src/icons/regular/square-sliders-vertical.svg");
const square_sliders_svg_1 = require("../src/icons/regular/square-sliders.svg");
const square_small_svg_1 = require("../src/icons/regular/square-small.svg");
const square_star_svg_1 = require("../src/icons/regular/square-star.svg");
const square_t_svg_1 = require("../src/icons/regular/square-t.svg");
const square_this_way_up_svg_1 = require("../src/icons/regular/square-this-way-up.svg");
const square_u_svg_1 = require("../src/icons/regular/square-u.svg");
const square_up_left_svg_1 = require("../src/icons/regular/square-up-left.svg");
const square_up_right_svg_1 = require("../src/icons/regular/square-up-right.svg");
const square_up_svg_1 = require("../src/icons/regular/square-up.svg");
const square_user_svg_1 = require("../src/icons/regular/square-user.svg");
const square_v_svg_1 = require("../src/icons/regular/square-v.svg");
const square_w_svg_1 = require("../src/icons/regular/square-w.svg");
const square_x_svg_1 = require("../src/icons/regular/square-x.svg");
const square_xmark_svg_1 = require("../src/icons/regular/square-xmark.svg");
const square_y_svg_1 = require("../src/icons/regular/square-y.svg");
const square_z_svg_1 = require("../src/icons/regular/square-z.svg");
const square_svg_1 = require("../src/icons/regular/square.svg");
const squirrel_svg_1 = require("../src/icons/regular/squirrel.svg");
const staff_svg_1 = require("../src/icons/regular/staff.svg");
const stairs_svg_1 = require("../src/icons/regular/stairs.svg");
const stamp_svg_1 = require("../src/icons/regular/stamp.svg");
const standard_definition_svg_1 = require("../src/icons/regular/standard-definition.svg");
const star_and_crescent_svg_1 = require("../src/icons/regular/star-and-crescent.svg");
const star_christmas_svg_1 = require("../src/icons/regular/star-christmas.svg");
const star_exclamation_svg_1 = require("../src/icons/regular/star-exclamation.svg");
const star_half_stroke_svg_1 = require("../src/icons/regular/star-half-stroke.svg");
const star_half_svg_1 = require("../src/icons/regular/star-half.svg");
const star_of_david_svg_1 = require("../src/icons/regular/star-of-david.svg");
const star_of_life_svg_1 = require("../src/icons/regular/star-of-life.svg");
const star_sharp_half_stroke_svg_1 = require("../src/icons/regular/star-sharp-half-stroke.svg");
const star_sharp_half_svg_1 = require("../src/icons/regular/star-sharp-half.svg");
const star_sharp_svg_1 = require("../src/icons/regular/star-sharp.svg");
const star_shooting_svg_1 = require("../src/icons/regular/star-shooting.svg");
const star_svg_1 = require("../src/icons/regular/star.svg");
const starfighter_twin_ion_engine_advanced_svg_1 = require("../src/icons/regular/starfighter-twin-ion-engine-advanced.svg");
const starfighter_twin_ion_engine_svg_1 = require("../src/icons/regular/starfighter-twin-ion-engine.svg");
const starfighter_svg_1 = require("../src/icons/regular/starfighter.svg");
const stars_svg_1 = require("../src/icons/regular/stars.svg");
const starship_freighter_svg_1 = require("../src/icons/regular/starship-freighter.svg");
const starship_svg_1 = require("../src/icons/regular/starship.svg");
const steak_svg_1 = require("../src/icons/regular/steak.svg");
const steering_wheel_svg_1 = require("../src/icons/regular/steering-wheel.svg");
const sterling_sign_svg_1 = require("../src/icons/regular/sterling-sign.svg");
const stethoscope_svg_1 = require("../src/icons/regular/stethoscope.svg");
const stocking_svg_1 = require("../src/icons/regular/stocking.svg");
const stomach_svg_1 = require("../src/icons/regular/stomach.svg");
const stop_svg_1 = require("../src/icons/regular/stop.svg");
const stopwatch_20_svg_1 = require("../src/icons/regular/stopwatch-20.svg");
const stopwatch_svg_1 = require("../src/icons/regular/stopwatch.svg");
const store_slash_svg_1 = require("../src/icons/regular/store-slash.svg");
const store_svg_1 = require("../src/icons/regular/store.svg");
const street_view_svg_1 = require("../src/icons/regular/street-view.svg");
const stretcher_svg_1 = require("../src/icons/regular/stretcher.svg");
const strikethrough_svg_1 = require("../src/icons/regular/strikethrough.svg");
const stroopwafel_svg_1 = require("../src/icons/regular/stroopwafel.svg");
const subscript_svg_1 = require("../src/icons/regular/subscript.svg");
const suitcase_medical_svg_1 = require("../src/icons/regular/suitcase-medical.svg");
const suitcase_rolling_svg_1 = require("../src/icons/regular/suitcase-rolling.svg");
const suitcase_svg_1 = require("../src/icons/regular/suitcase.svg");
const sun_bright_svg_1 = require("../src/icons/regular/sun-bright.svg");
const sun_cloud_svg_1 = require("../src/icons/regular/sun-cloud.svg");
const sun_dust_svg_1 = require("../src/icons/regular/sun-dust.svg");
const sun_haze_svg_1 = require("../src/icons/regular/sun-haze.svg");
const sun_svg_1 = require("../src/icons/regular/sun.svg");
const sunglasses_svg_1 = require("../src/icons/regular/sunglasses.svg");
const sunrise_svg_1 = require("../src/icons/regular/sunrise.svg");
const sunset_svg_1 = require("../src/icons/regular/sunset.svg");
const superscript_svg_1 = require("../src/icons/regular/superscript.svg");
const swatchbook_svg_1 = require("../src/icons/regular/swatchbook.svg");
const sword_laser_alt_svg_1 = require("../src/icons/regular/sword-laser-alt.svg");
const sword_laser_svg_1 = require("../src/icons/regular/sword-laser.svg");
const sword_svg_1 = require("../src/icons/regular/sword.svg");
const swords_laser_svg_1 = require("../src/icons/regular/swords-laser.svg");
const swords_svg_1 = require("../src/icons/regular/swords.svg");
const symbols_svg_1 = require("../src/icons/regular/symbols.svg");
const synagogue_svg_1 = require("../src/icons/regular/synagogue.svg");
const syringe_svg_1 = require("../src/icons/regular/syringe.svg");
const t_svg_1 = require("../src/icons/regular/t.svg");
const table_cells_large_svg_1 = require("../src/icons/regular/table-cells-large.svg");
const table_cells_svg_1 = require("../src/icons/regular/table-cells.svg");
const table_columns_svg_1 = require("../src/icons/regular/table-columns.svg");
const table_layout_svg_1 = require("../src/icons/regular/table-layout.svg");
const table_list_svg_1 = require("../src/icons/regular/table-list.svg");
const table_pivot_svg_1 = require("../src/icons/regular/table-pivot.svg");
const table_rows_svg_1 = require("../src/icons/regular/table-rows.svg");
const table_tennis_paddle_ball_svg_1 = require("../src/icons/regular/table-tennis-paddle-ball.svg");
const table_tree_svg_1 = require("../src/icons/regular/table-tree.svg");
const table_svg_1 = require("../src/icons/regular/table.svg");
const tablet_button_svg_1 = require("../src/icons/regular/tablet-button.svg");
const tablet_rugged_svg_1 = require("../src/icons/regular/tablet-rugged.svg");
const tablet_screen_button_svg_1 = require("../src/icons/regular/tablet-screen-button.svg");
const tablet_screen_svg_1 = require("../src/icons/regular/tablet-screen.svg");
const tablet_svg_1 = require("../src/icons/regular/tablet.svg");
const tablets_svg_1 = require("../src/icons/regular/tablets.svg");
const tachograph_digital_svg_1 = require("../src/icons/regular/tachograph-digital.svg");
const taco_svg_1 = require("../src/icons/regular/taco.svg");
const tag_svg_1 = require("../src/icons/regular/tag.svg");
const tags_svg_1 = require("../src/icons/regular/tags.svg");
const tally_1_svg_1 = require("../src/icons/regular/tally-1.svg");
const tally_2_svg_1 = require("../src/icons/regular/tally-2.svg");
const tally_3_svg_1 = require("../src/icons/regular/tally-3.svg");
const tally_4_svg_1 = require("../src/icons/regular/tally-4.svg");
const tally_svg_1 = require("../src/icons/regular/tally.svg");
const tape_svg_1 = require("../src/icons/regular/tape.svg");
const taxi_bus_svg_1 = require("../src/icons/regular/taxi-bus.svg");
const taxi_svg_1 = require("../src/icons/regular/taxi.svg");
const teeth_open_svg_1 = require("../src/icons/regular/teeth-open.svg");
const teeth_svg_1 = require("../src/icons/regular/teeth.svg");
const telescope_svg_1 = require("../src/icons/regular/telescope.svg");
const temperature_arrow_down_svg_1 = require("../src/icons/regular/temperature-arrow-down.svg");
const temperature_arrow_up_svg_1 = require("../src/icons/regular/temperature-arrow-up.svg");
const temperature_empty_svg_1 = require("../src/icons/regular/temperature-empty.svg");
const temperature_full_svg_1 = require("../src/icons/regular/temperature-full.svg");
const temperature_half_svg_1 = require("../src/icons/regular/temperature-half.svg");
const temperature_high_svg_1 = require("../src/icons/regular/temperature-high.svg");
const temperature_list_svg_1 = require("../src/icons/regular/temperature-list.svg");
const temperature_low_svg_1 = require("../src/icons/regular/temperature-low.svg");
const temperature_quarter_svg_1 = require("../src/icons/regular/temperature-quarter.svg");
const temperature_snow_svg_1 = require("../src/icons/regular/temperature-snow.svg");
const temperature_sun_svg_1 = require("../src/icons/regular/temperature-sun.svg");
const temperature_three_quarters_svg_1 = require("../src/icons/regular/temperature-three-quarters.svg");
const tenge_sign_svg_1 = require("../src/icons/regular/tenge-sign.svg");
const tennis_ball_svg_1 = require("../src/icons/regular/tennis-ball.svg");
const terminal_svg_1 = require("../src/icons/regular/terminal.svg");
const text_height_svg_1 = require("../src/icons/regular/text-height.svg");
const text_size_svg_1 = require("../src/icons/regular/text-size.svg");
const text_slash_svg_1 = require("../src/icons/regular/text-slash.svg");
const text_width_svg_1 = require("../src/icons/regular/text-width.svg");
const text_svg_1 = require("../src/icons/regular/text.svg");
const thermometer_svg_1 = require("../src/icons/regular/thermometer.svg");
const theta_svg_1 = require("../src/icons/regular/theta.svg");
const thumbs_down_svg_1 = require("../src/icons/regular/thumbs-down.svg");
const thumbs_up_svg_1 = require("../src/icons/regular/thumbs-up.svg");
const thumbtack_svg_1 = require("../src/icons/regular/thumbtack.svg");
const ticket_airline_svg_1 = require("../src/icons/regular/ticket-airline.svg");
const ticket_simple_svg_1 = require("../src/icons/regular/ticket-simple.svg");
const ticket_svg_1 = require("../src/icons/regular/ticket.svg");
const tickets_airline_svg_1 = require("../src/icons/regular/tickets-airline.svg");
const tilde_svg_1 = require("../src/icons/regular/tilde.svg");
const timeline_arrow_svg_1 = require("../src/icons/regular/timeline-arrow.svg");
const timeline_svg_1 = require("../src/icons/regular/timeline.svg");
const timer_svg_1 = require("../src/icons/regular/timer.svg");
const tire_flat_svg_1 = require("../src/icons/regular/tire-flat.svg");
const tire_pressure_warning_svg_1 = require("../src/icons/regular/tire-pressure-warning.svg");
const tire_rugged_svg_1 = require("../src/icons/regular/tire-rugged.svg");
const tire_svg_1 = require("../src/icons/regular/tire.svg");
const toggle_off_svg_1 = require("../src/icons/regular/toggle-off.svg");
const toggle_on_svg_1 = require("../src/icons/regular/toggle-on.svg");
const toilet_paper_blank_under_svg_1 = require("../src/icons/regular/toilet-paper-blank-under.svg");
const toilet_paper_blank_svg_1 = require("../src/icons/regular/toilet-paper-blank.svg");
const toilet_paper_slash_svg_1 = require("../src/icons/regular/toilet-paper-slash.svg");
const toilet_paper_under_slash_svg_1 = require("../src/icons/regular/toilet-paper-under-slash.svg");
const toilet_paper_under_svg_1 = require("../src/icons/regular/toilet-paper-under.svg");
const toilet_paper_svg_1 = require("../src/icons/regular/toilet-paper.svg");
const toilet_svg_1 = require("../src/icons/regular/toilet.svg");
const tombstone_blank_svg_1 = require("../src/icons/regular/tombstone-blank.svg");
const tombstone_svg_1 = require("../src/icons/regular/tombstone.svg");
const toolbox_svg_1 = require("../src/icons/regular/toolbox.svg");
const tooth_svg_1 = require("../src/icons/regular/tooth.svg");
const toothbrush_svg_1 = require("../src/icons/regular/toothbrush.svg");
const torii_gate_svg_1 = require("../src/icons/regular/torii-gate.svg");
const tornado_svg_1 = require("../src/icons/regular/tornado.svg");
const tower_broadcast_svg_1 = require("../src/icons/regular/tower-broadcast.svg");
const tower_control_svg_1 = require("../src/icons/regular/tower-control.svg");
const tractor_svg_1 = require("../src/icons/regular/tractor.svg");
const trademark_svg_1 = require("../src/icons/regular/trademark.svg");
const traffic_cone_svg_1 = require("../src/icons/regular/traffic-cone.svg");
const traffic_light_go_svg_1 = require("../src/icons/regular/traffic-light-go.svg");
const traffic_light_slow_svg_1 = require("../src/icons/regular/traffic-light-slow.svg");
const traffic_light_stop_svg_1 = require("../src/icons/regular/traffic-light-stop.svg");
const traffic_light_svg_1 = require("../src/icons/regular/traffic-light.svg");
const trailer_svg_1 = require("../src/icons/regular/trailer.svg");
const train_subway_tunnel_svg_1 = require("../src/icons/regular/train-subway-tunnel.svg");
const train_subway_svg_1 = require("../src/icons/regular/train-subway.svg");
const train_tram_svg_1 = require("../src/icons/regular/train-tram.svg");
const train_svg_1 = require("../src/icons/regular/train.svg");
const transformer_bolt_svg_1 = require("../src/icons/regular/transformer-bolt.svg");
const transgender_alt_svg_1 = require("../src/icons/regular/transgender-alt.svg");
const transgender_svg_1 = require("../src/icons/regular/transgender.svg");
const transporter_1_svg_1 = require("../src/icons/regular/transporter-1.svg");
const transporter_2_svg_1 = require("../src/icons/regular/transporter-2.svg");
const transporter_3_svg_1 = require("../src/icons/regular/transporter-3.svg");
const transporter_4_svg_1 = require("../src/icons/regular/transporter-4.svg");
const transporter_5_svg_1 = require("../src/icons/regular/transporter-5.svg");
const transporter_6_svg_1 = require("../src/icons/regular/transporter-6.svg");
const transporter_7_svg_1 = require("../src/icons/regular/transporter-7.svg");
const transporter_empty_svg_1 = require("../src/icons/regular/transporter-empty.svg");
const transporter_svg_1 = require("../src/icons/regular/transporter.svg");
const trash_arrow_up_svg_1 = require("../src/icons/regular/trash-arrow-up.svg");
const trash_can_arrow_up_svg_1 = require("../src/icons/regular/trash-can-arrow-up.svg");
const trash_can_clock_svg_1 = require("../src/icons/regular/trash-can-clock.svg");
const trash_can_list_svg_1 = require("../src/icons/regular/trash-can-list.svg");
const trash_can_slash_svg_1 = require("../src/icons/regular/trash-can-slash.svg");
const trash_can_undo_svg_1 = require("../src/icons/regular/trash-can-undo.svg");
const trash_can_svg_1 = require("../src/icons/regular/trash-can.svg");
const trash_clock_svg_1 = require("../src/icons/regular/trash-clock.svg");
const trash_list_svg_1 = require("../src/icons/regular/trash-list.svg");
const trash_slash_svg_1 = require("../src/icons/regular/trash-slash.svg");
const trash_undo_svg_1 = require("../src/icons/regular/trash-undo.svg");
const trash_svg_1 = require("../src/icons/regular/trash.svg");
const treasure_chest_svg_1 = require("../src/icons/regular/treasure-chest.svg");
const tree_christmas_svg_1 = require("../src/icons/regular/tree-christmas.svg");
const tree_deciduous_svg_1 = require("../src/icons/regular/tree-deciduous.svg");
const tree_decorated_svg_1 = require("../src/icons/regular/tree-decorated.svg");
const tree_large_svg_1 = require("../src/icons/regular/tree-large.svg");
const tree_palm_svg_1 = require("../src/icons/regular/tree-palm.svg");
const tree_svg_1 = require("../src/icons/regular/tree.svg");
const trees_svg_1 = require("../src/icons/regular/trees.svg");
const triangle_exclamation_svg_1 = require("../src/icons/regular/triangle-exclamation.svg");
const triangle_instrument_svg_1 = require("../src/icons/regular/triangle-instrument.svg");
const triangle_person_digging_svg_1 = require("../src/icons/regular/triangle-person-digging.svg");
const triangle_svg_1 = require("../src/icons/regular/triangle.svg");
const trophy_star_svg_1 = require("../src/icons/regular/trophy-star.svg");
const trophy_svg_1 = require("../src/icons/regular/trophy.svg");
const truck_clock_svg_1 = require("../src/icons/regular/truck-clock.svg");
const truck_container_empty_svg_1 = require("../src/icons/regular/truck-container-empty.svg");
const truck_container_svg_1 = require("../src/icons/regular/truck-container.svg");
const truck_fast_svg_1 = require("../src/icons/regular/truck-fast.svg");
const truck_flatbed_svg_1 = require("../src/icons/regular/truck-flatbed.svg");
const truck_front_svg_1 = require("../src/icons/regular/truck-front.svg");
const truck_medical_svg_1 = require("../src/icons/regular/truck-medical.svg");
const truck_monster_svg_1 = require("../src/icons/regular/truck-monster.svg");
const truck_moving_svg_1 = require("../src/icons/regular/truck-moving.svg");
const truck_pickup_svg_1 = require("../src/icons/regular/truck-pickup.svg");
const truck_plow_svg_1 = require("../src/icons/regular/truck-plow.svg");
const truck_ramp_box_svg_1 = require("../src/icons/regular/truck-ramp-box.svg");
const truck_ramp_couch_svg_1 = require("../src/icons/regular/truck-ramp-couch.svg");
const truck_ramp_svg_1 = require("../src/icons/regular/truck-ramp.svg");
const truck_tow_svg_1 = require("../src/icons/regular/truck-tow.svg");
const truck_svg_1 = require("../src/icons/regular/truck.svg");
const trumpet_svg_1 = require("../src/icons/regular/trumpet.svg");
const tshirt_svg_1 = require("../src/icons/regular/tshirt.svg");
const tty_answer_svg_1 = require("../src/icons/regular/tty-answer.svg");
const tty_svg_1 = require("../src/icons/regular/tty.svg");
const tugrik_sign_svg_1 = require("../src/icons/regular/tugrik-sign.svg");
const turkey_svg_1 = require("../src/icons/regular/turkey.svg");
const turkish_lira_sign_svg_1 = require("../src/icons/regular/turkish-lira-sign.svg");
const turn_down_svg_1 = require("../src/icons/regular/turn-down.svg");
const turn_up_svg_1 = require("../src/icons/regular/turn-up.svg");
const turntable_svg_1 = require("../src/icons/regular/turntable.svg");
const turtle_svg_1 = require("../src/icons/regular/turtle.svg");
const tv_music_svg_1 = require("../src/icons/regular/tv-music.svg");
const tv_retro_svg_1 = require("../src/icons/regular/tv-retro.svg");
const tv_svg_1 = require("../src/icons/regular/tv.svg");
const typewriter_svg_1 = require("../src/icons/regular/typewriter.svg");
const u_svg_1 = require("../src/icons/regular/u.svg");
const ufo_beam_svg_1 = require("../src/icons/regular/ufo-beam.svg");
const ufo_svg_1 = require("../src/icons/regular/ufo.svg");
const umbrella_beach_svg_1 = require("../src/icons/regular/umbrella-beach.svg");
const umbrella_simple_svg_1 = require("../src/icons/regular/umbrella-simple.svg");
const umbrella_svg_1 = require("../src/icons/regular/umbrella.svg");
const underline_svg_1 = require("../src/icons/regular/underline.svg");
const unicorn_svg_1 = require("../src/icons/regular/unicorn.svg");
const union_svg_1 = require("../src/icons/regular/union.svg");
const universal_access_svg_1 = require("../src/icons/regular/universal-access.svg");
const unlock_keyhole_svg_1 = require("../src/icons/regular/unlock-keyhole.svg");
const unlock_svg_1 = require("../src/icons/regular/unlock.svg");
const up_down_left_right_svg_1 = require("../src/icons/regular/up-down-left-right.svg");
const up_down_svg_1 = require("../src/icons/regular/up-down.svg");
const up_from_line_svg_1 = require("../src/icons/regular/up-from-line.svg");
const up_left_svg_1 = require("../src/icons/regular/up-left.svg");
const up_long_svg_1 = require("../src/icons/regular/up-long.svg");
const up_right_and_down_left_from_center_svg_1 = require("../src/icons/regular/up-right-and-down-left-from-center.svg");
const up_right_from_square_svg_1 = require("../src/icons/regular/up-right-from-square.svg");
const up_right_svg_1 = require("../src/icons/regular/up-right.svg");
const up_to_line_svg_1 = require("../src/icons/regular/up-to-line.svg");
const up_svg_1 = require("../src/icons/regular/up.svg");
const upload_svg_1 = require("../src/icons/regular/upload.svg");
const usb_drive_svg_1 = require("../src/icons/regular/usb-drive.svg");
const user_alien_svg_1 = require("../src/icons/regular/user-alien.svg");
const user_astronaut_svg_1 = require("../src/icons/regular/user-astronaut.svg");
const user_bounty_hunter_svg_1 = require("../src/icons/regular/user-bounty-hunter.svg");
const user_check_svg_1 = require("../src/icons/regular/user-check.svg");
const user_clock_svg_1 = require("../src/icons/regular/user-clock.svg");
const user_cowboy_svg_1 = require("../src/icons/regular/user-cowboy.svg");
const user_crown_svg_1 = require("../src/icons/regular/user-crown.svg");
const user_doctor_message_svg_1 = require("../src/icons/regular/user-doctor-message.svg");
const user_doctor_svg_1 = require("../src/icons/regular/user-doctor.svg");
const user_gear_svg_1 = require("../src/icons/regular/user-gear.svg");
const user_graduate_svg_1 = require("../src/icons/regular/user-graduate.svg");
const user_group_crown_svg_1 = require("../src/icons/regular/user-group-crown.svg");
const user_group_svg_1 = require("../src/icons/regular/user-group.svg");
const user_headset_svg_1 = require("../src/icons/regular/user-headset.svg");
const user_helmet_safety_svg_1 = require("../src/icons/regular/user-helmet-safety.svg");
const user_injured_svg_1 = require("../src/icons/regular/user-injured.svg");
const user_large_slash_svg_1 = require("../src/icons/regular/user-large-slash.svg");
const user_large_svg_1 = require("../src/icons/regular/user-large.svg");
const user_lock_svg_1 = require("../src/icons/regular/user-lock.svg");
const user_minus_svg_1 = require("../src/icons/regular/user-minus.svg");
const user_music_svg_1 = require("../src/icons/regular/user-music.svg");
const user_ninja_svg_1 = require("../src/icons/regular/user-ninja.svg");
const user_nurse_svg_1 = require("../src/icons/regular/user-nurse.svg");
const user_pen_svg_1 = require("../src/icons/regular/user-pen.svg");
const user_pilot_tie_svg_1 = require("../src/icons/regular/user-pilot-tie.svg");
const user_pilot_svg_1 = require("../src/icons/regular/user-pilot.svg");
const user_plus_svg_1 = require("../src/icons/regular/user-plus.svg");
const user_robot_svg_1 = require("../src/icons/regular/user-robot.svg");
const user_secret_svg_1 = require("../src/icons/regular/user-secret.svg");
const user_shakespeare_svg_1 = require("../src/icons/regular/user-shakespeare.svg");
const user_shield_svg_1 = require("../src/icons/regular/user-shield.svg");
const user_slash_svg_1 = require("../src/icons/regular/user-slash.svg");
const user_tag_svg_1 = require("../src/icons/regular/user-tag.svg");
const user_tie_svg_1 = require("../src/icons/regular/user-tie.svg");
const user_unlock_svg_1 = require("../src/icons/regular/user-unlock.svg");
const user_visor_svg_1 = require("../src/icons/regular/user-visor.svg");
const user_xmark_svg_1 = require("../src/icons/regular/user-xmark.svg");
const user_svg_1 = require("../src/icons/regular/user.svg");
const users_gear_svg_1 = require("../src/icons/regular/users-gear.svg");
const users_medical_svg_1 = require("../src/icons/regular/users-medical.svg");
const users_slash_svg_1 = require("../src/icons/regular/users-slash.svg");
const users_svg_1 = require("../src/icons/regular/users.svg");
const utensils_svg_1 = require("../src/icons/regular/utensils.svg");
const utility_pole_double_svg_1 = require("../src/icons/regular/utility-pole-double.svg");
const utility_pole_svg_1 = require("../src/icons/regular/utility-pole.svg");
const v_svg_1 = require("../src/icons/regular/v.svg");
const vacuum_robot_svg_1 = require("../src/icons/regular/vacuum-robot.svg");
const vacuum_svg_1 = require("../src/icons/regular/vacuum.svg");
const value_absolute_svg_1 = require("../src/icons/regular/value-absolute.svg");
const van_shuttle_svg_1 = require("../src/icons/regular/van-shuttle.svg");
const vault_svg_1 = require("../src/icons/regular/vault.svg");
const vector_circle_svg_1 = require("../src/icons/regular/vector-circle.svg");
const vector_polygon_svg_1 = require("../src/icons/regular/vector-polygon.svg");
const vector_square_svg_1 = require("../src/icons/regular/vector-square.svg");
const venus_double_svg_1 = require("../src/icons/regular/venus-double.svg");
const venus_mars_svg_1 = require("../src/icons/regular/venus-mars.svg");
const venus_svg_1 = require("../src/icons/regular/venus.svg");
const vest_patches_svg_1 = require("../src/icons/regular/vest-patches.svg");
const vest_svg_1 = require("../src/icons/regular/vest.svg");
const vial_svg_1 = require("../src/icons/regular/vial.svg");
const vials_svg_1 = require("../src/icons/regular/vials.svg");
const video_arrow_down_left_svg_1 = require("../src/icons/regular/video-arrow-down-left.svg");
const video_arrow_up_right_svg_1 = require("../src/icons/regular/video-arrow-up-right.svg");
const video_plus_svg_1 = require("../src/icons/regular/video-plus.svg");
const video_slash_svg_1 = require("../src/icons/regular/video-slash.svg");
const video_svg_1 = require("../src/icons/regular/video.svg");
const vihara_svg_1 = require("../src/icons/regular/vihara.svg");
const violin_svg_1 = require("../src/icons/regular/violin.svg");
const virus_slash_svg_1 = require("../src/icons/regular/virus-slash.svg");
const virus_svg_1 = require("../src/icons/regular/virus.svg");
const viruses_svg_1 = require("../src/icons/regular/viruses.svg");
const voicemail_svg_1 = require("../src/icons/regular/voicemail.svg");
const volcano_svg_1 = require("../src/icons/regular/volcano.svg");
const volleyball_ball_svg_1 = require("../src/icons/regular/volleyball-ball.svg");
const volume_high_svg_1 = require("../src/icons/regular/volume-high.svg");
const volume_low_svg_1 = require("../src/icons/regular/volume-low.svg");
const volume_off_svg_1 = require("../src/icons/regular/volume-off.svg");
const volume_slash_svg_1 = require("../src/icons/regular/volume-slash.svg");
const volume_xmark_svg_1 = require("../src/icons/regular/volume-xmark.svg");
const volume_svg_1 = require("../src/icons/regular/volume.svg");
const vr_cardboard_svg_1 = require("../src/icons/regular/vr-cardboard.svg");
const w_svg_1 = require("../src/icons/regular/w.svg");
const wagon_covered_svg_1 = require("../src/icons/regular/wagon-covered.svg");
const walker_svg_1 = require("../src/icons/regular/walker.svg");
const walkie_talkie_svg_1 = require("../src/icons/regular/walkie-talkie.svg");
const wallet_svg_1 = require("../src/icons/regular/wallet.svg");
const wand_magic_sparkles_svg_1 = require("../src/icons/regular/wand-magic-sparkles.svg");
const wand_magic_svg_1 = require("../src/icons/regular/wand-magic.svg");
const wand_sparkles_svg_1 = require("../src/icons/regular/wand-sparkles.svg");
const wand_svg_1 = require("../src/icons/regular/wand.svg");
const warehouse_full_svg_1 = require("../src/icons/regular/warehouse-full.svg");
const warehouse_svg_1 = require("../src/icons/regular/warehouse.svg");
const washing_machine_svg_1 = require("../src/icons/regular/washing-machine.svg");
const watch_apple_svg_1 = require("../src/icons/regular/watch-apple.svg");
const watch_calculator_svg_1 = require("../src/icons/regular/watch-calculator.svg");
const watch_fitness_svg_1 = require("../src/icons/regular/watch-fitness.svg");
const watch_smart_svg_1 = require("../src/icons/regular/watch-smart.svg");
const watch_svg_1 = require("../src/icons/regular/watch.svg");
const water_arrow_down_svg_1 = require("../src/icons/regular/water-arrow-down.svg");
const water_arrow_up_svg_1 = require("../src/icons/regular/water-arrow-up.svg");
const water_ladder_svg_1 = require("../src/icons/regular/water-ladder.svg");
const water_svg_1 = require("../src/icons/regular/water.svg");
const wave_pulse_svg_1 = require("../src/icons/regular/wave-pulse.svg");
const wave_sine_svg_1 = require("../src/icons/regular/wave-sine.svg");
const wave_square_svg_1 = require("../src/icons/regular/wave-square.svg");
const wave_triangle_svg_1 = require("../src/icons/regular/wave-triangle.svg");
const waveform_lines_svg_1 = require("../src/icons/regular/waveform-lines.svg");
const waveform_svg_1 = require("../src/icons/regular/waveform.svg");
const weight_hanging_svg_1 = require("../src/icons/regular/weight-hanging.svg");
const weight_scale_svg_1 = require("../src/icons/regular/weight-scale.svg");
const whale_svg_1 = require("../src/icons/regular/whale.svg");
const wheat_awn_svg_1 = require("../src/icons/regular/wheat-awn.svg");
const wheat_svg_1 = require("../src/icons/regular/wheat.svg");
const wheelchair_move_svg_1 = require("../src/icons/regular/wheelchair-move.svg");
const wheelchair_svg_1 = require("../src/icons/regular/wheelchair.svg");
const whiskey_glass_ice_svg_1 = require("../src/icons/regular/whiskey-glass-ice.svg");
const whiskey_glass_svg_1 = require("../src/icons/regular/whiskey-glass.svg");
const whistle_svg_1 = require("../src/icons/regular/whistle.svg");
const wifi_exclamation_svg_1 = require("../src/icons/regular/wifi-exclamation.svg");
const wifi_fair_svg_1 = require("../src/icons/regular/wifi-fair.svg");
const wifi_slash_svg_1 = require("../src/icons/regular/wifi-slash.svg");
const wifi_weak_svg_1 = require("../src/icons/regular/wifi-weak.svg");
const wifi_svg_1 = require("../src/icons/regular/wifi.svg");
const wind_turbine_svg_1 = require("../src/icons/regular/wind-turbine.svg");
const wind_warning_svg_1 = require("../src/icons/regular/wind-warning.svg");
const wind_svg_1 = require("../src/icons/regular/wind.svg");
const window_flip_svg_1 = require("../src/icons/regular/window-flip.svg");
const window_frame_open_svg_1 = require("../src/icons/regular/window-frame-open.svg");
const window_frame_svg_1 = require("../src/icons/regular/window-frame.svg");
const window_maximize_svg_1 = require("../src/icons/regular/window-maximize.svg");
const window_minimize_svg_1 = require("../src/icons/regular/window-minimize.svg");
const window_restore_svg_1 = require("../src/icons/regular/window-restore.svg");
const window_svg_1 = require("../src/icons/regular/window.svg");
const windsock_svg_1 = require("../src/icons/regular/windsock.svg");
const wine_bottle_svg_1 = require("../src/icons/regular/wine-bottle.svg");
const wine_glass_crack_svg_1 = require("../src/icons/regular/wine-glass-crack.svg");
const wine_glass_empty_svg_1 = require("../src/icons/regular/wine-glass-empty.svg");
const wine_glass_svg_1 = require("../src/icons/regular/wine-glass.svg");
const won_sign_svg_1 = require("../src/icons/regular/won-sign.svg");
const wreath_svg_1 = require("../src/icons/regular/wreath.svg");
const wrench_simple_svg_1 = require("../src/icons/regular/wrench-simple.svg");
const wrench_svg_1 = require("../src/icons/regular/wrench.svg");
const x_ray_svg_1 = require("../src/icons/regular/x-ray.svg");
const x_svg_1 = require("../src/icons/regular/x.svg");
const xmark_to_slot_svg_1 = require("../src/icons/regular/xmark-to-slot.svg");
const xmark_svg_1 = require("../src/icons/regular/xmark.svg");
const y_svg_1 = require("../src/icons/regular/y.svg");
const yen_sign_svg_1 = require("../src/icons/regular/yen-sign.svg");
const yin_yang_svg_1 = require("../src/icons/regular/yin-yang.svg");
const z_svg_1 = require("../src/icons/regular/z.svg");
const _0_svg_2 = require("../src/icons/solid/0.svg");
const _1_svg_2 = require("../src/icons/solid/1.svg");
const _2_svg_2 = require("../src/icons/solid/2.svg");
const _3_svg_2 = require("../src/icons/solid/3.svg");
const _4_svg_2 = require("../src/icons/solid/4.svg");
const _5_svg_2 = require("../src/icons/solid/5.svg");
const _6_svg_2 = require("../src/icons/solid/6.svg");
const _7_svg_2 = require("../src/icons/solid/7.svg");
const _8_svg_2 = require("../src/icons/solid/8.svg");
const _9_svg_2 = require("../src/icons/solid/9.svg");
const a_svg_2 = require("../src/icons/solid/a.svg");
const abacus_svg_2 = require("../src/icons/solid/abacus.svg");
const acorn_svg_2 = require("../src/icons/solid/acorn.svg");
const address_book_svg_2 = require("../src/icons/solid/address-book.svg");
const address_card_svg_2 = require("../src/icons/solid/address-card.svg");
const air_conditioner_svg_2 = require("../src/icons/solid/air-conditioner.svg");
const air_freshener_svg_2 = require("../src/icons/solid/air-freshener.svg");
const airplay_svg_2 = require("../src/icons/solid/airplay.svg");
const alarm_clock_svg_2 = require("../src/icons/solid/alarm-clock.svg");
const alarm_exclamation_svg_2 = require("../src/icons/solid/alarm-exclamation.svg");
const alarm_plus_svg_2 = require("../src/icons/solid/alarm-plus.svg");
const alarm_snooze_svg_2 = require("../src/icons/solid/alarm-snooze.svg");
const album_collection_svg_2 = require("../src/icons/solid/album-collection.svg");
const album_svg_2 = require("../src/icons/solid/album.svg");
const alicorn_svg_2 = require("../src/icons/solid/alicorn.svg");
const alien_8bit_svg_2 = require("../src/icons/solid/alien-8bit.svg");
const alien_svg_2 = require("../src/icons/solid/alien.svg");
const align_center_svg_2 = require("../src/icons/solid/align-center.svg");
const align_justify_svg_2 = require("../src/icons/solid/align-justify.svg");
const align_left_svg_2 = require("../src/icons/solid/align-left.svg");
const align_right_svg_2 = require("../src/icons/solid/align-right.svg");
const align_slash_svg_2 = require("../src/icons/solid/align-slash.svg");
const alt_svg_2 = require("../src/icons/solid/alt.svg");
const amp_guitar_svg_2 = require("../src/icons/solid/amp-guitar.svg");
const ampersand_svg_2 = require("../src/icons/solid/ampersand.svg");
const anchor_svg_2 = require("../src/icons/solid/anchor.svg");
const angel_svg_2 = require("../src/icons/solid/angel.svg");
const angle_90_svg_2 = require("../src/icons/solid/angle-90.svg");
const angle_down_svg_2 = require("../src/icons/solid/angle-down.svg");
const angle_left_svg_2 = require("../src/icons/solid/angle-left.svg");
const angle_right_svg_2 = require("../src/icons/solid/angle-right.svg");
const angle_up_svg_2 = require("../src/icons/solid/angle-up.svg");
const angle_svg_2 = require("../src/icons/solid/angle.svg");
const angles_down_svg_2 = require("../src/icons/solid/angles-down.svg");
const angles_left_svg_2 = require("../src/icons/solid/angles-left.svg");
const angles_right_svg_2 = require("../src/icons/solid/angles-right.svg");
const angles_up_svg_2 = require("../src/icons/solid/angles-up.svg");
const ankh_svg_2 = require("../src/icons/solid/ankh.svg");
const aperture_svg_2 = require("../src/icons/solid/aperture.svg");
const apple_core_svg_2 = require("../src/icons/solid/apple-core.svg");
const apple_crate_svg_2 = require("../src/icons/solid/apple-crate.svg");
const apple_whole_svg_2 = require("../src/icons/solid/apple-whole.svg");
const archway_svg_2 = require("../src/icons/solid/archway.svg");
const arrow_down_1_9_svg_2 = require("../src/icons/solid/arrow-down-1-9.svg");
const arrow_down_9_1_svg_2 = require("../src/icons/solid/arrow-down-9-1.svg");
const arrow_down_a_z_svg_2 = require("../src/icons/solid/arrow-down-a-z.svg");
const arrow_down_arrow_up_svg_2 = require("../src/icons/solid/arrow-down-arrow-up.svg");
const arrow_down_big_small_svg_2 = require("../src/icons/solid/arrow-down-big-small.svg");
const arrow_down_from_dotted_line_svg_2 = require("../src/icons/solid/arrow-down-from-dotted-line.svg");
const arrow_down_from_line_svg_2 = require("../src/icons/solid/arrow-down-from-line.svg");
const arrow_down_left_and_arrow_up_right_to_center_svg_2 = require("../src/icons/solid/arrow-down-left-and-arrow-up-right-to-center.svg");
const arrow_down_left_svg_2 = require("../src/icons/solid/arrow-down-left.svg");
const arrow_down_long_svg_2 = require("../src/icons/solid/arrow-down-long.svg");
const arrow_down_right_svg_2 = require("../src/icons/solid/arrow-down-right.svg");
const arrow_down_short_wide_svg_2 = require("../src/icons/solid/arrow-down-short-wide.svg");
const arrow_down_small_big_svg_2 = require("../src/icons/solid/arrow-down-small-big.svg");
const arrow_down_square_triangle_svg_2 = require("../src/icons/solid/arrow-down-square-triangle.svg");
const arrow_down_to_bracket_svg_2 = require("../src/icons/solid/arrow-down-to-bracket.svg");
const arrow_down_to_dotted_line_svg_2 = require("../src/icons/solid/arrow-down-to-dotted-line.svg");
const arrow_down_to_line_svg_2 = require("../src/icons/solid/arrow-down-to-line.svg");
const arrow_down_to_square_svg_2 = require("../src/icons/solid/arrow-down-to-square.svg");
const arrow_down_triangle_square_svg_2 = require("../src/icons/solid/arrow-down-triangle-square.svg");
const arrow_down_wide_short_svg_2 = require("../src/icons/solid/arrow-down-wide-short.svg");
const arrow_down_z_a_svg_2 = require("../src/icons/solid/arrow-down-z-a.svg");
const arrow_down_svg_2 = require("../src/icons/solid/arrow-down.svg");
const arrow_left_from_line_svg_2 = require("../src/icons/solid/arrow-left-from-line.svg");
const arrow_left_long_svg_2 = require("../src/icons/solid/arrow-left-long.svg");
const arrow_left_rotate_svg_2 = require("../src/icons/solid/arrow-left-rotate.svg");
const arrow_left_to_line_svg_2 = require("../src/icons/solid/arrow-left-to-line.svg");
const arrow_left_svg_2 = require("../src/icons/solid/arrow-left.svg");
const arrow_pointer_svg_2 = require("../src/icons/solid/arrow-pointer.svg");
const arrow_right_arrow_left_svg_2 = require("../src/icons/solid/arrow-right-arrow-left.svg");
const arrow_right_from_bracket_svg_2 = require("../src/icons/solid/arrow-right-from-bracket.svg");
const arrow_right_from_line_svg_2 = require("../src/icons/solid/arrow-right-from-line.svg");
const arrow_right_long_svg_2 = require("../src/icons/solid/arrow-right-long.svg");
const arrow_right_to_bracket_svg_2 = require("../src/icons/solid/arrow-right-to-bracket.svg");
const arrow_right_to_line_svg_2 = require("../src/icons/solid/arrow-right-to-line.svg");
const arrow_right_svg_2 = require("../src/icons/solid/arrow-right.svg");
const arrow_rotate_forward_svg_2 = require("../src/icons/solid/arrow-rotate-forward.svg");
const arrow_trend_down_svg_2 = require("../src/icons/solid/arrow-trend-down.svg");
const arrow_trend_up_svg_2 = require("../src/icons/solid/arrow-trend-up.svg");
const arrow_turn_down_svg_2 = require("../src/icons/solid/arrow-turn-down.svg");
const arrow_turn_up_svg_2 = require("../src/icons/solid/arrow-turn-up.svg");
const arrow_up_1_9_svg_2 = require("../src/icons/solid/arrow-up-1-9.svg");
const arrow_up_9_1_svg_2 = require("../src/icons/solid/arrow-up-9-1.svg");
const arrow_up_a_z_svg_2 = require("../src/icons/solid/arrow-up-a-z.svg");
const arrow_up_arrow_down_svg_2 = require("../src/icons/solid/arrow-up-arrow-down.svg");
const arrow_up_big_small_svg_2 = require("../src/icons/solid/arrow-up-big-small.svg");
const arrow_up_from_bracket_svg_2 = require("../src/icons/solid/arrow-up-from-bracket.svg");
const arrow_up_from_dotted_line_svg_2 = require("../src/icons/solid/arrow-up-from-dotted-line.svg");
const arrow_up_from_line_svg_2 = require("../src/icons/solid/arrow-up-from-line.svg");
const arrow_up_from_square_svg_2 = require("../src/icons/solid/arrow-up-from-square.svg");
const arrow_up_left_from_circle_svg_2 = require("../src/icons/solid/arrow-up-left-from-circle.svg");
const arrow_up_left_svg_2 = require("../src/icons/solid/arrow-up-left.svg");
const arrow_up_long_svg_2 = require("../src/icons/solid/arrow-up-long.svg");
const arrow_up_right_and_arrow_down_left_from_center_svg_2 = require("../src/icons/solid/arrow-up-right-and-arrow-down-left-from-center.svg");
const arrow_up_right_from_square_svg_2 = require("../src/icons/solid/arrow-up-right-from-square.svg");
const arrow_up_right_svg_2 = require("../src/icons/solid/arrow-up-right.svg");
const arrow_up_short_wide_svg_2 = require("../src/icons/solid/arrow-up-short-wide.svg");
const arrow_up_small_big_svg_2 = require("../src/icons/solid/arrow-up-small-big.svg");
const arrow_up_square_triangle_svg_2 = require("../src/icons/solid/arrow-up-square-triangle.svg");
const arrow_up_to_dotted_line_svg_2 = require("../src/icons/solid/arrow-up-to-dotted-line.svg");
const arrow_up_to_line_svg_2 = require("../src/icons/solid/arrow-up-to-line.svg");
const arrow_up_triangle_square_svg_2 = require("../src/icons/solid/arrow-up-triangle-square.svg");
const arrow_up_wide_short_svg_2 = require("../src/icons/solid/arrow-up-wide-short.svg");
const arrow_up_z_a_svg_2 = require("../src/icons/solid/arrow-up-z-a.svg");
const arrow_up_svg_2 = require("../src/icons/solid/arrow-up.svg");
const arrows_cross_svg_2 = require("../src/icons/solid/arrows-cross.svg");
const arrows_from_dotted_line_svg_2 = require("../src/icons/solid/arrows-from-dotted-line.svg");
const arrows_from_line_svg_2 = require("../src/icons/solid/arrows-from-line.svg");
const arrows_left_right_svg_2 = require("../src/icons/solid/arrows-left-right.svg");
const arrows_maximize_svg_2 = require("../src/icons/solid/arrows-maximize.svg");
const arrows_minimize_svg_2 = require("../src/icons/solid/arrows-minimize.svg");
const arrows_repeat_1_svg_2 = require("../src/icons/solid/arrows-repeat-1.svg");
const arrows_repeat_svg_2 = require("../src/icons/solid/arrows-repeat.svg");
const arrows_retweet_svg_2 = require("../src/icons/solid/arrows-retweet.svg");
const arrows_rotate_svg_2 = require("../src/icons/solid/arrows-rotate.svg");
const arrows_to_dotted_line_svg_2 = require("../src/icons/solid/arrows-to-dotted-line.svg");
const arrows_to_line_svg_2 = require("../src/icons/solid/arrows-to-line.svg");
const arrows_up_down_left_right_svg_2 = require("../src/icons/solid/arrows-up-down-left-right.svg");
const arrows_up_down_svg_2 = require("../src/icons/solid/arrows-up-down.svg");
const asterisk_svg_2 = require("../src/icons/solid/asterisk.svg");
const at_svg_2 = require("../src/icons/solid/at.svg");
const atom_simple_svg_2 = require("../src/icons/solid/atom-simple.svg");
const atom_svg_2 = require("../src/icons/solid/atom.svg");
const audio_description_slash_svg_2 = require("../src/icons/solid/audio-description-slash.svg");
const audio_description_svg_2 = require("../src/icons/solid/audio-description.svg");
const austral_sign_svg_2 = require("../src/icons/solid/austral-sign.svg");
const avocado_svg_2 = require("../src/icons/solid/avocado.svg");
const award_simple_svg_2 = require("../src/icons/solid/award-simple.svg");
const award_svg_2 = require("../src/icons/solid/award.svg");
const axe_battle_svg_2 = require("../src/icons/solid/axe-battle.svg");
const axe_svg_2 = require("../src/icons/solid/axe.svg");
const b_svg_2 = require("../src/icons/solid/b.svg");
const baby_carriage_svg_2 = require("../src/icons/solid/baby-carriage.svg");
const baby_svg_2 = require("../src/icons/solid/baby.svg");
const backpack_svg_2 = require("../src/icons/solid/backpack.svg");
const backward_fast_svg_2 = require("../src/icons/solid/backward-fast.svg");
const backward_step_svg_2 = require("../src/icons/solid/backward-step.svg");
const backward_svg_2 = require("../src/icons/solid/backward.svg");
const bacon_svg_2 = require("../src/icons/solid/bacon.svg");
const bacteria_svg_2 = require("../src/icons/solid/bacteria.svg");
const bacterium_svg_2 = require("../src/icons/solid/bacterium.svg");
const badge_check_svg_2 = require("../src/icons/solid/badge-check.svg");
const badge_dollar_svg_2 = require("../src/icons/solid/badge-dollar.svg");
const badge_percent_svg_2 = require("../src/icons/solid/badge-percent.svg");
const badge_sheriff_svg_2 = require("../src/icons/solid/badge-sheriff.svg");
const badge_svg_2 = require("../src/icons/solid/badge.svg");
const badger_honey_svg_2 = require("../src/icons/solid/badger-honey.svg");
const bag_shopping_svg_2 = require("../src/icons/solid/bag-shopping.svg");
const bags_shopping_svg_2 = require("../src/icons/solid/bags-shopping.svg");
const bahai_svg_2 = require("../src/icons/solid/bahai.svg");
const baht_sign_svg_2 = require("../src/icons/solid/baht-sign.svg");
const ball_pile_svg_2 = require("../src/icons/solid/ball-pile.svg");
const ballot_check_svg_2 = require("../src/icons/solid/ballot-check.svg");
const ballot_svg_2 = require("../src/icons/solid/ballot.svg");
const ban_bug_svg_2 = require("../src/icons/solid/ban-bug.svg");
const ban_parking_svg_2 = require("../src/icons/solid/ban-parking.svg");
const ban_smoking_svg_2 = require("../src/icons/solid/ban-smoking.svg");
const ban_svg_2 = require("../src/icons/solid/ban.svg");
const bandage_svg_2 = require("../src/icons/solid/bandage.svg");
const banjo_svg_2 = require("../src/icons/solid/banjo.svg");
const bank_svg_2 = require("../src/icons/solid/bank.svg");
const barcode_read_svg_2 = require("../src/icons/solid/barcode-read.svg");
const barcode_scan_svg_2 = require("../src/icons/solid/barcode-scan.svg");
const barcode_svg_2 = require("../src/icons/solid/barcode.svg");
const bars_filter_svg_2 = require("../src/icons/solid/bars-filter.svg");
const bars_progress_svg_2 = require("../src/icons/solid/bars-progress.svg");
const bars_sort_svg_2 = require("../src/icons/solid/bars-sort.svg");
const bars_staggered_svg_2 = require("../src/icons/solid/bars-staggered.svg");
const bars_svg_2 = require("../src/icons/solid/bars.svg");
const baseball_ball_svg_2 = require("../src/icons/solid/baseball-ball.svg");
const baseball_bat_ball_svg_2 = require("../src/icons/solid/baseball-bat-ball.svg");
const basket_shopping_simple_svg_2 = require("../src/icons/solid/basket-shopping-simple.svg");
const basket_shopping_svg_2 = require("../src/icons/solid/basket-shopping.svg");
const basketball_ball_svg_2 = require("../src/icons/solid/basketball-ball.svg");
const basketball_hoop_svg_2 = require("../src/icons/solid/basketball-hoop.svg");
const bat_svg_2 = require("../src/icons/solid/bat.svg");
const bath_svg_2 = require("../src/icons/solid/bath.svg");
const battery_bolt_svg_2 = require("../src/icons/solid/battery-bolt.svg");
const battery_empty_svg_2 = require("../src/icons/solid/battery-empty.svg");
const battery_exclamation_svg_2 = require("../src/icons/solid/battery-exclamation.svg");
const battery_full_svg_2 = require("../src/icons/solid/battery-full.svg");
const battery_half_svg_2 = require("../src/icons/solid/battery-half.svg");
const battery_low_svg_2 = require("../src/icons/solid/battery-low.svg");
const battery_quarter_svg_2 = require("../src/icons/solid/battery-quarter.svg");
const battery_slash_svg_2 = require("../src/icons/solid/battery-slash.svg");
const battery_three_quarters_svg_2 = require("../src/icons/solid/battery-three-quarters.svg");
const bed_bunk_svg_2 = require("../src/icons/solid/bed-bunk.svg");
const bed_empty_svg_2 = require("../src/icons/solid/bed-empty.svg");
const bed_front_svg_2 = require("../src/icons/solid/bed-front.svg");
const bed_pulse_svg_2 = require("../src/icons/solid/bed-pulse.svg");
const bed_svg_2 = require("../src/icons/solid/bed.svg");
const bee_svg_2 = require("../src/icons/solid/bee.svg");
const beer_mug_empty_svg_2 = require("../src/icons/solid/beer-mug-empty.svg");
const beer_mug_svg_2 = require("../src/icons/solid/beer-mug.svg");
const bell_concierge_svg_2 = require("../src/icons/solid/bell-concierge.svg");
const bell_exclamation_svg_2 = require("../src/icons/solid/bell-exclamation.svg");
const bell_on_svg_2 = require("../src/icons/solid/bell-on.svg");
const bell_plus_svg_2 = require("../src/icons/solid/bell-plus.svg");
const bell_school_slash_svg_2 = require("../src/icons/solid/bell-school-slash.svg");
const bell_school_svg_2 = require("../src/icons/solid/bell-school.svg");
const bell_slash_svg_2 = require("../src/icons/solid/bell-slash.svg");
const bell_svg_2 = require("../src/icons/solid/bell.svg");
const bells_svg_2 = require("../src/icons/solid/bells.svg");
const bezier_curve_svg_2 = require("../src/icons/solid/bezier-curve.svg");
const bicycle_svg_2 = require("../src/icons/solid/bicycle.svg");
const binoculars_svg_2 = require("../src/icons/solid/binoculars.svg");
const biohazard_svg_2 = require("../src/icons/solid/biohazard.svg");
const bitcoin_sign_svg_2 = require("../src/icons/solid/bitcoin-sign.svg");
const blanket_svg_2 = require("../src/icons/solid/blanket.svg");
const blender_phone_svg_2 = require("../src/icons/solid/blender-phone.svg");
const blender_svg_2 = require("../src/icons/solid/blender.svg");
const blinds_open_svg_2 = require("../src/icons/solid/blinds-open.svg");
const blinds_raised_svg_2 = require("../src/icons/solid/blinds-raised.svg");
const blinds_svg_2 = require("../src/icons/solid/blinds.svg");
const block_quote_svg_2 = require("../src/icons/solid/block-quote.svg");
const blog_svg_2 = require("../src/icons/solid/blog.svg");
const bluetooth_svg_3 = require("../src/icons/solid/bluetooth.svg");
const bold_svg_2 = require("../src/icons/solid/bold.svg");
const bolt_auto_svg_2 = require("../src/icons/solid/bolt-auto.svg");
const bolt_lightning_svg_2 = require("../src/icons/solid/bolt-lightning.svg");
const bolt_slash_svg_2 = require("../src/icons/solid/bolt-slash.svg");
const bolt_svg_2 = require("../src/icons/solid/bolt.svg");
const bomb_svg_2 = require("../src/icons/solid/bomb.svg");
const bone_break_svg_2 = require("../src/icons/solid/bone-break.svg");
const bone_svg_2 = require("../src/icons/solid/bone.svg");
const bong_svg_2 = require("../src/icons/solid/bong.svg");
const book_arrow_right_svg_2 = require("../src/icons/solid/book-arrow-right.svg");
const book_arrow_up_svg_2 = require("../src/icons/solid/book-arrow-up.svg");
const book_atlas_svg_2 = require("../src/icons/solid/book-atlas.svg");
const book_bible_svg_2 = require("../src/icons/solid/book-bible.svg");
const book_blank_svg_2 = require("../src/icons/solid/book-blank.svg");
const book_bookmark_svg_2 = require("../src/icons/solid/book-bookmark.svg");
const book_circle_arrow_right_svg_2 = require("../src/icons/solid/book-circle-arrow-right.svg");
const book_circle_arrow_up_svg_2 = require("../src/icons/solid/book-circle-arrow-up.svg");
const book_copy_svg_2 = require("../src/icons/solid/book-copy.svg");
const book_font_svg_2 = require("../src/icons/solid/book-font.svg");
const book_heart_svg_2 = require("../src/icons/solid/book-heart.svg");
const book_journal_whills_svg_2 = require("../src/icons/solid/book-journal-whills.svg");
const book_law_svg_2 = require("../src/icons/solid/book-law.svg");
const book_medical_svg_2 = require("../src/icons/solid/book-medical.svg");
const book_open_cover_svg_2 = require("../src/icons/solid/book-open-cover.svg");
const book_open_reader_svg_2 = require("../src/icons/solid/book-open-reader.svg");
const book_open_svg_2 = require("../src/icons/solid/book-open.svg");
const book_quran_svg_2 = require("../src/icons/solid/book-quran.svg");
const book_section_svg_2 = require("../src/icons/solid/book-section.svg");
const book_skull_svg_2 = require("../src/icons/solid/book-skull.svg");
const book_sparkles_svg_2 = require("../src/icons/solid/book-sparkles.svg");
const book_tanakh_svg_2 = require("../src/icons/solid/book-tanakh.svg");
const book_user_svg_2 = require("../src/icons/solid/book-user.svg");
const book_svg_2 = require("../src/icons/solid/book.svg");
const bookmark_slash_svg_2 = require("../src/icons/solid/bookmark-slash.svg");
const bookmark_svg_2 = require("../src/icons/solid/bookmark.svg");
const books_medical_svg_2 = require("../src/icons/solid/books-medical.svg");
const books_svg_2 = require("../src/icons/solid/books.svg");
const boombox_svg_2 = require("../src/icons/solid/boombox.svg");
const boot_svg_2 = require("../src/icons/solid/boot.svg");
const booth_curtain_svg_2 = require("../src/icons/solid/booth-curtain.svg");
const border_all_svg_2 = require("../src/icons/solid/border-all.svg");
const border_bottom_right_svg_2 = require("../src/icons/solid/border-bottom-right.svg");
const border_bottom_svg_2 = require("../src/icons/solid/border-bottom.svg");
const border_center_h_svg_2 = require("../src/icons/solid/border-center-h.svg");
const border_center_v_svg_2 = require("../src/icons/solid/border-center-v.svg");
const border_inner_svg_2 = require("../src/icons/solid/border-inner.svg");
const border_left_svg_2 = require("../src/icons/solid/border-left.svg");
const border_none_svg_2 = require("../src/icons/solid/border-none.svg");
const border_outer_svg_2 = require("../src/icons/solid/border-outer.svg");
const border_right_svg_2 = require("../src/icons/solid/border-right.svg");
const border_top_left_svg_2 = require("../src/icons/solid/border-top-left.svg");
const border_top_svg_2 = require("../src/icons/solid/border-top.svg");
const bow_arrow_svg_2 = require("../src/icons/solid/bow-arrow.svg");
const bowl_hot_svg_2 = require("../src/icons/solid/bowl-hot.svg");
const bowling_ball_pin_svg_2 = require("../src/icons/solid/bowling-ball-pin.svg");
const bowling_ball_svg_2 = require("../src/icons/solid/bowling-ball.svg");
const bowling_pins_svg_2 = require("../src/icons/solid/bowling-pins.svg");
const box_archive_svg_2 = require("../src/icons/solid/box-archive.svg");
const box_ballot_svg_2 = require("../src/icons/solid/box-ballot.svg");
const box_check_svg_2 = require("../src/icons/solid/box-check.svg");
const box_circle_check_svg_2 = require("../src/icons/solid/box-circle-check.svg");
const box_dollar_svg_2 = require("../src/icons/solid/box-dollar.svg");
const box_heart_svg_2 = require("../src/icons/solid/box-heart.svg");
const box_open_full_svg_2 = require("../src/icons/solid/box-open-full.svg");
const box_open_svg_2 = require("../src/icons/solid/box-open.svg");
const box_taped_svg_2 = require("../src/icons/solid/box-taped.svg");
const box_tissue_svg_2 = require("../src/icons/solid/box-tissue.svg");
const box_svg_2 = require("../src/icons/solid/box.svg");
const boxes_stacked_svg_2 = require("../src/icons/solid/boxes-stacked.svg");
const boxing_glove_svg_2 = require("../src/icons/solid/boxing-glove.svg");
const bracket_curly_right_svg_2 = require("../src/icons/solid/bracket-curly-right.svg");
const bracket_curly_svg_2 = require("../src/icons/solid/bracket-curly.svg");
const bracket_round_right_svg_2 = require("../src/icons/solid/bracket-round-right.svg");
const bracket_round_svg_2 = require("../src/icons/solid/bracket-round.svg");
const bracket_square_right_svg_2 = require("../src/icons/solid/bracket-square-right.svg");
const bracket_square_svg_2 = require("../src/icons/solid/bracket-square.svg");
const brackets_curly_svg_2 = require("../src/icons/solid/brackets-curly.svg");
const brackets_round_svg_2 = require("../src/icons/solid/brackets-round.svg");
const brackets_square_svg_2 = require("../src/icons/solid/brackets-square.svg");
const braille_svg_2 = require("../src/icons/solid/braille.svg");
const brain_arrow_curved_right_svg_2 = require("../src/icons/solid/brain-arrow-curved-right.svg");
const brain_circuit_svg_2 = require("../src/icons/solid/brain-circuit.svg");
const brain_svg_2 = require("../src/icons/solid/brain.svg");
const brake_warning_svg_2 = require("../src/icons/solid/brake-warning.svg");
const bread_loaf_svg_2 = require("../src/icons/solid/bread-loaf.svg");
const bread_slice_svg_2 = require("../src/icons/solid/bread-slice.svg");
const briefcase_arrow_right_svg_2 = require("../src/icons/solid/briefcase-arrow-right.svg");
const briefcase_clock_svg_2 = require("../src/icons/solid/briefcase-clock.svg");
const briefcase_medical_svg_2 = require("../src/icons/solid/briefcase-medical.svg");
const briefcase_svg_2 = require("../src/icons/solid/briefcase.svg");
const bring_forward_svg_2 = require("../src/icons/solid/bring-forward.svg");
const bring_front_svg_2 = require("../src/icons/solid/bring-front.svg");
const broom_svg_2 = require("../src/icons/solid/broom.svg");
const browser_svg_2 = require("../src/icons/solid/browser.svg");
const browsers_svg_2 = require("../src/icons/solid/browsers.svg");
const brush_svg_2 = require("../src/icons/solid/brush.svg");
const bug_svg_2 = require("../src/icons/solid/bug.svg");
const building_svg_2 = require("../src/icons/solid/building.svg");
const buildings_svg_2 = require("../src/icons/solid/buildings.svg");
const bullhorn_svg_2 = require("../src/icons/solid/bullhorn.svg");
const bullseye_arrow_svg_2 = require("../src/icons/solid/bullseye-arrow.svg");
const bullseye_pointer_svg_2 = require("../src/icons/solid/bullseye-pointer.svg");
const bullseye_svg_2 = require("../src/icons/solid/bullseye.svg");
const burger_cheese_svg_2 = require("../src/icons/solid/burger-cheese.svg");
const burger_fries_svg_2 = require("../src/icons/solid/burger-fries.svg");
const burger_glass_svg_2 = require("../src/icons/solid/burger-glass.svg");
const burger_soda_svg_2 = require("../src/icons/solid/burger-soda.svg");
const burger_svg_2 = require("../src/icons/solid/burger.svg");
const burrito_svg_2 = require("../src/icons/solid/burrito.svg");
const bus_school_svg_2 = require("../src/icons/solid/bus-school.svg");
const bus_simple_svg_2 = require("../src/icons/solid/bus-simple.svg");
const bus_svg_2 = require("../src/icons/solid/bus.svg");
const c_svg_2 = require("../src/icons/solid/c.svg");
const cabinet_filing_svg_2 = require("../src/icons/solid/cabinet-filing.svg");
const cable_car_svg_2 = require("../src/icons/solid/cable-car.svg");
const cactus_svg_2 = require("../src/icons/solid/cactus.svg");
const cake_candles_svg_2 = require("../src/icons/solid/cake-candles.svg");
const calculator_simple_svg_2 = require("../src/icons/solid/calculator-simple.svg");
const calculator_svg_2 = require("../src/icons/solid/calculator.svg");
const calendar_arrow_down_svg_2 = require("../src/icons/solid/calendar-arrow-down.svg");
const calendar_arrow_up_svg_2 = require("../src/icons/solid/calendar-arrow-up.svg");
const calendar_check_svg_2 = require("../src/icons/solid/calendar-check.svg");
const calendar_clock_svg_2 = require("../src/icons/solid/calendar-clock.svg");
const calendar_day_svg_2 = require("../src/icons/solid/calendar-day.svg");
const calendar_days_svg_2 = require("../src/icons/solid/calendar-days.svg");
const calendar_exclamation_svg_2 = require("../src/icons/solid/calendar-exclamation.svg");
const calendar_heart_svg_2 = require("../src/icons/solid/calendar-heart.svg");
const calendar_image_svg_2 = require("../src/icons/solid/calendar-image.svg");
const calendar_lines_svg_2 = require("../src/icons/solid/calendar-lines.svg");
const calendar_minus_svg_2 = require("../src/icons/solid/calendar-minus.svg");
const calendar_pen_svg_2 = require("../src/icons/solid/calendar-pen.svg");
const calendar_plus_svg_2 = require("../src/icons/solid/calendar-plus.svg");
const calendar_range_svg_2 = require("../src/icons/solid/calendar-range.svg");
const calendar_star_svg_2 = require("../src/icons/solid/calendar-star.svg");
const calendar_week_svg_2 = require("../src/icons/solid/calendar-week.svg");
const calendar_xmark_svg_2 = require("../src/icons/solid/calendar-xmark.svg");
const calendar_svg_2 = require("../src/icons/solid/calendar.svg");
const calendars_svg_2 = require("../src/icons/solid/calendars.svg");
const camcorder_svg_2 = require("../src/icons/solid/camcorder.svg");
const camera_cctv_svg_2 = require("../src/icons/solid/camera-cctv.svg");
const camera_movie_svg_2 = require("../src/icons/solid/camera-movie.svg");
const camera_polaroid_svg_2 = require("../src/icons/solid/camera-polaroid.svg");
const camera_retro_svg_2 = require("../src/icons/solid/camera-retro.svg");
const camera_rotate_svg_2 = require("../src/icons/solid/camera-rotate.svg");
const camera_security_svg_2 = require("../src/icons/solid/camera-security.svg");
const camera_slash_svg_2 = require("../src/icons/solid/camera-slash.svg");
const camera_viewfinder_svg_2 = require("../src/icons/solid/camera-viewfinder.svg");
const camera_web_slash_svg_2 = require("../src/icons/solid/camera-web-slash.svg");
const camera_web_svg_2 = require("../src/icons/solid/camera-web.svg");
const camera_svg_2 = require("../src/icons/solid/camera.svg");
const campfire_svg_2 = require("../src/icons/solid/campfire.svg");
const campground_svg_2 = require("../src/icons/solid/campground.svg");
const candle_holder_svg_2 = require("../src/icons/solid/candle-holder.svg");
const candy_cane_svg_2 = require("../src/icons/solid/candy-cane.svg");
const candy_corn_svg_2 = require("../src/icons/solid/candy-corn.svg");
const cannabis_svg_2 = require("../src/icons/solid/cannabis.svg");
const capsules_svg_2 = require("../src/icons/solid/capsules.svg");
const car_battery_svg_2 = require("../src/icons/solid/car-battery.svg");
const car_building_svg_2 = require("../src/icons/solid/car-building.svg");
const car_bump_svg_2 = require("../src/icons/solid/car-bump.svg");
const car_bus_svg_2 = require("../src/icons/solid/car-bus.svg");
const car_crash_svg_2 = require("../src/icons/solid/car-crash.svg");
const car_garage_svg_2 = require("../src/icons/solid/car-garage.svg");
const car_rear_svg_2 = require("../src/icons/solid/car-rear.svg");
const car_side_svg_2 = require("../src/icons/solid/car-side.svg");
const car_tilt_svg_2 = require("../src/icons/solid/car-tilt.svg");
const car_wash_svg_2 = require("../src/icons/solid/car-wash.svg");
const car_wrench_svg_2 = require("../src/icons/solid/car-wrench.svg");
const car_svg_2 = require("../src/icons/solid/car.svg");
const caravan_simple_svg_2 = require("../src/icons/solid/caravan-simple.svg");
const caravan_svg_2 = require("../src/icons/solid/caravan.svg");
const caret_down_svg_2 = require("../src/icons/solid/caret-down.svg");
const caret_left_svg_2 = require("../src/icons/solid/caret-left.svg");
const caret_right_svg_2 = require("../src/icons/solid/caret-right.svg");
const caret_up_svg_2 = require("../src/icons/solid/caret-up.svg");
const carrot_svg_2 = require("../src/icons/solid/carrot.svg");
const cars_svg_2 = require("../src/icons/solid/cars.svg");
const cart_arrow_down_svg_2 = require("../src/icons/solid/cart-arrow-down.svg");
const cart_flatbed_boxes_svg_2 = require("../src/icons/solid/cart-flatbed-boxes.svg");
const cart_flatbed_empty_svg_2 = require("../src/icons/solid/cart-flatbed-empty.svg");
const cart_flatbed_suitcase_svg_2 = require("../src/icons/solid/cart-flatbed-suitcase.svg");
const cart_flatbed_svg_2 = require("../src/icons/solid/cart-flatbed.svg");
const cart_plus_svg_2 = require("../src/icons/solid/cart-plus.svg");
const cart_shopping_fast_svg_2 = require("../src/icons/solid/cart-shopping-fast.svg");
const cart_shopping_svg_2 = require("../src/icons/solid/cart-shopping.svg");
const casette_betamax_svg_2 = require("../src/icons/solid/casette-betamax.svg");
const casette_vhs_svg_2 = require("../src/icons/solid/casette-vhs.svg");
const cash_register_svg_2 = require("../src/icons/solid/cash-register.svg");
const cassette_tape_svg_2 = require("../src/icons/solid/cassette-tape.svg");
const castle_svg_2 = require("../src/icons/solid/castle.svg");
const cat_space_svg_2 = require("../src/icons/solid/cat-space.svg");
const cat_svg_2 = require("../src/icons/solid/cat.svg");
const cauldron_svg_2 = require("../src/icons/solid/cauldron.svg");
const cedi_sign_svg_2 = require("../src/icons/solid/cedi-sign.svg");
const cent_sign_svg_2 = require("../src/icons/solid/cent-sign.svg");
const certificate_svg_2 = require("../src/icons/solid/certificate.svg");
const chair_office_svg_2 = require("../src/icons/solid/chair-office.svg");
const chair_svg_2 = require("../src/icons/solid/chair.svg");
const chalkboard_user_svg_2 = require("../src/icons/solid/chalkboard-user.svg");
const chalkboard_svg_2 = require("../src/icons/solid/chalkboard.svg");
const champagne_glass_svg_2 = require("../src/icons/solid/champagne-glass.svg");
const champagne_glasses_svg_2 = require("../src/icons/solid/champagne-glasses.svg");
const charging_station_svg_2 = require("../src/icons/solid/charging-station.svg");
const chart_area_svg_2 = require("../src/icons/solid/chart-area.svg");
const chart_bar_svg_2 = require("../src/icons/solid/chart-bar.svg");
const chart_bullet_svg_2 = require("../src/icons/solid/chart-bullet.svg");
const chart_candlestick_svg_2 = require("../src/icons/solid/chart-candlestick.svg");
const chart_column_svg_2 = require("../src/icons/solid/chart-column.svg");
const chart_gantt_svg_2 = require("../src/icons/solid/chart-gantt.svg");
const chart_line_down_svg_2 = require("../src/icons/solid/chart-line-down.svg");
const chart_line_up_svg_2 = require("../src/icons/solid/chart-line-up.svg");
const chart_line_svg_2 = require("../src/icons/solid/chart-line.svg");
const chart_mixed_svg_2 = require("../src/icons/solid/chart-mixed.svg");
const chart_network_svg_2 = require("../src/icons/solid/chart-network.svg");
const chart_pie_simple_svg_2 = require("../src/icons/solid/chart-pie-simple.svg");
const chart_pie_svg_2 = require("../src/icons/solid/chart-pie.svg");
const chart_pyramid_svg_2 = require("../src/icons/solid/chart-pyramid.svg");
const chart_radar_svg_2 = require("../src/icons/solid/chart-radar.svg");
const chart_scatter_3d_svg_2 = require("../src/icons/solid/chart-scatter-3d.svg");
const chart_scatter_bubble_svg_2 = require("../src/icons/solid/chart-scatter-bubble.svg");
const chart_scatter_svg_2 = require("../src/icons/solid/chart-scatter.svg");
const chart_tree_map_svg_2 = require("../src/icons/solid/chart-tree-map.svg");
const chart_user_svg_2 = require("../src/icons/solid/chart-user.svg");
const chart_waterfall_svg_2 = require("../src/icons/solid/chart-waterfall.svg");
const check_double_svg_2 = require("../src/icons/solid/check-double.svg");
const check_to_slot_svg_2 = require("../src/icons/solid/check-to-slot.svg");
const check_svg_2 = require("../src/icons/solid/check.svg");
const cheese_swiss_svg_2 = require("../src/icons/solid/cheese-swiss.svg");
const cheese_svg_2 = require("../src/icons/solid/cheese.svg");
const cherries_svg_2 = require("../src/icons/solid/cherries.svg");
const chess_bishop_piece_svg_2 = require("../src/icons/solid/chess-bishop-piece.svg");
const chess_bishop_svg_2 = require("../src/icons/solid/chess-bishop.svg");
const chess_board_svg_2 = require("../src/icons/solid/chess-board.svg");
const chess_clock_flip_svg_2 = require("../src/icons/solid/chess-clock-flip.svg");
const chess_clock_svg_2 = require("../src/icons/solid/chess-clock.svg");
const chess_king_piece_svg_2 = require("../src/icons/solid/chess-king-piece.svg");
const chess_king_svg_2 = require("../src/icons/solid/chess-king.svg");
const chess_knight_piece_svg_2 = require("../src/icons/solid/chess-knight-piece.svg");
const chess_knight_svg_2 = require("../src/icons/solid/chess-knight.svg");
const chess_pawn_piece_svg_2 = require("../src/icons/solid/chess-pawn-piece.svg");
const chess_pawn_svg_2 = require("../src/icons/solid/chess-pawn.svg");
const chess_queen_piece_svg_2 = require("../src/icons/solid/chess-queen-piece.svg");
const chess_queen_svg_2 = require("../src/icons/solid/chess-queen.svg");
const chess_rook_piece_svg_2 = require("../src/icons/solid/chess-rook-piece.svg");
const chess_rook_svg_2 = require("../src/icons/solid/chess-rook.svg");
const chess_svg_2 = require("../src/icons/solid/chess.svg");
const chevron_down_svg_2 = require("../src/icons/solid/chevron-down.svg");
const chevron_left_svg_2 = require("../src/icons/solid/chevron-left.svg");
const chevron_right_svg_2 = require("../src/icons/solid/chevron-right.svg");
const chevron_up_svg_2 = require("../src/icons/solid/chevron-up.svg");
const chevrons_down_svg_2 = require("../src/icons/solid/chevrons-down.svg");
const chevrons_left_svg_2 = require("../src/icons/solid/chevrons-left.svg");
const chevrons_right_svg_2 = require("../src/icons/solid/chevrons-right.svg");
const chevrons_up_svg_2 = require("../src/icons/solid/chevrons-up.svg");
const child_svg_2 = require("../src/icons/solid/child.svg");
const chimney_svg_2 = require("../src/icons/solid/chimney.svg");
const church_svg_2 = require("../src/icons/solid/church.svg");
const circle_0_svg_2 = require("../src/icons/solid/circle-0.svg");
const circle_1_svg_2 = require("../src/icons/solid/circle-1.svg");
const circle_2_svg_2 = require("../src/icons/solid/circle-2.svg");
const circle_3_svg_2 = require("../src/icons/solid/circle-3.svg");
const circle_4_svg_2 = require("../src/icons/solid/circle-4.svg");
const circle_5_svg_2 = require("../src/icons/solid/circle-5.svg");
const circle_6_svg_2 = require("../src/icons/solid/circle-6.svg");
const circle_7_svg_2 = require("../src/icons/solid/circle-7.svg");
const circle_8_svg_2 = require("../src/icons/solid/circle-8.svg");
const circle_9_svg_2 = require("../src/icons/solid/circle-9.svg");
const circle_a_svg_2 = require("../src/icons/solid/circle-a.svg");
const circle_ampersand_svg_2 = require("../src/icons/solid/circle-ampersand.svg");
const circle_arrow_down_left_svg_2 = require("../src/icons/solid/circle-arrow-down-left.svg");
const circle_arrow_down_right_svg_2 = require("../src/icons/solid/circle-arrow-down-right.svg");
const circle_arrow_down_svg_2 = require("../src/icons/solid/circle-arrow-down.svg");
const circle_arrow_left_svg_2 = require("../src/icons/solid/circle-arrow-left.svg");
const circle_arrow_right_svg_2 = require("../src/icons/solid/circle-arrow-right.svg");
const circle_arrow_up_left_svg_2 = require("../src/icons/solid/circle-arrow-up-left.svg");
const circle_arrow_up_right_svg_2 = require("../src/icons/solid/circle-arrow-up-right.svg");
const circle_arrow_up_svg_2 = require("../src/icons/solid/circle-arrow-up.svg");
const circle_b_svg_2 = require("../src/icons/solid/circle-b.svg");
const circle_bolt_svg_2 = require("../src/icons/solid/circle-bolt.svg");
const circle_book_open_svg_2 = require("../src/icons/solid/circle-book-open.svg");
const circle_bookmark_svg_2 = require("../src/icons/solid/circle-bookmark.svg");
const circle_c_svg_2 = require("../src/icons/solid/circle-c.svg");
const circle_calendar_svg_2 = require("../src/icons/solid/circle-calendar.svg");
const circle_camera_svg_2 = require("../src/icons/solid/circle-camera.svg");
const circle_caret_down_svg_2 = require("../src/icons/solid/circle-caret-down.svg");
const circle_caret_left_svg_2 = require("../src/icons/solid/circle-caret-left.svg");
const circle_caret_right_svg_2 = require("../src/icons/solid/circle-caret-right.svg");
const circle_caret_up_svg_2 = require("../src/icons/solid/circle-caret-up.svg");
const circle_check_svg_2 = require("../src/icons/solid/circle-check.svg");
const circle_chevron_down_svg_2 = require("../src/icons/solid/circle-chevron-down.svg");
const circle_chevron_left_svg_2 = require("../src/icons/solid/circle-chevron-left.svg");
const circle_chevron_right_svg_2 = require("../src/icons/solid/circle-chevron-right.svg");
const circle_chevron_up_svg_2 = require("../src/icons/solid/circle-chevron-up.svg");
const circle_d_svg_2 = require("../src/icons/solid/circle-d.svg");
const circle_dashed_svg_2 = require("../src/icons/solid/circle-dashed.svg");
const circle_divide_svg_2 = require("../src/icons/solid/circle-divide.svg");
const circle_dollar_to_slot_svg_2 = require("../src/icons/solid/circle-dollar-to-slot.svg");
const circle_dollar_svg_2 = require("../src/icons/solid/circle-dollar.svg");
const circle_dot_svg_2 = require("../src/icons/solid/circle-dot.svg");
const circle_down_left_svg_2 = require("../src/icons/solid/circle-down-left.svg");
const circle_down_right_svg_2 = require("../src/icons/solid/circle-down-right.svg");
const circle_down_svg_2 = require("../src/icons/solid/circle-down.svg");
const circle_e_svg_2 = require("../src/icons/solid/circle-e.svg");
const circle_envelope_svg_2 = require("../src/icons/solid/circle-envelope.svg");
const circle_exclamation_check_svg_2 = require("../src/icons/solid/circle-exclamation-check.svg");
const circle_exclamation_svg_2 = require("../src/icons/solid/circle-exclamation.svg");
const circle_f_svg_2 = require("../src/icons/solid/circle-f.svg");
const circle_g_svg_2 = require("../src/icons/solid/circle-g.svg");
const circle_h_svg_2 = require("../src/icons/solid/circle-h.svg");
const circle_half_stroke_svg_2 = require("../src/icons/solid/circle-half-stroke.svg");
const circle_half_svg_2 = require("../src/icons/solid/circle-half.svg");
const circle_heart_svg_2 = require("../src/icons/solid/circle-heart.svg");
const circle_i_svg_2 = require("../src/icons/solid/circle-i.svg");
const circle_info_svg_2 = require("../src/icons/solid/circle-info.svg");
const circle_j_svg_2 = require("../src/icons/solid/circle-j.svg");
const circle_k_svg_2 = require("../src/icons/solid/circle-k.svg");
const circle_l_svg_2 = require("../src/icons/solid/circle-l.svg");
const circle_left_svg_2 = require("../src/icons/solid/circle-left.svg");
const circle_location_arrow_svg_2 = require("../src/icons/solid/circle-location-arrow.svg");
const circle_m_svg_2 = require("../src/icons/solid/circle-m.svg");
const circle_microphone_lines_svg_2 = require("../src/icons/solid/circle-microphone-lines.svg");
const circle_microphone_svg_2 = require("../src/icons/solid/circle-microphone.svg");
const circle_minus_svg_2 = require("../src/icons/solid/circle-minus.svg");
const circle_n_svg_2 = require("../src/icons/solid/circle-n.svg");
const circle_notch_svg_2 = require("../src/icons/solid/circle-notch.svg");
const circle_o_svg_2 = require("../src/icons/solid/circle-o.svg");
const circle_p_svg_2 = require("../src/icons/solid/circle-p.svg");
const circle_parking_svg_2 = require("../src/icons/solid/circle-parking.svg");
const circle_pause_svg_2 = require("../src/icons/solid/circle-pause.svg");
const circle_phone_flip_svg_2 = require("../src/icons/solid/circle-phone-flip.svg");
const circle_phone_hangup_svg_2 = require("../src/icons/solid/circle-phone-hangup.svg");
const circle_phone_svg_2 = require("../src/icons/solid/circle-phone.svg");
const circle_play_svg_2 = require("../src/icons/solid/circle-play.svg");
const circle_plus_svg_2 = require("../src/icons/solid/circle-plus.svg");
const circle_q_svg_2 = require("../src/icons/solid/circle-q.svg");
const circle_quarter_svg_2 = require("../src/icons/solid/circle-quarter.svg");
const circle_question_svg_2 = require("../src/icons/solid/circle-question.svg");
const circle_r_svg_2 = require("../src/icons/solid/circle-r.svg");
const circle_radiation_svg_2 = require("../src/icons/solid/circle-radiation.svg");
const circle_right_svg_2 = require("../src/icons/solid/circle-right.svg");
const circle_s_svg_2 = require("../src/icons/solid/circle-s.svg");
const circle_small_svg_2 = require("../src/icons/solid/circle-small.svg");
const circle_sort_down_svg_2 = require("../src/icons/solid/circle-sort-down.svg");
const circle_sort_up_svg_2 = require("../src/icons/solid/circle-sort-up.svg");
const circle_sort_svg_2 = require("../src/icons/solid/circle-sort.svg");
const circle_star_svg_2 = require("../src/icons/solid/circle-star.svg");
const circle_stop_svg_2 = require("../src/icons/solid/circle-stop.svg");
const circle_t_svg_2 = require("../src/icons/solid/circle-t.svg");
const circle_three_quarters_svg_2 = require("../src/icons/solid/circle-three-quarters.svg");
const circle_trash_svg_2 = require("../src/icons/solid/circle-trash.svg");
const circle_u_svg_2 = require("../src/icons/solid/circle-u.svg");
const circle_up_left_svg_2 = require("../src/icons/solid/circle-up-left.svg");
const circle_up_right_svg_2 = require("../src/icons/solid/circle-up-right.svg");
const circle_up_svg_2 = require("../src/icons/solid/circle-up.svg");
const circle_user_svg_2 = require("../src/icons/solid/circle-user.svg");
const circle_v_svg_2 = require("../src/icons/solid/circle-v.svg");
const circle_video_svg_2 = require("../src/icons/solid/circle-video.svg");
const circle_w_svg_2 = require("../src/icons/solid/circle-w.svg");
const circle_waveform_lines_svg_2 = require("../src/icons/solid/circle-waveform-lines.svg");
const circle_x_svg_2 = require("../src/icons/solid/circle-x.svg");
const circle_xmark_svg_2 = require("../src/icons/solid/circle-xmark.svg");
const circle_y_svg_2 = require("../src/icons/solid/circle-y.svg");
const circle_z_svg_2 = require("../src/icons/solid/circle-z.svg");
const circle_svg_2 = require("../src/icons/solid/circle.svg");
const city_svg_2 = require("../src/icons/solid/city.svg");
const clapperboard_play_svg_2 = require("../src/icons/solid/clapperboard-play.svg");
const clapperboard_svg_2 = require("../src/icons/solid/clapperboard.svg");
const clarinet_svg_2 = require("../src/icons/solid/clarinet.svg");
const claw_marks_svg_2 = require("../src/icons/solid/claw-marks.svg");
const clipboard_check_svg_2 = require("../src/icons/solid/clipboard-check.svg");
const clipboard_list_check_svg_2 = require("../src/icons/solid/clipboard-list-check.svg");
const clipboard_list_svg_2 = require("../src/icons/solid/clipboard-list.svg");
const clipboard_medical_svg_2 = require("../src/icons/solid/clipboard-medical.svg");
const clipboard_prescription_svg_2 = require("../src/icons/solid/clipboard-prescription.svg");
const clipboard_user_svg_2 = require("../src/icons/solid/clipboard-user.svg");
const clipboard_svg_2 = require("../src/icons/solid/clipboard.svg");
const clock_desk_svg_2 = require("../src/icons/solid/clock-desk.svg");
const clock_rotate_left_svg_2 = require("../src/icons/solid/clock-rotate-left.svg");
const clock_svg_2 = require("../src/icons/solid/clock.svg");
const clone_svg_2 = require("../src/icons/solid/clone.svg");
const closed_captioning_slash_svg_2 = require("../src/icons/solid/closed-captioning-slash.svg");
const closed_captioning_svg_2 = require("../src/icons/solid/closed-captioning.svg");
const clothes_hanger_svg_2 = require("../src/icons/solid/clothes-hanger.svg");
const cloud_arrow_down_svg_2 = require("../src/icons/solid/cloud-arrow-down.svg");
const cloud_arrow_up_svg_2 = require("../src/icons/solid/cloud-arrow-up.svg");
const cloud_bolt_moon_svg_2 = require("../src/icons/solid/cloud-bolt-moon.svg");
const cloud_bolt_sun_svg_2 = require("../src/icons/solid/cloud-bolt-sun.svg");
const cloud_bolt_svg_2 = require("../src/icons/solid/cloud-bolt.svg");
const cloud_drizzle_svg_2 = require("../src/icons/solid/cloud-drizzle.svg");
const cloud_fog_svg_2 = require("../src/icons/solid/cloud-fog.svg");
const cloud_hail_mixed_svg_2 = require("../src/icons/solid/cloud-hail-mixed.svg");
const cloud_hail_svg_2 = require("../src/icons/solid/cloud-hail.svg");
const cloud_meatball_svg_2 = require("../src/icons/solid/cloud-meatball.svg");
const cloud_moon_rain_svg_2 = require("../src/icons/solid/cloud-moon-rain.svg");
const cloud_moon_svg_2 = require("../src/icons/solid/cloud-moon.svg");
const cloud_music_svg_2 = require("../src/icons/solid/cloud-music.svg");
const cloud_rain_svg_2 = require("../src/icons/solid/cloud-rain.svg");
const cloud_rainbow_svg_2 = require("../src/icons/solid/cloud-rainbow.svg");
const cloud_showers_heavy_svg_2 = require("../src/icons/solid/cloud-showers-heavy.svg");
const cloud_showers_svg_2 = require("../src/icons/solid/cloud-showers.svg");
const cloud_slash_svg_2 = require("../src/icons/solid/cloud-slash.svg");
const cloud_sleet_svg_2 = require("../src/icons/solid/cloud-sleet.svg");
const cloud_snow_svg_2 = require("../src/icons/solid/cloud-snow.svg");
const cloud_sun_rain_svg_2 = require("../src/icons/solid/cloud-sun-rain.svg");
const cloud_sun_svg_2 = require("../src/icons/solid/cloud-sun.svg");
const cloud_word_svg_2 = require("../src/icons/solid/cloud-word.svg");
const cloud_svg_2 = require("../src/icons/solid/cloud.svg");
const clouds_moon_svg_2 = require("../src/icons/solid/clouds-moon.svg");
const clouds_sun_svg_2 = require("../src/icons/solid/clouds-sun.svg");
const clouds_svg_2 = require("../src/icons/solid/clouds.svg");
const clover_svg_2 = require("../src/icons/solid/clover.svg");
const club_svg_2 = require("../src/icons/solid/club.svg");
const code_branch_svg_2 = require("../src/icons/solid/code-branch.svg");
const code_commit_svg_2 = require("../src/icons/solid/code-commit.svg");
const code_compare_svg_2 = require("../src/icons/solid/code-compare.svg");
const code_fork_svg_2 = require("../src/icons/solid/code-fork.svg");
const code_merge_svg_2 = require("../src/icons/solid/code-merge.svg");
const code_pull_request_svg_2 = require("../src/icons/solid/code-pull-request.svg");
const code_simple_svg_2 = require("../src/icons/solid/code-simple.svg");
const code_svg_2 = require("../src/icons/solid/code.svg");
const coffee_bean_svg_2 = require("../src/icons/solid/coffee-bean.svg");
const coffee_beans_svg_2 = require("../src/icons/solid/coffee-beans.svg");
const coffee_pot_svg_2 = require("../src/icons/solid/coffee-pot.svg");
const coffin_cross_svg_2 = require("../src/icons/solid/coffin-cross.svg");
const coffin_svg_2 = require("../src/icons/solid/coffin.svg");
const coin_svg_2 = require("../src/icons/solid/coin.svg");
const coins_svg_2 = require("../src/icons/solid/coins.svg");
const colon_sign_svg_2 = require("../src/icons/solid/colon-sign.svg");
const comet_svg_2 = require("../src/icons/solid/comet.svg");
const command_svg_2 = require("../src/icons/solid/command.svg");
const comment_arrow_down_svg_2 = require("../src/icons/solid/comment-arrow-down.svg");
const comment_arrow_up_right_svg_2 = require("../src/icons/solid/comment-arrow-up-right.svg");
const comment_arrow_up_svg_2 = require("../src/icons/solid/comment-arrow-up.svg");
const comment_captions_svg_2 = require("../src/icons/solid/comment-captions.svg");
const comment_check_svg_2 = require("../src/icons/solid/comment-check.svg");
const comment_code_svg_2 = require("../src/icons/solid/comment-code.svg");
const comment_dollar_svg_2 = require("../src/icons/solid/comment-dollar.svg");
const comment_dots_svg_2 = require("../src/icons/solid/comment-dots.svg");
const comment_exclamation_svg_2 = require("../src/icons/solid/comment-exclamation.svg");
const comment_image_svg_2 = require("../src/icons/solid/comment-image.svg");
const comment_lines_svg_2 = require("../src/icons/solid/comment-lines.svg");
const comment_medical_svg_2 = require("../src/icons/solid/comment-medical.svg");
const comment_middle_top_svg_2 = require("../src/icons/solid/comment-middle-top.svg");
const comment_middle_svg_2 = require("../src/icons/solid/comment-middle.svg");
const comment_minus_svg_2 = require("../src/icons/solid/comment-minus.svg");
const comment_music_svg_2 = require("../src/icons/solid/comment-music.svg");
const comment_pen_svg_2 = require("../src/icons/solid/comment-pen.svg");
const comment_plus_svg_2 = require("../src/icons/solid/comment-plus.svg");
const comment_question_svg_2 = require("../src/icons/solid/comment-question.svg");
const comment_quote_svg_2 = require("../src/icons/solid/comment-quote.svg");
const comment_slash_svg_2 = require("../src/icons/solid/comment-slash.svg");
const comment_smile_svg_2 = require("../src/icons/solid/comment-smile.svg");
const comment_sms_svg_2 = require("../src/icons/solid/comment-sms.svg");
const comment_text_svg_2 = require("../src/icons/solid/comment-text.svg");
const comment_xmark_svg_2 = require("../src/icons/solid/comment-xmark.svg");
const comment_svg_2 = require("../src/icons/solid/comment.svg");
const comments_dollar_svg_2 = require("../src/icons/solid/comments-dollar.svg");
const comments_question_check_svg_2 = require("../src/icons/solid/comments-question-check.svg");
const comments_question_svg_2 = require("../src/icons/solid/comments-question.svg");
const comments_svg_2 = require("../src/icons/solid/comments.svg");
const compact_disc_svg_2 = require("../src/icons/solid/compact-disc.svg");
const compass_drafting_svg_2 = require("../src/icons/solid/compass-drafting.svg");
const compass_slash_svg_2 = require("../src/icons/solid/compass-slash.svg");
const compass_svg_2 = require("../src/icons/solid/compass.svg");
const compress_wide_svg_2 = require("../src/icons/solid/compress-wide.svg");
const compress_svg_2 = require("../src/icons/solid/compress.svg");
const computer_classic_svg_2 = require("../src/icons/solid/computer-classic.svg");
const computer_mouse_scrollwheel_svg_2 = require("../src/icons/solid/computer-mouse-scrollwheel.svg");
const computer_mouse_svg_2 = require("../src/icons/solid/computer-mouse.svg");
const computer_speaker_svg_2 = require("../src/icons/solid/computer-speaker.svg");
const container_storage_svg_2 = require("../src/icons/solid/container-storage.svg");
const conveyor_belt_boxes_svg_2 = require("../src/icons/solid/conveyor-belt-boxes.svg");
const conveyor_belt_empty_svg_2 = require("../src/icons/solid/conveyor-belt-empty.svg");
const conveyor_belt_svg_2 = require("../src/icons/solid/conveyor-belt.svg");
const cookie_bite_svg_2 = require("../src/icons/solid/cookie-bite.svg");
const cookie_svg_2 = require("../src/icons/solid/cookie.svg");
const copy_svg_2 = require("../src/icons/solid/copy.svg");
const copyright_svg_2 = require("../src/icons/solid/copyright.svg");
const corn_svg_2 = require("../src/icons/solid/corn.svg");
const couch_svg_2 = require("../src/icons/solid/couch.svg");
const cow_svg_2 = require("../src/icons/solid/cow.svg");
const cowbell_circle_plus_svg_2 = require("../src/icons/solid/cowbell-circle-plus.svg");
const cowbell_svg_2 = require("../src/icons/solid/cowbell.svg");
const credit_card_blank_svg_2 = require("../src/icons/solid/credit-card-blank.svg");
const credit_card_front_svg_2 = require("../src/icons/solid/credit-card-front.svg");
const credit_card_svg_2 = require("../src/icons/solid/credit-card.svg");
const cricket_bat_ball_svg_2 = require("../src/icons/solid/cricket-bat-ball.svg");
const croissant_svg_2 = require("../src/icons/solid/croissant.svg");
const crop_simple_svg_2 = require("../src/icons/solid/crop-simple.svg");
const crop_svg_2 = require("../src/icons/solid/crop.svg");
const cross_svg_2 = require("../src/icons/solid/cross.svg");
const crosshairs_svg_2 = require("../src/icons/solid/crosshairs.svg");
const crow_svg_2 = require("../src/icons/solid/crow.svg");
const crown_svg_2 = require("../src/icons/solid/crown.svg");
const crutch_svg_2 = require("../src/icons/solid/crutch.svg");
const crutches_svg_2 = require("../src/icons/solid/crutches.svg");
const cruzeiro_sign_svg_2 = require("../src/icons/solid/cruzeiro-sign.svg");
const cube_svg_2 = require("../src/icons/solid/cube.svg");
const cubes_svg_2 = require("../src/icons/solid/cubes.svg");
const cup_togo_svg_2 = require("../src/icons/solid/cup-togo.svg");
const curling_stone_svg_2 = require("../src/icons/solid/curling-stone.svg");
const d_svg_2 = require("../src/icons/solid/d.svg");
const dagger_svg_2 = require("../src/icons/solid/dagger.svg");
const database_svg_2 = require("../src/icons/solid/database.svg");
const deer_rudolph_svg_2 = require("../src/icons/solid/deer-rudolph.svg");
const deer_svg_2 = require("../src/icons/solid/deer.svg");
const delete_left_svg_2 = require("../src/icons/solid/delete-left.svg");
const delete_right_svg_2 = require("../src/icons/solid/delete-right.svg");
const democrat_svg_2 = require("../src/icons/solid/democrat.svg");
const desktop_arrow_down_svg_2 = require("../src/icons/solid/desktop-arrow-down.svg");
const desktop_svg_2 = require("../src/icons/solid/desktop.svg");
const dharmachakra_svg_2 = require("../src/icons/solid/dharmachakra.svg");
const diagram_lean_canvas_svg_2 = require("../src/icons/solid/diagram-lean-canvas.svg");
const diagram_nested_svg_2 = require("../src/icons/solid/diagram-nested.svg");
const diagram_project_svg_2 = require("../src/icons/solid/diagram-project.svg");
const diagram_sankey_svg_2 = require("../src/icons/solid/diagram-sankey.svg");
const diagram_stankey_svg_2 = require("../src/icons/solid/diagram-stankey.svg");
const diagram_venn_svg_2 = require("../src/icons/solid/diagram-venn.svg");
const dial_high_svg_2 = require("../src/icons/solid/dial-high.svg");
const dial_low_svg_2 = require("../src/icons/solid/dial-low.svg");
const dial_max_svg_2 = require("../src/icons/solid/dial-max.svg");
const dial_med_low_svg_2 = require("../src/icons/solid/dial-med-low.svg");
const dial_med_svg_2 = require("../src/icons/solid/dial-med.svg");
const dial_min_svg_2 = require("../src/icons/solid/dial-min.svg");
const dial_svg_2 = require("../src/icons/solid/dial.svg");
const diamond_turn_right_svg_2 = require("../src/icons/solid/diamond-turn-right.svg");
const diamond_svg_2 = require("../src/icons/solid/diamond.svg");
const dice_d10_svg_2 = require("../src/icons/solid/dice-d10.svg");
const dice_d12_svg_2 = require("../src/icons/solid/dice-d12.svg");
const dice_d20_svg_2 = require("../src/icons/solid/dice-d20.svg");
const dice_d4_svg_2 = require("../src/icons/solid/dice-d4.svg");
const dice_d6_svg_2 = require("../src/icons/solid/dice-d6.svg");
const dice_d8_svg_2 = require("../src/icons/solid/dice-d8.svg");
const dice_five_svg_2 = require("../src/icons/solid/dice-five.svg");
const dice_four_svg_2 = require("../src/icons/solid/dice-four.svg");
const dice_one_svg_2 = require("../src/icons/solid/dice-one.svg");
const dice_six_svg_2 = require("../src/icons/solid/dice-six.svg");
const dice_three_svg_2 = require("../src/icons/solid/dice-three.svg");
const dice_two_svg_2 = require("../src/icons/solid/dice-two.svg");
const dice_svg_2 = require("../src/icons/solid/dice.svg");
const diploma_svg_2 = require("../src/icons/solid/diploma.svg");
const disc_drive_svg_2 = require("../src/icons/solid/disc-drive.svg");
const disease_svg_2 = require("../src/icons/solid/disease.svg");
const display_arrow_down_svg_2 = require("../src/icons/solid/display-arrow-down.svg");
const display_code_svg_2 = require("../src/icons/solid/display-code.svg");
const display_medical_svg_2 = require("../src/icons/solid/display-medical.svg");
const display_slash_svg_2 = require("../src/icons/solid/display-slash.svg");
const display_svg_2 = require("../src/icons/solid/display.svg");
const divide_svg_2 = require("../src/icons/solid/divide.svg");
const dna_svg_2 = require("../src/icons/solid/dna.svg");
const do_not_enter_svg_2 = require("../src/icons/solid/do-not-enter.svg");
const dog_leashed_svg_2 = require("../src/icons/solid/dog-leashed.svg");
const dog_svg_2 = require("../src/icons/solid/dog.svg");
const dollar_sign_svg_2 = require("../src/icons/solid/dollar-sign.svg");
const dolly_empty_svg_2 = require("../src/icons/solid/dolly-empty.svg");
const dolly_svg_2 = require("../src/icons/solid/dolly.svg");
const dolphin_svg_2 = require("../src/icons/solid/dolphin.svg");
const dong_sign_svg_2 = require("../src/icons/solid/dong-sign.svg");
const door_closed_svg_2 = require("../src/icons/solid/door-closed.svg");
const door_open_svg_2 = require("../src/icons/solid/door-open.svg");
const dove_svg_2 = require("../src/icons/solid/dove.svg");
const down_from_line_svg_2 = require("../src/icons/solid/down-from-line.svg");
const down_left_and_up_right_to_center_svg_2 = require("../src/icons/solid/down-left-and-up-right-to-center.svg");
const down_left_svg_2 = require("../src/icons/solid/down-left.svg");
const down_long_svg_2 = require("../src/icons/solid/down-long.svg");
const down_right_svg_2 = require("../src/icons/solid/down-right.svg");
const down_to_line_svg_2 = require("../src/icons/solid/down-to-line.svg");
const down_svg_2 = require("../src/icons/solid/down.svg");
const download_svg_2 = require("../src/icons/solid/download.svg");
const dragon_svg_2 = require("../src/icons/solid/dragon.svg");
const draw_circle_svg_2 = require("../src/icons/solid/draw-circle.svg");
const draw_polygon_svg_2 = require("../src/icons/solid/draw-polygon.svg");
const draw_square_svg_2 = require("../src/icons/solid/draw-square.svg");
const dreidel_svg_2 = require("../src/icons/solid/dreidel.svg");
const drone_front_svg_2 = require("../src/icons/solid/drone-front.svg");
const drone_svg_2 = require("../src/icons/solid/drone.svg");
const droplet_degree_svg_2 = require("../src/icons/solid/droplet-degree.svg");
const droplet_percent_svg_2 = require("../src/icons/solid/droplet-percent.svg");
const droplet_slash_svg_2 = require("../src/icons/solid/droplet-slash.svg");
const droplet_svg_2 = require("../src/icons/solid/droplet.svg");
const drum_steelpan_svg_2 = require("../src/icons/solid/drum-steelpan.svg");
const drum_svg_2 = require("../src/icons/solid/drum.svg");
const drumstick_bite_svg_2 = require("../src/icons/solid/drumstick-bite.svg");
const drumstick_svg_2 = require("../src/icons/solid/drumstick.svg");
const dryer_heat_svg_2 = require("../src/icons/solid/dryer-heat.svg");
const dryer_svg_2 = require("../src/icons/solid/dryer.svg");
const duck_svg_2 = require("../src/icons/solid/duck.svg");
const dumbbell_svg_2 = require("../src/icons/solid/dumbbell.svg");
const dumpster_fire_svg_2 = require("../src/icons/solid/dumpster-fire.svg");
const dumpster_svg_2 = require("../src/icons/solid/dumpster.svg");
const dungeon_svg_2 = require("../src/icons/solid/dungeon.svg");
const e_svg_2 = require("../src/icons/solid/e.svg");
const ear_deaf_svg_2 = require("../src/icons/solid/ear-deaf.svg");
const ear_listen_svg_2 = require("../src/icons/solid/ear-listen.svg");
const ear_muffs_svg_2 = require("../src/icons/solid/ear-muffs.svg");
const ear_svg_2 = require("../src/icons/solid/ear.svg");
const earth_africa_svg_2 = require("../src/icons/solid/earth-africa.svg");
const earth_americas_svg_2 = require("../src/icons/solid/earth-americas.svg");
const earth_asia_svg_2 = require("../src/icons/solid/earth-asia.svg");
const earth_europa_svg_2 = require("../src/icons/solid/earth-europa.svg");
const eclipse_svg_2 = require("../src/icons/solid/eclipse.svg");
const egg_fried_svg_2 = require("../src/icons/solid/egg-fried.svg");
const egg_svg_2 = require("../src/icons/solid/egg.svg");
const eggplant_svg_2 = require("../src/icons/solid/eggplant.svg");
const eject_svg_2 = require("../src/icons/solid/eject.svg");
const elephant_svg_2 = require("../src/icons/solid/elephant.svg");
const elevator_svg_2 = require("../src/icons/solid/elevator.svg");
const ellipsis_stroke_vertical_svg_2 = require("../src/icons/solid/ellipsis-stroke-vertical.svg");
const ellipsis_stroke_svg_2 = require("../src/icons/solid/ellipsis-stroke.svg");
const ellipsis_vertical_svg_2 = require("../src/icons/solid/ellipsis-vertical.svg");
const ellipsis_svg_2 = require("../src/icons/solid/ellipsis.svg");
const empty_set_svg_2 = require("../src/icons/solid/empty-set.svg");
const engine_warning_svg_2 = require("../src/icons/solid/engine-warning.svg");
const engine_svg_2 = require("../src/icons/solid/engine.svg");
const envelope_dot_svg_2 = require("../src/icons/solid/envelope-dot.svg");
const envelope_open_dollar_svg_2 = require("../src/icons/solid/envelope-open-dollar.svg");
const envelope_open_text_svg_2 = require("../src/icons/solid/envelope-open-text.svg");
const envelope_open_svg_2 = require("../src/icons/solid/envelope-open.svg");
const envelope_svg_2 = require("../src/icons/solid/envelope.svg");
const envelopes_bulk_svg_2 = require("../src/icons/solid/envelopes-bulk.svg");
const envelopes_svg_2 = require("../src/icons/solid/envelopes.svg");
const equals_svg_2 = require("../src/icons/solid/equals.svg");
const eraser_svg_2 = require("../src/icons/solid/eraser.svg");
const escalator_svg_2 = require("../src/icons/solid/escalator.svg");
const ethernet_svg_2 = require("../src/icons/solid/ethernet.svg");
const euro_sign_svg_2 = require("../src/icons/solid/euro-sign.svg");
const exclamation_svg_2 = require("../src/icons/solid/exclamation.svg");
const expand_wide_svg_2 = require("../src/icons/solid/expand-wide.svg");
const expand_svg_2 = require("../src/icons/solid/expand.svg");
const eye_dropper_full_svg_2 = require("../src/icons/solid/eye-dropper-full.svg");
const eye_dropper_half_svg_2 = require("../src/icons/solid/eye-dropper-half.svg");
const eye_dropper_svg_2 = require("../src/icons/solid/eye-dropper.svg");
const eye_evil_svg_2 = require("../src/icons/solid/eye-evil.svg");
const eye_low_vision_svg_2 = require("../src/icons/solid/eye-low-vision.svg");
const eye_slash_svg_2 = require("../src/icons/solid/eye-slash.svg");
const eye_svg_2 = require("../src/icons/solid/eye.svg");
const f_svg_2 = require("../src/icons/solid/f.svg");
const face_angry_svg_2 = require("../src/icons/solid/face-angry.svg");
const face_dizzy_svg_2 = require("../src/icons/solid/face-dizzy.svg");
const face_flushed_svg_2 = require("../src/icons/solid/face-flushed.svg");
const face_frown_open_svg_2 = require("../src/icons/solid/face-frown-open.svg");
const face_frown_svg_2 = require("../src/icons/solid/face-frown.svg");
const face_grimace_svg_2 = require("../src/icons/solid/face-grimace.svg");
const face_grin_beam_sweat_svg_2 = require("../src/icons/solid/face-grin-beam-sweat.svg");
const face_grin_beam_svg_2 = require("../src/icons/solid/face-grin-beam.svg");
const face_grin_hearts_svg_2 = require("../src/icons/solid/face-grin-hearts.svg");
const face_grin_squint_tears_svg_2 = require("../src/icons/solid/face-grin-squint-tears.svg");
const face_grin_squint_svg_2 = require("../src/icons/solid/face-grin-squint.svg");
const face_grin_stars_svg_2 = require("../src/icons/solid/face-grin-stars.svg");
const face_grin_tears_svg_2 = require("../src/icons/solid/face-grin-tears.svg");
const face_grin_tongue_squint_svg_2 = require("../src/icons/solid/face-grin-tongue-squint.svg");
const face_grin_tongue_wink_svg_2 = require("../src/icons/solid/face-grin-tongue-wink.svg");
const face_grin_tongue_svg_2 = require("../src/icons/solid/face-grin-tongue.svg");
const face_grin_wide_svg_2 = require("../src/icons/solid/face-grin-wide.svg");
const face_grin_wink_svg_2 = require("../src/icons/solid/face-grin-wink.svg");
const face_grin_svg_2 = require("../src/icons/solid/face-grin.svg");
const face_kiss_beam_svg_2 = require("../src/icons/solid/face-kiss-beam.svg");
const face_kiss_wink_heart_svg_2 = require("../src/icons/solid/face-kiss-wink-heart.svg");
const face_kiss_svg_2 = require("../src/icons/solid/face-kiss.svg");
const face_laugh_beam_svg_2 = require("../src/icons/solid/face-laugh-beam.svg");
const face_laugh_squint_svg_2 = require("../src/icons/solid/face-laugh-squint.svg");
const face_laugh_wink_svg_2 = require("../src/icons/solid/face-laugh-wink.svg");
const face_laugh_svg_2 = require("../src/icons/solid/face-laugh.svg");
const face_meh_blank_svg_2 = require("../src/icons/solid/face-meh-blank.svg");
const face_meh_svg_2 = require("../src/icons/solid/face-meh.svg");
const face_rolling_eyes_svg_2 = require("../src/icons/solid/face-rolling-eyes.svg");
const face_sad_cry_svg_2 = require("../src/icons/solid/face-sad-cry.svg");
const face_sad_tear_svg_2 = require("../src/icons/solid/face-sad-tear.svg");
const face_smile_beam_svg_2 = require("../src/icons/solid/face-smile-beam.svg");
const face_smile_plus_svg_2 = require("../src/icons/solid/face-smile-plus.svg");
const face_smile_wink_svg_2 = require("../src/icons/solid/face-smile-wink.svg");
const face_smile_svg_2 = require("../src/icons/solid/face-smile.svg");
const face_surprise_svg_2 = require("../src/icons/solid/face-surprise.svg");
const face_tired_svg_2 = require("../src/icons/solid/face-tired.svg");
const fan_table_svg_2 = require("../src/icons/solid/fan-table.svg");
const fan_svg_2 = require("../src/icons/solid/fan.svg");
const farm_svg_2 = require("../src/icons/solid/farm.svg");
const faucet_drip_svg_2 = require("../src/icons/solid/faucet-drip.svg");
const faucet_svg_2 = require("../src/icons/solid/faucet.svg");
const fax_svg_2 = require("../src/icons/solid/fax.svg");
const feather_pointed_svg_2 = require("../src/icons/solid/feather-pointed.svg");
const feather_svg_2 = require("../src/icons/solid/feather.svg");
const fence_svg_2 = require("../src/icons/solid/fence.svg");
const field_hockey_stick_ball_svg_2 = require("../src/icons/solid/field-hockey-stick-ball.svg");
const file_arrow_down_svg_2 = require("../src/icons/solid/file-arrow-down.svg");
const file_arrow_up_svg_2 = require("../src/icons/solid/file-arrow-up.svg");
const file_audio_svg_2 = require("../src/icons/solid/file-audio.svg");
const file_binary_svg_2 = require("../src/icons/solid/file-binary.svg");
const file_certificate_svg_2 = require("../src/icons/solid/file-certificate.svg");
const file_chart_column_svg_2 = require("../src/icons/solid/file-chart-column.svg");
const file_chart_pie_svg_2 = require("../src/icons/solid/file-chart-pie.svg");
const file_check_svg_2 = require("../src/icons/solid/file-check.svg");
const file_code_svg_2 = require("../src/icons/solid/file-code.svg");
const file_contract_svg_2 = require("../src/icons/solid/file-contract.svg");
const file_csv_svg_2 = require("../src/icons/solid/file-csv.svg");
const file_dashed_line_svg_2 = require("../src/icons/solid/file-dashed-line.svg");
const file_excel_svg_2 = require("../src/icons/solid/file-excel.svg");
const file_exclamation_svg_2 = require("../src/icons/solid/file-exclamation.svg");
const file_export_svg_2 = require("../src/icons/solid/file-export.svg");
const file_heart_svg_2 = require("../src/icons/solid/file-heart.svg");
const file_image_svg_2 = require("../src/icons/solid/file-image.svg");
const file_import_svg_2 = require("../src/icons/solid/file-import.svg");
const file_invoice_dollar_svg_2 = require("../src/icons/solid/file-invoice-dollar.svg");
const file_invoice_svg_2 = require("../src/icons/solid/file-invoice.svg");
const file_lines_svg_2 = require("../src/icons/solid/file-lines.svg");
const file_magnifying_glass_svg_2 = require("../src/icons/solid/file-magnifying-glass.svg");
const file_medical_svg_2 = require("../src/icons/solid/file-medical.svg");
const file_minus_svg_2 = require("../src/icons/solid/file-minus.svg");
const file_music_svg_2 = require("../src/icons/solid/file-music.svg");
const file_pdf_svg_2 = require("../src/icons/solid/file-pdf.svg");
const file_pen_svg_2 = require("../src/icons/solid/file-pen.svg");
const file_plus_minus_svg_2 = require("../src/icons/solid/file-plus-minus.svg");
const file_plus_svg_2 = require("../src/icons/solid/file-plus.svg");
const file_powerpoint_svg_2 = require("../src/icons/solid/file-powerpoint.svg");
const file_prescription_svg_2 = require("../src/icons/solid/file-prescription.svg");
const file_signature_svg_2 = require("../src/icons/solid/file-signature.svg");
const file_spreadsheet_svg_2 = require("../src/icons/solid/file-spreadsheet.svg");
const file_user_svg_2 = require("../src/icons/solid/file-user.svg");
const file_video_svg_2 = require("../src/icons/solid/file-video.svg");
const file_waveform_svg_2 = require("../src/icons/solid/file-waveform.svg");
const file_word_svg_2 = require("../src/icons/solid/file-word.svg");
const file_xmark_svg_2 = require("../src/icons/solid/file-xmark.svg");
const file_zipper_svg_2 = require("../src/icons/solid/file-zipper.svg");
const file_svg_2 = require("../src/icons/solid/file.svg");
const files_medical_svg_2 = require("../src/icons/solid/files-medical.svg");
const files_svg_2 = require("../src/icons/solid/files.svg");
const fill_drip_svg_2 = require("../src/icons/solid/fill-drip.svg");
const fill_svg_2 = require("../src/icons/solid/fill.svg");
const film_canister_svg_2 = require("../src/icons/solid/film-canister.svg");
const film_simple_svg_2 = require("../src/icons/solid/film-simple.svg");
const film_slash_svg_2 = require("../src/icons/solid/film-slash.svg");
const film_svg_2 = require("../src/icons/solid/film.svg");
const films_svg_2 = require("../src/icons/solid/films.svg");
const filter_circle_dollar_svg_2 = require("../src/icons/solid/filter-circle-dollar.svg");
const filter_circle_xmark_svg_2 = require("../src/icons/solid/filter-circle-xmark.svg");
const filter_list_svg_2 = require("../src/icons/solid/filter-list.svg");
const filter_slash_svg_2 = require("../src/icons/solid/filter-slash.svg");
const filter_svg_2 = require("../src/icons/solid/filter.svg");
const filters_svg_2 = require("../src/icons/solid/filters.svg");
const fingerprint_svg_2 = require("../src/icons/solid/fingerprint.svg");
const fire_extinguisher_svg_2 = require("../src/icons/solid/fire-extinguisher.svg");
const fire_flame_curved_svg_2 = require("../src/icons/solid/fire-flame-curved.svg");
const fire_flame_simple_svg_2 = require("../src/icons/solid/fire-flame-simple.svg");
const fire_flame_svg_2 = require("../src/icons/solid/fire-flame.svg");
const fire_hydrant_svg_2 = require("../src/icons/solid/fire-hydrant.svg");
const fire_smoke_svg_2 = require("../src/icons/solid/fire-smoke.svg");
const fire_svg_2 = require("../src/icons/solid/fire.svg");
const fireplace_svg_2 = require("../src/icons/solid/fireplace.svg");
const fish_cooked_svg_2 = require("../src/icons/solid/fish-cooked.svg");
const fish_svg_2 = require("../src/icons/solid/fish.svg");
const flag_checkered_svg_2 = require("../src/icons/solid/flag-checkered.svg");
const flag_pennant_svg_2 = require("../src/icons/solid/flag-pennant.svg");
const flag_swallowtail_svg_2 = require("../src/icons/solid/flag-swallowtail.svg");
const flag_usa_svg_2 = require("../src/icons/solid/flag-usa.svg");
const flag_svg_2 = require("../src/icons/solid/flag.svg");
const flashlight_svg_2 = require("../src/icons/solid/flashlight.svg");
const flask_round_poison_svg_2 = require("../src/icons/solid/flask-round-poison.svg");
const flask_round_potion_svg_2 = require("../src/icons/solid/flask-round-potion.svg");
const flask_svg_2 = require("../src/icons/solid/flask.svg");
const floppy_disk_circle_arrow_right_svg_2 = require("../src/icons/solid/floppy-disk-circle-arrow-right.svg");
const floppy_disk_circle_xmark_svg_2 = require("../src/icons/solid/floppy-disk-circle-xmark.svg");
const floppy_disk_pen_svg_2 = require("../src/icons/solid/floppy-disk-pen.svg");
const floppy_disk_svg_2 = require("../src/icons/solid/floppy-disk.svg");
const floppy_disks_svg_2 = require("../src/icons/solid/floppy-disks.svg");
const florin_sign_svg_2 = require("../src/icons/solid/florin-sign.svg");
const flower_daffodil_svg_2 = require("../src/icons/solid/flower-daffodil.svg");
const flower_tulip_svg_2 = require("../src/icons/solid/flower-tulip.svg");
const flower_svg_2 = require("../src/icons/solid/flower.svg");
const flute_svg_2 = require("../src/icons/solid/flute.svg");
const flux_capacitor_svg_2 = require("../src/icons/solid/flux-capacitor.svg");
const folder_arrow_down_svg_2 = require("../src/icons/solid/folder-arrow-down.svg");
const folder_arrow_up_svg_2 = require("../src/icons/solid/folder-arrow-up.svg");
const folder_blank_svg_2 = require("../src/icons/solid/folder-blank.svg");
const folder_bookmark_svg_2 = require("../src/icons/solid/folder-bookmark.svg");
const folder_gear_svg_2 = require("../src/icons/solid/folder-gear.svg");
const folder_grid_svg_2 = require("../src/icons/solid/folder-grid.svg");
const folder_heart_svg_2 = require("../src/icons/solid/folder-heart.svg");
const folder_image_svg_2 = require("../src/icons/solid/folder-image.svg");
const folder_magnifying_glass_svg_2 = require("../src/icons/solid/folder-magnifying-glass.svg");
const folder_medical_svg_2 = require("../src/icons/solid/folder-medical.svg");
const folder_minus_svg_2 = require("../src/icons/solid/folder-minus.svg");
const folder_music_svg_2 = require("../src/icons/solid/folder-music.svg");
const folder_open_svg_2 = require("../src/icons/solid/folder-open.svg");
const folder_plus_svg_2 = require("../src/icons/solid/folder-plus.svg");
const folder_tree_svg_2 = require("../src/icons/solid/folder-tree.svg");
const folder_user_svg_2 = require("../src/icons/solid/folder-user.svg");
const folder_xmark_svg_2 = require("../src/icons/solid/folder-xmark.svg");
const folder_svg_2 = require("../src/icons/solid/folder.svg");
const folders_svg_2 = require("../src/icons/solid/folders.svg");
const font_awesome_svg_3 = require("../src/icons/solid/font-awesome.svg");
const font_case_svg_2 = require("../src/icons/solid/font-case.svg");
const font_svg_2 = require("../src/icons/solid/font.svg");
const football_ball_svg_2 = require("../src/icons/solid/football-ball.svg");
const football_helmet_svg_2 = require("../src/icons/solid/football-helmet.svg");
const fork_knife_svg_2 = require("../src/icons/solid/fork-knife.svg");
const fork_svg_2 = require("../src/icons/solid/fork.svg");
const forklift_svg_2 = require("../src/icons/solid/forklift.svg");
const forward_fast_svg_2 = require("../src/icons/solid/forward-fast.svg");
const forward_step_svg_2 = require("../src/icons/solid/forward-step.svg");
const forward_svg_2 = require("../src/icons/solid/forward.svg");
const franc_sign_svg_2 = require("../src/icons/solid/franc-sign.svg");
const french_fries_svg_2 = require("../src/icons/solid/french-fries.svg");
const frog_svg_2 = require("../src/icons/solid/frog.svg");
const function_svg_2 = require("../src/icons/solid/function.svg");
const futbol_ball_svg_2 = require("../src/icons/solid/futbol-ball.svg");
const g_svg_2 = require("../src/icons/solid/g.svg");
const galaxy_svg_2 = require("../src/icons/solid/galaxy.svg");
const game_board_simple_svg_2 = require("../src/icons/solid/game-board-simple.svg");
const game_board_svg_2 = require("../src/icons/solid/game-board.svg");
const game_console_handheld_svg_2 = require("../src/icons/solid/game-console-handheld.svg");
const gamepad_modern_svg_2 = require("../src/icons/solid/gamepad-modern.svg");
const gamepad_svg_2 = require("../src/icons/solid/gamepad.svg");
const garage_car_svg_2 = require("../src/icons/solid/garage-car.svg");
const garage_open_svg_2 = require("../src/icons/solid/garage-open.svg");
const garage_svg_2 = require("../src/icons/solid/garage.svg");
const gas_pump_slash_svg_2 = require("../src/icons/solid/gas-pump-slash.svg");
const gas_pump_svg_2 = require("../src/icons/solid/gas-pump.svg");
const gauge_low_svg_2 = require("../src/icons/solid/gauge-low.svg");
const gauge_max_svg_2 = require("../src/icons/solid/gauge-max.svg");
const gauge_med_svg_2 = require("../src/icons/solid/gauge-med.svg");
const gauge_min_svg_2 = require("../src/icons/solid/gauge-min.svg");
const gauge_simple_low_svg_2 = require("../src/icons/solid/gauge-simple-low.svg");
const gauge_simple_max_svg_2 = require("../src/icons/solid/gauge-simple-max.svg");
const gauge_simple_med_svg_2 = require("../src/icons/solid/gauge-simple-med.svg");
const gauge_simple_min_svg_2 = require("../src/icons/solid/gauge-simple-min.svg");
const gauge_simple_svg_2 = require("../src/icons/solid/gauge-simple.svg");
const gauge_svg_2 = require("../src/icons/solid/gauge.svg");
const gavel_svg_2 = require("../src/icons/solid/gavel.svg");
const gear_svg_2 = require("../src/icons/solid/gear.svg");
const gears_svg_2 = require("../src/icons/solid/gears.svg");
const gem_svg_2 = require("../src/icons/solid/gem.svg");
const genderless_svg_2 = require("../src/icons/solid/genderless.svg");
const ghost_svg_2 = require("../src/icons/solid/ghost.svg");
const gif_svg_2 = require("../src/icons/solid/gif.svg");
const gift_card_svg_2 = require("../src/icons/solid/gift-card.svg");
const gift_svg_2 = require("../src/icons/solid/gift.svg");
const gifts_svg_2 = require("../src/icons/solid/gifts.svg");
const gingerbread_man_svg_2 = require("../src/icons/solid/gingerbread-man.svg");
const glass_citrus_svg_2 = require("../src/icons/solid/glass-citrus.svg");
const glass_empty_svg_2 = require("../src/icons/solid/glass-empty.svg");
const glass_half_svg_2 = require("../src/icons/solid/glass-half.svg");
const glass_svg_2 = require("../src/icons/solid/glass.svg");
const glasses_round_svg_2 = require("../src/icons/solid/glasses-round.svg");
const glasses_svg_2 = require("../src/icons/solid/glasses.svg");
const globe_snow_svg_2 = require("../src/icons/solid/globe-snow.svg");
const globe_stand_svg_2 = require("../src/icons/solid/globe-stand.svg");
const globe_svg_2 = require("../src/icons/solid/globe.svg");
const golf_ball_tee_svg_2 = require("../src/icons/solid/golf-ball-tee.svg");
const golf_club_svg_2 = require("../src/icons/solid/golf-club.svg");
const gopuram_svg_2 = require("../src/icons/solid/gopuram.svg");
const graduation_cap_svg_2 = require("../src/icons/solid/graduation-cap.svg");
const gramophone_svg_2 = require("../src/icons/solid/gramophone.svg");
const grate_droplet_svg_2 = require("../src/icons/solid/grate-droplet.svg");
const grate_svg_2 = require("../src/icons/solid/grate.svg");
const greater_than_equal_svg_2 = require("../src/icons/solid/greater-than-equal.svg");
const greater_than_svg_2 = require("../src/icons/solid/greater-than.svg");
const grid_2_plus_svg_2 = require("../src/icons/solid/grid-2-plus.svg");
const grid_2_svg_2 = require("../src/icons/solid/grid-2.svg");
const grid_4_svg_2 = require("../src/icons/solid/grid-4.svg");
const grid_5_svg_2 = require("../src/icons/solid/grid-5.svg");
const grid_svg_2 = require("../src/icons/solid/grid.svg");
const grip_lines_vertical_svg_2 = require("../src/icons/solid/grip-lines-vertical.svg");
const grip_lines_svg_2 = require("../src/icons/solid/grip-lines.svg");
const grip_vertical_svg_2 = require("../src/icons/solid/grip-vertical.svg");
const grip_svg_2 = require("../src/icons/solid/grip.svg");
const guarani_sign_svg_2 = require("../src/icons/solid/guarani-sign.svg");
const guitar_electric_svg_2 = require("../src/icons/solid/guitar-electric.svg");
const guitar_svg_2 = require("../src/icons/solid/guitar.svg");
const guitars_svg_2 = require("../src/icons/solid/guitars.svg");
const gun_slash_svg_2 = require("../src/icons/solid/gun-slash.svg");
const gun_squirt_svg_2 = require("../src/icons/solid/gun-squirt.svg");
const gun_svg_2 = require("../src/icons/solid/gun.svg");
const h_svg_2 = require("../src/icons/solid/h.svg");
const h1_svg_2 = require("../src/icons/solid/h1.svg");
const h2_svg_2 = require("../src/icons/solid/h2.svg");
const h3_svg_2 = require("../src/icons/solid/h3.svg");
const h4_svg_2 = require("../src/icons/solid/h4.svg");
const hammer_war_svg_2 = require("../src/icons/solid/hammer-war.svg");
const hammer_svg_2 = require("../src/icons/solid/hammer.svg");
const hamsa_svg_2 = require("../src/icons/solid/hamsa.svg");
const hand_back_point_down_svg_2 = require("../src/icons/solid/hand-back-point-down.svg");
const hand_back_point_left_svg_2 = require("../src/icons/solid/hand-back-point-left.svg");
const hand_back_point_right_svg_2 = require("../src/icons/solid/hand-back-point-right.svg");
const hand_back_point_up_svg_2 = require("../src/icons/solid/hand-back-point-up.svg");
const hand_dots_svg_2 = require("../src/icons/solid/hand-dots.svg");
const hand_fingers_crossed_svg_2 = require("../src/icons/solid/hand-fingers-crossed.svg");
const hand_fist_svg_2 = require("../src/icons/solid/hand-fist.svg");
const hand_heart_svg_2 = require("../src/icons/solid/hand-heart.svg");
const hand_holding_box_svg_2 = require("../src/icons/solid/hand-holding-box.svg");
const hand_holding_dollar_svg_2 = require("../src/icons/solid/hand-holding-dollar.svg");
const hand_holding_droplet_svg_2 = require("../src/icons/solid/hand-holding-droplet.svg");
const hand_holding_heart_svg_2 = require("../src/icons/solid/hand-holding-heart.svg");
const hand_holding_magic_svg_2 = require("../src/icons/solid/hand-holding-magic.svg");
const hand_holding_medical_svg_2 = require("../src/icons/solid/hand-holding-medical.svg");
const hand_holding_seedling_svg_2 = require("../src/icons/solid/hand-holding-seedling.svg");
const hand_holding_skull_svg_2 = require("../src/icons/solid/hand-holding-skull.svg");
const hand_holding_svg_2 = require("../src/icons/solid/hand-holding.svg");
const hand_lizard_svg_2 = require("../src/icons/solid/hand-lizard.svg");
const hand_love_svg_2 = require("../src/icons/solid/hand-love.svg");
const hand_middle_finger_svg_2 = require("../src/icons/solid/hand-middle-finger.svg");
const hand_paper_svg_2 = require("../src/icons/solid/hand-paper.svg");
const hand_peace_svg_2 = require("../src/icons/solid/hand-peace.svg");
const hand_point_down_svg_2 = require("../src/icons/solid/hand-point-down.svg");
const hand_point_left_svg_2 = require("../src/icons/solid/hand-point-left.svg");
const hand_point_right_svg_2 = require("../src/icons/solid/hand-point-right.svg");
const hand_point_up_svg_2 = require("../src/icons/solid/hand-point-up.svg");
const hand_pointer_svg_2 = require("../src/icons/solid/hand-pointer.svg");
const hand_rock_svg_2 = require("../src/icons/solid/hand-rock.svg");
const hand_scissors_svg_2 = require("../src/icons/solid/hand-scissors.svg");
const hand_sparkles_svg_2 = require("../src/icons/solid/hand-sparkles.svg");
const hand_spock_svg_2 = require("../src/icons/solid/hand-spock.svg");
const hand_wave_svg_2 = require("../src/icons/solid/hand-wave.svg");
const hands_asl_interpreting_svg_2 = require("../src/icons/solid/hands-asl-interpreting.svg");
const hands_bubbles_svg_2 = require("../src/icons/solid/hands-bubbles.svg");
const hands_clapping_svg_2 = require("../src/icons/solid/hands-clapping.svg");
const hands_holding_diamond_svg_2 = require("../src/icons/solid/hands-holding-diamond.svg");
const hands_holding_dollar_svg_2 = require("../src/icons/solid/hands-holding-dollar.svg");
const hands_holding_heart_svg_2 = require("../src/icons/solid/hands-holding-heart.svg");
const hands_holding_svg_2 = require("../src/icons/solid/hands-holding.svg");
const hands_horns_svg_2 = require("../src/icons/solid/hands-horns.svg");
const hands_praying_svg_2 = require("../src/icons/solid/hands-praying.svg");
const hands_svg_2 = require("../src/icons/solid/hands.svg");
const handshake_angle_svg_2 = require("../src/icons/solid/handshake-angle.svg");
const handshake_simple_slash_svg_2 = require("../src/icons/solid/handshake-simple-slash.svg");
const handshake_simple_svg_2 = require("../src/icons/solid/handshake-simple.svg");
const handshake_slash_svg_2 = require("../src/icons/solid/handshake-slash.svg");
const handshake_svg_2 = require("../src/icons/solid/handshake.svg");
const hanukiah_svg_2 = require("../src/icons/solid/hanukiah.svg");
const hard_drive_svg_2 = require("../src/icons/solid/hard-drive.svg");
const hashtag_svg_2 = require("../src/icons/solid/hashtag.svg");
const hat_chef_svg_2 = require("../src/icons/solid/hat-chef.svg");
const hat_cowboy_side_svg_2 = require("../src/icons/solid/hat-cowboy-side.svg");
const hat_cowboy_svg_2 = require("../src/icons/solid/hat-cowboy.svg");
const hat_santa_svg_2 = require("../src/icons/solid/hat-santa.svg");
const hat_winter_svg_2 = require("../src/icons/solid/hat-winter.svg");
const hat_witch_svg_2 = require("../src/icons/solid/hat-witch.svg");
const hat_wizard_svg_2 = require("../src/icons/solid/hat-wizard.svg");
const head_side_brain_svg_2 = require("../src/icons/solid/head-side-brain.svg");
const head_side_cough_slash_svg_2 = require("../src/icons/solid/head-side-cough-slash.svg");
const head_side_cough_svg_2 = require("../src/icons/solid/head-side-cough.svg");
const head_side_goggles_svg_2 = require("../src/icons/solid/head-side-goggles.svg");
const head_side_headphones_svg_2 = require("../src/icons/solid/head-side-headphones.svg");
const head_side_heart_svg_2 = require("../src/icons/solid/head-side-heart.svg");
const head_side_mask_svg_2 = require("../src/icons/solid/head-side-mask.svg");
const head_side_medical_svg_2 = require("../src/icons/solid/head-side-medical.svg");
const head_side_virus_svg_2 = require("../src/icons/solid/head-side-virus.svg");
const head_side_svg_2 = require("../src/icons/solid/head-side.svg");
const heading_svg_2 = require("../src/icons/solid/heading.svg");
const headphones_simple_svg_2 = require("../src/icons/solid/headphones-simple.svg");
const headphones_svg_2 = require("../src/icons/solid/headphones.svg");
const headset_svg_2 = require("../src/icons/solid/headset.svg");
const heart_crack_svg_2 = require("../src/icons/solid/heart-crack.svg");
const heart_half_stroke_svg_2 = require("../src/icons/solid/heart-half-stroke.svg");
const heart_half_svg_2 = require("../src/icons/solid/heart-half.svg");
const heart_pulse_svg_2 = require("../src/icons/solid/heart-pulse.svg");
const heart_svg_2 = require("../src/icons/solid/heart.svg");
const heat_svg_2 = require("../src/icons/solid/heat.svg");
const helicopter_svg_2 = require("../src/icons/solid/helicopter.svg");
const helmet_battle_svg_2 = require("../src/icons/solid/helmet-battle.svg");
const helmet_safety_svg_2 = require("../src/icons/solid/helmet-safety.svg");
const hexagon_divide_svg_2 = require("../src/icons/solid/hexagon-divide.svg");
const hexagon_minus_svg_2 = require("../src/icons/solid/hexagon-minus.svg");
const hexagon_plus_svg_2 = require("../src/icons/solid/hexagon-plus.svg");
const hexagon_xmark_svg_2 = require("../src/icons/solid/hexagon-xmark.svg");
const hexagon_svg_2 = require("../src/icons/solid/hexagon.svg");
const high_definition_svg_2 = require("../src/icons/solid/high-definition.svg");
const highlighter_line_svg_2 = require("../src/icons/solid/highlighter-line.svg");
const highlighter_svg_2 = require("../src/icons/solid/highlighter.svg");
const hippo_svg_2 = require("../src/icons/solid/hippo.svg");
const hockey_mask_svg_2 = require("../src/icons/solid/hockey-mask.svg");
const hockey_puck_svg_2 = require("../src/icons/solid/hockey-puck.svg");
const hockey_sticks_svg_2 = require("../src/icons/solid/hockey-sticks.svg");
const holly_berry_svg_2 = require("../src/icons/solid/holly-berry.svg");
const home_heart_svg_2 = require("../src/icons/solid/home-heart.svg");
const home_simple_svg_2 = require("../src/icons/solid/home-simple.svg");
const home_user_svg_2 = require("../src/icons/solid/home-user.svg");
const home_svg_2 = require("../src/icons/solid/home.svg");
const hood_cloak_svg_2 = require("../src/icons/solid/hood-cloak.svg");
const horizontal_rule_svg_2 = require("../src/icons/solid/horizontal-rule.svg");
const horse_head_svg_2 = require("../src/icons/solid/horse-head.svg");
const horse_saddle_svg_2 = require("../src/icons/solid/horse-saddle.svg");
const horse_svg_2 = require("../src/icons/solid/horse.svg");
const hospital_user_svg_2 = require("../src/icons/solid/hospital-user.svg");
const hospital_wide_svg_2 = require("../src/icons/solid/hospital-wide.svg");
const hospital_svg_2 = require("../src/icons/solid/hospital.svg");
const hospitals_svg_2 = require("../src/icons/solid/hospitals.svg");
const hot_tub_person_svg_2 = require("../src/icons/solid/hot-tub-person.svg");
const hotdog_svg_2 = require("../src/icons/solid/hotdog.svg");
const hotel_svg_2 = require("../src/icons/solid/hotel.svg");
const hourglass_empty_svg_2 = require("../src/icons/solid/hourglass-empty.svg");
const hourglass_end_svg_2 = require("../src/icons/solid/hourglass-end.svg");
const hourglass_start_svg_2 = require("../src/icons/solid/hourglass-start.svg");
const hourglass_svg_2 = require("../src/icons/solid/hourglass.svg");
const house_building_svg_2 = require("../src/icons/solid/house-building.svg");
const house_crack_svg_2 = require("../src/icons/solid/house-crack.svg");
const house_day_svg_2 = require("../src/icons/solid/house-day.svg");
const house_flood_svg_2 = require("../src/icons/solid/house-flood.svg");
const house_heart_svg_2 = require("../src/icons/solid/house-heart.svg");
const house_laptop_svg_2 = require("../src/icons/solid/house-laptop.svg");
const house_medical_svg_2 = require("../src/icons/solid/house-medical.svg");
const house_night_svg_2 = require("../src/icons/solid/house-night.svg");
const house_person_leave_svg_2 = require("../src/icons/solid/house-person-leave.svg");
const house_person_return_svg_2 = require("../src/icons/solid/house-person-return.svg");
const house_signal_svg_2 = require("../src/icons/solid/house-signal.svg");
const house_tree_svg_2 = require("../src/icons/solid/house-tree.svg");
const house_turret_svg_2 = require("../src/icons/solid/house-turret.svg");
const house_user_svg_2 = require("../src/icons/solid/house-user.svg");
const house_svg_2 = require("../src/icons/solid/house.svg");
const hryvnia_sign_svg_2 = require("../src/icons/solid/hryvnia-sign.svg");
const hurricane_svg_2 = require("../src/icons/solid/hurricane.svg");
const i_cursor_svg_2 = require("../src/icons/solid/i-cursor.svg");
const i_svg_2 = require("../src/icons/solid/i.svg");
const ice_cream_svg_2 = require("../src/icons/solid/ice-cream.svg");
const ice_skate_svg_2 = require("../src/icons/solid/ice-skate.svg");
const icicles_svg_2 = require("../src/icons/solid/icicles.svg");
const icons_svg_2 = require("../src/icons/solid/icons.svg");
const id_badge_svg_2 = require("../src/icons/solid/id-badge.svg");
const id_card_clip_svg_2 = require("../src/icons/solid/id-card-clip.svg");
const id_card_svg_2 = require("../src/icons/solid/id-card.svg");
const igloo_svg_2 = require("../src/icons/solid/igloo.svg");
const image_landscape_svg_2 = require("../src/icons/solid/image-landscape.svg");
const image_polaroid_user_svg_2 = require("../src/icons/solid/image-polaroid-user.svg");
const image_polaroid_svg_2 = require("../src/icons/solid/image-polaroid.svg");
const image_portrait_svg_2 = require("../src/icons/solid/image-portrait.svg");
const image_slash_svg_2 = require("../src/icons/solid/image-slash.svg");
const image_user_svg_2 = require("../src/icons/solid/image-user.svg");
const image_svg_2 = require("../src/icons/solid/image.svg");
const images_user_svg_2 = require("../src/icons/solid/images-user.svg");
const images_svg_2 = require("../src/icons/solid/images.svg");
const inbox_full_svg_2 = require("../src/icons/solid/inbox-full.svg");
const inbox_in_svg_2 = require("../src/icons/solid/inbox-in.svg");
const inbox_out_svg_2 = require("../src/icons/solid/inbox-out.svg");
const inbox_svg_2 = require("../src/icons/solid/inbox.svg");
const inboxes_svg_2 = require("../src/icons/solid/inboxes.svg");
const indent_svg_2 = require("../src/icons/solid/indent.svg");
const indian_rupee_sign_svg_2 = require("../src/icons/solid/indian-rupee-sign.svg");
const industry_windows_svg_2 = require("../src/icons/solid/industry-windows.svg");
const industry_svg_2 = require("../src/icons/solid/industry.svg");
const infinity_svg_2 = require("../src/icons/solid/infinity.svg");
const info_svg_2 = require("../src/icons/solid/info.svg");
const inhaler_svg_2 = require("../src/icons/solid/inhaler.svg");
const input_numeric_svg_2 = require("../src/icons/solid/input-numeric.svg");
const input_pipe_svg_2 = require("../src/icons/solid/input-pipe.svg");
const input_text_svg_2 = require("../src/icons/solid/input-text.svg");
const integral_svg_2 = require("../src/icons/solid/integral.svg");
const intersection_svg_2 = require("../src/icons/solid/intersection.svg");
const island_tropical_svg_2 = require("../src/icons/solid/island-tropical.svg");
const italic_svg_2 = require("../src/icons/solid/italic.svg");
const j_svg_2 = require("../src/icons/solid/j.svg");
const jack_o_lantern_svg_2 = require("../src/icons/solid/jack-o-lantern.svg");
const jedi_svg_2 = require("../src/icons/solid/jedi.svg");
const jet_fighter_svg_2 = require("../src/icons/solid/jet-fighter.svg");
const joint_svg_2 = require("../src/icons/solid/joint.svg");
const joystick_svg_2 = require("../src/icons/solid/joystick.svg");
const jug_svg_2 = require("../src/icons/solid/jug.svg");
const k_svg_2 = require("../src/icons/solid/k.svg");
const kaaba_svg_2 = require("../src/icons/solid/kaaba.svg");
const kazoo_svg_2 = require("../src/icons/solid/kazoo.svg");
const kerning_svg_2 = require("../src/icons/solid/kerning.svg");
const key_skeleton_svg_2 = require("../src/icons/solid/key-skeleton.svg");
const key_svg_2 = require("../src/icons/solid/key.svg");
const keyboard_down_svg_2 = require("../src/icons/solid/keyboard-down.svg");
const keyboard_left_svg_2 = require("../src/icons/solid/keyboard-left.svg");
const keyboard_svg_2 = require("../src/icons/solid/keyboard.svg");
const keynote_svg_2 = require("../src/icons/solid/keynote.svg");
const khanda_svg_2 = require("../src/icons/solid/khanda.svg");
const kidneys_svg_2 = require("../src/icons/solid/kidneys.svg");
const kip_sign_svg_2 = require("../src/icons/solid/kip-sign.svg");
const kit_medical_svg_2 = require("../src/icons/solid/kit-medical.svg");
const kite_svg_2 = require("../src/icons/solid/kite.svg");
const kiwi_bird_svg_2 = require("../src/icons/solid/kiwi-bird.svg");
const knife_kitchen_svg_2 = require("../src/icons/solid/knife-kitchen.svg");
const knife_svg_2 = require("../src/icons/solid/knife.svg");
const l_svg_2 = require("../src/icons/solid/l.svg");
const lambda_svg_2 = require("../src/icons/solid/lambda.svg");
const lamp_desk_svg_2 = require("../src/icons/solid/lamp-desk.svg");
const lamp_floor_svg_2 = require("../src/icons/solid/lamp-floor.svg");
const lamp_street_svg_2 = require("../src/icons/solid/lamp-street.svg");
const lamp_svg_2 = require("../src/icons/solid/lamp.svg");
const landmark_dome_svg_2 = require("../src/icons/solid/landmark-dome.svg");
const landmark_svg_2 = require("../src/icons/solid/landmark.svg");
const language_svg_2 = require("../src/icons/solid/language.svg");
const laptop_arrow_down_svg_2 = require("../src/icons/solid/laptop-arrow-down.svg");
const laptop_code_svg_2 = require("../src/icons/solid/laptop-code.svg");
const laptop_medical_svg_2 = require("../src/icons/solid/laptop-medical.svg");
const laptop_mobile_svg_2 = require("../src/icons/solid/laptop-mobile.svg");
const laptop_slash_svg_2 = require("../src/icons/solid/laptop-slash.svg");
const laptop_svg_2 = require("../src/icons/solid/laptop.svg");
const lari_sign_svg_2 = require("../src/icons/solid/lari-sign.svg");
const lasso_sparkles_svg_2 = require("../src/icons/solid/lasso-sparkles.svg");
const lasso_svg_2 = require("../src/icons/solid/lasso.svg");
const layers_minus_svg_2 = require("../src/icons/solid/layers-minus.svg");
const layers_plus_svg_2 = require("../src/icons/solid/layers-plus.svg");
const layers_svg_2 = require("../src/icons/solid/layers.svg");
const leaf_heart_svg_2 = require("../src/icons/solid/leaf-heart.svg");
const leaf_maple_svg_2 = require("../src/icons/solid/leaf-maple.svg");
const leaf_oak_svg_2 = require("../src/icons/solid/leaf-oak.svg");
const leaf_svg_2 = require("../src/icons/solid/leaf.svg");
const left_from_line_svg_2 = require("../src/icons/solid/left-from-line.svg");
const left_long_svg_2 = require("../src/icons/solid/left-long.svg");
const left_right_svg_2 = require("../src/icons/solid/left-right.svg");
const left_to_line_svg_2 = require("../src/icons/solid/left-to-line.svg");
const left_svg_2 = require("../src/icons/solid/left.svg");
const lemon_svg_2 = require("../src/icons/solid/lemon.svg");
const less_than_equal_svg_2 = require("../src/icons/solid/less-than-equal.svg");
const less_than_svg_2 = require("../src/icons/solid/less-than.svg");
const life_ring_svg_2 = require("../src/icons/solid/life-ring.svg");
const light_ceiling_svg_2 = require("../src/icons/solid/light-ceiling.svg");
const light_switch_off_svg_2 = require("../src/icons/solid/light-switch-off.svg");
const light_switch_on_svg_2 = require("../src/icons/solid/light-switch-on.svg");
const light_switch_svg_2 = require("../src/icons/solid/light-switch.svg");
const lightbulb_dollar_svg_2 = require("../src/icons/solid/lightbulb-dollar.svg");
const lightbulb_exclamation_svg_2 = require("../src/icons/solid/lightbulb-exclamation.svg");
const lightbulb_on_svg_2 = require("../src/icons/solid/lightbulb-on.svg");
const lightbulb_slash_svg_2 = require("../src/icons/solid/lightbulb-slash.svg");
const lightbulb_svg_2 = require("../src/icons/solid/lightbulb.svg");
const lights_holiday_svg_2 = require("../src/icons/solid/lights-holiday.svg");
const line_columns_svg_2 = require("../src/icons/solid/line-columns.svg");
const line_height_svg_2 = require("../src/icons/solid/line-height.svg");
const link_horizontal_slash_svg_2 = require("../src/icons/solid/link-horizontal-slash.svg");
const link_horizontal_svg_2 = require("../src/icons/solid/link-horizontal.svg");
const link_simple_slash_svg_2 = require("../src/icons/solid/link-simple-slash.svg");
const link_simple_svg_2 = require("../src/icons/solid/link-simple.svg");
const link_slash_svg_2 = require("../src/icons/solid/link-slash.svg");
const link_svg_2 = require("../src/icons/solid/link.svg");
const lips_svg_2 = require("../src/icons/solid/lips.svg");
const lira_sign_svg_2 = require("../src/icons/solid/lira-sign.svg");
const list_check_svg_2 = require("../src/icons/solid/list-check.svg");
const list_dropdown_svg_2 = require("../src/icons/solid/list-dropdown.svg");
const list_music_svg_2 = require("../src/icons/solid/list-music.svg");
const list_ol_svg_2 = require("../src/icons/solid/list-ol.svg");
const list_radio_svg_2 = require("../src/icons/solid/list-radio.svg");
const list_timeline_svg_2 = require("../src/icons/solid/list-timeline.svg");
const list_tree_svg_2 = require("../src/icons/solid/list-tree.svg");
const list_ul_svg_2 = require("../src/icons/solid/list-ul.svg");
const list_svg_2 = require("../src/icons/solid/list.svg");
const litecoin_sign_svg_2 = require("../src/icons/solid/litecoin-sign.svg");
const loader_svg_2 = require("../src/icons/solid/loader.svg");
const location_arrow_svg_2 = require("../src/icons/solid/location-arrow.svg");
const location_check_svg_2 = require("../src/icons/solid/location-check.svg");
const location_crosshairs_slash_svg_2 = require("../src/icons/solid/location-crosshairs-slash.svg");
const location_crosshairs_svg_2 = require("../src/icons/solid/location-crosshairs.svg");
const location_dot_slash_svg_2 = require("../src/icons/solid/location-dot-slash.svg");
const location_dot_svg_2 = require("../src/icons/solid/location-dot.svg");
const location_exclamation_svg_2 = require("../src/icons/solid/location-exclamation.svg");
const location_minus_svg_2 = require("../src/icons/solid/location-minus.svg");
const location_pen_svg_2 = require("../src/icons/solid/location-pen.svg");
const location_plus_svg_2 = require("../src/icons/solid/location-plus.svg");
const location_question_svg_2 = require("../src/icons/solid/location-question.svg");
const location_slash_svg_2 = require("../src/icons/solid/location-slash.svg");
const location_smile_svg_2 = require("../src/icons/solid/location-smile.svg");
const location_xmark_svg_2 = require("../src/icons/solid/location-xmark.svg");
const location_svg_2 = require("../src/icons/solid/location.svg");
const lock_keyhole_open_svg_2 = require("../src/icons/solid/lock-keyhole-open.svg");
const lock_keyhole_svg_2 = require("../src/icons/solid/lock-keyhole.svg");
const lock_open_svg_2 = require("../src/icons/solid/lock-open.svg");
const lock_svg_2 = require("../src/icons/solid/lock.svg");
const loveseat_svg_2 = require("../src/icons/solid/loveseat.svg");
const luchador_mask_svg_2 = require("../src/icons/solid/luchador-mask.svg");
const lungs_virus_svg_2 = require("../src/icons/solid/lungs-virus.svg");
const lungs_svg_2 = require("../src/icons/solid/lungs.svg");
const m_svg_2 = require("../src/icons/solid/m.svg");
const mace_svg_2 = require("../src/icons/solid/mace.svg");
const magnet_svg_2 = require("../src/icons/solid/magnet.svg");
const magnifying_glass_dollar_svg_2 = require("../src/icons/solid/magnifying-glass-dollar.svg");
const magnifying_glass_location_svg_2 = require("../src/icons/solid/magnifying-glass-location.svg");
const magnifying_glass_minus_svg_2 = require("../src/icons/solid/magnifying-glass-minus.svg");
const magnifying_glass_plus_svg_2 = require("../src/icons/solid/magnifying-glass-plus.svg");
const magnifying_glass_svg_2 = require("../src/icons/solid/magnifying-glass.svg");
const mailbox_svg_2 = require("../src/icons/solid/mailbox.svg");
const manat_sign_svg_2 = require("../src/icons/solid/manat-sign.svg");
const mandolin_svg_2 = require("../src/icons/solid/mandolin.svg");
const manhole_svg_2 = require("../src/icons/solid/manhole.svg");
const map_location_dot_svg_2 = require("../src/icons/solid/map-location-dot.svg");
const map_location_svg_2 = require("../src/icons/solid/map-location.svg");
const map_pin_svg_2 = require("../src/icons/solid/map-pin.svg");
const map_svg_2 = require("../src/icons/solid/map.svg");
const marker_svg_2 = require("../src/icons/solid/marker.svg");
const mars_double_svg_2 = require("../src/icons/solid/mars-double.svg");
const mars_stroke_right_svg_2 = require("../src/icons/solid/mars-stroke-right.svg");
const mars_stroke_up_svg_2 = require("../src/icons/solid/mars-stroke-up.svg");
const mars_stroke_svg_2 = require("../src/icons/solid/mars-stroke.svg");
const mars_svg_2 = require("../src/icons/solid/mars.svg");
const martini_glass_citrus_svg_2 = require("../src/icons/solid/martini-glass-citrus.svg");
const martini_glass_empty_svg_2 = require("../src/icons/solid/martini-glass-empty.svg");
const martini_glass_svg_2 = require("../src/icons/solid/martini-glass.svg");
const mask_face_svg_2 = require("../src/icons/solid/mask-face.svg");
const mask_svg_2 = require("../src/icons/solid/mask.svg");
const masks_theater_svg_2 = require("../src/icons/solid/masks-theater.svg");
const maximize_svg_2 = require("../src/icons/solid/maximize.svg");
const meat_svg_2 = require("../src/icons/solid/meat.svg");
const medal_svg_2 = require("../src/icons/solid/medal.svg");
const megaphone_svg_2 = require("../src/icons/solid/megaphone.svg");
const memo_circle_check_svg_2 = require("../src/icons/solid/memo-circle-check.svg");
const memo_svg_2 = require("../src/icons/solid/memo.svg");
const memory_svg_2 = require("../src/icons/solid/memory.svg");
const menorah_svg_2 = require("../src/icons/solid/menorah.svg");
const mercury_svg_2 = require("../src/icons/solid/mercury.svg");
const message_arrow_down_svg_2 = require("../src/icons/solid/message-arrow-down.svg");
const message_arrow_up_right_svg_2 = require("../src/icons/solid/message-arrow-up-right.svg");
const message_arrow_up_svg_2 = require("../src/icons/solid/message-arrow-up.svg");
const message_captions_svg_2 = require("../src/icons/solid/message-captions.svg");
const message_check_svg_2 = require("../src/icons/solid/message-check.svg");
const message_code_svg_2 = require("../src/icons/solid/message-code.svg");
const message_dollar_svg_2 = require("../src/icons/solid/message-dollar.svg");
const message_dots_svg_2 = require("../src/icons/solid/message-dots.svg");
const message_exclamation_svg_2 = require("../src/icons/solid/message-exclamation.svg");
const message_image_svg_2 = require("../src/icons/solid/message-image.svg");
const message_lines_svg_2 = require("../src/icons/solid/message-lines.svg");
const message_medical_svg_2 = require("../src/icons/solid/message-medical.svg");
const message_middle_top_svg_2 = require("../src/icons/solid/message-middle-top.svg");
const message_middle_svg_2 = require("../src/icons/solid/message-middle.svg");
const message_minus_svg_2 = require("../src/icons/solid/message-minus.svg");
const message_music_svg_2 = require("../src/icons/solid/message-music.svg");
const message_pen_svg_2 = require("../src/icons/solid/message-pen.svg");
const message_plus_svg_2 = require("../src/icons/solid/message-plus.svg");
const message_question_svg_2 = require("../src/icons/solid/message-question.svg");
const message_quote_svg_2 = require("../src/icons/solid/message-quote.svg");
const message_slash_svg_2 = require("../src/icons/solid/message-slash.svg");
const message_smile_svg_2 = require("../src/icons/solid/message-smile.svg");
const message_sms_svg_2 = require("../src/icons/solid/message-sms.svg");
const message_text_svg_2 = require("../src/icons/solid/message-text.svg");
const message_xmark_svg_2 = require("../src/icons/solid/message-xmark.svg");
const message_svg_2 = require("../src/icons/solid/message.svg");
const messages_dollar_svg_2 = require("../src/icons/solid/messages-dollar.svg");
const messages_question_svg_2 = require("../src/icons/solid/messages-question.svg");
const messages_svg_2 = require("../src/icons/solid/messages.svg");
const meteor_svg_2 = require("../src/icons/solid/meteor.svg");
const meter_bolt_svg_2 = require("../src/icons/solid/meter-bolt.svg");
const meter_droplet_svg_2 = require("../src/icons/solid/meter-droplet.svg");
const meter_fire_svg_2 = require("../src/icons/solid/meter-fire.svg");
const meter_svg_2 = require("../src/icons/solid/meter.svg");
const microchip_ai_svg_2 = require("../src/icons/solid/microchip-ai.svg");
const microchip_svg_2 = require("../src/icons/solid/microchip.svg");
const microphone_lines_slash_svg_2 = require("../src/icons/solid/microphone-lines-slash.svg");
const microphone_lines_svg_2 = require("../src/icons/solid/microphone-lines.svg");
const microphone_slash_svg_2 = require("../src/icons/solid/microphone-slash.svg");
const microphone_stand_svg_2 = require("../src/icons/solid/microphone-stand.svg");
const microphone_svg_2 = require("../src/icons/solid/microphone.svg");
const microscope_svg_2 = require("../src/icons/solid/microscope.svg");
const microwave_svg_2 = require("../src/icons/solid/microwave.svg");
const mill_sign_svg_2 = require("../src/icons/solid/mill-sign.svg");
const minimize_svg_2 = require("../src/icons/solid/minimize.svg");
const minus_svg_2 = require("../src/icons/solid/minus.svg");
const mistletoe_svg_2 = require("../src/icons/solid/mistletoe.svg");
const mitten_svg_2 = require("../src/icons/solid/mitten.svg");
const mobile_button_svg_2 = require("../src/icons/solid/mobile-button.svg");
const mobile_notch_svg_2 = require("../src/icons/solid/mobile-notch.svg");
const mobile_screen_button_svg_2 = require("../src/icons/solid/mobile-screen-button.svg");
const mobile_screen_svg_2 = require("../src/icons/solid/mobile-screen.svg");
const mobile_svg_2 = require("../src/icons/solid/mobile.svg");
const money_bill_1_wave_svg_2 = require("../src/icons/solid/money-bill-1-wave.svg");
const money_bill_1_svg_2 = require("../src/icons/solid/money-bill-1.svg");
const money_bill_simple_wave_svg_2 = require("../src/icons/solid/money-bill-simple-wave.svg");
const money_bill_simple_svg_2 = require("../src/icons/solid/money-bill-simple.svg");
const money_bill_wave_svg_2 = require("../src/icons/solid/money-bill-wave.svg");
const money_bill_svg_2 = require("../src/icons/solid/money-bill.svg");
const money_bills_simple_svg_2 = require("../src/icons/solid/money-bills-simple.svg");
const money_bills_svg_2 = require("../src/icons/solid/money-bills.svg");
const money_check_dollar_pen_svg_2 = require("../src/icons/solid/money-check-dollar-pen.svg");
const money_check_dollar_svg_2 = require("../src/icons/solid/money-check-dollar.svg");
const money_check_pen_svg_2 = require("../src/icons/solid/money-check-pen.svg");
const money_check_svg_2 = require("../src/icons/solid/money-check.svg");
const monitor_waveform_svg_2 = require("../src/icons/solid/monitor-waveform.svg");
const monkey_svg_2 = require("../src/icons/solid/monkey.svg");
const monument_svg_2 = require("../src/icons/solid/monument.svg");
const moon_cloud_svg_2 = require("../src/icons/solid/moon-cloud.svg");
const moon_over_sun_svg_2 = require("../src/icons/solid/moon-over-sun.svg");
const moon_stars_svg_2 = require("../src/icons/solid/moon-stars.svg");
const moon_svg_2 = require("../src/icons/solid/moon.svg");
const mortar_pestle_svg_2 = require("../src/icons/solid/mortar-pestle.svg");
const mosque_svg_2 = require("../src/icons/solid/mosque.svg");
const motorcycle_svg_2 = require("../src/icons/solid/motorcycle.svg");
const mountain_svg_2 = require("../src/icons/solid/mountain.svg");
const mountains_svg_2 = require("../src/icons/solid/mountains.svg");
const mp3_player_svg_2 = require("../src/icons/solid/mp3-player.svg");
const mug_hot_svg_2 = require("../src/icons/solid/mug-hot.svg");
const mug_marshmallows_svg_2 = require("../src/icons/solid/mug-marshmallows.svg");
const mug_saucer_svg_2 = require("../src/icons/solid/mug-saucer.svg");
const mug_tea_saucer_svg_2 = require("../src/icons/solid/mug-tea-saucer.svg");
const mug_tea_svg_2 = require("../src/icons/solid/mug-tea.svg");
const mug_svg_2 = require("../src/icons/solid/mug.svg");
const music_note_slash_svg_2 = require("../src/icons/solid/music-note-slash.svg");
const music_note_svg_2 = require("../src/icons/solid/music-note.svg");
const music_slash_svg_2 = require("../src/icons/solid/music-slash.svg");
const music_svg_2 = require("../src/icons/solid/music.svg");
const n_svg_2 = require("../src/icons/solid/n.svg");
const naira_sign_svg_2 = require("../src/icons/solid/naira-sign.svg");
const narwhal_svg_2 = require("../src/icons/solid/narwhal.svg");
const network_wired_svg_2 = require("../src/icons/solid/network-wired.svg");
const neuter_svg_2 = require("../src/icons/solid/neuter.svg");
const newspaper_svg_2 = require("../src/icons/solid/newspaper.svg");
const not_equal_svg_2 = require("../src/icons/solid/not-equal.svg");
const notdef_svg_2 = require("../src/icons/solid/notdef.svg");
const note_medical_svg_2 = require("../src/icons/solid/note-medical.svg");
const note_sticky_svg_2 = require("../src/icons/solid/note-sticky.svg");
const note_svg_2 = require("../src/icons/solid/note.svg");
const notes_medical_svg_2 = require("../src/icons/solid/notes-medical.svg");
const notes_svg_2 = require("../src/icons/solid/notes.svg");
const o_svg_2 = require("../src/icons/solid/o.svg");
const object_group_svg_2 = require("../src/icons/solid/object-group.svg");
const object_ungroup_svg_2 = require("../src/icons/solid/object-ungroup.svg");
const octagon_divide_svg_2 = require("../src/icons/solid/octagon-divide.svg");
const octagon_exclamation_svg_2 = require("../src/icons/solid/octagon-exclamation.svg");
const octagon_minus_svg_2 = require("../src/icons/solid/octagon-minus.svg");
const octagon_plus_svg_2 = require("../src/icons/solid/octagon-plus.svg");
const octagon_xmark_svg_2 = require("../src/icons/solid/octagon-xmark.svg");
const octagon_svg_2 = require("../src/icons/solid/octagon.svg");
const oil_can_drip_svg_2 = require("../src/icons/solid/oil-can-drip.svg");
const oil_can_svg_2 = require("../src/icons/solid/oil-can.svg");
const oil_temperature_svg_2 = require("../src/icons/solid/oil-temperature.svg");
const om_svg_2 = require("../src/icons/solid/om.svg");
const omega_svg_2 = require("../src/icons/solid/omega.svg");
const option_svg_2 = require("../src/icons/solid/option.svg");
const ornament_svg_2 = require("../src/icons/solid/ornament.svg");
const otter_svg_2 = require("../src/icons/solid/otter.svg");
const outdent_svg_2 = require("../src/icons/solid/outdent.svg");
const outlet_svg_2 = require("../src/icons/solid/outlet.svg");
const oven_svg_2 = require("../src/icons/solid/oven.svg");
const overline_svg_2 = require("../src/icons/solid/overline.svg");
const p_svg_2 = require("../src/icons/solid/p.svg");
const pager_svg_2 = require("../src/icons/solid/pager.svg");
const paint_brush_fine_svg_2 = require("../src/icons/solid/paint-brush-fine.svg");
const paint_brush_svg_2 = require("../src/icons/solid/paint-brush.svg");
const paint_roller_svg_2 = require("../src/icons/solid/paint-roller.svg");
const paintbrush_pencil_svg_2 = require("../src/icons/solid/paintbrush-pencil.svg");
const palette_boxes_svg_2 = require("../src/icons/solid/palette-boxes.svg");
const palette_svg_2 = require("../src/icons/solid/palette.svg");
const pallet_box_svg_2 = require("../src/icons/solid/pallet-box.svg");
const pallet_boxes_svg_2 = require("../src/icons/solid/pallet-boxes.svg");
const pallet_svg_2 = require("../src/icons/solid/pallet.svg");
const panorama_svg_2 = require("../src/icons/solid/panorama.svg");
const paper_plane_top_svg_2 = require("../src/icons/solid/paper-plane-top.svg");
const paper_plane_svg_2 = require("../src/icons/solid/paper-plane.svg");
const paperclip_svg_2 = require("../src/icons/solid/paperclip.svg");
const parachute_box_svg_2 = require("../src/icons/solid/parachute-box.svg");
const paragraph_left_svg_2 = require("../src/icons/solid/paragraph-left.svg");
const paragraph_svg_2 = require("../src/icons/solid/paragraph.svg");
const passport_svg_2 = require("../src/icons/solid/passport.svg");
const paste_svg_2 = require("../src/icons/solid/paste.svg");
const pause_svg_2 = require("../src/icons/solid/pause.svg");
const paw_claws_svg_2 = require("../src/icons/solid/paw-claws.svg");
const paw_simple_svg_2 = require("../src/icons/solid/paw-simple.svg");
const paw_svg_2 = require("../src/icons/solid/paw.svg");
const peace_svg_2 = require("../src/icons/solid/peace.svg");
const peach_svg_2 = require("../src/icons/solid/peach.svg");
const pear_svg_2 = require("../src/icons/solid/pear.svg");
const pedestal_svg_2 = require("../src/icons/solid/pedestal.svg");
const pegasus_svg_2 = require("../src/icons/solid/pegasus.svg");
const pen_circle_svg_2 = require("../src/icons/solid/pen-circle.svg");
const pen_clip_slash_svg_2 = require("../src/icons/solid/pen-clip-slash.svg");
const pen_clip_svg_2 = require("../src/icons/solid/pen-clip.svg");
const pen_fancy_slash_svg_2 = require("../src/icons/solid/pen-fancy-slash.svg");
const pen_fancy_svg_2 = require("../src/icons/solid/pen-fancy.svg");
const pen_field_svg_2 = require("../src/icons/solid/pen-field.svg");
const pen_line_svg_2 = require("../src/icons/solid/pen-line.svg");
const pen_nib_svg_2 = require("../src/icons/solid/pen-nib.svg");
const pen_paintbrush_svg_2 = require("../src/icons/solid/pen-paintbrush.svg");
const pen_ruler_svg_2 = require("../src/icons/solid/pen-ruler.svg");
const pen_slash_svg_2 = require("../src/icons/solid/pen-slash.svg");
const pen_swirl_svg_2 = require("../src/icons/solid/pen-swirl.svg");
const pen_to_square_svg_2 = require("../src/icons/solid/pen-to-square.svg");
const pen_svg_2 = require("../src/icons/solid/pen.svg");
const pencil_slash_svg_2 = require("../src/icons/solid/pencil-slash.svg");
const pencil_svg_2 = require("../src/icons/solid/pencil.svg");
const people_arrows_left_right_svg_2 = require("../src/icons/solid/people-arrows-left-right.svg");
const people_carry_box_svg_2 = require("../src/icons/solid/people-carry-box.svg");
const pepper_hot_svg_2 = require("../src/icons/solid/pepper-hot.svg");
const percent_svg_2 = require("../src/icons/solid/percent.svg");
const person_biking_mountain_svg_2 = require("../src/icons/solid/person-biking-mountain.svg");
const person_biking_svg_2 = require("../src/icons/solid/person-biking.svg");
const person_booth_svg_2 = require("../src/icons/solid/person-booth.svg");
const person_carry_box_svg_2 = require("../src/icons/solid/person-carry-box.svg");
const person_digging_svg_2 = require("../src/icons/solid/person-digging.svg");
const person_dolly_empty_svg_2 = require("../src/icons/solid/person-dolly-empty.svg");
const person_dolly_svg_2 = require("../src/icons/solid/person-dolly.svg");
const person_dots_from_line_svg_2 = require("../src/icons/solid/person-dots-from-line.svg");
const person_dress_simple_svg_2 = require("../src/icons/solid/person-dress-simple.svg");
const person_dress_svg_2 = require("../src/icons/solid/person-dress.svg");
const person_from_portal_svg_2 = require("../src/icons/solid/person-from-portal.svg");
const person_hiking_svg_2 = require("../src/icons/solid/person-hiking.svg");
const person_pinball_svg_2 = require("../src/icons/solid/person-pinball.svg");
const person_praying_svg_2 = require("../src/icons/solid/person-praying.svg");
const person_running_svg_2 = require("../src/icons/solid/person-running.svg");
const person_seat_reclined_svg_2 = require("../src/icons/solid/person-seat-reclined.svg");
const person_seat_svg_2 = require("../src/icons/solid/person-seat.svg");
const person_sign_svg_2 = require("../src/icons/solid/person-sign.svg");
const person_simple_svg_2 = require("../src/icons/solid/person-simple.svg");
const person_skating_svg_2 = require("../src/icons/solid/person-skating.svg");
const person_ski_jumping_svg_2 = require("../src/icons/solid/person-ski-jumping.svg");
const person_ski_lift_svg_2 = require("../src/icons/solid/person-ski-lift.svg");
const person_skiing_nordic_svg_2 = require("../src/icons/solid/person-skiing-nordic.svg");
const person_skiing_svg_2 = require("../src/icons/solid/person-skiing.svg");
const person_sledding_svg_2 = require("../src/icons/solid/person-sledding.svg");
const person_snowboarding_svg_2 = require("../src/icons/solid/person-snowboarding.svg");
const person_snowmobiling_svg_2 = require("../src/icons/solid/person-snowmobiling.svg");
const person_swimming_svg_2 = require("../src/icons/solid/person-swimming.svg");
const person_to_portal_svg_2 = require("../src/icons/solid/person-to-portal.svg");
const person_walking_with_cane_svg_2 = require("../src/icons/solid/person-walking-with-cane.svg");
const person_walking_svg_2 = require("../src/icons/solid/person-walking.svg");
const person_svg_2 = require("../src/icons/solid/person.svg");
const peseta_sign_svg_2 = require("../src/icons/solid/peseta-sign.svg");
const peso_sign_svg_2 = require("../src/icons/solid/peso-sign.svg");
const phone_arrow_down_left_svg_2 = require("../src/icons/solid/phone-arrow-down-left.svg");
const phone_arrow_up_right_svg_2 = require("../src/icons/solid/phone-arrow-up-right.svg");
const phone_flip_svg_2 = require("../src/icons/solid/phone-flip.svg");
const phone_hangup_svg_2 = require("../src/icons/solid/phone-hangup.svg");
const phone_missed_svg_2 = require("../src/icons/solid/phone-missed.svg");
const phone_office_svg_2 = require("../src/icons/solid/phone-office.svg");
const phone_plus_svg_2 = require("../src/icons/solid/phone-plus.svg");
const phone_rotary_svg_2 = require("../src/icons/solid/phone-rotary.svg");
const phone_slash_svg_2 = require("../src/icons/solid/phone-slash.svg");
const phone_volume_svg_2 = require("../src/icons/solid/phone-volume.svg");
const phone_xmark_svg_2 = require("../src/icons/solid/phone-xmark.svg");
const phone_svg_2 = require("../src/icons/solid/phone.svg");
const photo_film_music_svg_2 = require("../src/icons/solid/photo-film-music.svg");
const photo_film_svg_2 = require("../src/icons/solid/photo-film.svg");
const pi_svg_2 = require("../src/icons/solid/pi.svg");
const piano_keyboard_svg_2 = require("../src/icons/solid/piano-keyboard.svg");
const piano_svg_2 = require("../src/icons/solid/piano.svg");
const pie_svg_2 = require("../src/icons/solid/pie.svg");
const pig_svg_2 = require("../src/icons/solid/pig.svg");
const piggy_bank_svg_2 = require("../src/icons/solid/piggy-bank.svg");
const pills_svg_2 = require("../src/icons/solid/pills.svg");
const pinball_svg_2 = require("../src/icons/solid/pinball.svg");
const pizza_slice_svg_2 = require("../src/icons/solid/pizza-slice.svg");
const pizza_svg_2 = require("../src/icons/solid/pizza.svg");
const place_of_worship_svg_2 = require("../src/icons/solid/place-of-worship.svg");
const plane_arrival_svg_2 = require("../src/icons/solid/plane-arrival.svg");
const plane_departure_svg_2 = require("../src/icons/solid/plane-departure.svg");
const plane_engines_svg_2 = require("../src/icons/solid/plane-engines.svg");
const plane_prop_svg_2 = require("../src/icons/solid/plane-prop.svg");
const plane_slash_svg_2 = require("../src/icons/solid/plane-slash.svg");
const plane_tail_svg_2 = require("../src/icons/solid/plane-tail.svg");
const plane_up_slash_svg_2 = require("../src/icons/solid/plane-up-slash.svg");
const plane_up_svg_2 = require("../src/icons/solid/plane-up.svg");
const plane_svg_2 = require("../src/icons/solid/plane.svg");
const planet_moon_svg_2 = require("../src/icons/solid/planet-moon.svg");
const planet_ringed_svg_2 = require("../src/icons/solid/planet-ringed.svg");
const play_pause_svg_2 = require("../src/icons/solid/play-pause.svg");
const play_svg_2 = require("../src/icons/solid/play.svg");
const plug_svg_2 = require("../src/icons/solid/plug.svg");
const plus_minus_svg_2 = require("../src/icons/solid/plus-minus.svg");
const plus_svg_2 = require("../src/icons/solid/plus.svg");
const podcast_svg_2 = require("../src/icons/solid/podcast.svg");
const podium_star_svg_2 = require("../src/icons/solid/podium-star.svg");
const podium_svg_2 = require("../src/icons/solid/podium.svg");
const police_box_svg_2 = require("../src/icons/solid/police-box.svg");
const poll_people_svg_2 = require("../src/icons/solid/poll-people.svg");
const poo_bolt_svg_2 = require("../src/icons/solid/poo-bolt.svg");
const poo_svg_2 = require("../src/icons/solid/poo.svg");
const poop_svg_2 = require("../src/icons/solid/poop.svg");
const popcorn_svg_2 = require("../src/icons/solid/popcorn.svg");
const power_off_svg_2 = require("../src/icons/solid/power-off.svg");
const prescription_bottle_medical_svg_2 = require("../src/icons/solid/prescription-bottle-medical.svg");
const prescription_bottle_svg_2 = require("../src/icons/solid/prescription-bottle.svg");
const prescription_svg_2 = require("../src/icons/solid/prescription.svg");
const presentation_screen_svg_2 = require("../src/icons/solid/presentation-screen.svg");
const print_magnifying_glass_svg_2 = require("../src/icons/solid/print-magnifying-glass.svg");
const print_slash_svg_2 = require("../src/icons/solid/print-slash.svg");
const print_svg_2 = require("../src/icons/solid/print.svg");
const projector_svg_2 = require("../src/icons/solid/projector.svg");
const pump_medical_svg_2 = require("../src/icons/solid/pump-medical.svg");
const pump_soap_svg_2 = require("../src/icons/solid/pump-soap.svg");
const pumpkin_svg_2 = require("../src/icons/solid/pumpkin.svg");
const puzzle_piece_simple_svg_2 = require("../src/icons/solid/puzzle-piece-simple.svg");
const puzzle_piece_svg_2 = require("../src/icons/solid/puzzle-piece.svg");
const q_svg_2 = require("../src/icons/solid/q.svg");
const qrcode_svg_2 = require("../src/icons/solid/qrcode.svg");
const question_svg_2 = require("../src/icons/solid/question.svg");
const quidditch_broom_ball_svg_2 = require("../src/icons/solid/quidditch-broom-ball.svg");
const quote_left_round_svg_2 = require("../src/icons/solid/quote-left-round.svg");
const quote_left_svg_2 = require("../src/icons/solid/quote-left.svg");
const quote_right_round_svg_2 = require("../src/icons/solid/quote-right-round.svg");
const quote_right_svg_2 = require("../src/icons/solid/quote-right.svg");
const r_svg_2 = require("../src/icons/solid/r.svg");
const rabbit_running_svg_2 = require("../src/icons/solid/rabbit-running.svg");
const rabbit_svg_2 = require("../src/icons/solid/rabbit.svg");
const racquet_svg_2 = require("../src/icons/solid/racquet.svg");
const radar_svg_2 = require("../src/icons/solid/radar.svg");
const radiation_svg_2 = require("../src/icons/solid/radiation.svg");
const radio_tuner_svg_2 = require("../src/icons/solid/radio-tuner.svg");
const radio_svg_2 = require("../src/icons/solid/radio.svg");
const rainbow_svg_2 = require("../src/icons/solid/rainbow.svg");
const raindrops_svg_2 = require("../src/icons/solid/raindrops.svg");
const ram_svg_2 = require("../src/icons/solid/ram.svg");
const ramp_loading_svg_2 = require("../src/icons/solid/ramp-loading.svg");
const raygun_svg_2 = require("../src/icons/solid/raygun.svg");
const receipt_svg_2 = require("../src/icons/solid/receipt.svg");
const record_vinyl_svg_2 = require("../src/icons/solid/record-vinyl.svg");
const rectangle_ad_svg_2 = require("../src/icons/solid/rectangle-ad.svg");
const rectangle_barcode_svg_2 = require("../src/icons/solid/rectangle-barcode.svg");
const rectangle_list_svg_2 = require("../src/icons/solid/rectangle-list.svg");
const rectangle_terminal_svg_2 = require("../src/icons/solid/rectangle-terminal.svg");
const rectangle_vertical_history_svg_2 = require("../src/icons/solid/rectangle-vertical-history.svg");
const rectangle_vertical_svg_2 = require("../src/icons/solid/rectangle-vertical.svg");
const rectangle_wide_svg_2 = require("../src/icons/solid/rectangle-wide.svg");
const rectangle_xmark_svg_2 = require("../src/icons/solid/rectangle-xmark.svg");
const rectangle_svg_2 = require("../src/icons/solid/rectangle.svg");
const recycle_svg_2 = require("../src/icons/solid/recycle.svg");
const refrigerator_svg_2 = require("../src/icons/solid/refrigerator.svg");
const registered_svg_2 = require("../src/icons/solid/registered.svg");
const repeat_1_svg_2 = require("../src/icons/solid/repeat-1.svg");
const repeat_svg_2 = require("../src/icons/solid/repeat.svg");
const reply_all_svg_2 = require("../src/icons/solid/reply-all.svg");
const reply_clock_svg_2 = require("../src/icons/solid/reply-clock.svg");
const reply_svg_2 = require("../src/icons/solid/reply.svg");
const republican_svg_2 = require("../src/icons/solid/republican.svg");
const restroom_simple_svg_2 = require("../src/icons/solid/restroom-simple.svg");
const restroom_svg_2 = require("../src/icons/solid/restroom.svg");
const retweet_svg_2 = require("../src/icons/solid/retweet.svg");
const rhombus_svg_2 = require("../src/icons/solid/rhombus.svg");
const ribbon_svg_2 = require("../src/icons/solid/ribbon.svg");
const right_from_bracket_svg_2 = require("../src/icons/solid/right-from-bracket.svg");
const right_from_line_svg_2 = require("../src/icons/solid/right-from-line.svg");
const right_left_svg_2 = require("../src/icons/solid/right-left.svg");
const right_long_svg_2 = require("../src/icons/solid/right-long.svg");
const right_to_bracket_svg_2 = require("../src/icons/solid/right-to-bracket.svg");
const right_to_line_svg_2 = require("../src/icons/solid/right-to-line.svg");
const right_svg_2 = require("../src/icons/solid/right.svg");
const ring_svg_2 = require("../src/icons/solid/ring.svg");
const rings_wedding_svg_2 = require("../src/icons/solid/rings-wedding.svg");
const road_svg_2 = require("../src/icons/solid/road.svg");
const robot_svg_2 = require("../src/icons/solid/robot.svg");
const rocket_launch_svg_2 = require("../src/icons/solid/rocket-launch.svg");
const rocket_svg_2 = require("../src/icons/solid/rocket.svg");
const rotate_exclamation_svg_2 = require("../src/icons/solid/rotate-exclamation.svg");
const rotate_forward_svg_2 = require("../src/icons/solid/rotate-forward.svg");
const rotate_left_svg_2 = require("../src/icons/solid/rotate-left.svg");
const rotate_svg_2 = require("../src/icons/solid/rotate.svg");
const route_highway_svg_2 = require("../src/icons/solid/route-highway.svg");
const route_interstate_svg_2 = require("../src/icons/solid/route-interstate.svg");
const route_svg_2 = require("../src/icons/solid/route.svg");
const router_svg_2 = require("../src/icons/solid/router.svg");
const rss_svg_2 = require("../src/icons/solid/rss.svg");
const ruble_sign_svg_2 = require("../src/icons/solid/ruble-sign.svg");
const ruler_combined_svg_2 = require("../src/icons/solid/ruler-combined.svg");
const ruler_horizontal_svg_2 = require("../src/icons/solid/ruler-horizontal.svg");
const ruler_triangle_svg_2 = require("../src/icons/solid/ruler-triangle.svg");
const ruler_vertical_svg_2 = require("../src/icons/solid/ruler-vertical.svg");
const ruler_svg_2 = require("../src/icons/solid/ruler.svg");
const rupee_sign_svg_2 = require("../src/icons/solid/rupee-sign.svg");
const rupiah_sign_svg_2 = require("../src/icons/solid/rupiah-sign.svg");
const rv_svg_2 = require("../src/icons/solid/rv.svg");
const s_svg_2 = require("../src/icons/solid/s.svg");
const sack_dollar_svg_2 = require("../src/icons/solid/sack-dollar.svg");
const sack_svg_2 = require("../src/icons/solid/sack.svg");
const salad_svg_2 = require("../src/icons/solid/salad.svg");
const sandwich_svg_2 = require("../src/icons/solid/sandwich.svg");
const satellite_dish_svg_2 = require("../src/icons/solid/satellite-dish.svg");
const satellite_svg_2 = require("../src/icons/solid/satellite.svg");
const sausage_svg_2 = require("../src/icons/solid/sausage.svg");
const saxophone_fire_svg_2 = require("../src/icons/solid/saxophone-fire.svg");
const saxophone_svg_2 = require("../src/icons/solid/saxophone.svg");
const scale_balanced_svg_2 = require("../src/icons/solid/scale-balanced.svg");
const scale_unbalanced_flip_svg_2 = require("../src/icons/solid/scale-unbalanced-flip.svg");
const scale_unbalanced_svg_2 = require("../src/icons/solid/scale-unbalanced.svg");
const scalpel_line_dashed_svg_2 = require("../src/icons/solid/scalpel-line-dashed.svg");
const scalpel_svg_2 = require("../src/icons/solid/scalpel.svg");
const scanner_gun_svg_2 = require("../src/icons/solid/scanner-gun.svg");
const scanner_keyboard_svg_2 = require("../src/icons/solid/scanner-keyboard.svg");
const scanner_touchscreen_svg_2 = require("../src/icons/solid/scanner-touchscreen.svg");
const scanner_svg_2 = require("../src/icons/solid/scanner.svg");
const scarecrow_svg_2 = require("../src/icons/solid/scarecrow.svg");
const scarf_svg_2 = require("../src/icons/solid/scarf.svg");
const school_svg_2 = require("../src/icons/solid/school.svg");
const scissors_svg_2 = require("../src/icons/solid/scissors.svg");
const screen_users_svg_2 = require("../src/icons/solid/screen-users.svg");
const screencast_svg_2 = require("../src/icons/solid/screencast.svg");
const screwdriver_wrench_svg_2 = require("../src/icons/solid/screwdriver-wrench.svg");
const screwdriver_svg_2 = require("../src/icons/solid/screwdriver.svg");
const scribble_svg_2 = require("../src/icons/solid/scribble.svg");
const scroll_old_svg_2 = require("../src/icons/solid/scroll-old.svg");
const scroll_torah_svg_2 = require("../src/icons/solid/scroll-torah.svg");
const scroll_svg_2 = require("../src/icons/solid/scroll.svg");
const scrubber_svg_2 = require("../src/icons/solid/scrubber.svg");
const scythe_svg_2 = require("../src/icons/solid/scythe.svg");
const sd_card_svg_2 = require("../src/icons/solid/sd-card.svg");
const sd_cards_svg_2 = require("../src/icons/solid/sd-cards.svg");
const seal_exclamation_svg_2 = require("../src/icons/solid/seal-exclamation.svg");
const seal_question_svg_2 = require("../src/icons/solid/seal-question.svg");
const seal_svg_2 = require("../src/icons/solid/seal.svg");
const seat_airline_svg_2 = require("../src/icons/solid/seat-airline.svg");
const section_svg_2 = require("../src/icons/solid/section.svg");
const seedling_svg_2 = require("../src/icons/solid/seedling.svg");
const send_back_svg_2 = require("../src/icons/solid/send-back.svg");
const send_backward_svg_2 = require("../src/icons/solid/send-backward.svg");
const sensor_cloud_svg_2 = require("../src/icons/solid/sensor-cloud.svg");
const sensor_fire_svg_2 = require("../src/icons/solid/sensor-fire.svg");
const sensor_on_svg_2 = require("../src/icons/solid/sensor-on.svg");
const sensor_triangle_exclamation_svg_2 = require("../src/icons/solid/sensor-triangle-exclamation.svg");
const sensor_svg_2 = require("../src/icons/solid/sensor.svg");
const server_svg_2 = require("../src/icons/solid/server.svg");
const shapes_svg_2 = require("../src/icons/solid/shapes.svg");
const share_all_svg_2 = require("../src/icons/solid/share-all.svg");
const share_from_square_svg_2 = require("../src/icons/solid/share-from-square.svg");
const share_nodes_svg_2 = require("../src/icons/solid/share-nodes.svg");
const share_svg_2 = require("../src/icons/solid/share.svg");
const sheep_svg_2 = require("../src/icons/solid/sheep.svg");
const shekel_sign_svg_2 = require("../src/icons/solid/shekel-sign.svg");
const shelves_empty_svg_2 = require("../src/icons/solid/shelves-empty.svg");
const shelves_svg_2 = require("../src/icons/solid/shelves.svg");
const shield_blank_svg_2 = require("../src/icons/solid/shield-blank.svg");
const shield_check_svg_2 = require("../src/icons/solid/shield-check.svg");
const shield_cross_svg_2 = require("../src/icons/solid/shield-cross.svg");
const shield_exclamation_svg_2 = require("../src/icons/solid/shield-exclamation.svg");
const shield_keyhole_svg_2 = require("../src/icons/solid/shield-keyhole.svg");
const shield_minus_svg_2 = require("../src/icons/solid/shield-minus.svg");
const shield_plus_svg_2 = require("../src/icons/solid/shield-plus.svg");
const shield_slash_svg_2 = require("../src/icons/solid/shield-slash.svg");
const shield_virus_svg_2 = require("../src/icons/solid/shield-virus.svg");
const shield_xmark_svg_2 = require("../src/icons/solid/shield-xmark.svg");
const shield_svg_2 = require("../src/icons/solid/shield.svg");
const ship_svg_2 = require("../src/icons/solid/ship.svg");
const shish_kebab_svg_2 = require("../src/icons/solid/shish-kebab.svg");
const shoe_prints_svg_2 = require("../src/icons/solid/shoe-prints.svg");
const shop_slash_svg_2 = require("../src/icons/solid/shop-slash.svg");
const shop_svg_2 = require("../src/icons/solid/shop.svg");
const shovel_snow_svg_2 = require("../src/icons/solid/shovel-snow.svg");
const shovel_svg_2 = require("../src/icons/solid/shovel.svg");
const shower_down_svg_2 = require("../src/icons/solid/shower-down.svg");
const shower_svg_2 = require("../src/icons/solid/shower.svg");
const shredder_svg_2 = require("../src/icons/solid/shredder.svg");
const shuffle_svg_2 = require("../src/icons/solid/shuffle.svg");
const shuttle_space_svg_2 = require("../src/icons/solid/shuttle-space.svg");
const shuttlecock_svg_2 = require("../src/icons/solid/shuttlecock.svg");
const sickle_svg_2 = require("../src/icons/solid/sickle.svg");
const sidebar_flip_svg_2 = require("../src/icons/solid/sidebar-flip.svg");
const sidebar_svg_2 = require("../src/icons/solid/sidebar.svg");
const sigma_svg_2 = require("../src/icons/solid/sigma.svg");
const sign_hanging_svg_2 = require("../src/icons/solid/sign-hanging.svg");
const signal_bars_fair_svg_2 = require("../src/icons/solid/signal-bars-fair.svg");
const signal_bars_good_svg_2 = require("../src/icons/solid/signal-bars-good.svg");
const signal_bars_slash_svg_2 = require("../src/icons/solid/signal-bars-slash.svg");
const signal_bars_weak_svg_2 = require("../src/icons/solid/signal-bars-weak.svg");
const signal_bars_svg_2 = require("../src/icons/solid/signal-bars.svg");
const signal_fair_svg_2 = require("../src/icons/solid/signal-fair.svg");
const signal_good_svg_2 = require("../src/icons/solid/signal-good.svg");
const signal_slash_svg_2 = require("../src/icons/solid/signal-slash.svg");
const signal_stream_slash_svg_2 = require("../src/icons/solid/signal-stream-slash.svg");
const signal_stream_svg_2 = require("../src/icons/solid/signal-stream.svg");
const signal_strong_svg_2 = require("../src/icons/solid/signal-strong.svg");
const signal_weak_svg_2 = require("../src/icons/solid/signal-weak.svg");
const signal_svg_2 = require("../src/icons/solid/signal.svg");
const signature_svg_2 = require("../src/icons/solid/signature.svg");
const signs_post_svg_2 = require("../src/icons/solid/signs-post.svg");
const sim_card_svg_2 = require("../src/icons/solid/sim-card.svg");
const sim_cards_svg_2 = require("../src/icons/solid/sim-cards.svg");
const sink_svg_2 = require("../src/icons/solid/sink.svg");
const siren_on_svg_2 = require("../src/icons/solid/siren-on.svg");
const siren_svg_2 = require("../src/icons/solid/siren.svg");
const sitemap_svg_2 = require("../src/icons/solid/sitemap.svg");
const skeleton_svg_2 = require("../src/icons/solid/skeleton.svg");
const skull_cow_svg_2 = require("../src/icons/solid/skull-cow.svg");
const skull_crossbones_svg_2 = require("../src/icons/solid/skull-crossbones.svg");
const skull_svg_2 = require("../src/icons/solid/skull.svg");
const slash_svg_2 = require("../src/icons/solid/slash.svg");
const sleigh_svg_2 = require("../src/icons/solid/sleigh.svg");
const slider_svg_2 = require("../src/icons/solid/slider.svg");
const sliders_up_svg_2 = require("../src/icons/solid/sliders-up.svg");
const sliders_svg_2 = require("../src/icons/solid/sliders.svg");
const smog_svg_2 = require("../src/icons/solid/smog.svg");
const smoke_svg_2 = require("../src/icons/solid/smoke.svg");
const smoking_svg_2 = require("../src/icons/solid/smoking.svg");
const snake_svg_2 = require("../src/icons/solid/snake.svg");
const snooze_svg_2 = require("../src/icons/solid/snooze.svg");
const snow_blowing_svg_2 = require("../src/icons/solid/snow-blowing.svg");
const snowflake_svg_2 = require("../src/icons/solid/snowflake.svg");
const snowflakes_svg_2 = require("../src/icons/solid/snowflakes.svg");
const snowman_head_svg_2 = require("../src/icons/solid/snowman-head.svg");
const snowman_svg_2 = require("../src/icons/solid/snowman.svg");
const snowplow_svg_2 = require("../src/icons/solid/snowplow.svg");
const soap_svg_2 = require("../src/icons/solid/soap.svg");
const socks_svg_2 = require("../src/icons/solid/socks.svg");
const solar_panel_svg_2 = require("../src/icons/solid/solar-panel.svg");
const solar_system_svg_2 = require("../src/icons/solid/solar-system.svg");
const sort_down_svg_2 = require("../src/icons/solid/sort-down.svg");
const sort_up_svg_2 = require("../src/icons/solid/sort-up.svg");
const sort_svg_2 = require("../src/icons/solid/sort.svg");
const spa_svg_2 = require("../src/icons/solid/spa.svg");
const space_station_moon_construction_svg_2 = require("../src/icons/solid/space-station-moon-construction.svg");
const space_station_moon_svg_2 = require("../src/icons/solid/space-station-moon.svg");
const spade_svg_2 = require("../src/icons/solid/spade.svg");
const spaghetti_monster_flying_svg_2 = require("../src/icons/solid/spaghetti-monster-flying.svg");
const sparkles_svg_2 = require("../src/icons/solid/sparkles.svg");
const speaker_svg_2 = require("../src/icons/solid/speaker.svg");
const speakers_svg_2 = require("../src/icons/solid/speakers.svg");
const spell_check_svg_2 = require("../src/icons/solid/spell-check.svg");
const spider_black_widow_svg_2 = require("../src/icons/solid/spider-black-widow.svg");
const spider_web_svg_2 = require("../src/icons/solid/spider-web.svg");
const spider_svg_2 = require("../src/icons/solid/spider.svg");
const spinner_third_svg_2 = require("../src/icons/solid/spinner-third.svg");
const spinner_svg_2 = require("../src/icons/solid/spinner.svg");
const split_svg_2 = require("../src/icons/solid/split.svg");
const splotch_svg_2 = require("../src/icons/solid/splotch.svg");
const spoon_svg_2 = require("../src/icons/solid/spoon.svg");
const spray_can_svg_2 = require("../src/icons/solid/spray-can.svg");
const sprinkler_svg_2 = require("../src/icons/solid/sprinkler.svg");
const square_0_svg_2 = require("../src/icons/solid/square-0.svg");
const square_1_svg_2 = require("../src/icons/solid/square-1.svg");
const square_2_svg_2 = require("../src/icons/solid/square-2.svg");
const square_3_svg_2 = require("../src/icons/solid/square-3.svg");
const square_4_svg_2 = require("../src/icons/solid/square-4.svg");
const square_5_svg_2 = require("../src/icons/solid/square-5.svg");
const square_6_svg_2 = require("../src/icons/solid/square-6.svg");
const square_7_svg_2 = require("../src/icons/solid/square-7.svg");
const square_8_svg_2 = require("../src/icons/solid/square-8.svg");
const square_9_svg_2 = require("../src/icons/solid/square-9.svg");
const square_a_svg_2 = require("../src/icons/solid/square-a.svg");
const square_ampersand_svg_2 = require("../src/icons/solid/square-ampersand.svg");
const square_arrow_down_left_svg_2 = require("../src/icons/solid/square-arrow-down-left.svg");
const square_arrow_down_right_svg_2 = require("../src/icons/solid/square-arrow-down-right.svg");
const square_arrow_down_svg_2 = require("../src/icons/solid/square-arrow-down.svg");
const square_arrow_left_svg_2 = require("../src/icons/solid/square-arrow-left.svg");
const square_arrow_right_svg_2 = require("../src/icons/solid/square-arrow-right.svg");
const square_arrow_up_left_svg_2 = require("../src/icons/solid/square-arrow-up-left.svg");
const square_arrow_up_right_svg_2 = require("../src/icons/solid/square-arrow-up-right.svg");
const square_arrow_up_svg_2 = require("../src/icons/solid/square-arrow-up.svg");
const square_b_svg_2 = require("../src/icons/solid/square-b.svg");
const square_bolt_svg_2 = require("../src/icons/solid/square-bolt.svg");
const square_c_svg_2 = require("../src/icons/solid/square-c.svg");
const square_caret_down_svg_2 = require("../src/icons/solid/square-caret-down.svg");
const square_caret_left_svg_2 = require("../src/icons/solid/square-caret-left.svg");
const square_caret_right_svg_2 = require("../src/icons/solid/square-caret-right.svg");
const square_caret_up_svg_2 = require("../src/icons/solid/square-caret-up.svg");
const square_check_svg_2 = require("../src/icons/solid/square-check.svg");
const square_chevron_down_svg_2 = require("../src/icons/solid/square-chevron-down.svg");
const square_chevron_left_svg_2 = require("../src/icons/solid/square-chevron-left.svg");
const square_chevron_right_svg_2 = require("../src/icons/solid/square-chevron-right.svg");
const square_chevron_up_svg_2 = require("../src/icons/solid/square-chevron-up.svg");
const square_code_svg_2 = require("../src/icons/solid/square-code.svg");
const square_d_svg_2 = require("../src/icons/solid/square-d.svg");
const square_dashed_svg_2 = require("../src/icons/solid/square-dashed.svg");
const square_divide_svg_2 = require("../src/icons/solid/square-divide.svg");
const square_dollar_svg_2 = require("../src/icons/solid/square-dollar.svg");
const square_down_left_svg_2 = require("../src/icons/solid/square-down-left.svg");
const square_down_right_svg_2 = require("../src/icons/solid/square-down-right.svg");
const square_down_svg_2 = require("../src/icons/solid/square-down.svg");
const square_e_svg_2 = require("../src/icons/solid/square-e.svg");
const square_envelope_svg_2 = require("../src/icons/solid/square-envelope.svg");
const square_exclamation_svg_2 = require("../src/icons/solid/square-exclamation.svg");
const square_f_svg_2 = require("../src/icons/solid/square-f.svg");
const square_fragile_svg_2 = require("../src/icons/solid/square-fragile.svg");
const square_full_svg_2 = require("../src/icons/solid/square-full.svg");
const square_g_svg_2 = require("../src/icons/solid/square-g.svg");
const square_h_svg_2 = require("../src/icons/solid/square-h.svg");
const square_heart_svg_2 = require("../src/icons/solid/square-heart.svg");
const square_i_svg_2 = require("../src/icons/solid/square-i.svg");
const square_info_svg_2 = require("../src/icons/solid/square-info.svg");
const square_j_svg_2 = require("../src/icons/solid/square-j.svg");
const square_k_svg_2 = require("../src/icons/solid/square-k.svg");
const square_l_svg_2 = require("../src/icons/solid/square-l.svg");
const square_left_svg_2 = require("../src/icons/solid/square-left.svg");
const square_m_svg_2 = require("../src/icons/solid/square-m.svg");
const square_minus_svg_2 = require("../src/icons/solid/square-minus.svg");
const square_n_svg_2 = require("../src/icons/solid/square-n.svg");
const square_o_svg_2 = require("../src/icons/solid/square-o.svg");
const square_p_svg_2 = require("../src/icons/solid/square-p.svg");
const square_parking_slash_svg_2 = require("../src/icons/solid/square-parking-slash.svg");
const square_parking_svg_2 = require("../src/icons/solid/square-parking.svg");
const square_pen_svg_2 = require("../src/icons/solid/square-pen.svg");
const square_phone_flip_svg_2 = require("../src/icons/solid/square-phone-flip.svg");
const square_phone_hangup_svg_2 = require("../src/icons/solid/square-phone-hangup.svg");
const square_phone_svg_2 = require("../src/icons/solid/square-phone.svg");
const square_plus_svg_2 = require("../src/icons/solid/square-plus.svg");
const square_poll_horizontal_svg_2 = require("../src/icons/solid/square-poll-horizontal.svg");
const square_poll_vertical_svg_2 = require("../src/icons/solid/square-poll-vertical.svg");
const square_q_svg_2 = require("../src/icons/solid/square-q.svg");
const square_question_svg_2 = require("../src/icons/solid/square-question.svg");
const square_r_svg_2 = require("../src/icons/solid/square-r.svg");
const square_right_svg_2 = require("../src/icons/solid/square-right.svg");
const square_root_variable_svg_2 = require("../src/icons/solid/square-root-variable.svg");
const square_root_svg_2 = require("../src/icons/solid/square-root.svg");
const square_rss_svg_2 = require("../src/icons/solid/square-rss.svg");
const square_s_svg_2 = require("../src/icons/solid/square-s.svg");
const square_share_nodes_svg_2 = require("../src/icons/solid/square-share-nodes.svg");
const square_sliders_vertical_svg_2 = require("../src/icons/solid/square-sliders-vertical.svg");
const square_sliders_svg_2 = require("../src/icons/solid/square-sliders.svg");
const square_small_svg_2 = require("../src/icons/solid/square-small.svg");
const square_star_svg_2 = require("../src/icons/solid/square-star.svg");
const square_t_svg_2 = require("../src/icons/solid/square-t.svg");
const square_this_way_up_svg_2 = require("../src/icons/solid/square-this-way-up.svg");
const square_u_svg_2 = require("../src/icons/solid/square-u.svg");
const square_up_left_svg_2 = require("../src/icons/solid/square-up-left.svg");
const square_up_right_svg_2 = require("../src/icons/solid/square-up-right.svg");
const square_up_svg_2 = require("../src/icons/solid/square-up.svg");
const square_user_svg_2 = require("../src/icons/solid/square-user.svg");
const square_v_svg_2 = require("../src/icons/solid/square-v.svg");
const square_w_svg_2 = require("../src/icons/solid/square-w.svg");
const square_x_svg_2 = require("../src/icons/solid/square-x.svg");
const square_xmark_svg_2 = require("../src/icons/solid/square-xmark.svg");
const square_y_svg_2 = require("../src/icons/solid/square-y.svg");
const square_z_svg_2 = require("../src/icons/solid/square-z.svg");
const square_svg_2 = require("../src/icons/solid/square.svg");
const squirrel_svg_2 = require("../src/icons/solid/squirrel.svg");
const staff_svg_2 = require("../src/icons/solid/staff.svg");
const stairs_svg_2 = require("../src/icons/solid/stairs.svg");
const stamp_svg_2 = require("../src/icons/solid/stamp.svg");
const standard_definition_svg_2 = require("../src/icons/solid/standard-definition.svg");
const star_and_crescent_svg_2 = require("../src/icons/solid/star-and-crescent.svg");
const star_christmas_svg_2 = require("../src/icons/solid/star-christmas.svg");
const star_exclamation_svg_2 = require("../src/icons/solid/star-exclamation.svg");
const star_half_stroke_svg_2 = require("../src/icons/solid/star-half-stroke.svg");
const star_half_svg_2 = require("../src/icons/solid/star-half.svg");
const star_of_david_svg_2 = require("../src/icons/solid/star-of-david.svg");
const star_of_life_svg_2 = require("../src/icons/solid/star-of-life.svg");
const star_sharp_half_stroke_svg_2 = require("../src/icons/solid/star-sharp-half-stroke.svg");
const star_sharp_half_svg_2 = require("../src/icons/solid/star-sharp-half.svg");
const star_sharp_svg_2 = require("../src/icons/solid/star-sharp.svg");
const star_shooting_svg_2 = require("../src/icons/solid/star-shooting.svg");
const star_svg_2 = require("../src/icons/solid/star.svg");
const starfighter_twin_ion_engine_advanced_svg_2 = require("../src/icons/solid/starfighter-twin-ion-engine-advanced.svg");
const starfighter_twin_ion_engine_svg_2 = require("../src/icons/solid/starfighter-twin-ion-engine.svg");
const starfighter_svg_2 = require("../src/icons/solid/starfighter.svg");
const stars_svg_2 = require("../src/icons/solid/stars.svg");
const starship_freighter_svg_2 = require("../src/icons/solid/starship-freighter.svg");
const starship_svg_2 = require("../src/icons/solid/starship.svg");
const steak_svg_2 = require("../src/icons/solid/steak.svg");
const steering_wheel_svg_2 = require("../src/icons/solid/steering-wheel.svg");
const sterling_sign_svg_2 = require("../src/icons/solid/sterling-sign.svg");
const stethoscope_svg_2 = require("../src/icons/solid/stethoscope.svg");
const stocking_svg_2 = require("../src/icons/solid/stocking.svg");
const stomach_svg_2 = require("../src/icons/solid/stomach.svg");
const stop_svg_2 = require("../src/icons/solid/stop.svg");
const stopwatch_20_svg_2 = require("../src/icons/solid/stopwatch-20.svg");
const stopwatch_svg_2 = require("../src/icons/solid/stopwatch.svg");
const store_slash_svg_2 = require("../src/icons/solid/store-slash.svg");
const store_svg_2 = require("../src/icons/solid/store.svg");
const street_view_svg_2 = require("../src/icons/solid/street-view.svg");
const stretcher_svg_2 = require("../src/icons/solid/stretcher.svg");
const strikethrough_svg_2 = require("../src/icons/solid/strikethrough.svg");
const stroopwafel_svg_2 = require("../src/icons/solid/stroopwafel.svg");
const subscript_svg_2 = require("../src/icons/solid/subscript.svg");
const suitcase_medical_svg_2 = require("../src/icons/solid/suitcase-medical.svg");
const suitcase_rolling_svg_2 = require("../src/icons/solid/suitcase-rolling.svg");
const suitcase_svg_2 = require("../src/icons/solid/suitcase.svg");
const sun_bright_svg_2 = require("../src/icons/solid/sun-bright.svg");
const sun_cloud_svg_2 = require("../src/icons/solid/sun-cloud.svg");
const sun_dust_svg_2 = require("../src/icons/solid/sun-dust.svg");
const sun_haze_svg_2 = require("../src/icons/solid/sun-haze.svg");
const sun_svg_2 = require("../src/icons/solid/sun.svg");
const sunglasses_svg_2 = require("../src/icons/solid/sunglasses.svg");
const sunrise_svg_2 = require("../src/icons/solid/sunrise.svg");
const sunset_svg_2 = require("../src/icons/solid/sunset.svg");
const superscript_svg_2 = require("../src/icons/solid/superscript.svg");
const swatchbook_svg_2 = require("../src/icons/solid/swatchbook.svg");
const sword_laser_alt_svg_2 = require("../src/icons/solid/sword-laser-alt.svg");
const sword_laser_svg_2 = require("../src/icons/solid/sword-laser.svg");
const sword_svg_2 = require("../src/icons/solid/sword.svg");
const swords_laser_svg_2 = require("../src/icons/solid/swords-laser.svg");
const swords_svg_2 = require("../src/icons/solid/swords.svg");
const symbols_svg_2 = require("../src/icons/solid/symbols.svg");
const synagogue_svg_2 = require("../src/icons/solid/synagogue.svg");
const syringe_svg_2 = require("../src/icons/solid/syringe.svg");
const t_svg_2 = require("../src/icons/solid/t.svg");
const table_cells_large_svg_2 = require("../src/icons/solid/table-cells-large.svg");
const table_cells_svg_2 = require("../src/icons/solid/table-cells.svg");
const table_columns_svg_2 = require("../src/icons/solid/table-columns.svg");
const table_layout_svg_2 = require("../src/icons/solid/table-layout.svg");
const table_list_svg_2 = require("../src/icons/solid/table-list.svg");
const table_pivot_svg_2 = require("../src/icons/solid/table-pivot.svg");
const table_rows_svg_2 = require("../src/icons/solid/table-rows.svg");
const table_tennis_paddle_ball_svg_2 = require("../src/icons/solid/table-tennis-paddle-ball.svg");
const table_tree_svg_2 = require("../src/icons/solid/table-tree.svg");
const table_svg_2 = require("../src/icons/solid/table.svg");
const tablet_button_svg_2 = require("../src/icons/solid/tablet-button.svg");
const tablet_rugged_svg_2 = require("../src/icons/solid/tablet-rugged.svg");
const tablet_screen_button_svg_2 = require("../src/icons/solid/tablet-screen-button.svg");
const tablet_screen_svg_2 = require("../src/icons/solid/tablet-screen.svg");
const tablet_svg_2 = require("../src/icons/solid/tablet.svg");
const tablets_svg_2 = require("../src/icons/solid/tablets.svg");
const tachograph_digital_svg_2 = require("../src/icons/solid/tachograph-digital.svg");
const taco_svg_2 = require("../src/icons/solid/taco.svg");
const tag_svg_2 = require("../src/icons/solid/tag.svg");
const tags_svg_2 = require("../src/icons/solid/tags.svg");
const tally_1_svg_2 = require("../src/icons/solid/tally-1.svg");
const tally_2_svg_2 = require("../src/icons/solid/tally-2.svg");
const tally_3_svg_2 = require("../src/icons/solid/tally-3.svg");
const tally_4_svg_2 = require("../src/icons/solid/tally-4.svg");
const tally_svg_2 = require("../src/icons/solid/tally.svg");
const tape_svg_2 = require("../src/icons/solid/tape.svg");
const taxi_bus_svg_2 = require("../src/icons/solid/taxi-bus.svg");
const taxi_svg_2 = require("../src/icons/solid/taxi.svg");
const teeth_open_svg_2 = require("../src/icons/solid/teeth-open.svg");
const teeth_svg_2 = require("../src/icons/solid/teeth.svg");
const telescope_svg_2 = require("../src/icons/solid/telescope.svg");
const temperature_arrow_down_svg_2 = require("../src/icons/solid/temperature-arrow-down.svg");
const temperature_arrow_up_svg_2 = require("../src/icons/solid/temperature-arrow-up.svg");
const temperature_empty_svg_2 = require("../src/icons/solid/temperature-empty.svg");
const temperature_full_svg_2 = require("../src/icons/solid/temperature-full.svg");
const temperature_half_svg_2 = require("../src/icons/solid/temperature-half.svg");
const temperature_high_svg_2 = require("../src/icons/solid/temperature-high.svg");
const temperature_list_svg_2 = require("../src/icons/solid/temperature-list.svg");
const temperature_low_svg_2 = require("../src/icons/solid/temperature-low.svg");
const temperature_quarter_svg_2 = require("../src/icons/solid/temperature-quarter.svg");
const temperature_snow_svg_2 = require("../src/icons/solid/temperature-snow.svg");
const temperature_sun_svg_2 = require("../src/icons/solid/temperature-sun.svg");
const temperature_three_quarters_svg_2 = require("../src/icons/solid/temperature-three-quarters.svg");
const tenge_sign_svg_2 = require("../src/icons/solid/tenge-sign.svg");
const tennis_ball_svg_2 = require("../src/icons/solid/tennis-ball.svg");
const terminal_svg_2 = require("../src/icons/solid/terminal.svg");
const text_height_svg_2 = require("../src/icons/solid/text-height.svg");
const text_size_svg_2 = require("../src/icons/solid/text-size.svg");
const text_slash_svg_2 = require("../src/icons/solid/text-slash.svg");
const text_width_svg_2 = require("../src/icons/solid/text-width.svg");
const text_svg_2 = require("../src/icons/solid/text.svg");
const thermometer_svg_2 = require("../src/icons/solid/thermometer.svg");
const theta_svg_2 = require("../src/icons/solid/theta.svg");
const thumbs_down_svg_2 = require("../src/icons/solid/thumbs-down.svg");
const thumbs_up_svg_2 = require("../src/icons/solid/thumbs-up.svg");
const thumbtack_svg_2 = require("../src/icons/solid/thumbtack.svg");
const ticket_airline_svg_2 = require("../src/icons/solid/ticket-airline.svg");
const ticket_simple_svg_2 = require("../src/icons/solid/ticket-simple.svg");
const ticket_svg_2 = require("../src/icons/solid/ticket.svg");
const tickets_airline_svg_2 = require("../src/icons/solid/tickets-airline.svg");
const tilde_svg_2 = require("../src/icons/solid/tilde.svg");
const timeline_arrow_svg_2 = require("../src/icons/solid/timeline-arrow.svg");
const timeline_svg_2 = require("../src/icons/solid/timeline.svg");
const timer_svg_2 = require("../src/icons/solid/timer.svg");
const tire_flat_svg_2 = require("../src/icons/solid/tire-flat.svg");
const tire_pressure_warning_svg_2 = require("../src/icons/solid/tire-pressure-warning.svg");
const tire_rugged_svg_2 = require("../src/icons/solid/tire-rugged.svg");
const tire_svg_2 = require("../src/icons/solid/tire.svg");
const toggle_off_svg_2 = require("../src/icons/solid/toggle-off.svg");
const toggle_on_svg_2 = require("../src/icons/solid/toggle-on.svg");
const toilet_paper_blank_under_svg_2 = require("../src/icons/solid/toilet-paper-blank-under.svg");
const toilet_paper_blank_svg_2 = require("../src/icons/solid/toilet-paper-blank.svg");
const toilet_paper_slash_svg_2 = require("../src/icons/solid/toilet-paper-slash.svg");
const toilet_paper_under_slash_svg_2 = require("../src/icons/solid/toilet-paper-under-slash.svg");
const toilet_paper_under_svg_2 = require("../src/icons/solid/toilet-paper-under.svg");
const toilet_paper_svg_2 = require("../src/icons/solid/toilet-paper.svg");
const toilet_svg_2 = require("../src/icons/solid/toilet.svg");
const tombstone_blank_svg_2 = require("../src/icons/solid/tombstone-blank.svg");
const tombstone_svg_2 = require("../src/icons/solid/tombstone.svg");
const toolbox_svg_2 = require("../src/icons/solid/toolbox.svg");
const tooth_svg_2 = require("../src/icons/solid/tooth.svg");
const toothbrush_svg_2 = require("../src/icons/solid/toothbrush.svg");
const torii_gate_svg_2 = require("../src/icons/solid/torii-gate.svg");
const tornado_svg_2 = require("../src/icons/solid/tornado.svg");
const tower_broadcast_svg_2 = require("../src/icons/solid/tower-broadcast.svg");
const tower_control_svg_2 = require("../src/icons/solid/tower-control.svg");
const tractor_svg_2 = require("../src/icons/solid/tractor.svg");
const trademark_svg_2 = require("../src/icons/solid/trademark.svg");
const traffic_cone_svg_2 = require("../src/icons/solid/traffic-cone.svg");
const traffic_light_go_svg_2 = require("../src/icons/solid/traffic-light-go.svg");
const traffic_light_slow_svg_2 = require("../src/icons/solid/traffic-light-slow.svg");
const traffic_light_stop_svg_2 = require("../src/icons/solid/traffic-light-stop.svg");
const traffic_light_svg_2 = require("../src/icons/solid/traffic-light.svg");
const trailer_svg_2 = require("../src/icons/solid/trailer.svg");
const train_subway_tunnel_svg_2 = require("../src/icons/solid/train-subway-tunnel.svg");
const train_subway_svg_2 = require("../src/icons/solid/train-subway.svg");
const train_tram_svg_2 = require("../src/icons/solid/train-tram.svg");
const train_svg_2 = require("../src/icons/solid/train.svg");
const transformer_bolt_svg_2 = require("../src/icons/solid/transformer-bolt.svg");
const transgender_alt_svg_2 = require("../src/icons/solid/transgender-alt.svg");
const transgender_svg_2 = require("../src/icons/solid/transgender.svg");
const transporter_1_svg_2 = require("../src/icons/solid/transporter-1.svg");
const transporter_2_svg_2 = require("../src/icons/solid/transporter-2.svg");
const transporter_3_svg_2 = require("../src/icons/solid/transporter-3.svg");
const transporter_4_svg_2 = require("../src/icons/solid/transporter-4.svg");
const transporter_5_svg_2 = require("../src/icons/solid/transporter-5.svg");
const transporter_6_svg_2 = require("../src/icons/solid/transporter-6.svg");
const transporter_7_svg_2 = require("../src/icons/solid/transporter-7.svg");
const transporter_empty_svg_2 = require("../src/icons/solid/transporter-empty.svg");
const transporter_svg_2 = require("../src/icons/solid/transporter.svg");
const trash_arrow_up_svg_2 = require("../src/icons/solid/trash-arrow-up.svg");
const trash_can_arrow_up_svg_2 = require("../src/icons/solid/trash-can-arrow-up.svg");
const trash_can_clock_svg_2 = require("../src/icons/solid/trash-can-clock.svg");
const trash_can_list_svg_2 = require("../src/icons/solid/trash-can-list.svg");
const trash_can_slash_svg_2 = require("../src/icons/solid/trash-can-slash.svg");
const trash_can_undo_svg_2 = require("../src/icons/solid/trash-can-undo.svg");
const trash_can_svg_2 = require("../src/icons/solid/trash-can.svg");
const trash_clock_svg_2 = require("../src/icons/solid/trash-clock.svg");
const trash_list_svg_2 = require("../src/icons/solid/trash-list.svg");
const trash_slash_svg_2 = require("../src/icons/solid/trash-slash.svg");
const trash_undo_svg_2 = require("../src/icons/solid/trash-undo.svg");
const trash_svg_2 = require("../src/icons/solid/trash.svg");
const treasure_chest_svg_2 = require("../src/icons/solid/treasure-chest.svg");
const tree_christmas_svg_2 = require("../src/icons/solid/tree-christmas.svg");
const tree_deciduous_svg_2 = require("../src/icons/solid/tree-deciduous.svg");
const tree_decorated_svg_2 = require("../src/icons/solid/tree-decorated.svg");
const tree_large_svg_2 = require("../src/icons/solid/tree-large.svg");
const tree_palm_svg_2 = require("../src/icons/solid/tree-palm.svg");
const tree_svg_2 = require("../src/icons/solid/tree.svg");
const trees_svg_2 = require("../src/icons/solid/trees.svg");
const triangle_exclamation_svg_2 = require("../src/icons/solid/triangle-exclamation.svg");
const triangle_instrument_svg_2 = require("../src/icons/solid/triangle-instrument.svg");
const triangle_person_digging_svg_2 = require("../src/icons/solid/triangle-person-digging.svg");
const triangle_svg_2 = require("../src/icons/solid/triangle.svg");
const trophy_star_svg_2 = require("../src/icons/solid/trophy-star.svg");
const trophy_svg_2 = require("../src/icons/solid/trophy.svg");
const truck_clock_svg_2 = require("../src/icons/solid/truck-clock.svg");
const truck_container_empty_svg_2 = require("../src/icons/solid/truck-container-empty.svg");
const truck_container_svg_2 = require("../src/icons/solid/truck-container.svg");
const truck_fast_svg_2 = require("../src/icons/solid/truck-fast.svg");
const truck_flatbed_svg_2 = require("../src/icons/solid/truck-flatbed.svg");
const truck_front_svg_2 = require("../src/icons/solid/truck-front.svg");
const truck_medical_svg_2 = require("../src/icons/solid/truck-medical.svg");
const truck_monster_svg_2 = require("../src/icons/solid/truck-monster.svg");
const truck_moving_svg_2 = require("../src/icons/solid/truck-moving.svg");
const truck_pickup_svg_2 = require("../src/icons/solid/truck-pickup.svg");
const truck_plow_svg_2 = require("../src/icons/solid/truck-plow.svg");
const truck_ramp_box_svg_2 = require("../src/icons/solid/truck-ramp-box.svg");
const truck_ramp_couch_svg_2 = require("../src/icons/solid/truck-ramp-couch.svg");
const truck_ramp_svg_2 = require("../src/icons/solid/truck-ramp.svg");
const truck_tow_svg_2 = require("../src/icons/solid/truck-tow.svg");
const truck_svg_2 = require("../src/icons/solid/truck.svg");
const trumpet_svg_2 = require("../src/icons/solid/trumpet.svg");
const tshirt_svg_2 = require("../src/icons/solid/tshirt.svg");
const tty_answer_svg_2 = require("../src/icons/solid/tty-answer.svg");
const tty_svg_2 = require("../src/icons/solid/tty.svg");
const tugrik_sign_svg_2 = require("../src/icons/solid/tugrik-sign.svg");
const turkey_svg_2 = require("../src/icons/solid/turkey.svg");
const turkish_lira_sign_svg_2 = require("../src/icons/solid/turkish-lira-sign.svg");
const turn_down_svg_2 = require("../src/icons/solid/turn-down.svg");
const turn_up_svg_2 = require("../src/icons/solid/turn-up.svg");
const turntable_svg_2 = require("../src/icons/solid/turntable.svg");
const turtle_svg_2 = require("../src/icons/solid/turtle.svg");
const tv_music_svg_2 = require("../src/icons/solid/tv-music.svg");
const tv_retro_svg_2 = require("../src/icons/solid/tv-retro.svg");
const tv_svg_2 = require("../src/icons/solid/tv.svg");
const typewriter_svg_2 = require("../src/icons/solid/typewriter.svg");
const u_svg_2 = require("../src/icons/solid/u.svg");
const ufo_beam_svg_2 = require("../src/icons/solid/ufo-beam.svg");
const ufo_svg_2 = require("../src/icons/solid/ufo.svg");
const umbrella_beach_svg_2 = require("../src/icons/solid/umbrella-beach.svg");
const umbrella_simple_svg_2 = require("../src/icons/solid/umbrella-simple.svg");
const umbrella_svg_2 = require("../src/icons/solid/umbrella.svg");
const underline_svg_2 = require("../src/icons/solid/underline.svg");
const unicorn_svg_2 = require("../src/icons/solid/unicorn.svg");
const union_svg_2 = require("../src/icons/solid/union.svg");
const universal_access_svg_2 = require("../src/icons/solid/universal-access.svg");
const unlock_keyhole_svg_2 = require("../src/icons/solid/unlock-keyhole.svg");
const unlock_svg_2 = require("../src/icons/solid/unlock.svg");
const up_down_left_right_svg_2 = require("../src/icons/solid/up-down-left-right.svg");
const up_down_svg_2 = require("../src/icons/solid/up-down.svg");
const up_from_line_svg_2 = require("../src/icons/solid/up-from-line.svg");
const up_left_svg_2 = require("../src/icons/solid/up-left.svg");
const up_long_svg_2 = require("../src/icons/solid/up-long.svg");
const up_right_and_down_left_from_center_svg_2 = require("../src/icons/solid/up-right-and-down-left-from-center.svg");
const up_right_from_square_svg_2 = require("../src/icons/solid/up-right-from-square.svg");
const up_right_svg_2 = require("../src/icons/solid/up-right.svg");
const up_to_line_svg_2 = require("../src/icons/solid/up-to-line.svg");
const up_svg_2 = require("../src/icons/solid/up.svg");
const upload_svg_2 = require("../src/icons/solid/upload.svg");
const usb_drive_svg_2 = require("../src/icons/solid/usb-drive.svg");
const user_alien_svg_2 = require("../src/icons/solid/user-alien.svg");
const user_astronaut_svg_2 = require("../src/icons/solid/user-astronaut.svg");
const user_bounty_hunter_svg_2 = require("../src/icons/solid/user-bounty-hunter.svg");
const user_check_svg_2 = require("../src/icons/solid/user-check.svg");
const user_clock_svg_2 = require("../src/icons/solid/user-clock.svg");
const user_cowboy_svg_2 = require("../src/icons/solid/user-cowboy.svg");
const user_crown_svg_2 = require("../src/icons/solid/user-crown.svg");
const user_doctor_message_svg_2 = require("../src/icons/solid/user-doctor-message.svg");
const user_doctor_svg_2 = require("../src/icons/solid/user-doctor.svg");
const user_gear_svg_2 = require("../src/icons/solid/user-gear.svg");
const user_graduate_svg_2 = require("../src/icons/solid/user-graduate.svg");
const user_group_crown_svg_2 = require("../src/icons/solid/user-group-crown.svg");
const user_group_svg_2 = require("../src/icons/solid/user-group.svg");
const user_headset_svg_2 = require("../src/icons/solid/user-headset.svg");
const user_helmet_safety_svg_2 = require("../src/icons/solid/user-helmet-safety.svg");
const user_injured_svg_2 = require("../src/icons/solid/user-injured.svg");
const user_large_slash_svg_2 = require("../src/icons/solid/user-large-slash.svg");
const user_large_svg_2 = require("../src/icons/solid/user-large.svg");
const user_lock_svg_2 = require("../src/icons/solid/user-lock.svg");
const user_minus_svg_2 = require("../src/icons/solid/user-minus.svg");
const user_music_svg_2 = require("../src/icons/solid/user-music.svg");
const user_ninja_svg_2 = require("../src/icons/solid/user-ninja.svg");
const user_nurse_svg_2 = require("../src/icons/solid/user-nurse.svg");
const user_pen_svg_2 = require("../src/icons/solid/user-pen.svg");
const user_pilot_tie_svg_2 = require("../src/icons/solid/user-pilot-tie.svg");
const user_pilot_svg_2 = require("../src/icons/solid/user-pilot.svg");
const user_plus_svg_2 = require("../src/icons/solid/user-plus.svg");
const user_robot_svg_2 = require("../src/icons/solid/user-robot.svg");
const user_secret_svg_2 = require("../src/icons/solid/user-secret.svg");
const user_shakespeare_svg_2 = require("../src/icons/solid/user-shakespeare.svg");
const user_shield_svg_2 = require("../src/icons/solid/user-shield.svg");
const user_slash_svg_2 = require("../src/icons/solid/user-slash.svg");
const user_tag_svg_2 = require("../src/icons/solid/user-tag.svg");
const user_tie_svg_2 = require("../src/icons/solid/user-tie.svg");
const user_unlock_svg_2 = require("../src/icons/solid/user-unlock.svg");
const user_visor_svg_2 = require("../src/icons/solid/user-visor.svg");
const user_xmark_svg_2 = require("../src/icons/solid/user-xmark.svg");
const user_svg_2 = require("../src/icons/solid/user.svg");
const users_gear_svg_2 = require("../src/icons/solid/users-gear.svg");
const users_medical_svg_2 = require("../src/icons/solid/users-medical.svg");
const users_slash_svg_2 = require("../src/icons/solid/users-slash.svg");
const users_svg_2 = require("../src/icons/solid/users.svg");
const utensils_svg_2 = require("../src/icons/solid/utensils.svg");
const utility_pole_double_svg_2 = require("../src/icons/solid/utility-pole-double.svg");
const utility_pole_svg_2 = require("../src/icons/solid/utility-pole.svg");
const v_svg_2 = require("../src/icons/solid/v.svg");
const vacuum_robot_svg_2 = require("../src/icons/solid/vacuum-robot.svg");
const vacuum_svg_2 = require("../src/icons/solid/vacuum.svg");
const value_absolute_svg_2 = require("../src/icons/solid/value-absolute.svg");
const van_shuttle_svg_2 = require("../src/icons/solid/van-shuttle.svg");
const vault_svg_2 = require("../src/icons/solid/vault.svg");
const vector_circle_svg_2 = require("../src/icons/solid/vector-circle.svg");
const vector_polygon_svg_2 = require("../src/icons/solid/vector-polygon.svg");
const vector_square_svg_2 = require("../src/icons/solid/vector-square.svg");
const venus_double_svg_2 = require("../src/icons/solid/venus-double.svg");
const venus_mars_svg_2 = require("../src/icons/solid/venus-mars.svg");
const venus_svg_2 = require("../src/icons/solid/venus.svg");
const vest_patches_svg_2 = require("../src/icons/solid/vest-patches.svg");
const vest_svg_2 = require("../src/icons/solid/vest.svg");
const vial_svg_2 = require("../src/icons/solid/vial.svg");
const vials_svg_2 = require("../src/icons/solid/vials.svg");
const video_arrow_down_left_svg_2 = require("../src/icons/solid/video-arrow-down-left.svg");
const video_arrow_up_right_svg_2 = require("../src/icons/solid/video-arrow-up-right.svg");
const video_plus_svg_2 = require("../src/icons/solid/video-plus.svg");
const video_slash_svg_2 = require("../src/icons/solid/video-slash.svg");
const video_svg_2 = require("../src/icons/solid/video.svg");
const vihara_svg_2 = require("../src/icons/solid/vihara.svg");
const violin_svg_2 = require("../src/icons/solid/violin.svg");
const virus_slash_svg_2 = require("../src/icons/solid/virus-slash.svg");
const virus_svg_2 = require("../src/icons/solid/virus.svg");
const viruses_svg_2 = require("../src/icons/solid/viruses.svg");
const voicemail_svg_2 = require("../src/icons/solid/voicemail.svg");
const volcano_svg_2 = require("../src/icons/solid/volcano.svg");
const volleyball_ball_svg_2 = require("../src/icons/solid/volleyball-ball.svg");
const volume_high_svg_2 = require("../src/icons/solid/volume-high.svg");
const volume_low_svg_2 = require("../src/icons/solid/volume-low.svg");
const volume_off_svg_2 = require("../src/icons/solid/volume-off.svg");
const volume_slash_svg_2 = require("../src/icons/solid/volume-slash.svg");
const volume_xmark_svg_2 = require("../src/icons/solid/volume-xmark.svg");
const volume_svg_2 = require("../src/icons/solid/volume.svg");
const vr_cardboard_svg_2 = require("../src/icons/solid/vr-cardboard.svg");
const w_svg_2 = require("../src/icons/solid/w.svg");
const wagon_covered_svg_2 = require("../src/icons/solid/wagon-covered.svg");
const walker_svg_2 = require("../src/icons/solid/walker.svg");
const walkie_talkie_svg_2 = require("../src/icons/solid/walkie-talkie.svg");
const wallet_svg_2 = require("../src/icons/solid/wallet.svg");
const wand_magic_sparkles_svg_2 = require("../src/icons/solid/wand-magic-sparkles.svg");
const wand_magic_svg_2 = require("../src/icons/solid/wand-magic.svg");
const wand_sparkles_svg_2 = require("../src/icons/solid/wand-sparkles.svg");
const wand_svg_2 = require("../src/icons/solid/wand.svg");
const warehouse_full_svg_2 = require("../src/icons/solid/warehouse-full.svg");
const warehouse_svg_2 = require("../src/icons/solid/warehouse.svg");
const washing_machine_svg_2 = require("../src/icons/solid/washing-machine.svg");
const watch_apple_svg_2 = require("../src/icons/solid/watch-apple.svg");
const watch_calculator_svg_2 = require("../src/icons/solid/watch-calculator.svg");
const watch_fitness_svg_2 = require("../src/icons/solid/watch-fitness.svg");
const watch_smart_svg_2 = require("../src/icons/solid/watch-smart.svg");
const watch_svg_2 = require("../src/icons/solid/watch.svg");
const water_arrow_down_svg_2 = require("../src/icons/solid/water-arrow-down.svg");
const water_arrow_up_svg_2 = require("../src/icons/solid/water-arrow-up.svg");
const water_ladder_svg_2 = require("../src/icons/solid/water-ladder.svg");
const water_svg_2 = require("../src/icons/solid/water.svg");
const wave_pulse_svg_2 = require("../src/icons/solid/wave-pulse.svg");
const wave_sine_svg_2 = require("../src/icons/solid/wave-sine.svg");
const wave_square_svg_2 = require("../src/icons/solid/wave-square.svg");
const wave_triangle_svg_2 = require("../src/icons/solid/wave-triangle.svg");
const waveform_lines_svg_2 = require("../src/icons/solid/waveform-lines.svg");
const waveform_svg_2 = require("../src/icons/solid/waveform.svg");
const weight_hanging_svg_2 = require("../src/icons/solid/weight-hanging.svg");
const weight_scale_svg_2 = require("../src/icons/solid/weight-scale.svg");
const whale_svg_2 = require("../src/icons/solid/whale.svg");
const wheat_awn_svg_2 = require("../src/icons/solid/wheat-awn.svg");
const wheat_svg_2 = require("../src/icons/solid/wheat.svg");
const wheelchair_move_svg_2 = require("../src/icons/solid/wheelchair-move.svg");
const wheelchair_svg_2 = require("../src/icons/solid/wheelchair.svg");
const whiskey_glass_ice_svg_2 = require("../src/icons/solid/whiskey-glass-ice.svg");
const whiskey_glass_svg_2 = require("../src/icons/solid/whiskey-glass.svg");
const whistle_svg_2 = require("../src/icons/solid/whistle.svg");
const wifi_exclamation_svg_2 = require("../src/icons/solid/wifi-exclamation.svg");
const wifi_fair_svg_2 = require("../src/icons/solid/wifi-fair.svg");
const wifi_slash_svg_2 = require("../src/icons/solid/wifi-slash.svg");
const wifi_weak_svg_2 = require("../src/icons/solid/wifi-weak.svg");
const wifi_svg_2 = require("../src/icons/solid/wifi.svg");
const wind_turbine_svg_2 = require("../src/icons/solid/wind-turbine.svg");
const wind_warning_svg_2 = require("../src/icons/solid/wind-warning.svg");
const wind_svg_2 = require("../src/icons/solid/wind.svg");
const window_flip_svg_2 = require("../src/icons/solid/window-flip.svg");
const window_frame_open_svg_2 = require("../src/icons/solid/window-frame-open.svg");
const window_frame_svg_2 = require("../src/icons/solid/window-frame.svg");
const window_maximize_svg_2 = require("../src/icons/solid/window-maximize.svg");
const window_minimize_svg_2 = require("../src/icons/solid/window-minimize.svg");
const window_restore_svg_2 = require("../src/icons/solid/window-restore.svg");
const window_svg_2 = require("../src/icons/solid/window.svg");
const windsock_svg_2 = require("../src/icons/solid/windsock.svg");
const wine_bottle_svg_2 = require("../src/icons/solid/wine-bottle.svg");
const wine_glass_crack_svg_2 = require("../src/icons/solid/wine-glass-crack.svg");
const wine_glass_empty_svg_2 = require("../src/icons/solid/wine-glass-empty.svg");
const wine_glass_svg_2 = require("../src/icons/solid/wine-glass.svg");
const won_sign_svg_2 = require("../src/icons/solid/won-sign.svg");
const wreath_svg_2 = require("../src/icons/solid/wreath.svg");
const wrench_simple_svg_2 = require("../src/icons/solid/wrench-simple.svg");
const wrench_svg_2 = require("../src/icons/solid/wrench.svg");
const x_ray_svg_2 = require("../src/icons/solid/x-ray.svg");
const x_svg_2 = require("../src/icons/solid/x.svg");
const xmark_to_slot_svg_2 = require("../src/icons/solid/xmark-to-slot.svg");
const xmark_svg_2 = require("../src/icons/solid/xmark.svg");
const y_svg_2 = require("../src/icons/solid/y.svg");
const yen_sign_svg_2 = require("../src/icons/solid/yen-sign.svg");
const yin_yang_svg_2 = require("../src/icons/solid/yin-yang.svg");
const z_svg_2 = require("../src/icons/solid/z.svg");
const _0_svg_3 = require("../src/icons/thin/0.svg");
const _1_svg_3 = require("../src/icons/thin/1.svg");
const _2_svg_3 = require("../src/icons/thin/2.svg");
const _3_svg_3 = require("../src/icons/thin/3.svg");
const _4_svg_3 = require("../src/icons/thin/4.svg");
const _5_svg_3 = require("../src/icons/thin/5.svg");
const _6_svg_3 = require("../src/icons/thin/6.svg");
const _7_svg_3 = require("../src/icons/thin/7.svg");
const _8_svg_3 = require("../src/icons/thin/8.svg");
const _9_svg_3 = require("../src/icons/thin/9.svg");
const a_svg_3 = require("../src/icons/thin/a.svg");
const abacus_svg_3 = require("../src/icons/thin/abacus.svg");
const acorn_svg_3 = require("../src/icons/thin/acorn.svg");
const address_book_svg_3 = require("../src/icons/thin/address-book.svg");
const address_card_svg_3 = require("../src/icons/thin/address-card.svg");
const air_conditioner_svg_3 = require("../src/icons/thin/air-conditioner.svg");
const air_freshener_svg_3 = require("../src/icons/thin/air-freshener.svg");
const airplay_svg_3 = require("../src/icons/thin/airplay.svg");
const alarm_clock_svg_3 = require("../src/icons/thin/alarm-clock.svg");
const alarm_exclamation_svg_3 = require("../src/icons/thin/alarm-exclamation.svg");
const alarm_plus_svg_3 = require("../src/icons/thin/alarm-plus.svg");
const alarm_snooze_svg_3 = require("../src/icons/thin/alarm-snooze.svg");
const album_collection_svg_3 = require("../src/icons/thin/album-collection.svg");
const album_svg_3 = require("../src/icons/thin/album.svg");
const alicorn_svg_3 = require("../src/icons/thin/alicorn.svg");
const alien_8bit_svg_3 = require("../src/icons/thin/alien-8bit.svg");
const alien_svg_3 = require("../src/icons/thin/alien.svg");
const align_center_svg_3 = require("../src/icons/thin/align-center.svg");
const align_justify_svg_3 = require("../src/icons/thin/align-justify.svg");
const align_left_svg_3 = require("../src/icons/thin/align-left.svg");
const align_right_svg_3 = require("../src/icons/thin/align-right.svg");
const align_slash_svg_3 = require("../src/icons/thin/align-slash.svg");
const alt_svg_3 = require("../src/icons/thin/alt.svg");
const amp_guitar_svg_3 = require("../src/icons/thin/amp-guitar.svg");
const ampersand_svg_3 = require("../src/icons/thin/ampersand.svg");
const anchor_svg_3 = require("../src/icons/thin/anchor.svg");
const angel_svg_3 = require("../src/icons/thin/angel.svg");
const angle_90_svg_3 = require("../src/icons/thin/angle-90.svg");
const angle_down_svg_3 = require("../src/icons/thin/angle-down.svg");
const angle_left_svg_3 = require("../src/icons/thin/angle-left.svg");
const angle_right_svg_3 = require("../src/icons/thin/angle-right.svg");
const angle_up_svg_3 = require("../src/icons/thin/angle-up.svg");
const angle_svg_3 = require("../src/icons/thin/angle.svg");
const angles_down_svg_3 = require("../src/icons/thin/angles-down.svg");
const angles_left_svg_3 = require("../src/icons/thin/angles-left.svg");
const angles_right_svg_3 = require("../src/icons/thin/angles-right.svg");
const angles_up_svg_3 = require("../src/icons/thin/angles-up.svg");
const ankh_svg_3 = require("../src/icons/thin/ankh.svg");
const aperture_svg_3 = require("../src/icons/thin/aperture.svg");
const apple_core_svg_3 = require("../src/icons/thin/apple-core.svg");
const apple_crate_svg_3 = require("../src/icons/thin/apple-crate.svg");
const apple_whole_svg_3 = require("../src/icons/thin/apple-whole.svg");
const archway_svg_3 = require("../src/icons/thin/archway.svg");
const arrow_down_1_9_svg_3 = require("../src/icons/thin/arrow-down-1-9.svg");
const arrow_down_9_1_svg_3 = require("../src/icons/thin/arrow-down-9-1.svg");
const arrow_down_a_z_svg_3 = require("../src/icons/thin/arrow-down-a-z.svg");
const arrow_down_arrow_up_svg_3 = require("../src/icons/thin/arrow-down-arrow-up.svg");
const arrow_down_big_small_svg_3 = require("../src/icons/thin/arrow-down-big-small.svg");
const arrow_down_from_dotted_line_svg_3 = require("../src/icons/thin/arrow-down-from-dotted-line.svg");
const arrow_down_from_line_svg_3 = require("../src/icons/thin/arrow-down-from-line.svg");
const arrow_down_left_and_arrow_up_right_to_center_svg_3 = require("../src/icons/thin/arrow-down-left-and-arrow-up-right-to-center.svg");
const arrow_down_left_svg_3 = require("../src/icons/thin/arrow-down-left.svg");
const arrow_down_long_svg_3 = require("../src/icons/thin/arrow-down-long.svg");
const arrow_down_right_svg_3 = require("../src/icons/thin/arrow-down-right.svg");
const arrow_down_short_wide_svg_3 = require("../src/icons/thin/arrow-down-short-wide.svg");
const arrow_down_small_big_svg_3 = require("../src/icons/thin/arrow-down-small-big.svg");
const arrow_down_square_triangle_svg_3 = require("../src/icons/thin/arrow-down-square-triangle.svg");
const arrow_down_to_bracket_svg_3 = require("../src/icons/thin/arrow-down-to-bracket.svg");
const arrow_down_to_dotted_line_svg_3 = require("../src/icons/thin/arrow-down-to-dotted-line.svg");
const arrow_down_to_line_svg_3 = require("../src/icons/thin/arrow-down-to-line.svg");
const arrow_down_to_square_svg_3 = require("../src/icons/thin/arrow-down-to-square.svg");
const arrow_down_triangle_square_svg_3 = require("../src/icons/thin/arrow-down-triangle-square.svg");
const arrow_down_wide_short_svg_3 = require("../src/icons/thin/arrow-down-wide-short.svg");
const arrow_down_z_a_svg_3 = require("../src/icons/thin/arrow-down-z-a.svg");
const arrow_down_svg_3 = require("../src/icons/thin/arrow-down.svg");
const arrow_left_from_line_svg_3 = require("../src/icons/thin/arrow-left-from-line.svg");
const arrow_left_long_svg_3 = require("../src/icons/thin/arrow-left-long.svg");
const arrow_left_rotate_svg_3 = require("../src/icons/thin/arrow-left-rotate.svg");
const arrow_left_to_line_svg_3 = require("../src/icons/thin/arrow-left-to-line.svg");
const arrow_left_svg_3 = require("../src/icons/thin/arrow-left.svg");
const arrow_pointer_svg_3 = require("../src/icons/thin/arrow-pointer.svg");
const arrow_right_arrow_left_svg_3 = require("../src/icons/thin/arrow-right-arrow-left.svg");
const arrow_right_from_bracket_svg_3 = require("../src/icons/thin/arrow-right-from-bracket.svg");
const arrow_right_from_line_svg_3 = require("../src/icons/thin/arrow-right-from-line.svg");
const arrow_right_long_svg_3 = require("../src/icons/thin/arrow-right-long.svg");
const arrow_right_to_bracket_svg_3 = require("../src/icons/thin/arrow-right-to-bracket.svg");
const arrow_right_to_line_svg_3 = require("../src/icons/thin/arrow-right-to-line.svg");
const arrow_right_svg_3 = require("../src/icons/thin/arrow-right.svg");
const arrow_rotate_forward_svg_3 = require("../src/icons/thin/arrow-rotate-forward.svg");
const arrow_trend_down_svg_3 = require("../src/icons/thin/arrow-trend-down.svg");
const arrow_trend_up_svg_3 = require("../src/icons/thin/arrow-trend-up.svg");
const arrow_turn_down_svg_3 = require("../src/icons/thin/arrow-turn-down.svg");
const arrow_turn_up_svg_3 = require("../src/icons/thin/arrow-turn-up.svg");
const arrow_up_1_9_svg_3 = require("../src/icons/thin/arrow-up-1-9.svg");
const arrow_up_9_1_svg_3 = require("../src/icons/thin/arrow-up-9-1.svg");
const arrow_up_a_z_svg_3 = require("../src/icons/thin/arrow-up-a-z.svg");
const arrow_up_arrow_down_svg_3 = require("../src/icons/thin/arrow-up-arrow-down.svg");
const arrow_up_big_small_svg_3 = require("../src/icons/thin/arrow-up-big-small.svg");
const arrow_up_from_bracket_svg_3 = require("../src/icons/thin/arrow-up-from-bracket.svg");
const arrow_up_from_dotted_line_svg_3 = require("../src/icons/thin/arrow-up-from-dotted-line.svg");
const arrow_up_from_line_svg_3 = require("../src/icons/thin/arrow-up-from-line.svg");
const arrow_up_from_square_svg_3 = require("../src/icons/thin/arrow-up-from-square.svg");
const arrow_up_left_from_circle_svg_3 = require("../src/icons/thin/arrow-up-left-from-circle.svg");
const arrow_up_left_svg_3 = require("../src/icons/thin/arrow-up-left.svg");
const arrow_up_long_svg_3 = require("../src/icons/thin/arrow-up-long.svg");
const arrow_up_right_and_arrow_down_left_from_center_svg_3 = require("../src/icons/thin/arrow-up-right-and-arrow-down-left-from-center.svg");
const arrow_up_right_from_square_svg_3 = require("../src/icons/thin/arrow-up-right-from-square.svg");
const arrow_up_right_svg_3 = require("../src/icons/thin/arrow-up-right.svg");
const arrow_up_short_wide_svg_3 = require("../src/icons/thin/arrow-up-short-wide.svg");
const arrow_up_small_big_svg_3 = require("../src/icons/thin/arrow-up-small-big.svg");
const arrow_up_square_triangle_svg_3 = require("../src/icons/thin/arrow-up-square-triangle.svg");
const arrow_up_to_dotted_line_svg_3 = require("../src/icons/thin/arrow-up-to-dotted-line.svg");
const arrow_up_to_line_svg_3 = require("../src/icons/thin/arrow-up-to-line.svg");
const arrow_up_triangle_square_svg_3 = require("../src/icons/thin/arrow-up-triangle-square.svg");
const arrow_up_wide_short_svg_3 = require("../src/icons/thin/arrow-up-wide-short.svg");
const arrow_up_z_a_svg_3 = require("../src/icons/thin/arrow-up-z-a.svg");
const arrow_up_svg_3 = require("../src/icons/thin/arrow-up.svg");
const arrows_cross_svg_3 = require("../src/icons/thin/arrows-cross.svg");
const arrows_from_dotted_line_svg_3 = require("../src/icons/thin/arrows-from-dotted-line.svg");
const arrows_from_line_svg_3 = require("../src/icons/thin/arrows-from-line.svg");
const arrows_left_right_svg_3 = require("../src/icons/thin/arrows-left-right.svg");
const arrows_maximize_svg_3 = require("../src/icons/thin/arrows-maximize.svg");
const arrows_minimize_svg_3 = require("../src/icons/thin/arrows-minimize.svg");
const arrows_repeat_1_svg_3 = require("../src/icons/thin/arrows-repeat-1.svg");
const arrows_repeat_svg_3 = require("../src/icons/thin/arrows-repeat.svg");
const arrows_retweet_svg_3 = require("../src/icons/thin/arrows-retweet.svg");
const arrows_rotate_svg_3 = require("../src/icons/thin/arrows-rotate.svg");
const arrows_to_dotted_line_svg_3 = require("../src/icons/thin/arrows-to-dotted-line.svg");
const arrows_to_line_svg_3 = require("../src/icons/thin/arrows-to-line.svg");
const arrows_up_down_left_right_svg_3 = require("../src/icons/thin/arrows-up-down-left-right.svg");
const arrows_up_down_svg_3 = require("../src/icons/thin/arrows-up-down.svg");
const asterisk_svg_3 = require("../src/icons/thin/asterisk.svg");
const at_svg_3 = require("../src/icons/thin/at.svg");
const atom_simple_svg_3 = require("../src/icons/thin/atom-simple.svg");
const atom_svg_3 = require("../src/icons/thin/atom.svg");
const audio_description_slash_svg_3 = require("../src/icons/thin/audio-description-slash.svg");
const audio_description_svg_3 = require("../src/icons/thin/audio-description.svg");
const austral_sign_svg_3 = require("../src/icons/thin/austral-sign.svg");
const avocado_svg_3 = require("../src/icons/thin/avocado.svg");
const award_simple_svg_3 = require("../src/icons/thin/award-simple.svg");
const award_svg_3 = require("../src/icons/thin/award.svg");
const axe_battle_svg_3 = require("../src/icons/thin/axe-battle.svg");
const axe_svg_3 = require("../src/icons/thin/axe.svg");
const b_svg_3 = require("../src/icons/thin/b.svg");
const baby_carriage_svg_3 = require("../src/icons/thin/baby-carriage.svg");
const baby_svg_3 = require("../src/icons/thin/baby.svg");
const backpack_svg_3 = require("../src/icons/thin/backpack.svg");
const backward_fast_svg_3 = require("../src/icons/thin/backward-fast.svg");
const backward_step_svg_3 = require("../src/icons/thin/backward-step.svg");
const backward_svg_3 = require("../src/icons/thin/backward.svg");
const bacon_svg_3 = require("../src/icons/thin/bacon.svg");
const bacteria_svg_3 = require("../src/icons/thin/bacteria.svg");
const bacterium_svg_3 = require("../src/icons/thin/bacterium.svg");
const badge_check_svg_3 = require("../src/icons/thin/badge-check.svg");
const badge_dollar_svg_3 = require("../src/icons/thin/badge-dollar.svg");
const badge_percent_svg_3 = require("../src/icons/thin/badge-percent.svg");
const badge_sheriff_svg_3 = require("../src/icons/thin/badge-sheriff.svg");
const badge_svg_3 = require("../src/icons/thin/badge.svg");
const badger_honey_svg_3 = require("../src/icons/thin/badger-honey.svg");
const bag_shopping_svg_3 = require("../src/icons/thin/bag-shopping.svg");
const bags_shopping_svg_3 = require("../src/icons/thin/bags-shopping.svg");
const bahai_svg_3 = require("../src/icons/thin/bahai.svg");
const baht_sign_svg_3 = require("../src/icons/thin/baht-sign.svg");
const ball_pile_svg_3 = require("../src/icons/thin/ball-pile.svg");
const ballot_check_svg_3 = require("../src/icons/thin/ballot-check.svg");
const ballot_svg_3 = require("../src/icons/thin/ballot.svg");
const ban_bug_svg_3 = require("../src/icons/thin/ban-bug.svg");
const ban_parking_svg_3 = require("../src/icons/thin/ban-parking.svg");
const ban_smoking_svg_3 = require("../src/icons/thin/ban-smoking.svg");
const ban_svg_3 = require("../src/icons/thin/ban.svg");
const bandage_svg_3 = require("../src/icons/thin/bandage.svg");
const banjo_svg_3 = require("../src/icons/thin/banjo.svg");
const bank_svg_3 = require("../src/icons/thin/bank.svg");
const barcode_read_svg_3 = require("../src/icons/thin/barcode-read.svg");
const barcode_scan_svg_3 = require("../src/icons/thin/barcode-scan.svg");
const barcode_svg_3 = require("../src/icons/thin/barcode.svg");
const bars_filter_svg_3 = require("../src/icons/thin/bars-filter.svg");
const bars_progress_svg_3 = require("../src/icons/thin/bars-progress.svg");
const bars_sort_svg_3 = require("../src/icons/thin/bars-sort.svg");
const bars_staggered_svg_3 = require("../src/icons/thin/bars-staggered.svg");
const bars_svg_3 = require("../src/icons/thin/bars.svg");
const baseball_ball_svg_3 = require("../src/icons/thin/baseball-ball.svg");
const baseball_bat_ball_svg_3 = require("../src/icons/thin/baseball-bat-ball.svg");
const basket_shopping_simple_svg_3 = require("../src/icons/thin/basket-shopping-simple.svg");
const basket_shopping_svg_3 = require("../src/icons/thin/basket-shopping.svg");
const basketball_ball_svg_3 = require("../src/icons/thin/basketball-ball.svg");
const basketball_hoop_svg_3 = require("../src/icons/thin/basketball-hoop.svg");
const bat_svg_3 = require("../src/icons/thin/bat.svg");
const bath_svg_3 = require("../src/icons/thin/bath.svg");
const battery_bolt_svg_3 = require("../src/icons/thin/battery-bolt.svg");
const battery_empty_svg_3 = require("../src/icons/thin/battery-empty.svg");
const battery_exclamation_svg_3 = require("../src/icons/thin/battery-exclamation.svg");
const battery_full_svg_3 = require("../src/icons/thin/battery-full.svg");
const battery_half_svg_3 = require("../src/icons/thin/battery-half.svg");
const battery_low_svg_3 = require("../src/icons/thin/battery-low.svg");
const battery_quarter_svg_3 = require("../src/icons/thin/battery-quarter.svg");
const battery_slash_svg_3 = require("../src/icons/thin/battery-slash.svg");
const battery_three_quarters_svg_3 = require("../src/icons/thin/battery-three-quarters.svg");
const bed_bunk_svg_3 = require("../src/icons/thin/bed-bunk.svg");
const bed_empty_svg_3 = require("../src/icons/thin/bed-empty.svg");
const bed_front_svg_3 = require("../src/icons/thin/bed-front.svg");
const bed_pulse_svg_3 = require("../src/icons/thin/bed-pulse.svg");
const bed_svg_3 = require("../src/icons/thin/bed.svg");
const bee_svg_3 = require("../src/icons/thin/bee.svg");
const beer_mug_empty_svg_3 = require("../src/icons/thin/beer-mug-empty.svg");
const beer_mug_svg_3 = require("../src/icons/thin/beer-mug.svg");
const bell_concierge_svg_3 = require("../src/icons/thin/bell-concierge.svg");
const bell_exclamation_svg_3 = require("../src/icons/thin/bell-exclamation.svg");
const bell_on_svg_3 = require("../src/icons/thin/bell-on.svg");
const bell_plus_svg_3 = require("../src/icons/thin/bell-plus.svg");
const bell_school_slash_svg_3 = require("../src/icons/thin/bell-school-slash.svg");
const bell_school_svg_3 = require("../src/icons/thin/bell-school.svg");
const bell_slash_svg_3 = require("../src/icons/thin/bell-slash.svg");
const bell_svg_3 = require("../src/icons/thin/bell.svg");
const bells_svg_3 = require("../src/icons/thin/bells.svg");
const bezier_curve_svg_3 = require("../src/icons/thin/bezier-curve.svg");
const bicycle_svg_3 = require("../src/icons/thin/bicycle.svg");
const binoculars_svg_3 = require("../src/icons/thin/binoculars.svg");
const biohazard_svg_3 = require("../src/icons/thin/biohazard.svg");
const bitcoin_sign_svg_3 = require("../src/icons/thin/bitcoin-sign.svg");
const blanket_svg_3 = require("../src/icons/thin/blanket.svg");
const blender_phone_svg_3 = require("../src/icons/thin/blender-phone.svg");
const blender_svg_3 = require("../src/icons/thin/blender.svg");
const blinds_open_svg_3 = require("../src/icons/thin/blinds-open.svg");
const blinds_raised_svg_3 = require("../src/icons/thin/blinds-raised.svg");
const blinds_svg_3 = require("../src/icons/thin/blinds.svg");
const block_quote_svg_3 = require("../src/icons/thin/block-quote.svg");
const blog_svg_3 = require("../src/icons/thin/blog.svg");
const bluetooth_svg_4 = require("../src/icons/thin/bluetooth.svg");
const bold_svg_3 = require("../src/icons/thin/bold.svg");
const bolt_auto_svg_3 = require("../src/icons/thin/bolt-auto.svg");
const bolt_lightning_svg_3 = require("../src/icons/thin/bolt-lightning.svg");
const bolt_slash_svg_3 = require("../src/icons/thin/bolt-slash.svg");
const bolt_svg_3 = require("../src/icons/thin/bolt.svg");
const bomb_svg_3 = require("../src/icons/thin/bomb.svg");
const bone_break_svg_3 = require("../src/icons/thin/bone-break.svg");
const bone_svg_3 = require("../src/icons/thin/bone.svg");
const bong_svg_3 = require("../src/icons/thin/bong.svg");
const book_arrow_right_svg_3 = require("../src/icons/thin/book-arrow-right.svg");
const book_arrow_up_svg_3 = require("../src/icons/thin/book-arrow-up.svg");
const book_atlas_svg_3 = require("../src/icons/thin/book-atlas.svg");
const book_bible_svg_3 = require("../src/icons/thin/book-bible.svg");
const book_blank_svg_3 = require("../src/icons/thin/book-blank.svg");
const book_bookmark_svg_3 = require("../src/icons/thin/book-bookmark.svg");
const book_circle_arrow_right_svg_3 = require("../src/icons/thin/book-circle-arrow-right.svg");
const book_circle_arrow_up_svg_3 = require("../src/icons/thin/book-circle-arrow-up.svg");
const book_copy_svg_3 = require("../src/icons/thin/book-copy.svg");
const book_font_svg_3 = require("../src/icons/thin/book-font.svg");
const book_heart_svg_3 = require("../src/icons/thin/book-heart.svg");
const book_journal_whills_svg_3 = require("../src/icons/thin/book-journal-whills.svg");
const book_law_svg_3 = require("../src/icons/thin/book-law.svg");
const book_medical_svg_3 = require("../src/icons/thin/book-medical.svg");
const book_open_cover_svg_3 = require("../src/icons/thin/book-open-cover.svg");
const book_open_reader_svg_3 = require("../src/icons/thin/book-open-reader.svg");
const book_open_svg_3 = require("../src/icons/thin/book-open.svg");
const book_quran_svg_3 = require("../src/icons/thin/book-quran.svg");
const book_section_svg_3 = require("../src/icons/thin/book-section.svg");
const book_skull_svg_3 = require("../src/icons/thin/book-skull.svg");
const book_sparkles_svg_3 = require("../src/icons/thin/book-sparkles.svg");
const book_tanakh_svg_3 = require("../src/icons/thin/book-tanakh.svg");
const book_user_svg_3 = require("../src/icons/thin/book-user.svg");
const book_svg_3 = require("../src/icons/thin/book.svg");
const bookmark_slash_svg_3 = require("../src/icons/thin/bookmark-slash.svg");
const bookmark_svg_3 = require("../src/icons/thin/bookmark.svg");
const books_medical_svg_3 = require("../src/icons/thin/books-medical.svg");
const books_svg_3 = require("../src/icons/thin/books.svg");
const boombox_svg_3 = require("../src/icons/thin/boombox.svg");
const boot_svg_3 = require("../src/icons/thin/boot.svg");
const booth_curtain_svg_3 = require("../src/icons/thin/booth-curtain.svg");
const border_all_svg_3 = require("../src/icons/thin/border-all.svg");
const border_bottom_right_svg_3 = require("../src/icons/thin/border-bottom-right.svg");
const border_bottom_svg_3 = require("../src/icons/thin/border-bottom.svg");
const border_center_h_svg_3 = require("../src/icons/thin/border-center-h.svg");
const border_center_v_svg_3 = require("../src/icons/thin/border-center-v.svg");
const border_inner_svg_3 = require("../src/icons/thin/border-inner.svg");
const border_left_svg_3 = require("../src/icons/thin/border-left.svg");
const border_none_svg_3 = require("../src/icons/thin/border-none.svg");
const border_outer_svg_3 = require("../src/icons/thin/border-outer.svg");
const border_right_svg_3 = require("../src/icons/thin/border-right.svg");
const border_top_left_svg_3 = require("../src/icons/thin/border-top-left.svg");
const border_top_svg_3 = require("../src/icons/thin/border-top.svg");
const bow_arrow_svg_3 = require("../src/icons/thin/bow-arrow.svg");
const bowl_hot_svg_3 = require("../src/icons/thin/bowl-hot.svg");
const bowling_ball_pin_svg_3 = require("../src/icons/thin/bowling-ball-pin.svg");
const bowling_ball_svg_3 = require("../src/icons/thin/bowling-ball.svg");
const bowling_pins_svg_3 = require("../src/icons/thin/bowling-pins.svg");
const box_archive_svg_3 = require("../src/icons/thin/box-archive.svg");
const box_ballot_svg_3 = require("../src/icons/thin/box-ballot.svg");
const box_check_svg_3 = require("../src/icons/thin/box-check.svg");
const box_circle_check_svg_3 = require("../src/icons/thin/box-circle-check.svg");
const box_dollar_svg_3 = require("../src/icons/thin/box-dollar.svg");
const box_heart_svg_3 = require("../src/icons/thin/box-heart.svg");
const box_open_full_svg_3 = require("../src/icons/thin/box-open-full.svg");
const box_open_svg_3 = require("../src/icons/thin/box-open.svg");
const box_taped_svg_3 = require("../src/icons/thin/box-taped.svg");
const box_tissue_svg_3 = require("../src/icons/thin/box-tissue.svg");
const box_svg_3 = require("../src/icons/thin/box.svg");
const boxes_stacked_svg_3 = require("../src/icons/thin/boxes-stacked.svg");
const boxing_glove_svg_3 = require("../src/icons/thin/boxing-glove.svg");
const bracket_curly_right_svg_3 = require("../src/icons/thin/bracket-curly-right.svg");
const bracket_curly_svg_3 = require("../src/icons/thin/bracket-curly.svg");
const bracket_round_right_svg_3 = require("../src/icons/thin/bracket-round-right.svg");
const bracket_round_svg_3 = require("../src/icons/thin/bracket-round.svg");
const bracket_square_right_svg_3 = require("../src/icons/thin/bracket-square-right.svg");
const bracket_square_svg_3 = require("../src/icons/thin/bracket-square.svg");
const brackets_curly_svg_3 = require("../src/icons/thin/brackets-curly.svg");
const brackets_round_svg_3 = require("../src/icons/thin/brackets-round.svg");
const brackets_square_svg_3 = require("../src/icons/thin/brackets-square.svg");
const braille_svg_3 = require("../src/icons/thin/braille.svg");
const brain_arrow_curved_right_svg_3 = require("../src/icons/thin/brain-arrow-curved-right.svg");
const brain_circuit_svg_3 = require("../src/icons/thin/brain-circuit.svg");
const brain_svg_3 = require("../src/icons/thin/brain.svg");
const brake_warning_svg_3 = require("../src/icons/thin/brake-warning.svg");
const bread_loaf_svg_3 = require("../src/icons/thin/bread-loaf.svg");
const bread_slice_svg_3 = require("../src/icons/thin/bread-slice.svg");
const briefcase_arrow_right_svg_3 = require("../src/icons/thin/briefcase-arrow-right.svg");
const briefcase_clock_svg_3 = require("../src/icons/thin/briefcase-clock.svg");
const briefcase_medical_svg_3 = require("../src/icons/thin/briefcase-medical.svg");
const briefcase_svg_3 = require("../src/icons/thin/briefcase.svg");
const bring_forward_svg_3 = require("../src/icons/thin/bring-forward.svg");
const bring_front_svg_3 = require("../src/icons/thin/bring-front.svg");
const broom_svg_3 = require("../src/icons/thin/broom.svg");
const browser_svg_3 = require("../src/icons/thin/browser.svg");
const browsers_svg_3 = require("../src/icons/thin/browsers.svg");
const brush_svg_3 = require("../src/icons/thin/brush.svg");
const bug_svg_3 = require("../src/icons/thin/bug.svg");
const building_svg_3 = require("../src/icons/thin/building.svg");
const buildings_svg_3 = require("../src/icons/thin/buildings.svg");
const bullhorn_svg_3 = require("../src/icons/thin/bullhorn.svg");
const bullseye_arrow_svg_3 = require("../src/icons/thin/bullseye-arrow.svg");
const bullseye_pointer_svg_3 = require("../src/icons/thin/bullseye-pointer.svg");
const bullseye_svg_3 = require("../src/icons/thin/bullseye.svg");
const burger_cheese_svg_3 = require("../src/icons/thin/burger-cheese.svg");
const burger_fries_svg_3 = require("../src/icons/thin/burger-fries.svg");
const burger_glass_svg_3 = require("../src/icons/thin/burger-glass.svg");
const burger_soda_svg_3 = require("../src/icons/thin/burger-soda.svg");
const burger_svg_3 = require("../src/icons/thin/burger.svg");
const burrito_svg_3 = require("../src/icons/thin/burrito.svg");
const bus_school_svg_3 = require("../src/icons/thin/bus-school.svg");
const bus_simple_svg_3 = require("../src/icons/thin/bus-simple.svg");
const bus_svg_3 = require("../src/icons/thin/bus.svg");
const c_svg_3 = require("../src/icons/thin/c.svg");
const cabinet_filing_svg_3 = require("../src/icons/thin/cabinet-filing.svg");
const cable_car_svg_3 = require("../src/icons/thin/cable-car.svg");
const cactus_svg_3 = require("../src/icons/thin/cactus.svg");
const cake_candles_svg_3 = require("../src/icons/thin/cake-candles.svg");
const calculator_simple_svg_3 = require("../src/icons/thin/calculator-simple.svg");
const calculator_svg_3 = require("../src/icons/thin/calculator.svg");
const calendar_arrow_down_svg_3 = require("../src/icons/thin/calendar-arrow-down.svg");
const calendar_arrow_up_svg_3 = require("../src/icons/thin/calendar-arrow-up.svg");
const calendar_check_svg_3 = require("../src/icons/thin/calendar-check.svg");
const calendar_clock_svg_3 = require("../src/icons/thin/calendar-clock.svg");
const calendar_day_svg_3 = require("../src/icons/thin/calendar-day.svg");
const calendar_days_svg_3 = require("../src/icons/thin/calendar-days.svg");
const calendar_exclamation_svg_3 = require("../src/icons/thin/calendar-exclamation.svg");
const calendar_heart_svg_3 = require("../src/icons/thin/calendar-heart.svg");
const calendar_image_svg_3 = require("../src/icons/thin/calendar-image.svg");
const calendar_lines_svg_3 = require("../src/icons/thin/calendar-lines.svg");
const calendar_minus_svg_3 = require("../src/icons/thin/calendar-minus.svg");
const calendar_pen_svg_3 = require("../src/icons/thin/calendar-pen.svg");
const calendar_plus_svg_3 = require("../src/icons/thin/calendar-plus.svg");
const calendar_range_svg_3 = require("../src/icons/thin/calendar-range.svg");
const calendar_star_svg_3 = require("../src/icons/thin/calendar-star.svg");
const calendar_week_svg_3 = require("../src/icons/thin/calendar-week.svg");
const calendar_xmark_svg_3 = require("../src/icons/thin/calendar-xmark.svg");
const calendar_svg_3 = require("../src/icons/thin/calendar.svg");
const calendars_svg_3 = require("../src/icons/thin/calendars.svg");
const camcorder_svg_3 = require("../src/icons/thin/camcorder.svg");
const camera_cctv_svg_3 = require("../src/icons/thin/camera-cctv.svg");
const camera_movie_svg_3 = require("../src/icons/thin/camera-movie.svg");
const camera_polaroid_svg_3 = require("../src/icons/thin/camera-polaroid.svg");
const camera_retro_svg_3 = require("../src/icons/thin/camera-retro.svg");
const camera_rotate_svg_3 = require("../src/icons/thin/camera-rotate.svg");
const camera_security_svg_3 = require("../src/icons/thin/camera-security.svg");
const camera_slash_svg_3 = require("../src/icons/thin/camera-slash.svg");
const camera_viewfinder_svg_3 = require("../src/icons/thin/camera-viewfinder.svg");
const camera_web_slash_svg_3 = require("../src/icons/thin/camera-web-slash.svg");
const camera_web_svg_3 = require("../src/icons/thin/camera-web.svg");
const camera_svg_3 = require("../src/icons/thin/camera.svg");
const campfire_svg_3 = require("../src/icons/thin/campfire.svg");
const campground_svg_3 = require("../src/icons/thin/campground.svg");
const candle_holder_svg_3 = require("../src/icons/thin/candle-holder.svg");
const candy_cane_svg_3 = require("../src/icons/thin/candy-cane.svg");
const candy_corn_svg_3 = require("../src/icons/thin/candy-corn.svg");
const cannabis_svg_3 = require("../src/icons/thin/cannabis.svg");
const capsules_svg_3 = require("../src/icons/thin/capsules.svg");
const car_battery_svg_3 = require("../src/icons/thin/car-battery.svg");
const car_building_svg_3 = require("../src/icons/thin/car-building.svg");
const car_bump_svg_3 = require("../src/icons/thin/car-bump.svg");
const car_bus_svg_3 = require("../src/icons/thin/car-bus.svg");
const car_crash_svg_3 = require("../src/icons/thin/car-crash.svg");
const car_garage_svg_3 = require("../src/icons/thin/car-garage.svg");
const car_rear_svg_3 = require("../src/icons/thin/car-rear.svg");
const car_side_svg_3 = require("../src/icons/thin/car-side.svg");
const car_tilt_svg_3 = require("../src/icons/thin/car-tilt.svg");
const car_wash_svg_3 = require("../src/icons/thin/car-wash.svg");
const car_wrench_svg_3 = require("../src/icons/thin/car-wrench.svg");
const car_svg_3 = require("../src/icons/thin/car.svg");
const caravan_simple_svg_3 = require("../src/icons/thin/caravan-simple.svg");
const caravan_svg_3 = require("../src/icons/thin/caravan.svg");
const caret_down_svg_3 = require("../src/icons/thin/caret-down.svg");
const caret_left_svg_3 = require("../src/icons/thin/caret-left.svg");
const caret_right_svg_3 = require("../src/icons/thin/caret-right.svg");
const caret_up_svg_3 = require("../src/icons/thin/caret-up.svg");
const carrot_svg_3 = require("../src/icons/thin/carrot.svg");
const cars_svg_3 = require("../src/icons/thin/cars.svg");
const cart_arrow_down_svg_3 = require("../src/icons/thin/cart-arrow-down.svg");
const cart_flatbed_boxes_svg_3 = require("../src/icons/thin/cart-flatbed-boxes.svg");
const cart_flatbed_empty_svg_3 = require("../src/icons/thin/cart-flatbed-empty.svg");
const cart_flatbed_suitcase_svg_3 = require("../src/icons/thin/cart-flatbed-suitcase.svg");
const cart_flatbed_svg_3 = require("../src/icons/thin/cart-flatbed.svg");
const cart_plus_svg_3 = require("../src/icons/thin/cart-plus.svg");
const cart_shopping_fast_svg_3 = require("../src/icons/thin/cart-shopping-fast.svg");
const cart_shopping_svg_3 = require("../src/icons/thin/cart-shopping.svg");
const casette_betamax_svg_3 = require("../src/icons/thin/casette-betamax.svg");
const casette_vhs_svg_3 = require("../src/icons/thin/casette-vhs.svg");
const cash_register_svg_3 = require("../src/icons/thin/cash-register.svg");
const cassette_tape_svg_3 = require("../src/icons/thin/cassette-tape.svg");
const castle_svg_3 = require("../src/icons/thin/castle.svg");
const cat_space_svg_3 = require("../src/icons/thin/cat-space.svg");
const cat_svg_3 = require("../src/icons/thin/cat.svg");
const cauldron_svg_3 = require("../src/icons/thin/cauldron.svg");
const cedi_sign_svg_3 = require("../src/icons/thin/cedi-sign.svg");
const cent_sign_svg_3 = require("../src/icons/thin/cent-sign.svg");
const certificate_svg_3 = require("../src/icons/thin/certificate.svg");
const chair_office_svg_3 = require("../src/icons/thin/chair-office.svg");
const chair_svg_3 = require("../src/icons/thin/chair.svg");
const chalkboard_user_svg_3 = require("../src/icons/thin/chalkboard-user.svg");
const chalkboard_svg_3 = require("../src/icons/thin/chalkboard.svg");
const champagne_glass_svg_3 = require("../src/icons/thin/champagne-glass.svg");
const champagne_glasses_svg_3 = require("../src/icons/thin/champagne-glasses.svg");
const charging_station_svg_3 = require("../src/icons/thin/charging-station.svg");
const chart_area_svg_3 = require("../src/icons/thin/chart-area.svg");
const chart_bar_svg_3 = require("../src/icons/thin/chart-bar.svg");
const chart_bullet_svg_3 = require("../src/icons/thin/chart-bullet.svg");
const chart_candlestick_svg_3 = require("../src/icons/thin/chart-candlestick.svg");
const chart_column_svg_3 = require("../src/icons/thin/chart-column.svg");
const chart_gantt_svg_3 = require("../src/icons/thin/chart-gantt.svg");
const chart_line_down_svg_3 = require("../src/icons/thin/chart-line-down.svg");
const chart_line_up_svg_3 = require("../src/icons/thin/chart-line-up.svg");
const chart_line_svg_3 = require("../src/icons/thin/chart-line.svg");
const chart_mixed_svg_3 = require("../src/icons/thin/chart-mixed.svg");
const chart_network_svg_3 = require("../src/icons/thin/chart-network.svg");
const chart_pie_simple_svg_3 = require("../src/icons/thin/chart-pie-simple.svg");
const chart_pie_svg_3 = require("../src/icons/thin/chart-pie.svg");
const chart_pyramid_svg_3 = require("../src/icons/thin/chart-pyramid.svg");
const chart_radar_svg_3 = require("../src/icons/thin/chart-radar.svg");
const chart_scatter_3d_svg_3 = require("../src/icons/thin/chart-scatter-3d.svg");
const chart_scatter_bubble_svg_3 = require("../src/icons/thin/chart-scatter-bubble.svg");
const chart_scatter_svg_3 = require("../src/icons/thin/chart-scatter.svg");
const chart_tree_map_svg_3 = require("../src/icons/thin/chart-tree-map.svg");
const chart_user_svg_3 = require("../src/icons/thin/chart-user.svg");
const chart_waterfall_svg_3 = require("../src/icons/thin/chart-waterfall.svg");
const check_double_svg_3 = require("../src/icons/thin/check-double.svg");
const check_to_slot_svg_3 = require("../src/icons/thin/check-to-slot.svg");
const check_svg_3 = require("../src/icons/thin/check.svg");
const cheese_swiss_svg_3 = require("../src/icons/thin/cheese-swiss.svg");
const cheese_svg_3 = require("../src/icons/thin/cheese.svg");
const cherries_svg_3 = require("../src/icons/thin/cherries.svg");
const chess_bishop_piece_svg_3 = require("../src/icons/thin/chess-bishop-piece.svg");
const chess_bishop_svg_3 = require("../src/icons/thin/chess-bishop.svg");
const chess_board_svg_3 = require("../src/icons/thin/chess-board.svg");
const chess_clock_flip_svg_3 = require("../src/icons/thin/chess-clock-flip.svg");
const chess_clock_svg_3 = require("../src/icons/thin/chess-clock.svg");
const chess_king_piece_svg_3 = require("../src/icons/thin/chess-king-piece.svg");
const chess_king_svg_3 = require("../src/icons/thin/chess-king.svg");
const chess_knight_piece_svg_3 = require("../src/icons/thin/chess-knight-piece.svg");
const chess_knight_svg_3 = require("../src/icons/thin/chess-knight.svg");
const chess_pawn_piece_svg_3 = require("../src/icons/thin/chess-pawn-piece.svg");
const chess_pawn_svg_3 = require("../src/icons/thin/chess-pawn.svg");
const chess_queen_piece_svg_3 = require("../src/icons/thin/chess-queen-piece.svg");
const chess_queen_svg_3 = require("../src/icons/thin/chess-queen.svg");
const chess_rook_piece_svg_3 = require("../src/icons/thin/chess-rook-piece.svg");
const chess_rook_svg_3 = require("../src/icons/thin/chess-rook.svg");
const chess_svg_3 = require("../src/icons/thin/chess.svg");
const chevron_down_svg_3 = require("../src/icons/thin/chevron-down.svg");
const chevron_left_svg_3 = require("../src/icons/thin/chevron-left.svg");
const chevron_right_svg_3 = require("../src/icons/thin/chevron-right.svg");
const chevron_up_svg_3 = require("../src/icons/thin/chevron-up.svg");
const chevrons_down_svg_3 = require("../src/icons/thin/chevrons-down.svg");
const chevrons_left_svg_3 = require("../src/icons/thin/chevrons-left.svg");
const chevrons_right_svg_3 = require("../src/icons/thin/chevrons-right.svg");
const chevrons_up_svg_3 = require("../src/icons/thin/chevrons-up.svg");
const child_svg_3 = require("../src/icons/thin/child.svg");
const chimney_svg_3 = require("../src/icons/thin/chimney.svg");
const church_svg_3 = require("../src/icons/thin/church.svg");
const circle_0_svg_3 = require("../src/icons/thin/circle-0.svg");
const circle_1_svg_3 = require("../src/icons/thin/circle-1.svg");
const circle_2_svg_3 = require("../src/icons/thin/circle-2.svg");
const circle_3_svg_3 = require("../src/icons/thin/circle-3.svg");
const circle_4_svg_3 = require("../src/icons/thin/circle-4.svg");
const circle_5_svg_3 = require("../src/icons/thin/circle-5.svg");
const circle_6_svg_3 = require("../src/icons/thin/circle-6.svg");
const circle_7_svg_3 = require("../src/icons/thin/circle-7.svg");
const circle_8_svg_3 = require("../src/icons/thin/circle-8.svg");
const circle_9_svg_3 = require("../src/icons/thin/circle-9.svg");
const circle_a_svg_3 = require("../src/icons/thin/circle-a.svg");
const circle_ampersand_svg_3 = require("../src/icons/thin/circle-ampersand.svg");
const circle_arrow_down_left_svg_3 = require("../src/icons/thin/circle-arrow-down-left.svg");
const circle_arrow_down_right_svg_3 = require("../src/icons/thin/circle-arrow-down-right.svg");
const circle_arrow_down_svg_3 = require("../src/icons/thin/circle-arrow-down.svg");
const circle_arrow_left_svg_3 = require("../src/icons/thin/circle-arrow-left.svg");
const circle_arrow_right_svg_3 = require("../src/icons/thin/circle-arrow-right.svg");
const circle_arrow_up_left_svg_3 = require("../src/icons/thin/circle-arrow-up-left.svg");
const circle_arrow_up_right_svg_3 = require("../src/icons/thin/circle-arrow-up-right.svg");
const circle_arrow_up_svg_3 = require("../src/icons/thin/circle-arrow-up.svg");
const circle_b_svg_3 = require("../src/icons/thin/circle-b.svg");
const circle_bolt_svg_3 = require("../src/icons/thin/circle-bolt.svg");
const circle_book_open_svg_3 = require("../src/icons/thin/circle-book-open.svg");
const circle_bookmark_svg_3 = require("../src/icons/thin/circle-bookmark.svg");
const circle_c_svg_3 = require("../src/icons/thin/circle-c.svg");
const circle_calendar_svg_3 = require("../src/icons/thin/circle-calendar.svg");
const circle_camera_svg_3 = require("../src/icons/thin/circle-camera.svg");
const circle_caret_down_svg_3 = require("../src/icons/thin/circle-caret-down.svg");
const circle_caret_left_svg_3 = require("../src/icons/thin/circle-caret-left.svg");
const circle_caret_right_svg_3 = require("../src/icons/thin/circle-caret-right.svg");
const circle_caret_up_svg_3 = require("../src/icons/thin/circle-caret-up.svg");
const circle_check_svg_3 = require("../src/icons/thin/circle-check.svg");
const circle_chevron_down_svg_3 = require("../src/icons/thin/circle-chevron-down.svg");
const circle_chevron_left_svg_3 = require("../src/icons/thin/circle-chevron-left.svg");
const circle_chevron_right_svg_3 = require("../src/icons/thin/circle-chevron-right.svg");
const circle_chevron_up_svg_3 = require("../src/icons/thin/circle-chevron-up.svg");
const circle_d_svg_3 = require("../src/icons/thin/circle-d.svg");
const circle_dashed_svg_3 = require("../src/icons/thin/circle-dashed.svg");
const circle_divide_svg_3 = require("../src/icons/thin/circle-divide.svg");
const circle_dollar_to_slot_svg_3 = require("../src/icons/thin/circle-dollar-to-slot.svg");
const circle_dollar_svg_3 = require("../src/icons/thin/circle-dollar.svg");
const circle_dot_svg_3 = require("../src/icons/thin/circle-dot.svg");
const circle_down_left_svg_3 = require("../src/icons/thin/circle-down-left.svg");
const circle_down_right_svg_3 = require("../src/icons/thin/circle-down-right.svg");
const circle_down_svg_3 = require("../src/icons/thin/circle-down.svg");
const circle_e_svg_3 = require("../src/icons/thin/circle-e.svg");
const circle_envelope_svg_3 = require("../src/icons/thin/circle-envelope.svg");
const circle_exclamation_check_svg_3 = require("../src/icons/thin/circle-exclamation-check.svg");
const circle_exclamation_svg_3 = require("../src/icons/thin/circle-exclamation.svg");
const circle_f_svg_3 = require("../src/icons/thin/circle-f.svg");
const circle_g_svg_3 = require("../src/icons/thin/circle-g.svg");
const circle_h_svg_3 = require("../src/icons/thin/circle-h.svg");
const circle_half_stroke_svg_3 = require("../src/icons/thin/circle-half-stroke.svg");
const circle_half_svg_3 = require("../src/icons/thin/circle-half.svg");
const circle_heart_svg_3 = require("../src/icons/thin/circle-heart.svg");
const circle_i_svg_3 = require("../src/icons/thin/circle-i.svg");
const circle_info_svg_3 = require("../src/icons/thin/circle-info.svg");
const circle_j_svg_3 = require("../src/icons/thin/circle-j.svg");
const circle_k_svg_3 = require("../src/icons/thin/circle-k.svg");
const circle_l_svg_3 = require("../src/icons/thin/circle-l.svg");
const circle_left_svg_3 = require("../src/icons/thin/circle-left.svg");
const circle_location_arrow_svg_3 = require("../src/icons/thin/circle-location-arrow.svg");
const circle_m_svg_3 = require("../src/icons/thin/circle-m.svg");
const circle_microphone_lines_svg_3 = require("../src/icons/thin/circle-microphone-lines.svg");
const circle_microphone_svg_3 = require("../src/icons/thin/circle-microphone.svg");
const circle_minus_svg_3 = require("../src/icons/thin/circle-minus.svg");
const circle_n_svg_3 = require("../src/icons/thin/circle-n.svg");
const circle_notch_svg_3 = require("../src/icons/thin/circle-notch.svg");
const circle_o_svg_3 = require("../src/icons/thin/circle-o.svg");
const circle_p_svg_3 = require("../src/icons/thin/circle-p.svg");
const circle_parking_svg_3 = require("../src/icons/thin/circle-parking.svg");
const circle_pause_svg_3 = require("../src/icons/thin/circle-pause.svg");
const circle_phone_flip_svg_3 = require("../src/icons/thin/circle-phone-flip.svg");
const circle_phone_hangup_svg_3 = require("../src/icons/thin/circle-phone-hangup.svg");
const circle_phone_svg_3 = require("../src/icons/thin/circle-phone.svg");
const circle_play_svg_3 = require("../src/icons/thin/circle-play.svg");
const circle_plus_svg_3 = require("../src/icons/thin/circle-plus.svg");
const circle_q_svg_3 = require("../src/icons/thin/circle-q.svg");
const circle_quarter_svg_3 = require("../src/icons/thin/circle-quarter.svg");
const circle_question_svg_3 = require("../src/icons/thin/circle-question.svg");
const circle_r_svg_3 = require("../src/icons/thin/circle-r.svg");
const circle_radiation_svg_3 = require("../src/icons/thin/circle-radiation.svg");
const circle_right_svg_3 = require("../src/icons/thin/circle-right.svg");
const circle_s_svg_3 = require("../src/icons/thin/circle-s.svg");
const circle_small_svg_3 = require("../src/icons/thin/circle-small.svg");
const circle_sort_down_svg_3 = require("../src/icons/thin/circle-sort-down.svg");
const circle_sort_up_svg_3 = require("../src/icons/thin/circle-sort-up.svg");
const circle_sort_svg_3 = require("../src/icons/thin/circle-sort.svg");
const circle_star_svg_3 = require("../src/icons/thin/circle-star.svg");
const circle_stop_svg_3 = require("../src/icons/thin/circle-stop.svg");
const circle_t_svg_3 = require("../src/icons/thin/circle-t.svg");
const circle_three_quarters_svg_3 = require("../src/icons/thin/circle-three-quarters.svg");
const circle_trash_svg_3 = require("../src/icons/thin/circle-trash.svg");
const circle_u_svg_3 = require("../src/icons/thin/circle-u.svg");
const circle_up_left_svg_3 = require("../src/icons/thin/circle-up-left.svg");
const circle_up_right_svg_3 = require("../src/icons/thin/circle-up-right.svg");
const circle_up_svg_3 = require("../src/icons/thin/circle-up.svg");
const circle_user_svg_3 = require("../src/icons/thin/circle-user.svg");
const circle_v_svg_3 = require("../src/icons/thin/circle-v.svg");
const circle_video_svg_3 = require("../src/icons/thin/circle-video.svg");
const circle_w_svg_3 = require("../src/icons/thin/circle-w.svg");
const circle_waveform_lines_svg_3 = require("../src/icons/thin/circle-waveform-lines.svg");
const circle_x_svg_3 = require("../src/icons/thin/circle-x.svg");
const circle_xmark_svg_3 = require("../src/icons/thin/circle-xmark.svg");
const circle_y_svg_3 = require("../src/icons/thin/circle-y.svg");
const circle_z_svg_3 = require("../src/icons/thin/circle-z.svg");
const circle_svg_3 = require("../src/icons/thin/circle.svg");
const city_svg_3 = require("../src/icons/thin/city.svg");
const clapperboard_play_svg_3 = require("../src/icons/thin/clapperboard-play.svg");
const clapperboard_svg_3 = require("../src/icons/thin/clapperboard.svg");
const clarinet_svg_3 = require("../src/icons/thin/clarinet.svg");
const claw_marks_svg_3 = require("../src/icons/thin/claw-marks.svg");
const clipboard_check_svg_3 = require("../src/icons/thin/clipboard-check.svg");
const clipboard_list_check_svg_3 = require("../src/icons/thin/clipboard-list-check.svg");
const clipboard_list_svg_3 = require("../src/icons/thin/clipboard-list.svg");
const clipboard_medical_svg_3 = require("../src/icons/thin/clipboard-medical.svg");
const clipboard_prescription_svg_3 = require("../src/icons/thin/clipboard-prescription.svg");
const clipboard_user_svg_3 = require("../src/icons/thin/clipboard-user.svg");
const clipboard_svg_3 = require("../src/icons/thin/clipboard.svg");
const clock_desk_svg_3 = require("../src/icons/thin/clock-desk.svg");
const clock_rotate_left_svg_3 = require("../src/icons/thin/clock-rotate-left.svg");
const clock_svg_3 = require("../src/icons/thin/clock.svg");
const clone_svg_3 = require("../src/icons/thin/clone.svg");
const closed_captioning_slash_svg_3 = require("../src/icons/thin/closed-captioning-slash.svg");
const closed_captioning_svg_3 = require("../src/icons/thin/closed-captioning.svg");
const clothes_hanger_svg_3 = require("../src/icons/thin/clothes-hanger.svg");
const cloud_arrow_down_svg_3 = require("../src/icons/thin/cloud-arrow-down.svg");
const cloud_arrow_up_svg_3 = require("../src/icons/thin/cloud-arrow-up.svg");
const cloud_bolt_moon_svg_3 = require("../src/icons/thin/cloud-bolt-moon.svg");
const cloud_bolt_sun_svg_3 = require("../src/icons/thin/cloud-bolt-sun.svg");
const cloud_bolt_svg_3 = require("../src/icons/thin/cloud-bolt.svg");
const cloud_drizzle_svg_3 = require("../src/icons/thin/cloud-drizzle.svg");
const cloud_fog_svg_3 = require("../src/icons/thin/cloud-fog.svg");
const cloud_hail_mixed_svg_3 = require("../src/icons/thin/cloud-hail-mixed.svg");
const cloud_hail_svg_3 = require("../src/icons/thin/cloud-hail.svg");
const cloud_meatball_svg_3 = require("../src/icons/thin/cloud-meatball.svg");
const cloud_moon_rain_svg_3 = require("../src/icons/thin/cloud-moon-rain.svg");
const cloud_moon_svg_3 = require("../src/icons/thin/cloud-moon.svg");
const cloud_music_svg_3 = require("../src/icons/thin/cloud-music.svg");
const cloud_rain_svg_3 = require("../src/icons/thin/cloud-rain.svg");
const cloud_rainbow_svg_3 = require("../src/icons/thin/cloud-rainbow.svg");
const cloud_showers_heavy_svg_3 = require("../src/icons/thin/cloud-showers-heavy.svg");
const cloud_showers_svg_3 = require("../src/icons/thin/cloud-showers.svg");
const cloud_slash_svg_3 = require("../src/icons/thin/cloud-slash.svg");
const cloud_sleet_svg_3 = require("../src/icons/thin/cloud-sleet.svg");
const cloud_snow_svg_3 = require("../src/icons/thin/cloud-snow.svg");
const cloud_sun_rain_svg_3 = require("../src/icons/thin/cloud-sun-rain.svg");
const cloud_sun_svg_3 = require("../src/icons/thin/cloud-sun.svg");
const cloud_word_svg_3 = require("../src/icons/thin/cloud-word.svg");
const cloud_svg_3 = require("../src/icons/thin/cloud.svg");
const clouds_moon_svg_3 = require("../src/icons/thin/clouds-moon.svg");
const clouds_sun_svg_3 = require("../src/icons/thin/clouds-sun.svg");
const clouds_svg_3 = require("../src/icons/thin/clouds.svg");
const clover_svg_3 = require("../src/icons/thin/clover.svg");
const club_svg_3 = require("../src/icons/thin/club.svg");
const code_branch_svg_3 = require("../src/icons/thin/code-branch.svg");
const code_commit_svg_3 = require("../src/icons/thin/code-commit.svg");
const code_compare_svg_3 = require("../src/icons/thin/code-compare.svg");
const code_fork_svg_3 = require("../src/icons/thin/code-fork.svg");
const code_merge_svg_3 = require("../src/icons/thin/code-merge.svg");
const code_pull_request_svg_3 = require("../src/icons/thin/code-pull-request.svg");
const code_simple_svg_3 = require("../src/icons/thin/code-simple.svg");
const code_svg_3 = require("../src/icons/thin/code.svg");
const coffee_bean_svg_3 = require("../src/icons/thin/coffee-bean.svg");
const coffee_beans_svg_3 = require("../src/icons/thin/coffee-beans.svg");
const coffee_pot_svg_3 = require("../src/icons/thin/coffee-pot.svg");
const coffin_cross_svg_3 = require("../src/icons/thin/coffin-cross.svg");
const coffin_svg_3 = require("../src/icons/thin/coffin.svg");
const coin_svg_3 = require("../src/icons/thin/coin.svg");
const coins_svg_3 = require("../src/icons/thin/coins.svg");
const colon_sign_svg_3 = require("../src/icons/thin/colon-sign.svg");
const comet_svg_3 = require("../src/icons/thin/comet.svg");
const command_svg_3 = require("../src/icons/thin/command.svg");
const comment_arrow_down_svg_3 = require("../src/icons/thin/comment-arrow-down.svg");
const comment_arrow_up_right_svg_3 = require("../src/icons/thin/comment-arrow-up-right.svg");
const comment_arrow_up_svg_3 = require("../src/icons/thin/comment-arrow-up.svg");
const comment_captions_svg_3 = require("../src/icons/thin/comment-captions.svg");
const comment_check_svg_3 = require("../src/icons/thin/comment-check.svg");
const comment_code_svg_3 = require("../src/icons/thin/comment-code.svg");
const comment_dollar_svg_3 = require("../src/icons/thin/comment-dollar.svg");
const comment_dots_svg_3 = require("../src/icons/thin/comment-dots.svg");
const comment_exclamation_svg_3 = require("../src/icons/thin/comment-exclamation.svg");
const comment_image_svg_3 = require("../src/icons/thin/comment-image.svg");
const comment_lines_svg_3 = require("../src/icons/thin/comment-lines.svg");
const comment_medical_svg_3 = require("../src/icons/thin/comment-medical.svg");
const comment_middle_top_svg_3 = require("../src/icons/thin/comment-middle-top.svg");
const comment_middle_svg_3 = require("../src/icons/thin/comment-middle.svg");
const comment_minus_svg_3 = require("../src/icons/thin/comment-minus.svg");
const comment_music_svg_3 = require("../src/icons/thin/comment-music.svg");
const comment_pen_svg_3 = require("../src/icons/thin/comment-pen.svg");
const comment_plus_svg_3 = require("../src/icons/thin/comment-plus.svg");
const comment_question_svg_3 = require("../src/icons/thin/comment-question.svg");
const comment_quote_svg_3 = require("../src/icons/thin/comment-quote.svg");
const comment_slash_svg_3 = require("../src/icons/thin/comment-slash.svg");
const comment_smile_svg_3 = require("../src/icons/thin/comment-smile.svg");
const comment_sms_svg_3 = require("../src/icons/thin/comment-sms.svg");
const comment_text_svg_3 = require("../src/icons/thin/comment-text.svg");
const comment_xmark_svg_3 = require("../src/icons/thin/comment-xmark.svg");
const comment_svg_3 = require("../src/icons/thin/comment.svg");
const comments_dollar_svg_3 = require("../src/icons/thin/comments-dollar.svg");
const comments_question_check_svg_3 = require("../src/icons/thin/comments-question-check.svg");
const comments_question_svg_3 = require("../src/icons/thin/comments-question.svg");
const comments_svg_3 = require("../src/icons/thin/comments.svg");
const compact_disc_svg_3 = require("../src/icons/thin/compact-disc.svg");
const compass_drafting_svg_3 = require("../src/icons/thin/compass-drafting.svg");
const compass_slash_svg_3 = require("../src/icons/thin/compass-slash.svg");
const compass_svg_3 = require("../src/icons/thin/compass.svg");
const compress_wide_svg_3 = require("../src/icons/thin/compress-wide.svg");
const compress_svg_3 = require("../src/icons/thin/compress.svg");
const computer_classic_svg_3 = require("../src/icons/thin/computer-classic.svg");
const computer_mouse_scrollwheel_svg_3 = require("../src/icons/thin/computer-mouse-scrollwheel.svg");
const computer_mouse_svg_3 = require("../src/icons/thin/computer-mouse.svg");
const computer_speaker_svg_3 = require("../src/icons/thin/computer-speaker.svg");
const container_storage_svg_3 = require("../src/icons/thin/container-storage.svg");
const conveyor_belt_boxes_svg_3 = require("../src/icons/thin/conveyor-belt-boxes.svg");
const conveyor_belt_empty_svg_3 = require("../src/icons/thin/conveyor-belt-empty.svg");
const conveyor_belt_svg_3 = require("../src/icons/thin/conveyor-belt.svg");
const cookie_bite_svg_3 = require("../src/icons/thin/cookie-bite.svg");
const cookie_svg_3 = require("../src/icons/thin/cookie.svg");
const copy_svg_3 = require("../src/icons/thin/copy.svg");
const copyright_svg_3 = require("../src/icons/thin/copyright.svg");
const corn_svg_3 = require("../src/icons/thin/corn.svg");
const couch_svg_3 = require("../src/icons/thin/couch.svg");
const cow_svg_3 = require("../src/icons/thin/cow.svg");
const cowbell_circle_plus_svg_3 = require("../src/icons/thin/cowbell-circle-plus.svg");
const cowbell_svg_3 = require("../src/icons/thin/cowbell.svg");
const credit_card_blank_svg_3 = require("../src/icons/thin/credit-card-blank.svg");
const credit_card_front_svg_3 = require("../src/icons/thin/credit-card-front.svg");
const credit_card_svg_3 = require("../src/icons/thin/credit-card.svg");
const cricket_bat_ball_svg_3 = require("../src/icons/thin/cricket-bat-ball.svg");
const croissant_svg_3 = require("../src/icons/thin/croissant.svg");
const crop_simple_svg_3 = require("../src/icons/thin/crop-simple.svg");
const crop_svg_3 = require("../src/icons/thin/crop.svg");
const cross_svg_3 = require("../src/icons/thin/cross.svg");
const crosshairs_svg_3 = require("../src/icons/thin/crosshairs.svg");
const crow_svg_3 = require("../src/icons/thin/crow.svg");
const crown_svg_3 = require("../src/icons/thin/crown.svg");
const crutch_svg_3 = require("../src/icons/thin/crutch.svg");
const crutches_svg_3 = require("../src/icons/thin/crutches.svg");
const cruzeiro_sign_svg_3 = require("../src/icons/thin/cruzeiro-sign.svg");
const cube_svg_3 = require("../src/icons/thin/cube.svg");
const cubes_svg_3 = require("../src/icons/thin/cubes.svg");
const cup_togo_svg_3 = require("../src/icons/thin/cup-togo.svg");
const curling_stone_svg_3 = require("../src/icons/thin/curling-stone.svg");
const d_svg_3 = require("../src/icons/thin/d.svg");
const dagger_svg_3 = require("../src/icons/thin/dagger.svg");
const database_svg_3 = require("../src/icons/thin/database.svg");
const deer_rudolph_svg_3 = require("../src/icons/thin/deer-rudolph.svg");
const deer_svg_3 = require("../src/icons/thin/deer.svg");
const delete_left_svg_3 = require("../src/icons/thin/delete-left.svg");
const delete_right_svg_3 = require("../src/icons/thin/delete-right.svg");
const democrat_svg_3 = require("../src/icons/thin/democrat.svg");
const desktop_arrow_down_svg_3 = require("../src/icons/thin/desktop-arrow-down.svg");
const desktop_svg_3 = require("../src/icons/thin/desktop.svg");
const dharmachakra_svg_3 = require("../src/icons/thin/dharmachakra.svg");
const diagram_lean_canvas_svg_3 = require("../src/icons/thin/diagram-lean-canvas.svg");
const diagram_nested_svg_3 = require("../src/icons/thin/diagram-nested.svg");
const diagram_project_svg_3 = require("../src/icons/thin/diagram-project.svg");
const diagram_sankey_svg_3 = require("../src/icons/thin/diagram-sankey.svg");
const diagram_stankey_svg_3 = require("../src/icons/thin/diagram-stankey.svg");
const diagram_venn_svg_3 = require("../src/icons/thin/diagram-venn.svg");
const dial_high_svg_3 = require("../src/icons/thin/dial-high.svg");
const dial_low_svg_3 = require("../src/icons/thin/dial-low.svg");
const dial_max_svg_3 = require("../src/icons/thin/dial-max.svg");
const dial_med_low_svg_3 = require("../src/icons/thin/dial-med-low.svg");
const dial_med_svg_3 = require("../src/icons/thin/dial-med.svg");
const dial_min_svg_3 = require("../src/icons/thin/dial-min.svg");
const dial_svg_3 = require("../src/icons/thin/dial.svg");
const diamond_turn_right_svg_3 = require("../src/icons/thin/diamond-turn-right.svg");
const diamond_svg_3 = require("../src/icons/thin/diamond.svg");
const dice_d10_svg_3 = require("../src/icons/thin/dice-d10.svg");
const dice_d12_svg_3 = require("../src/icons/thin/dice-d12.svg");
const dice_d20_svg_3 = require("../src/icons/thin/dice-d20.svg");
const dice_d4_svg_3 = require("../src/icons/thin/dice-d4.svg");
const dice_d6_svg_3 = require("../src/icons/thin/dice-d6.svg");
const dice_d8_svg_3 = require("../src/icons/thin/dice-d8.svg");
const dice_five_svg_3 = require("../src/icons/thin/dice-five.svg");
const dice_four_svg_3 = require("../src/icons/thin/dice-four.svg");
const dice_one_svg_3 = require("../src/icons/thin/dice-one.svg");
const dice_six_svg_3 = require("../src/icons/thin/dice-six.svg");
const dice_three_svg_3 = require("../src/icons/thin/dice-three.svg");
const dice_two_svg_3 = require("../src/icons/thin/dice-two.svg");
const dice_svg_3 = require("../src/icons/thin/dice.svg");
const diploma_svg_3 = require("../src/icons/thin/diploma.svg");
const disc_drive_svg_3 = require("../src/icons/thin/disc-drive.svg");
const disease_svg_3 = require("../src/icons/thin/disease.svg");
const display_arrow_down_svg_3 = require("../src/icons/thin/display-arrow-down.svg");
const display_code_svg_3 = require("../src/icons/thin/display-code.svg");
const display_medical_svg_3 = require("../src/icons/thin/display-medical.svg");
const display_slash_svg_3 = require("../src/icons/thin/display-slash.svg");
const display_svg_3 = require("../src/icons/thin/display.svg");
const divide_svg_3 = require("../src/icons/thin/divide.svg");
const dna_svg_3 = require("../src/icons/thin/dna.svg");
const do_not_enter_svg_3 = require("../src/icons/thin/do-not-enter.svg");
const dog_leashed_svg_3 = require("../src/icons/thin/dog-leashed.svg");
const dog_svg_3 = require("../src/icons/thin/dog.svg");
const dollar_sign_svg_3 = require("../src/icons/thin/dollar-sign.svg");
const dolly_empty_svg_3 = require("../src/icons/thin/dolly-empty.svg");
const dolly_svg_3 = require("../src/icons/thin/dolly.svg");
const dolphin_svg_3 = require("../src/icons/thin/dolphin.svg");
const dong_sign_svg_3 = require("../src/icons/thin/dong-sign.svg");
const door_closed_svg_3 = require("../src/icons/thin/door-closed.svg");
const door_open_svg_3 = require("../src/icons/thin/door-open.svg");
const dove_svg_3 = require("../src/icons/thin/dove.svg");
const down_from_line_svg_3 = require("../src/icons/thin/down-from-line.svg");
const down_left_and_up_right_to_center_svg_3 = require("../src/icons/thin/down-left-and-up-right-to-center.svg");
const down_left_svg_3 = require("../src/icons/thin/down-left.svg");
const down_long_svg_3 = require("../src/icons/thin/down-long.svg");
const down_right_svg_3 = require("../src/icons/thin/down-right.svg");
const down_to_line_svg_3 = require("../src/icons/thin/down-to-line.svg");
const down_svg_3 = require("../src/icons/thin/down.svg");
const download_svg_3 = require("../src/icons/thin/download.svg");
const dragon_svg_3 = require("../src/icons/thin/dragon.svg");
const draw_circle_svg_3 = require("../src/icons/thin/draw-circle.svg");
const draw_polygon_svg_3 = require("../src/icons/thin/draw-polygon.svg");
const draw_square_svg_3 = require("../src/icons/thin/draw-square.svg");
const dreidel_svg_3 = require("../src/icons/thin/dreidel.svg");
const drone_front_svg_3 = require("../src/icons/thin/drone-front.svg");
const drone_svg_3 = require("../src/icons/thin/drone.svg");
const droplet_degree_svg_3 = require("../src/icons/thin/droplet-degree.svg");
const droplet_percent_svg_3 = require("../src/icons/thin/droplet-percent.svg");
const droplet_slash_svg_3 = require("../src/icons/thin/droplet-slash.svg");
const droplet_svg_3 = require("../src/icons/thin/droplet.svg");
const drum_steelpan_svg_3 = require("../src/icons/thin/drum-steelpan.svg");
const drum_svg_3 = require("../src/icons/thin/drum.svg");
const drumstick_bite_svg_3 = require("../src/icons/thin/drumstick-bite.svg");
const drumstick_svg_3 = require("../src/icons/thin/drumstick.svg");
const dryer_heat_svg_3 = require("../src/icons/thin/dryer-heat.svg");
const dryer_svg_3 = require("../src/icons/thin/dryer.svg");
const duck_svg_3 = require("../src/icons/thin/duck.svg");
const dumbbell_svg_3 = require("../src/icons/thin/dumbbell.svg");
const dumpster_fire_svg_3 = require("../src/icons/thin/dumpster-fire.svg");
const dumpster_svg_3 = require("../src/icons/thin/dumpster.svg");
const dungeon_svg_3 = require("../src/icons/thin/dungeon.svg");
const e_svg_3 = require("../src/icons/thin/e.svg");
const ear_deaf_svg_3 = require("../src/icons/thin/ear-deaf.svg");
const ear_listen_svg_3 = require("../src/icons/thin/ear-listen.svg");
const ear_muffs_svg_3 = require("../src/icons/thin/ear-muffs.svg");
const ear_svg_3 = require("../src/icons/thin/ear.svg");
const earth_africa_svg_3 = require("../src/icons/thin/earth-africa.svg");
const earth_americas_svg_3 = require("../src/icons/thin/earth-americas.svg");
const earth_asia_svg_3 = require("../src/icons/thin/earth-asia.svg");
const earth_europa_svg_3 = require("../src/icons/thin/earth-europa.svg");
const eclipse_svg_3 = require("../src/icons/thin/eclipse.svg");
const egg_fried_svg_3 = require("../src/icons/thin/egg-fried.svg");
const egg_svg_3 = require("../src/icons/thin/egg.svg");
const eggplant_svg_3 = require("../src/icons/thin/eggplant.svg");
const eject_svg_3 = require("../src/icons/thin/eject.svg");
const elephant_svg_3 = require("../src/icons/thin/elephant.svg");
const elevator_svg_3 = require("../src/icons/thin/elevator.svg");
const ellipsis_stroke_vertical_svg_3 = require("../src/icons/thin/ellipsis-stroke-vertical.svg");
const ellipsis_stroke_svg_3 = require("../src/icons/thin/ellipsis-stroke.svg");
const ellipsis_vertical_svg_3 = require("../src/icons/thin/ellipsis-vertical.svg");
const ellipsis_svg_3 = require("../src/icons/thin/ellipsis.svg");
const empty_set_svg_3 = require("../src/icons/thin/empty-set.svg");
const engine_warning_svg_3 = require("../src/icons/thin/engine-warning.svg");
const engine_svg_3 = require("../src/icons/thin/engine.svg");
const envelope_dot_svg_3 = require("../src/icons/thin/envelope-dot.svg");
const envelope_open_dollar_svg_3 = require("../src/icons/thin/envelope-open-dollar.svg");
const envelope_open_text_svg_3 = require("../src/icons/thin/envelope-open-text.svg");
const envelope_open_svg_3 = require("../src/icons/thin/envelope-open.svg");
const envelope_svg_3 = require("../src/icons/thin/envelope.svg");
const envelopes_bulk_svg_3 = require("../src/icons/thin/envelopes-bulk.svg");
const envelopes_svg_3 = require("../src/icons/thin/envelopes.svg");
const equals_svg_3 = require("../src/icons/thin/equals.svg");
const eraser_svg_3 = require("../src/icons/thin/eraser.svg");
const escalator_svg_3 = require("../src/icons/thin/escalator.svg");
const ethernet_svg_3 = require("../src/icons/thin/ethernet.svg");
const euro_sign_svg_3 = require("../src/icons/thin/euro-sign.svg");
const exclamation_svg_3 = require("../src/icons/thin/exclamation.svg");
const expand_wide_svg_3 = require("../src/icons/thin/expand-wide.svg");
const expand_svg_3 = require("../src/icons/thin/expand.svg");
const eye_dropper_full_svg_3 = require("../src/icons/thin/eye-dropper-full.svg");
const eye_dropper_half_svg_3 = require("../src/icons/thin/eye-dropper-half.svg");
const eye_dropper_svg_3 = require("../src/icons/thin/eye-dropper.svg");
const eye_evil_svg_3 = require("../src/icons/thin/eye-evil.svg");
const eye_low_vision_svg_3 = require("../src/icons/thin/eye-low-vision.svg");
const eye_slash_svg_3 = require("../src/icons/thin/eye-slash.svg");
const eye_svg_3 = require("../src/icons/thin/eye.svg");
const f_svg_3 = require("../src/icons/thin/f.svg");
const face_angry_svg_3 = require("../src/icons/thin/face-angry.svg");
const face_dizzy_svg_3 = require("../src/icons/thin/face-dizzy.svg");
const face_flushed_svg_3 = require("../src/icons/thin/face-flushed.svg");
const face_frown_open_svg_3 = require("../src/icons/thin/face-frown-open.svg");
const face_frown_svg_3 = require("../src/icons/thin/face-frown.svg");
const face_grimace_svg_3 = require("../src/icons/thin/face-grimace.svg");
const face_grin_beam_sweat_svg_3 = require("../src/icons/thin/face-grin-beam-sweat.svg");
const face_grin_beam_svg_3 = require("../src/icons/thin/face-grin-beam.svg");
const face_grin_hearts_svg_3 = require("../src/icons/thin/face-grin-hearts.svg");
const face_grin_squint_tears_svg_3 = require("../src/icons/thin/face-grin-squint-tears.svg");
const face_grin_squint_svg_3 = require("../src/icons/thin/face-grin-squint.svg");
const face_grin_stars_svg_3 = require("../src/icons/thin/face-grin-stars.svg");
const face_grin_tears_svg_3 = require("../src/icons/thin/face-grin-tears.svg");
const face_grin_tongue_squint_svg_3 = require("../src/icons/thin/face-grin-tongue-squint.svg");
const face_grin_tongue_wink_svg_3 = require("../src/icons/thin/face-grin-tongue-wink.svg");
const face_grin_tongue_svg_3 = require("../src/icons/thin/face-grin-tongue.svg");
const face_grin_wide_svg_3 = require("../src/icons/thin/face-grin-wide.svg");
const face_grin_wink_svg_3 = require("../src/icons/thin/face-grin-wink.svg");
const face_grin_svg_3 = require("../src/icons/thin/face-grin.svg");
const face_kiss_beam_svg_3 = require("../src/icons/thin/face-kiss-beam.svg");
const face_kiss_wink_heart_svg_3 = require("../src/icons/thin/face-kiss-wink-heart.svg");
const face_kiss_svg_3 = require("../src/icons/thin/face-kiss.svg");
const face_laugh_beam_svg_3 = require("../src/icons/thin/face-laugh-beam.svg");
const face_laugh_squint_svg_3 = require("../src/icons/thin/face-laugh-squint.svg");
const face_laugh_wink_svg_3 = require("../src/icons/thin/face-laugh-wink.svg");
const face_laugh_svg_3 = require("../src/icons/thin/face-laugh.svg");
const face_meh_blank_svg_3 = require("../src/icons/thin/face-meh-blank.svg");
const face_meh_svg_3 = require("../src/icons/thin/face-meh.svg");
const face_rolling_eyes_svg_3 = require("../src/icons/thin/face-rolling-eyes.svg");
const face_sad_cry_svg_3 = require("../src/icons/thin/face-sad-cry.svg");
const face_sad_tear_svg_3 = require("../src/icons/thin/face-sad-tear.svg");
const face_smile_beam_svg_3 = require("../src/icons/thin/face-smile-beam.svg");
const face_smile_plus_svg_3 = require("../src/icons/thin/face-smile-plus.svg");
const face_smile_wink_svg_3 = require("../src/icons/thin/face-smile-wink.svg");
const face_smile_svg_3 = require("../src/icons/thin/face-smile.svg");
const face_surprise_svg_3 = require("../src/icons/thin/face-surprise.svg");
const face_tired_svg_3 = require("../src/icons/thin/face-tired.svg");
const fan_table_svg_3 = require("../src/icons/thin/fan-table.svg");
const fan_svg_3 = require("../src/icons/thin/fan.svg");
const farm_svg_3 = require("../src/icons/thin/farm.svg");
const faucet_drip_svg_3 = require("../src/icons/thin/faucet-drip.svg");
const faucet_svg_3 = require("../src/icons/thin/faucet.svg");
const fax_svg_3 = require("../src/icons/thin/fax.svg");
const feather_pointed_svg_3 = require("../src/icons/thin/feather-pointed.svg");
const feather_svg_3 = require("../src/icons/thin/feather.svg");
const fence_svg_3 = require("../src/icons/thin/fence.svg");
const field_hockey_stick_ball_svg_3 = require("../src/icons/thin/field-hockey-stick-ball.svg");
const file_arrow_down_svg_3 = require("../src/icons/thin/file-arrow-down.svg");
const file_arrow_up_svg_3 = require("../src/icons/thin/file-arrow-up.svg");
const file_audio_svg_3 = require("../src/icons/thin/file-audio.svg");
const file_binary_svg_3 = require("../src/icons/thin/file-binary.svg");
const file_certificate_svg_3 = require("../src/icons/thin/file-certificate.svg");
const file_chart_column_svg_3 = require("../src/icons/thin/file-chart-column.svg");
const file_chart_pie_svg_3 = require("../src/icons/thin/file-chart-pie.svg");
const file_check_svg_3 = require("../src/icons/thin/file-check.svg");
const file_code_svg_3 = require("../src/icons/thin/file-code.svg");
const file_contract_svg_3 = require("../src/icons/thin/file-contract.svg");
const file_csv_svg_3 = require("../src/icons/thin/file-csv.svg");
const file_dashed_line_svg_3 = require("../src/icons/thin/file-dashed-line.svg");
const file_excel_svg_3 = require("../src/icons/thin/file-excel.svg");
const file_exclamation_svg_3 = require("../src/icons/thin/file-exclamation.svg");
const file_export_svg_3 = require("../src/icons/thin/file-export.svg");
const file_heart_svg_3 = require("../src/icons/thin/file-heart.svg");
const file_image_svg_3 = require("../src/icons/thin/file-image.svg");
const file_import_svg_3 = require("../src/icons/thin/file-import.svg");
const file_invoice_dollar_svg_3 = require("../src/icons/thin/file-invoice-dollar.svg");
const file_invoice_svg_3 = require("../src/icons/thin/file-invoice.svg");
const file_lines_svg_3 = require("../src/icons/thin/file-lines.svg");
const file_magnifying_glass_svg_3 = require("../src/icons/thin/file-magnifying-glass.svg");
const file_medical_svg_3 = require("../src/icons/thin/file-medical.svg");
const file_minus_svg_3 = require("../src/icons/thin/file-minus.svg");
const file_music_svg_3 = require("../src/icons/thin/file-music.svg");
const file_pdf_svg_3 = require("../src/icons/thin/file-pdf.svg");
const file_pen_svg_3 = require("../src/icons/thin/file-pen.svg");
const file_plus_minus_svg_3 = require("../src/icons/thin/file-plus-minus.svg");
const file_plus_svg_3 = require("../src/icons/thin/file-plus.svg");
const file_powerpoint_svg_3 = require("../src/icons/thin/file-powerpoint.svg");
const file_prescription_svg_3 = require("../src/icons/thin/file-prescription.svg");
const file_signature_svg_3 = require("../src/icons/thin/file-signature.svg");
const file_spreadsheet_svg_3 = require("../src/icons/thin/file-spreadsheet.svg");
const file_user_svg_3 = require("../src/icons/thin/file-user.svg");
const file_video_svg_3 = require("../src/icons/thin/file-video.svg");
const file_waveform_svg_3 = require("../src/icons/thin/file-waveform.svg");
const file_word_svg_3 = require("../src/icons/thin/file-word.svg");
const file_xmark_svg_3 = require("../src/icons/thin/file-xmark.svg");
const file_zipper_svg_3 = require("../src/icons/thin/file-zipper.svg");
const file_svg_3 = require("../src/icons/thin/file.svg");
const files_medical_svg_3 = require("../src/icons/thin/files-medical.svg");
const files_svg_3 = require("../src/icons/thin/files.svg");
const fill_drip_svg_3 = require("../src/icons/thin/fill-drip.svg");
const fill_svg_3 = require("../src/icons/thin/fill.svg");
const film_canister_svg_3 = require("../src/icons/thin/film-canister.svg");
const film_simple_svg_3 = require("../src/icons/thin/film-simple.svg");
const film_slash_svg_3 = require("../src/icons/thin/film-slash.svg");
const film_svg_3 = require("../src/icons/thin/film.svg");
const films_svg_3 = require("../src/icons/thin/films.svg");
const filter_circle_dollar_svg_3 = require("../src/icons/thin/filter-circle-dollar.svg");
const filter_circle_xmark_svg_3 = require("../src/icons/thin/filter-circle-xmark.svg");
const filter_list_svg_3 = require("../src/icons/thin/filter-list.svg");
const filter_slash_svg_3 = require("../src/icons/thin/filter-slash.svg");
const filter_svg_3 = require("../src/icons/thin/filter.svg");
const filters_svg_3 = require("../src/icons/thin/filters.svg");
const fingerprint_svg_3 = require("../src/icons/thin/fingerprint.svg");
const fire_extinguisher_svg_3 = require("../src/icons/thin/fire-extinguisher.svg");
const fire_flame_curved_svg_3 = require("../src/icons/thin/fire-flame-curved.svg");
const fire_flame_simple_svg_3 = require("../src/icons/thin/fire-flame-simple.svg");
const fire_flame_svg_3 = require("../src/icons/thin/fire-flame.svg");
const fire_hydrant_svg_3 = require("../src/icons/thin/fire-hydrant.svg");
const fire_smoke_svg_3 = require("../src/icons/thin/fire-smoke.svg");
const fire_svg_3 = require("../src/icons/thin/fire.svg");
const fireplace_svg_3 = require("../src/icons/thin/fireplace.svg");
const fish_cooked_svg_3 = require("../src/icons/thin/fish-cooked.svg");
const fish_svg_3 = require("../src/icons/thin/fish.svg");
const flag_checkered_svg_3 = require("../src/icons/thin/flag-checkered.svg");
const flag_pennant_svg_3 = require("../src/icons/thin/flag-pennant.svg");
const flag_swallowtail_svg_3 = require("../src/icons/thin/flag-swallowtail.svg");
const flag_usa_svg_3 = require("../src/icons/thin/flag-usa.svg");
const flag_svg_3 = require("../src/icons/thin/flag.svg");
const flashlight_svg_3 = require("../src/icons/thin/flashlight.svg");
const flask_round_poison_svg_3 = require("../src/icons/thin/flask-round-poison.svg");
const flask_round_potion_svg_3 = require("../src/icons/thin/flask-round-potion.svg");
const flask_svg_3 = require("../src/icons/thin/flask.svg");
const floppy_disk_circle_arrow_right_svg_3 = require("../src/icons/thin/floppy-disk-circle-arrow-right.svg");
const floppy_disk_circle_xmark_svg_3 = require("../src/icons/thin/floppy-disk-circle-xmark.svg");
const floppy_disk_pen_svg_3 = require("../src/icons/thin/floppy-disk-pen.svg");
const floppy_disk_svg_3 = require("../src/icons/thin/floppy-disk.svg");
const floppy_disks_svg_3 = require("../src/icons/thin/floppy-disks.svg");
const florin_sign_svg_3 = require("../src/icons/thin/florin-sign.svg");
const flower_daffodil_svg_3 = require("../src/icons/thin/flower-daffodil.svg");
const flower_tulip_svg_3 = require("../src/icons/thin/flower-tulip.svg");
const flower_svg_3 = require("../src/icons/thin/flower.svg");
const flute_svg_3 = require("../src/icons/thin/flute.svg");
const flux_capacitor_svg_3 = require("../src/icons/thin/flux-capacitor.svg");
const folder_arrow_down_svg_3 = require("../src/icons/thin/folder-arrow-down.svg");
const folder_arrow_up_svg_3 = require("../src/icons/thin/folder-arrow-up.svg");
const folder_blank_svg_3 = require("../src/icons/thin/folder-blank.svg");
const folder_bookmark_svg_3 = require("../src/icons/thin/folder-bookmark.svg");
const folder_gear_svg_3 = require("../src/icons/thin/folder-gear.svg");
const folder_grid_svg_3 = require("../src/icons/thin/folder-grid.svg");
const folder_heart_svg_3 = require("../src/icons/thin/folder-heart.svg");
const folder_image_svg_3 = require("../src/icons/thin/folder-image.svg");
const folder_magnifying_glass_svg_3 = require("../src/icons/thin/folder-magnifying-glass.svg");
const folder_medical_svg_3 = require("../src/icons/thin/folder-medical.svg");
const folder_minus_svg_3 = require("../src/icons/thin/folder-minus.svg");
const folder_music_svg_3 = require("../src/icons/thin/folder-music.svg");
const folder_open_svg_3 = require("../src/icons/thin/folder-open.svg");
const folder_plus_svg_3 = require("../src/icons/thin/folder-plus.svg");
const folder_tree_svg_3 = require("../src/icons/thin/folder-tree.svg");
const folder_user_svg_3 = require("../src/icons/thin/folder-user.svg");
const folder_xmark_svg_3 = require("../src/icons/thin/folder-xmark.svg");
const folder_svg_3 = require("../src/icons/thin/folder.svg");
const folders_svg_3 = require("../src/icons/thin/folders.svg");
const font_awesome_svg_4 = require("../src/icons/thin/font-awesome.svg");
const font_case_svg_3 = require("../src/icons/thin/font-case.svg");
const font_svg_3 = require("../src/icons/thin/font.svg");
const football_ball_svg_3 = require("../src/icons/thin/football-ball.svg");
const football_helmet_svg_3 = require("../src/icons/thin/football-helmet.svg");
const fork_knife_svg_3 = require("../src/icons/thin/fork-knife.svg");
const fork_svg_3 = require("../src/icons/thin/fork.svg");
const forklift_svg_3 = require("../src/icons/thin/forklift.svg");
const forward_fast_svg_3 = require("../src/icons/thin/forward-fast.svg");
const forward_step_svg_3 = require("../src/icons/thin/forward-step.svg");
const forward_svg_3 = require("../src/icons/thin/forward.svg");
const franc_sign_svg_3 = require("../src/icons/thin/franc-sign.svg");
const french_fries_svg_3 = require("../src/icons/thin/french-fries.svg");
const frog_svg_3 = require("../src/icons/thin/frog.svg");
const function_svg_3 = require("../src/icons/thin/function.svg");
const futbol_ball_svg_3 = require("../src/icons/thin/futbol-ball.svg");
const g_svg_3 = require("../src/icons/thin/g.svg");
const galaxy_svg_3 = require("../src/icons/thin/galaxy.svg");
const game_board_simple_svg_3 = require("../src/icons/thin/game-board-simple.svg");
const game_board_svg_3 = require("../src/icons/thin/game-board.svg");
const game_console_handheld_svg_3 = require("../src/icons/thin/game-console-handheld.svg");
const gamepad_modern_svg_3 = require("../src/icons/thin/gamepad-modern.svg");
const gamepad_svg_3 = require("../src/icons/thin/gamepad.svg");
const garage_car_svg_3 = require("../src/icons/thin/garage-car.svg");
const garage_open_svg_3 = require("../src/icons/thin/garage-open.svg");
const garage_svg_3 = require("../src/icons/thin/garage.svg");
const gas_pump_slash_svg_3 = require("../src/icons/thin/gas-pump-slash.svg");
const gas_pump_svg_3 = require("../src/icons/thin/gas-pump.svg");
const gauge_low_svg_3 = require("../src/icons/thin/gauge-low.svg");
const gauge_max_svg_3 = require("../src/icons/thin/gauge-max.svg");
const gauge_med_svg_3 = require("../src/icons/thin/gauge-med.svg");
const gauge_min_svg_3 = require("../src/icons/thin/gauge-min.svg");
const gauge_simple_low_svg_3 = require("../src/icons/thin/gauge-simple-low.svg");
const gauge_simple_max_svg_3 = require("../src/icons/thin/gauge-simple-max.svg");
const gauge_simple_med_svg_3 = require("../src/icons/thin/gauge-simple-med.svg");
const gauge_simple_min_svg_3 = require("../src/icons/thin/gauge-simple-min.svg");
const gauge_simple_svg_3 = require("../src/icons/thin/gauge-simple.svg");
const gauge_svg_3 = require("../src/icons/thin/gauge.svg");
const gavel_svg_3 = require("../src/icons/thin/gavel.svg");
const gear_svg_3 = require("../src/icons/thin/gear.svg");
const gears_svg_3 = require("../src/icons/thin/gears.svg");
const gem_svg_3 = require("../src/icons/thin/gem.svg");
const genderless_svg_3 = require("../src/icons/thin/genderless.svg");
const ghost_svg_3 = require("../src/icons/thin/ghost.svg");
const gif_svg_3 = require("../src/icons/thin/gif.svg");
const gift_card_svg_3 = require("../src/icons/thin/gift-card.svg");
const gift_svg_3 = require("../src/icons/thin/gift.svg");
const gifts_svg_3 = require("../src/icons/thin/gifts.svg");
const gingerbread_man_svg_3 = require("../src/icons/thin/gingerbread-man.svg");
const glass_citrus_svg_3 = require("../src/icons/thin/glass-citrus.svg");
const glass_empty_svg_3 = require("../src/icons/thin/glass-empty.svg");
const glass_half_svg_3 = require("../src/icons/thin/glass-half.svg");
const glass_svg_3 = require("../src/icons/thin/glass.svg");
const glasses_round_svg_3 = require("../src/icons/thin/glasses-round.svg");
const glasses_svg_3 = require("../src/icons/thin/glasses.svg");
const globe_snow_svg_3 = require("../src/icons/thin/globe-snow.svg");
const globe_stand_svg_3 = require("../src/icons/thin/globe-stand.svg");
const globe_svg_3 = require("../src/icons/thin/globe.svg");
const golf_ball_tee_svg_3 = require("../src/icons/thin/golf-ball-tee.svg");
const golf_club_svg_3 = require("../src/icons/thin/golf-club.svg");
const gopuram_svg_3 = require("../src/icons/thin/gopuram.svg");
const graduation_cap_svg_3 = require("../src/icons/thin/graduation-cap.svg");
const gramophone_svg_3 = require("../src/icons/thin/gramophone.svg");
const grate_droplet_svg_3 = require("../src/icons/thin/grate-droplet.svg");
const grate_svg_3 = require("../src/icons/thin/grate.svg");
const greater_than_equal_svg_3 = require("../src/icons/thin/greater-than-equal.svg");
const greater_than_svg_3 = require("../src/icons/thin/greater-than.svg");
const grid_2_plus_svg_3 = require("../src/icons/thin/grid-2-plus.svg");
const grid_2_svg_3 = require("../src/icons/thin/grid-2.svg");
const grid_4_svg_3 = require("../src/icons/thin/grid-4.svg");
const grid_5_svg_3 = require("../src/icons/thin/grid-5.svg");
const grid_svg_3 = require("../src/icons/thin/grid.svg");
const grip_lines_vertical_svg_3 = require("../src/icons/thin/grip-lines-vertical.svg");
const grip_lines_svg_3 = require("../src/icons/thin/grip-lines.svg");
const grip_vertical_svg_3 = require("../src/icons/thin/grip-vertical.svg");
const grip_svg_3 = require("../src/icons/thin/grip.svg");
const guarani_sign_svg_3 = require("../src/icons/thin/guarani-sign.svg");
const guitar_electric_svg_3 = require("../src/icons/thin/guitar-electric.svg");
const guitar_svg_3 = require("../src/icons/thin/guitar.svg");
const guitars_svg_3 = require("../src/icons/thin/guitars.svg");
const gun_slash_svg_3 = require("../src/icons/thin/gun-slash.svg");
const gun_squirt_svg_3 = require("../src/icons/thin/gun-squirt.svg");
const gun_svg_3 = require("../src/icons/thin/gun.svg");
const h_svg_3 = require("../src/icons/thin/h.svg");
const h1_svg_3 = require("../src/icons/thin/h1.svg");
const h2_svg_3 = require("../src/icons/thin/h2.svg");
const h3_svg_3 = require("../src/icons/thin/h3.svg");
const h4_svg_3 = require("../src/icons/thin/h4.svg");
const hammer_war_svg_3 = require("../src/icons/thin/hammer-war.svg");
const hammer_svg_3 = require("../src/icons/thin/hammer.svg");
const hamsa_svg_3 = require("../src/icons/thin/hamsa.svg");
const hand_back_point_down_svg_3 = require("../src/icons/thin/hand-back-point-down.svg");
const hand_back_point_left_svg_3 = require("../src/icons/thin/hand-back-point-left.svg");
const hand_back_point_right_svg_3 = require("../src/icons/thin/hand-back-point-right.svg");
const hand_back_point_up_svg_3 = require("../src/icons/thin/hand-back-point-up.svg");
const hand_dots_svg_3 = require("../src/icons/thin/hand-dots.svg");
const hand_fingers_crossed_svg_3 = require("../src/icons/thin/hand-fingers-crossed.svg");
const hand_fist_svg_3 = require("../src/icons/thin/hand-fist.svg");
const hand_heart_svg_3 = require("../src/icons/thin/hand-heart.svg");
const hand_holding_box_svg_3 = require("../src/icons/thin/hand-holding-box.svg");
const hand_holding_dollar_svg_3 = require("../src/icons/thin/hand-holding-dollar.svg");
const hand_holding_droplet_svg_3 = require("../src/icons/thin/hand-holding-droplet.svg");
const hand_holding_heart_svg_3 = require("../src/icons/thin/hand-holding-heart.svg");
const hand_holding_magic_svg_3 = require("../src/icons/thin/hand-holding-magic.svg");
const hand_holding_medical_svg_3 = require("../src/icons/thin/hand-holding-medical.svg");
const hand_holding_seedling_svg_3 = require("../src/icons/thin/hand-holding-seedling.svg");
const hand_holding_skull_svg_3 = require("../src/icons/thin/hand-holding-skull.svg");
const hand_holding_svg_3 = require("../src/icons/thin/hand-holding.svg");
const hand_lizard_svg_3 = require("../src/icons/thin/hand-lizard.svg");
const hand_love_svg_3 = require("../src/icons/thin/hand-love.svg");
const hand_middle_finger_svg_3 = require("../src/icons/thin/hand-middle-finger.svg");
const hand_paper_svg_3 = require("../src/icons/thin/hand-paper.svg");
const hand_peace_svg_3 = require("../src/icons/thin/hand-peace.svg");
const hand_point_down_svg_3 = require("../src/icons/thin/hand-point-down.svg");
const hand_point_left_svg_3 = require("../src/icons/thin/hand-point-left.svg");
const hand_point_right_svg_3 = require("../src/icons/thin/hand-point-right.svg");
const hand_point_up_svg_3 = require("../src/icons/thin/hand-point-up.svg");
const hand_pointer_svg_3 = require("../src/icons/thin/hand-pointer.svg");
const hand_rock_svg_3 = require("../src/icons/thin/hand-rock.svg");
const hand_scissors_svg_3 = require("../src/icons/thin/hand-scissors.svg");
const hand_sparkles_svg_3 = require("../src/icons/thin/hand-sparkles.svg");
const hand_spock_svg_3 = require("../src/icons/thin/hand-spock.svg");
const hand_wave_svg_3 = require("../src/icons/thin/hand-wave.svg");
const hands_asl_interpreting_svg_3 = require("../src/icons/thin/hands-asl-interpreting.svg");
const hands_bubbles_svg_3 = require("../src/icons/thin/hands-bubbles.svg");
const hands_clapping_svg_3 = require("../src/icons/thin/hands-clapping.svg");
const hands_holding_diamond_svg_3 = require("../src/icons/thin/hands-holding-diamond.svg");
const hands_holding_dollar_svg_3 = require("../src/icons/thin/hands-holding-dollar.svg");
const hands_holding_heart_svg_3 = require("../src/icons/thin/hands-holding-heart.svg");
const hands_holding_svg_3 = require("../src/icons/thin/hands-holding.svg");
const hands_horns_svg_3 = require("../src/icons/thin/hands-horns.svg");
const hands_praying_svg_3 = require("../src/icons/thin/hands-praying.svg");
const hands_svg_3 = require("../src/icons/thin/hands.svg");
const handshake_angle_svg_3 = require("../src/icons/thin/handshake-angle.svg");
const handshake_simple_slash_svg_3 = require("../src/icons/thin/handshake-simple-slash.svg");
const handshake_simple_svg_3 = require("../src/icons/thin/handshake-simple.svg");
const handshake_slash_svg_3 = require("../src/icons/thin/handshake-slash.svg");
const handshake_svg_3 = require("../src/icons/thin/handshake.svg");
const hanukiah_svg_3 = require("../src/icons/thin/hanukiah.svg");
const hard_drive_svg_3 = require("../src/icons/thin/hard-drive.svg");
const hashtag_svg_3 = require("../src/icons/thin/hashtag.svg");
const hat_chef_svg_3 = require("../src/icons/thin/hat-chef.svg");
const hat_cowboy_side_svg_3 = require("../src/icons/thin/hat-cowboy-side.svg");
const hat_cowboy_svg_3 = require("../src/icons/thin/hat-cowboy.svg");
const hat_santa_svg_3 = require("../src/icons/thin/hat-santa.svg");
const hat_winter_svg_3 = require("../src/icons/thin/hat-winter.svg");
const hat_witch_svg_3 = require("../src/icons/thin/hat-witch.svg");
const hat_wizard_svg_3 = require("../src/icons/thin/hat-wizard.svg");
const head_side_brain_svg_3 = require("../src/icons/thin/head-side-brain.svg");
const head_side_cough_slash_svg_3 = require("../src/icons/thin/head-side-cough-slash.svg");
const head_side_cough_svg_3 = require("../src/icons/thin/head-side-cough.svg");
const head_side_goggles_svg_3 = require("../src/icons/thin/head-side-goggles.svg");
const head_side_headphones_svg_3 = require("../src/icons/thin/head-side-headphones.svg");
const head_side_heart_svg_3 = require("../src/icons/thin/head-side-heart.svg");
const head_side_mask_svg_3 = require("../src/icons/thin/head-side-mask.svg");
const head_side_medical_svg_3 = require("../src/icons/thin/head-side-medical.svg");
const head_side_virus_svg_3 = require("../src/icons/thin/head-side-virus.svg");
const head_side_svg_3 = require("../src/icons/thin/head-side.svg");
const heading_svg_3 = require("../src/icons/thin/heading.svg");
const headphones_simple_svg_3 = require("../src/icons/thin/headphones-simple.svg");
const headphones_svg_3 = require("../src/icons/thin/headphones.svg");
const headset_svg_3 = require("../src/icons/thin/headset.svg");
const heart_crack_svg_3 = require("../src/icons/thin/heart-crack.svg");
const heart_half_stroke_svg_3 = require("../src/icons/thin/heart-half-stroke.svg");
const heart_half_svg_3 = require("../src/icons/thin/heart-half.svg");
const heart_pulse_svg_3 = require("../src/icons/thin/heart-pulse.svg");
const heart_svg_3 = require("../src/icons/thin/heart.svg");
const heat_svg_3 = require("../src/icons/thin/heat.svg");
const helicopter_svg_3 = require("../src/icons/thin/helicopter.svg");
const helmet_battle_svg_3 = require("../src/icons/thin/helmet-battle.svg");
const helmet_safety_svg_3 = require("../src/icons/thin/helmet-safety.svg");
const hexagon_divide_svg_3 = require("../src/icons/thin/hexagon-divide.svg");
const hexagon_minus_svg_3 = require("../src/icons/thin/hexagon-minus.svg");
const hexagon_plus_svg_3 = require("../src/icons/thin/hexagon-plus.svg");
const hexagon_xmark_svg_3 = require("../src/icons/thin/hexagon-xmark.svg");
const hexagon_svg_3 = require("../src/icons/thin/hexagon.svg");
const high_definition_svg_3 = require("../src/icons/thin/high-definition.svg");
const highlighter_line_svg_3 = require("../src/icons/thin/highlighter-line.svg");
const highlighter_svg_3 = require("../src/icons/thin/highlighter.svg");
const hippo_svg_3 = require("../src/icons/thin/hippo.svg");
const hockey_mask_svg_3 = require("../src/icons/thin/hockey-mask.svg");
const hockey_puck_svg_3 = require("../src/icons/thin/hockey-puck.svg");
const hockey_sticks_svg_3 = require("../src/icons/thin/hockey-sticks.svg");
const holly_berry_svg_3 = require("../src/icons/thin/holly-berry.svg");
const home_heart_svg_3 = require("../src/icons/thin/home-heart.svg");
const home_simple_svg_3 = require("../src/icons/thin/home-simple.svg");
const home_user_svg_3 = require("../src/icons/thin/home-user.svg");
const home_svg_3 = require("../src/icons/thin/home.svg");
const hood_cloak_svg_3 = require("../src/icons/thin/hood-cloak.svg");
const horizontal_rule_svg_3 = require("../src/icons/thin/horizontal-rule.svg");
const horse_head_svg_3 = require("../src/icons/thin/horse-head.svg");
const horse_saddle_svg_3 = require("../src/icons/thin/horse-saddle.svg");
const horse_svg_3 = require("../src/icons/thin/horse.svg");
const hospital_user_svg_3 = require("../src/icons/thin/hospital-user.svg");
const hospital_wide_svg_3 = require("../src/icons/thin/hospital-wide.svg");
const hospital_svg_3 = require("../src/icons/thin/hospital.svg");
const hospitals_svg_3 = require("../src/icons/thin/hospitals.svg");
const hot_tub_person_svg_3 = require("../src/icons/thin/hot-tub-person.svg");
const hotdog_svg_3 = require("../src/icons/thin/hotdog.svg");
const hotel_svg_3 = require("../src/icons/thin/hotel.svg");
const hourglass_empty_svg_3 = require("../src/icons/thin/hourglass-empty.svg");
const hourglass_end_svg_3 = require("../src/icons/thin/hourglass-end.svg");
const hourglass_start_svg_3 = require("../src/icons/thin/hourglass-start.svg");
const hourglass_svg_3 = require("../src/icons/thin/hourglass.svg");
const house_building_svg_3 = require("../src/icons/thin/house-building.svg");
const house_crack_svg_3 = require("../src/icons/thin/house-crack.svg");
const house_day_svg_3 = require("../src/icons/thin/house-day.svg");
const house_flood_svg_3 = require("../src/icons/thin/house-flood.svg");
const house_heart_svg_3 = require("../src/icons/thin/house-heart.svg");
const house_laptop_svg_3 = require("../src/icons/thin/house-laptop.svg");
const house_medical_svg_3 = require("../src/icons/thin/house-medical.svg");
const house_night_svg_3 = require("../src/icons/thin/house-night.svg");
const house_person_leave_svg_3 = require("../src/icons/thin/house-person-leave.svg");
const house_person_return_svg_3 = require("../src/icons/thin/house-person-return.svg");
const house_signal_svg_3 = require("../src/icons/thin/house-signal.svg");
const house_tree_svg_3 = require("../src/icons/thin/house-tree.svg");
const house_turret_svg_3 = require("../src/icons/thin/house-turret.svg");
const house_user_svg_3 = require("../src/icons/thin/house-user.svg");
const house_svg_3 = require("../src/icons/thin/house.svg");
const hryvnia_sign_svg_3 = require("../src/icons/thin/hryvnia-sign.svg");
const hurricane_svg_3 = require("../src/icons/thin/hurricane.svg");
const i_cursor_svg_3 = require("../src/icons/thin/i-cursor.svg");
const i_svg_3 = require("../src/icons/thin/i.svg");
const ice_cream_svg_3 = require("../src/icons/thin/ice-cream.svg");
const ice_skate_svg_3 = require("../src/icons/thin/ice-skate.svg");
const icicles_svg_3 = require("../src/icons/thin/icicles.svg");
const icons_svg_3 = require("../src/icons/thin/icons.svg");
const id_badge_svg_3 = require("../src/icons/thin/id-badge.svg");
const id_card_clip_svg_3 = require("../src/icons/thin/id-card-clip.svg");
const id_card_svg_3 = require("../src/icons/thin/id-card.svg");
const igloo_svg_3 = require("../src/icons/thin/igloo.svg");
const image_landscape_svg_3 = require("../src/icons/thin/image-landscape.svg");
const image_polaroid_user_svg_3 = require("../src/icons/thin/image-polaroid-user.svg");
const image_polaroid_svg_3 = require("../src/icons/thin/image-polaroid.svg");
const image_portrait_svg_3 = require("../src/icons/thin/image-portrait.svg");
const image_slash_svg_3 = require("../src/icons/thin/image-slash.svg");
const image_user_svg_3 = require("../src/icons/thin/image-user.svg");
const image_svg_3 = require("../src/icons/thin/image.svg");
const images_user_svg_3 = require("../src/icons/thin/images-user.svg");
const images_svg_3 = require("../src/icons/thin/images.svg");
const inbox_full_svg_3 = require("../src/icons/thin/inbox-full.svg");
const inbox_in_svg_3 = require("../src/icons/thin/inbox-in.svg");
const inbox_out_svg_3 = require("../src/icons/thin/inbox-out.svg");
const inbox_svg_3 = require("../src/icons/thin/inbox.svg");
const inboxes_svg_3 = require("../src/icons/thin/inboxes.svg");
const indent_svg_3 = require("../src/icons/thin/indent.svg");
const indian_rupee_sign_svg_3 = require("../src/icons/thin/indian-rupee-sign.svg");
const industry_windows_svg_3 = require("../src/icons/thin/industry-windows.svg");
const industry_svg_3 = require("../src/icons/thin/industry.svg");
const infinity_svg_3 = require("../src/icons/thin/infinity.svg");
const info_svg_3 = require("../src/icons/thin/info.svg");
const inhaler_svg_3 = require("../src/icons/thin/inhaler.svg");
const input_numeric_svg_3 = require("../src/icons/thin/input-numeric.svg");
const input_pipe_svg_3 = require("../src/icons/thin/input-pipe.svg");
const input_text_svg_3 = require("../src/icons/thin/input-text.svg");
const integral_svg_3 = require("../src/icons/thin/integral.svg");
const intersection_svg_3 = require("../src/icons/thin/intersection.svg");
const island_tropical_svg_3 = require("../src/icons/thin/island-tropical.svg");
const italic_svg_3 = require("../src/icons/thin/italic.svg");
const j_svg_3 = require("../src/icons/thin/j.svg");
const jack_o_lantern_svg_3 = require("../src/icons/thin/jack-o-lantern.svg");
const jedi_svg_3 = require("../src/icons/thin/jedi.svg");
const jet_fighter_svg_3 = require("../src/icons/thin/jet-fighter.svg");
const joint_svg_3 = require("../src/icons/thin/joint.svg");
const joystick_svg_3 = require("../src/icons/thin/joystick.svg");
const jug_svg_3 = require("../src/icons/thin/jug.svg");
const k_svg_3 = require("../src/icons/thin/k.svg");
const kaaba_svg_3 = require("../src/icons/thin/kaaba.svg");
const kazoo_svg_3 = require("../src/icons/thin/kazoo.svg");
const kerning_svg_3 = require("../src/icons/thin/kerning.svg");
const key_skeleton_svg_3 = require("../src/icons/thin/key-skeleton.svg");
const key_svg_3 = require("../src/icons/thin/key.svg");
const keyboard_down_svg_3 = require("../src/icons/thin/keyboard-down.svg");
const keyboard_left_svg_3 = require("../src/icons/thin/keyboard-left.svg");
const keyboard_svg_3 = require("../src/icons/thin/keyboard.svg");
const keynote_svg_3 = require("../src/icons/thin/keynote.svg");
const khanda_svg_3 = require("../src/icons/thin/khanda.svg");
const kidneys_svg_3 = require("../src/icons/thin/kidneys.svg");
const kip_sign_svg_3 = require("../src/icons/thin/kip-sign.svg");
const kit_medical_svg_3 = require("../src/icons/thin/kit-medical.svg");
const kite_svg_3 = require("../src/icons/thin/kite.svg");
const kiwi_bird_svg_3 = require("../src/icons/thin/kiwi-bird.svg");
const knife_kitchen_svg_3 = require("../src/icons/thin/knife-kitchen.svg");
const knife_svg_3 = require("../src/icons/thin/knife.svg");
const l_svg_3 = require("../src/icons/thin/l.svg");
const lambda_svg_3 = require("../src/icons/thin/lambda.svg");
const lamp_desk_svg_3 = require("../src/icons/thin/lamp-desk.svg");
const lamp_floor_svg_3 = require("../src/icons/thin/lamp-floor.svg");
const lamp_street_svg_3 = require("../src/icons/thin/lamp-street.svg");
const lamp_svg_3 = require("../src/icons/thin/lamp.svg");
const landmark_dome_svg_3 = require("../src/icons/thin/landmark-dome.svg");
const landmark_svg_3 = require("../src/icons/thin/landmark.svg");
const language_svg_3 = require("../src/icons/thin/language.svg");
const laptop_arrow_down_svg_3 = require("../src/icons/thin/laptop-arrow-down.svg");
const laptop_code_svg_3 = require("../src/icons/thin/laptop-code.svg");
const laptop_medical_svg_3 = require("../src/icons/thin/laptop-medical.svg");
const laptop_mobile_svg_3 = require("../src/icons/thin/laptop-mobile.svg");
const laptop_slash_svg_3 = require("../src/icons/thin/laptop-slash.svg");
const laptop_svg_3 = require("../src/icons/thin/laptop.svg");
const lari_sign_svg_3 = require("../src/icons/thin/lari-sign.svg");
const lasso_sparkles_svg_3 = require("../src/icons/thin/lasso-sparkles.svg");
const lasso_svg_3 = require("../src/icons/thin/lasso.svg");
const layers_minus_svg_3 = require("../src/icons/thin/layers-minus.svg");
const layers_plus_svg_3 = require("../src/icons/thin/layers-plus.svg");
const layers_svg_3 = require("../src/icons/thin/layers.svg");
const leaf_heart_svg_3 = require("../src/icons/thin/leaf-heart.svg");
const leaf_maple_svg_3 = require("../src/icons/thin/leaf-maple.svg");
const leaf_oak_svg_3 = require("../src/icons/thin/leaf-oak.svg");
const leaf_svg_3 = require("../src/icons/thin/leaf.svg");
const left_from_line_svg_3 = require("../src/icons/thin/left-from-line.svg");
const left_long_svg_3 = require("../src/icons/thin/left-long.svg");
const left_right_svg_3 = require("../src/icons/thin/left-right.svg");
const left_to_line_svg_3 = require("../src/icons/thin/left-to-line.svg");
const left_svg_3 = require("../src/icons/thin/left.svg");
const lemon_svg_3 = require("../src/icons/thin/lemon.svg");
const less_than_equal_svg_3 = require("../src/icons/thin/less-than-equal.svg");
const less_than_svg_3 = require("../src/icons/thin/less-than.svg");
const life_ring_svg_3 = require("../src/icons/thin/life-ring.svg");
const light_ceiling_svg_3 = require("../src/icons/thin/light-ceiling.svg");
const light_switch_off_svg_3 = require("../src/icons/thin/light-switch-off.svg");
const light_switch_on_svg_3 = require("../src/icons/thin/light-switch-on.svg");
const light_switch_svg_3 = require("../src/icons/thin/light-switch.svg");
const lightbulb_dollar_svg_3 = require("../src/icons/thin/lightbulb-dollar.svg");
const lightbulb_exclamation_svg_3 = require("../src/icons/thin/lightbulb-exclamation.svg");
const lightbulb_on_svg_3 = require("../src/icons/thin/lightbulb-on.svg");
const lightbulb_slash_svg_3 = require("../src/icons/thin/lightbulb-slash.svg");
const lightbulb_svg_3 = require("../src/icons/thin/lightbulb.svg");
const lights_holiday_svg_3 = require("../src/icons/thin/lights-holiday.svg");
const line_columns_svg_3 = require("../src/icons/thin/line-columns.svg");
const line_height_svg_3 = require("../src/icons/thin/line-height.svg");
const link_horizontal_slash_svg_3 = require("../src/icons/thin/link-horizontal-slash.svg");
const link_horizontal_svg_3 = require("../src/icons/thin/link-horizontal.svg");
const link_simple_slash_svg_3 = require("../src/icons/thin/link-simple-slash.svg");
const link_simple_svg_3 = require("../src/icons/thin/link-simple.svg");
const link_slash_svg_3 = require("../src/icons/thin/link-slash.svg");
const link_svg_3 = require("../src/icons/thin/link.svg");
const lips_svg_3 = require("../src/icons/thin/lips.svg");
const lira_sign_svg_3 = require("../src/icons/thin/lira-sign.svg");
const list_check_svg_3 = require("../src/icons/thin/list-check.svg");
const list_dropdown_svg_3 = require("../src/icons/thin/list-dropdown.svg");
const list_music_svg_3 = require("../src/icons/thin/list-music.svg");
const list_ol_svg_3 = require("../src/icons/thin/list-ol.svg");
const list_radio_svg_3 = require("../src/icons/thin/list-radio.svg");
const list_timeline_svg_3 = require("../src/icons/thin/list-timeline.svg");
const list_tree_svg_3 = require("../src/icons/thin/list-tree.svg");
const list_ul_svg_3 = require("../src/icons/thin/list-ul.svg");
const list_svg_3 = require("../src/icons/thin/list.svg");
const litecoin_sign_svg_3 = require("../src/icons/thin/litecoin-sign.svg");
const loader_svg_3 = require("../src/icons/thin/loader.svg");
const location_arrow_svg_3 = require("../src/icons/thin/location-arrow.svg");
const location_check_svg_3 = require("../src/icons/thin/location-check.svg");
const location_crosshairs_slash_svg_3 = require("../src/icons/thin/location-crosshairs-slash.svg");
const location_crosshairs_svg_3 = require("../src/icons/thin/location-crosshairs.svg");
const location_dot_slash_svg_3 = require("../src/icons/thin/location-dot-slash.svg");
const location_dot_svg_3 = require("../src/icons/thin/location-dot.svg");
const location_exclamation_svg_3 = require("../src/icons/thin/location-exclamation.svg");
const location_minus_svg_3 = require("../src/icons/thin/location-minus.svg");
const location_pen_svg_3 = require("../src/icons/thin/location-pen.svg");
const location_plus_svg_3 = require("../src/icons/thin/location-plus.svg");
const location_question_svg_3 = require("../src/icons/thin/location-question.svg");
const location_slash_svg_3 = require("../src/icons/thin/location-slash.svg");
const location_smile_svg_3 = require("../src/icons/thin/location-smile.svg");
const location_xmark_svg_3 = require("../src/icons/thin/location-xmark.svg");
const location_svg_3 = require("../src/icons/thin/location.svg");
const lock_keyhole_open_svg_3 = require("../src/icons/thin/lock-keyhole-open.svg");
const lock_keyhole_svg_3 = require("../src/icons/thin/lock-keyhole.svg");
const lock_open_svg_3 = require("../src/icons/thin/lock-open.svg");
const lock_svg_3 = require("../src/icons/thin/lock.svg");
const loveseat_svg_3 = require("../src/icons/thin/loveseat.svg");
const luchador_mask_svg_3 = require("../src/icons/thin/luchador-mask.svg");
const lungs_virus_svg_3 = require("../src/icons/thin/lungs-virus.svg");
const lungs_svg_3 = require("../src/icons/thin/lungs.svg");
const m_svg_3 = require("../src/icons/thin/m.svg");
const mace_svg_3 = require("../src/icons/thin/mace.svg");
const magnet_svg_3 = require("../src/icons/thin/magnet.svg");
const magnifying_glass_dollar_svg_3 = require("../src/icons/thin/magnifying-glass-dollar.svg");
const magnifying_glass_location_svg_3 = require("../src/icons/thin/magnifying-glass-location.svg");
const magnifying_glass_minus_svg_3 = require("../src/icons/thin/magnifying-glass-minus.svg");
const magnifying_glass_plus_svg_3 = require("../src/icons/thin/magnifying-glass-plus.svg");
const magnifying_glass_svg_3 = require("../src/icons/thin/magnifying-glass.svg");
const mailbox_svg_3 = require("../src/icons/thin/mailbox.svg");
const manat_sign_svg_3 = require("../src/icons/thin/manat-sign.svg");
const mandolin_svg_3 = require("../src/icons/thin/mandolin.svg");
const manhole_svg_3 = require("../src/icons/thin/manhole.svg");
const map_location_dot_svg_3 = require("../src/icons/thin/map-location-dot.svg");
const map_location_svg_3 = require("../src/icons/thin/map-location.svg");
const map_pin_svg_3 = require("../src/icons/thin/map-pin.svg");
const map_svg_3 = require("../src/icons/thin/map.svg");
const marker_svg_3 = require("../src/icons/thin/marker.svg");
const mars_double_svg_3 = require("../src/icons/thin/mars-double.svg");
const mars_stroke_right_svg_3 = require("../src/icons/thin/mars-stroke-right.svg");
const mars_stroke_up_svg_3 = require("../src/icons/thin/mars-stroke-up.svg");
const mars_stroke_svg_3 = require("../src/icons/thin/mars-stroke.svg");
const mars_svg_3 = require("../src/icons/thin/mars.svg");
const martini_glass_citrus_svg_3 = require("../src/icons/thin/martini-glass-citrus.svg");
const martini_glass_empty_svg_3 = require("../src/icons/thin/martini-glass-empty.svg");
const martini_glass_svg_3 = require("../src/icons/thin/martini-glass.svg");
const mask_face_svg_3 = require("../src/icons/thin/mask-face.svg");
const mask_svg_3 = require("../src/icons/thin/mask.svg");
const masks_theater_svg_3 = require("../src/icons/thin/masks-theater.svg");
const maximize_svg_3 = require("../src/icons/thin/maximize.svg");
const meat_svg_3 = require("../src/icons/thin/meat.svg");
const medal_svg_3 = require("../src/icons/thin/medal.svg");
const megaphone_svg_3 = require("../src/icons/thin/megaphone.svg");
const memo_circle_check_svg_3 = require("../src/icons/thin/memo-circle-check.svg");
const memo_svg_3 = require("../src/icons/thin/memo.svg");
const memory_svg_3 = require("../src/icons/thin/memory.svg");
const menorah_svg_3 = require("../src/icons/thin/menorah.svg");
const mercury_svg_3 = require("../src/icons/thin/mercury.svg");
const message_arrow_down_svg_3 = require("../src/icons/thin/message-arrow-down.svg");
const message_arrow_up_right_svg_3 = require("../src/icons/thin/message-arrow-up-right.svg");
const message_arrow_up_svg_3 = require("../src/icons/thin/message-arrow-up.svg");
const message_captions_svg_3 = require("../src/icons/thin/message-captions.svg");
const message_check_svg_3 = require("../src/icons/thin/message-check.svg");
const message_code_svg_3 = require("../src/icons/thin/message-code.svg");
const message_dollar_svg_3 = require("../src/icons/thin/message-dollar.svg");
const message_dots_svg_3 = require("../src/icons/thin/message-dots.svg");
const message_exclamation_svg_3 = require("../src/icons/thin/message-exclamation.svg");
const message_image_svg_3 = require("../src/icons/thin/message-image.svg");
const message_lines_svg_3 = require("../src/icons/thin/message-lines.svg");
const message_medical_svg_3 = require("../src/icons/thin/message-medical.svg");
const message_middle_top_svg_3 = require("../src/icons/thin/message-middle-top.svg");
const message_middle_svg_3 = require("../src/icons/thin/message-middle.svg");
const message_minus_svg_3 = require("../src/icons/thin/message-minus.svg");
const message_music_svg_3 = require("../src/icons/thin/message-music.svg");
const message_pen_svg_3 = require("../src/icons/thin/message-pen.svg");
const message_plus_svg_3 = require("../src/icons/thin/message-plus.svg");
const message_question_svg_3 = require("../src/icons/thin/message-question.svg");
const message_quote_svg_3 = require("../src/icons/thin/message-quote.svg");
const message_slash_svg_3 = require("../src/icons/thin/message-slash.svg");
const message_smile_svg_3 = require("../src/icons/thin/message-smile.svg");
const message_sms_svg_3 = require("../src/icons/thin/message-sms.svg");
const message_text_svg_3 = require("../src/icons/thin/message-text.svg");
const message_xmark_svg_3 = require("../src/icons/thin/message-xmark.svg");
const message_svg_3 = require("../src/icons/thin/message.svg");
const messages_dollar_svg_3 = require("../src/icons/thin/messages-dollar.svg");
const messages_question_svg_3 = require("../src/icons/thin/messages-question.svg");
const messages_svg_3 = require("../src/icons/thin/messages.svg");
const meteor_svg_3 = require("../src/icons/thin/meteor.svg");
const meter_bolt_svg_3 = require("../src/icons/thin/meter-bolt.svg");
const meter_droplet_svg_3 = require("../src/icons/thin/meter-droplet.svg");
const meter_fire_svg_3 = require("../src/icons/thin/meter-fire.svg");
const meter_svg_3 = require("../src/icons/thin/meter.svg");
const microchip_ai_svg_3 = require("../src/icons/thin/microchip-ai.svg");
const microchip_svg_3 = require("../src/icons/thin/microchip.svg");
const microphone_lines_slash_svg_3 = require("../src/icons/thin/microphone-lines-slash.svg");
const microphone_lines_svg_3 = require("../src/icons/thin/microphone-lines.svg");
const microphone_slash_svg_3 = require("../src/icons/thin/microphone-slash.svg");
const microphone_stand_svg_3 = require("../src/icons/thin/microphone-stand.svg");
const microphone_svg_3 = require("../src/icons/thin/microphone.svg");
const microscope_svg_3 = require("../src/icons/thin/microscope.svg");
const microwave_svg_3 = require("../src/icons/thin/microwave.svg");
const mill_sign_svg_3 = require("../src/icons/thin/mill-sign.svg");
const minimize_svg_3 = require("../src/icons/thin/minimize.svg");
const minus_svg_3 = require("../src/icons/thin/minus.svg");
const mistletoe_svg_3 = require("../src/icons/thin/mistletoe.svg");
const mitten_svg_3 = require("../src/icons/thin/mitten.svg");
const mobile_button_svg_3 = require("../src/icons/thin/mobile-button.svg");
const mobile_notch_svg_3 = require("../src/icons/thin/mobile-notch.svg");
const mobile_screen_button_svg_3 = require("../src/icons/thin/mobile-screen-button.svg");
const mobile_screen_svg_3 = require("../src/icons/thin/mobile-screen.svg");
const mobile_svg_3 = require("../src/icons/thin/mobile.svg");
const money_bill_1_wave_svg_3 = require("../src/icons/thin/money-bill-1-wave.svg");
const money_bill_1_svg_3 = require("../src/icons/thin/money-bill-1.svg");
const money_bill_simple_wave_svg_3 = require("../src/icons/thin/money-bill-simple-wave.svg");
const money_bill_simple_svg_3 = require("../src/icons/thin/money-bill-simple.svg");
const money_bill_wave_svg_3 = require("../src/icons/thin/money-bill-wave.svg");
const money_bill_svg_3 = require("../src/icons/thin/money-bill.svg");
const money_bills_simple_svg_3 = require("../src/icons/thin/money-bills-simple.svg");
const money_bills_svg_3 = require("../src/icons/thin/money-bills.svg");
const money_check_dollar_pen_svg_3 = require("../src/icons/thin/money-check-dollar-pen.svg");
const money_check_dollar_svg_3 = require("../src/icons/thin/money-check-dollar.svg");
const money_check_pen_svg_3 = require("../src/icons/thin/money-check-pen.svg");
const money_check_svg_3 = require("../src/icons/thin/money-check.svg");
const monitor_waveform_svg_3 = require("../src/icons/thin/monitor-waveform.svg");
const monkey_svg_3 = require("../src/icons/thin/monkey.svg");
const monument_svg_3 = require("../src/icons/thin/monument.svg");
const moon_cloud_svg_3 = require("../src/icons/thin/moon-cloud.svg");
const moon_over_sun_svg_3 = require("../src/icons/thin/moon-over-sun.svg");
const moon_stars_svg_3 = require("../src/icons/thin/moon-stars.svg");
const moon_svg_3 = require("../src/icons/thin/moon.svg");
const mortar_pestle_svg_3 = require("../src/icons/thin/mortar-pestle.svg");
const mosque_svg_3 = require("../src/icons/thin/mosque.svg");
const motorcycle_svg_3 = require("../src/icons/thin/motorcycle.svg");
const mountain_svg_3 = require("../src/icons/thin/mountain.svg");
const mountains_svg_3 = require("../src/icons/thin/mountains.svg");
const mp3_player_svg_3 = require("../src/icons/thin/mp3-player.svg");
const mug_hot_svg_3 = require("../src/icons/thin/mug-hot.svg");
const mug_marshmallows_svg_3 = require("../src/icons/thin/mug-marshmallows.svg");
const mug_saucer_svg_3 = require("../src/icons/thin/mug-saucer.svg");
const mug_tea_saucer_svg_3 = require("../src/icons/thin/mug-tea-saucer.svg");
const mug_tea_svg_3 = require("../src/icons/thin/mug-tea.svg");
const mug_svg_3 = require("../src/icons/thin/mug.svg");
const music_note_slash_svg_3 = require("../src/icons/thin/music-note-slash.svg");
const music_note_svg_3 = require("../src/icons/thin/music-note.svg");
const music_slash_svg_3 = require("../src/icons/thin/music-slash.svg");
const music_svg_3 = require("../src/icons/thin/music.svg");
const n_svg_3 = require("../src/icons/thin/n.svg");
const naira_sign_svg_3 = require("../src/icons/thin/naira-sign.svg");
const narwhal_svg_3 = require("../src/icons/thin/narwhal.svg");
const network_wired_svg_3 = require("../src/icons/thin/network-wired.svg");
const neuter_svg_3 = require("../src/icons/thin/neuter.svg");
const newspaper_svg_3 = require("../src/icons/thin/newspaper.svg");
const not_equal_svg_3 = require("../src/icons/thin/not-equal.svg");
const notdef_svg_3 = require("../src/icons/thin/notdef.svg");
const note_medical_svg_3 = require("../src/icons/thin/note-medical.svg");
const note_sticky_svg_3 = require("../src/icons/thin/note-sticky.svg");
const note_svg_3 = require("../src/icons/thin/note.svg");
const notes_medical_svg_3 = require("../src/icons/thin/notes-medical.svg");
const notes_svg_3 = require("../src/icons/thin/notes.svg");
const o_svg_3 = require("../src/icons/thin/o.svg");
const object_group_svg_3 = require("../src/icons/thin/object-group.svg");
const object_ungroup_svg_3 = require("../src/icons/thin/object-ungroup.svg");
const octagon_divide_svg_3 = require("../src/icons/thin/octagon-divide.svg");
const octagon_exclamation_svg_3 = require("../src/icons/thin/octagon-exclamation.svg");
const octagon_minus_svg_3 = require("../src/icons/thin/octagon-minus.svg");
const octagon_plus_svg_3 = require("../src/icons/thin/octagon-plus.svg");
const octagon_xmark_svg_3 = require("../src/icons/thin/octagon-xmark.svg");
const octagon_svg_3 = require("../src/icons/thin/octagon.svg");
const oil_can_drip_svg_3 = require("../src/icons/thin/oil-can-drip.svg");
const oil_can_svg_3 = require("../src/icons/thin/oil-can.svg");
const oil_temperature_svg_3 = require("../src/icons/thin/oil-temperature.svg");
const om_svg_3 = require("../src/icons/thin/om.svg");
const omega_svg_3 = require("../src/icons/thin/omega.svg");
const option_svg_3 = require("../src/icons/thin/option.svg");
const ornament_svg_3 = require("../src/icons/thin/ornament.svg");
const otter_svg_3 = require("../src/icons/thin/otter.svg");
const outdent_svg_3 = require("../src/icons/thin/outdent.svg");
const outlet_svg_3 = require("../src/icons/thin/outlet.svg");
const oven_svg_3 = require("../src/icons/thin/oven.svg");
const overline_svg_3 = require("../src/icons/thin/overline.svg");
const p_svg_3 = require("../src/icons/thin/p.svg");
const pager_svg_3 = require("../src/icons/thin/pager.svg");
const paint_brush_fine_svg_3 = require("../src/icons/thin/paint-brush-fine.svg");
const paint_brush_svg_3 = require("../src/icons/thin/paint-brush.svg");
const paint_roller_svg_3 = require("../src/icons/thin/paint-roller.svg");
const paintbrush_pencil_svg_3 = require("../src/icons/thin/paintbrush-pencil.svg");
const palette_boxes_svg_3 = require("../src/icons/thin/palette-boxes.svg");
const palette_svg_3 = require("../src/icons/thin/palette.svg");
const pallet_box_svg_3 = require("../src/icons/thin/pallet-box.svg");
const pallet_boxes_svg_3 = require("../src/icons/thin/pallet-boxes.svg");
const pallet_svg_3 = require("../src/icons/thin/pallet.svg");
const panorama_svg_3 = require("../src/icons/thin/panorama.svg");
const paper_plane_top_svg_3 = require("../src/icons/thin/paper-plane-top.svg");
const paper_plane_svg_3 = require("../src/icons/thin/paper-plane.svg");
const paperclip_svg_3 = require("../src/icons/thin/paperclip.svg");
const parachute_box_svg_3 = require("../src/icons/thin/parachute-box.svg");
const paragraph_left_svg_3 = require("../src/icons/thin/paragraph-left.svg");
const paragraph_svg_3 = require("../src/icons/thin/paragraph.svg");
const passport_svg_3 = require("../src/icons/thin/passport.svg");
const paste_svg_3 = require("../src/icons/thin/paste.svg");
const pause_svg_3 = require("../src/icons/thin/pause.svg");
const paw_claws_svg_3 = require("../src/icons/thin/paw-claws.svg");
const paw_simple_svg_3 = require("../src/icons/thin/paw-simple.svg");
const paw_svg_3 = require("../src/icons/thin/paw.svg");
const peace_svg_3 = require("../src/icons/thin/peace.svg");
const peach_svg_3 = require("../src/icons/thin/peach.svg");
const pear_svg_3 = require("../src/icons/thin/pear.svg");
const pedestal_svg_3 = require("../src/icons/thin/pedestal.svg");
const pegasus_svg_3 = require("../src/icons/thin/pegasus.svg");
const pen_circle_svg_3 = require("../src/icons/thin/pen-circle.svg");
const pen_clip_slash_svg_3 = require("../src/icons/thin/pen-clip-slash.svg");
const pen_clip_svg_3 = require("../src/icons/thin/pen-clip.svg");
const pen_fancy_slash_svg_3 = require("../src/icons/thin/pen-fancy-slash.svg");
const pen_fancy_svg_3 = require("../src/icons/thin/pen-fancy.svg");
const pen_field_svg_3 = require("../src/icons/thin/pen-field.svg");
const pen_line_svg_3 = require("../src/icons/thin/pen-line.svg");
const pen_nib_svg_3 = require("../src/icons/thin/pen-nib.svg");
const pen_paintbrush_svg_3 = require("../src/icons/thin/pen-paintbrush.svg");
const pen_ruler_svg_3 = require("../src/icons/thin/pen-ruler.svg");
const pen_slash_svg_3 = require("../src/icons/thin/pen-slash.svg");
const pen_swirl_svg_3 = require("../src/icons/thin/pen-swirl.svg");
const pen_to_square_svg_3 = require("../src/icons/thin/pen-to-square.svg");
const pen_svg_3 = require("../src/icons/thin/pen.svg");
const pencil_slash_svg_3 = require("../src/icons/thin/pencil-slash.svg");
const pencil_svg_3 = require("../src/icons/thin/pencil.svg");
const people_arrows_left_right_svg_3 = require("../src/icons/thin/people-arrows-left-right.svg");
const people_carry_box_svg_3 = require("../src/icons/thin/people-carry-box.svg");
const pepper_hot_svg_3 = require("../src/icons/thin/pepper-hot.svg");
const percent_svg_3 = require("../src/icons/thin/percent.svg");
const person_biking_mountain_svg_3 = require("../src/icons/thin/person-biking-mountain.svg");
const person_biking_svg_3 = require("../src/icons/thin/person-biking.svg");
const person_booth_svg_3 = require("../src/icons/thin/person-booth.svg");
const person_carry_box_svg_3 = require("../src/icons/thin/person-carry-box.svg");
const person_digging_svg_3 = require("../src/icons/thin/person-digging.svg");
const person_dolly_empty_svg_3 = require("../src/icons/thin/person-dolly-empty.svg");
const person_dolly_svg_3 = require("../src/icons/thin/person-dolly.svg");
const person_dots_from_line_svg_3 = require("../src/icons/thin/person-dots-from-line.svg");
const person_dress_simple_svg_3 = require("../src/icons/thin/person-dress-simple.svg");
const person_dress_svg_3 = require("../src/icons/thin/person-dress.svg");
const person_from_portal_svg_3 = require("../src/icons/thin/person-from-portal.svg");
const person_hiking_svg_3 = require("../src/icons/thin/person-hiking.svg");
const person_pinball_svg_3 = require("../src/icons/thin/person-pinball.svg");
const person_praying_svg_3 = require("../src/icons/thin/person-praying.svg");
const person_running_svg_3 = require("../src/icons/thin/person-running.svg");
const person_seat_reclined_svg_3 = require("../src/icons/thin/person-seat-reclined.svg");
const person_seat_svg_3 = require("../src/icons/thin/person-seat.svg");
const person_sign_svg_3 = require("../src/icons/thin/person-sign.svg");
const person_simple_svg_3 = require("../src/icons/thin/person-simple.svg");
const person_skating_svg_3 = require("../src/icons/thin/person-skating.svg");
const person_ski_jumping_svg_3 = require("../src/icons/thin/person-ski-jumping.svg");
const person_ski_lift_svg_3 = require("../src/icons/thin/person-ski-lift.svg");
const person_skiing_nordic_svg_3 = require("../src/icons/thin/person-skiing-nordic.svg");
const person_skiing_svg_3 = require("../src/icons/thin/person-skiing.svg");
const person_sledding_svg_3 = require("../src/icons/thin/person-sledding.svg");
const person_snowboarding_svg_3 = require("../src/icons/thin/person-snowboarding.svg");
const person_snowmobiling_svg_3 = require("../src/icons/thin/person-snowmobiling.svg");
const person_swimming_svg_3 = require("../src/icons/thin/person-swimming.svg");
const person_to_portal_svg_3 = require("../src/icons/thin/person-to-portal.svg");
const person_walking_with_cane_svg_3 = require("../src/icons/thin/person-walking-with-cane.svg");
const person_walking_svg_3 = require("../src/icons/thin/person-walking.svg");
const person_svg_3 = require("../src/icons/thin/person.svg");
const peseta_sign_svg_3 = require("../src/icons/thin/peseta-sign.svg");
const peso_sign_svg_3 = require("../src/icons/thin/peso-sign.svg");
const phone_arrow_down_left_svg_3 = require("../src/icons/thin/phone-arrow-down-left.svg");
const phone_arrow_up_right_svg_3 = require("../src/icons/thin/phone-arrow-up-right.svg");
const phone_flip_svg_3 = require("../src/icons/thin/phone-flip.svg");
const phone_hangup_svg_3 = require("../src/icons/thin/phone-hangup.svg");
const phone_missed_svg_3 = require("../src/icons/thin/phone-missed.svg");
const phone_office_svg_3 = require("../src/icons/thin/phone-office.svg");
const phone_plus_svg_3 = require("../src/icons/thin/phone-plus.svg");
const phone_rotary_svg_3 = require("../src/icons/thin/phone-rotary.svg");
const phone_slash_svg_3 = require("../src/icons/thin/phone-slash.svg");
const phone_volume_svg_3 = require("../src/icons/thin/phone-volume.svg");
const phone_xmark_svg_3 = require("../src/icons/thin/phone-xmark.svg");
const phone_svg_3 = require("../src/icons/thin/phone.svg");
const photo_film_music_svg_3 = require("../src/icons/thin/photo-film-music.svg");
const photo_film_svg_3 = require("../src/icons/thin/photo-film.svg");
const pi_svg_3 = require("../src/icons/thin/pi.svg");
const piano_keyboard_svg_3 = require("../src/icons/thin/piano-keyboard.svg");
const piano_svg_3 = require("../src/icons/thin/piano.svg");
const pie_svg_3 = require("../src/icons/thin/pie.svg");
const pig_svg_3 = require("../src/icons/thin/pig.svg");
const piggy_bank_svg_3 = require("../src/icons/thin/piggy-bank.svg");
const pills_svg_3 = require("../src/icons/thin/pills.svg");
const pinball_svg_3 = require("../src/icons/thin/pinball.svg");
const pizza_slice_svg_3 = require("../src/icons/thin/pizza-slice.svg");
const pizza_svg_3 = require("../src/icons/thin/pizza.svg");
const place_of_worship_svg_3 = require("../src/icons/thin/place-of-worship.svg");
const plane_arrival_svg_3 = require("../src/icons/thin/plane-arrival.svg");
const plane_departure_svg_3 = require("../src/icons/thin/plane-departure.svg");
const plane_engines_svg_3 = require("../src/icons/thin/plane-engines.svg");
const plane_prop_svg_3 = require("../src/icons/thin/plane-prop.svg");
const plane_slash_svg_3 = require("../src/icons/thin/plane-slash.svg");
const plane_tail_svg_3 = require("../src/icons/thin/plane-tail.svg");
const plane_up_slash_svg_3 = require("../src/icons/thin/plane-up-slash.svg");
const plane_up_svg_3 = require("../src/icons/thin/plane-up.svg");
const plane_svg_3 = require("../src/icons/thin/plane.svg");
const planet_moon_svg_3 = require("../src/icons/thin/planet-moon.svg");
const planet_ringed_svg_3 = require("../src/icons/thin/planet-ringed.svg");
const play_pause_svg_3 = require("../src/icons/thin/play-pause.svg");
const play_svg_3 = require("../src/icons/thin/play.svg");
const plug_svg_3 = require("../src/icons/thin/plug.svg");
const plus_minus_svg_3 = require("../src/icons/thin/plus-minus.svg");
const plus_svg_3 = require("../src/icons/thin/plus.svg");
const podcast_svg_3 = require("../src/icons/thin/podcast.svg");
const podium_star_svg_3 = require("../src/icons/thin/podium-star.svg");
const podium_svg_3 = require("../src/icons/thin/podium.svg");
const police_box_svg_3 = require("../src/icons/thin/police-box.svg");
const poll_people_svg_3 = require("../src/icons/thin/poll-people.svg");
const poo_bolt_svg_3 = require("../src/icons/thin/poo-bolt.svg");
const poo_svg_3 = require("../src/icons/thin/poo.svg");
const poop_svg_3 = require("../src/icons/thin/poop.svg");
const popcorn_svg_3 = require("../src/icons/thin/popcorn.svg");
const power_off_svg_3 = require("../src/icons/thin/power-off.svg");
const prescription_bottle_medical_svg_3 = require("../src/icons/thin/prescription-bottle-medical.svg");
const prescription_bottle_svg_3 = require("../src/icons/thin/prescription-bottle.svg");
const prescription_svg_3 = require("../src/icons/thin/prescription.svg");
const presentation_screen_svg_3 = require("../src/icons/thin/presentation-screen.svg");
const print_magnifying_glass_svg_3 = require("../src/icons/thin/print-magnifying-glass.svg");
const print_slash_svg_3 = require("../src/icons/thin/print-slash.svg");
const print_svg_3 = require("../src/icons/thin/print.svg");
const projector_svg_3 = require("../src/icons/thin/projector.svg");
const pump_medical_svg_3 = require("../src/icons/thin/pump-medical.svg");
const pump_soap_svg_3 = require("../src/icons/thin/pump-soap.svg");
const pumpkin_svg_3 = require("../src/icons/thin/pumpkin.svg");
const puzzle_piece_simple_svg_3 = require("../src/icons/thin/puzzle-piece-simple.svg");
const puzzle_piece_svg_3 = require("../src/icons/thin/puzzle-piece.svg");
const q_svg_3 = require("../src/icons/thin/q.svg");
const qrcode_svg_3 = require("../src/icons/thin/qrcode.svg");
const question_svg_3 = require("../src/icons/thin/question.svg");
const quidditch_broom_ball_svg_3 = require("../src/icons/thin/quidditch-broom-ball.svg");
const quote_left_round_svg_3 = require("../src/icons/thin/quote-left-round.svg");
const quote_left_svg_3 = require("../src/icons/thin/quote-left.svg");
const quote_right_round_svg_3 = require("../src/icons/thin/quote-right-round.svg");
const quote_right_svg_3 = require("../src/icons/thin/quote-right.svg");
const r_svg_3 = require("../src/icons/thin/r.svg");
const rabbit_running_svg_3 = require("../src/icons/thin/rabbit-running.svg");
const rabbit_svg_3 = require("../src/icons/thin/rabbit.svg");
const racquet_svg_3 = require("../src/icons/thin/racquet.svg");
const radar_svg_3 = require("../src/icons/thin/radar.svg");
const radiation_svg_3 = require("../src/icons/thin/radiation.svg");
const radio_tuner_svg_3 = require("../src/icons/thin/radio-tuner.svg");
const radio_svg_3 = require("../src/icons/thin/radio.svg");
const rainbow_svg_3 = require("../src/icons/thin/rainbow.svg");
const raindrops_svg_3 = require("../src/icons/thin/raindrops.svg");
const ram_svg_3 = require("../src/icons/thin/ram.svg");
const ramp_loading_svg_3 = require("../src/icons/thin/ramp-loading.svg");
const raygun_svg_3 = require("../src/icons/thin/raygun.svg");
const receipt_svg_3 = require("../src/icons/thin/receipt.svg");
const record_vinyl_svg_3 = require("../src/icons/thin/record-vinyl.svg");
const rectangle_ad_svg_3 = require("../src/icons/thin/rectangle-ad.svg");
const rectangle_barcode_svg_3 = require("../src/icons/thin/rectangle-barcode.svg");
const rectangle_list_svg_3 = require("../src/icons/thin/rectangle-list.svg");
const rectangle_terminal_svg_3 = require("../src/icons/thin/rectangle-terminal.svg");
const rectangle_vertical_history_svg_3 = require("../src/icons/thin/rectangle-vertical-history.svg");
const rectangle_vertical_svg_3 = require("../src/icons/thin/rectangle-vertical.svg");
const rectangle_wide_svg_3 = require("../src/icons/thin/rectangle-wide.svg");
const rectangle_xmark_svg_3 = require("../src/icons/thin/rectangle-xmark.svg");
const rectangle_svg_3 = require("../src/icons/thin/rectangle.svg");
const recycle_svg_3 = require("../src/icons/thin/recycle.svg");
const refrigerator_svg_3 = require("../src/icons/thin/refrigerator.svg");
const registered_svg_3 = require("../src/icons/thin/registered.svg");
const repeat_1_svg_3 = require("../src/icons/thin/repeat-1.svg");
const repeat_svg_3 = require("../src/icons/thin/repeat.svg");
const reply_all_svg_3 = require("../src/icons/thin/reply-all.svg");
const reply_clock_svg_3 = require("../src/icons/thin/reply-clock.svg");
const reply_svg_3 = require("../src/icons/thin/reply.svg");
const republican_svg_3 = require("../src/icons/thin/republican.svg");
const restroom_simple_svg_3 = require("../src/icons/thin/restroom-simple.svg");
const restroom_svg_3 = require("../src/icons/thin/restroom.svg");
const retweet_svg_3 = require("../src/icons/thin/retweet.svg");
const rhombus_svg_3 = require("../src/icons/thin/rhombus.svg");
const ribbon_svg_3 = require("../src/icons/thin/ribbon.svg");
const right_from_bracket_svg_3 = require("../src/icons/thin/right-from-bracket.svg");
const right_from_line_svg_3 = require("../src/icons/thin/right-from-line.svg");
const right_left_svg_3 = require("../src/icons/thin/right-left.svg");
const right_long_svg_3 = require("../src/icons/thin/right-long.svg");
const right_to_bracket_svg_3 = require("../src/icons/thin/right-to-bracket.svg");
const right_to_line_svg_3 = require("../src/icons/thin/right-to-line.svg");
const right_svg_3 = require("../src/icons/thin/right.svg");
const ring_svg_3 = require("../src/icons/thin/ring.svg");
const rings_wedding_svg_3 = require("../src/icons/thin/rings-wedding.svg");
const road_svg_3 = require("../src/icons/thin/road.svg");
const robot_svg_3 = require("../src/icons/thin/robot.svg");
const rocket_launch_svg_3 = require("../src/icons/thin/rocket-launch.svg");
const rocket_svg_3 = require("../src/icons/thin/rocket.svg");
const rotate_exclamation_svg_3 = require("../src/icons/thin/rotate-exclamation.svg");
const rotate_forward_svg_3 = require("../src/icons/thin/rotate-forward.svg");
const rotate_left_svg_3 = require("../src/icons/thin/rotate-left.svg");
const rotate_svg_3 = require("../src/icons/thin/rotate.svg");
const route_highway_svg_3 = require("../src/icons/thin/route-highway.svg");
const route_interstate_svg_3 = require("../src/icons/thin/route-interstate.svg");
const route_svg_3 = require("../src/icons/thin/route.svg");
const router_svg_3 = require("../src/icons/thin/router.svg");
const rss_svg_3 = require("../src/icons/thin/rss.svg");
const ruble_sign_svg_3 = require("../src/icons/thin/ruble-sign.svg");
const ruler_combined_svg_3 = require("../src/icons/thin/ruler-combined.svg");
const ruler_horizontal_svg_3 = require("../src/icons/thin/ruler-horizontal.svg");
const ruler_triangle_svg_3 = require("../src/icons/thin/ruler-triangle.svg");
const ruler_vertical_svg_3 = require("../src/icons/thin/ruler-vertical.svg");
const ruler_svg_3 = require("../src/icons/thin/ruler.svg");
const rupee_sign_svg_3 = require("../src/icons/thin/rupee-sign.svg");
const rupiah_sign_svg_3 = require("../src/icons/thin/rupiah-sign.svg");
const rv_svg_3 = require("../src/icons/thin/rv.svg");
const s_svg_3 = require("../src/icons/thin/s.svg");
const sack_dollar_svg_3 = require("../src/icons/thin/sack-dollar.svg");
const sack_svg_3 = require("../src/icons/thin/sack.svg");
const salad_svg_3 = require("../src/icons/thin/salad.svg");
const sandwich_svg_3 = require("../src/icons/thin/sandwich.svg");
const satellite_dish_svg_3 = require("../src/icons/thin/satellite-dish.svg");
const satellite_svg_3 = require("../src/icons/thin/satellite.svg");
const sausage_svg_3 = require("../src/icons/thin/sausage.svg");
const saxophone_fire_svg_3 = require("../src/icons/thin/saxophone-fire.svg");
const saxophone_svg_3 = require("../src/icons/thin/saxophone.svg");
const scale_balanced_svg_3 = require("../src/icons/thin/scale-balanced.svg");
const scale_unbalanced_flip_svg_3 = require("../src/icons/thin/scale-unbalanced-flip.svg");
const scale_unbalanced_svg_3 = require("../src/icons/thin/scale-unbalanced.svg");
const scalpel_line_dashed_svg_3 = require("../src/icons/thin/scalpel-line-dashed.svg");
const scalpel_svg_3 = require("../src/icons/thin/scalpel.svg");
const scanner_gun_svg_3 = require("../src/icons/thin/scanner-gun.svg");
const scanner_keyboard_svg_3 = require("../src/icons/thin/scanner-keyboard.svg");
const scanner_touchscreen_svg_3 = require("../src/icons/thin/scanner-touchscreen.svg");
const scanner_svg_3 = require("../src/icons/thin/scanner.svg");
const scarecrow_svg_3 = require("../src/icons/thin/scarecrow.svg");
const scarf_svg_3 = require("../src/icons/thin/scarf.svg");
const school_svg_3 = require("../src/icons/thin/school.svg");
const scissors_svg_3 = require("../src/icons/thin/scissors.svg");
const screen_users_svg_3 = require("../src/icons/thin/screen-users.svg");
const screencast_svg_3 = require("../src/icons/thin/screencast.svg");
const screwdriver_wrench_svg_3 = require("../src/icons/thin/screwdriver-wrench.svg");
const screwdriver_svg_3 = require("../src/icons/thin/screwdriver.svg");
const scribble_svg_3 = require("../src/icons/thin/scribble.svg");
const scroll_old_svg_3 = require("../src/icons/thin/scroll-old.svg");
const scroll_torah_svg_3 = require("../src/icons/thin/scroll-torah.svg");
const scroll_svg_3 = require("../src/icons/thin/scroll.svg");
const scrubber_svg_3 = require("../src/icons/thin/scrubber.svg");
const scythe_svg_3 = require("../src/icons/thin/scythe.svg");
const sd_card_svg_3 = require("../src/icons/thin/sd-card.svg");
const sd_cards_svg_3 = require("../src/icons/thin/sd-cards.svg");
const seal_exclamation_svg_3 = require("../src/icons/thin/seal-exclamation.svg");
const seal_question_svg_3 = require("../src/icons/thin/seal-question.svg");
const seal_svg_3 = require("../src/icons/thin/seal.svg");
const seat_airline_svg_3 = require("../src/icons/thin/seat-airline.svg");
const section_svg_3 = require("../src/icons/thin/section.svg");
const seedling_svg_3 = require("../src/icons/thin/seedling.svg");
const send_back_svg_3 = require("../src/icons/thin/send-back.svg");
const send_backward_svg_3 = require("../src/icons/thin/send-backward.svg");
const sensor_cloud_svg_3 = require("../src/icons/thin/sensor-cloud.svg");
const sensor_fire_svg_3 = require("../src/icons/thin/sensor-fire.svg");
const sensor_on_svg_3 = require("../src/icons/thin/sensor-on.svg");
const sensor_triangle_exclamation_svg_3 = require("../src/icons/thin/sensor-triangle-exclamation.svg");
const sensor_svg_3 = require("../src/icons/thin/sensor.svg");
const server_svg_3 = require("../src/icons/thin/server.svg");
const shapes_svg_3 = require("../src/icons/thin/shapes.svg");
const share_all_svg_3 = require("../src/icons/thin/share-all.svg");
const share_from_square_svg_3 = require("../src/icons/thin/share-from-square.svg");
const share_nodes_svg_3 = require("../src/icons/thin/share-nodes.svg");
const share_svg_3 = require("../src/icons/thin/share.svg");
const sheep_svg_3 = require("../src/icons/thin/sheep.svg");
const shekel_sign_svg_3 = require("../src/icons/thin/shekel-sign.svg");
const shelves_empty_svg_3 = require("../src/icons/thin/shelves-empty.svg");
const shelves_svg_3 = require("../src/icons/thin/shelves.svg");
const shield_blank_svg_3 = require("../src/icons/thin/shield-blank.svg");
const shield_check_svg_3 = require("../src/icons/thin/shield-check.svg");
const shield_cross_svg_3 = require("../src/icons/thin/shield-cross.svg");
const shield_exclamation_svg_3 = require("../src/icons/thin/shield-exclamation.svg");
const shield_keyhole_svg_3 = require("../src/icons/thin/shield-keyhole.svg");
const shield_minus_svg_3 = require("../src/icons/thin/shield-minus.svg");
const shield_plus_svg_3 = require("../src/icons/thin/shield-plus.svg");
const shield_slash_svg_3 = require("../src/icons/thin/shield-slash.svg");
const shield_virus_svg_3 = require("../src/icons/thin/shield-virus.svg");
const shield_xmark_svg_3 = require("../src/icons/thin/shield-xmark.svg");
const shield_svg_3 = require("../src/icons/thin/shield.svg");
const ship_svg_3 = require("../src/icons/thin/ship.svg");
const shish_kebab_svg_3 = require("../src/icons/thin/shish-kebab.svg");
const shoe_prints_svg_3 = require("../src/icons/thin/shoe-prints.svg");
const shop_slash_svg_3 = require("../src/icons/thin/shop-slash.svg");
const shop_svg_3 = require("../src/icons/thin/shop.svg");
const shovel_snow_svg_3 = require("../src/icons/thin/shovel-snow.svg");
const shovel_svg_3 = require("../src/icons/thin/shovel.svg");
const shower_down_svg_3 = require("../src/icons/thin/shower-down.svg");
const shower_svg_3 = require("../src/icons/thin/shower.svg");
const shredder_svg_3 = require("../src/icons/thin/shredder.svg");
const shuffle_svg_3 = require("../src/icons/thin/shuffle.svg");
const shuttle_space_svg_3 = require("../src/icons/thin/shuttle-space.svg");
const shuttlecock_svg_3 = require("../src/icons/thin/shuttlecock.svg");
const sickle_svg_3 = require("../src/icons/thin/sickle.svg");
const sidebar_flip_svg_3 = require("../src/icons/thin/sidebar-flip.svg");
const sidebar_svg_3 = require("../src/icons/thin/sidebar.svg");
const sigma_svg_3 = require("../src/icons/thin/sigma.svg");
const sign_hanging_svg_3 = require("../src/icons/thin/sign-hanging.svg");
const signal_bars_fair_svg_3 = require("../src/icons/thin/signal-bars-fair.svg");
const signal_bars_good_svg_3 = require("../src/icons/thin/signal-bars-good.svg");
const signal_bars_slash_svg_3 = require("../src/icons/thin/signal-bars-slash.svg");
const signal_bars_weak_svg_3 = require("../src/icons/thin/signal-bars-weak.svg");
const signal_bars_svg_3 = require("../src/icons/thin/signal-bars.svg");
const signal_fair_svg_3 = require("../src/icons/thin/signal-fair.svg");
const signal_good_svg_3 = require("../src/icons/thin/signal-good.svg");
const signal_slash_svg_3 = require("../src/icons/thin/signal-slash.svg");
const signal_stream_slash_svg_3 = require("../src/icons/thin/signal-stream-slash.svg");
const signal_stream_svg_3 = require("../src/icons/thin/signal-stream.svg");
const signal_strong_svg_3 = require("../src/icons/thin/signal-strong.svg");
const signal_weak_svg_3 = require("../src/icons/thin/signal-weak.svg");
const signal_svg_3 = require("../src/icons/thin/signal.svg");
const signature_svg_3 = require("../src/icons/thin/signature.svg");
const signs_post_svg_3 = require("../src/icons/thin/signs-post.svg");
const sim_card_svg_3 = require("../src/icons/thin/sim-card.svg");
const sim_cards_svg_3 = require("../src/icons/thin/sim-cards.svg");
const sink_svg_3 = require("../src/icons/thin/sink.svg");
const siren_on_svg_3 = require("../src/icons/thin/siren-on.svg");
const siren_svg_3 = require("../src/icons/thin/siren.svg");
const sitemap_svg_3 = require("../src/icons/thin/sitemap.svg");
const skeleton_svg_3 = require("../src/icons/thin/skeleton.svg");
const skull_cow_svg_3 = require("../src/icons/thin/skull-cow.svg");
const skull_crossbones_svg_3 = require("../src/icons/thin/skull-crossbones.svg");
const skull_svg_3 = require("../src/icons/thin/skull.svg");
const slash_svg_3 = require("../src/icons/thin/slash.svg");
const sleigh_svg_3 = require("../src/icons/thin/sleigh.svg");
const slider_svg_3 = require("../src/icons/thin/slider.svg");
const sliders_up_svg_3 = require("../src/icons/thin/sliders-up.svg");
const sliders_svg_3 = require("../src/icons/thin/sliders.svg");
const smog_svg_3 = require("../src/icons/thin/smog.svg");
const smoke_svg_3 = require("../src/icons/thin/smoke.svg");
const smoking_svg_3 = require("../src/icons/thin/smoking.svg");
const snake_svg_3 = require("../src/icons/thin/snake.svg");
const snooze_svg_3 = require("../src/icons/thin/snooze.svg");
const snow_blowing_svg_3 = require("../src/icons/thin/snow-blowing.svg");
const snowflake_svg_3 = require("../src/icons/thin/snowflake.svg");
const snowflakes_svg_3 = require("../src/icons/thin/snowflakes.svg");
const snowman_head_svg_3 = require("../src/icons/thin/snowman-head.svg");
const snowman_svg_3 = require("../src/icons/thin/snowman.svg");
const snowplow_svg_3 = require("../src/icons/thin/snowplow.svg");
const soap_svg_3 = require("../src/icons/thin/soap.svg");
const socks_svg_3 = require("../src/icons/thin/socks.svg");
const solar_panel_svg_3 = require("../src/icons/thin/solar-panel.svg");
const solar_system_svg_3 = require("../src/icons/thin/solar-system.svg");
const sort_down_svg_3 = require("../src/icons/thin/sort-down.svg");
const sort_up_svg_3 = require("../src/icons/thin/sort-up.svg");
const sort_svg_3 = require("../src/icons/thin/sort.svg");
const spa_svg_3 = require("../src/icons/thin/spa.svg");
const space_station_moon_construction_svg_3 = require("../src/icons/thin/space-station-moon-construction.svg");
const space_station_moon_svg_3 = require("../src/icons/thin/space-station-moon.svg");
const spade_svg_3 = require("../src/icons/thin/spade.svg");
const spaghetti_monster_flying_svg_3 = require("../src/icons/thin/spaghetti-monster-flying.svg");
const sparkles_svg_3 = require("../src/icons/thin/sparkles.svg");
const speaker_svg_3 = require("../src/icons/thin/speaker.svg");
const speakers_svg_3 = require("../src/icons/thin/speakers.svg");
const spell_check_svg_3 = require("../src/icons/thin/spell-check.svg");
const spider_black_widow_svg_3 = require("../src/icons/thin/spider-black-widow.svg");
const spider_web_svg_3 = require("../src/icons/thin/spider-web.svg");
const spider_svg_3 = require("../src/icons/thin/spider.svg");
const spinner_third_svg_3 = require("../src/icons/thin/spinner-third.svg");
const spinner_svg_3 = require("../src/icons/thin/spinner.svg");
const split_svg_3 = require("../src/icons/thin/split.svg");
const splotch_svg_3 = require("../src/icons/thin/splotch.svg");
const spoon_svg_3 = require("../src/icons/thin/spoon.svg");
const spray_can_svg_3 = require("../src/icons/thin/spray-can.svg");
const sprinkler_svg_3 = require("../src/icons/thin/sprinkler.svg");
const square_0_svg_3 = require("../src/icons/thin/square-0.svg");
const square_1_svg_3 = require("../src/icons/thin/square-1.svg");
const square_2_svg_3 = require("../src/icons/thin/square-2.svg");
const square_3_svg_3 = require("../src/icons/thin/square-3.svg");
const square_4_svg_3 = require("../src/icons/thin/square-4.svg");
const square_5_svg_3 = require("../src/icons/thin/square-5.svg");
const square_6_svg_3 = require("../src/icons/thin/square-6.svg");
const square_7_svg_3 = require("../src/icons/thin/square-7.svg");
const square_8_svg_3 = require("../src/icons/thin/square-8.svg");
const square_9_svg_3 = require("../src/icons/thin/square-9.svg");
const square_a_svg_3 = require("../src/icons/thin/square-a.svg");
const square_ampersand_svg_3 = require("../src/icons/thin/square-ampersand.svg");
const square_arrow_down_left_svg_3 = require("../src/icons/thin/square-arrow-down-left.svg");
const square_arrow_down_right_svg_3 = require("../src/icons/thin/square-arrow-down-right.svg");
const square_arrow_down_svg_3 = require("../src/icons/thin/square-arrow-down.svg");
const square_arrow_left_svg_3 = require("../src/icons/thin/square-arrow-left.svg");
const square_arrow_right_svg_3 = require("../src/icons/thin/square-arrow-right.svg");
const square_arrow_up_left_svg_3 = require("../src/icons/thin/square-arrow-up-left.svg");
const square_arrow_up_right_svg_3 = require("../src/icons/thin/square-arrow-up-right.svg");
const square_arrow_up_svg_3 = require("../src/icons/thin/square-arrow-up.svg");
const square_b_svg_3 = require("../src/icons/thin/square-b.svg");
const square_bolt_svg_3 = require("../src/icons/thin/square-bolt.svg");
const square_c_svg_3 = require("../src/icons/thin/square-c.svg");
const square_caret_down_svg_3 = require("../src/icons/thin/square-caret-down.svg");
const square_caret_left_svg_3 = require("../src/icons/thin/square-caret-left.svg");
const square_caret_right_svg_3 = require("../src/icons/thin/square-caret-right.svg");
const square_caret_up_svg_3 = require("../src/icons/thin/square-caret-up.svg");
const square_check_svg_3 = require("../src/icons/thin/square-check.svg");
const square_chevron_down_svg_3 = require("../src/icons/thin/square-chevron-down.svg");
const square_chevron_left_svg_3 = require("../src/icons/thin/square-chevron-left.svg");
const square_chevron_right_svg_3 = require("../src/icons/thin/square-chevron-right.svg");
const square_chevron_up_svg_3 = require("../src/icons/thin/square-chevron-up.svg");
const square_code_svg_3 = require("../src/icons/thin/square-code.svg");
const square_d_svg_3 = require("../src/icons/thin/square-d.svg");
const square_dashed_svg_3 = require("../src/icons/thin/square-dashed.svg");
const square_divide_svg_3 = require("../src/icons/thin/square-divide.svg");
const square_dollar_svg_3 = require("../src/icons/thin/square-dollar.svg");
const square_down_left_svg_3 = require("../src/icons/thin/square-down-left.svg");
const square_down_right_svg_3 = require("../src/icons/thin/square-down-right.svg");
const square_down_svg_3 = require("../src/icons/thin/square-down.svg");
const square_e_svg_3 = require("../src/icons/thin/square-e.svg");
const square_envelope_svg_3 = require("../src/icons/thin/square-envelope.svg");
const square_exclamation_svg_3 = require("../src/icons/thin/square-exclamation.svg");
const square_f_svg_3 = require("../src/icons/thin/square-f.svg");
const square_fragile_svg_3 = require("../src/icons/thin/square-fragile.svg");
const square_full_svg_3 = require("../src/icons/thin/square-full.svg");
const square_g_svg_3 = require("../src/icons/thin/square-g.svg");
const square_h_svg_3 = require("../src/icons/thin/square-h.svg");
const square_heart_svg_3 = require("../src/icons/thin/square-heart.svg");
const square_i_svg_3 = require("../src/icons/thin/square-i.svg");
const square_info_svg_3 = require("../src/icons/thin/square-info.svg");
const square_j_svg_3 = require("../src/icons/thin/square-j.svg");
const square_k_svg_3 = require("../src/icons/thin/square-k.svg");
const square_l_svg_3 = require("../src/icons/thin/square-l.svg");
const square_left_svg_3 = require("../src/icons/thin/square-left.svg");
const square_m_svg_3 = require("../src/icons/thin/square-m.svg");
const square_minus_svg_3 = require("../src/icons/thin/square-minus.svg");
const square_n_svg_3 = require("../src/icons/thin/square-n.svg");
const square_o_svg_3 = require("../src/icons/thin/square-o.svg");
const square_p_svg_3 = require("../src/icons/thin/square-p.svg");
const square_parking_slash_svg_3 = require("../src/icons/thin/square-parking-slash.svg");
const square_parking_svg_3 = require("../src/icons/thin/square-parking.svg");
const square_pen_svg_3 = require("../src/icons/thin/square-pen.svg");
const square_phone_flip_svg_3 = require("../src/icons/thin/square-phone-flip.svg");
const square_phone_hangup_svg_3 = require("../src/icons/thin/square-phone-hangup.svg");
const square_phone_svg_3 = require("../src/icons/thin/square-phone.svg");
const square_plus_svg_3 = require("../src/icons/thin/square-plus.svg");
const square_poll_horizontal_svg_3 = require("../src/icons/thin/square-poll-horizontal.svg");
const square_poll_vertical_svg_3 = require("../src/icons/thin/square-poll-vertical.svg");
const square_q_svg_3 = require("../src/icons/thin/square-q.svg");
const square_question_svg_3 = require("../src/icons/thin/square-question.svg");
const square_r_svg_3 = require("../src/icons/thin/square-r.svg");
const square_right_svg_3 = require("../src/icons/thin/square-right.svg");
const square_root_variable_svg_3 = require("../src/icons/thin/square-root-variable.svg");
const square_root_svg_3 = require("../src/icons/thin/square-root.svg");
const square_rss_svg_3 = require("../src/icons/thin/square-rss.svg");
const square_s_svg_3 = require("../src/icons/thin/square-s.svg");
const square_share_nodes_svg_3 = require("../src/icons/thin/square-share-nodes.svg");
const square_sliders_vertical_svg_3 = require("../src/icons/thin/square-sliders-vertical.svg");
const square_sliders_svg_3 = require("../src/icons/thin/square-sliders.svg");
const square_small_svg_3 = require("../src/icons/thin/square-small.svg");
const square_star_svg_3 = require("../src/icons/thin/square-star.svg");
const square_t_svg_3 = require("../src/icons/thin/square-t.svg");
const square_this_way_up_svg_3 = require("../src/icons/thin/square-this-way-up.svg");
const square_u_svg_3 = require("../src/icons/thin/square-u.svg");
const square_up_left_svg_3 = require("../src/icons/thin/square-up-left.svg");
const square_up_right_svg_3 = require("../src/icons/thin/square-up-right.svg");
const square_up_svg_3 = require("../src/icons/thin/square-up.svg");
const square_user_svg_3 = require("../src/icons/thin/square-user.svg");
const square_v_svg_3 = require("../src/icons/thin/square-v.svg");
const square_w_svg_3 = require("../src/icons/thin/square-w.svg");
const square_x_svg_3 = require("../src/icons/thin/square-x.svg");
const square_xmark_svg_3 = require("../src/icons/thin/square-xmark.svg");
const square_y_svg_3 = require("../src/icons/thin/square-y.svg");
const square_z_svg_3 = require("../src/icons/thin/square-z.svg");
const square_svg_3 = require("../src/icons/thin/square.svg");
const squirrel_svg_3 = require("../src/icons/thin/squirrel.svg");
const staff_svg_3 = require("../src/icons/thin/staff.svg");
const stairs_svg_3 = require("../src/icons/thin/stairs.svg");
const stamp_svg_3 = require("../src/icons/thin/stamp.svg");
const standard_definition_svg_3 = require("../src/icons/thin/standard-definition.svg");
const star_and_crescent_svg_3 = require("../src/icons/thin/star-and-crescent.svg");
const star_christmas_svg_3 = require("../src/icons/thin/star-christmas.svg");
const star_exclamation_svg_3 = require("../src/icons/thin/star-exclamation.svg");
const star_half_stroke_svg_3 = require("../src/icons/thin/star-half-stroke.svg");
const star_half_svg_3 = require("../src/icons/thin/star-half.svg");
const star_of_david_svg_3 = require("../src/icons/thin/star-of-david.svg");
const star_of_life_svg_3 = require("../src/icons/thin/star-of-life.svg");
const star_sharp_half_stroke_svg_3 = require("../src/icons/thin/star-sharp-half-stroke.svg");
const star_sharp_half_svg_3 = require("../src/icons/thin/star-sharp-half.svg");
const star_sharp_svg_3 = require("../src/icons/thin/star-sharp.svg");
const star_shooting_svg_3 = require("../src/icons/thin/star-shooting.svg");
const star_svg_3 = require("../src/icons/thin/star.svg");
const starfighter_twin_ion_engine_advanced_svg_3 = require("../src/icons/thin/starfighter-twin-ion-engine-advanced.svg");
const starfighter_twin_ion_engine_svg_3 = require("../src/icons/thin/starfighter-twin-ion-engine.svg");
const starfighter_svg_3 = require("../src/icons/thin/starfighter.svg");
const stars_svg_3 = require("../src/icons/thin/stars.svg");
const starship_freighter_svg_3 = require("../src/icons/thin/starship-freighter.svg");
const starship_svg_3 = require("../src/icons/thin/starship.svg");
const steak_svg_3 = require("../src/icons/thin/steak.svg");
const steering_wheel_svg_3 = require("../src/icons/thin/steering-wheel.svg");
const sterling_sign_svg_3 = require("../src/icons/thin/sterling-sign.svg");
const stethoscope_svg_3 = require("../src/icons/thin/stethoscope.svg");
const stocking_svg_3 = require("../src/icons/thin/stocking.svg");
const stomach_svg_3 = require("../src/icons/thin/stomach.svg");
const stop_svg_3 = require("../src/icons/thin/stop.svg");
const stopwatch_20_svg_3 = require("../src/icons/thin/stopwatch-20.svg");
const stopwatch_svg_3 = require("../src/icons/thin/stopwatch.svg");
const store_slash_svg_3 = require("../src/icons/thin/store-slash.svg");
const store_svg_3 = require("../src/icons/thin/store.svg");
const street_view_svg_3 = require("../src/icons/thin/street-view.svg");
const stretcher_svg_3 = require("../src/icons/thin/stretcher.svg");
const strikethrough_svg_3 = require("../src/icons/thin/strikethrough.svg");
const stroopwafel_svg_3 = require("../src/icons/thin/stroopwafel.svg");
const subscript_svg_3 = require("../src/icons/thin/subscript.svg");
const suitcase_medical_svg_3 = require("../src/icons/thin/suitcase-medical.svg");
const suitcase_rolling_svg_3 = require("../src/icons/thin/suitcase-rolling.svg");
const suitcase_svg_3 = require("../src/icons/thin/suitcase.svg");
const sun_bright_svg_3 = require("../src/icons/thin/sun-bright.svg");
const sun_cloud_svg_3 = require("../src/icons/thin/sun-cloud.svg");
const sun_dust_svg_3 = require("../src/icons/thin/sun-dust.svg");
const sun_haze_svg_3 = require("../src/icons/thin/sun-haze.svg");
const sun_svg_3 = require("../src/icons/thin/sun.svg");
const sunglasses_svg_3 = require("../src/icons/thin/sunglasses.svg");
const sunrise_svg_3 = require("../src/icons/thin/sunrise.svg");
const sunset_svg_3 = require("../src/icons/thin/sunset.svg");
const superscript_svg_3 = require("../src/icons/thin/superscript.svg");
const swatchbook_svg_3 = require("../src/icons/thin/swatchbook.svg");
const sword_laser_alt_svg_3 = require("../src/icons/thin/sword-laser-alt.svg");
const sword_laser_svg_3 = require("../src/icons/thin/sword-laser.svg");
const sword_svg_3 = require("../src/icons/thin/sword.svg");
const swords_laser_svg_3 = require("../src/icons/thin/swords-laser.svg");
const swords_svg_3 = require("../src/icons/thin/swords.svg");
const symbols_svg_3 = require("../src/icons/thin/symbols.svg");
const synagogue_svg_3 = require("../src/icons/thin/synagogue.svg");
const syringe_svg_3 = require("../src/icons/thin/syringe.svg");
const t_svg_3 = require("../src/icons/thin/t.svg");
const table_cells_large_svg_3 = require("../src/icons/thin/table-cells-large.svg");
const table_cells_svg_3 = require("../src/icons/thin/table-cells.svg");
const table_columns_svg_3 = require("../src/icons/thin/table-columns.svg");
const table_layout_svg_3 = require("../src/icons/thin/table-layout.svg");
const table_list_svg_3 = require("../src/icons/thin/table-list.svg");
const table_pivot_svg_3 = require("../src/icons/thin/table-pivot.svg");
const table_rows_svg_3 = require("../src/icons/thin/table-rows.svg");
const table_tennis_paddle_ball_svg_3 = require("../src/icons/thin/table-tennis-paddle-ball.svg");
const table_tree_svg_3 = require("../src/icons/thin/table-tree.svg");
const table_svg_3 = require("../src/icons/thin/table.svg");
const tablet_button_svg_3 = require("../src/icons/thin/tablet-button.svg");
const tablet_rugged_svg_3 = require("../src/icons/thin/tablet-rugged.svg");
const tablet_screen_button_svg_3 = require("../src/icons/thin/tablet-screen-button.svg");
const tablet_screen_svg_3 = require("../src/icons/thin/tablet-screen.svg");
const tablet_svg_3 = require("../src/icons/thin/tablet.svg");
const tablets_svg_3 = require("../src/icons/thin/tablets.svg");
const tachograph_digital_svg_3 = require("../src/icons/thin/tachograph-digital.svg");
const taco_svg_3 = require("../src/icons/thin/taco.svg");
const tag_svg_3 = require("../src/icons/thin/tag.svg");
const tags_svg_3 = require("../src/icons/thin/tags.svg");
const tally_1_svg_3 = require("../src/icons/thin/tally-1.svg");
const tally_2_svg_3 = require("../src/icons/thin/tally-2.svg");
const tally_3_svg_3 = require("../src/icons/thin/tally-3.svg");
const tally_4_svg_3 = require("../src/icons/thin/tally-4.svg");
const tally_svg_3 = require("../src/icons/thin/tally.svg");
const tape_svg_3 = require("../src/icons/thin/tape.svg");
const taxi_bus_svg_3 = require("../src/icons/thin/taxi-bus.svg");
const taxi_svg_3 = require("../src/icons/thin/taxi.svg");
const teeth_open_svg_3 = require("../src/icons/thin/teeth-open.svg");
const teeth_svg_3 = require("../src/icons/thin/teeth.svg");
const telescope_svg_3 = require("../src/icons/thin/telescope.svg");
const temperature_arrow_down_svg_3 = require("../src/icons/thin/temperature-arrow-down.svg");
const temperature_arrow_up_svg_3 = require("../src/icons/thin/temperature-arrow-up.svg");
const temperature_empty_svg_3 = require("../src/icons/thin/temperature-empty.svg");
const temperature_full_svg_3 = require("../src/icons/thin/temperature-full.svg");
const temperature_half_svg_3 = require("../src/icons/thin/temperature-half.svg");
const temperature_high_svg_3 = require("../src/icons/thin/temperature-high.svg");
const temperature_list_svg_3 = require("../src/icons/thin/temperature-list.svg");
const temperature_low_svg_3 = require("../src/icons/thin/temperature-low.svg");
const temperature_quarter_svg_3 = require("../src/icons/thin/temperature-quarter.svg");
const temperature_snow_svg_3 = require("../src/icons/thin/temperature-snow.svg");
const temperature_sun_svg_3 = require("../src/icons/thin/temperature-sun.svg");
const temperature_three_quarters_svg_3 = require("../src/icons/thin/temperature-three-quarters.svg");
const tenge_sign_svg_3 = require("../src/icons/thin/tenge-sign.svg");
const tennis_ball_svg_3 = require("../src/icons/thin/tennis-ball.svg");
const terminal_svg_3 = require("../src/icons/thin/terminal.svg");
const text_height_svg_3 = require("../src/icons/thin/text-height.svg");
const text_size_svg_3 = require("../src/icons/thin/text-size.svg");
const text_slash_svg_3 = require("../src/icons/thin/text-slash.svg");
const text_width_svg_3 = require("../src/icons/thin/text-width.svg");
const text_svg_3 = require("../src/icons/thin/text.svg");
const thermometer_svg_3 = require("../src/icons/thin/thermometer.svg");
const theta_svg_3 = require("../src/icons/thin/theta.svg");
const thumbs_down_svg_3 = require("../src/icons/thin/thumbs-down.svg");
const thumbs_up_svg_3 = require("../src/icons/thin/thumbs-up.svg");
const thumbtack_svg_3 = require("../src/icons/thin/thumbtack.svg");
const ticket_airline_svg_3 = require("../src/icons/thin/ticket-airline.svg");
const ticket_simple_svg_3 = require("../src/icons/thin/ticket-simple.svg");
const ticket_svg_3 = require("../src/icons/thin/ticket.svg");
const tickets_airline_svg_3 = require("../src/icons/thin/tickets-airline.svg");
const tilde_svg_3 = require("../src/icons/thin/tilde.svg");
const timeline_arrow_svg_3 = require("../src/icons/thin/timeline-arrow.svg");
const timeline_svg_3 = require("../src/icons/thin/timeline.svg");
const timer_svg_3 = require("../src/icons/thin/timer.svg");
const tire_flat_svg_3 = require("../src/icons/thin/tire-flat.svg");
const tire_pressure_warning_svg_3 = require("../src/icons/thin/tire-pressure-warning.svg");
const tire_rugged_svg_3 = require("../src/icons/thin/tire-rugged.svg");
const tire_svg_3 = require("../src/icons/thin/tire.svg");
const toggle_off_svg_3 = require("../src/icons/thin/toggle-off.svg");
const toggle_on_svg_3 = require("../src/icons/thin/toggle-on.svg");
const toilet_paper_blank_under_svg_3 = require("../src/icons/thin/toilet-paper-blank-under.svg");
const toilet_paper_blank_svg_3 = require("../src/icons/thin/toilet-paper-blank.svg");
const toilet_paper_slash_svg_3 = require("../src/icons/thin/toilet-paper-slash.svg");
const toilet_paper_under_slash_svg_3 = require("../src/icons/thin/toilet-paper-under-slash.svg");
const toilet_paper_under_svg_3 = require("../src/icons/thin/toilet-paper-under.svg");
const toilet_paper_svg_3 = require("../src/icons/thin/toilet-paper.svg");
const toilet_svg_3 = require("../src/icons/thin/toilet.svg");
const tombstone_blank_svg_3 = require("../src/icons/thin/tombstone-blank.svg");
const tombstone_svg_3 = require("../src/icons/thin/tombstone.svg");
const toolbox_svg_3 = require("../src/icons/thin/toolbox.svg");
const tooth_svg_3 = require("../src/icons/thin/tooth.svg");
const toothbrush_svg_3 = require("../src/icons/thin/toothbrush.svg");
const torii_gate_svg_3 = require("../src/icons/thin/torii-gate.svg");
const tornado_svg_3 = require("../src/icons/thin/tornado.svg");
const tower_broadcast_svg_3 = require("../src/icons/thin/tower-broadcast.svg");
const tower_control_svg_3 = require("../src/icons/thin/tower-control.svg");
const tractor_svg_3 = require("../src/icons/thin/tractor.svg");
const trademark_svg_3 = require("../src/icons/thin/trademark.svg");
const traffic_cone_svg_3 = require("../src/icons/thin/traffic-cone.svg");
const traffic_light_go_svg_3 = require("../src/icons/thin/traffic-light-go.svg");
const traffic_light_slow_svg_3 = require("../src/icons/thin/traffic-light-slow.svg");
const traffic_light_stop_svg_3 = require("../src/icons/thin/traffic-light-stop.svg");
const traffic_light_svg_3 = require("../src/icons/thin/traffic-light.svg");
const trailer_svg_3 = require("../src/icons/thin/trailer.svg");
const train_subway_tunnel_svg_3 = require("../src/icons/thin/train-subway-tunnel.svg");
const train_subway_svg_3 = require("../src/icons/thin/train-subway.svg");
const train_tram_svg_3 = require("../src/icons/thin/train-tram.svg");
const train_svg_3 = require("../src/icons/thin/train.svg");
const transformer_bolt_svg_3 = require("../src/icons/thin/transformer-bolt.svg");
const transgender_alt_svg_3 = require("../src/icons/thin/transgender-alt.svg");
const transgender_svg_3 = require("../src/icons/thin/transgender.svg");
const transporter_1_svg_3 = require("../src/icons/thin/transporter-1.svg");
const transporter_2_svg_3 = require("../src/icons/thin/transporter-2.svg");
const transporter_3_svg_3 = require("../src/icons/thin/transporter-3.svg");
const transporter_4_svg_3 = require("../src/icons/thin/transporter-4.svg");
const transporter_5_svg_3 = require("../src/icons/thin/transporter-5.svg");
const transporter_6_svg_3 = require("../src/icons/thin/transporter-6.svg");
const transporter_7_svg_3 = require("../src/icons/thin/transporter-7.svg");
const transporter_empty_svg_3 = require("../src/icons/thin/transporter-empty.svg");
const transporter_svg_3 = require("../src/icons/thin/transporter.svg");
const trash_arrow_up_svg_3 = require("../src/icons/thin/trash-arrow-up.svg");
const trash_can_arrow_up_svg_3 = require("../src/icons/thin/trash-can-arrow-up.svg");
const trash_can_clock_svg_3 = require("../src/icons/thin/trash-can-clock.svg");
const trash_can_list_svg_3 = require("../src/icons/thin/trash-can-list.svg");
const trash_can_slash_svg_3 = require("../src/icons/thin/trash-can-slash.svg");
const trash_can_undo_svg_3 = require("../src/icons/thin/trash-can-undo.svg");
const trash_can_svg_3 = require("../src/icons/thin/trash-can.svg");
const trash_clock_svg_3 = require("../src/icons/thin/trash-clock.svg");
const trash_list_svg_3 = require("../src/icons/thin/trash-list.svg");
const trash_slash_svg_3 = require("../src/icons/thin/trash-slash.svg");
const trash_undo_svg_3 = require("../src/icons/thin/trash-undo.svg");
const trash_svg_3 = require("../src/icons/thin/trash.svg");
const treasure_chest_svg_3 = require("../src/icons/thin/treasure-chest.svg");
const tree_christmas_svg_3 = require("../src/icons/thin/tree-christmas.svg");
const tree_deciduous_svg_3 = require("../src/icons/thin/tree-deciduous.svg");
const tree_decorated_svg_3 = require("../src/icons/thin/tree-decorated.svg");
const tree_large_svg_3 = require("../src/icons/thin/tree-large.svg");
const tree_palm_svg_3 = require("../src/icons/thin/tree-palm.svg");
const tree_svg_3 = require("../src/icons/thin/tree.svg");
const trees_svg_3 = require("../src/icons/thin/trees.svg");
const triangle_exclamation_svg_3 = require("../src/icons/thin/triangle-exclamation.svg");
const triangle_instrument_svg_3 = require("../src/icons/thin/triangle-instrument.svg");
const triangle_person_digging_svg_3 = require("../src/icons/thin/triangle-person-digging.svg");
const triangle_svg_3 = require("../src/icons/thin/triangle.svg");
const trophy_star_svg_3 = require("../src/icons/thin/trophy-star.svg");
const trophy_svg_3 = require("../src/icons/thin/trophy.svg");
const truck_clock_svg_3 = require("../src/icons/thin/truck-clock.svg");
const truck_container_empty_svg_3 = require("../src/icons/thin/truck-container-empty.svg");
const truck_container_svg_3 = require("../src/icons/thin/truck-container.svg");
const truck_fast_svg_3 = require("../src/icons/thin/truck-fast.svg");
const truck_flatbed_svg_3 = require("../src/icons/thin/truck-flatbed.svg");
const truck_front_svg_3 = require("../src/icons/thin/truck-front.svg");
const truck_medical_svg_3 = require("../src/icons/thin/truck-medical.svg");
const truck_monster_svg_3 = require("../src/icons/thin/truck-monster.svg");
const truck_moving_svg_3 = require("../src/icons/thin/truck-moving.svg");
const truck_pickup_svg_3 = require("../src/icons/thin/truck-pickup.svg");
const truck_plow_svg_3 = require("../src/icons/thin/truck-plow.svg");
const truck_ramp_box_svg_3 = require("../src/icons/thin/truck-ramp-box.svg");
const truck_ramp_couch_svg_3 = require("../src/icons/thin/truck-ramp-couch.svg");
const truck_ramp_svg_3 = require("../src/icons/thin/truck-ramp.svg");
const truck_tow_svg_3 = require("../src/icons/thin/truck-tow.svg");
const truck_svg_3 = require("../src/icons/thin/truck.svg");
const trumpet_svg_3 = require("../src/icons/thin/trumpet.svg");
const tshirt_svg_3 = require("../src/icons/thin/tshirt.svg");
const tty_answer_svg_3 = require("../src/icons/thin/tty-answer.svg");
const tty_svg_3 = require("../src/icons/thin/tty.svg");
const tugrik_sign_svg_3 = require("../src/icons/thin/tugrik-sign.svg");
const turkey_svg_3 = require("../src/icons/thin/turkey.svg");
const turkish_lira_sign_svg_3 = require("../src/icons/thin/turkish-lira-sign.svg");
const turn_down_svg_3 = require("../src/icons/thin/turn-down.svg");
const turn_up_svg_3 = require("../src/icons/thin/turn-up.svg");
const turntable_svg_3 = require("../src/icons/thin/turntable.svg");
const turtle_svg_3 = require("../src/icons/thin/turtle.svg");
const tv_music_svg_3 = require("../src/icons/thin/tv-music.svg");
const tv_retro_svg_3 = require("../src/icons/thin/tv-retro.svg");
const tv_svg_3 = require("../src/icons/thin/tv.svg");
const typewriter_svg_3 = require("../src/icons/thin/typewriter.svg");
const u_svg_3 = require("../src/icons/thin/u.svg");
const ufo_beam_svg_3 = require("../src/icons/thin/ufo-beam.svg");
const ufo_svg_3 = require("../src/icons/thin/ufo.svg");
const umbrella_beach_svg_3 = require("../src/icons/thin/umbrella-beach.svg");
const umbrella_simple_svg_3 = require("../src/icons/thin/umbrella-simple.svg");
const umbrella_svg_3 = require("../src/icons/thin/umbrella.svg");
const underline_svg_3 = require("../src/icons/thin/underline.svg");
const unicorn_svg_3 = require("../src/icons/thin/unicorn.svg");
const union_svg_3 = require("../src/icons/thin/union.svg");
const universal_access_svg_3 = require("../src/icons/thin/universal-access.svg");
const unlock_keyhole_svg_3 = require("../src/icons/thin/unlock-keyhole.svg");
const unlock_svg_3 = require("../src/icons/thin/unlock.svg");
const up_down_left_right_svg_3 = require("../src/icons/thin/up-down-left-right.svg");
const up_down_svg_3 = require("../src/icons/thin/up-down.svg");
const up_from_line_svg_3 = require("../src/icons/thin/up-from-line.svg");
const up_left_svg_3 = require("../src/icons/thin/up-left.svg");
const up_long_svg_3 = require("../src/icons/thin/up-long.svg");
const up_right_and_down_left_from_center_svg_3 = require("../src/icons/thin/up-right-and-down-left-from-center.svg");
const up_right_from_square_svg_3 = require("../src/icons/thin/up-right-from-square.svg");
const up_right_svg_3 = require("../src/icons/thin/up-right.svg");
const up_to_line_svg_3 = require("../src/icons/thin/up-to-line.svg");
const up_svg_3 = require("../src/icons/thin/up.svg");
const upload_svg_3 = require("../src/icons/thin/upload.svg");
const usb_drive_svg_3 = require("../src/icons/thin/usb-drive.svg");
const user_alien_svg_3 = require("../src/icons/thin/user-alien.svg");
const user_astronaut_svg_3 = require("../src/icons/thin/user-astronaut.svg");
const user_bounty_hunter_svg_3 = require("../src/icons/thin/user-bounty-hunter.svg");
const user_check_svg_3 = require("../src/icons/thin/user-check.svg");
const user_clock_svg_3 = require("../src/icons/thin/user-clock.svg");
const user_cowboy_svg_3 = require("../src/icons/thin/user-cowboy.svg");
const user_crown_svg_3 = require("../src/icons/thin/user-crown.svg");
const user_doctor_message_svg_3 = require("../src/icons/thin/user-doctor-message.svg");
const user_doctor_svg_3 = require("../src/icons/thin/user-doctor.svg");
const user_gear_svg_3 = require("../src/icons/thin/user-gear.svg");
const user_graduate_svg_3 = require("../src/icons/thin/user-graduate.svg");
const user_group_crown_svg_3 = require("../src/icons/thin/user-group-crown.svg");
const user_group_svg_3 = require("../src/icons/thin/user-group.svg");
const user_headset_svg_3 = require("../src/icons/thin/user-headset.svg");
const user_helmet_safety_svg_3 = require("../src/icons/thin/user-helmet-safety.svg");
const user_injured_svg_3 = require("../src/icons/thin/user-injured.svg");
const user_large_slash_svg_3 = require("../src/icons/thin/user-large-slash.svg");
const user_large_svg_3 = require("../src/icons/thin/user-large.svg");
const user_lock_svg_3 = require("../src/icons/thin/user-lock.svg");
const user_minus_svg_3 = require("../src/icons/thin/user-minus.svg");
const user_music_svg_3 = require("../src/icons/thin/user-music.svg");
const user_ninja_svg_3 = require("../src/icons/thin/user-ninja.svg");
const user_nurse_svg_3 = require("../src/icons/thin/user-nurse.svg");
const user_pen_svg_3 = require("../src/icons/thin/user-pen.svg");
const user_pilot_tie_svg_3 = require("../src/icons/thin/user-pilot-tie.svg");
const user_pilot_svg_3 = require("../src/icons/thin/user-pilot.svg");
const user_plus_svg_3 = require("../src/icons/thin/user-plus.svg");
const user_robot_svg_3 = require("../src/icons/thin/user-robot.svg");
const user_secret_svg_3 = require("../src/icons/thin/user-secret.svg");
const user_shakespeare_svg_3 = require("../src/icons/thin/user-shakespeare.svg");
const user_shield_svg_3 = require("../src/icons/thin/user-shield.svg");
const user_slash_svg_3 = require("../src/icons/thin/user-slash.svg");
const user_tag_svg_3 = require("../src/icons/thin/user-tag.svg");
const user_tie_svg_3 = require("../src/icons/thin/user-tie.svg");
const user_unlock_svg_3 = require("../src/icons/thin/user-unlock.svg");
const user_visor_svg_3 = require("../src/icons/thin/user-visor.svg");
const user_xmark_svg_3 = require("../src/icons/thin/user-xmark.svg");
const user_svg_3 = require("../src/icons/thin/user.svg");
const users_gear_svg_3 = require("../src/icons/thin/users-gear.svg");
const users_medical_svg_3 = require("../src/icons/thin/users-medical.svg");
const users_slash_svg_3 = require("../src/icons/thin/users-slash.svg");
const users_svg_3 = require("../src/icons/thin/users.svg");
const utensils_svg_3 = require("../src/icons/thin/utensils.svg");
const utility_pole_double_svg_3 = require("../src/icons/thin/utility-pole-double.svg");
const utility_pole_svg_3 = require("../src/icons/thin/utility-pole.svg");
const v_svg_3 = require("../src/icons/thin/v.svg");
const vacuum_robot_svg_3 = require("../src/icons/thin/vacuum-robot.svg");
const vacuum_svg_3 = require("../src/icons/thin/vacuum.svg");
const value_absolute_svg_3 = require("../src/icons/thin/value-absolute.svg");
const van_shuttle_svg_3 = require("../src/icons/thin/van-shuttle.svg");
const vault_svg_3 = require("../src/icons/thin/vault.svg");
const vector_circle_svg_3 = require("../src/icons/thin/vector-circle.svg");
const vector_polygon_svg_3 = require("../src/icons/thin/vector-polygon.svg");
const vector_square_svg_3 = require("../src/icons/thin/vector-square.svg");
const venus_double_svg_3 = require("../src/icons/thin/venus-double.svg");
const venus_mars_svg_3 = require("../src/icons/thin/venus-mars.svg");
const venus_svg_3 = require("../src/icons/thin/venus.svg");
const vest_patches_svg_3 = require("../src/icons/thin/vest-patches.svg");
const vest_svg_3 = require("../src/icons/thin/vest.svg");
const vial_svg_3 = require("../src/icons/thin/vial.svg");
const vials_svg_3 = require("../src/icons/thin/vials.svg");
const video_arrow_down_left_svg_3 = require("../src/icons/thin/video-arrow-down-left.svg");
const video_arrow_up_right_svg_3 = require("../src/icons/thin/video-arrow-up-right.svg");
const video_plus_svg_3 = require("../src/icons/thin/video-plus.svg");
const video_slash_svg_3 = require("../src/icons/thin/video-slash.svg");
const video_svg_3 = require("../src/icons/thin/video.svg");
const vihara_svg_3 = require("../src/icons/thin/vihara.svg");
const violin_svg_3 = require("../src/icons/thin/violin.svg");
const virus_slash_svg_3 = require("../src/icons/thin/virus-slash.svg");
const virus_svg_3 = require("../src/icons/thin/virus.svg");
const viruses_svg_3 = require("../src/icons/thin/viruses.svg");
const voicemail_svg_3 = require("../src/icons/thin/voicemail.svg");
const volcano_svg_3 = require("../src/icons/thin/volcano.svg");
const volleyball_ball_svg_3 = require("../src/icons/thin/volleyball-ball.svg");
const volume_high_svg_3 = require("../src/icons/thin/volume-high.svg");
const volume_low_svg_3 = require("../src/icons/thin/volume-low.svg");
const volume_off_svg_3 = require("../src/icons/thin/volume-off.svg");
const volume_slash_svg_3 = require("../src/icons/thin/volume-slash.svg");
const volume_xmark_svg_3 = require("../src/icons/thin/volume-xmark.svg");
const volume_svg_3 = require("../src/icons/thin/volume.svg");
const vr_cardboard_svg_3 = require("../src/icons/thin/vr-cardboard.svg");
const w_svg_3 = require("../src/icons/thin/w.svg");
const wagon_covered_svg_3 = require("../src/icons/thin/wagon-covered.svg");
const walker_svg_3 = require("../src/icons/thin/walker.svg");
const walkie_talkie_svg_3 = require("../src/icons/thin/walkie-talkie.svg");
const wallet_svg_3 = require("../src/icons/thin/wallet.svg");
const wand_magic_sparkles_svg_3 = require("../src/icons/thin/wand-magic-sparkles.svg");
const wand_magic_svg_3 = require("../src/icons/thin/wand-magic.svg");
const wand_sparkles_svg_3 = require("../src/icons/thin/wand-sparkles.svg");
const wand_svg_3 = require("../src/icons/thin/wand.svg");
const warehouse_full_svg_3 = require("../src/icons/thin/warehouse-full.svg");
const warehouse_svg_3 = require("../src/icons/thin/warehouse.svg");
const washing_machine_svg_3 = require("../src/icons/thin/washing-machine.svg");
const watch_apple_svg_3 = require("../src/icons/thin/watch-apple.svg");
const watch_calculator_svg_3 = require("../src/icons/thin/watch-calculator.svg");
const watch_fitness_svg_3 = require("../src/icons/thin/watch-fitness.svg");
const watch_smart_svg_3 = require("../src/icons/thin/watch-smart.svg");
const watch_svg_3 = require("../src/icons/thin/watch.svg");
const water_arrow_down_svg_3 = require("../src/icons/thin/water-arrow-down.svg");
const water_arrow_up_svg_3 = require("../src/icons/thin/water-arrow-up.svg");
const water_ladder_svg_3 = require("../src/icons/thin/water-ladder.svg");
const water_svg_3 = require("../src/icons/thin/water.svg");
const wave_pulse_svg_3 = require("../src/icons/thin/wave-pulse.svg");
const wave_sine_svg_3 = require("../src/icons/thin/wave-sine.svg");
const wave_square_svg_3 = require("../src/icons/thin/wave-square.svg");
const wave_triangle_svg_3 = require("../src/icons/thin/wave-triangle.svg");
const waveform_lines_svg_3 = require("../src/icons/thin/waveform-lines.svg");
const waveform_svg_3 = require("../src/icons/thin/waveform.svg");
const weight_hanging_svg_3 = require("../src/icons/thin/weight-hanging.svg");
const weight_scale_svg_3 = require("../src/icons/thin/weight-scale.svg");
const whale_svg_3 = require("../src/icons/thin/whale.svg");
const wheat_awn_svg_3 = require("../src/icons/thin/wheat-awn.svg");
const wheat_svg_3 = require("../src/icons/thin/wheat.svg");
const wheelchair_move_svg_3 = require("../src/icons/thin/wheelchair-move.svg");
const wheelchair_svg_3 = require("../src/icons/thin/wheelchair.svg");
const whiskey_glass_ice_svg_3 = require("../src/icons/thin/whiskey-glass-ice.svg");
const whiskey_glass_svg_3 = require("../src/icons/thin/whiskey-glass.svg");
const whistle_svg_3 = require("../src/icons/thin/whistle.svg");
const wifi_exclamation_svg_3 = require("../src/icons/thin/wifi-exclamation.svg");
const wifi_fair_svg_3 = require("../src/icons/thin/wifi-fair.svg");
const wifi_slash_svg_3 = require("../src/icons/thin/wifi-slash.svg");
const wifi_weak_svg_3 = require("../src/icons/thin/wifi-weak.svg");
const wifi_svg_3 = require("../src/icons/thin/wifi.svg");
const wind_turbine_svg_3 = require("../src/icons/thin/wind-turbine.svg");
const wind_warning_svg_3 = require("../src/icons/thin/wind-warning.svg");
const wind_svg_3 = require("../src/icons/thin/wind.svg");
const window_flip_svg_3 = require("../src/icons/thin/window-flip.svg");
const window_frame_open_svg_3 = require("../src/icons/thin/window-frame-open.svg");
const window_frame_svg_3 = require("../src/icons/thin/window-frame.svg");
const window_maximize_svg_3 = require("../src/icons/thin/window-maximize.svg");
const window_minimize_svg_3 = require("../src/icons/thin/window-minimize.svg");
const window_restore_svg_3 = require("../src/icons/thin/window-restore.svg");
const window_svg_3 = require("../src/icons/thin/window.svg");
const windsock_svg_3 = require("../src/icons/thin/windsock.svg");
const wine_bottle_svg_3 = require("../src/icons/thin/wine-bottle.svg");
const wine_glass_crack_svg_3 = require("../src/icons/thin/wine-glass-crack.svg");
const wine_glass_empty_svg_3 = require("../src/icons/thin/wine-glass-empty.svg");
const wine_glass_svg_3 = require("../src/icons/thin/wine-glass.svg");
const won_sign_svg_3 = require("../src/icons/thin/won-sign.svg");
const wreath_svg_3 = require("../src/icons/thin/wreath.svg");
const wrench_simple_svg_3 = require("../src/icons/thin/wrench-simple.svg");
const wrench_svg_3 = require("../src/icons/thin/wrench.svg");
const x_ray_svg_3 = require("../src/icons/thin/x-ray.svg");
const x_svg_3 = require("../src/icons/thin/x.svg");
const xmark_to_slot_svg_3 = require("../src/icons/thin/xmark-to-slot.svg");
const xmark_svg_3 = require("../src/icons/thin/xmark.svg");
const y_svg_3 = require("../src/icons/thin/y.svg");
const yen_sign_svg_3 = require("../src/icons/thin/yen-sign.svg");
const yin_yang_svg_3 = require("../src/icons/thin/yin-yang.svg");
const z_svg_3 = require("../src/icons/thin/z.svg");
const iconMap = {
    'brands-500px': _500px_svg_1.ReactComponent,
    'brands-accessible-icon': accessible_icon_svg_1.ReactComponent,
    'brands-accusoft': accusoft_svg_1.ReactComponent,
    'brands-acquisitions-incorporated': acquisitions_incorporated_svg_1.ReactComponent,
    'brands-adn': adn_svg_1.ReactComponent,
    'brands-adversal': adversal_svg_1.ReactComponent,
    'brands-affiliatetheme': affiliatetheme_svg_1.ReactComponent,
    'brands-airbnb': airbnb_svg_1.ReactComponent,
    'brands-algolia': algolia_svg_1.ReactComponent,
    'brands-alipay': alipay_svg_1.ReactComponent,
    'brands-amazon-pay': amazon_pay_svg_1.ReactComponent,
    'brands-amazon': amazon_svg_1.ReactComponent,
    'brands-amilia': amilia_svg_1.ReactComponent,
    'brands-android': android_svg_1.ReactComponent,
    'brands-angellist': angellist_svg_1.ReactComponent,
    'brands-angrycreative': angrycreative_svg_1.ReactComponent,
    'brands-angular': angular_svg_1.ReactComponent,
    'brands-app-store-ios': app_store_ios_svg_1.ReactComponent,
    'brands-app-store': app_store_svg_1.ReactComponent,
    'brands-apper': apper_svg_1.ReactComponent,
    'brands-apple-pay': apple_pay_svg_1.ReactComponent,
    'brands-apple': apple_svg_1.ReactComponent,
    'brands-artstation': artstation_svg_1.ReactComponent,
    'brands-asymmetrik': asymmetrik_svg_1.ReactComponent,
    'brands-atlassian': atlassian_svg_1.ReactComponent,
    'brands-audible': audible_svg_1.ReactComponent,
    'brands-autoprefixer': autoprefixer_svg_1.ReactComponent,
    'brands-avianex': avianex_svg_1.ReactComponent,
    'brands-aviato': aviato_svg_1.ReactComponent,
    'brands-aws': aws_svg_1.ReactComponent,
    'brands-bandcamp': bandcamp_svg_1.ReactComponent,
    'brands-battle-net': battle_net_svg_1.ReactComponent,
    'brands-behance-square': behance_square_svg_1.ReactComponent,
    'brands-behance': behance_svg_1.ReactComponent,
    'brands-bimobject': bimobject_svg_1.ReactComponent,
    'brands-bitbucket': bitbucket_svg_1.ReactComponent,
    'brands-bitcoin': bitcoin_svg_1.ReactComponent,
    'brands-bity': bity_svg_1.ReactComponent,
    'brands-black-tie': black_tie_svg_1.ReactComponent,
    'brands-blackberry': blackberry_svg_1.ReactComponent,
    'brands-blogger-b': blogger_b_svg_1.ReactComponent,
    'brands-blogger': blogger_svg_1.ReactComponent,
    'brands-bluetooth-b': bluetooth_b_svg_1.ReactComponent,
    'brands-bluetooth': bluetooth_svg_1.ReactComponent,
    'brands-bootstrap': bootstrap_svg_1.ReactComponent,
    'brands-btc': btc_svg_1.ReactComponent,
    'brands-buffer': buffer_svg_1.ReactComponent,
    'brands-buromobelexperte': buromobelexperte_svg_1.ReactComponent,
    'brands-buy-n-large': buy_n_large_svg_1.ReactComponent,
    'brands-buysellads': buysellads_svg_1.ReactComponent,
    'brands-canadian-maple-leaf': canadian_maple_leaf_svg_1.ReactComponent,
    'brands-cc-amazon-pay': cc_amazon_pay_svg_1.ReactComponent,
    'brands-cc-amex': cc_amex_svg_1.ReactComponent,
    'brands-cc-apple-pay': cc_apple_pay_svg_1.ReactComponent,
    'brands-cc-diners-club': cc_diners_club_svg_1.ReactComponent,
    'brands-cc-discover': cc_discover_svg_1.ReactComponent,
    'brands-cc-jcb': cc_jcb_svg_1.ReactComponent,
    'brands-cc-mastercard': cc_mastercard_svg_1.ReactComponent,
    'brands-cc-paypal': cc_paypal_svg_1.ReactComponent,
    'brands-cc-stripe': cc_stripe_svg_1.ReactComponent,
    'brands-cc-visa': cc_visa_svg_1.ReactComponent,
    'brands-centercode': centercode_svg_1.ReactComponent,
    'brands-centos': centos_svg_1.ReactComponent,
    'brands-chrome': chrome_svg_1.ReactComponent,
    'brands-chromecast': chromecast_svg_1.ReactComponent,
    'brands-cloudflare': cloudflare_svg_1.ReactComponent,
    'brands-cloudscale': cloudscale_svg_1.ReactComponent,
    'brands-cloudsmith': cloudsmith_svg_1.ReactComponent,
    'brands-cloudversify': cloudversify_svg_1.ReactComponent,
    'brands-codepen': codepen_svg_1.ReactComponent,
    'brands-codiepie': codiepie_svg_1.ReactComponent,
    'brands-confluence': confluence_svg_1.ReactComponent,
    'brands-connectdevelop': connectdevelop_svg_1.ReactComponent,
    'brands-contao': contao_svg_1.ReactComponent,
    'brands-cotton-bureau': cotton_bureau_svg_1.ReactComponent,
    'brands-cpanel': cpanel_svg_1.ReactComponent,
    'brands-creative-commons-by': creative_commons_by_svg_1.ReactComponent,
    'brands-creative-commons-nc-eu': creative_commons_nc_eu_svg_1.ReactComponent,
    'brands-creative-commons-nc-jp': creative_commons_nc_jp_svg_1.ReactComponent,
    'brands-creative-commons-nc': creative_commons_nc_svg_1.ReactComponent,
    'brands-creative-commons-nd': creative_commons_nd_svg_1.ReactComponent,
    'brands-creative-commons-pd-alt': creative_commons_pd_alt_svg_1.ReactComponent,
    'brands-creative-commons-pd': creative_commons_pd_svg_1.ReactComponent,
    'brands-creative-commons-remix': creative_commons_remix_svg_1.ReactComponent,
    'brands-creative-commons-sa': creative_commons_sa_svg_1.ReactComponent,
    'brands-creative-commons-sampling-plus': creative_commons_sampling_plus_svg_1.ReactComponent,
    'brands-creative-commons-sampling': creative_commons_sampling_svg_1.ReactComponent,
    'brands-creative-commons-share': creative_commons_share_svg_1.ReactComponent,
    'brands-creative-commons-zero': creative_commons_zero_svg_1.ReactComponent,
    'brands-creative-commons': creative_commons_svg_1.ReactComponent,
    'brands-critical-role': critical_role_svg_1.ReactComponent,
    'brands-css3-alt': css3_alt_svg_1.ReactComponent,
    'brands-css3': css3_svg_1.ReactComponent,
    'brands-cuttlefish': cuttlefish_svg_1.ReactComponent,
    'brands-d-and-d-beyond': d_and_d_beyond_svg_1.ReactComponent,
    'brands-d-and-d': d_and_d_svg_1.ReactComponent,
    'brands-dailymotion': dailymotion_svg_1.ReactComponent,
    'brands-dashcube': dashcube_svg_1.ReactComponent,
    'brands-deezer': deezer_svg_1.ReactComponent,
    'brands-delicious': delicious_svg_1.ReactComponent,
    'brands-deploydog': deploydog_svg_1.ReactComponent,
    'brands-deskpro': deskpro_svg_1.ReactComponent,
    'brands-dev': dev_svg_1.ReactComponent,
    'brands-deviantart': deviantart_svg_1.ReactComponent,
    'brands-dhl': dhl_svg_1.ReactComponent,
    'brands-diaspora': diaspora_svg_1.ReactComponent,
    'brands-digg': digg_svg_1.ReactComponent,
    'brands-digital-ocean': digital_ocean_svg_1.ReactComponent,
    'brands-discord': discord_svg_1.ReactComponent,
    'brands-discourse': discourse_svg_1.ReactComponent,
    'brands-dochub': dochub_svg_1.ReactComponent,
    'brands-docker': docker_svg_1.ReactComponent,
    'brands-draft2digital': draft2digital_svg_1.ReactComponent,
    'brands-dribbble-square': dribbble_square_svg_1.ReactComponent,
    'brands-dribbble': dribbble_svg_1.ReactComponent,
    'brands-dropbox': dropbox_svg_1.ReactComponent,
    'brands-drupal': drupal_svg_1.ReactComponent,
    'brands-dyalog': dyalog_svg_1.ReactComponent,
    'brands-earlybirds': earlybirds_svg_1.ReactComponent,
    'brands-ebay': ebay_svg_1.ReactComponent,
    'brands-edge-legacy': edge_legacy_svg_1.ReactComponent,
    'brands-edge': edge_svg_1.ReactComponent,
    'brands-elementor': elementor_svg_1.ReactComponent,
    'brands-ello': ello_svg_1.ReactComponent,
    'brands-ember': ember_svg_1.ReactComponent,
    'brands-empire': empire_svg_1.ReactComponent,
    'brands-envira': envira_svg_1.ReactComponent,
    'brands-erlang': erlang_svg_1.ReactComponent,
    'brands-ethereum': ethereum_svg_1.ReactComponent,
    'brands-etsy': etsy_svg_1.ReactComponent,
    'brands-evernote': evernote_svg_1.ReactComponent,
    'brands-expeditedssl': expeditedssl_svg_1.ReactComponent,
    'brands-facebook-f': facebook_f_svg_1.ReactComponent,
    'brands-facebook-messenger': facebook_messenger_svg_1.ReactComponent,
    'brands-facebook-square': facebook_square_svg_1.ReactComponent,
    'brands-facebook': facebook_svg_1.ReactComponent,
    'brands-fantasy-flight-games': fantasy_flight_games_svg_1.ReactComponent,
    'brands-fedex': fedex_svg_1.ReactComponent,
    'brands-fedora': fedora_svg_1.ReactComponent,
    'brands-figma': figma_svg_1.ReactComponent,
    'brands-firefox-browser': firefox_browser_svg_1.ReactComponent,
    'brands-firefox': firefox_svg_1.ReactComponent,
    'brands-first-order-alt': first_order_alt_svg_1.ReactComponent,
    'brands-first-order': first_order_svg_1.ReactComponent,
    'brands-firstdraft': firstdraft_svg_1.ReactComponent,
    'brands-flickr': flickr_svg_1.ReactComponent,
    'brands-flipboard': flipboard_svg_1.ReactComponent,
    'brands-fly': fly_svg_1.ReactComponent,
    'brands-font-awesome': font_awesome_svg_1.ReactComponent,
    'brands-fonticons-fi': fonticons_fi_svg_1.ReactComponent,
    'brands-fonticons': fonticons_svg_1.ReactComponent,
    'brands-fort-awesome-alt': fort_awesome_alt_svg_1.ReactComponent,
    'brands-fort-awesome': fort_awesome_svg_1.ReactComponent,
    'brands-forumbee': forumbee_svg_1.ReactComponent,
    'brands-foursquare': foursquare_svg_1.ReactComponent,
    'brands-free-code-camp': free_code_camp_svg_1.ReactComponent,
    'brands-freebsd': freebsd_svg_1.ReactComponent,
    'brands-fulcrum': fulcrum_svg_1.ReactComponent,
    'brands-galactic-republic': galactic_republic_svg_1.ReactComponent,
    'brands-galactic-senate': galactic_senate_svg_1.ReactComponent,
    'brands-get-pocket': get_pocket_svg_1.ReactComponent,
    'brands-gg-circle': gg_circle_svg_1.ReactComponent,
    'brands-gg': gg_svg_1.ReactComponent,
    'brands-git-alt': git_alt_svg_1.ReactComponent,
    'brands-git-square': git_square_svg_1.ReactComponent,
    'brands-git': git_svg_1.ReactComponent,
    'brands-github-alt': github_alt_svg_1.ReactComponent,
    'brands-github-square': github_square_svg_1.ReactComponent,
    'brands-github': github_svg_1.ReactComponent,
    'brands-gitkraken': gitkraken_svg_1.ReactComponent,
    'brands-gitlab': gitlab_svg_1.ReactComponent,
    'brands-gitter': gitter_svg_1.ReactComponent,
    'brands-glide-g': glide_g_svg_1.ReactComponent,
    'brands-glide': glide_svg_1.ReactComponent,
    'brands-gofore': gofore_svg_1.ReactComponent,
    'brands-goodreads-g': goodreads_g_svg_1.ReactComponent,
    'brands-goodreads': goodreads_svg_1.ReactComponent,
    'brands-google-drive': google_drive_svg_1.ReactComponent,
    'brands-google-pay': google_pay_svg_1.ReactComponent,
    'brands-google-play': google_play_svg_1.ReactComponent,
    'brands-google-plus-g': google_plus_g_svg_1.ReactComponent,
    'brands-google-plus-square': google_plus_square_svg_1.ReactComponent,
    'brands-google-plus': google_plus_svg_1.ReactComponent,
    'brands-google-wallet': google_wallet_svg_1.ReactComponent,
    'brands-google': google_svg_1.ReactComponent,
    'brands-gratipay': gratipay_svg_1.ReactComponent,
    'brands-grav': grav_svg_1.ReactComponent,
    'brands-gripfire': gripfire_svg_1.ReactComponent,
    'brands-grunt': grunt_svg_1.ReactComponent,
    'brands-guilded': guilded_svg_1.ReactComponent,
    'brands-gulp': gulp_svg_1.ReactComponent,
    'brands-hacker-news-square': hacker_news_square_svg_1.ReactComponent,
    'brands-hacker-news': hacker_news_svg_1.ReactComponent,
    'brands-hackerrank': hackerrank_svg_1.ReactComponent,
    'brands-hips': hips_svg_1.ReactComponent,
    'brands-hire-a-helper': hire_a_helper_svg_1.ReactComponent,
    'brands-hive': hive_svg_1.ReactComponent,
    'brands-hooli': hooli_svg_1.ReactComponent,
    'brands-hornbill': hornbill_svg_1.ReactComponent,
    'brands-hotjar': hotjar_svg_1.ReactComponent,
    'brands-houzz': houzz_svg_1.ReactComponent,
    'brands-html5': html5_svg_1.ReactComponent,
    'brands-hubspot': hubspot_svg_1.ReactComponent,
    'brands-ideal': ideal_svg_1.ReactComponent,
    'brands-imdb': imdb_svg_1.ReactComponent,
    'brands-innosoft': innosoft_svg_1.ReactComponent,
    'brands-instagram-square': instagram_square_svg_1.ReactComponent,
    'brands-instagram': instagram_svg_1.ReactComponent,
    'brands-instalod': instalod_svg_1.ReactComponent,
    'brands-intercom': intercom_svg_1.ReactComponent,
    'brands-internet-explorer': internet_explorer_svg_1.ReactComponent,
    'brands-invision': invision_svg_1.ReactComponent,
    'brands-ioxhost': ioxhost_svg_1.ReactComponent,
    'brands-itch-io': itch_io_svg_1.ReactComponent,
    'brands-itunes-note': itunes_note_svg_1.ReactComponent,
    'brands-itunes': itunes_svg_1.ReactComponent,
    'brands-java': java_svg_1.ReactComponent,
    'brands-jedi-order': jedi_order_svg_1.ReactComponent,
    'brands-jenkins': jenkins_svg_1.ReactComponent,
    'brands-jira': jira_svg_1.ReactComponent,
    'brands-joget': joget_svg_1.ReactComponent,
    'brands-joomla': joomla_svg_1.ReactComponent,
    'brands-js-square': js_square_svg_1.ReactComponent,
    'brands-js': js_svg_1.ReactComponent,
    'brands-jsfiddle': jsfiddle_svg_1.ReactComponent,
    'brands-kaggle': kaggle_svg_1.ReactComponent,
    'brands-keybase': keybase_svg_1.ReactComponent,
    'brands-keycdn': keycdn_svg_1.ReactComponent,
    'brands-kickstarter-k': kickstarter_k_svg_1.ReactComponent,
    'brands-kickstarter': kickstarter_svg_1.ReactComponent,
    'brands-korvue': korvue_svg_1.ReactComponent,
    'brands-laravel': laravel_svg_1.ReactComponent,
    'brands-lastfm-square': lastfm_square_svg_1.ReactComponent,
    'brands-lastfm': lastfm_svg_1.ReactComponent,
    'brands-leanpub': leanpub_svg_1.ReactComponent,
    'brands-less': less_svg_1.ReactComponent,
    'brands-line': line_svg_1.ReactComponent,
    'brands-linkedin-in': linkedin_in_svg_1.ReactComponent,
    'brands-linkedin': linkedin_svg_1.ReactComponent,
    'brands-linode': linode_svg_1.ReactComponent,
    'brands-linux': linux_svg_1.ReactComponent,
    'brands-lyft': lyft_svg_1.ReactComponent,
    'brands-magento': magento_svg_1.ReactComponent,
    'brands-mailchimp': mailchimp_svg_1.ReactComponent,
    'brands-mandalorian': mandalorian_svg_1.ReactComponent,
    'brands-markdown': markdown_svg_1.ReactComponent,
    'brands-mastodon': mastodon_svg_1.ReactComponent,
    'brands-maxcdn': maxcdn_svg_1.ReactComponent,
    'brands-mdb': mdb_svg_1.ReactComponent,
    'brands-medapps': medapps_svg_1.ReactComponent,
    'brands-medium': medium_svg_1.ReactComponent,
    'brands-medrt': medrt_svg_1.ReactComponent,
    'brands-meetup': meetup_svg_1.ReactComponent,
    'brands-megaport': megaport_svg_1.ReactComponent,
    'brands-mendeley': mendeley_svg_1.ReactComponent,
    'brands-microblog': microblog_svg_1.ReactComponent,
    'brands-microsoft': microsoft_svg_1.ReactComponent,
    'brands-mix': mix_svg_1.ReactComponent,
    'brands-mixcloud': mixcloud_svg_1.ReactComponent,
    'brands-mixer': mixer_svg_1.ReactComponent,
    'brands-mizuni': mizuni_svg_1.ReactComponent,
    'brands-modx': modx_svg_1.ReactComponent,
    'brands-monero': monero_svg_1.ReactComponent,
    'brands-napster': napster_svg_1.ReactComponent,
    'brands-neos': neos_svg_1.ReactComponent,
    'brands-nimblr': nimblr_svg_1.ReactComponent,
    'brands-node-js': node_js_svg_1.ReactComponent,
    'brands-node': node_svg_1.ReactComponent,
    'brands-npm': npm_svg_1.ReactComponent,
    'brands-ns8': ns8_svg_1.ReactComponent,
    'brands-nutritionix': nutritionix_svg_1.ReactComponent,
    'brands-octopus-deploy': octopus_deploy_svg_1.ReactComponent,
    'brands-odnoklassniki-square': odnoklassniki_square_svg_1.ReactComponent,
    'brands-odnoklassniki': odnoklassniki_svg_1.ReactComponent,
    'brands-old-republic': old_republic_svg_1.ReactComponent,
    'brands-opencart': opencart_svg_1.ReactComponent,
    'brands-openid': openid_svg_1.ReactComponent,
    'brands-opera': opera_svg_1.ReactComponent,
    'brands-optin-monster': optin_monster_svg_1.ReactComponent,
    'brands-orcid': orcid_svg_1.ReactComponent,
    'brands-osi': osi_svg_1.ReactComponent,
    'brands-page4': page4_svg_1.ReactComponent,
    'brands-pagelines': pagelines_svg_1.ReactComponent,
    'brands-palfed': palfed_svg_1.ReactComponent,
    'brands-patreon': patreon_svg_1.ReactComponent,
    'brands-paypal': paypal_svg_1.ReactComponent,
    'brands-penny-arcade': penny_arcade_svg_1.ReactComponent,
    'brands-perbyte': perbyte_svg_1.ReactComponent,
    'brands-periscope': periscope_svg_1.ReactComponent,
    'brands-phabricator': phabricator_svg_1.ReactComponent,
    'brands-phoenix-framework': phoenix_framework_svg_1.ReactComponent,
    'brands-phoenix-squadron': phoenix_squadron_svg_1.ReactComponent,
    'brands-php': php_svg_1.ReactComponent,
    'brands-pied-piper-alt': pied_piper_alt_svg_1.ReactComponent,
    'brands-pied-piper-hat': pied_piper_hat_svg_1.ReactComponent,
    'brands-pied-piper-pp': pied_piper_pp_svg_1.ReactComponent,
    'brands-pied-piper-square': pied_piper_square_svg_1.ReactComponent,
    'brands-pied-piper': pied_piper_svg_1.ReactComponent,
    'brands-pinterest-p': pinterest_p_svg_1.ReactComponent,
    'brands-pinterest-square': pinterest_square_svg_1.ReactComponent,
    'brands-pinterest': pinterest_svg_1.ReactComponent,
    'brands-playstation': playstation_svg_1.ReactComponent,
    'brands-product-hunt': product_hunt_svg_1.ReactComponent,
    'brands-pushed': pushed_svg_1.ReactComponent,
    'brands-python': python_svg_1.ReactComponent,
    'brands-qq': qq_svg_1.ReactComponent,
    'brands-quinscape': quinscape_svg_1.ReactComponent,
    'brands-quora': quora_svg_1.ReactComponent,
    'brands-r-project': r_project_svg_1.ReactComponent,
    'brands-raspberry-pi': raspberry_pi_svg_1.ReactComponent,
    'brands-ravelry': ravelry_svg_1.ReactComponent,
    'brands-react': react_svg_1.ReactComponent,
    'brands-reacteurope': reacteurope_svg_1.ReactComponent,
    'brands-readme': readme_svg_1.ReactComponent,
    'brands-rebel': rebel_svg_1.ReactComponent,
    'brands-red-river': red_river_svg_1.ReactComponent,
    'brands-reddit-alien': reddit_alien_svg_1.ReactComponent,
    'brands-reddit-square': reddit_square_svg_1.ReactComponent,
    'brands-reddit': reddit_svg_1.ReactComponent,
    'brands-redhat': redhat_svg_1.ReactComponent,
    'brands-renren': renren_svg_1.ReactComponent,
    'brands-replyd': replyd_svg_1.ReactComponent,
    'brands-researchgate': researchgate_svg_1.ReactComponent,
    'brands-resolving': resolving_svg_1.ReactComponent,
    'brands-rev': rev_svg_1.ReactComponent,
    'brands-rocketchat': rocketchat_svg_1.ReactComponent,
    'brands-rockrms': rockrms_svg_1.ReactComponent,
    'brands-rust': rust_svg_1.ReactComponent,
    'brands-safari': safari_svg_1.ReactComponent,
    'brands-salesforce': salesforce_svg_1.ReactComponent,
    'brands-sass': sass_svg_1.ReactComponent,
    'brands-schlix': schlix_svg_1.ReactComponent,
    'brands-scribd': scribd_svg_1.ReactComponent,
    'brands-searchengin': searchengin_svg_1.ReactComponent,
    'brands-sellcast': sellcast_svg_1.ReactComponent,
    'brands-sellsy': sellsy_svg_1.ReactComponent,
    'brands-servicestack': servicestack_svg_1.ReactComponent,
    'brands-shirtsinbulk': shirtsinbulk_svg_1.ReactComponent,
    'brands-shopify': shopify_svg_1.ReactComponent,
    'brands-shopware': shopware_svg_1.ReactComponent,
    'brands-simplybuilt': simplybuilt_svg_1.ReactComponent,
    'brands-sistrix': sistrix_svg_1.ReactComponent,
    'brands-sith': sith_svg_1.ReactComponent,
    'brands-sketch': sketch_svg_1.ReactComponent,
    'brands-skyatlas': skyatlas_svg_1.ReactComponent,
    'brands-skype': skype_svg_1.ReactComponent,
    'brands-slack': slack_svg_1.ReactComponent,
    'brands-slideshare': slideshare_svg_1.ReactComponent,
    'brands-snapchat-square': snapchat_square_svg_1.ReactComponent,
    'brands-snapchat': snapchat_svg_1.ReactComponent,
    'brands-soundcloud': soundcloud_svg_1.ReactComponent,
    'brands-sourcetree': sourcetree_svg_1.ReactComponent,
    'brands-speakap': speakap_svg_1.ReactComponent,
    'brands-speaker-deck': speaker_deck_svg_1.ReactComponent,
    'brands-spotify': spotify_svg_1.ReactComponent,
    'brands-square-font-awesome-stroke': square_font_awesome_stroke_svg_1.ReactComponent,
    'brands-square-font-awesome': square_font_awesome_svg_1.ReactComponent,
    'brands-squarespace': squarespace_svg_1.ReactComponent,
    'brands-stack-exchange': stack_exchange_svg_1.ReactComponent,
    'brands-stack-overflow': stack_overflow_svg_1.ReactComponent,
    'brands-stackpath': stackpath_svg_1.ReactComponent,
    'brands-staylinked': staylinked_svg_1.ReactComponent,
    'brands-steam-square': steam_square_svg_1.ReactComponent,
    'brands-steam-symbol': steam_symbol_svg_1.ReactComponent,
    'brands-steam': steam_svg_1.ReactComponent,
    'brands-sticker-mule': sticker_mule_svg_1.ReactComponent,
    'brands-strava': strava_svg_1.ReactComponent,
    'brands-stripe-s': stripe_s_svg_1.ReactComponent,
    'brands-stripe': stripe_svg_1.ReactComponent,
    'brands-studiovinari': studiovinari_svg_1.ReactComponent,
    'brands-stumbleupon-circle': stumbleupon_circle_svg_1.ReactComponent,
    'brands-stumbleupon': stumbleupon_svg_1.ReactComponent,
    'brands-superpowers': superpowers_svg_1.ReactComponent,
    'brands-supple': supple_svg_1.ReactComponent,
    'brands-suse': suse_svg_1.ReactComponent,
    'brands-swift': swift_svg_1.ReactComponent,
    'brands-symfony': symfony_svg_1.ReactComponent,
    'brands-teamspeak': teamspeak_svg_1.ReactComponent,
    'brands-telegram': telegram_svg_1.ReactComponent,
    'brands-tencent-weibo': tencent_weibo_svg_1.ReactComponent,
    'brands-the-red-yeti': the_red_yeti_svg_1.ReactComponent,
    'brands-themeco': themeco_svg_1.ReactComponent,
    'brands-themeisle': themeisle_svg_1.ReactComponent,
    'brands-think-peaks': think_peaks_svg_1.ReactComponent,
    'brands-tiktok': tiktok_svg_1.ReactComponent,
    'brands-trade-federation': trade_federation_svg_1.ReactComponent,
    'brands-trello': trello_svg_1.ReactComponent,
    'brands-tripadvisor': tripadvisor_svg_1.ReactComponent,
    'brands-tumblr-square': tumblr_square_svg_1.ReactComponent,
    'brands-tumblr': tumblr_svg_1.ReactComponent,
    'brands-twitch': twitch_svg_1.ReactComponent,
    'brands-twitter-square': twitter_square_svg_1.ReactComponent,
    'brands-twitter': twitter_svg_1.ReactComponent,
    'brands-typo3': typo3_svg_1.ReactComponent,
    'brands-uber': uber_svg_1.ReactComponent,
    'brands-ubuntu': ubuntu_svg_1.ReactComponent,
    'brands-uikit': uikit_svg_1.ReactComponent,
    'brands-umbraco': umbraco_svg_1.ReactComponent,
    'brands-uncharted': uncharted_svg_1.ReactComponent,
    'brands-uniregistry': uniregistry_svg_1.ReactComponent,
    'brands-unity': unity_svg_1.ReactComponent,
    'brands-unsplash': unsplash_svg_1.ReactComponent,
    'brands-untappd': untappd_svg_1.ReactComponent,
    'brands-ups': ups_svg_1.ReactComponent,
    'brands-usb': usb_svg_1.ReactComponent,
    'brands-usps': usps_svg_1.ReactComponent,
    'brands-ussunnah': ussunnah_svg_1.ReactComponent,
    'brands-vaadin': vaadin_svg_1.ReactComponent,
    'brands-viacoin': viacoin_svg_1.ReactComponent,
    'brands-viadeo-square': viadeo_square_svg_1.ReactComponent,
    'brands-viadeo': viadeo_svg_1.ReactComponent,
    'brands-viber': viber_svg_1.ReactComponent,
    'brands-vimeo-square': vimeo_square_svg_1.ReactComponent,
    'brands-vimeo-v': vimeo_v_svg_1.ReactComponent,
    'brands-vimeo': vimeo_svg_1.ReactComponent,
    'brands-vine': vine_svg_1.ReactComponent,
    'brands-vk': vk_svg_1.ReactComponent,
    'brands-vnv': vnv_svg_1.ReactComponent,
    'brands-vuejs': vuejs_svg_1.ReactComponent,
    'brands-watchman-monitoring': watchman_monitoring_svg_1.ReactComponent,
    'brands-waze': waze_svg_1.ReactComponent,
    'brands-weebly': weebly_svg_1.ReactComponent,
    'brands-weibo': weibo_svg_1.ReactComponent,
    'brands-weixin': weixin_svg_1.ReactComponent,
    'brands-whatsapp-square': whatsapp_square_svg_1.ReactComponent,
    'brands-whatsapp': whatsapp_svg_1.ReactComponent,
    'brands-whmcs': whmcs_svg_1.ReactComponent,
    'brands-wikipedia-w': wikipedia_w_svg_1.ReactComponent,
    'brands-windows': windows_svg_1.ReactComponent,
    'brands-wix': wix_svg_1.ReactComponent,
    'brands-wizards-of-the-coast': wizards_of_the_coast_svg_1.ReactComponent,
    'brands-wodu': wodu_svg_1.ReactComponent,
    'brands-wolf-pack-battalion': wolf_pack_battalion_svg_1.ReactComponent,
    'brands-wordpress-simple': wordpress_simple_svg_1.ReactComponent,
    'brands-wordpress': wordpress_svg_1.ReactComponent,
    'brands-wpbeginner': wpbeginner_svg_1.ReactComponent,
    'brands-wpexplorer': wpexplorer_svg_1.ReactComponent,
    'brands-wpforms': wpforms_svg_1.ReactComponent,
    'brands-wpressr': wpressr_svg_1.ReactComponent,
    'brands-xbox': xbox_svg_1.ReactComponent,
    'brands-xing-square': xing_square_svg_1.ReactComponent,
    'brands-xing': xing_svg_1.ReactComponent,
    'brands-y-combinator': y_combinator_svg_1.ReactComponent,
    'brands-yahoo': yahoo_svg_1.ReactComponent,
    'brands-yammer': yammer_svg_1.ReactComponent,
    'brands-yandex-international': yandex_international_svg_1.ReactComponent,
    'brands-yandex': yandex_svg_1.ReactComponent,
    'brands-yarn': yarn_svg_1.ReactComponent,
    'brands-yelp': yelp_svg_1.ReactComponent,
    'brands-yoast': yoast_svg_1.ReactComponent,
    'brands-youtube-square': youtube_square_svg_1.ReactComponent,
    'brands-youtube': youtube_svg_1.ReactComponent,
    'brands-zhihu': zhihu_svg_1.ReactComponent,
    'regular-0': _0_svg_1.ReactComponent,
    'regular-1': _1_svg_1.ReactComponent,
    'regular-2': _2_svg_1.ReactComponent,
    'regular-3': _3_svg_1.ReactComponent,
    'regular-4': _4_svg_1.ReactComponent,
    'regular-5': _5_svg_1.ReactComponent,
    'regular-6': _6_svg_1.ReactComponent,
    'regular-7': _7_svg_1.ReactComponent,
    'regular-8': _8_svg_1.ReactComponent,
    'regular-9': _9_svg_1.ReactComponent,
    'regular-a': a_svg_1.ReactComponent,
    'regular-abacus': abacus_svg_1.ReactComponent,
    'regular-acorn': acorn_svg_1.ReactComponent,
    'regular-address-book': address_book_svg_1.ReactComponent,
    'regular-address-card': address_card_svg_1.ReactComponent,
    'regular-air-conditioner': air_conditioner_svg_1.ReactComponent,
    'regular-air-freshener': air_freshener_svg_1.ReactComponent,
    'regular-airplay': airplay_svg_1.ReactComponent,
    'regular-alarm-clock': alarm_clock_svg_1.ReactComponent,
    'regular-alarm-exclamation': alarm_exclamation_svg_1.ReactComponent,
    'regular-alarm-plus': alarm_plus_svg_1.ReactComponent,
    'regular-alarm-snooze': alarm_snooze_svg_1.ReactComponent,
    'regular-album-collection': album_collection_svg_1.ReactComponent,
    'regular-album': album_svg_1.ReactComponent,
    'regular-alicorn': alicorn_svg_1.ReactComponent,
    'regular-alien-8bit': alien_8bit_svg_1.ReactComponent,
    'regular-alien': alien_svg_1.ReactComponent,
    'regular-align-center': align_center_svg_1.ReactComponent,
    'regular-align-justify': align_justify_svg_1.ReactComponent,
    'regular-align-left': align_left_svg_1.ReactComponent,
    'regular-align-right': align_right_svg_1.ReactComponent,
    'regular-align-slash': align_slash_svg_1.ReactComponent,
    'regular-alt': alt_svg_1.ReactComponent,
    'regular-amp-guitar': amp_guitar_svg_1.ReactComponent,
    'regular-ampersand': ampersand_svg_1.ReactComponent,
    'regular-anchor': anchor_svg_1.ReactComponent,
    'regular-angel': angel_svg_1.ReactComponent,
    'regular-angle-90': angle_90_svg_1.ReactComponent,
    'regular-angle-down': angle_down_svg_1.ReactComponent,
    'regular-angle-left': angle_left_svg_1.ReactComponent,
    'regular-angle-right': angle_right_svg_1.ReactComponent,
    'regular-angle-up': angle_up_svg_1.ReactComponent,
    'regular-angle': angle_svg_1.ReactComponent,
    'regular-angles-down': angles_down_svg_1.ReactComponent,
    'regular-angles-left': angles_left_svg_1.ReactComponent,
    'regular-angles-right': angles_right_svg_1.ReactComponent,
    'regular-angles-up': angles_up_svg_1.ReactComponent,
    'regular-ankh': ankh_svg_1.ReactComponent,
    'regular-aperture': aperture_svg_1.ReactComponent,
    'regular-apple-core': apple_core_svg_1.ReactComponent,
    'regular-apple-crate': apple_crate_svg_1.ReactComponent,
    'regular-apple-whole': apple_whole_svg_1.ReactComponent,
    'regular-archway': archway_svg_1.ReactComponent,
    'regular-arrow-down-1-9': arrow_down_1_9_svg_1.ReactComponent,
    'regular-arrow-down-9-1': arrow_down_9_1_svg_1.ReactComponent,
    'regular-arrow-down-a-z': arrow_down_a_z_svg_1.ReactComponent,
    'regular-arrow-down-arrow-up': arrow_down_arrow_up_svg_1.ReactComponent,
    'regular-arrow-down-big-small': arrow_down_big_small_svg_1.ReactComponent,
    'regular-arrow-down-from-dotted-line': arrow_down_from_dotted_line_svg_1.ReactComponent,
    'regular-arrow-down-from-line': arrow_down_from_line_svg_1.ReactComponent,
    'regular-arrow-down-left-and-arrow-up-right-to-center': arrow_down_left_and_arrow_up_right_to_center_svg_1.ReactComponent,
    'regular-arrow-down-left': arrow_down_left_svg_1.ReactComponent,
    'regular-arrow-down-long': arrow_down_long_svg_1.ReactComponent,
    'regular-arrow-down-right': arrow_down_right_svg_1.ReactComponent,
    'regular-arrow-down-short-wide': arrow_down_short_wide_svg_1.ReactComponent,
    'regular-arrow-down-small-big': arrow_down_small_big_svg_1.ReactComponent,
    'regular-arrow-down-square-triangle': arrow_down_square_triangle_svg_1.ReactComponent,
    'regular-arrow-down-to-bracket': arrow_down_to_bracket_svg_1.ReactComponent,
    'regular-arrow-down-to-dotted-line': arrow_down_to_dotted_line_svg_1.ReactComponent,
    'regular-arrow-down-to-line': arrow_down_to_line_svg_1.ReactComponent,
    'regular-arrow-down-to-square': arrow_down_to_square_svg_1.ReactComponent,
    'regular-arrow-down-triangle-square': arrow_down_triangle_square_svg_1.ReactComponent,
    'regular-arrow-down-wide-short': arrow_down_wide_short_svg_1.ReactComponent,
    'regular-arrow-down-z-a': arrow_down_z_a_svg_1.ReactComponent,
    'regular-arrow-down': arrow_down_svg_1.ReactComponent,
    'regular-arrow-left-from-line': arrow_left_from_line_svg_1.ReactComponent,
    'regular-arrow-left-long': arrow_left_long_svg_1.ReactComponent,
    'regular-arrow-left-rotate': arrow_left_rotate_svg_1.ReactComponent,
    'regular-arrow-left-to-line': arrow_left_to_line_svg_1.ReactComponent,
    'regular-arrow-left': arrow_left_svg_1.ReactComponent,
    'regular-arrow-pointer': arrow_pointer_svg_1.ReactComponent,
    'regular-arrow-right-arrow-left': arrow_right_arrow_left_svg_1.ReactComponent,
    'regular-arrow-right-from-bracket': arrow_right_from_bracket_svg_1.ReactComponent,
    'regular-arrow-right-from-line': arrow_right_from_line_svg_1.ReactComponent,
    'regular-arrow-right-long': arrow_right_long_svg_1.ReactComponent,
    'regular-arrow-right-to-bracket': arrow_right_to_bracket_svg_1.ReactComponent,
    'regular-arrow-right-to-line': arrow_right_to_line_svg_1.ReactComponent,
    'regular-arrow-right': arrow_right_svg_1.ReactComponent,
    'regular-arrow-rotate-forward': arrow_rotate_forward_svg_1.ReactComponent,
    'regular-arrow-trend-down': arrow_trend_down_svg_1.ReactComponent,
    'regular-arrow-trend-up': arrow_trend_up_svg_1.ReactComponent,
    'regular-arrow-turn-down': arrow_turn_down_svg_1.ReactComponent,
    'regular-arrow-turn-up': arrow_turn_up_svg_1.ReactComponent,
    'regular-arrow-up-1-9': arrow_up_1_9_svg_1.ReactComponent,
    'regular-arrow-up-9-1': arrow_up_9_1_svg_1.ReactComponent,
    'regular-arrow-up-a-z': arrow_up_a_z_svg_1.ReactComponent,
    'regular-arrow-up-arrow-down': arrow_up_arrow_down_svg_1.ReactComponent,
    'regular-arrow-up-big-small': arrow_up_big_small_svg_1.ReactComponent,
    'regular-arrow-up-from-bracket': arrow_up_from_bracket_svg_1.ReactComponent,
    'regular-arrow-up-from-dotted-line': arrow_up_from_dotted_line_svg_1.ReactComponent,
    'regular-arrow-up-from-line': arrow_up_from_line_svg_1.ReactComponent,
    'regular-arrow-up-from-square': arrow_up_from_square_svg_1.ReactComponent,
    'regular-arrow-up-left-from-circle': arrow_up_left_from_circle_svg_1.ReactComponent,
    'regular-arrow-up-left': arrow_up_left_svg_1.ReactComponent,
    'regular-arrow-up-long': arrow_up_long_svg_1.ReactComponent,
    'regular-arrow-up-right-and-arrow-down-left-from-center': arrow_up_right_and_arrow_down_left_from_center_svg_1.ReactComponent,
    'regular-arrow-up-right-from-square': arrow_up_right_from_square_svg_1.ReactComponent,
    'regular-arrow-up-right': arrow_up_right_svg_1.ReactComponent,
    'regular-arrow-up-short-wide': arrow_up_short_wide_svg_1.ReactComponent,
    'regular-arrow-up-small-big': arrow_up_small_big_svg_1.ReactComponent,
    'regular-arrow-up-square-triangle': arrow_up_square_triangle_svg_1.ReactComponent,
    'regular-arrow-up-to-dotted-line': arrow_up_to_dotted_line_svg_1.ReactComponent,
    'regular-arrow-up-to-line': arrow_up_to_line_svg_1.ReactComponent,
    'regular-arrow-up-triangle-square': arrow_up_triangle_square_svg_1.ReactComponent,
    'regular-arrow-up-wide-short': arrow_up_wide_short_svg_1.ReactComponent,
    'regular-arrow-up-z-a': arrow_up_z_a_svg_1.ReactComponent,
    'regular-arrow-up': arrow_up_svg_1.ReactComponent,
    'regular-arrows-cross': arrows_cross_svg_1.ReactComponent,
    'regular-arrows-from-dotted-line': arrows_from_dotted_line_svg_1.ReactComponent,
    'regular-arrows-from-line': arrows_from_line_svg_1.ReactComponent,
    'regular-arrows-left-right': arrows_left_right_svg_1.ReactComponent,
    'regular-arrows-maximize': arrows_maximize_svg_1.ReactComponent,
    'regular-arrows-minimize': arrows_minimize_svg_1.ReactComponent,
    'regular-arrows-repeat-1': arrows_repeat_1_svg_1.ReactComponent,
    'regular-arrows-repeat': arrows_repeat_svg_1.ReactComponent,
    'regular-arrows-retweet': arrows_retweet_svg_1.ReactComponent,
    'regular-arrows-rotate': arrows_rotate_svg_1.ReactComponent,
    'regular-arrows-to-dotted-line': arrows_to_dotted_line_svg_1.ReactComponent,
    'regular-arrows-to-line': arrows_to_line_svg_1.ReactComponent,
    'regular-arrows-up-down-left-right': arrows_up_down_left_right_svg_1.ReactComponent,
    'regular-arrows-up-down': arrows_up_down_svg_1.ReactComponent,
    'regular-asterisk': asterisk_svg_1.ReactComponent,
    'regular-at': at_svg_1.ReactComponent,
    'regular-atom-simple': atom_simple_svg_1.ReactComponent,
    'regular-atom': atom_svg_1.ReactComponent,
    'regular-audio-description-slash': audio_description_slash_svg_1.ReactComponent,
    'regular-audio-description': audio_description_svg_1.ReactComponent,
    'regular-austral-sign': austral_sign_svg_1.ReactComponent,
    'regular-avocado': avocado_svg_1.ReactComponent,
    'regular-award-simple': award_simple_svg_1.ReactComponent,
    'regular-award': award_svg_1.ReactComponent,
    'regular-axe-battle': axe_battle_svg_1.ReactComponent,
    'regular-axe': axe_svg_1.ReactComponent,
    'regular-b': b_svg_1.ReactComponent,
    'regular-baby-carriage': baby_carriage_svg_1.ReactComponent,
    'regular-baby': baby_svg_1.ReactComponent,
    'regular-backpack': backpack_svg_1.ReactComponent,
    'regular-backward-fast': backward_fast_svg_1.ReactComponent,
    'regular-backward-step': backward_step_svg_1.ReactComponent,
    'regular-backward': backward_svg_1.ReactComponent,
    'regular-bacon': bacon_svg_1.ReactComponent,
    'regular-bacteria': bacteria_svg_1.ReactComponent,
    'regular-bacterium': bacterium_svg_1.ReactComponent,
    'regular-badge-check': badge_check_svg_1.ReactComponent,
    'regular-badge-dollar': badge_dollar_svg_1.ReactComponent,
    'regular-badge-percent': badge_percent_svg_1.ReactComponent,
    'regular-badge-sheriff': badge_sheriff_svg_1.ReactComponent,
    'regular-badge': badge_svg_1.ReactComponent,
    'regular-badger-honey': badger_honey_svg_1.ReactComponent,
    'regular-bag-shopping': bag_shopping_svg_1.ReactComponent,
    'regular-bags-shopping': bags_shopping_svg_1.ReactComponent,
    'regular-bahai': bahai_svg_1.ReactComponent,
    'regular-baht-sign': baht_sign_svg_1.ReactComponent,
    'regular-ball-pile': ball_pile_svg_1.ReactComponent,
    'regular-ballot-check': ballot_check_svg_1.ReactComponent,
    'regular-ballot': ballot_svg_1.ReactComponent,
    'regular-ban-bug': ban_bug_svg_1.ReactComponent,
    'regular-ban-parking': ban_parking_svg_1.ReactComponent,
    'regular-ban-smoking': ban_smoking_svg_1.ReactComponent,
    'regular-ban': ban_svg_1.ReactComponent,
    'regular-bandage': bandage_svg_1.ReactComponent,
    'regular-banjo': banjo_svg_1.ReactComponent,
    'regular-bank': bank_svg_1.ReactComponent,
    'regular-barcode-read': barcode_read_svg_1.ReactComponent,
    'regular-barcode-scan': barcode_scan_svg_1.ReactComponent,
    'regular-barcode': barcode_svg_1.ReactComponent,
    'regular-bars-filter': bars_filter_svg_1.ReactComponent,
    'regular-bars-progress': bars_progress_svg_1.ReactComponent,
    'regular-bars-sort': bars_sort_svg_1.ReactComponent,
    'regular-bars-staggered': bars_staggered_svg_1.ReactComponent,
    'regular-bars': bars_svg_1.ReactComponent,
    'regular-baseball-ball': baseball_ball_svg_1.ReactComponent,
    'regular-baseball-bat-ball': baseball_bat_ball_svg_1.ReactComponent,
    'regular-basket-shopping-simple': basket_shopping_simple_svg_1.ReactComponent,
    'regular-basket-shopping': basket_shopping_svg_1.ReactComponent,
    'regular-basketball-ball': basketball_ball_svg_1.ReactComponent,
    'regular-basketball-hoop': basketball_hoop_svg_1.ReactComponent,
    'regular-bat': bat_svg_1.ReactComponent,
    'regular-bath': bath_svg_1.ReactComponent,
    'regular-battery-bolt': battery_bolt_svg_1.ReactComponent,
    'regular-battery-empty': battery_empty_svg_1.ReactComponent,
    'regular-battery-exclamation': battery_exclamation_svg_1.ReactComponent,
    'regular-battery-full': battery_full_svg_1.ReactComponent,
    'regular-battery-half': battery_half_svg_1.ReactComponent,
    'regular-battery-low': battery_low_svg_1.ReactComponent,
    'regular-battery-quarter': battery_quarter_svg_1.ReactComponent,
    'regular-battery-slash': battery_slash_svg_1.ReactComponent,
    'regular-battery-three-quarters': battery_three_quarters_svg_1.ReactComponent,
    'regular-bed-bunk': bed_bunk_svg_1.ReactComponent,
    'regular-bed-empty': bed_empty_svg_1.ReactComponent,
    'regular-bed-front': bed_front_svg_1.ReactComponent,
    'regular-bed-pulse': bed_pulse_svg_1.ReactComponent,
    'regular-bed': bed_svg_1.ReactComponent,
    'regular-bee': bee_svg_1.ReactComponent,
    'regular-beer-mug-empty': beer_mug_empty_svg_1.ReactComponent,
    'regular-beer-mug': beer_mug_svg_1.ReactComponent,
    'regular-bell-concierge': bell_concierge_svg_1.ReactComponent,
    'regular-bell-exclamation': bell_exclamation_svg_1.ReactComponent,
    'regular-bell-on': bell_on_svg_1.ReactComponent,
    'regular-bell-plus': bell_plus_svg_1.ReactComponent,
    'regular-bell-school-slash': bell_school_slash_svg_1.ReactComponent,
    'regular-bell-school': bell_school_svg_1.ReactComponent,
    'regular-bell-slash': bell_slash_svg_1.ReactComponent,
    'regular-bell': bell_svg_1.ReactComponent,
    'regular-bells': bells_svg_1.ReactComponent,
    'regular-bezier-curve': bezier_curve_svg_1.ReactComponent,
    'regular-bicycle': bicycle_svg_1.ReactComponent,
    'regular-binoculars': binoculars_svg_1.ReactComponent,
    'regular-biohazard': biohazard_svg_1.ReactComponent,
    'regular-bitcoin-sign': bitcoin_sign_svg_1.ReactComponent,
    'regular-blanket': blanket_svg_1.ReactComponent,
    'regular-blender-phone': blender_phone_svg_1.ReactComponent,
    'regular-blender': blender_svg_1.ReactComponent,
    'regular-blinds-open': blinds_open_svg_1.ReactComponent,
    'regular-blinds-raised': blinds_raised_svg_1.ReactComponent,
    'regular-blinds': blinds_svg_1.ReactComponent,
    'regular-block-quote': block_quote_svg_1.ReactComponent,
    'regular-blog': blog_svg_1.ReactComponent,
    'regular-bluetooth': bluetooth_svg_2.ReactComponent,
    'regular-bold': bold_svg_1.ReactComponent,
    'regular-bolt-auto': bolt_auto_svg_1.ReactComponent,
    'regular-bolt-lightning': bolt_lightning_svg_1.ReactComponent,
    'regular-bolt-slash': bolt_slash_svg_1.ReactComponent,
    'regular-bolt': bolt_svg_1.ReactComponent,
    'regular-bomb': bomb_svg_1.ReactComponent,
    'regular-bone-break': bone_break_svg_1.ReactComponent,
    'regular-bone': bone_svg_1.ReactComponent,
    'regular-bong': bong_svg_1.ReactComponent,
    'regular-book-arrow-right': book_arrow_right_svg_1.ReactComponent,
    'regular-book-arrow-up': book_arrow_up_svg_1.ReactComponent,
    'regular-book-atlas': book_atlas_svg_1.ReactComponent,
    'regular-book-bible': book_bible_svg_1.ReactComponent,
    'regular-book-blank': book_blank_svg_1.ReactComponent,
    'regular-book-bookmark': book_bookmark_svg_1.ReactComponent,
    'regular-book-circle-arrow-right': book_circle_arrow_right_svg_1.ReactComponent,
    'regular-book-circle-arrow-up': book_circle_arrow_up_svg_1.ReactComponent,
    'regular-book-copy': book_copy_svg_1.ReactComponent,
    'regular-book-font': book_font_svg_1.ReactComponent,
    'regular-book-heart': book_heart_svg_1.ReactComponent,
    'regular-book-journal-whills': book_journal_whills_svg_1.ReactComponent,
    'regular-book-law': book_law_svg_1.ReactComponent,
    'regular-book-medical': book_medical_svg_1.ReactComponent,
    'regular-book-open-cover': book_open_cover_svg_1.ReactComponent,
    'regular-book-open-reader': book_open_reader_svg_1.ReactComponent,
    'regular-book-open': book_open_svg_1.ReactComponent,
    'regular-book-quran': book_quran_svg_1.ReactComponent,
    'regular-book-section': book_section_svg_1.ReactComponent,
    'regular-book-skull': book_skull_svg_1.ReactComponent,
    'regular-book-sparkles': book_sparkles_svg_1.ReactComponent,
    'regular-book-tanakh': book_tanakh_svg_1.ReactComponent,
    'regular-book-user': book_user_svg_1.ReactComponent,
    'regular-book': book_svg_1.ReactComponent,
    'regular-bookmark-slash': bookmark_slash_svg_1.ReactComponent,
    'regular-bookmark': bookmark_svg_1.ReactComponent,
    'regular-books-medical': books_medical_svg_1.ReactComponent,
    'regular-books': books_svg_1.ReactComponent,
    'regular-boombox': boombox_svg_1.ReactComponent,
    'regular-boot': boot_svg_1.ReactComponent,
    'regular-booth-curtain': booth_curtain_svg_1.ReactComponent,
    'regular-border-all': border_all_svg_1.ReactComponent,
    'regular-border-bottom-right': border_bottom_right_svg_1.ReactComponent,
    'regular-border-bottom': border_bottom_svg_1.ReactComponent,
    'regular-border-center-h': border_center_h_svg_1.ReactComponent,
    'regular-border-center-v': border_center_v_svg_1.ReactComponent,
    'regular-border-inner': border_inner_svg_1.ReactComponent,
    'regular-border-left': border_left_svg_1.ReactComponent,
    'regular-border-none': border_none_svg_1.ReactComponent,
    'regular-border-outer': border_outer_svg_1.ReactComponent,
    'regular-border-right': border_right_svg_1.ReactComponent,
    'regular-border-top-left': border_top_left_svg_1.ReactComponent,
    'regular-border-top': border_top_svg_1.ReactComponent,
    'regular-bow-arrow': bow_arrow_svg_1.ReactComponent,
    'regular-bowl-hot': bowl_hot_svg_1.ReactComponent,
    'regular-bowling-ball-pin': bowling_ball_pin_svg_1.ReactComponent,
    'regular-bowling-ball': bowling_ball_svg_1.ReactComponent,
    'regular-bowling-pins': bowling_pins_svg_1.ReactComponent,
    'regular-box-archive': box_archive_svg_1.ReactComponent,
    'regular-box-ballot': box_ballot_svg_1.ReactComponent,
    'regular-box-check': box_check_svg_1.ReactComponent,
    'regular-box-circle-check': box_circle_check_svg_1.ReactComponent,
    'regular-box-dollar': box_dollar_svg_1.ReactComponent,
    'regular-box-heart': box_heart_svg_1.ReactComponent,
    'regular-box-open-full': box_open_full_svg_1.ReactComponent,
    'regular-box-open': box_open_svg_1.ReactComponent,
    'regular-box-taped': box_taped_svg_1.ReactComponent,
    'regular-box-tissue': box_tissue_svg_1.ReactComponent,
    'regular-box': box_svg_1.ReactComponent,
    'regular-boxes-stacked': boxes_stacked_svg_1.ReactComponent,
    'regular-boxing-glove': boxing_glove_svg_1.ReactComponent,
    'regular-bracket-curly-right': bracket_curly_right_svg_1.ReactComponent,
    'regular-bracket-curly': bracket_curly_svg_1.ReactComponent,
    'regular-bracket-round-right': bracket_round_right_svg_1.ReactComponent,
    'regular-bracket-round': bracket_round_svg_1.ReactComponent,
    'regular-bracket-square-right': bracket_square_right_svg_1.ReactComponent,
    'regular-bracket-square': bracket_square_svg_1.ReactComponent,
    'regular-brackets-curly': brackets_curly_svg_1.ReactComponent,
    'regular-brackets-round': brackets_round_svg_1.ReactComponent,
    'regular-brackets-square': brackets_square_svg_1.ReactComponent,
    'regular-braille': braille_svg_1.ReactComponent,
    'regular-brain-arrow-curved-right': brain_arrow_curved_right_svg_1.ReactComponent,
    'regular-brain-circuit': brain_circuit_svg_1.ReactComponent,
    'regular-brain': brain_svg_1.ReactComponent,
    'regular-brake-warning': brake_warning_svg_1.ReactComponent,
    'regular-bread-loaf': bread_loaf_svg_1.ReactComponent,
    'regular-bread-slice': bread_slice_svg_1.ReactComponent,
    'regular-briefcase-arrow-right': briefcase_arrow_right_svg_1.ReactComponent,
    'regular-briefcase-clock': briefcase_clock_svg_1.ReactComponent,
    'regular-briefcase-medical': briefcase_medical_svg_1.ReactComponent,
    'regular-briefcase': briefcase_svg_1.ReactComponent,
    'regular-bring-forward': bring_forward_svg_1.ReactComponent,
    'regular-bring-front': bring_front_svg_1.ReactComponent,
    'regular-broom': broom_svg_1.ReactComponent,
    'regular-browser': browser_svg_1.ReactComponent,
    'regular-browsers': browsers_svg_1.ReactComponent,
    'regular-brush': brush_svg_1.ReactComponent,
    'regular-bug': bug_svg_1.ReactComponent,
    'regular-building': building_svg_1.ReactComponent,
    'regular-buildings': buildings_svg_1.ReactComponent,
    'regular-bullhorn': bullhorn_svg_1.ReactComponent,
    'regular-bullseye-arrow': bullseye_arrow_svg_1.ReactComponent,
    'regular-bullseye-pointer': bullseye_pointer_svg_1.ReactComponent,
    'regular-bullseye': bullseye_svg_1.ReactComponent,
    'regular-burger-cheese': burger_cheese_svg_1.ReactComponent,
    'regular-burger-fries': burger_fries_svg_1.ReactComponent,
    'regular-burger-glass': burger_glass_svg_1.ReactComponent,
    'regular-burger-soda': burger_soda_svg_1.ReactComponent,
    'regular-burger': burger_svg_1.ReactComponent,
    'regular-burrito': burrito_svg_1.ReactComponent,
    'regular-bus-school': bus_school_svg_1.ReactComponent,
    'regular-bus-simple': bus_simple_svg_1.ReactComponent,
    'regular-bus': bus_svg_1.ReactComponent,
    'regular-c': c_svg_1.ReactComponent,
    'regular-cabinet-filing': cabinet_filing_svg_1.ReactComponent,
    'regular-cable-car': cable_car_svg_1.ReactComponent,
    'regular-cactus': cactus_svg_1.ReactComponent,
    'regular-cake-candles': cake_candles_svg_1.ReactComponent,
    'regular-calculator-simple': calculator_simple_svg_1.ReactComponent,
    'regular-calculator': calculator_svg_1.ReactComponent,
    'regular-calendar-arrow-down': calendar_arrow_down_svg_1.ReactComponent,
    'regular-calendar-arrow-up': calendar_arrow_up_svg_1.ReactComponent,
    'regular-calendar-check': calendar_check_svg_1.ReactComponent,
    'regular-calendar-clock': calendar_clock_svg_1.ReactComponent,
    'regular-calendar-day': calendar_day_svg_1.ReactComponent,
    'regular-calendar-days': calendar_days_svg_1.ReactComponent,
    'regular-calendar-exclamation': calendar_exclamation_svg_1.ReactComponent,
    'regular-calendar-heart': calendar_heart_svg_1.ReactComponent,
    'regular-calendar-image': calendar_image_svg_1.ReactComponent,
    'regular-calendar-lines': calendar_lines_svg_1.ReactComponent,
    'regular-calendar-minus': calendar_minus_svg_1.ReactComponent,
    'regular-calendar-pen': calendar_pen_svg_1.ReactComponent,
    'regular-calendar-plus': calendar_plus_svg_1.ReactComponent,
    'regular-calendar-range': calendar_range_svg_1.ReactComponent,
    'regular-calendar-star': calendar_star_svg_1.ReactComponent,
    'regular-calendar-week': calendar_week_svg_1.ReactComponent,
    'regular-calendar-xmark': calendar_xmark_svg_1.ReactComponent,
    'regular-calendar': calendar_svg_1.ReactComponent,
    'regular-calendars': calendars_svg_1.ReactComponent,
    'regular-camcorder': camcorder_svg_1.ReactComponent,
    'regular-camera-cctv': camera_cctv_svg_1.ReactComponent,
    'regular-camera-movie': camera_movie_svg_1.ReactComponent,
    'regular-camera-polaroid': camera_polaroid_svg_1.ReactComponent,
    'regular-camera-retro': camera_retro_svg_1.ReactComponent,
    'regular-camera-rotate': camera_rotate_svg_1.ReactComponent,
    'regular-camera-security': camera_security_svg_1.ReactComponent,
    'regular-camera-slash': camera_slash_svg_1.ReactComponent,
    'regular-camera-viewfinder': camera_viewfinder_svg_1.ReactComponent,
    'regular-camera-web-slash': camera_web_slash_svg_1.ReactComponent,
    'regular-camera-web': camera_web_svg_1.ReactComponent,
    'regular-camera': camera_svg_1.ReactComponent,
    'regular-campfire': campfire_svg_1.ReactComponent,
    'regular-campground': campground_svg_1.ReactComponent,
    'regular-candle-holder': candle_holder_svg_1.ReactComponent,
    'regular-candy-cane': candy_cane_svg_1.ReactComponent,
    'regular-candy-corn': candy_corn_svg_1.ReactComponent,
    'regular-cannabis': cannabis_svg_1.ReactComponent,
    'regular-capsules': capsules_svg_1.ReactComponent,
    'regular-car-battery': car_battery_svg_1.ReactComponent,
    'regular-car-building': car_building_svg_1.ReactComponent,
    'regular-car-bump': car_bump_svg_1.ReactComponent,
    'regular-car-bus': car_bus_svg_1.ReactComponent,
    'regular-car-crash': car_crash_svg_1.ReactComponent,
    'regular-car-garage': car_garage_svg_1.ReactComponent,
    'regular-car-rear': car_rear_svg_1.ReactComponent,
    'regular-car-side': car_side_svg_1.ReactComponent,
    'regular-car-tilt': car_tilt_svg_1.ReactComponent,
    'regular-car-wash': car_wash_svg_1.ReactComponent,
    'regular-car-wrench': car_wrench_svg_1.ReactComponent,
    'regular-car': car_svg_1.ReactComponent,
    'regular-caravan-simple': caravan_simple_svg_1.ReactComponent,
    'regular-caravan': caravan_svg_1.ReactComponent,
    'regular-caret-down': caret_down_svg_1.ReactComponent,
    'regular-caret-left': caret_left_svg_1.ReactComponent,
    'regular-caret-right': caret_right_svg_1.ReactComponent,
    'regular-caret-up': caret_up_svg_1.ReactComponent,
    'regular-carrot': carrot_svg_1.ReactComponent,
    'regular-cars': cars_svg_1.ReactComponent,
    'regular-cart-arrow-down': cart_arrow_down_svg_1.ReactComponent,
    'regular-cart-flatbed-boxes': cart_flatbed_boxes_svg_1.ReactComponent,
    'regular-cart-flatbed-empty': cart_flatbed_empty_svg_1.ReactComponent,
    'regular-cart-flatbed-suitcase': cart_flatbed_suitcase_svg_1.ReactComponent,
    'regular-cart-flatbed': cart_flatbed_svg_1.ReactComponent,
    'regular-cart-plus': cart_plus_svg_1.ReactComponent,
    'regular-cart-shopping-fast': cart_shopping_fast_svg_1.ReactComponent,
    'regular-cart-shopping': cart_shopping_svg_1.ReactComponent,
    'regular-casette-betamax': casette_betamax_svg_1.ReactComponent,
    'regular-casette-vhs': casette_vhs_svg_1.ReactComponent,
    'regular-cash-register': cash_register_svg_1.ReactComponent,
    'regular-cassette-tape': cassette_tape_svg_1.ReactComponent,
    'regular-castle': castle_svg_1.ReactComponent,
    'regular-cat-space': cat_space_svg_1.ReactComponent,
    'regular-cat': cat_svg_1.ReactComponent,
    'regular-cauldron': cauldron_svg_1.ReactComponent,
    'regular-cedi-sign': cedi_sign_svg_1.ReactComponent,
    'regular-cent-sign': cent_sign_svg_1.ReactComponent,
    'regular-certificate': certificate_svg_1.ReactComponent,
    'regular-chair-office': chair_office_svg_1.ReactComponent,
    'regular-chair': chair_svg_1.ReactComponent,
    'regular-chalkboard-user': chalkboard_user_svg_1.ReactComponent,
    'regular-chalkboard': chalkboard_svg_1.ReactComponent,
    'regular-champagne-glass': champagne_glass_svg_1.ReactComponent,
    'regular-champagne-glasses': champagne_glasses_svg_1.ReactComponent,
    'regular-charging-station': charging_station_svg_1.ReactComponent,
    'regular-chart-area': chart_area_svg_1.ReactComponent,
    'regular-chart-bar': chart_bar_svg_1.ReactComponent,
    'regular-chart-bullet': chart_bullet_svg_1.ReactComponent,
    'regular-chart-candlestick': chart_candlestick_svg_1.ReactComponent,
    'regular-chart-column': chart_column_svg_1.ReactComponent,
    'regular-chart-gantt': chart_gantt_svg_1.ReactComponent,
    'regular-chart-line-down': chart_line_down_svg_1.ReactComponent,
    'regular-chart-line-up': chart_line_up_svg_1.ReactComponent,
    'regular-chart-line': chart_line_svg_1.ReactComponent,
    'regular-chart-mixed': chart_mixed_svg_1.ReactComponent,
    'regular-chart-network': chart_network_svg_1.ReactComponent,
    'regular-chart-pie-simple': chart_pie_simple_svg_1.ReactComponent,
    'regular-chart-pie': chart_pie_svg_1.ReactComponent,
    'regular-chart-pyramid': chart_pyramid_svg_1.ReactComponent,
    'regular-chart-radar': chart_radar_svg_1.ReactComponent,
    'regular-chart-scatter-3d': chart_scatter_3d_svg_1.ReactComponent,
    'regular-chart-scatter-bubble': chart_scatter_bubble_svg_1.ReactComponent,
    'regular-chart-scatter': chart_scatter_svg_1.ReactComponent,
    'regular-chart-tree-map': chart_tree_map_svg_1.ReactComponent,
    'regular-chart-user': chart_user_svg_1.ReactComponent,
    'regular-chart-waterfall': chart_waterfall_svg_1.ReactComponent,
    'regular-check-double': check_double_svg_1.ReactComponent,
    'regular-check-to-slot': check_to_slot_svg_1.ReactComponent,
    'regular-check': check_svg_1.ReactComponent,
    'regular-cheese-swiss': cheese_swiss_svg_1.ReactComponent,
    'regular-cheese': cheese_svg_1.ReactComponent,
    'regular-cherries': cherries_svg_1.ReactComponent,
    'regular-chess-bishop-piece': chess_bishop_piece_svg_1.ReactComponent,
    'regular-chess-bishop': chess_bishop_svg_1.ReactComponent,
    'regular-chess-board': chess_board_svg_1.ReactComponent,
    'regular-chess-clock-flip': chess_clock_flip_svg_1.ReactComponent,
    'regular-chess-clock': chess_clock_svg_1.ReactComponent,
    'regular-chess-king-piece': chess_king_piece_svg_1.ReactComponent,
    'regular-chess-king': chess_king_svg_1.ReactComponent,
    'regular-chess-knight-piece': chess_knight_piece_svg_1.ReactComponent,
    'regular-chess-knight': chess_knight_svg_1.ReactComponent,
    'regular-chess-pawn-piece': chess_pawn_piece_svg_1.ReactComponent,
    'regular-chess-pawn': chess_pawn_svg_1.ReactComponent,
    'regular-chess-queen-piece': chess_queen_piece_svg_1.ReactComponent,
    'regular-chess-queen': chess_queen_svg_1.ReactComponent,
    'regular-chess-rook-piece': chess_rook_piece_svg_1.ReactComponent,
    'regular-chess-rook': chess_rook_svg_1.ReactComponent,
    'regular-chess': chess_svg_1.ReactComponent,
    'regular-chevron-down': chevron_down_svg_1.ReactComponent,
    'regular-chevron-left': chevron_left_svg_1.ReactComponent,
    'regular-chevron-right': chevron_right_svg_1.ReactComponent,
    'regular-chevron-up': chevron_up_svg_1.ReactComponent,
    'regular-chevrons-down': chevrons_down_svg_1.ReactComponent,
    'regular-chevrons-left': chevrons_left_svg_1.ReactComponent,
    'regular-chevrons-right': chevrons_right_svg_1.ReactComponent,
    'regular-chevrons-up': chevrons_up_svg_1.ReactComponent,
    'regular-child': child_svg_1.ReactComponent,
    'regular-chimney': chimney_svg_1.ReactComponent,
    'regular-church': church_svg_1.ReactComponent,
    'regular-circle-0': circle_0_svg_1.ReactComponent,
    'regular-circle-1': circle_1_svg_1.ReactComponent,
    'regular-circle-2': circle_2_svg_1.ReactComponent,
    'regular-circle-3': circle_3_svg_1.ReactComponent,
    'regular-circle-4': circle_4_svg_1.ReactComponent,
    'regular-circle-5': circle_5_svg_1.ReactComponent,
    'regular-circle-6': circle_6_svg_1.ReactComponent,
    'regular-circle-7': circle_7_svg_1.ReactComponent,
    'regular-circle-8': circle_8_svg_1.ReactComponent,
    'regular-circle-9': circle_9_svg_1.ReactComponent,
    'regular-circle-a': circle_a_svg_1.ReactComponent,
    'regular-circle-ampersand': circle_ampersand_svg_1.ReactComponent,
    'regular-circle-arrow-down-left': circle_arrow_down_left_svg_1.ReactComponent,
    'regular-circle-arrow-down-right': circle_arrow_down_right_svg_1.ReactComponent,
    'regular-circle-arrow-down': circle_arrow_down_svg_1.ReactComponent,
    'regular-circle-arrow-left': circle_arrow_left_svg_1.ReactComponent,
    'regular-circle-arrow-right': circle_arrow_right_svg_1.ReactComponent,
    'regular-circle-arrow-up-left': circle_arrow_up_left_svg_1.ReactComponent,
    'regular-circle-arrow-up-right': circle_arrow_up_right_svg_1.ReactComponent,
    'regular-circle-arrow-up': circle_arrow_up_svg_1.ReactComponent,
    'regular-circle-b': circle_b_svg_1.ReactComponent,
    'regular-circle-bolt': circle_bolt_svg_1.ReactComponent,
    'regular-circle-book-open': circle_book_open_svg_1.ReactComponent,
    'regular-circle-bookmark': circle_bookmark_svg_1.ReactComponent,
    'regular-circle-c': circle_c_svg_1.ReactComponent,
    'regular-circle-calendar': circle_calendar_svg_1.ReactComponent,
    'regular-circle-camera': circle_camera_svg_1.ReactComponent,
    'regular-circle-caret-down': circle_caret_down_svg_1.ReactComponent,
    'regular-circle-caret-left': circle_caret_left_svg_1.ReactComponent,
    'regular-circle-caret-right': circle_caret_right_svg_1.ReactComponent,
    'regular-circle-caret-up': circle_caret_up_svg_1.ReactComponent,
    'regular-circle-check': circle_check_svg_1.ReactComponent,
    'regular-circle-chevron-down': circle_chevron_down_svg_1.ReactComponent,
    'regular-circle-chevron-left': circle_chevron_left_svg_1.ReactComponent,
    'regular-circle-chevron-right': circle_chevron_right_svg_1.ReactComponent,
    'regular-circle-chevron-up': circle_chevron_up_svg_1.ReactComponent,
    'regular-circle-d': circle_d_svg_1.ReactComponent,
    'regular-circle-dashed': circle_dashed_svg_1.ReactComponent,
    'regular-circle-divide': circle_divide_svg_1.ReactComponent,
    'regular-circle-dollar-to-slot': circle_dollar_to_slot_svg_1.ReactComponent,
    'regular-circle-dollar': circle_dollar_svg_1.ReactComponent,
    'regular-circle-dot': circle_dot_svg_1.ReactComponent,
    'regular-circle-down-left': circle_down_left_svg_1.ReactComponent,
    'regular-circle-down-right': circle_down_right_svg_1.ReactComponent,
    'regular-circle-down': circle_down_svg_1.ReactComponent,
    'regular-circle-e': circle_e_svg_1.ReactComponent,
    'regular-circle-envelope': circle_envelope_svg_1.ReactComponent,
    'regular-circle-exclamation-check': circle_exclamation_check_svg_1.ReactComponent,
    'regular-circle-exclamation': circle_exclamation_svg_1.ReactComponent,
    'regular-circle-f': circle_f_svg_1.ReactComponent,
    'regular-circle-g': circle_g_svg_1.ReactComponent,
    'regular-circle-h': circle_h_svg_1.ReactComponent,
    'regular-circle-half-stroke': circle_half_stroke_svg_1.ReactComponent,
    'regular-circle-half': circle_half_svg_1.ReactComponent,
    'regular-circle-heart': circle_heart_svg_1.ReactComponent,
    'regular-circle-i': circle_i_svg_1.ReactComponent,
    'regular-circle-info': circle_info_svg_1.ReactComponent,
    'regular-circle-j': circle_j_svg_1.ReactComponent,
    'regular-circle-k': circle_k_svg_1.ReactComponent,
    'regular-circle-l': circle_l_svg_1.ReactComponent,
    'regular-circle-left': circle_left_svg_1.ReactComponent,
    'regular-circle-location-arrow': circle_location_arrow_svg_1.ReactComponent,
    'regular-circle-m': circle_m_svg_1.ReactComponent,
    'regular-circle-microphone-lines': circle_microphone_lines_svg_1.ReactComponent,
    'regular-circle-microphone': circle_microphone_svg_1.ReactComponent,
    'regular-circle-minus': circle_minus_svg_1.ReactComponent,
    'regular-circle-n': circle_n_svg_1.ReactComponent,
    'regular-circle-notch': circle_notch_svg_1.ReactComponent,
    'regular-circle-o': circle_o_svg_1.ReactComponent,
    'regular-circle-p': circle_p_svg_1.ReactComponent,
    'regular-circle-parking': circle_parking_svg_1.ReactComponent,
    'regular-circle-pause': circle_pause_svg_1.ReactComponent,
    'regular-circle-phone-flip': circle_phone_flip_svg_1.ReactComponent,
    'regular-circle-phone-hangup': circle_phone_hangup_svg_1.ReactComponent,
    'regular-circle-phone': circle_phone_svg_1.ReactComponent,
    'regular-circle-play': circle_play_svg_1.ReactComponent,
    'regular-circle-plus': circle_plus_svg_1.ReactComponent,
    'regular-circle-q': circle_q_svg_1.ReactComponent,
    'regular-circle-quarter': circle_quarter_svg_1.ReactComponent,
    'regular-circle-question': circle_question_svg_1.ReactComponent,
    'regular-circle-r': circle_r_svg_1.ReactComponent,
    'regular-circle-radiation': circle_radiation_svg_1.ReactComponent,
    'regular-circle-right': circle_right_svg_1.ReactComponent,
    'regular-circle-s': circle_s_svg_1.ReactComponent,
    'regular-circle-small': circle_small_svg_1.ReactComponent,
    'regular-circle-sort-down': circle_sort_down_svg_1.ReactComponent,
    'regular-circle-sort-up': circle_sort_up_svg_1.ReactComponent,
    'regular-circle-sort': circle_sort_svg_1.ReactComponent,
    'regular-circle-star': circle_star_svg_1.ReactComponent,
    'regular-circle-stop': circle_stop_svg_1.ReactComponent,
    'regular-circle-t': circle_t_svg_1.ReactComponent,
    'regular-circle-three-quarters': circle_three_quarters_svg_1.ReactComponent,
    'regular-circle-trash': circle_trash_svg_1.ReactComponent,
    'regular-circle-u': circle_u_svg_1.ReactComponent,
    'regular-circle-up-left': circle_up_left_svg_1.ReactComponent,
    'regular-circle-up-right': circle_up_right_svg_1.ReactComponent,
    'regular-circle-up': circle_up_svg_1.ReactComponent,
    'regular-circle-user': circle_user_svg_1.ReactComponent,
    'regular-circle-v': circle_v_svg_1.ReactComponent,
    'regular-circle-video': circle_video_svg_1.ReactComponent,
    'regular-circle-w': circle_w_svg_1.ReactComponent,
    'regular-circle-waveform-lines': circle_waveform_lines_svg_1.ReactComponent,
    'regular-circle-x': circle_x_svg_1.ReactComponent,
    'regular-circle-xmark': circle_xmark_svg_1.ReactComponent,
    'regular-circle-y': circle_y_svg_1.ReactComponent,
    'regular-circle-z': circle_z_svg_1.ReactComponent,
    'regular-circle': circle_svg_1.ReactComponent,
    'regular-city': city_svg_1.ReactComponent,
    'regular-clapperboard-play': clapperboard_play_svg_1.ReactComponent,
    'regular-clapperboard': clapperboard_svg_1.ReactComponent,
    'regular-clarinet': clarinet_svg_1.ReactComponent,
    'regular-claw-marks': claw_marks_svg_1.ReactComponent,
    'regular-clipboard-check': clipboard_check_svg_1.ReactComponent,
    'regular-clipboard-list-check': clipboard_list_check_svg_1.ReactComponent,
    'regular-clipboard-list': clipboard_list_svg_1.ReactComponent,
    'regular-clipboard-medical': clipboard_medical_svg_1.ReactComponent,
    'regular-clipboard-prescription': clipboard_prescription_svg_1.ReactComponent,
    'regular-clipboard-user': clipboard_user_svg_1.ReactComponent,
    'regular-clipboard': clipboard_svg_1.ReactComponent,
    'regular-clock-desk': clock_desk_svg_1.ReactComponent,
    'regular-clock-rotate-left': clock_rotate_left_svg_1.ReactComponent,
    'regular-clock': clock_svg_1.ReactComponent,
    'regular-clone': clone_svg_1.ReactComponent,
    'regular-closed-captioning-slash': closed_captioning_slash_svg_1.ReactComponent,
    'regular-closed-captioning': closed_captioning_svg_1.ReactComponent,
    'regular-clothes-hanger': clothes_hanger_svg_1.ReactComponent,
    'regular-cloud-arrow-down': cloud_arrow_down_svg_1.ReactComponent,
    'regular-cloud-arrow-up': cloud_arrow_up_svg_1.ReactComponent,
    'regular-cloud-bolt-moon': cloud_bolt_moon_svg_1.ReactComponent,
    'regular-cloud-bolt-sun': cloud_bolt_sun_svg_1.ReactComponent,
    'regular-cloud-bolt': cloud_bolt_svg_1.ReactComponent,
    'regular-cloud-drizzle': cloud_drizzle_svg_1.ReactComponent,
    'regular-cloud-fog': cloud_fog_svg_1.ReactComponent,
    'regular-cloud-hail-mixed': cloud_hail_mixed_svg_1.ReactComponent,
    'regular-cloud-hail': cloud_hail_svg_1.ReactComponent,
    'regular-cloud-meatball': cloud_meatball_svg_1.ReactComponent,
    'regular-cloud-moon-rain': cloud_moon_rain_svg_1.ReactComponent,
    'regular-cloud-moon': cloud_moon_svg_1.ReactComponent,
    'regular-cloud-music': cloud_music_svg_1.ReactComponent,
    'regular-cloud-rain': cloud_rain_svg_1.ReactComponent,
    'regular-cloud-rainbow': cloud_rainbow_svg_1.ReactComponent,
    'regular-cloud-showers-heavy': cloud_showers_heavy_svg_1.ReactComponent,
    'regular-cloud-showers': cloud_showers_svg_1.ReactComponent,
    'regular-cloud-slash': cloud_slash_svg_1.ReactComponent,
    'regular-cloud-sleet': cloud_sleet_svg_1.ReactComponent,
    'regular-cloud-snow': cloud_snow_svg_1.ReactComponent,
    'regular-cloud-sun-rain': cloud_sun_rain_svg_1.ReactComponent,
    'regular-cloud-sun': cloud_sun_svg_1.ReactComponent,
    'regular-cloud-word': cloud_word_svg_1.ReactComponent,
    'regular-cloud': cloud_svg_1.ReactComponent,
    'regular-clouds-moon': clouds_moon_svg_1.ReactComponent,
    'regular-clouds-sun': clouds_sun_svg_1.ReactComponent,
    'regular-clouds': clouds_svg_1.ReactComponent,
    'regular-clover': clover_svg_1.ReactComponent,
    'regular-club': club_svg_1.ReactComponent,
    'regular-code-branch': code_branch_svg_1.ReactComponent,
    'regular-code-commit': code_commit_svg_1.ReactComponent,
    'regular-code-compare': code_compare_svg_1.ReactComponent,
    'regular-code-fork': code_fork_svg_1.ReactComponent,
    'regular-code-merge': code_merge_svg_1.ReactComponent,
    'regular-code-pull-request': code_pull_request_svg_1.ReactComponent,
    'regular-code-simple': code_simple_svg_1.ReactComponent,
    'regular-code': code_svg_1.ReactComponent,
    'regular-coffee-bean': coffee_bean_svg_1.ReactComponent,
    'regular-coffee-beans': coffee_beans_svg_1.ReactComponent,
    'regular-coffee-pot': coffee_pot_svg_1.ReactComponent,
    'regular-coffin-cross': coffin_cross_svg_1.ReactComponent,
    'regular-coffin': coffin_svg_1.ReactComponent,
    'regular-coin': coin_svg_1.ReactComponent,
    'regular-coins': coins_svg_1.ReactComponent,
    'regular-colon-sign': colon_sign_svg_1.ReactComponent,
    'regular-comet': comet_svg_1.ReactComponent,
    'regular-command': command_svg_1.ReactComponent,
    'regular-comment-arrow-down': comment_arrow_down_svg_1.ReactComponent,
    'regular-comment-arrow-up-right': comment_arrow_up_right_svg_1.ReactComponent,
    'regular-comment-arrow-up': comment_arrow_up_svg_1.ReactComponent,
    'regular-comment-captions': comment_captions_svg_1.ReactComponent,
    'regular-comment-check': comment_check_svg_1.ReactComponent,
    'regular-comment-code': comment_code_svg_1.ReactComponent,
    'regular-comment-dollar': comment_dollar_svg_1.ReactComponent,
    'regular-comment-dots': comment_dots_svg_1.ReactComponent,
    'regular-comment-exclamation': comment_exclamation_svg_1.ReactComponent,
    'regular-comment-image': comment_image_svg_1.ReactComponent,
    'regular-comment-lines': comment_lines_svg_1.ReactComponent,
    'regular-comment-medical': comment_medical_svg_1.ReactComponent,
    'regular-comment-middle-top': comment_middle_top_svg_1.ReactComponent,
    'regular-comment-middle': comment_middle_svg_1.ReactComponent,
    'regular-comment-minus': comment_minus_svg_1.ReactComponent,
    'regular-comment-music': comment_music_svg_1.ReactComponent,
    'regular-comment-pen': comment_pen_svg_1.ReactComponent,
    'regular-comment-plus': comment_plus_svg_1.ReactComponent,
    'regular-comment-question': comment_question_svg_1.ReactComponent,
    'regular-comment-quote': comment_quote_svg_1.ReactComponent,
    'regular-comment-slash': comment_slash_svg_1.ReactComponent,
    'regular-comment-smile': comment_smile_svg_1.ReactComponent,
    'regular-comment-sms': comment_sms_svg_1.ReactComponent,
    'regular-comment-text': comment_text_svg_1.ReactComponent,
    'regular-comment-xmark': comment_xmark_svg_1.ReactComponent,
    'regular-comment': comment_svg_1.ReactComponent,
    'regular-comments-dollar': comments_dollar_svg_1.ReactComponent,
    'regular-comments-question-check': comments_question_check_svg_1.ReactComponent,
    'regular-comments-question': comments_question_svg_1.ReactComponent,
    'regular-comments': comments_svg_1.ReactComponent,
    'regular-compact-disc': compact_disc_svg_1.ReactComponent,
    'regular-compass-drafting': compass_drafting_svg_1.ReactComponent,
    'regular-compass-slash': compass_slash_svg_1.ReactComponent,
    'regular-compass': compass_svg_1.ReactComponent,
    'regular-compress-wide': compress_wide_svg_1.ReactComponent,
    'regular-compress': compress_svg_1.ReactComponent,
    'regular-computer-classic': computer_classic_svg_1.ReactComponent,
    'regular-computer-mouse-scrollwheel': computer_mouse_scrollwheel_svg_1.ReactComponent,
    'regular-computer-mouse': computer_mouse_svg_1.ReactComponent,
    'regular-computer-speaker': computer_speaker_svg_1.ReactComponent,
    'regular-container-storage': container_storage_svg_1.ReactComponent,
    'regular-conveyor-belt-boxes': conveyor_belt_boxes_svg_1.ReactComponent,
    'regular-conveyor-belt-empty': conveyor_belt_empty_svg_1.ReactComponent,
    'regular-conveyor-belt': conveyor_belt_svg_1.ReactComponent,
    'regular-cookie-bite': cookie_bite_svg_1.ReactComponent,
    'regular-cookie': cookie_svg_1.ReactComponent,
    'regular-copy': copy_svg_1.ReactComponent,
    'regular-copyright': copyright_svg_1.ReactComponent,
    'regular-corn': corn_svg_1.ReactComponent,
    'regular-couch': couch_svg_1.ReactComponent,
    'regular-cow': cow_svg_1.ReactComponent,
    'regular-cowbell-circle-plus': cowbell_circle_plus_svg_1.ReactComponent,
    'regular-cowbell': cowbell_svg_1.ReactComponent,
    'regular-credit-card-blank': credit_card_blank_svg_1.ReactComponent,
    'regular-credit-card-front': credit_card_front_svg_1.ReactComponent,
    'regular-credit-card': credit_card_svg_1.ReactComponent,
    'regular-cricket-bat-ball': cricket_bat_ball_svg_1.ReactComponent,
    'regular-croissant': croissant_svg_1.ReactComponent,
    'regular-crop-simple': crop_simple_svg_1.ReactComponent,
    'regular-crop': crop_svg_1.ReactComponent,
    'regular-cross': cross_svg_1.ReactComponent,
    'regular-crosshairs': crosshairs_svg_1.ReactComponent,
    'regular-crow': crow_svg_1.ReactComponent,
    'regular-crown': crown_svg_1.ReactComponent,
    'regular-crutch': crutch_svg_1.ReactComponent,
    'regular-crutches': crutches_svg_1.ReactComponent,
    'regular-cruzeiro-sign': cruzeiro_sign_svg_1.ReactComponent,
    'regular-cube': cube_svg_1.ReactComponent,
    'regular-cubes': cubes_svg_1.ReactComponent,
    'regular-cup-togo': cup_togo_svg_1.ReactComponent,
    'regular-curling-stone': curling_stone_svg_1.ReactComponent,
    'regular-d': d_svg_1.ReactComponent,
    'regular-dagger': dagger_svg_1.ReactComponent,
    'regular-database': database_svg_1.ReactComponent,
    'regular-deer-rudolph': deer_rudolph_svg_1.ReactComponent,
    'regular-deer': deer_svg_1.ReactComponent,
    'regular-delete-left': delete_left_svg_1.ReactComponent,
    'regular-delete-right': delete_right_svg_1.ReactComponent,
    'regular-democrat': democrat_svg_1.ReactComponent,
    'regular-desktop-arrow-down': desktop_arrow_down_svg_1.ReactComponent,
    'regular-desktop': desktop_svg_1.ReactComponent,
    'regular-dharmachakra': dharmachakra_svg_1.ReactComponent,
    'regular-diagram-lean-canvas': diagram_lean_canvas_svg_1.ReactComponent,
    'regular-diagram-nested': diagram_nested_svg_1.ReactComponent,
    'regular-diagram-project': diagram_project_svg_1.ReactComponent,
    'regular-diagram-sankey': diagram_sankey_svg_1.ReactComponent,
    'regular-diagram-stankey': diagram_stankey_svg_1.ReactComponent,
    'regular-diagram-venn': diagram_venn_svg_1.ReactComponent,
    'regular-dial-high': dial_high_svg_1.ReactComponent,
    'regular-dial-low': dial_low_svg_1.ReactComponent,
    'regular-dial-max': dial_max_svg_1.ReactComponent,
    'regular-dial-med-low': dial_med_low_svg_1.ReactComponent,
    'regular-dial-med': dial_med_svg_1.ReactComponent,
    'regular-dial-min': dial_min_svg_1.ReactComponent,
    'regular-dial': dial_svg_1.ReactComponent,
    'regular-diamond-turn-right': diamond_turn_right_svg_1.ReactComponent,
    'regular-diamond': diamond_svg_1.ReactComponent,
    'regular-dice-d10': dice_d10_svg_1.ReactComponent,
    'regular-dice-d12': dice_d12_svg_1.ReactComponent,
    'regular-dice-d20': dice_d20_svg_1.ReactComponent,
    'regular-dice-d4': dice_d4_svg_1.ReactComponent,
    'regular-dice-d6': dice_d6_svg_1.ReactComponent,
    'regular-dice-d8': dice_d8_svg_1.ReactComponent,
    'regular-dice-five': dice_five_svg_1.ReactComponent,
    'regular-dice-four': dice_four_svg_1.ReactComponent,
    'regular-dice-one': dice_one_svg_1.ReactComponent,
    'regular-dice-six': dice_six_svg_1.ReactComponent,
    'regular-dice-three': dice_three_svg_1.ReactComponent,
    'regular-dice-two': dice_two_svg_1.ReactComponent,
    'regular-dice': dice_svg_1.ReactComponent,
    'regular-diploma': diploma_svg_1.ReactComponent,
    'regular-disc-drive': disc_drive_svg_1.ReactComponent,
    'regular-disease': disease_svg_1.ReactComponent,
    'regular-display-arrow-down': display_arrow_down_svg_1.ReactComponent,
    'regular-display-code': display_code_svg_1.ReactComponent,
    'regular-display-medical': display_medical_svg_1.ReactComponent,
    'regular-display-slash': display_slash_svg_1.ReactComponent,
    'regular-display': display_svg_1.ReactComponent,
    'regular-divide': divide_svg_1.ReactComponent,
    'regular-dna': dna_svg_1.ReactComponent,
    'regular-do-not-enter': do_not_enter_svg_1.ReactComponent,
    'regular-dog-leashed': dog_leashed_svg_1.ReactComponent,
    'regular-dog': dog_svg_1.ReactComponent,
    'regular-dollar-sign': dollar_sign_svg_1.ReactComponent,
    'regular-dolly-empty': dolly_empty_svg_1.ReactComponent,
    'regular-dolly': dolly_svg_1.ReactComponent,
    'regular-dolphin': dolphin_svg_1.ReactComponent,
    'regular-dong-sign': dong_sign_svg_1.ReactComponent,
    'regular-door-closed': door_closed_svg_1.ReactComponent,
    'regular-door-open': door_open_svg_1.ReactComponent,
    'regular-dove': dove_svg_1.ReactComponent,
    'regular-down-from-line': down_from_line_svg_1.ReactComponent,
    'regular-down-left-and-up-right-to-center': down_left_and_up_right_to_center_svg_1.ReactComponent,
    'regular-down-left': down_left_svg_1.ReactComponent,
    'regular-down-long': down_long_svg_1.ReactComponent,
    'regular-down-right': down_right_svg_1.ReactComponent,
    'regular-down-to-line': down_to_line_svg_1.ReactComponent,
    'regular-down': down_svg_1.ReactComponent,
    'regular-download': download_svg_1.ReactComponent,
    'regular-dragon': dragon_svg_1.ReactComponent,
    'regular-draw-circle': draw_circle_svg_1.ReactComponent,
    'regular-draw-polygon': draw_polygon_svg_1.ReactComponent,
    'regular-draw-square': draw_square_svg_1.ReactComponent,
    'regular-dreidel': dreidel_svg_1.ReactComponent,
    'regular-drone-front': drone_front_svg_1.ReactComponent,
    'regular-drone': drone_svg_1.ReactComponent,
    'regular-droplet-degree': droplet_degree_svg_1.ReactComponent,
    'regular-droplet-percent': droplet_percent_svg_1.ReactComponent,
    'regular-droplet-slash': droplet_slash_svg_1.ReactComponent,
    'regular-droplet': droplet_svg_1.ReactComponent,
    'regular-drum-steelpan': drum_steelpan_svg_1.ReactComponent,
    'regular-drum': drum_svg_1.ReactComponent,
    'regular-drumstick-bite': drumstick_bite_svg_1.ReactComponent,
    'regular-drumstick': drumstick_svg_1.ReactComponent,
    'regular-dryer-heat': dryer_heat_svg_1.ReactComponent,
    'regular-dryer': dryer_svg_1.ReactComponent,
    'regular-duck': duck_svg_1.ReactComponent,
    'regular-dumbbell': dumbbell_svg_1.ReactComponent,
    'regular-dumpster-fire': dumpster_fire_svg_1.ReactComponent,
    'regular-dumpster': dumpster_svg_1.ReactComponent,
    'regular-dungeon': dungeon_svg_1.ReactComponent,
    'regular-e': e_svg_1.ReactComponent,
    'regular-ear-deaf': ear_deaf_svg_1.ReactComponent,
    'regular-ear-listen': ear_listen_svg_1.ReactComponent,
    'regular-ear-muffs': ear_muffs_svg_1.ReactComponent,
    'regular-ear': ear_svg_1.ReactComponent,
    'regular-earth-africa': earth_africa_svg_1.ReactComponent,
    'regular-earth-americas': earth_americas_svg_1.ReactComponent,
    'regular-earth-asia': earth_asia_svg_1.ReactComponent,
    'regular-earth-europa': earth_europa_svg_1.ReactComponent,
    'regular-eclipse': eclipse_svg_1.ReactComponent,
    'regular-egg-fried': egg_fried_svg_1.ReactComponent,
    'regular-egg': egg_svg_1.ReactComponent,
    'regular-eggplant': eggplant_svg_1.ReactComponent,
    'regular-eject': eject_svg_1.ReactComponent,
    'regular-elephant': elephant_svg_1.ReactComponent,
    'regular-elevator': elevator_svg_1.ReactComponent,
    'regular-ellipsis-stroke-vertical': ellipsis_stroke_vertical_svg_1.ReactComponent,
    'regular-ellipsis-stroke': ellipsis_stroke_svg_1.ReactComponent,
    'regular-ellipsis-vertical': ellipsis_vertical_svg_1.ReactComponent,
    'regular-ellipsis': ellipsis_svg_1.ReactComponent,
    'regular-empty-set': empty_set_svg_1.ReactComponent,
    'regular-engine-warning': engine_warning_svg_1.ReactComponent,
    'regular-engine': engine_svg_1.ReactComponent,
    'regular-envelope-dot': envelope_dot_svg_1.ReactComponent,
    'regular-envelope-open-dollar': envelope_open_dollar_svg_1.ReactComponent,
    'regular-envelope-open-text': envelope_open_text_svg_1.ReactComponent,
    'regular-envelope-open': envelope_open_svg_1.ReactComponent,
    'regular-envelope': envelope_svg_1.ReactComponent,
    'regular-envelopes-bulk': envelopes_bulk_svg_1.ReactComponent,
    'regular-envelopes': envelopes_svg_1.ReactComponent,
    'regular-equals': equals_svg_1.ReactComponent,
    'regular-eraser': eraser_svg_1.ReactComponent,
    'regular-escalator': escalator_svg_1.ReactComponent,
    'regular-ethernet': ethernet_svg_1.ReactComponent,
    'regular-euro-sign': euro_sign_svg_1.ReactComponent,
    'regular-exclamation': exclamation_svg_1.ReactComponent,
    'regular-expand-wide': expand_wide_svg_1.ReactComponent,
    'regular-expand': expand_svg_1.ReactComponent,
    'regular-eye-dropper-full': eye_dropper_full_svg_1.ReactComponent,
    'regular-eye-dropper-half': eye_dropper_half_svg_1.ReactComponent,
    'regular-eye-dropper': eye_dropper_svg_1.ReactComponent,
    'regular-eye-evil': eye_evil_svg_1.ReactComponent,
    'regular-eye-low-vision': eye_low_vision_svg_1.ReactComponent,
    'regular-eye-slash': eye_slash_svg_1.ReactComponent,
    'regular-eye': eye_svg_1.ReactComponent,
    'regular-f': f_svg_1.ReactComponent,
    'regular-face-angry': face_angry_svg_1.ReactComponent,
    'regular-face-dizzy': face_dizzy_svg_1.ReactComponent,
    'regular-face-flushed': face_flushed_svg_1.ReactComponent,
    'regular-face-frown-open': face_frown_open_svg_1.ReactComponent,
    'regular-face-frown': face_frown_svg_1.ReactComponent,
    'regular-face-grimace': face_grimace_svg_1.ReactComponent,
    'regular-face-grin-beam-sweat': face_grin_beam_sweat_svg_1.ReactComponent,
    'regular-face-grin-beam': face_grin_beam_svg_1.ReactComponent,
    'regular-face-grin-hearts': face_grin_hearts_svg_1.ReactComponent,
    'regular-face-grin-squint-tears': face_grin_squint_tears_svg_1.ReactComponent,
    'regular-face-grin-squint': face_grin_squint_svg_1.ReactComponent,
    'regular-face-grin-stars': face_grin_stars_svg_1.ReactComponent,
    'regular-face-grin-tears': face_grin_tears_svg_1.ReactComponent,
    'regular-face-grin-tongue-squint': face_grin_tongue_squint_svg_1.ReactComponent,
    'regular-face-grin-tongue-wink': face_grin_tongue_wink_svg_1.ReactComponent,
    'regular-face-grin-tongue': face_grin_tongue_svg_1.ReactComponent,
    'regular-face-grin-wide': face_grin_wide_svg_1.ReactComponent,
    'regular-face-grin-wink': face_grin_wink_svg_1.ReactComponent,
    'regular-face-grin': face_grin_svg_1.ReactComponent,
    'regular-face-kiss-beam': face_kiss_beam_svg_1.ReactComponent,
    'regular-face-kiss-wink-heart': face_kiss_wink_heart_svg_1.ReactComponent,
    'regular-face-kiss': face_kiss_svg_1.ReactComponent,
    'regular-face-laugh-beam': face_laugh_beam_svg_1.ReactComponent,
    'regular-face-laugh-squint': face_laugh_squint_svg_1.ReactComponent,
    'regular-face-laugh-wink': face_laugh_wink_svg_1.ReactComponent,
    'regular-face-laugh': face_laugh_svg_1.ReactComponent,
    'regular-face-meh-blank': face_meh_blank_svg_1.ReactComponent,
    'regular-face-meh': face_meh_svg_1.ReactComponent,
    'regular-face-rolling-eyes': face_rolling_eyes_svg_1.ReactComponent,
    'regular-face-sad-cry': face_sad_cry_svg_1.ReactComponent,
    'regular-face-sad-tear': face_sad_tear_svg_1.ReactComponent,
    'regular-face-smile-beam': face_smile_beam_svg_1.ReactComponent,
    'regular-face-smile-plus': face_smile_plus_svg_1.ReactComponent,
    'regular-face-smile-wink': face_smile_wink_svg_1.ReactComponent,
    'regular-face-smile': face_smile_svg_1.ReactComponent,
    'regular-face-surprise': face_surprise_svg_1.ReactComponent,
    'regular-face-tired': face_tired_svg_1.ReactComponent,
    'regular-fan-table': fan_table_svg_1.ReactComponent,
    'regular-fan': fan_svg_1.ReactComponent,
    'regular-farm': farm_svg_1.ReactComponent,
    'regular-faucet-drip': faucet_drip_svg_1.ReactComponent,
    'regular-faucet': faucet_svg_1.ReactComponent,
    'regular-fax': fax_svg_1.ReactComponent,
    'regular-feather-pointed': feather_pointed_svg_1.ReactComponent,
    'regular-feather': feather_svg_1.ReactComponent,
    'regular-fence': fence_svg_1.ReactComponent,
    'regular-field-hockey-stick-ball': field_hockey_stick_ball_svg_1.ReactComponent,
    'regular-file-arrow-down': file_arrow_down_svg_1.ReactComponent,
    'regular-file-arrow-up': file_arrow_up_svg_1.ReactComponent,
    'regular-file-audio': file_audio_svg_1.ReactComponent,
    'regular-file-binary': file_binary_svg_1.ReactComponent,
    'regular-file-certificate': file_certificate_svg_1.ReactComponent,
    'regular-file-chart-column': file_chart_column_svg_1.ReactComponent,
    'regular-file-chart-pie': file_chart_pie_svg_1.ReactComponent,
    'regular-file-check': file_check_svg_1.ReactComponent,
    'regular-file-code': file_code_svg_1.ReactComponent,
    'regular-file-contract': file_contract_svg_1.ReactComponent,
    'regular-file-csv': file_csv_svg_1.ReactComponent,
    'regular-file-dashed-line': file_dashed_line_svg_1.ReactComponent,
    'regular-file-excel': file_excel_svg_1.ReactComponent,
    'regular-file-exclamation': file_exclamation_svg_1.ReactComponent,
    'regular-file-export': file_export_svg_1.ReactComponent,
    'regular-file-heart': file_heart_svg_1.ReactComponent,
    'regular-file-image': file_image_svg_1.ReactComponent,
    'regular-file-import': file_import_svg_1.ReactComponent,
    'regular-file-invoice-dollar': file_invoice_dollar_svg_1.ReactComponent,
    'regular-file-invoice': file_invoice_svg_1.ReactComponent,
    'regular-file-lines': file_lines_svg_1.ReactComponent,
    'regular-file-magnifying-glass': file_magnifying_glass_svg_1.ReactComponent,
    'regular-file-medical': file_medical_svg_1.ReactComponent,
    'regular-file-minus': file_minus_svg_1.ReactComponent,
    'regular-file-music': file_music_svg_1.ReactComponent,
    'regular-file-pdf': file_pdf_svg_1.ReactComponent,
    'regular-file-pen': file_pen_svg_1.ReactComponent,
    'regular-file-plus-minus': file_plus_minus_svg_1.ReactComponent,
    'regular-file-plus': file_plus_svg_1.ReactComponent,
    'regular-file-powerpoint': file_powerpoint_svg_1.ReactComponent,
    'regular-file-prescription': file_prescription_svg_1.ReactComponent,
    'regular-file-signature': file_signature_svg_1.ReactComponent,
    'regular-file-spreadsheet': file_spreadsheet_svg_1.ReactComponent,
    'regular-file-user': file_user_svg_1.ReactComponent,
    'regular-file-video': file_video_svg_1.ReactComponent,
    'regular-file-waveform': file_waveform_svg_1.ReactComponent,
    'regular-file-word': file_word_svg_1.ReactComponent,
    'regular-file-xmark': file_xmark_svg_1.ReactComponent,
    'regular-file-zipper': file_zipper_svg_1.ReactComponent,
    'regular-file': file_svg_1.ReactComponent,
    'regular-files-medical': files_medical_svg_1.ReactComponent,
    'regular-files': files_svg_1.ReactComponent,
    'regular-fill-drip': fill_drip_svg_1.ReactComponent,
    'regular-fill': fill_svg_1.ReactComponent,
    'regular-film-canister': film_canister_svg_1.ReactComponent,
    'regular-film-simple': film_simple_svg_1.ReactComponent,
    'regular-film-slash': film_slash_svg_1.ReactComponent,
    'regular-film': film_svg_1.ReactComponent,
    'regular-films': films_svg_1.ReactComponent,
    'regular-filter-circle-dollar': filter_circle_dollar_svg_1.ReactComponent,
    'regular-filter-circle-xmark': filter_circle_xmark_svg_1.ReactComponent,
    'regular-filter-list': filter_list_svg_1.ReactComponent,
    'regular-filter-slash': filter_slash_svg_1.ReactComponent,
    'regular-filter': filter_svg_1.ReactComponent,
    'regular-filters': filters_svg_1.ReactComponent,
    'regular-fingerprint': fingerprint_svg_1.ReactComponent,
    'regular-fire-extinguisher': fire_extinguisher_svg_1.ReactComponent,
    'regular-fire-flame-curved': fire_flame_curved_svg_1.ReactComponent,
    'regular-fire-flame-simple': fire_flame_simple_svg_1.ReactComponent,
    'regular-fire-flame': fire_flame_svg_1.ReactComponent,
    'regular-fire-hydrant': fire_hydrant_svg_1.ReactComponent,
    'regular-fire-smoke': fire_smoke_svg_1.ReactComponent,
    'regular-fire': fire_svg_1.ReactComponent,
    'regular-fireplace': fireplace_svg_1.ReactComponent,
    'regular-fish-cooked': fish_cooked_svg_1.ReactComponent,
    'regular-fish': fish_svg_1.ReactComponent,
    'regular-flag-checkered': flag_checkered_svg_1.ReactComponent,
    'regular-flag-pennant': flag_pennant_svg_1.ReactComponent,
    'regular-flag-swallowtail': flag_swallowtail_svg_1.ReactComponent,
    'regular-flag-usa': flag_usa_svg_1.ReactComponent,
    'regular-flag': flag_svg_1.ReactComponent,
    'regular-flashlight': flashlight_svg_1.ReactComponent,
    'regular-flask-round-poison': flask_round_poison_svg_1.ReactComponent,
    'regular-flask-round-potion': flask_round_potion_svg_1.ReactComponent,
    'regular-flask': flask_svg_1.ReactComponent,
    'regular-floppy-disk-circle-arrow-right': floppy_disk_circle_arrow_right_svg_1.ReactComponent,
    'regular-floppy-disk-circle-xmark': floppy_disk_circle_xmark_svg_1.ReactComponent,
    'regular-floppy-disk-pen': floppy_disk_pen_svg_1.ReactComponent,
    'regular-floppy-disk': floppy_disk_svg_1.ReactComponent,
    'regular-floppy-disks': floppy_disks_svg_1.ReactComponent,
    'regular-florin-sign': florin_sign_svg_1.ReactComponent,
    'regular-flower-daffodil': flower_daffodil_svg_1.ReactComponent,
    'regular-flower-tulip': flower_tulip_svg_1.ReactComponent,
    'regular-flower': flower_svg_1.ReactComponent,
    'regular-flute': flute_svg_1.ReactComponent,
    'regular-flux-capacitor': flux_capacitor_svg_1.ReactComponent,
    'regular-folder-arrow-down': folder_arrow_down_svg_1.ReactComponent,
    'regular-folder-arrow-up': folder_arrow_up_svg_1.ReactComponent,
    'regular-folder-blank': folder_blank_svg_1.ReactComponent,
    'regular-folder-bookmark': folder_bookmark_svg_1.ReactComponent,
    'regular-folder-gear': folder_gear_svg_1.ReactComponent,
    'regular-folder-grid': folder_grid_svg_1.ReactComponent,
    'regular-folder-heart': folder_heart_svg_1.ReactComponent,
    'regular-folder-image': folder_image_svg_1.ReactComponent,
    'regular-folder-magnifying-glass': folder_magnifying_glass_svg_1.ReactComponent,
    'regular-folder-medical': folder_medical_svg_1.ReactComponent,
    'regular-folder-minus': folder_minus_svg_1.ReactComponent,
    'regular-folder-music': folder_music_svg_1.ReactComponent,
    'regular-folder-open': folder_open_svg_1.ReactComponent,
    'regular-folder-plus': folder_plus_svg_1.ReactComponent,
    'regular-folder-tree': folder_tree_svg_1.ReactComponent,
    'regular-folder-user': folder_user_svg_1.ReactComponent,
    'regular-folder-xmark': folder_xmark_svg_1.ReactComponent,
    'regular-folder': folder_svg_1.ReactComponent,
    'regular-folders': folders_svg_1.ReactComponent,
    'regular-font-awesome': font_awesome_svg_2.ReactComponent,
    'regular-font-case': font_case_svg_1.ReactComponent,
    'regular-font': font_svg_1.ReactComponent,
    'regular-football-ball': football_ball_svg_1.ReactComponent,
    'regular-football-helmet': football_helmet_svg_1.ReactComponent,
    'regular-fork-knife': fork_knife_svg_1.ReactComponent,
    'regular-fork': fork_svg_1.ReactComponent,
    'regular-forklift': forklift_svg_1.ReactComponent,
    'regular-forward-fast': forward_fast_svg_1.ReactComponent,
    'regular-forward-step': forward_step_svg_1.ReactComponent,
    'regular-forward': forward_svg_1.ReactComponent,
    'regular-franc-sign': franc_sign_svg_1.ReactComponent,
    'regular-french-fries': french_fries_svg_1.ReactComponent,
    'regular-frog': frog_svg_1.ReactComponent,
    'regular-function': function_svg_1.ReactComponent,
    'regular-futbol-ball': futbol_ball_svg_1.ReactComponent,
    'regular-g': g_svg_1.ReactComponent,
    'regular-galaxy': galaxy_svg_1.ReactComponent,
    'regular-game-board-simple': game_board_simple_svg_1.ReactComponent,
    'regular-game-board': game_board_svg_1.ReactComponent,
    'regular-game-console-handheld': game_console_handheld_svg_1.ReactComponent,
    'regular-gamepad-modern': gamepad_modern_svg_1.ReactComponent,
    'regular-gamepad': gamepad_svg_1.ReactComponent,
    'regular-garage-car': garage_car_svg_1.ReactComponent,
    'regular-garage-open': garage_open_svg_1.ReactComponent,
    'regular-garage': garage_svg_1.ReactComponent,
    'regular-gas-pump-slash': gas_pump_slash_svg_1.ReactComponent,
    'regular-gas-pump': gas_pump_svg_1.ReactComponent,
    'regular-gauge-low': gauge_low_svg_1.ReactComponent,
    'regular-gauge-max': gauge_max_svg_1.ReactComponent,
    'regular-gauge-med': gauge_med_svg_1.ReactComponent,
    'regular-gauge-min': gauge_min_svg_1.ReactComponent,
    'regular-gauge-simple-low': gauge_simple_low_svg_1.ReactComponent,
    'regular-gauge-simple-max': gauge_simple_max_svg_1.ReactComponent,
    'regular-gauge-simple-med': gauge_simple_med_svg_1.ReactComponent,
    'regular-gauge-simple-min': gauge_simple_min_svg_1.ReactComponent,
    'regular-gauge-simple': gauge_simple_svg_1.ReactComponent,
    'regular-gauge': gauge_svg_1.ReactComponent,
    'regular-gavel': gavel_svg_1.ReactComponent,
    'regular-gear': gear_svg_1.ReactComponent,
    'regular-gears': gears_svg_1.ReactComponent,
    'regular-gem': gem_svg_1.ReactComponent,
    'regular-genderless': genderless_svg_1.ReactComponent,
    'regular-ghost': ghost_svg_1.ReactComponent,
    'regular-gif': gif_svg_1.ReactComponent,
    'regular-gift-card': gift_card_svg_1.ReactComponent,
    'regular-gift': gift_svg_1.ReactComponent,
    'regular-gifts': gifts_svg_1.ReactComponent,
    'regular-gingerbread-man': gingerbread_man_svg_1.ReactComponent,
    'regular-glass-citrus': glass_citrus_svg_1.ReactComponent,
    'regular-glass-empty': glass_empty_svg_1.ReactComponent,
    'regular-glass-half': glass_half_svg_1.ReactComponent,
    'regular-glass': glass_svg_1.ReactComponent,
    'regular-glasses-round': glasses_round_svg_1.ReactComponent,
    'regular-glasses': glasses_svg_1.ReactComponent,
    'regular-globe-snow': globe_snow_svg_1.ReactComponent,
    'regular-globe-stand': globe_stand_svg_1.ReactComponent,
    'regular-globe': globe_svg_1.ReactComponent,
    'regular-golf-ball-tee': golf_ball_tee_svg_1.ReactComponent,
    'regular-golf-club': golf_club_svg_1.ReactComponent,
    'regular-gopuram': gopuram_svg_1.ReactComponent,
    'regular-graduation-cap': graduation_cap_svg_1.ReactComponent,
    'regular-gramophone': gramophone_svg_1.ReactComponent,
    'regular-grate-droplet': grate_droplet_svg_1.ReactComponent,
    'regular-grate': grate_svg_1.ReactComponent,
    'regular-greater-than-equal': greater_than_equal_svg_1.ReactComponent,
    'regular-greater-than': greater_than_svg_1.ReactComponent,
    'regular-grid-2-plus': grid_2_plus_svg_1.ReactComponent,
    'regular-grid-2': grid_2_svg_1.ReactComponent,
    'regular-grid-4': grid_4_svg_1.ReactComponent,
    'regular-grid-5': grid_5_svg_1.ReactComponent,
    'regular-grid': grid_svg_1.ReactComponent,
    'regular-grip-lines-vertical': grip_lines_vertical_svg_1.ReactComponent,
    'regular-grip-lines': grip_lines_svg_1.ReactComponent,
    'regular-grip-vertical': grip_vertical_svg_1.ReactComponent,
    'regular-grip': grip_svg_1.ReactComponent,
    'regular-guarani-sign': guarani_sign_svg_1.ReactComponent,
    'regular-guitar-electric': guitar_electric_svg_1.ReactComponent,
    'regular-guitar': guitar_svg_1.ReactComponent,
    'regular-guitars': guitars_svg_1.ReactComponent,
    'regular-gun-slash': gun_slash_svg_1.ReactComponent,
    'regular-gun-squirt': gun_squirt_svg_1.ReactComponent,
    'regular-gun': gun_svg_1.ReactComponent,
    'regular-h': h_svg_1.ReactComponent,
    'regular-h1': h1_svg_1.ReactComponent,
    'regular-h2': h2_svg_1.ReactComponent,
    'regular-h3': h3_svg_1.ReactComponent,
    'regular-h4': h4_svg_1.ReactComponent,
    'regular-hammer-war': hammer_war_svg_1.ReactComponent,
    'regular-hammer': hammer_svg_1.ReactComponent,
    'regular-hamsa': hamsa_svg_1.ReactComponent,
    'regular-hand-back-point-down': hand_back_point_down_svg_1.ReactComponent,
    'regular-hand-back-point-left': hand_back_point_left_svg_1.ReactComponent,
    'regular-hand-back-point-right': hand_back_point_right_svg_1.ReactComponent,
    'regular-hand-back-point-up': hand_back_point_up_svg_1.ReactComponent,
    'regular-hand-dots': hand_dots_svg_1.ReactComponent,
    'regular-hand-fingers-crossed': hand_fingers_crossed_svg_1.ReactComponent,
    'regular-hand-fist': hand_fist_svg_1.ReactComponent,
    'regular-hand-heart': hand_heart_svg_1.ReactComponent,
    'regular-hand-holding-box': hand_holding_box_svg_1.ReactComponent,
    'regular-hand-holding-dollar': hand_holding_dollar_svg_1.ReactComponent,
    'regular-hand-holding-droplet': hand_holding_droplet_svg_1.ReactComponent,
    'regular-hand-holding-heart': hand_holding_heart_svg_1.ReactComponent,
    'regular-hand-holding-magic': hand_holding_magic_svg_1.ReactComponent,
    'regular-hand-holding-medical': hand_holding_medical_svg_1.ReactComponent,
    'regular-hand-holding-seedling': hand_holding_seedling_svg_1.ReactComponent,
    'regular-hand-holding-skull': hand_holding_skull_svg_1.ReactComponent,
    'regular-hand-holding': hand_holding_svg_1.ReactComponent,
    'regular-hand-lizard': hand_lizard_svg_1.ReactComponent,
    'regular-hand-love': hand_love_svg_1.ReactComponent,
    'regular-hand-middle-finger': hand_middle_finger_svg_1.ReactComponent,
    'regular-hand-paper': hand_paper_svg_1.ReactComponent,
    'regular-hand-peace': hand_peace_svg_1.ReactComponent,
    'regular-hand-point-down': hand_point_down_svg_1.ReactComponent,
    'regular-hand-point-left': hand_point_left_svg_1.ReactComponent,
    'regular-hand-point-right': hand_point_right_svg_1.ReactComponent,
    'regular-hand-point-up': hand_point_up_svg_1.ReactComponent,
    'regular-hand-pointer': hand_pointer_svg_1.ReactComponent,
    'regular-hand-rock': hand_rock_svg_1.ReactComponent,
    'regular-hand-scissors': hand_scissors_svg_1.ReactComponent,
    'regular-hand-sparkles': hand_sparkles_svg_1.ReactComponent,
    'regular-hand-spock': hand_spock_svg_1.ReactComponent,
    'regular-hand-wave': hand_wave_svg_1.ReactComponent,
    'regular-hands-asl-interpreting': hands_asl_interpreting_svg_1.ReactComponent,
    'regular-hands-bubbles': hands_bubbles_svg_1.ReactComponent,
    'regular-hands-clapping': hands_clapping_svg_1.ReactComponent,
    'regular-hands-holding-diamond': hands_holding_diamond_svg_1.ReactComponent,
    'regular-hands-holding-dollar': hands_holding_dollar_svg_1.ReactComponent,
    'regular-hands-holding-heart': hands_holding_heart_svg_1.ReactComponent,
    'regular-hands-holding': hands_holding_svg_1.ReactComponent,
    'regular-hands-horns': hands_horns_svg_1.ReactComponent,
    'regular-hands-praying': hands_praying_svg_1.ReactComponent,
    'regular-hands': hands_svg_1.ReactComponent,
    'regular-handshake-angle': handshake_angle_svg_1.ReactComponent,
    'regular-handshake-simple-slash': handshake_simple_slash_svg_1.ReactComponent,
    'regular-handshake-simple': handshake_simple_svg_1.ReactComponent,
    'regular-handshake-slash': handshake_slash_svg_1.ReactComponent,
    'regular-handshake': handshake_svg_1.ReactComponent,
    'regular-hanukiah': hanukiah_svg_1.ReactComponent,
    'regular-hard-drive': hard_drive_svg_1.ReactComponent,
    'regular-hashtag': hashtag_svg_1.ReactComponent,
    'regular-hat-chef': hat_chef_svg_1.ReactComponent,
    'regular-hat-cowboy-side': hat_cowboy_side_svg_1.ReactComponent,
    'regular-hat-cowboy': hat_cowboy_svg_1.ReactComponent,
    'regular-hat-santa': hat_santa_svg_1.ReactComponent,
    'regular-hat-winter': hat_winter_svg_1.ReactComponent,
    'regular-hat-witch': hat_witch_svg_1.ReactComponent,
    'regular-hat-wizard': hat_wizard_svg_1.ReactComponent,
    'regular-head-side-brain': head_side_brain_svg_1.ReactComponent,
    'regular-head-side-cough-slash': head_side_cough_slash_svg_1.ReactComponent,
    'regular-head-side-cough': head_side_cough_svg_1.ReactComponent,
    'regular-head-side-goggles': head_side_goggles_svg_1.ReactComponent,
    'regular-head-side-headphones': head_side_headphones_svg_1.ReactComponent,
    'regular-head-side-heart': head_side_heart_svg_1.ReactComponent,
    'regular-head-side-mask': head_side_mask_svg_1.ReactComponent,
    'regular-head-side-medical': head_side_medical_svg_1.ReactComponent,
    'regular-head-side-virus': head_side_virus_svg_1.ReactComponent,
    'regular-head-side': head_side_svg_1.ReactComponent,
    'regular-heading': heading_svg_1.ReactComponent,
    'regular-headphones-simple': headphones_simple_svg_1.ReactComponent,
    'regular-headphones': headphones_svg_1.ReactComponent,
    'regular-headset': headset_svg_1.ReactComponent,
    'regular-heart-crack': heart_crack_svg_1.ReactComponent,
    'regular-heart-half-stroke': heart_half_stroke_svg_1.ReactComponent,
    'regular-heart-half': heart_half_svg_1.ReactComponent,
    'regular-heart-pulse': heart_pulse_svg_1.ReactComponent,
    'regular-heart': heart_svg_1.ReactComponent,
    'regular-heat': heat_svg_1.ReactComponent,
    'regular-helicopter': helicopter_svg_1.ReactComponent,
    'regular-helmet-battle': helmet_battle_svg_1.ReactComponent,
    'regular-helmet-safety': helmet_safety_svg_1.ReactComponent,
    'regular-hexagon-divide': hexagon_divide_svg_1.ReactComponent,
    'regular-hexagon-minus': hexagon_minus_svg_1.ReactComponent,
    'regular-hexagon-plus': hexagon_plus_svg_1.ReactComponent,
    'regular-hexagon-xmark': hexagon_xmark_svg_1.ReactComponent,
    'regular-hexagon': hexagon_svg_1.ReactComponent,
    'regular-high-definition': high_definition_svg_1.ReactComponent,
    'regular-highlighter-line': highlighter_line_svg_1.ReactComponent,
    'regular-highlighter': highlighter_svg_1.ReactComponent,
    'regular-hippo': hippo_svg_1.ReactComponent,
    'regular-hockey-mask': hockey_mask_svg_1.ReactComponent,
    'regular-hockey-puck': hockey_puck_svg_1.ReactComponent,
    'regular-hockey-sticks': hockey_sticks_svg_1.ReactComponent,
    'regular-holly-berry': holly_berry_svg_1.ReactComponent,
    'regular-home-heart': home_heart_svg_1.ReactComponent,
    'regular-home-simple': home_simple_svg_1.ReactComponent,
    'regular-home-user': home_user_svg_1.ReactComponent,
    'regular-home': home_svg_1.ReactComponent,
    'regular-hood-cloak': hood_cloak_svg_1.ReactComponent,
    'regular-horizontal-rule': horizontal_rule_svg_1.ReactComponent,
    'regular-horse-head': horse_head_svg_1.ReactComponent,
    'regular-horse-saddle': horse_saddle_svg_1.ReactComponent,
    'regular-horse': horse_svg_1.ReactComponent,
    'regular-hospital-user': hospital_user_svg_1.ReactComponent,
    'regular-hospital-wide': hospital_wide_svg_1.ReactComponent,
    'regular-hospital': hospital_svg_1.ReactComponent,
    'regular-hospitals': hospitals_svg_1.ReactComponent,
    'regular-hot-tub-person': hot_tub_person_svg_1.ReactComponent,
    'regular-hotdog': hotdog_svg_1.ReactComponent,
    'regular-hotel': hotel_svg_1.ReactComponent,
    'regular-hourglass-empty': hourglass_empty_svg_1.ReactComponent,
    'regular-hourglass-end': hourglass_end_svg_1.ReactComponent,
    'regular-hourglass-start': hourglass_start_svg_1.ReactComponent,
    'regular-hourglass': hourglass_svg_1.ReactComponent,
    'regular-house-building': house_building_svg_1.ReactComponent,
    'regular-house-crack': house_crack_svg_1.ReactComponent,
    'regular-house-day': house_day_svg_1.ReactComponent,
    'regular-house-flood': house_flood_svg_1.ReactComponent,
    'regular-house-heart': house_heart_svg_1.ReactComponent,
    'regular-house-laptop': house_laptop_svg_1.ReactComponent,
    'regular-house-medical': house_medical_svg_1.ReactComponent,
    'regular-house-night': house_night_svg_1.ReactComponent,
    'regular-house-person-leave': house_person_leave_svg_1.ReactComponent,
    'regular-house-person-return': house_person_return_svg_1.ReactComponent,
    'regular-house-signal': house_signal_svg_1.ReactComponent,
    'regular-house-tree': house_tree_svg_1.ReactComponent,
    'regular-house-turret': house_turret_svg_1.ReactComponent,
    'regular-house-user': house_user_svg_1.ReactComponent,
    'regular-house': house_svg_1.ReactComponent,
    'regular-hryvnia-sign': hryvnia_sign_svg_1.ReactComponent,
    'regular-hurricane': hurricane_svg_1.ReactComponent,
    'regular-i-cursor': i_cursor_svg_1.ReactComponent,
    'regular-i': i_svg_1.ReactComponent,
    'regular-ice-cream': ice_cream_svg_1.ReactComponent,
    'regular-ice-skate': ice_skate_svg_1.ReactComponent,
    'regular-icicles': icicles_svg_1.ReactComponent,
    'regular-icons': icons_svg_1.ReactComponent,
    'regular-id-badge': id_badge_svg_1.ReactComponent,
    'regular-id-card-clip': id_card_clip_svg_1.ReactComponent,
    'regular-id-card': id_card_svg_1.ReactComponent,
    'regular-igloo': igloo_svg_1.ReactComponent,
    'regular-image-landscape': image_landscape_svg_1.ReactComponent,
    'regular-image-polaroid-user': image_polaroid_user_svg_1.ReactComponent,
    'regular-image-polaroid': image_polaroid_svg_1.ReactComponent,
    'regular-image-portrait': image_portrait_svg_1.ReactComponent,
    'regular-image-slash': image_slash_svg_1.ReactComponent,
    'regular-image-user': image_user_svg_1.ReactComponent,
    'regular-image': image_svg_1.ReactComponent,
    'regular-images-user': images_user_svg_1.ReactComponent,
    'regular-images': images_svg_1.ReactComponent,
    'regular-inbox-full': inbox_full_svg_1.ReactComponent,
    'regular-inbox-in': inbox_in_svg_1.ReactComponent,
    'regular-inbox-out': inbox_out_svg_1.ReactComponent,
    'regular-inbox': inbox_svg_1.ReactComponent,
    'regular-inboxes': inboxes_svg_1.ReactComponent,
    'regular-indent': indent_svg_1.ReactComponent,
    'regular-indian-rupee-sign': indian_rupee_sign_svg_1.ReactComponent,
    'regular-industry-windows': industry_windows_svg_1.ReactComponent,
    'regular-industry': industry_svg_1.ReactComponent,
    'regular-infinity': infinity_svg_1.ReactComponent,
    'regular-info': info_svg_1.ReactComponent,
    'regular-inhaler': inhaler_svg_1.ReactComponent,
    'regular-input-numeric': input_numeric_svg_1.ReactComponent,
    'regular-input-pipe': input_pipe_svg_1.ReactComponent,
    'regular-input-text': input_text_svg_1.ReactComponent,
    'regular-integral': integral_svg_1.ReactComponent,
    'regular-intersection': intersection_svg_1.ReactComponent,
    'regular-island-tropical': island_tropical_svg_1.ReactComponent,
    'regular-italic': italic_svg_1.ReactComponent,
    'regular-j': j_svg_1.ReactComponent,
    'regular-jack-o-lantern': jack_o_lantern_svg_1.ReactComponent,
    'regular-jedi': jedi_svg_1.ReactComponent,
    'regular-jet-fighter': jet_fighter_svg_1.ReactComponent,
    'regular-joint': joint_svg_1.ReactComponent,
    'regular-joystick': joystick_svg_1.ReactComponent,
    'regular-jug': jug_svg_1.ReactComponent,
    'regular-k': k_svg_1.ReactComponent,
    'regular-kaaba': kaaba_svg_1.ReactComponent,
    'regular-kazoo': kazoo_svg_1.ReactComponent,
    'regular-kerning': kerning_svg_1.ReactComponent,
    'regular-key-skeleton': key_skeleton_svg_1.ReactComponent,
    'regular-key': key_svg_1.ReactComponent,
    'regular-keyboard-down': keyboard_down_svg_1.ReactComponent,
    'regular-keyboard-left': keyboard_left_svg_1.ReactComponent,
    'regular-keyboard': keyboard_svg_1.ReactComponent,
    'regular-keynote': keynote_svg_1.ReactComponent,
    'regular-khanda': khanda_svg_1.ReactComponent,
    'regular-kidneys': kidneys_svg_1.ReactComponent,
    'regular-kip-sign': kip_sign_svg_1.ReactComponent,
    'regular-kit-medical': kit_medical_svg_1.ReactComponent,
    'regular-kite': kite_svg_1.ReactComponent,
    'regular-kiwi-bird': kiwi_bird_svg_1.ReactComponent,
    'regular-knife-kitchen': knife_kitchen_svg_1.ReactComponent,
    'regular-knife': knife_svg_1.ReactComponent,
    'regular-l': l_svg_1.ReactComponent,
    'regular-lambda': lambda_svg_1.ReactComponent,
    'regular-lamp-desk': lamp_desk_svg_1.ReactComponent,
    'regular-lamp-floor': lamp_floor_svg_1.ReactComponent,
    'regular-lamp-street': lamp_street_svg_1.ReactComponent,
    'regular-lamp': lamp_svg_1.ReactComponent,
    'regular-landmark-dome': landmark_dome_svg_1.ReactComponent,
    'regular-landmark': landmark_svg_1.ReactComponent,
    'regular-language': language_svg_1.ReactComponent,
    'regular-laptop-arrow-down': laptop_arrow_down_svg_1.ReactComponent,
    'regular-laptop-code': laptop_code_svg_1.ReactComponent,
    'regular-laptop-medical': laptop_medical_svg_1.ReactComponent,
    'regular-laptop-mobile': laptop_mobile_svg_1.ReactComponent,
    'regular-laptop-slash': laptop_slash_svg_1.ReactComponent,
    'regular-laptop': laptop_svg_1.ReactComponent,
    'regular-lari-sign': lari_sign_svg_1.ReactComponent,
    'regular-lasso-sparkles': lasso_sparkles_svg_1.ReactComponent,
    'regular-lasso': lasso_svg_1.ReactComponent,
    'regular-layers-minus': layers_minus_svg_1.ReactComponent,
    'regular-layers-plus': layers_plus_svg_1.ReactComponent,
    'regular-layers': layers_svg_1.ReactComponent,
    'regular-leaf-heart': leaf_heart_svg_1.ReactComponent,
    'regular-leaf-maple': leaf_maple_svg_1.ReactComponent,
    'regular-leaf-oak': leaf_oak_svg_1.ReactComponent,
    'regular-leaf': leaf_svg_1.ReactComponent,
    'regular-left-from-line': left_from_line_svg_1.ReactComponent,
    'regular-left-long': left_long_svg_1.ReactComponent,
    'regular-left-right': left_right_svg_1.ReactComponent,
    'regular-left-to-line': left_to_line_svg_1.ReactComponent,
    'regular-left': left_svg_1.ReactComponent,
    'regular-lemon': lemon_svg_1.ReactComponent,
    'regular-less-than-equal': less_than_equal_svg_1.ReactComponent,
    'regular-less-than': less_than_svg_1.ReactComponent,
    'regular-life-ring': life_ring_svg_1.ReactComponent,
    'regular-light-ceiling': light_ceiling_svg_1.ReactComponent,
    'regular-light-switch-off': light_switch_off_svg_1.ReactComponent,
    'regular-light-switch-on': light_switch_on_svg_1.ReactComponent,
    'regular-light-switch': light_switch_svg_1.ReactComponent,
    'regular-lightbulb-dollar': lightbulb_dollar_svg_1.ReactComponent,
    'regular-lightbulb-exclamation': lightbulb_exclamation_svg_1.ReactComponent,
    'regular-lightbulb-on': lightbulb_on_svg_1.ReactComponent,
    'regular-lightbulb-slash': lightbulb_slash_svg_1.ReactComponent,
    'regular-lightbulb': lightbulb_svg_1.ReactComponent,
    'regular-lights-holiday': lights_holiday_svg_1.ReactComponent,
    'regular-line-columns': line_columns_svg_1.ReactComponent,
    'regular-line-height': line_height_svg_1.ReactComponent,
    'regular-link-horizontal-slash': link_horizontal_slash_svg_1.ReactComponent,
    'regular-link-horizontal': link_horizontal_svg_1.ReactComponent,
    'regular-link-simple-slash': link_simple_slash_svg_1.ReactComponent,
    'regular-link-simple': link_simple_svg_1.ReactComponent,
    'regular-link-slash': link_slash_svg_1.ReactComponent,
    'regular-link': link_svg_1.ReactComponent,
    'regular-lips': lips_svg_1.ReactComponent,
    'regular-lira-sign': lira_sign_svg_1.ReactComponent,
    'regular-list-check': list_check_svg_1.ReactComponent,
    'regular-list-dropdown': list_dropdown_svg_1.ReactComponent,
    'regular-list-music': list_music_svg_1.ReactComponent,
    'regular-list-ol': list_ol_svg_1.ReactComponent,
    'regular-list-radio': list_radio_svg_1.ReactComponent,
    'regular-list-timeline': list_timeline_svg_1.ReactComponent,
    'regular-list-tree': list_tree_svg_1.ReactComponent,
    'regular-list-ul': list_ul_svg_1.ReactComponent,
    'regular-list': list_svg_1.ReactComponent,
    'regular-litecoin-sign': litecoin_sign_svg_1.ReactComponent,
    'regular-loader': loader_svg_1.ReactComponent,
    'regular-location-arrow': location_arrow_svg_1.ReactComponent,
    'regular-location-check': location_check_svg_1.ReactComponent,
    'regular-location-crosshairs-slash': location_crosshairs_slash_svg_1.ReactComponent,
    'regular-location-crosshairs': location_crosshairs_svg_1.ReactComponent,
    'regular-location-dot-slash': location_dot_slash_svg_1.ReactComponent,
    'regular-location-dot': location_dot_svg_1.ReactComponent,
    'regular-location-exclamation': location_exclamation_svg_1.ReactComponent,
    'regular-location-minus': location_minus_svg_1.ReactComponent,
    'regular-location-pen': location_pen_svg_1.ReactComponent,
    'regular-location-plus': location_plus_svg_1.ReactComponent,
    'regular-location-question': location_question_svg_1.ReactComponent,
    'regular-location-slash': location_slash_svg_1.ReactComponent,
    'regular-location-smile': location_smile_svg_1.ReactComponent,
    'regular-location-xmark': location_xmark_svg_1.ReactComponent,
    'regular-location': location_svg_1.ReactComponent,
    'regular-lock-keyhole-open': lock_keyhole_open_svg_1.ReactComponent,
    'regular-lock-keyhole': lock_keyhole_svg_1.ReactComponent,
    'regular-lock-open': lock_open_svg_1.ReactComponent,
    'regular-lock': lock_svg_1.ReactComponent,
    'regular-loveseat': loveseat_svg_1.ReactComponent,
    'regular-luchador-mask': luchador_mask_svg_1.ReactComponent,
    'regular-lungs-virus': lungs_virus_svg_1.ReactComponent,
    'regular-lungs': lungs_svg_1.ReactComponent,
    'regular-m': m_svg_1.ReactComponent,
    'regular-mace': mace_svg_1.ReactComponent,
    'regular-magnet': magnet_svg_1.ReactComponent,
    'regular-magnifying-glass-dollar': magnifying_glass_dollar_svg_1.ReactComponent,
    'regular-magnifying-glass-location': magnifying_glass_location_svg_1.ReactComponent,
    'regular-magnifying-glass-minus': magnifying_glass_minus_svg_1.ReactComponent,
    'regular-magnifying-glass-plus': magnifying_glass_plus_svg_1.ReactComponent,
    'regular-magnifying-glass': magnifying_glass_svg_1.ReactComponent,
    'regular-mailbox': mailbox_svg_1.ReactComponent,
    'regular-manat-sign': manat_sign_svg_1.ReactComponent,
    'regular-mandolin': mandolin_svg_1.ReactComponent,
    'regular-manhole': manhole_svg_1.ReactComponent,
    'regular-map-location-dot': map_location_dot_svg_1.ReactComponent,
    'regular-map-location': map_location_svg_1.ReactComponent,
    'regular-map-pin': map_pin_svg_1.ReactComponent,
    'regular-map': map_svg_1.ReactComponent,
    'regular-marker': marker_svg_1.ReactComponent,
    'regular-mars-double': mars_double_svg_1.ReactComponent,
    'regular-mars-stroke-right': mars_stroke_right_svg_1.ReactComponent,
    'regular-mars-stroke-up': mars_stroke_up_svg_1.ReactComponent,
    'regular-mars-stroke': mars_stroke_svg_1.ReactComponent,
    'regular-mars': mars_svg_1.ReactComponent,
    'regular-martini-glass-citrus': martini_glass_citrus_svg_1.ReactComponent,
    'regular-martini-glass-empty': martini_glass_empty_svg_1.ReactComponent,
    'regular-martini-glass': martini_glass_svg_1.ReactComponent,
    'regular-mask-face': mask_face_svg_1.ReactComponent,
    'regular-mask': mask_svg_1.ReactComponent,
    'regular-masks-theater': masks_theater_svg_1.ReactComponent,
    'regular-maximize': maximize_svg_1.ReactComponent,
    'regular-meat': meat_svg_1.ReactComponent,
    'regular-medal': medal_svg_1.ReactComponent,
    'regular-megaphone': megaphone_svg_1.ReactComponent,
    'regular-memo-circle-check': memo_circle_check_svg_1.ReactComponent,
    'regular-memo': memo_svg_1.ReactComponent,
    'regular-memory': memory_svg_1.ReactComponent,
    'regular-menorah': menorah_svg_1.ReactComponent,
    'regular-mercury': mercury_svg_1.ReactComponent,
    'regular-message-arrow-down': message_arrow_down_svg_1.ReactComponent,
    'regular-message-arrow-up-right': message_arrow_up_right_svg_1.ReactComponent,
    'regular-message-arrow-up': message_arrow_up_svg_1.ReactComponent,
    'regular-message-captions': message_captions_svg_1.ReactComponent,
    'regular-message-check': message_check_svg_1.ReactComponent,
    'regular-message-code': message_code_svg_1.ReactComponent,
    'regular-message-dollar': message_dollar_svg_1.ReactComponent,
    'regular-message-dots': message_dots_svg_1.ReactComponent,
    'regular-message-exclamation': message_exclamation_svg_1.ReactComponent,
    'regular-message-image': message_image_svg_1.ReactComponent,
    'regular-message-lines': message_lines_svg_1.ReactComponent,
    'regular-message-medical': message_medical_svg_1.ReactComponent,
    'regular-message-middle-top': message_middle_top_svg_1.ReactComponent,
    'regular-message-middle': message_middle_svg_1.ReactComponent,
    'regular-message-minus': message_minus_svg_1.ReactComponent,
    'regular-message-music': message_music_svg_1.ReactComponent,
    'regular-message-pen': message_pen_svg_1.ReactComponent,
    'regular-message-plus': message_plus_svg_1.ReactComponent,
    'regular-message-question': message_question_svg_1.ReactComponent,
    'regular-message-quote': message_quote_svg_1.ReactComponent,
    'regular-message-slash': message_slash_svg_1.ReactComponent,
    'regular-message-smile': message_smile_svg_1.ReactComponent,
    'regular-message-sms': message_sms_svg_1.ReactComponent,
    'regular-message-text': message_text_svg_1.ReactComponent,
    'regular-message-xmark': message_xmark_svg_1.ReactComponent,
    'regular-message': message_svg_1.ReactComponent,
    'regular-messages-dollar': messages_dollar_svg_1.ReactComponent,
    'regular-messages-question': messages_question_svg_1.ReactComponent,
    'regular-messages': messages_svg_1.ReactComponent,
    'regular-meteor': meteor_svg_1.ReactComponent,
    'regular-meter-bolt': meter_bolt_svg_1.ReactComponent,
    'regular-meter-droplet': meter_droplet_svg_1.ReactComponent,
    'regular-meter-fire': meter_fire_svg_1.ReactComponent,
    'regular-meter': meter_svg_1.ReactComponent,
    'regular-microchip-ai': microchip_ai_svg_1.ReactComponent,
    'regular-microchip': microchip_svg_1.ReactComponent,
    'regular-microphone-lines-slash': microphone_lines_slash_svg_1.ReactComponent,
    'regular-microphone-lines': microphone_lines_svg_1.ReactComponent,
    'regular-microphone-slash': microphone_slash_svg_1.ReactComponent,
    'regular-microphone-stand': microphone_stand_svg_1.ReactComponent,
    'regular-microphone': microphone_svg_1.ReactComponent,
    'regular-microscope': microscope_svg_1.ReactComponent,
    'regular-microwave': microwave_svg_1.ReactComponent,
    'regular-mill-sign': mill_sign_svg_1.ReactComponent,
    'regular-minimize': minimize_svg_1.ReactComponent,
    'regular-minus': minus_svg_1.ReactComponent,
    'regular-mistletoe': mistletoe_svg_1.ReactComponent,
    'regular-mitten': mitten_svg_1.ReactComponent,
    'regular-mobile-button': mobile_button_svg_1.ReactComponent,
    'regular-mobile-notch': mobile_notch_svg_1.ReactComponent,
    'regular-mobile-screen-button': mobile_screen_button_svg_1.ReactComponent,
    'regular-mobile-screen': mobile_screen_svg_1.ReactComponent,
    'regular-mobile': mobile_svg_1.ReactComponent,
    'regular-money-bill-1-wave': money_bill_1_wave_svg_1.ReactComponent,
    'regular-money-bill-1': money_bill_1_svg_1.ReactComponent,
    'regular-money-bill-simple-wave': money_bill_simple_wave_svg_1.ReactComponent,
    'regular-money-bill-simple': money_bill_simple_svg_1.ReactComponent,
    'regular-money-bill-wave': money_bill_wave_svg_1.ReactComponent,
    'regular-money-bill': money_bill_svg_1.ReactComponent,
    'regular-money-bills-simple': money_bills_simple_svg_1.ReactComponent,
    'regular-money-bills': money_bills_svg_1.ReactComponent,
    'regular-money-check-dollar-pen': money_check_dollar_pen_svg_1.ReactComponent,
    'regular-money-check-dollar': money_check_dollar_svg_1.ReactComponent,
    'regular-money-check-pen': money_check_pen_svg_1.ReactComponent,
    'regular-money-check': money_check_svg_1.ReactComponent,
    'regular-monitor-waveform': monitor_waveform_svg_1.ReactComponent,
    'regular-monkey': monkey_svg_1.ReactComponent,
    'regular-monument': monument_svg_1.ReactComponent,
    'regular-moon-cloud': moon_cloud_svg_1.ReactComponent,
    'regular-moon-over-sun': moon_over_sun_svg_1.ReactComponent,
    'regular-moon-stars': moon_stars_svg_1.ReactComponent,
    'regular-moon': moon_svg_1.ReactComponent,
    'regular-mortar-pestle': mortar_pestle_svg_1.ReactComponent,
    'regular-mosque': mosque_svg_1.ReactComponent,
    'regular-motorcycle': motorcycle_svg_1.ReactComponent,
    'regular-mountain': mountain_svg_1.ReactComponent,
    'regular-mountains': mountains_svg_1.ReactComponent,
    'regular-mp3-player': mp3_player_svg_1.ReactComponent,
    'regular-mug-hot': mug_hot_svg_1.ReactComponent,
    'regular-mug-marshmallows': mug_marshmallows_svg_1.ReactComponent,
    'regular-mug-saucer': mug_saucer_svg_1.ReactComponent,
    'regular-mug-tea-saucer': mug_tea_saucer_svg_1.ReactComponent,
    'regular-mug-tea': mug_tea_svg_1.ReactComponent,
    'regular-mug': mug_svg_1.ReactComponent,
    'regular-music-note-slash': music_note_slash_svg_1.ReactComponent,
    'regular-music-note': music_note_svg_1.ReactComponent,
    'regular-music-slash': music_slash_svg_1.ReactComponent,
    'regular-music': music_svg_1.ReactComponent,
    'regular-n': n_svg_1.ReactComponent,
    'regular-naira-sign': naira_sign_svg_1.ReactComponent,
    'regular-narwhal': narwhal_svg_1.ReactComponent,
    'regular-network-wired': network_wired_svg_1.ReactComponent,
    'regular-neuter': neuter_svg_1.ReactComponent,
    'regular-newspaper': newspaper_svg_1.ReactComponent,
    'regular-not-equal': not_equal_svg_1.ReactComponent,
    'regular-notdef': notdef_svg_1.ReactComponent,
    'regular-note-medical': note_medical_svg_1.ReactComponent,
    'regular-note-sticky': note_sticky_svg_1.ReactComponent,
    'regular-note': note_svg_1.ReactComponent,
    'regular-notes-medical': notes_medical_svg_1.ReactComponent,
    'regular-notes': notes_svg_1.ReactComponent,
    'regular-o': o_svg_1.ReactComponent,
    'regular-object-group': object_group_svg_1.ReactComponent,
    'regular-object-ungroup': object_ungroup_svg_1.ReactComponent,
    'regular-octagon-divide': octagon_divide_svg_1.ReactComponent,
    'regular-octagon-exclamation': octagon_exclamation_svg_1.ReactComponent,
    'regular-octagon-minus': octagon_minus_svg_1.ReactComponent,
    'regular-octagon-plus': octagon_plus_svg_1.ReactComponent,
    'regular-octagon-xmark': octagon_xmark_svg_1.ReactComponent,
    'regular-octagon': octagon_svg_1.ReactComponent,
    'regular-oil-can-drip': oil_can_drip_svg_1.ReactComponent,
    'regular-oil-can': oil_can_svg_1.ReactComponent,
    'regular-oil-temperature': oil_temperature_svg_1.ReactComponent,
    'regular-om': om_svg_1.ReactComponent,
    'regular-omega': omega_svg_1.ReactComponent,
    'regular-option': option_svg_1.ReactComponent,
    'regular-ornament': ornament_svg_1.ReactComponent,
    'regular-otter': otter_svg_1.ReactComponent,
    'regular-outdent': outdent_svg_1.ReactComponent,
    'regular-outlet': outlet_svg_1.ReactComponent,
    'regular-oven': oven_svg_1.ReactComponent,
    'regular-overline': overline_svg_1.ReactComponent,
    'regular-p': p_svg_1.ReactComponent,
    'regular-pager': pager_svg_1.ReactComponent,
    'regular-paint-brush-fine': paint_brush_fine_svg_1.ReactComponent,
    'regular-paint-brush': paint_brush_svg_1.ReactComponent,
    'regular-paint-roller': paint_roller_svg_1.ReactComponent,
    'regular-paintbrush-pencil': paintbrush_pencil_svg_1.ReactComponent,
    'regular-palette-boxes': palette_boxes_svg_1.ReactComponent,
    'regular-palette': palette_svg_1.ReactComponent,
    'regular-pallet-box': pallet_box_svg_1.ReactComponent,
    'regular-pallet-boxes': pallet_boxes_svg_1.ReactComponent,
    'regular-pallet': pallet_svg_1.ReactComponent,
    'regular-panorama': panorama_svg_1.ReactComponent,
    'regular-paper-plane-top': paper_plane_top_svg_1.ReactComponent,
    'regular-paper-plane': paper_plane_svg_1.ReactComponent,
    'regular-paperclip': paperclip_svg_1.ReactComponent,
    'regular-parachute-box': parachute_box_svg_1.ReactComponent,
    'regular-paragraph-left': paragraph_left_svg_1.ReactComponent,
    'regular-paragraph': paragraph_svg_1.ReactComponent,
    'regular-passport': passport_svg_1.ReactComponent,
    'regular-paste': paste_svg_1.ReactComponent,
    'regular-pause': pause_svg_1.ReactComponent,
    'regular-paw-claws': paw_claws_svg_1.ReactComponent,
    'regular-paw-simple': paw_simple_svg_1.ReactComponent,
    'regular-paw': paw_svg_1.ReactComponent,
    'regular-peace': peace_svg_1.ReactComponent,
    'regular-peach': peach_svg_1.ReactComponent,
    'regular-pear': pear_svg_1.ReactComponent,
    'regular-pedestal': pedestal_svg_1.ReactComponent,
    'regular-pegasus': pegasus_svg_1.ReactComponent,
    'regular-pen-circle': pen_circle_svg_1.ReactComponent,
    'regular-pen-clip-slash': pen_clip_slash_svg_1.ReactComponent,
    'regular-pen-clip': pen_clip_svg_1.ReactComponent,
    'regular-pen-fancy-slash': pen_fancy_slash_svg_1.ReactComponent,
    'regular-pen-fancy': pen_fancy_svg_1.ReactComponent,
    'regular-pen-field': pen_field_svg_1.ReactComponent,
    'regular-pen-line': pen_line_svg_1.ReactComponent,
    'regular-pen-nib': pen_nib_svg_1.ReactComponent,
    'regular-pen-paintbrush': pen_paintbrush_svg_1.ReactComponent,
    'regular-pen-ruler': pen_ruler_svg_1.ReactComponent,
    'regular-pen-slash': pen_slash_svg_1.ReactComponent,
    'regular-pen-swirl': pen_swirl_svg_1.ReactComponent,
    'regular-pen-to-square': pen_to_square_svg_1.ReactComponent,
    'regular-pen': pen_svg_1.ReactComponent,
    'regular-pencil-slash': pencil_slash_svg_1.ReactComponent,
    'regular-pencil': pencil_svg_1.ReactComponent,
    'regular-people-arrows-left-right': people_arrows_left_right_svg_1.ReactComponent,
    'regular-people-carry-box': people_carry_box_svg_1.ReactComponent,
    'regular-pepper-hot': pepper_hot_svg_1.ReactComponent,
    'regular-percent': percent_svg_1.ReactComponent,
    'regular-person-biking-mountain': person_biking_mountain_svg_1.ReactComponent,
    'regular-person-biking': person_biking_svg_1.ReactComponent,
    'regular-person-booth': person_booth_svg_1.ReactComponent,
    'regular-person-carry-box': person_carry_box_svg_1.ReactComponent,
    'regular-person-digging': person_digging_svg_1.ReactComponent,
    'regular-person-dolly-empty': person_dolly_empty_svg_1.ReactComponent,
    'regular-person-dolly': person_dolly_svg_1.ReactComponent,
    'regular-person-dots-from-line': person_dots_from_line_svg_1.ReactComponent,
    'regular-person-dress-simple': person_dress_simple_svg_1.ReactComponent,
    'regular-person-dress': person_dress_svg_1.ReactComponent,
    'regular-person-from-portal': person_from_portal_svg_1.ReactComponent,
    'regular-person-hiking': person_hiking_svg_1.ReactComponent,
    'regular-person-pinball': person_pinball_svg_1.ReactComponent,
    'regular-person-praying': person_praying_svg_1.ReactComponent,
    'regular-person-running': person_running_svg_1.ReactComponent,
    'regular-person-seat-reclined': person_seat_reclined_svg_1.ReactComponent,
    'regular-person-seat': person_seat_svg_1.ReactComponent,
    'regular-person-sign': person_sign_svg_1.ReactComponent,
    'regular-person-simple': person_simple_svg_1.ReactComponent,
    'regular-person-skating': person_skating_svg_1.ReactComponent,
    'regular-person-ski-jumping': person_ski_jumping_svg_1.ReactComponent,
    'regular-person-ski-lift': person_ski_lift_svg_1.ReactComponent,
    'regular-person-skiing-nordic': person_skiing_nordic_svg_1.ReactComponent,
    'regular-person-skiing': person_skiing_svg_1.ReactComponent,
    'regular-person-sledding': person_sledding_svg_1.ReactComponent,
    'regular-person-snowboarding': person_snowboarding_svg_1.ReactComponent,
    'regular-person-snowmobiling': person_snowmobiling_svg_1.ReactComponent,
    'regular-person-swimming': person_swimming_svg_1.ReactComponent,
    'regular-person-to-portal': person_to_portal_svg_1.ReactComponent,
    'regular-person-walking-with-cane': person_walking_with_cane_svg_1.ReactComponent,
    'regular-person-walking': person_walking_svg_1.ReactComponent,
    'regular-person': person_svg_1.ReactComponent,
    'regular-peseta-sign': peseta_sign_svg_1.ReactComponent,
    'regular-peso-sign': peso_sign_svg_1.ReactComponent,
    'regular-phone-arrow-down-left': phone_arrow_down_left_svg_1.ReactComponent,
    'regular-phone-arrow-up-right': phone_arrow_up_right_svg_1.ReactComponent,
    'regular-phone-flip': phone_flip_svg_1.ReactComponent,
    'regular-phone-hangup': phone_hangup_svg_1.ReactComponent,
    'regular-phone-missed': phone_missed_svg_1.ReactComponent,
    'regular-phone-office': phone_office_svg_1.ReactComponent,
    'regular-phone-plus': phone_plus_svg_1.ReactComponent,
    'regular-phone-rotary': phone_rotary_svg_1.ReactComponent,
    'regular-phone-slash': phone_slash_svg_1.ReactComponent,
    'regular-phone-volume': phone_volume_svg_1.ReactComponent,
    'regular-phone-xmark': phone_xmark_svg_1.ReactComponent,
    'regular-phone': phone_svg_1.ReactComponent,
    'regular-photo-film-music': photo_film_music_svg_1.ReactComponent,
    'regular-photo-film': photo_film_svg_1.ReactComponent,
    'regular-pi': pi_svg_1.ReactComponent,
    'regular-piano-keyboard': piano_keyboard_svg_1.ReactComponent,
    'regular-piano': piano_svg_1.ReactComponent,
    'regular-pie': pie_svg_1.ReactComponent,
    'regular-pig': pig_svg_1.ReactComponent,
    'regular-piggy-bank': piggy_bank_svg_1.ReactComponent,
    'regular-pills': pills_svg_1.ReactComponent,
    'regular-pinball': pinball_svg_1.ReactComponent,
    'regular-pizza-slice': pizza_slice_svg_1.ReactComponent,
    'regular-pizza': pizza_svg_1.ReactComponent,
    'regular-place-of-worship': place_of_worship_svg_1.ReactComponent,
    'regular-plane-arrival': plane_arrival_svg_1.ReactComponent,
    'regular-plane-departure': plane_departure_svg_1.ReactComponent,
    'regular-plane-engines': plane_engines_svg_1.ReactComponent,
    'regular-plane-prop': plane_prop_svg_1.ReactComponent,
    'regular-plane-slash': plane_slash_svg_1.ReactComponent,
    'regular-plane-tail': plane_tail_svg_1.ReactComponent,
    'regular-plane-up-slash': plane_up_slash_svg_1.ReactComponent,
    'regular-plane-up': plane_up_svg_1.ReactComponent,
    'regular-plane': plane_svg_1.ReactComponent,
    'regular-planet-moon': planet_moon_svg_1.ReactComponent,
    'regular-planet-ringed': planet_ringed_svg_1.ReactComponent,
    'regular-play-pause': play_pause_svg_1.ReactComponent,
    'regular-play': play_svg_1.ReactComponent,
    'regular-plug': plug_svg_1.ReactComponent,
    'regular-plus-minus': plus_minus_svg_1.ReactComponent,
    'regular-plus': plus_svg_1.ReactComponent,
    'regular-podcast': podcast_svg_1.ReactComponent,
    'regular-podium-star': podium_star_svg_1.ReactComponent,
    'regular-podium': podium_svg_1.ReactComponent,
    'regular-police-box': police_box_svg_1.ReactComponent,
    'regular-poll-people': poll_people_svg_1.ReactComponent,
    'regular-poo-bolt': poo_bolt_svg_1.ReactComponent,
    'regular-poo': poo_svg_1.ReactComponent,
    'regular-poop': poop_svg_1.ReactComponent,
    'regular-popcorn': popcorn_svg_1.ReactComponent,
    'regular-power-off': power_off_svg_1.ReactComponent,
    'regular-prescription-bottle-medical': prescription_bottle_medical_svg_1.ReactComponent,
    'regular-prescription-bottle': prescription_bottle_svg_1.ReactComponent,
    'regular-prescription': prescription_svg_1.ReactComponent,
    'regular-presentation-screen': presentation_screen_svg_1.ReactComponent,
    'regular-print-magnifying-glass': print_magnifying_glass_svg_1.ReactComponent,
    'regular-print-slash': print_slash_svg_1.ReactComponent,
    'regular-print': print_svg_1.ReactComponent,
    'regular-projector': projector_svg_1.ReactComponent,
    'regular-pump-medical': pump_medical_svg_1.ReactComponent,
    'regular-pump-soap': pump_soap_svg_1.ReactComponent,
    'regular-pumpkin': pumpkin_svg_1.ReactComponent,
    'regular-puzzle-piece-simple': puzzle_piece_simple_svg_1.ReactComponent,
    'regular-puzzle-piece': puzzle_piece_svg_1.ReactComponent,
    'regular-q': q_svg_1.ReactComponent,
    'regular-qrcode': qrcode_svg_1.ReactComponent,
    'regular-question': question_svg_1.ReactComponent,
    'regular-quidditch-broom-ball': quidditch_broom_ball_svg_1.ReactComponent,
    'regular-quote-left-round': quote_left_round_svg_1.ReactComponent,
    'regular-quote-left': quote_left_svg_1.ReactComponent,
    'regular-quote-right-round': quote_right_round_svg_1.ReactComponent,
    'regular-quote-right': quote_right_svg_1.ReactComponent,
    'regular-r': r_svg_1.ReactComponent,
    'regular-rabbit-running': rabbit_running_svg_1.ReactComponent,
    'regular-rabbit': rabbit_svg_1.ReactComponent,
    'regular-racquet': racquet_svg_1.ReactComponent,
    'regular-radar': radar_svg_1.ReactComponent,
    'regular-radiation': radiation_svg_1.ReactComponent,
    'regular-radio-tuner': radio_tuner_svg_1.ReactComponent,
    'regular-radio': radio_svg_1.ReactComponent,
    'regular-rainbow': rainbow_svg_1.ReactComponent,
    'regular-raindrops': raindrops_svg_1.ReactComponent,
    'regular-ram': ram_svg_1.ReactComponent,
    'regular-ramp-loading': ramp_loading_svg_1.ReactComponent,
    'regular-raygun': raygun_svg_1.ReactComponent,
    'regular-receipt': receipt_svg_1.ReactComponent,
    'regular-record-vinyl': record_vinyl_svg_1.ReactComponent,
    'regular-rectangle-ad': rectangle_ad_svg_1.ReactComponent,
    'regular-rectangle-barcode': rectangle_barcode_svg_1.ReactComponent,
    'regular-rectangle-list': rectangle_list_svg_1.ReactComponent,
    'regular-rectangle-terminal': rectangle_terminal_svg_1.ReactComponent,
    'regular-rectangle-vertical-history': rectangle_vertical_history_svg_1.ReactComponent,
    'regular-rectangle-vertical': rectangle_vertical_svg_1.ReactComponent,
    'regular-rectangle-wide': rectangle_wide_svg_1.ReactComponent,
    'regular-rectangle-xmark': rectangle_xmark_svg_1.ReactComponent,
    'regular-rectangle': rectangle_svg_1.ReactComponent,
    'regular-recycle': recycle_svg_1.ReactComponent,
    'regular-refrigerator': refrigerator_svg_1.ReactComponent,
    'regular-registered': registered_svg_1.ReactComponent,
    'regular-repeat-1': repeat_1_svg_1.ReactComponent,
    'regular-repeat': repeat_svg_1.ReactComponent,
    'regular-reply-all': reply_all_svg_1.ReactComponent,
    'regular-reply-clock': reply_clock_svg_1.ReactComponent,
    'regular-reply': reply_svg_1.ReactComponent,
    'regular-republican': republican_svg_1.ReactComponent,
    'regular-restroom-simple': restroom_simple_svg_1.ReactComponent,
    'regular-restroom': restroom_svg_1.ReactComponent,
    'regular-retweet': retweet_svg_1.ReactComponent,
    'regular-rhombus': rhombus_svg_1.ReactComponent,
    'regular-ribbon': ribbon_svg_1.ReactComponent,
    'regular-right-from-bracket': right_from_bracket_svg_1.ReactComponent,
    'regular-right-from-line': right_from_line_svg_1.ReactComponent,
    'regular-right-left': right_left_svg_1.ReactComponent,
    'regular-right-long': right_long_svg_1.ReactComponent,
    'regular-right-to-bracket': right_to_bracket_svg_1.ReactComponent,
    'regular-right-to-line': right_to_line_svg_1.ReactComponent,
    'regular-right': right_svg_1.ReactComponent,
    'regular-ring': ring_svg_1.ReactComponent,
    'regular-rings-wedding': rings_wedding_svg_1.ReactComponent,
    'regular-road': road_svg_1.ReactComponent,
    'regular-robot': robot_svg_1.ReactComponent,
    'regular-rocket-launch': rocket_launch_svg_1.ReactComponent,
    'regular-rocket': rocket_svg_1.ReactComponent,
    'regular-rotate-exclamation': rotate_exclamation_svg_1.ReactComponent,
    'regular-rotate-forward': rotate_forward_svg_1.ReactComponent,
    'regular-rotate-left': rotate_left_svg_1.ReactComponent,
    'regular-rotate': rotate_svg_1.ReactComponent,
    'regular-route-highway': route_highway_svg_1.ReactComponent,
    'regular-route-interstate': route_interstate_svg_1.ReactComponent,
    'regular-route': route_svg_1.ReactComponent,
    'regular-router': router_svg_1.ReactComponent,
    'regular-rss': rss_svg_1.ReactComponent,
    'regular-ruble-sign': ruble_sign_svg_1.ReactComponent,
    'regular-ruler-combined': ruler_combined_svg_1.ReactComponent,
    'regular-ruler-horizontal': ruler_horizontal_svg_1.ReactComponent,
    'regular-ruler-triangle': ruler_triangle_svg_1.ReactComponent,
    'regular-ruler-vertical': ruler_vertical_svg_1.ReactComponent,
    'regular-ruler': ruler_svg_1.ReactComponent,
    'regular-rupee-sign': rupee_sign_svg_1.ReactComponent,
    'regular-rupiah-sign': rupiah_sign_svg_1.ReactComponent,
    'regular-rv': rv_svg_1.ReactComponent,
    'regular-s': s_svg_1.ReactComponent,
    'regular-sack-dollar': sack_dollar_svg_1.ReactComponent,
    'regular-sack': sack_svg_1.ReactComponent,
    'regular-salad': salad_svg_1.ReactComponent,
    'regular-sandwich': sandwich_svg_1.ReactComponent,
    'regular-satellite-dish': satellite_dish_svg_1.ReactComponent,
    'regular-satellite': satellite_svg_1.ReactComponent,
    'regular-sausage': sausage_svg_1.ReactComponent,
    'regular-saxophone-fire': saxophone_fire_svg_1.ReactComponent,
    'regular-saxophone': saxophone_svg_1.ReactComponent,
    'regular-scale-balanced': scale_balanced_svg_1.ReactComponent,
    'regular-scale-unbalanced-flip': scale_unbalanced_flip_svg_1.ReactComponent,
    'regular-scale-unbalanced': scale_unbalanced_svg_1.ReactComponent,
    'regular-scalpel-line-dashed': scalpel_line_dashed_svg_1.ReactComponent,
    'regular-scalpel': scalpel_svg_1.ReactComponent,
    'regular-scanner-gun': scanner_gun_svg_1.ReactComponent,
    'regular-scanner-keyboard': scanner_keyboard_svg_1.ReactComponent,
    'regular-scanner-touchscreen': scanner_touchscreen_svg_1.ReactComponent,
    'regular-scanner': scanner_svg_1.ReactComponent,
    'regular-scarecrow': scarecrow_svg_1.ReactComponent,
    'regular-scarf': scarf_svg_1.ReactComponent,
    'regular-school': school_svg_1.ReactComponent,
    'regular-scissors': scissors_svg_1.ReactComponent,
    'regular-screen-users': screen_users_svg_1.ReactComponent,
    'regular-screencast': screencast_svg_1.ReactComponent,
    'regular-screwdriver-wrench': screwdriver_wrench_svg_1.ReactComponent,
    'regular-screwdriver': screwdriver_svg_1.ReactComponent,
    'regular-scribble': scribble_svg_1.ReactComponent,
    'regular-scroll-old': scroll_old_svg_1.ReactComponent,
    'regular-scroll-torah': scroll_torah_svg_1.ReactComponent,
    'regular-scroll': scroll_svg_1.ReactComponent,
    'regular-scrubber': scrubber_svg_1.ReactComponent,
    'regular-scythe': scythe_svg_1.ReactComponent,
    'regular-sd-card': sd_card_svg_1.ReactComponent,
    'regular-sd-cards': sd_cards_svg_1.ReactComponent,
    'regular-seal-exclamation': seal_exclamation_svg_1.ReactComponent,
    'regular-seal-question': seal_question_svg_1.ReactComponent,
    'regular-seal': seal_svg_1.ReactComponent,
    'regular-seat-airline': seat_airline_svg_1.ReactComponent,
    'regular-section': section_svg_1.ReactComponent,
    'regular-seedling': seedling_svg_1.ReactComponent,
    'regular-send-back': send_back_svg_1.ReactComponent,
    'regular-send-backward': send_backward_svg_1.ReactComponent,
    'regular-sensor-cloud': sensor_cloud_svg_1.ReactComponent,
    'regular-sensor-fire': sensor_fire_svg_1.ReactComponent,
    'regular-sensor-on': sensor_on_svg_1.ReactComponent,
    'regular-sensor-triangle-exclamation': sensor_triangle_exclamation_svg_1.ReactComponent,
    'regular-sensor': sensor_svg_1.ReactComponent,
    'regular-server': server_svg_1.ReactComponent,
    'regular-shapes': shapes_svg_1.ReactComponent,
    'regular-share-all': share_all_svg_1.ReactComponent,
    'regular-share-from-square': share_from_square_svg_1.ReactComponent,
    'regular-share-nodes': share_nodes_svg_1.ReactComponent,
    'regular-share': share_svg_1.ReactComponent,
    'regular-sheep': sheep_svg_1.ReactComponent,
    'regular-shekel-sign': shekel_sign_svg_1.ReactComponent,
    'regular-shelves-empty': shelves_empty_svg_1.ReactComponent,
    'regular-shelves': shelves_svg_1.ReactComponent,
    'regular-shield-blank': shield_blank_svg_1.ReactComponent,
    'regular-shield-check': shield_check_svg_1.ReactComponent,
    'regular-shield-cross': shield_cross_svg_1.ReactComponent,
    'regular-shield-exclamation': shield_exclamation_svg_1.ReactComponent,
    'regular-shield-keyhole': shield_keyhole_svg_1.ReactComponent,
    'regular-shield-minus': shield_minus_svg_1.ReactComponent,
    'regular-shield-plus': shield_plus_svg_1.ReactComponent,
    'regular-shield-slash': shield_slash_svg_1.ReactComponent,
    'regular-shield-virus': shield_virus_svg_1.ReactComponent,
    'regular-shield-xmark': shield_xmark_svg_1.ReactComponent,
    'regular-shield': shield_svg_1.ReactComponent,
    'regular-ship': ship_svg_1.ReactComponent,
    'regular-shish-kebab': shish_kebab_svg_1.ReactComponent,
    'regular-shoe-prints': shoe_prints_svg_1.ReactComponent,
    'regular-shop-slash': shop_slash_svg_1.ReactComponent,
    'regular-shop': shop_svg_1.ReactComponent,
    'regular-shovel-snow': shovel_snow_svg_1.ReactComponent,
    'regular-shovel': shovel_svg_1.ReactComponent,
    'regular-shower-down': shower_down_svg_1.ReactComponent,
    'regular-shower': shower_svg_1.ReactComponent,
    'regular-shredder': shredder_svg_1.ReactComponent,
    'regular-shuffle': shuffle_svg_1.ReactComponent,
    'regular-shuttle-space': shuttle_space_svg_1.ReactComponent,
    'regular-shuttlecock': shuttlecock_svg_1.ReactComponent,
    'regular-sickle': sickle_svg_1.ReactComponent,
    'regular-sidebar-flip': sidebar_flip_svg_1.ReactComponent,
    'regular-sidebar': sidebar_svg_1.ReactComponent,
    'regular-sigma': sigma_svg_1.ReactComponent,
    'regular-sign-hanging': sign_hanging_svg_1.ReactComponent,
    'regular-signal-bars-fair': signal_bars_fair_svg_1.ReactComponent,
    'regular-signal-bars-good': signal_bars_good_svg_1.ReactComponent,
    'regular-signal-bars-slash': signal_bars_slash_svg_1.ReactComponent,
    'regular-signal-bars-weak': signal_bars_weak_svg_1.ReactComponent,
    'regular-signal-bars': signal_bars_svg_1.ReactComponent,
    'regular-signal-fair': signal_fair_svg_1.ReactComponent,
    'regular-signal-good': signal_good_svg_1.ReactComponent,
    'regular-signal-slash': signal_slash_svg_1.ReactComponent,
    'regular-signal-stream-slash': signal_stream_slash_svg_1.ReactComponent,
    'regular-signal-stream': signal_stream_svg_1.ReactComponent,
    'regular-signal-strong': signal_strong_svg_1.ReactComponent,
    'regular-signal-weak': signal_weak_svg_1.ReactComponent,
    'regular-signal': signal_svg_1.ReactComponent,
    'regular-signature': signature_svg_1.ReactComponent,
    'regular-signs-post': signs_post_svg_1.ReactComponent,
    'regular-sim-card': sim_card_svg_1.ReactComponent,
    'regular-sim-cards': sim_cards_svg_1.ReactComponent,
    'regular-sink': sink_svg_1.ReactComponent,
    'regular-siren-on': siren_on_svg_1.ReactComponent,
    'regular-siren': siren_svg_1.ReactComponent,
    'regular-sitemap': sitemap_svg_1.ReactComponent,
    'regular-skeleton': skeleton_svg_1.ReactComponent,
    'regular-skull-cow': skull_cow_svg_1.ReactComponent,
    'regular-skull-crossbones': skull_crossbones_svg_1.ReactComponent,
    'regular-skull': skull_svg_1.ReactComponent,
    'regular-slash': slash_svg_1.ReactComponent,
    'regular-sleigh': sleigh_svg_1.ReactComponent,
    'regular-slider': slider_svg_1.ReactComponent,
    'regular-sliders-up': sliders_up_svg_1.ReactComponent,
    'regular-sliders': sliders_svg_1.ReactComponent,
    'regular-smog': smog_svg_1.ReactComponent,
    'regular-smoke': smoke_svg_1.ReactComponent,
    'regular-smoking': smoking_svg_1.ReactComponent,
    'regular-snake': snake_svg_1.ReactComponent,
    'regular-snooze': snooze_svg_1.ReactComponent,
    'regular-snow-blowing': snow_blowing_svg_1.ReactComponent,
    'regular-snowflake': snowflake_svg_1.ReactComponent,
    'regular-snowflakes': snowflakes_svg_1.ReactComponent,
    'regular-snowman-head': snowman_head_svg_1.ReactComponent,
    'regular-snowman': snowman_svg_1.ReactComponent,
    'regular-snowplow': snowplow_svg_1.ReactComponent,
    'regular-soap': soap_svg_1.ReactComponent,
    'regular-socks': socks_svg_1.ReactComponent,
    'regular-solar-panel': solar_panel_svg_1.ReactComponent,
    'regular-solar-system': solar_system_svg_1.ReactComponent,
    'regular-sort-down': sort_down_svg_1.ReactComponent,
    'regular-sort-up': sort_up_svg_1.ReactComponent,
    'regular-sort': sort_svg_1.ReactComponent,
    'regular-spa': spa_svg_1.ReactComponent,
    'regular-space-station-moon-construction': space_station_moon_construction_svg_1.ReactComponent,
    'regular-space-station-moon': space_station_moon_svg_1.ReactComponent,
    'regular-spade': spade_svg_1.ReactComponent,
    'regular-spaghetti-monster-flying': spaghetti_monster_flying_svg_1.ReactComponent,
    'regular-sparkles': sparkles_svg_1.ReactComponent,
    'regular-speaker': speaker_svg_1.ReactComponent,
    'regular-speakers': speakers_svg_1.ReactComponent,
    'regular-spell-check': spell_check_svg_1.ReactComponent,
    'regular-spider-black-widow': spider_black_widow_svg_1.ReactComponent,
    'regular-spider-web': spider_web_svg_1.ReactComponent,
    'regular-spider': spider_svg_1.ReactComponent,
    'regular-spinner-third': spinner_third_svg_1.ReactComponent,
    'regular-spinner': spinner_svg_1.ReactComponent,
    'regular-split': split_svg_1.ReactComponent,
    'regular-splotch': splotch_svg_1.ReactComponent,
    'regular-spoon': spoon_svg_1.ReactComponent,
    'regular-spray-can': spray_can_svg_1.ReactComponent,
    'regular-sprinkler': sprinkler_svg_1.ReactComponent,
    'regular-square-0': square_0_svg_1.ReactComponent,
    'regular-square-1': square_1_svg_1.ReactComponent,
    'regular-square-2': square_2_svg_1.ReactComponent,
    'regular-square-3': square_3_svg_1.ReactComponent,
    'regular-square-4': square_4_svg_1.ReactComponent,
    'regular-square-5': square_5_svg_1.ReactComponent,
    'regular-square-6': square_6_svg_1.ReactComponent,
    'regular-square-7': square_7_svg_1.ReactComponent,
    'regular-square-8': square_8_svg_1.ReactComponent,
    'regular-square-9': square_9_svg_1.ReactComponent,
    'regular-square-a': square_a_svg_1.ReactComponent,
    'regular-square-ampersand': square_ampersand_svg_1.ReactComponent,
    'regular-square-arrow-down-left': square_arrow_down_left_svg_1.ReactComponent,
    'regular-square-arrow-down-right': square_arrow_down_right_svg_1.ReactComponent,
    'regular-square-arrow-down': square_arrow_down_svg_1.ReactComponent,
    'regular-square-arrow-left': square_arrow_left_svg_1.ReactComponent,
    'regular-square-arrow-right': square_arrow_right_svg_1.ReactComponent,
    'regular-square-arrow-up-left': square_arrow_up_left_svg_1.ReactComponent,
    'regular-square-arrow-up-right': square_arrow_up_right_svg_1.ReactComponent,
    'regular-square-arrow-up': square_arrow_up_svg_1.ReactComponent,
    'regular-square-b': square_b_svg_1.ReactComponent,
    'regular-square-bolt': square_bolt_svg_1.ReactComponent,
    'regular-square-c': square_c_svg_1.ReactComponent,
    'regular-square-caret-down': square_caret_down_svg_1.ReactComponent,
    'regular-square-caret-left': square_caret_left_svg_1.ReactComponent,
    'regular-square-caret-right': square_caret_right_svg_1.ReactComponent,
    'regular-square-caret-up': square_caret_up_svg_1.ReactComponent,
    'regular-square-check': square_check_svg_1.ReactComponent,
    'regular-square-chevron-down': square_chevron_down_svg_1.ReactComponent,
    'regular-square-chevron-left': square_chevron_left_svg_1.ReactComponent,
    'regular-square-chevron-right': square_chevron_right_svg_1.ReactComponent,
    'regular-square-chevron-up': square_chevron_up_svg_1.ReactComponent,
    'regular-square-code': square_code_svg_1.ReactComponent,
    'regular-square-d': square_d_svg_1.ReactComponent,
    'regular-square-dashed': square_dashed_svg_1.ReactComponent,
    'regular-square-divide': square_divide_svg_1.ReactComponent,
    'regular-square-dollar': square_dollar_svg_1.ReactComponent,
    'regular-square-down-left': square_down_left_svg_1.ReactComponent,
    'regular-square-down-right': square_down_right_svg_1.ReactComponent,
    'regular-square-down': square_down_svg_1.ReactComponent,
    'regular-square-e': square_e_svg_1.ReactComponent,
    'regular-square-envelope': square_envelope_svg_1.ReactComponent,
    'regular-square-exclamation': square_exclamation_svg_1.ReactComponent,
    'regular-square-f': square_f_svg_1.ReactComponent,
    'regular-square-fragile': square_fragile_svg_1.ReactComponent,
    'regular-square-full': square_full_svg_1.ReactComponent,
    'regular-square-g': square_g_svg_1.ReactComponent,
    'regular-square-h': square_h_svg_1.ReactComponent,
    'regular-square-heart': square_heart_svg_1.ReactComponent,
    'regular-square-i': square_i_svg_1.ReactComponent,
    'regular-square-info': square_info_svg_1.ReactComponent,
    'regular-square-j': square_j_svg_1.ReactComponent,
    'regular-square-k': square_k_svg_1.ReactComponent,
    'regular-square-l': square_l_svg_1.ReactComponent,
    'regular-square-left': square_left_svg_1.ReactComponent,
    'regular-square-m': square_m_svg_1.ReactComponent,
    'regular-square-minus': square_minus_svg_1.ReactComponent,
    'regular-square-n': square_n_svg_1.ReactComponent,
    'regular-square-o': square_o_svg_1.ReactComponent,
    'regular-square-p': square_p_svg_1.ReactComponent,
    'regular-square-parking-slash': square_parking_slash_svg_1.ReactComponent,
    'regular-square-parking': square_parking_svg_1.ReactComponent,
    'regular-square-pen': square_pen_svg_1.ReactComponent,
    'regular-square-phone-flip': square_phone_flip_svg_1.ReactComponent,
    'regular-square-phone-hangup': square_phone_hangup_svg_1.ReactComponent,
    'regular-square-phone': square_phone_svg_1.ReactComponent,
    'regular-square-plus': square_plus_svg_1.ReactComponent,
    'regular-square-poll-horizontal': square_poll_horizontal_svg_1.ReactComponent,
    'regular-square-poll-vertical': square_poll_vertical_svg_1.ReactComponent,
    'regular-square-q': square_q_svg_1.ReactComponent,
    'regular-square-question': square_question_svg_1.ReactComponent,
    'regular-square-r': square_r_svg_1.ReactComponent,
    'regular-square-right': square_right_svg_1.ReactComponent,
    'regular-square-root-variable': square_root_variable_svg_1.ReactComponent,
    'regular-square-root': square_root_svg_1.ReactComponent,
    'regular-square-rss': square_rss_svg_1.ReactComponent,
    'regular-square-s': square_s_svg_1.ReactComponent,
    'regular-square-share-nodes': square_share_nodes_svg_1.ReactComponent,
    'regular-square-sliders-vertical': square_sliders_vertical_svg_1.ReactComponent,
    'regular-square-sliders': square_sliders_svg_1.ReactComponent,
    'regular-square-small': square_small_svg_1.ReactComponent,
    'regular-square-star': square_star_svg_1.ReactComponent,
    'regular-square-t': square_t_svg_1.ReactComponent,
    'regular-square-this-way-up': square_this_way_up_svg_1.ReactComponent,
    'regular-square-u': square_u_svg_1.ReactComponent,
    'regular-square-up-left': square_up_left_svg_1.ReactComponent,
    'regular-square-up-right': square_up_right_svg_1.ReactComponent,
    'regular-square-up': square_up_svg_1.ReactComponent,
    'regular-square-user': square_user_svg_1.ReactComponent,
    'regular-square-v': square_v_svg_1.ReactComponent,
    'regular-square-w': square_w_svg_1.ReactComponent,
    'regular-square-x': square_x_svg_1.ReactComponent,
    'regular-square-xmark': square_xmark_svg_1.ReactComponent,
    'regular-square-y': square_y_svg_1.ReactComponent,
    'regular-square-z': square_z_svg_1.ReactComponent,
    'regular-square': square_svg_1.ReactComponent,
    'regular-squirrel': squirrel_svg_1.ReactComponent,
    'regular-staff': staff_svg_1.ReactComponent,
    'regular-stairs': stairs_svg_1.ReactComponent,
    'regular-stamp': stamp_svg_1.ReactComponent,
    'regular-standard-definition': standard_definition_svg_1.ReactComponent,
    'regular-star-and-crescent': star_and_crescent_svg_1.ReactComponent,
    'regular-star-christmas': star_christmas_svg_1.ReactComponent,
    'regular-star-exclamation': star_exclamation_svg_1.ReactComponent,
    'regular-star-half-stroke': star_half_stroke_svg_1.ReactComponent,
    'regular-star-half': star_half_svg_1.ReactComponent,
    'regular-star-of-david': star_of_david_svg_1.ReactComponent,
    'regular-star-of-life': star_of_life_svg_1.ReactComponent,
    'regular-star-sharp-half-stroke': star_sharp_half_stroke_svg_1.ReactComponent,
    'regular-star-sharp-half': star_sharp_half_svg_1.ReactComponent,
    'regular-star-sharp': star_sharp_svg_1.ReactComponent,
    'regular-star-shooting': star_shooting_svg_1.ReactComponent,
    'regular-star': star_svg_1.ReactComponent,
    'regular-starfighter-twin-ion-engine-advanced': starfighter_twin_ion_engine_advanced_svg_1.ReactComponent,
    'regular-starfighter-twin-ion-engine': starfighter_twin_ion_engine_svg_1.ReactComponent,
    'regular-starfighter': starfighter_svg_1.ReactComponent,
    'regular-stars': stars_svg_1.ReactComponent,
    'regular-starship-freighter': starship_freighter_svg_1.ReactComponent,
    'regular-starship': starship_svg_1.ReactComponent,
    'regular-steak': steak_svg_1.ReactComponent,
    'regular-steering-wheel': steering_wheel_svg_1.ReactComponent,
    'regular-sterling-sign': sterling_sign_svg_1.ReactComponent,
    'regular-stethoscope': stethoscope_svg_1.ReactComponent,
    'regular-stocking': stocking_svg_1.ReactComponent,
    'regular-stomach': stomach_svg_1.ReactComponent,
    'regular-stop': stop_svg_1.ReactComponent,
    'regular-stopwatch-20': stopwatch_20_svg_1.ReactComponent,
    'regular-stopwatch': stopwatch_svg_1.ReactComponent,
    'regular-store-slash': store_slash_svg_1.ReactComponent,
    'regular-store': store_svg_1.ReactComponent,
    'regular-street-view': street_view_svg_1.ReactComponent,
    'regular-stretcher': stretcher_svg_1.ReactComponent,
    'regular-strikethrough': strikethrough_svg_1.ReactComponent,
    'regular-stroopwafel': stroopwafel_svg_1.ReactComponent,
    'regular-subscript': subscript_svg_1.ReactComponent,
    'regular-suitcase-medical': suitcase_medical_svg_1.ReactComponent,
    'regular-suitcase-rolling': suitcase_rolling_svg_1.ReactComponent,
    'regular-suitcase': suitcase_svg_1.ReactComponent,
    'regular-sun-bright': sun_bright_svg_1.ReactComponent,
    'regular-sun-cloud': sun_cloud_svg_1.ReactComponent,
    'regular-sun-dust': sun_dust_svg_1.ReactComponent,
    'regular-sun-haze': sun_haze_svg_1.ReactComponent,
    'regular-sun': sun_svg_1.ReactComponent,
    'regular-sunglasses': sunglasses_svg_1.ReactComponent,
    'regular-sunrise': sunrise_svg_1.ReactComponent,
    'regular-sunset': sunset_svg_1.ReactComponent,
    'regular-superscript': superscript_svg_1.ReactComponent,
    'regular-swatchbook': swatchbook_svg_1.ReactComponent,
    'regular-sword-laser-alt': sword_laser_alt_svg_1.ReactComponent,
    'regular-sword-laser': sword_laser_svg_1.ReactComponent,
    'regular-sword': sword_svg_1.ReactComponent,
    'regular-swords-laser': swords_laser_svg_1.ReactComponent,
    'regular-swords': swords_svg_1.ReactComponent,
    'regular-symbols': symbols_svg_1.ReactComponent,
    'regular-synagogue': synagogue_svg_1.ReactComponent,
    'regular-syringe': syringe_svg_1.ReactComponent,
    'regular-t': t_svg_1.ReactComponent,
    'regular-table-cells-large': table_cells_large_svg_1.ReactComponent,
    'regular-table-cells': table_cells_svg_1.ReactComponent,
    'regular-table-columns': table_columns_svg_1.ReactComponent,
    'regular-table-layout': table_layout_svg_1.ReactComponent,
    'regular-table-list': table_list_svg_1.ReactComponent,
    'regular-table-pivot': table_pivot_svg_1.ReactComponent,
    'regular-table-rows': table_rows_svg_1.ReactComponent,
    'regular-table-tennis-paddle-ball': table_tennis_paddle_ball_svg_1.ReactComponent,
    'regular-table-tree': table_tree_svg_1.ReactComponent,
    'regular-table': table_svg_1.ReactComponent,
    'regular-tablet-button': tablet_button_svg_1.ReactComponent,
    'regular-tablet-rugged': tablet_rugged_svg_1.ReactComponent,
    'regular-tablet-screen-button': tablet_screen_button_svg_1.ReactComponent,
    'regular-tablet-screen': tablet_screen_svg_1.ReactComponent,
    'regular-tablet': tablet_svg_1.ReactComponent,
    'regular-tablets': tablets_svg_1.ReactComponent,
    'regular-tachograph-digital': tachograph_digital_svg_1.ReactComponent,
    'regular-taco': taco_svg_1.ReactComponent,
    'regular-tag': tag_svg_1.ReactComponent,
    'regular-tags': tags_svg_1.ReactComponent,
    'regular-tally-1': tally_1_svg_1.ReactComponent,
    'regular-tally-2': tally_2_svg_1.ReactComponent,
    'regular-tally-3': tally_3_svg_1.ReactComponent,
    'regular-tally-4': tally_4_svg_1.ReactComponent,
    'regular-tally': tally_svg_1.ReactComponent,
    'regular-tape': tape_svg_1.ReactComponent,
    'regular-taxi-bus': taxi_bus_svg_1.ReactComponent,
    'regular-taxi': taxi_svg_1.ReactComponent,
    'regular-teeth-open': teeth_open_svg_1.ReactComponent,
    'regular-teeth': teeth_svg_1.ReactComponent,
    'regular-telescope': telescope_svg_1.ReactComponent,
    'regular-temperature-arrow-down': temperature_arrow_down_svg_1.ReactComponent,
    'regular-temperature-arrow-up': temperature_arrow_up_svg_1.ReactComponent,
    'regular-temperature-empty': temperature_empty_svg_1.ReactComponent,
    'regular-temperature-full': temperature_full_svg_1.ReactComponent,
    'regular-temperature-half': temperature_half_svg_1.ReactComponent,
    'regular-temperature-high': temperature_high_svg_1.ReactComponent,
    'regular-temperature-list': temperature_list_svg_1.ReactComponent,
    'regular-temperature-low': temperature_low_svg_1.ReactComponent,
    'regular-temperature-quarter': temperature_quarter_svg_1.ReactComponent,
    'regular-temperature-snow': temperature_snow_svg_1.ReactComponent,
    'regular-temperature-sun': temperature_sun_svg_1.ReactComponent,
    'regular-temperature-three-quarters': temperature_three_quarters_svg_1.ReactComponent,
    'regular-tenge-sign': tenge_sign_svg_1.ReactComponent,
    'regular-tennis-ball': tennis_ball_svg_1.ReactComponent,
    'regular-terminal': terminal_svg_1.ReactComponent,
    'regular-text-height': text_height_svg_1.ReactComponent,
    'regular-text-size': text_size_svg_1.ReactComponent,
    'regular-text-slash': text_slash_svg_1.ReactComponent,
    'regular-text-width': text_width_svg_1.ReactComponent,
    'regular-text': text_svg_1.ReactComponent,
    'regular-thermometer': thermometer_svg_1.ReactComponent,
    'regular-theta': theta_svg_1.ReactComponent,
    'regular-thumbs-down': thumbs_down_svg_1.ReactComponent,
    'regular-thumbs-up': thumbs_up_svg_1.ReactComponent,
    'regular-thumbtack': thumbtack_svg_1.ReactComponent,
    'regular-ticket-airline': ticket_airline_svg_1.ReactComponent,
    'regular-ticket-simple': ticket_simple_svg_1.ReactComponent,
    'regular-ticket': ticket_svg_1.ReactComponent,
    'regular-tickets-airline': tickets_airline_svg_1.ReactComponent,
    'regular-tilde': tilde_svg_1.ReactComponent,
    'regular-timeline-arrow': timeline_arrow_svg_1.ReactComponent,
    'regular-timeline': timeline_svg_1.ReactComponent,
    'regular-timer': timer_svg_1.ReactComponent,
    'regular-tire-flat': tire_flat_svg_1.ReactComponent,
    'regular-tire-pressure-warning': tire_pressure_warning_svg_1.ReactComponent,
    'regular-tire-rugged': tire_rugged_svg_1.ReactComponent,
    'regular-tire': tire_svg_1.ReactComponent,
    'regular-toggle-off': toggle_off_svg_1.ReactComponent,
    'regular-toggle-on': toggle_on_svg_1.ReactComponent,
    'regular-toilet-paper-blank-under': toilet_paper_blank_under_svg_1.ReactComponent,
    'regular-toilet-paper-blank': toilet_paper_blank_svg_1.ReactComponent,
    'regular-toilet-paper-slash': toilet_paper_slash_svg_1.ReactComponent,
    'regular-toilet-paper-under-slash': toilet_paper_under_slash_svg_1.ReactComponent,
    'regular-toilet-paper-under': toilet_paper_under_svg_1.ReactComponent,
    'regular-toilet-paper': toilet_paper_svg_1.ReactComponent,
    'regular-toilet': toilet_svg_1.ReactComponent,
    'regular-tombstone-blank': tombstone_blank_svg_1.ReactComponent,
    'regular-tombstone': tombstone_svg_1.ReactComponent,
    'regular-toolbox': toolbox_svg_1.ReactComponent,
    'regular-tooth': tooth_svg_1.ReactComponent,
    'regular-toothbrush': toothbrush_svg_1.ReactComponent,
    'regular-torii-gate': torii_gate_svg_1.ReactComponent,
    'regular-tornado': tornado_svg_1.ReactComponent,
    'regular-tower-broadcast': tower_broadcast_svg_1.ReactComponent,
    'regular-tower-control': tower_control_svg_1.ReactComponent,
    'regular-tractor': tractor_svg_1.ReactComponent,
    'regular-trademark': trademark_svg_1.ReactComponent,
    'regular-traffic-cone': traffic_cone_svg_1.ReactComponent,
    'regular-traffic-light-go': traffic_light_go_svg_1.ReactComponent,
    'regular-traffic-light-slow': traffic_light_slow_svg_1.ReactComponent,
    'regular-traffic-light-stop': traffic_light_stop_svg_1.ReactComponent,
    'regular-traffic-light': traffic_light_svg_1.ReactComponent,
    'regular-trailer': trailer_svg_1.ReactComponent,
    'regular-train-subway-tunnel': train_subway_tunnel_svg_1.ReactComponent,
    'regular-train-subway': train_subway_svg_1.ReactComponent,
    'regular-train-tram': train_tram_svg_1.ReactComponent,
    'regular-train': train_svg_1.ReactComponent,
    'regular-transformer-bolt': transformer_bolt_svg_1.ReactComponent,
    'regular-transgender-alt': transgender_alt_svg_1.ReactComponent,
    'regular-transgender': transgender_svg_1.ReactComponent,
    'regular-transporter-1': transporter_1_svg_1.ReactComponent,
    'regular-transporter-2': transporter_2_svg_1.ReactComponent,
    'regular-transporter-3': transporter_3_svg_1.ReactComponent,
    'regular-transporter-4': transporter_4_svg_1.ReactComponent,
    'regular-transporter-5': transporter_5_svg_1.ReactComponent,
    'regular-transporter-6': transporter_6_svg_1.ReactComponent,
    'regular-transporter-7': transporter_7_svg_1.ReactComponent,
    'regular-transporter-empty': transporter_empty_svg_1.ReactComponent,
    'regular-transporter': transporter_svg_1.ReactComponent,
    'regular-trash-arrow-up': trash_arrow_up_svg_1.ReactComponent,
    'regular-trash-can-arrow-up': trash_can_arrow_up_svg_1.ReactComponent,
    'regular-trash-can-clock': trash_can_clock_svg_1.ReactComponent,
    'regular-trash-can-list': trash_can_list_svg_1.ReactComponent,
    'regular-trash-can-slash': trash_can_slash_svg_1.ReactComponent,
    'regular-trash-can-undo': trash_can_undo_svg_1.ReactComponent,
    'regular-trash-can': trash_can_svg_1.ReactComponent,
    'regular-trash-clock': trash_clock_svg_1.ReactComponent,
    'regular-trash-list': trash_list_svg_1.ReactComponent,
    'regular-trash-slash': trash_slash_svg_1.ReactComponent,
    'regular-trash-undo': trash_undo_svg_1.ReactComponent,
    'regular-trash': trash_svg_1.ReactComponent,
    'regular-treasure-chest': treasure_chest_svg_1.ReactComponent,
    'regular-tree-christmas': tree_christmas_svg_1.ReactComponent,
    'regular-tree-deciduous': tree_deciduous_svg_1.ReactComponent,
    'regular-tree-decorated': tree_decorated_svg_1.ReactComponent,
    'regular-tree-large': tree_large_svg_1.ReactComponent,
    'regular-tree-palm': tree_palm_svg_1.ReactComponent,
    'regular-tree': tree_svg_1.ReactComponent,
    'regular-trees': trees_svg_1.ReactComponent,
    'regular-triangle-exclamation': triangle_exclamation_svg_1.ReactComponent,
    'regular-triangle-instrument': triangle_instrument_svg_1.ReactComponent,
    'regular-triangle-person-digging': triangle_person_digging_svg_1.ReactComponent,
    'regular-triangle': triangle_svg_1.ReactComponent,
    'regular-trophy-star': trophy_star_svg_1.ReactComponent,
    'regular-trophy': trophy_svg_1.ReactComponent,
    'regular-truck-clock': truck_clock_svg_1.ReactComponent,
    'regular-truck-container-empty': truck_container_empty_svg_1.ReactComponent,
    'regular-truck-container': truck_container_svg_1.ReactComponent,
    'regular-truck-fast': truck_fast_svg_1.ReactComponent,
    'regular-truck-flatbed': truck_flatbed_svg_1.ReactComponent,
    'regular-truck-front': truck_front_svg_1.ReactComponent,
    'regular-truck-medical': truck_medical_svg_1.ReactComponent,
    'regular-truck-monster': truck_monster_svg_1.ReactComponent,
    'regular-truck-moving': truck_moving_svg_1.ReactComponent,
    'regular-truck-pickup': truck_pickup_svg_1.ReactComponent,
    'regular-truck-plow': truck_plow_svg_1.ReactComponent,
    'regular-truck-ramp-box': truck_ramp_box_svg_1.ReactComponent,
    'regular-truck-ramp-couch': truck_ramp_couch_svg_1.ReactComponent,
    'regular-truck-ramp': truck_ramp_svg_1.ReactComponent,
    'regular-truck-tow': truck_tow_svg_1.ReactComponent,
    'regular-truck': truck_svg_1.ReactComponent,
    'regular-trumpet': trumpet_svg_1.ReactComponent,
    'regular-tshirt': tshirt_svg_1.ReactComponent,
    'regular-tty-answer': tty_answer_svg_1.ReactComponent,
    'regular-tty': tty_svg_1.ReactComponent,
    'regular-tugrik-sign': tugrik_sign_svg_1.ReactComponent,
    'regular-turkey': turkey_svg_1.ReactComponent,
    'regular-turkish-lira-sign': turkish_lira_sign_svg_1.ReactComponent,
    'regular-turn-down': turn_down_svg_1.ReactComponent,
    'regular-turn-up': turn_up_svg_1.ReactComponent,
    'regular-turntable': turntable_svg_1.ReactComponent,
    'regular-turtle': turtle_svg_1.ReactComponent,
    'regular-tv-music': tv_music_svg_1.ReactComponent,
    'regular-tv-retro': tv_retro_svg_1.ReactComponent,
    'regular-tv': tv_svg_1.ReactComponent,
    'regular-typewriter': typewriter_svg_1.ReactComponent,
    'regular-u': u_svg_1.ReactComponent,
    'regular-ufo-beam': ufo_beam_svg_1.ReactComponent,
    'regular-ufo': ufo_svg_1.ReactComponent,
    'regular-umbrella-beach': umbrella_beach_svg_1.ReactComponent,
    'regular-umbrella-simple': umbrella_simple_svg_1.ReactComponent,
    'regular-umbrella': umbrella_svg_1.ReactComponent,
    'regular-underline': underline_svg_1.ReactComponent,
    'regular-unicorn': unicorn_svg_1.ReactComponent,
    'regular-union': union_svg_1.ReactComponent,
    'regular-universal-access': universal_access_svg_1.ReactComponent,
    'regular-unlock-keyhole': unlock_keyhole_svg_1.ReactComponent,
    'regular-unlock': unlock_svg_1.ReactComponent,
    'regular-up-down-left-right': up_down_left_right_svg_1.ReactComponent,
    'regular-up-down': up_down_svg_1.ReactComponent,
    'regular-up-from-line': up_from_line_svg_1.ReactComponent,
    'regular-up-left': up_left_svg_1.ReactComponent,
    'regular-up-long': up_long_svg_1.ReactComponent,
    'regular-up-right-and-down-left-from-center': up_right_and_down_left_from_center_svg_1.ReactComponent,
    'regular-up-right-from-square': up_right_from_square_svg_1.ReactComponent,
    'regular-up-right': up_right_svg_1.ReactComponent,
    'regular-up-to-line': up_to_line_svg_1.ReactComponent,
    'regular-up': up_svg_1.ReactComponent,
    'regular-upload': upload_svg_1.ReactComponent,
    'regular-usb-drive': usb_drive_svg_1.ReactComponent,
    'regular-user-alien': user_alien_svg_1.ReactComponent,
    'regular-user-astronaut': user_astronaut_svg_1.ReactComponent,
    'regular-user-bounty-hunter': user_bounty_hunter_svg_1.ReactComponent,
    'regular-user-check': user_check_svg_1.ReactComponent,
    'regular-user-clock': user_clock_svg_1.ReactComponent,
    'regular-user-cowboy': user_cowboy_svg_1.ReactComponent,
    'regular-user-crown': user_crown_svg_1.ReactComponent,
    'regular-user-doctor-message': user_doctor_message_svg_1.ReactComponent,
    'regular-user-doctor': user_doctor_svg_1.ReactComponent,
    'regular-user-gear': user_gear_svg_1.ReactComponent,
    'regular-user-graduate': user_graduate_svg_1.ReactComponent,
    'regular-user-group-crown': user_group_crown_svg_1.ReactComponent,
    'regular-user-group': user_group_svg_1.ReactComponent,
    'regular-user-headset': user_headset_svg_1.ReactComponent,
    'regular-user-helmet-safety': user_helmet_safety_svg_1.ReactComponent,
    'regular-user-injured': user_injured_svg_1.ReactComponent,
    'regular-user-large-slash': user_large_slash_svg_1.ReactComponent,
    'regular-user-large': user_large_svg_1.ReactComponent,
    'regular-user-lock': user_lock_svg_1.ReactComponent,
    'regular-user-minus': user_minus_svg_1.ReactComponent,
    'regular-user-music': user_music_svg_1.ReactComponent,
    'regular-user-ninja': user_ninja_svg_1.ReactComponent,
    'regular-user-nurse': user_nurse_svg_1.ReactComponent,
    'regular-user-pen': user_pen_svg_1.ReactComponent,
    'regular-user-pilot-tie': user_pilot_tie_svg_1.ReactComponent,
    'regular-user-pilot': user_pilot_svg_1.ReactComponent,
    'regular-user-plus': user_plus_svg_1.ReactComponent,
    'regular-user-robot': user_robot_svg_1.ReactComponent,
    'regular-user-secret': user_secret_svg_1.ReactComponent,
    'regular-user-shakespeare': user_shakespeare_svg_1.ReactComponent,
    'regular-user-shield': user_shield_svg_1.ReactComponent,
    'regular-user-slash': user_slash_svg_1.ReactComponent,
    'regular-user-tag': user_tag_svg_1.ReactComponent,
    'regular-user-tie': user_tie_svg_1.ReactComponent,
    'regular-user-unlock': user_unlock_svg_1.ReactComponent,
    'regular-user-visor': user_visor_svg_1.ReactComponent,
    'regular-user-xmark': user_xmark_svg_1.ReactComponent,
    'regular-user': user_svg_1.ReactComponent,
    'regular-users-gear': users_gear_svg_1.ReactComponent,
    'regular-users-medical': users_medical_svg_1.ReactComponent,
    'regular-users-slash': users_slash_svg_1.ReactComponent,
    'regular-users': users_svg_1.ReactComponent,
    'regular-utensils': utensils_svg_1.ReactComponent,
    'regular-utility-pole-double': utility_pole_double_svg_1.ReactComponent,
    'regular-utility-pole': utility_pole_svg_1.ReactComponent,
    'regular-v': v_svg_1.ReactComponent,
    'regular-vacuum-robot': vacuum_robot_svg_1.ReactComponent,
    'regular-vacuum': vacuum_svg_1.ReactComponent,
    'regular-value-absolute': value_absolute_svg_1.ReactComponent,
    'regular-van-shuttle': van_shuttle_svg_1.ReactComponent,
    'regular-vault': vault_svg_1.ReactComponent,
    'regular-vector-circle': vector_circle_svg_1.ReactComponent,
    'regular-vector-polygon': vector_polygon_svg_1.ReactComponent,
    'regular-vector-square': vector_square_svg_1.ReactComponent,
    'regular-venus-double': venus_double_svg_1.ReactComponent,
    'regular-venus-mars': venus_mars_svg_1.ReactComponent,
    'regular-venus': venus_svg_1.ReactComponent,
    'regular-vest-patches': vest_patches_svg_1.ReactComponent,
    'regular-vest': vest_svg_1.ReactComponent,
    'regular-vial': vial_svg_1.ReactComponent,
    'regular-vials': vials_svg_1.ReactComponent,
    'regular-video-arrow-down-left': video_arrow_down_left_svg_1.ReactComponent,
    'regular-video-arrow-up-right': video_arrow_up_right_svg_1.ReactComponent,
    'regular-video-plus': video_plus_svg_1.ReactComponent,
    'regular-video-slash': video_slash_svg_1.ReactComponent,
    'regular-video': video_svg_1.ReactComponent,
    'regular-vihara': vihara_svg_1.ReactComponent,
    'regular-violin': violin_svg_1.ReactComponent,
    'regular-virus-slash': virus_slash_svg_1.ReactComponent,
    'regular-virus': virus_svg_1.ReactComponent,
    'regular-viruses': viruses_svg_1.ReactComponent,
    'regular-voicemail': voicemail_svg_1.ReactComponent,
    'regular-volcano': volcano_svg_1.ReactComponent,
    'regular-volleyball-ball': volleyball_ball_svg_1.ReactComponent,
    'regular-volume-high': volume_high_svg_1.ReactComponent,
    'regular-volume-low': volume_low_svg_1.ReactComponent,
    'regular-volume-off': volume_off_svg_1.ReactComponent,
    'regular-volume-slash': volume_slash_svg_1.ReactComponent,
    'regular-volume-xmark': volume_xmark_svg_1.ReactComponent,
    'regular-volume': volume_svg_1.ReactComponent,
    'regular-vr-cardboard': vr_cardboard_svg_1.ReactComponent,
    'regular-w': w_svg_1.ReactComponent,
    'regular-wagon-covered': wagon_covered_svg_1.ReactComponent,
    'regular-walker': walker_svg_1.ReactComponent,
    'regular-walkie-talkie': walkie_talkie_svg_1.ReactComponent,
    'regular-wallet': wallet_svg_1.ReactComponent,
    'regular-wand-magic-sparkles': wand_magic_sparkles_svg_1.ReactComponent,
    'regular-wand-magic': wand_magic_svg_1.ReactComponent,
    'regular-wand-sparkles': wand_sparkles_svg_1.ReactComponent,
    'regular-wand': wand_svg_1.ReactComponent,
    'regular-warehouse-full': warehouse_full_svg_1.ReactComponent,
    'regular-warehouse': warehouse_svg_1.ReactComponent,
    'regular-washing-machine': washing_machine_svg_1.ReactComponent,
    'regular-watch-apple': watch_apple_svg_1.ReactComponent,
    'regular-watch-calculator': watch_calculator_svg_1.ReactComponent,
    'regular-watch-fitness': watch_fitness_svg_1.ReactComponent,
    'regular-watch-smart': watch_smart_svg_1.ReactComponent,
    'regular-watch': watch_svg_1.ReactComponent,
    'regular-water-arrow-down': water_arrow_down_svg_1.ReactComponent,
    'regular-water-arrow-up': water_arrow_up_svg_1.ReactComponent,
    'regular-water-ladder': water_ladder_svg_1.ReactComponent,
    'regular-water': water_svg_1.ReactComponent,
    'regular-wave-pulse': wave_pulse_svg_1.ReactComponent,
    'regular-wave-sine': wave_sine_svg_1.ReactComponent,
    'regular-wave-square': wave_square_svg_1.ReactComponent,
    'regular-wave-triangle': wave_triangle_svg_1.ReactComponent,
    'regular-waveform-lines': waveform_lines_svg_1.ReactComponent,
    'regular-waveform': waveform_svg_1.ReactComponent,
    'regular-weight-hanging': weight_hanging_svg_1.ReactComponent,
    'regular-weight-scale': weight_scale_svg_1.ReactComponent,
    'regular-whale': whale_svg_1.ReactComponent,
    'regular-wheat-awn': wheat_awn_svg_1.ReactComponent,
    'regular-wheat': wheat_svg_1.ReactComponent,
    'regular-wheelchair-move': wheelchair_move_svg_1.ReactComponent,
    'regular-wheelchair': wheelchair_svg_1.ReactComponent,
    'regular-whiskey-glass-ice': whiskey_glass_ice_svg_1.ReactComponent,
    'regular-whiskey-glass': whiskey_glass_svg_1.ReactComponent,
    'regular-whistle': whistle_svg_1.ReactComponent,
    'regular-wifi-exclamation': wifi_exclamation_svg_1.ReactComponent,
    'regular-wifi-fair': wifi_fair_svg_1.ReactComponent,
    'regular-wifi-slash': wifi_slash_svg_1.ReactComponent,
    'regular-wifi-weak': wifi_weak_svg_1.ReactComponent,
    'regular-wifi': wifi_svg_1.ReactComponent,
    'regular-wind-turbine': wind_turbine_svg_1.ReactComponent,
    'regular-wind-warning': wind_warning_svg_1.ReactComponent,
    'regular-wind': wind_svg_1.ReactComponent,
    'regular-window-flip': window_flip_svg_1.ReactComponent,
    'regular-window-frame-open': window_frame_open_svg_1.ReactComponent,
    'regular-window-frame': window_frame_svg_1.ReactComponent,
    'regular-window-maximize': window_maximize_svg_1.ReactComponent,
    'regular-window-minimize': window_minimize_svg_1.ReactComponent,
    'regular-window-restore': window_restore_svg_1.ReactComponent,
    'regular-window': window_svg_1.ReactComponent,
    'regular-windsock': windsock_svg_1.ReactComponent,
    'regular-wine-bottle': wine_bottle_svg_1.ReactComponent,
    'regular-wine-glass-crack': wine_glass_crack_svg_1.ReactComponent,
    'regular-wine-glass-empty': wine_glass_empty_svg_1.ReactComponent,
    'regular-wine-glass': wine_glass_svg_1.ReactComponent,
    'regular-won-sign': won_sign_svg_1.ReactComponent,
    'regular-wreath': wreath_svg_1.ReactComponent,
    'regular-wrench-simple': wrench_simple_svg_1.ReactComponent,
    'regular-wrench': wrench_svg_1.ReactComponent,
    'regular-x-ray': x_ray_svg_1.ReactComponent,
    'regular-x': x_svg_1.ReactComponent,
    'regular-xmark-to-slot': xmark_to_slot_svg_1.ReactComponent,
    'regular-xmark': xmark_svg_1.ReactComponent,
    'regular-y': y_svg_1.ReactComponent,
    'regular-yen-sign': yen_sign_svg_1.ReactComponent,
    'regular-yin-yang': yin_yang_svg_1.ReactComponent,
    'regular-z': z_svg_1.ReactComponent,
    'solid-0': _0_svg_2.ReactComponent,
    'solid-1': _1_svg_2.ReactComponent,
    'solid-2': _2_svg_2.ReactComponent,
    'solid-3': _3_svg_2.ReactComponent,
    'solid-4': _4_svg_2.ReactComponent,
    'solid-5': _5_svg_2.ReactComponent,
    'solid-6': _6_svg_2.ReactComponent,
    'solid-7': _7_svg_2.ReactComponent,
    'solid-8': _8_svg_2.ReactComponent,
    'solid-9': _9_svg_2.ReactComponent,
    'solid-a': a_svg_2.ReactComponent,
    'solid-abacus': abacus_svg_2.ReactComponent,
    'solid-acorn': acorn_svg_2.ReactComponent,
    'solid-address-book': address_book_svg_2.ReactComponent,
    'solid-address-card': address_card_svg_2.ReactComponent,
    'solid-air-conditioner': air_conditioner_svg_2.ReactComponent,
    'solid-air-freshener': air_freshener_svg_2.ReactComponent,
    'solid-airplay': airplay_svg_2.ReactComponent,
    'solid-alarm-clock': alarm_clock_svg_2.ReactComponent,
    'solid-alarm-exclamation': alarm_exclamation_svg_2.ReactComponent,
    'solid-alarm-plus': alarm_plus_svg_2.ReactComponent,
    'solid-alarm-snooze': alarm_snooze_svg_2.ReactComponent,
    'solid-album-collection': album_collection_svg_2.ReactComponent,
    'solid-album': album_svg_2.ReactComponent,
    'solid-alicorn': alicorn_svg_2.ReactComponent,
    'solid-alien-8bit': alien_8bit_svg_2.ReactComponent,
    'solid-alien': alien_svg_2.ReactComponent,
    'solid-align-center': align_center_svg_2.ReactComponent,
    'solid-align-justify': align_justify_svg_2.ReactComponent,
    'solid-align-left': align_left_svg_2.ReactComponent,
    'solid-align-right': align_right_svg_2.ReactComponent,
    'solid-align-slash': align_slash_svg_2.ReactComponent,
    'solid-alt': alt_svg_2.ReactComponent,
    'solid-amp-guitar': amp_guitar_svg_2.ReactComponent,
    'solid-ampersand': ampersand_svg_2.ReactComponent,
    'solid-anchor': anchor_svg_2.ReactComponent,
    'solid-angel': angel_svg_2.ReactComponent,
    'solid-angle-90': angle_90_svg_2.ReactComponent,
    'solid-angle-down': angle_down_svg_2.ReactComponent,
    'solid-angle-left': angle_left_svg_2.ReactComponent,
    'solid-angle-right': angle_right_svg_2.ReactComponent,
    'solid-angle-up': angle_up_svg_2.ReactComponent,
    'solid-angle': angle_svg_2.ReactComponent,
    'solid-angles-down': angles_down_svg_2.ReactComponent,
    'solid-angles-left': angles_left_svg_2.ReactComponent,
    'solid-angles-right': angles_right_svg_2.ReactComponent,
    'solid-angles-up': angles_up_svg_2.ReactComponent,
    'solid-ankh': ankh_svg_2.ReactComponent,
    'solid-aperture': aperture_svg_2.ReactComponent,
    'solid-apple-core': apple_core_svg_2.ReactComponent,
    'solid-apple-crate': apple_crate_svg_2.ReactComponent,
    'solid-apple-whole': apple_whole_svg_2.ReactComponent,
    'solid-archway': archway_svg_2.ReactComponent,
    'solid-arrow-down-1-9': arrow_down_1_9_svg_2.ReactComponent,
    'solid-arrow-down-9-1': arrow_down_9_1_svg_2.ReactComponent,
    'solid-arrow-down-a-z': arrow_down_a_z_svg_2.ReactComponent,
    'solid-arrow-down-arrow-up': arrow_down_arrow_up_svg_2.ReactComponent,
    'solid-arrow-down-big-small': arrow_down_big_small_svg_2.ReactComponent,
    'solid-arrow-down-from-dotted-line': arrow_down_from_dotted_line_svg_2.ReactComponent,
    'solid-arrow-down-from-line': arrow_down_from_line_svg_2.ReactComponent,
    'solid-arrow-down-left-and-arrow-up-right-to-center': arrow_down_left_and_arrow_up_right_to_center_svg_2.ReactComponent,
    'solid-arrow-down-left': arrow_down_left_svg_2.ReactComponent,
    'solid-arrow-down-long': arrow_down_long_svg_2.ReactComponent,
    'solid-arrow-down-right': arrow_down_right_svg_2.ReactComponent,
    'solid-arrow-down-short-wide': arrow_down_short_wide_svg_2.ReactComponent,
    'solid-arrow-down-small-big': arrow_down_small_big_svg_2.ReactComponent,
    'solid-arrow-down-square-triangle': arrow_down_square_triangle_svg_2.ReactComponent,
    'solid-arrow-down-to-bracket': arrow_down_to_bracket_svg_2.ReactComponent,
    'solid-arrow-down-to-dotted-line': arrow_down_to_dotted_line_svg_2.ReactComponent,
    'solid-arrow-down-to-line': arrow_down_to_line_svg_2.ReactComponent,
    'solid-arrow-down-to-square': arrow_down_to_square_svg_2.ReactComponent,
    'solid-arrow-down-triangle-square': arrow_down_triangle_square_svg_2.ReactComponent,
    'solid-arrow-down-wide-short': arrow_down_wide_short_svg_2.ReactComponent,
    'solid-arrow-down-z-a': arrow_down_z_a_svg_2.ReactComponent,
    'solid-arrow-down': arrow_down_svg_2.ReactComponent,
    'solid-arrow-left-from-line': arrow_left_from_line_svg_2.ReactComponent,
    'solid-arrow-left-long': arrow_left_long_svg_2.ReactComponent,
    'solid-arrow-left-rotate': arrow_left_rotate_svg_2.ReactComponent,
    'solid-arrow-left-to-line': arrow_left_to_line_svg_2.ReactComponent,
    'solid-arrow-left': arrow_left_svg_2.ReactComponent,
    'solid-arrow-pointer': arrow_pointer_svg_2.ReactComponent,
    'solid-arrow-right-arrow-left': arrow_right_arrow_left_svg_2.ReactComponent,
    'solid-arrow-right-from-bracket': arrow_right_from_bracket_svg_2.ReactComponent,
    'solid-arrow-right-from-line': arrow_right_from_line_svg_2.ReactComponent,
    'solid-arrow-right-long': arrow_right_long_svg_2.ReactComponent,
    'solid-arrow-right-to-bracket': arrow_right_to_bracket_svg_2.ReactComponent,
    'solid-arrow-right-to-line': arrow_right_to_line_svg_2.ReactComponent,
    'solid-arrow-right': arrow_right_svg_2.ReactComponent,
    'solid-arrow-rotate-forward': arrow_rotate_forward_svg_2.ReactComponent,
    'solid-arrow-trend-down': arrow_trend_down_svg_2.ReactComponent,
    'solid-arrow-trend-up': arrow_trend_up_svg_2.ReactComponent,
    'solid-arrow-turn-down': arrow_turn_down_svg_2.ReactComponent,
    'solid-arrow-turn-up': arrow_turn_up_svg_2.ReactComponent,
    'solid-arrow-up-1-9': arrow_up_1_9_svg_2.ReactComponent,
    'solid-arrow-up-9-1': arrow_up_9_1_svg_2.ReactComponent,
    'solid-arrow-up-a-z': arrow_up_a_z_svg_2.ReactComponent,
    'solid-arrow-up-arrow-down': arrow_up_arrow_down_svg_2.ReactComponent,
    'solid-arrow-up-big-small': arrow_up_big_small_svg_2.ReactComponent,
    'solid-arrow-up-from-bracket': arrow_up_from_bracket_svg_2.ReactComponent,
    'solid-arrow-up-from-dotted-line': arrow_up_from_dotted_line_svg_2.ReactComponent,
    'solid-arrow-up-from-line': arrow_up_from_line_svg_2.ReactComponent,
    'solid-arrow-up-from-square': arrow_up_from_square_svg_2.ReactComponent,
    'solid-arrow-up-left-from-circle': arrow_up_left_from_circle_svg_2.ReactComponent,
    'solid-arrow-up-left': arrow_up_left_svg_2.ReactComponent,
    'solid-arrow-up-long': arrow_up_long_svg_2.ReactComponent,
    'solid-arrow-up-right-and-arrow-down-left-from-center': arrow_up_right_and_arrow_down_left_from_center_svg_2.ReactComponent,
    'solid-arrow-up-right-from-square': arrow_up_right_from_square_svg_2.ReactComponent,
    'solid-arrow-up-right': arrow_up_right_svg_2.ReactComponent,
    'solid-arrow-up-short-wide': arrow_up_short_wide_svg_2.ReactComponent,
    'solid-arrow-up-small-big': arrow_up_small_big_svg_2.ReactComponent,
    'solid-arrow-up-square-triangle': arrow_up_square_triangle_svg_2.ReactComponent,
    'solid-arrow-up-to-dotted-line': arrow_up_to_dotted_line_svg_2.ReactComponent,
    'solid-arrow-up-to-line': arrow_up_to_line_svg_2.ReactComponent,
    'solid-arrow-up-triangle-square': arrow_up_triangle_square_svg_2.ReactComponent,
    'solid-arrow-up-wide-short': arrow_up_wide_short_svg_2.ReactComponent,
    'solid-arrow-up-z-a': arrow_up_z_a_svg_2.ReactComponent,
    'solid-arrow-up': arrow_up_svg_2.ReactComponent,
    'solid-arrows-cross': arrows_cross_svg_2.ReactComponent,
    'solid-arrows-from-dotted-line': arrows_from_dotted_line_svg_2.ReactComponent,
    'solid-arrows-from-line': arrows_from_line_svg_2.ReactComponent,
    'solid-arrows-left-right': arrows_left_right_svg_2.ReactComponent,
    'solid-arrows-maximize': arrows_maximize_svg_2.ReactComponent,
    'solid-arrows-minimize': arrows_minimize_svg_2.ReactComponent,
    'solid-arrows-repeat-1': arrows_repeat_1_svg_2.ReactComponent,
    'solid-arrows-repeat': arrows_repeat_svg_2.ReactComponent,
    'solid-arrows-retweet': arrows_retweet_svg_2.ReactComponent,
    'solid-arrows-rotate': arrows_rotate_svg_2.ReactComponent,
    'solid-arrows-to-dotted-line': arrows_to_dotted_line_svg_2.ReactComponent,
    'solid-arrows-to-line': arrows_to_line_svg_2.ReactComponent,
    'solid-arrows-up-down-left-right': arrows_up_down_left_right_svg_2.ReactComponent,
    'solid-arrows-up-down': arrows_up_down_svg_2.ReactComponent,
    'solid-asterisk': asterisk_svg_2.ReactComponent,
    'solid-at': at_svg_2.ReactComponent,
    'solid-atom-simple': atom_simple_svg_2.ReactComponent,
    'solid-atom': atom_svg_2.ReactComponent,
    'solid-audio-description-slash': audio_description_slash_svg_2.ReactComponent,
    'solid-audio-description': audio_description_svg_2.ReactComponent,
    'solid-austral-sign': austral_sign_svg_2.ReactComponent,
    'solid-avocado': avocado_svg_2.ReactComponent,
    'solid-award-simple': award_simple_svg_2.ReactComponent,
    'solid-award': award_svg_2.ReactComponent,
    'solid-axe-battle': axe_battle_svg_2.ReactComponent,
    'solid-axe': axe_svg_2.ReactComponent,
    'solid-b': b_svg_2.ReactComponent,
    'solid-baby-carriage': baby_carriage_svg_2.ReactComponent,
    'solid-baby': baby_svg_2.ReactComponent,
    'solid-backpack': backpack_svg_2.ReactComponent,
    'solid-backward-fast': backward_fast_svg_2.ReactComponent,
    'solid-backward-step': backward_step_svg_2.ReactComponent,
    'solid-backward': backward_svg_2.ReactComponent,
    'solid-bacon': bacon_svg_2.ReactComponent,
    'solid-bacteria': bacteria_svg_2.ReactComponent,
    'solid-bacterium': bacterium_svg_2.ReactComponent,
    'solid-badge-check': badge_check_svg_2.ReactComponent,
    'solid-badge-dollar': badge_dollar_svg_2.ReactComponent,
    'solid-badge-percent': badge_percent_svg_2.ReactComponent,
    'solid-badge-sheriff': badge_sheriff_svg_2.ReactComponent,
    'solid-badge': badge_svg_2.ReactComponent,
    'solid-badger-honey': badger_honey_svg_2.ReactComponent,
    'solid-bag-shopping': bag_shopping_svg_2.ReactComponent,
    'solid-bags-shopping': bags_shopping_svg_2.ReactComponent,
    'solid-bahai': bahai_svg_2.ReactComponent,
    'solid-baht-sign': baht_sign_svg_2.ReactComponent,
    'solid-ball-pile': ball_pile_svg_2.ReactComponent,
    'solid-ballot-check': ballot_check_svg_2.ReactComponent,
    'solid-ballot': ballot_svg_2.ReactComponent,
    'solid-ban-bug': ban_bug_svg_2.ReactComponent,
    'solid-ban-parking': ban_parking_svg_2.ReactComponent,
    'solid-ban-smoking': ban_smoking_svg_2.ReactComponent,
    'solid-ban': ban_svg_2.ReactComponent,
    'solid-bandage': bandage_svg_2.ReactComponent,
    'solid-banjo': banjo_svg_2.ReactComponent,
    'solid-bank': bank_svg_2.ReactComponent,
    'solid-barcode-read': barcode_read_svg_2.ReactComponent,
    'solid-barcode-scan': barcode_scan_svg_2.ReactComponent,
    'solid-barcode': barcode_svg_2.ReactComponent,
    'solid-bars-filter': bars_filter_svg_2.ReactComponent,
    'solid-bars-progress': bars_progress_svg_2.ReactComponent,
    'solid-bars-sort': bars_sort_svg_2.ReactComponent,
    'solid-bars-staggered': bars_staggered_svg_2.ReactComponent,
    'solid-bars': bars_svg_2.ReactComponent,
    'solid-baseball-ball': baseball_ball_svg_2.ReactComponent,
    'solid-baseball-bat-ball': baseball_bat_ball_svg_2.ReactComponent,
    'solid-basket-shopping-simple': basket_shopping_simple_svg_2.ReactComponent,
    'solid-basket-shopping': basket_shopping_svg_2.ReactComponent,
    'solid-basketball-ball': basketball_ball_svg_2.ReactComponent,
    'solid-basketball-hoop': basketball_hoop_svg_2.ReactComponent,
    'solid-bat': bat_svg_2.ReactComponent,
    'solid-bath': bath_svg_2.ReactComponent,
    'solid-battery-bolt': battery_bolt_svg_2.ReactComponent,
    'solid-battery-empty': battery_empty_svg_2.ReactComponent,
    'solid-battery-exclamation': battery_exclamation_svg_2.ReactComponent,
    'solid-battery-full': battery_full_svg_2.ReactComponent,
    'solid-battery-half': battery_half_svg_2.ReactComponent,
    'solid-battery-low': battery_low_svg_2.ReactComponent,
    'solid-battery-quarter': battery_quarter_svg_2.ReactComponent,
    'solid-battery-slash': battery_slash_svg_2.ReactComponent,
    'solid-battery-three-quarters': battery_three_quarters_svg_2.ReactComponent,
    'solid-bed-bunk': bed_bunk_svg_2.ReactComponent,
    'solid-bed-empty': bed_empty_svg_2.ReactComponent,
    'solid-bed-front': bed_front_svg_2.ReactComponent,
    'solid-bed-pulse': bed_pulse_svg_2.ReactComponent,
    'solid-bed': bed_svg_2.ReactComponent,
    'solid-bee': bee_svg_2.ReactComponent,
    'solid-beer-mug-empty': beer_mug_empty_svg_2.ReactComponent,
    'solid-beer-mug': beer_mug_svg_2.ReactComponent,
    'solid-bell-concierge': bell_concierge_svg_2.ReactComponent,
    'solid-bell-exclamation': bell_exclamation_svg_2.ReactComponent,
    'solid-bell-on': bell_on_svg_2.ReactComponent,
    'solid-bell-plus': bell_plus_svg_2.ReactComponent,
    'solid-bell-school-slash': bell_school_slash_svg_2.ReactComponent,
    'solid-bell-school': bell_school_svg_2.ReactComponent,
    'solid-bell-slash': bell_slash_svg_2.ReactComponent,
    'solid-bell': bell_svg_2.ReactComponent,
    'solid-bells': bells_svg_2.ReactComponent,
    'solid-bezier-curve': bezier_curve_svg_2.ReactComponent,
    'solid-bicycle': bicycle_svg_2.ReactComponent,
    'solid-binoculars': binoculars_svg_2.ReactComponent,
    'solid-biohazard': biohazard_svg_2.ReactComponent,
    'solid-bitcoin-sign': bitcoin_sign_svg_2.ReactComponent,
    'solid-blanket': blanket_svg_2.ReactComponent,
    'solid-blender-phone': blender_phone_svg_2.ReactComponent,
    'solid-blender': blender_svg_2.ReactComponent,
    'solid-blinds-open': blinds_open_svg_2.ReactComponent,
    'solid-blinds-raised': blinds_raised_svg_2.ReactComponent,
    'solid-blinds': blinds_svg_2.ReactComponent,
    'solid-block-quote': block_quote_svg_2.ReactComponent,
    'solid-blog': blog_svg_2.ReactComponent,
    'solid-bluetooth': bluetooth_svg_3.ReactComponent,
    'solid-bold': bold_svg_2.ReactComponent,
    'solid-bolt-auto': bolt_auto_svg_2.ReactComponent,
    'solid-bolt-lightning': bolt_lightning_svg_2.ReactComponent,
    'solid-bolt-slash': bolt_slash_svg_2.ReactComponent,
    'solid-bolt': bolt_svg_2.ReactComponent,
    'solid-bomb': bomb_svg_2.ReactComponent,
    'solid-bone-break': bone_break_svg_2.ReactComponent,
    'solid-bone': bone_svg_2.ReactComponent,
    'solid-bong': bong_svg_2.ReactComponent,
    'solid-book-arrow-right': book_arrow_right_svg_2.ReactComponent,
    'solid-book-arrow-up': book_arrow_up_svg_2.ReactComponent,
    'solid-book-atlas': book_atlas_svg_2.ReactComponent,
    'solid-book-bible': book_bible_svg_2.ReactComponent,
    'solid-book-blank': book_blank_svg_2.ReactComponent,
    'solid-book-bookmark': book_bookmark_svg_2.ReactComponent,
    'solid-book-circle-arrow-right': book_circle_arrow_right_svg_2.ReactComponent,
    'solid-book-circle-arrow-up': book_circle_arrow_up_svg_2.ReactComponent,
    'solid-book-copy': book_copy_svg_2.ReactComponent,
    'solid-book-font': book_font_svg_2.ReactComponent,
    'solid-book-heart': book_heart_svg_2.ReactComponent,
    'solid-book-journal-whills': book_journal_whills_svg_2.ReactComponent,
    'solid-book-law': book_law_svg_2.ReactComponent,
    'solid-book-medical': book_medical_svg_2.ReactComponent,
    'solid-book-open-cover': book_open_cover_svg_2.ReactComponent,
    'solid-book-open-reader': book_open_reader_svg_2.ReactComponent,
    'solid-book-open': book_open_svg_2.ReactComponent,
    'solid-book-quran': book_quran_svg_2.ReactComponent,
    'solid-book-section': book_section_svg_2.ReactComponent,
    'solid-book-skull': book_skull_svg_2.ReactComponent,
    'solid-book-sparkles': book_sparkles_svg_2.ReactComponent,
    'solid-book-tanakh': book_tanakh_svg_2.ReactComponent,
    'solid-book-user': book_user_svg_2.ReactComponent,
    'solid-book': book_svg_2.ReactComponent,
    'solid-bookmark-slash': bookmark_slash_svg_2.ReactComponent,
    'solid-bookmark': bookmark_svg_2.ReactComponent,
    'solid-books-medical': books_medical_svg_2.ReactComponent,
    'solid-books': books_svg_2.ReactComponent,
    'solid-boombox': boombox_svg_2.ReactComponent,
    'solid-boot': boot_svg_2.ReactComponent,
    'solid-booth-curtain': booth_curtain_svg_2.ReactComponent,
    'solid-border-all': border_all_svg_2.ReactComponent,
    'solid-border-bottom-right': border_bottom_right_svg_2.ReactComponent,
    'solid-border-bottom': border_bottom_svg_2.ReactComponent,
    'solid-border-center-h': border_center_h_svg_2.ReactComponent,
    'solid-border-center-v': border_center_v_svg_2.ReactComponent,
    'solid-border-inner': border_inner_svg_2.ReactComponent,
    'solid-border-left': border_left_svg_2.ReactComponent,
    'solid-border-none': border_none_svg_2.ReactComponent,
    'solid-border-outer': border_outer_svg_2.ReactComponent,
    'solid-border-right': border_right_svg_2.ReactComponent,
    'solid-border-top-left': border_top_left_svg_2.ReactComponent,
    'solid-border-top': border_top_svg_2.ReactComponent,
    'solid-bow-arrow': bow_arrow_svg_2.ReactComponent,
    'solid-bowl-hot': bowl_hot_svg_2.ReactComponent,
    'solid-bowling-ball-pin': bowling_ball_pin_svg_2.ReactComponent,
    'solid-bowling-ball': bowling_ball_svg_2.ReactComponent,
    'solid-bowling-pins': bowling_pins_svg_2.ReactComponent,
    'solid-box-archive': box_archive_svg_2.ReactComponent,
    'solid-box-ballot': box_ballot_svg_2.ReactComponent,
    'solid-box-check': box_check_svg_2.ReactComponent,
    'solid-box-circle-check': box_circle_check_svg_2.ReactComponent,
    'solid-box-dollar': box_dollar_svg_2.ReactComponent,
    'solid-box-heart': box_heart_svg_2.ReactComponent,
    'solid-box-open-full': box_open_full_svg_2.ReactComponent,
    'solid-box-open': box_open_svg_2.ReactComponent,
    'solid-box-taped': box_taped_svg_2.ReactComponent,
    'solid-box-tissue': box_tissue_svg_2.ReactComponent,
    'solid-box': box_svg_2.ReactComponent,
    'solid-boxes-stacked': boxes_stacked_svg_2.ReactComponent,
    'solid-boxing-glove': boxing_glove_svg_2.ReactComponent,
    'solid-bracket-curly-right': bracket_curly_right_svg_2.ReactComponent,
    'solid-bracket-curly': bracket_curly_svg_2.ReactComponent,
    'solid-bracket-round-right': bracket_round_right_svg_2.ReactComponent,
    'solid-bracket-round': bracket_round_svg_2.ReactComponent,
    'solid-bracket-square-right': bracket_square_right_svg_2.ReactComponent,
    'solid-bracket-square': bracket_square_svg_2.ReactComponent,
    'solid-brackets-curly': brackets_curly_svg_2.ReactComponent,
    'solid-brackets-round': brackets_round_svg_2.ReactComponent,
    'solid-brackets-square': brackets_square_svg_2.ReactComponent,
    'solid-braille': braille_svg_2.ReactComponent,
    'solid-brain-arrow-curved-right': brain_arrow_curved_right_svg_2.ReactComponent,
    'solid-brain-circuit': brain_circuit_svg_2.ReactComponent,
    'solid-brain': brain_svg_2.ReactComponent,
    'solid-brake-warning': brake_warning_svg_2.ReactComponent,
    'solid-bread-loaf': bread_loaf_svg_2.ReactComponent,
    'solid-bread-slice': bread_slice_svg_2.ReactComponent,
    'solid-briefcase-arrow-right': briefcase_arrow_right_svg_2.ReactComponent,
    'solid-briefcase-clock': briefcase_clock_svg_2.ReactComponent,
    'solid-briefcase-medical': briefcase_medical_svg_2.ReactComponent,
    'solid-briefcase': briefcase_svg_2.ReactComponent,
    'solid-bring-forward': bring_forward_svg_2.ReactComponent,
    'solid-bring-front': bring_front_svg_2.ReactComponent,
    'solid-broom': broom_svg_2.ReactComponent,
    'solid-browser': browser_svg_2.ReactComponent,
    'solid-browsers': browsers_svg_2.ReactComponent,
    'solid-brush': brush_svg_2.ReactComponent,
    'solid-bug': bug_svg_2.ReactComponent,
    'solid-building': building_svg_2.ReactComponent,
    'solid-buildings': buildings_svg_2.ReactComponent,
    'solid-bullhorn': bullhorn_svg_2.ReactComponent,
    'solid-bullseye-arrow': bullseye_arrow_svg_2.ReactComponent,
    'solid-bullseye-pointer': bullseye_pointer_svg_2.ReactComponent,
    'solid-bullseye': bullseye_svg_2.ReactComponent,
    'solid-burger-cheese': burger_cheese_svg_2.ReactComponent,
    'solid-burger-fries': burger_fries_svg_2.ReactComponent,
    'solid-burger-glass': burger_glass_svg_2.ReactComponent,
    'solid-burger-soda': burger_soda_svg_2.ReactComponent,
    'solid-burger': burger_svg_2.ReactComponent,
    'solid-burrito': burrito_svg_2.ReactComponent,
    'solid-bus-school': bus_school_svg_2.ReactComponent,
    'solid-bus-simple': bus_simple_svg_2.ReactComponent,
    'solid-bus': bus_svg_2.ReactComponent,
    'solid-c': c_svg_2.ReactComponent,
    'solid-cabinet-filing': cabinet_filing_svg_2.ReactComponent,
    'solid-cable-car': cable_car_svg_2.ReactComponent,
    'solid-cactus': cactus_svg_2.ReactComponent,
    'solid-cake-candles': cake_candles_svg_2.ReactComponent,
    'solid-calculator-simple': calculator_simple_svg_2.ReactComponent,
    'solid-calculator': calculator_svg_2.ReactComponent,
    'solid-calendar-arrow-down': calendar_arrow_down_svg_2.ReactComponent,
    'solid-calendar-arrow-up': calendar_arrow_up_svg_2.ReactComponent,
    'solid-calendar-check': calendar_check_svg_2.ReactComponent,
    'solid-calendar-clock': calendar_clock_svg_2.ReactComponent,
    'solid-calendar-day': calendar_day_svg_2.ReactComponent,
    'solid-calendar-days': calendar_days_svg_2.ReactComponent,
    'solid-calendar-exclamation': calendar_exclamation_svg_2.ReactComponent,
    'solid-calendar-heart': calendar_heart_svg_2.ReactComponent,
    'solid-calendar-image': calendar_image_svg_2.ReactComponent,
    'solid-calendar-lines': calendar_lines_svg_2.ReactComponent,
    'solid-calendar-minus': calendar_minus_svg_2.ReactComponent,
    'solid-calendar-pen': calendar_pen_svg_2.ReactComponent,
    'solid-calendar-plus': calendar_plus_svg_2.ReactComponent,
    'solid-calendar-range': calendar_range_svg_2.ReactComponent,
    'solid-calendar-star': calendar_star_svg_2.ReactComponent,
    'solid-calendar-week': calendar_week_svg_2.ReactComponent,
    'solid-calendar-xmark': calendar_xmark_svg_2.ReactComponent,
    'solid-calendar': calendar_svg_2.ReactComponent,
    'solid-calendars': calendars_svg_2.ReactComponent,
    'solid-camcorder': camcorder_svg_2.ReactComponent,
    'solid-camera-cctv': camera_cctv_svg_2.ReactComponent,
    'solid-camera-movie': camera_movie_svg_2.ReactComponent,
    'solid-camera-polaroid': camera_polaroid_svg_2.ReactComponent,
    'solid-camera-retro': camera_retro_svg_2.ReactComponent,
    'solid-camera-rotate': camera_rotate_svg_2.ReactComponent,
    'solid-camera-security': camera_security_svg_2.ReactComponent,
    'solid-camera-slash': camera_slash_svg_2.ReactComponent,
    'solid-camera-viewfinder': camera_viewfinder_svg_2.ReactComponent,
    'solid-camera-web-slash': camera_web_slash_svg_2.ReactComponent,
    'solid-camera-web': camera_web_svg_2.ReactComponent,
    'solid-camera': camera_svg_2.ReactComponent,
    'solid-campfire': campfire_svg_2.ReactComponent,
    'solid-campground': campground_svg_2.ReactComponent,
    'solid-candle-holder': candle_holder_svg_2.ReactComponent,
    'solid-candy-cane': candy_cane_svg_2.ReactComponent,
    'solid-candy-corn': candy_corn_svg_2.ReactComponent,
    'solid-cannabis': cannabis_svg_2.ReactComponent,
    'solid-capsules': capsules_svg_2.ReactComponent,
    'solid-car-battery': car_battery_svg_2.ReactComponent,
    'solid-car-building': car_building_svg_2.ReactComponent,
    'solid-car-bump': car_bump_svg_2.ReactComponent,
    'solid-car-bus': car_bus_svg_2.ReactComponent,
    'solid-car-crash': car_crash_svg_2.ReactComponent,
    'solid-car-garage': car_garage_svg_2.ReactComponent,
    'solid-car-rear': car_rear_svg_2.ReactComponent,
    'solid-car-side': car_side_svg_2.ReactComponent,
    'solid-car-tilt': car_tilt_svg_2.ReactComponent,
    'solid-car-wash': car_wash_svg_2.ReactComponent,
    'solid-car-wrench': car_wrench_svg_2.ReactComponent,
    'solid-car': car_svg_2.ReactComponent,
    'solid-caravan-simple': caravan_simple_svg_2.ReactComponent,
    'solid-caravan': caravan_svg_2.ReactComponent,
    'solid-caret-down': caret_down_svg_2.ReactComponent,
    'solid-caret-left': caret_left_svg_2.ReactComponent,
    'solid-caret-right': caret_right_svg_2.ReactComponent,
    'solid-caret-up': caret_up_svg_2.ReactComponent,
    'solid-carrot': carrot_svg_2.ReactComponent,
    'solid-cars': cars_svg_2.ReactComponent,
    'solid-cart-arrow-down': cart_arrow_down_svg_2.ReactComponent,
    'solid-cart-flatbed-boxes': cart_flatbed_boxes_svg_2.ReactComponent,
    'solid-cart-flatbed-empty': cart_flatbed_empty_svg_2.ReactComponent,
    'solid-cart-flatbed-suitcase': cart_flatbed_suitcase_svg_2.ReactComponent,
    'solid-cart-flatbed': cart_flatbed_svg_2.ReactComponent,
    'solid-cart-plus': cart_plus_svg_2.ReactComponent,
    'solid-cart-shopping-fast': cart_shopping_fast_svg_2.ReactComponent,
    'solid-cart-shopping': cart_shopping_svg_2.ReactComponent,
    'solid-casette-betamax': casette_betamax_svg_2.ReactComponent,
    'solid-casette-vhs': casette_vhs_svg_2.ReactComponent,
    'solid-cash-register': cash_register_svg_2.ReactComponent,
    'solid-cassette-tape': cassette_tape_svg_2.ReactComponent,
    'solid-castle': castle_svg_2.ReactComponent,
    'solid-cat-space': cat_space_svg_2.ReactComponent,
    'solid-cat': cat_svg_2.ReactComponent,
    'solid-cauldron': cauldron_svg_2.ReactComponent,
    'solid-cedi-sign': cedi_sign_svg_2.ReactComponent,
    'solid-cent-sign': cent_sign_svg_2.ReactComponent,
    'solid-certificate': certificate_svg_2.ReactComponent,
    'solid-chair-office': chair_office_svg_2.ReactComponent,
    'solid-chair': chair_svg_2.ReactComponent,
    'solid-chalkboard-user': chalkboard_user_svg_2.ReactComponent,
    'solid-chalkboard': chalkboard_svg_2.ReactComponent,
    'solid-champagne-glass': champagne_glass_svg_2.ReactComponent,
    'solid-champagne-glasses': champagne_glasses_svg_2.ReactComponent,
    'solid-charging-station': charging_station_svg_2.ReactComponent,
    'solid-chart-area': chart_area_svg_2.ReactComponent,
    'solid-chart-bar': chart_bar_svg_2.ReactComponent,
    'solid-chart-bullet': chart_bullet_svg_2.ReactComponent,
    'solid-chart-candlestick': chart_candlestick_svg_2.ReactComponent,
    'solid-chart-column': chart_column_svg_2.ReactComponent,
    'solid-chart-gantt': chart_gantt_svg_2.ReactComponent,
    'solid-chart-line-down': chart_line_down_svg_2.ReactComponent,
    'solid-chart-line-up': chart_line_up_svg_2.ReactComponent,
    'solid-chart-line': chart_line_svg_2.ReactComponent,
    'solid-chart-mixed': chart_mixed_svg_2.ReactComponent,
    'solid-chart-network': chart_network_svg_2.ReactComponent,
    'solid-chart-pie-simple': chart_pie_simple_svg_2.ReactComponent,
    'solid-chart-pie': chart_pie_svg_2.ReactComponent,
    'solid-chart-pyramid': chart_pyramid_svg_2.ReactComponent,
    'solid-chart-radar': chart_radar_svg_2.ReactComponent,
    'solid-chart-scatter-3d': chart_scatter_3d_svg_2.ReactComponent,
    'solid-chart-scatter-bubble': chart_scatter_bubble_svg_2.ReactComponent,
    'solid-chart-scatter': chart_scatter_svg_2.ReactComponent,
    'solid-chart-tree-map': chart_tree_map_svg_2.ReactComponent,
    'solid-chart-user': chart_user_svg_2.ReactComponent,
    'solid-chart-waterfall': chart_waterfall_svg_2.ReactComponent,
    'solid-check-double': check_double_svg_2.ReactComponent,
    'solid-check-to-slot': check_to_slot_svg_2.ReactComponent,
    'solid-check': check_svg_2.ReactComponent,
    'solid-cheese-swiss': cheese_swiss_svg_2.ReactComponent,
    'solid-cheese': cheese_svg_2.ReactComponent,
    'solid-cherries': cherries_svg_2.ReactComponent,
    'solid-chess-bishop-piece': chess_bishop_piece_svg_2.ReactComponent,
    'solid-chess-bishop': chess_bishop_svg_2.ReactComponent,
    'solid-chess-board': chess_board_svg_2.ReactComponent,
    'solid-chess-clock-flip': chess_clock_flip_svg_2.ReactComponent,
    'solid-chess-clock': chess_clock_svg_2.ReactComponent,
    'solid-chess-king-piece': chess_king_piece_svg_2.ReactComponent,
    'solid-chess-king': chess_king_svg_2.ReactComponent,
    'solid-chess-knight-piece': chess_knight_piece_svg_2.ReactComponent,
    'solid-chess-knight': chess_knight_svg_2.ReactComponent,
    'solid-chess-pawn-piece': chess_pawn_piece_svg_2.ReactComponent,
    'solid-chess-pawn': chess_pawn_svg_2.ReactComponent,
    'solid-chess-queen-piece': chess_queen_piece_svg_2.ReactComponent,
    'solid-chess-queen': chess_queen_svg_2.ReactComponent,
    'solid-chess-rook-piece': chess_rook_piece_svg_2.ReactComponent,
    'solid-chess-rook': chess_rook_svg_2.ReactComponent,
    'solid-chess': chess_svg_2.ReactComponent,
    'solid-chevron-down': chevron_down_svg_2.ReactComponent,
    'solid-chevron-left': chevron_left_svg_2.ReactComponent,
    'solid-chevron-right': chevron_right_svg_2.ReactComponent,
    'solid-chevron-up': chevron_up_svg_2.ReactComponent,
    'solid-chevrons-down': chevrons_down_svg_2.ReactComponent,
    'solid-chevrons-left': chevrons_left_svg_2.ReactComponent,
    'solid-chevrons-right': chevrons_right_svg_2.ReactComponent,
    'solid-chevrons-up': chevrons_up_svg_2.ReactComponent,
    'solid-child': child_svg_2.ReactComponent,
    'solid-chimney': chimney_svg_2.ReactComponent,
    'solid-church': church_svg_2.ReactComponent,
    'solid-circle-0': circle_0_svg_2.ReactComponent,
    'solid-circle-1': circle_1_svg_2.ReactComponent,
    'solid-circle-2': circle_2_svg_2.ReactComponent,
    'solid-circle-3': circle_3_svg_2.ReactComponent,
    'solid-circle-4': circle_4_svg_2.ReactComponent,
    'solid-circle-5': circle_5_svg_2.ReactComponent,
    'solid-circle-6': circle_6_svg_2.ReactComponent,
    'solid-circle-7': circle_7_svg_2.ReactComponent,
    'solid-circle-8': circle_8_svg_2.ReactComponent,
    'solid-circle-9': circle_9_svg_2.ReactComponent,
    'solid-circle-a': circle_a_svg_2.ReactComponent,
    'solid-circle-ampersand': circle_ampersand_svg_2.ReactComponent,
    'solid-circle-arrow-down-left': circle_arrow_down_left_svg_2.ReactComponent,
    'solid-circle-arrow-down-right': circle_arrow_down_right_svg_2.ReactComponent,
    'solid-circle-arrow-down': circle_arrow_down_svg_2.ReactComponent,
    'solid-circle-arrow-left': circle_arrow_left_svg_2.ReactComponent,
    'solid-circle-arrow-right': circle_arrow_right_svg_2.ReactComponent,
    'solid-circle-arrow-up-left': circle_arrow_up_left_svg_2.ReactComponent,
    'solid-circle-arrow-up-right': circle_arrow_up_right_svg_2.ReactComponent,
    'solid-circle-arrow-up': circle_arrow_up_svg_2.ReactComponent,
    'solid-circle-b': circle_b_svg_2.ReactComponent,
    'solid-circle-bolt': circle_bolt_svg_2.ReactComponent,
    'solid-circle-book-open': circle_book_open_svg_2.ReactComponent,
    'solid-circle-bookmark': circle_bookmark_svg_2.ReactComponent,
    'solid-circle-c': circle_c_svg_2.ReactComponent,
    'solid-circle-calendar': circle_calendar_svg_2.ReactComponent,
    'solid-circle-camera': circle_camera_svg_2.ReactComponent,
    'solid-circle-caret-down': circle_caret_down_svg_2.ReactComponent,
    'solid-circle-caret-left': circle_caret_left_svg_2.ReactComponent,
    'solid-circle-caret-right': circle_caret_right_svg_2.ReactComponent,
    'solid-circle-caret-up': circle_caret_up_svg_2.ReactComponent,
    'solid-circle-check': circle_check_svg_2.ReactComponent,
    'solid-circle-chevron-down': circle_chevron_down_svg_2.ReactComponent,
    'solid-circle-chevron-left': circle_chevron_left_svg_2.ReactComponent,
    'solid-circle-chevron-right': circle_chevron_right_svg_2.ReactComponent,
    'solid-circle-chevron-up': circle_chevron_up_svg_2.ReactComponent,
    'solid-circle-d': circle_d_svg_2.ReactComponent,
    'solid-circle-dashed': circle_dashed_svg_2.ReactComponent,
    'solid-circle-divide': circle_divide_svg_2.ReactComponent,
    'solid-circle-dollar-to-slot': circle_dollar_to_slot_svg_2.ReactComponent,
    'solid-circle-dollar': circle_dollar_svg_2.ReactComponent,
    'solid-circle-dot': circle_dot_svg_2.ReactComponent,
    'solid-circle-down-left': circle_down_left_svg_2.ReactComponent,
    'solid-circle-down-right': circle_down_right_svg_2.ReactComponent,
    'solid-circle-down': circle_down_svg_2.ReactComponent,
    'solid-circle-e': circle_e_svg_2.ReactComponent,
    'solid-circle-envelope': circle_envelope_svg_2.ReactComponent,
    'solid-circle-exclamation-check': circle_exclamation_check_svg_2.ReactComponent,
    'solid-circle-exclamation': circle_exclamation_svg_2.ReactComponent,
    'solid-circle-f': circle_f_svg_2.ReactComponent,
    'solid-circle-g': circle_g_svg_2.ReactComponent,
    'solid-circle-h': circle_h_svg_2.ReactComponent,
    'solid-circle-half-stroke': circle_half_stroke_svg_2.ReactComponent,
    'solid-circle-half': circle_half_svg_2.ReactComponent,
    'solid-circle-heart': circle_heart_svg_2.ReactComponent,
    'solid-circle-i': circle_i_svg_2.ReactComponent,
    'solid-circle-info': circle_info_svg_2.ReactComponent,
    'solid-circle-j': circle_j_svg_2.ReactComponent,
    'solid-circle-k': circle_k_svg_2.ReactComponent,
    'solid-circle-l': circle_l_svg_2.ReactComponent,
    'solid-circle-left': circle_left_svg_2.ReactComponent,
    'solid-circle-location-arrow': circle_location_arrow_svg_2.ReactComponent,
    'solid-circle-m': circle_m_svg_2.ReactComponent,
    'solid-circle-microphone-lines': circle_microphone_lines_svg_2.ReactComponent,
    'solid-circle-microphone': circle_microphone_svg_2.ReactComponent,
    'solid-circle-minus': circle_minus_svg_2.ReactComponent,
    'solid-circle-n': circle_n_svg_2.ReactComponent,
    'solid-circle-notch': circle_notch_svg_2.ReactComponent,
    'solid-circle-o': circle_o_svg_2.ReactComponent,
    'solid-circle-p': circle_p_svg_2.ReactComponent,
    'solid-circle-parking': circle_parking_svg_2.ReactComponent,
    'solid-circle-pause': circle_pause_svg_2.ReactComponent,
    'solid-circle-phone-flip': circle_phone_flip_svg_2.ReactComponent,
    'solid-circle-phone-hangup': circle_phone_hangup_svg_2.ReactComponent,
    'solid-circle-phone': circle_phone_svg_2.ReactComponent,
    'solid-circle-play': circle_play_svg_2.ReactComponent,
    'solid-circle-plus': circle_plus_svg_2.ReactComponent,
    'solid-circle-q': circle_q_svg_2.ReactComponent,
    'solid-circle-quarter': circle_quarter_svg_2.ReactComponent,
    'solid-circle-question': circle_question_svg_2.ReactComponent,
    'solid-circle-r': circle_r_svg_2.ReactComponent,
    'solid-circle-radiation': circle_radiation_svg_2.ReactComponent,
    'solid-circle-right': circle_right_svg_2.ReactComponent,
    'solid-circle-s': circle_s_svg_2.ReactComponent,
    'solid-circle-small': circle_small_svg_2.ReactComponent,
    'solid-circle-sort-down': circle_sort_down_svg_2.ReactComponent,
    'solid-circle-sort-up': circle_sort_up_svg_2.ReactComponent,
    'solid-circle-sort': circle_sort_svg_2.ReactComponent,
    'solid-circle-star': circle_star_svg_2.ReactComponent,
    'solid-circle-stop': circle_stop_svg_2.ReactComponent,
    'solid-circle-t': circle_t_svg_2.ReactComponent,
    'solid-circle-three-quarters': circle_three_quarters_svg_2.ReactComponent,
    'solid-circle-trash': circle_trash_svg_2.ReactComponent,
    'solid-circle-u': circle_u_svg_2.ReactComponent,
    'solid-circle-up-left': circle_up_left_svg_2.ReactComponent,
    'solid-circle-up-right': circle_up_right_svg_2.ReactComponent,
    'solid-circle-up': circle_up_svg_2.ReactComponent,
    'solid-circle-user': circle_user_svg_2.ReactComponent,
    'solid-circle-v': circle_v_svg_2.ReactComponent,
    'solid-circle-video': circle_video_svg_2.ReactComponent,
    'solid-circle-w': circle_w_svg_2.ReactComponent,
    'solid-circle-waveform-lines': circle_waveform_lines_svg_2.ReactComponent,
    'solid-circle-x': circle_x_svg_2.ReactComponent,
    'solid-circle-xmark': circle_xmark_svg_2.ReactComponent,
    'solid-circle-y': circle_y_svg_2.ReactComponent,
    'solid-circle-z': circle_z_svg_2.ReactComponent,
    'solid-circle': circle_svg_2.ReactComponent,
    'solid-city': city_svg_2.ReactComponent,
    'solid-clapperboard-play': clapperboard_play_svg_2.ReactComponent,
    'solid-clapperboard': clapperboard_svg_2.ReactComponent,
    'solid-clarinet': clarinet_svg_2.ReactComponent,
    'solid-claw-marks': claw_marks_svg_2.ReactComponent,
    'solid-clipboard-check': clipboard_check_svg_2.ReactComponent,
    'solid-clipboard-list-check': clipboard_list_check_svg_2.ReactComponent,
    'solid-clipboard-list': clipboard_list_svg_2.ReactComponent,
    'solid-clipboard-medical': clipboard_medical_svg_2.ReactComponent,
    'solid-clipboard-prescription': clipboard_prescription_svg_2.ReactComponent,
    'solid-clipboard-user': clipboard_user_svg_2.ReactComponent,
    'solid-clipboard': clipboard_svg_2.ReactComponent,
    'solid-clock-desk': clock_desk_svg_2.ReactComponent,
    'solid-clock-rotate-left': clock_rotate_left_svg_2.ReactComponent,
    'solid-clock': clock_svg_2.ReactComponent,
    'solid-clone': clone_svg_2.ReactComponent,
    'solid-closed-captioning-slash': closed_captioning_slash_svg_2.ReactComponent,
    'solid-closed-captioning': closed_captioning_svg_2.ReactComponent,
    'solid-clothes-hanger': clothes_hanger_svg_2.ReactComponent,
    'solid-cloud-arrow-down': cloud_arrow_down_svg_2.ReactComponent,
    'solid-cloud-arrow-up': cloud_arrow_up_svg_2.ReactComponent,
    'solid-cloud-bolt-moon': cloud_bolt_moon_svg_2.ReactComponent,
    'solid-cloud-bolt-sun': cloud_bolt_sun_svg_2.ReactComponent,
    'solid-cloud-bolt': cloud_bolt_svg_2.ReactComponent,
    'solid-cloud-drizzle': cloud_drizzle_svg_2.ReactComponent,
    'solid-cloud-fog': cloud_fog_svg_2.ReactComponent,
    'solid-cloud-hail-mixed': cloud_hail_mixed_svg_2.ReactComponent,
    'solid-cloud-hail': cloud_hail_svg_2.ReactComponent,
    'solid-cloud-meatball': cloud_meatball_svg_2.ReactComponent,
    'solid-cloud-moon-rain': cloud_moon_rain_svg_2.ReactComponent,
    'solid-cloud-moon': cloud_moon_svg_2.ReactComponent,
    'solid-cloud-music': cloud_music_svg_2.ReactComponent,
    'solid-cloud-rain': cloud_rain_svg_2.ReactComponent,
    'solid-cloud-rainbow': cloud_rainbow_svg_2.ReactComponent,
    'solid-cloud-showers-heavy': cloud_showers_heavy_svg_2.ReactComponent,
    'solid-cloud-showers': cloud_showers_svg_2.ReactComponent,
    'solid-cloud-slash': cloud_slash_svg_2.ReactComponent,
    'solid-cloud-sleet': cloud_sleet_svg_2.ReactComponent,
    'solid-cloud-snow': cloud_snow_svg_2.ReactComponent,
    'solid-cloud-sun-rain': cloud_sun_rain_svg_2.ReactComponent,
    'solid-cloud-sun': cloud_sun_svg_2.ReactComponent,
    'solid-cloud-word': cloud_word_svg_2.ReactComponent,
    'solid-cloud': cloud_svg_2.ReactComponent,
    'solid-clouds-moon': clouds_moon_svg_2.ReactComponent,
    'solid-clouds-sun': clouds_sun_svg_2.ReactComponent,
    'solid-clouds': clouds_svg_2.ReactComponent,
    'solid-clover': clover_svg_2.ReactComponent,
    'solid-club': club_svg_2.ReactComponent,
    'solid-code-branch': code_branch_svg_2.ReactComponent,
    'solid-code-commit': code_commit_svg_2.ReactComponent,
    'solid-code-compare': code_compare_svg_2.ReactComponent,
    'solid-code-fork': code_fork_svg_2.ReactComponent,
    'solid-code-merge': code_merge_svg_2.ReactComponent,
    'solid-code-pull-request': code_pull_request_svg_2.ReactComponent,
    'solid-code-simple': code_simple_svg_2.ReactComponent,
    'solid-code': code_svg_2.ReactComponent,
    'solid-coffee-bean': coffee_bean_svg_2.ReactComponent,
    'solid-coffee-beans': coffee_beans_svg_2.ReactComponent,
    'solid-coffee-pot': coffee_pot_svg_2.ReactComponent,
    'solid-coffin-cross': coffin_cross_svg_2.ReactComponent,
    'solid-coffin': coffin_svg_2.ReactComponent,
    'solid-coin': coin_svg_2.ReactComponent,
    'solid-coins': coins_svg_2.ReactComponent,
    'solid-colon-sign': colon_sign_svg_2.ReactComponent,
    'solid-comet': comet_svg_2.ReactComponent,
    'solid-command': command_svg_2.ReactComponent,
    'solid-comment-arrow-down': comment_arrow_down_svg_2.ReactComponent,
    'solid-comment-arrow-up-right': comment_arrow_up_right_svg_2.ReactComponent,
    'solid-comment-arrow-up': comment_arrow_up_svg_2.ReactComponent,
    'solid-comment-captions': comment_captions_svg_2.ReactComponent,
    'solid-comment-check': comment_check_svg_2.ReactComponent,
    'solid-comment-code': comment_code_svg_2.ReactComponent,
    'solid-comment-dollar': comment_dollar_svg_2.ReactComponent,
    'solid-comment-dots': comment_dots_svg_2.ReactComponent,
    'solid-comment-exclamation': comment_exclamation_svg_2.ReactComponent,
    'solid-comment-image': comment_image_svg_2.ReactComponent,
    'solid-comment-lines': comment_lines_svg_2.ReactComponent,
    'solid-comment-medical': comment_medical_svg_2.ReactComponent,
    'solid-comment-middle-top': comment_middle_top_svg_2.ReactComponent,
    'solid-comment-middle': comment_middle_svg_2.ReactComponent,
    'solid-comment-minus': comment_minus_svg_2.ReactComponent,
    'solid-comment-music': comment_music_svg_2.ReactComponent,
    'solid-comment-pen': comment_pen_svg_2.ReactComponent,
    'solid-comment-plus': comment_plus_svg_2.ReactComponent,
    'solid-comment-question': comment_question_svg_2.ReactComponent,
    'solid-comment-quote': comment_quote_svg_2.ReactComponent,
    'solid-comment-slash': comment_slash_svg_2.ReactComponent,
    'solid-comment-smile': comment_smile_svg_2.ReactComponent,
    'solid-comment-sms': comment_sms_svg_2.ReactComponent,
    'solid-comment-text': comment_text_svg_2.ReactComponent,
    'solid-comment-xmark': comment_xmark_svg_2.ReactComponent,
    'solid-comment': comment_svg_2.ReactComponent,
    'solid-comments-dollar': comments_dollar_svg_2.ReactComponent,
    'solid-comments-question-check': comments_question_check_svg_2.ReactComponent,
    'solid-comments-question': comments_question_svg_2.ReactComponent,
    'solid-comments': comments_svg_2.ReactComponent,
    'solid-compact-disc': compact_disc_svg_2.ReactComponent,
    'solid-compass-drafting': compass_drafting_svg_2.ReactComponent,
    'solid-compass-slash': compass_slash_svg_2.ReactComponent,
    'solid-compass': compass_svg_2.ReactComponent,
    'solid-compress-wide': compress_wide_svg_2.ReactComponent,
    'solid-compress': compress_svg_2.ReactComponent,
    'solid-computer-classic': computer_classic_svg_2.ReactComponent,
    'solid-computer-mouse-scrollwheel': computer_mouse_scrollwheel_svg_2.ReactComponent,
    'solid-computer-mouse': computer_mouse_svg_2.ReactComponent,
    'solid-computer-speaker': computer_speaker_svg_2.ReactComponent,
    'solid-container-storage': container_storage_svg_2.ReactComponent,
    'solid-conveyor-belt-boxes': conveyor_belt_boxes_svg_2.ReactComponent,
    'solid-conveyor-belt-empty': conveyor_belt_empty_svg_2.ReactComponent,
    'solid-conveyor-belt': conveyor_belt_svg_2.ReactComponent,
    'solid-cookie-bite': cookie_bite_svg_2.ReactComponent,
    'solid-cookie': cookie_svg_2.ReactComponent,
    'solid-copy': copy_svg_2.ReactComponent,
    'solid-copyright': copyright_svg_2.ReactComponent,
    'solid-corn': corn_svg_2.ReactComponent,
    'solid-couch': couch_svg_2.ReactComponent,
    'solid-cow': cow_svg_2.ReactComponent,
    'solid-cowbell-circle-plus': cowbell_circle_plus_svg_2.ReactComponent,
    'solid-cowbell': cowbell_svg_2.ReactComponent,
    'solid-credit-card-blank': credit_card_blank_svg_2.ReactComponent,
    'solid-credit-card-front': credit_card_front_svg_2.ReactComponent,
    'solid-credit-card': credit_card_svg_2.ReactComponent,
    'solid-cricket-bat-ball': cricket_bat_ball_svg_2.ReactComponent,
    'solid-croissant': croissant_svg_2.ReactComponent,
    'solid-crop-simple': crop_simple_svg_2.ReactComponent,
    'solid-crop': crop_svg_2.ReactComponent,
    'solid-cross': cross_svg_2.ReactComponent,
    'solid-crosshairs': crosshairs_svg_2.ReactComponent,
    'solid-crow': crow_svg_2.ReactComponent,
    'solid-crown': crown_svg_2.ReactComponent,
    'solid-crutch': crutch_svg_2.ReactComponent,
    'solid-crutches': crutches_svg_2.ReactComponent,
    'solid-cruzeiro-sign': cruzeiro_sign_svg_2.ReactComponent,
    'solid-cube': cube_svg_2.ReactComponent,
    'solid-cubes': cubes_svg_2.ReactComponent,
    'solid-cup-togo': cup_togo_svg_2.ReactComponent,
    'solid-curling-stone': curling_stone_svg_2.ReactComponent,
    'solid-d': d_svg_2.ReactComponent,
    'solid-dagger': dagger_svg_2.ReactComponent,
    'solid-database': database_svg_2.ReactComponent,
    'solid-deer-rudolph': deer_rudolph_svg_2.ReactComponent,
    'solid-deer': deer_svg_2.ReactComponent,
    'solid-delete-left': delete_left_svg_2.ReactComponent,
    'solid-delete-right': delete_right_svg_2.ReactComponent,
    'solid-democrat': democrat_svg_2.ReactComponent,
    'solid-desktop-arrow-down': desktop_arrow_down_svg_2.ReactComponent,
    'solid-desktop': desktop_svg_2.ReactComponent,
    'solid-dharmachakra': dharmachakra_svg_2.ReactComponent,
    'solid-diagram-lean-canvas': diagram_lean_canvas_svg_2.ReactComponent,
    'solid-diagram-nested': diagram_nested_svg_2.ReactComponent,
    'solid-diagram-project': diagram_project_svg_2.ReactComponent,
    'solid-diagram-sankey': diagram_sankey_svg_2.ReactComponent,
    'solid-diagram-stankey': diagram_stankey_svg_2.ReactComponent,
    'solid-diagram-venn': diagram_venn_svg_2.ReactComponent,
    'solid-dial-high': dial_high_svg_2.ReactComponent,
    'solid-dial-low': dial_low_svg_2.ReactComponent,
    'solid-dial-max': dial_max_svg_2.ReactComponent,
    'solid-dial-med-low': dial_med_low_svg_2.ReactComponent,
    'solid-dial-med': dial_med_svg_2.ReactComponent,
    'solid-dial-min': dial_min_svg_2.ReactComponent,
    'solid-dial': dial_svg_2.ReactComponent,
    'solid-diamond-turn-right': diamond_turn_right_svg_2.ReactComponent,
    'solid-diamond': diamond_svg_2.ReactComponent,
    'solid-dice-d10': dice_d10_svg_2.ReactComponent,
    'solid-dice-d12': dice_d12_svg_2.ReactComponent,
    'solid-dice-d20': dice_d20_svg_2.ReactComponent,
    'solid-dice-d4': dice_d4_svg_2.ReactComponent,
    'solid-dice-d6': dice_d6_svg_2.ReactComponent,
    'solid-dice-d8': dice_d8_svg_2.ReactComponent,
    'solid-dice-five': dice_five_svg_2.ReactComponent,
    'solid-dice-four': dice_four_svg_2.ReactComponent,
    'solid-dice-one': dice_one_svg_2.ReactComponent,
    'solid-dice-six': dice_six_svg_2.ReactComponent,
    'solid-dice-three': dice_three_svg_2.ReactComponent,
    'solid-dice-two': dice_two_svg_2.ReactComponent,
    'solid-dice': dice_svg_2.ReactComponent,
    'solid-diploma': diploma_svg_2.ReactComponent,
    'solid-disc-drive': disc_drive_svg_2.ReactComponent,
    'solid-disease': disease_svg_2.ReactComponent,
    'solid-display-arrow-down': display_arrow_down_svg_2.ReactComponent,
    'solid-display-code': display_code_svg_2.ReactComponent,
    'solid-display-medical': display_medical_svg_2.ReactComponent,
    'solid-display-slash': display_slash_svg_2.ReactComponent,
    'solid-display': display_svg_2.ReactComponent,
    'solid-divide': divide_svg_2.ReactComponent,
    'solid-dna': dna_svg_2.ReactComponent,
    'solid-do-not-enter': do_not_enter_svg_2.ReactComponent,
    'solid-dog-leashed': dog_leashed_svg_2.ReactComponent,
    'solid-dog': dog_svg_2.ReactComponent,
    'solid-dollar-sign': dollar_sign_svg_2.ReactComponent,
    'solid-dolly-empty': dolly_empty_svg_2.ReactComponent,
    'solid-dolly': dolly_svg_2.ReactComponent,
    'solid-dolphin': dolphin_svg_2.ReactComponent,
    'solid-dong-sign': dong_sign_svg_2.ReactComponent,
    'solid-door-closed': door_closed_svg_2.ReactComponent,
    'solid-door-open': door_open_svg_2.ReactComponent,
    'solid-dove': dove_svg_2.ReactComponent,
    'solid-down-from-line': down_from_line_svg_2.ReactComponent,
    'solid-down-left-and-up-right-to-center': down_left_and_up_right_to_center_svg_2.ReactComponent,
    'solid-down-left': down_left_svg_2.ReactComponent,
    'solid-down-long': down_long_svg_2.ReactComponent,
    'solid-down-right': down_right_svg_2.ReactComponent,
    'solid-down-to-line': down_to_line_svg_2.ReactComponent,
    'solid-down': down_svg_2.ReactComponent,
    'solid-download': download_svg_2.ReactComponent,
    'solid-dragon': dragon_svg_2.ReactComponent,
    'solid-draw-circle': draw_circle_svg_2.ReactComponent,
    'solid-draw-polygon': draw_polygon_svg_2.ReactComponent,
    'solid-draw-square': draw_square_svg_2.ReactComponent,
    'solid-dreidel': dreidel_svg_2.ReactComponent,
    'solid-drone-front': drone_front_svg_2.ReactComponent,
    'solid-drone': drone_svg_2.ReactComponent,
    'solid-droplet-degree': droplet_degree_svg_2.ReactComponent,
    'solid-droplet-percent': droplet_percent_svg_2.ReactComponent,
    'solid-droplet-slash': droplet_slash_svg_2.ReactComponent,
    'solid-droplet': droplet_svg_2.ReactComponent,
    'solid-drum-steelpan': drum_steelpan_svg_2.ReactComponent,
    'solid-drum': drum_svg_2.ReactComponent,
    'solid-drumstick-bite': drumstick_bite_svg_2.ReactComponent,
    'solid-drumstick': drumstick_svg_2.ReactComponent,
    'solid-dryer-heat': dryer_heat_svg_2.ReactComponent,
    'solid-dryer': dryer_svg_2.ReactComponent,
    'solid-duck': duck_svg_2.ReactComponent,
    'solid-dumbbell': dumbbell_svg_2.ReactComponent,
    'solid-dumpster-fire': dumpster_fire_svg_2.ReactComponent,
    'solid-dumpster': dumpster_svg_2.ReactComponent,
    'solid-dungeon': dungeon_svg_2.ReactComponent,
    'solid-e': e_svg_2.ReactComponent,
    'solid-ear-deaf': ear_deaf_svg_2.ReactComponent,
    'solid-ear-listen': ear_listen_svg_2.ReactComponent,
    'solid-ear-muffs': ear_muffs_svg_2.ReactComponent,
    'solid-ear': ear_svg_2.ReactComponent,
    'solid-earth-africa': earth_africa_svg_2.ReactComponent,
    'solid-earth-americas': earth_americas_svg_2.ReactComponent,
    'solid-earth-asia': earth_asia_svg_2.ReactComponent,
    'solid-earth-europa': earth_europa_svg_2.ReactComponent,
    'solid-eclipse': eclipse_svg_2.ReactComponent,
    'solid-egg-fried': egg_fried_svg_2.ReactComponent,
    'solid-egg': egg_svg_2.ReactComponent,
    'solid-eggplant': eggplant_svg_2.ReactComponent,
    'solid-eject': eject_svg_2.ReactComponent,
    'solid-elephant': elephant_svg_2.ReactComponent,
    'solid-elevator': elevator_svg_2.ReactComponent,
    'solid-ellipsis-stroke-vertical': ellipsis_stroke_vertical_svg_2.ReactComponent,
    'solid-ellipsis-stroke': ellipsis_stroke_svg_2.ReactComponent,
    'solid-ellipsis-vertical': ellipsis_vertical_svg_2.ReactComponent,
    'solid-ellipsis': ellipsis_svg_2.ReactComponent,
    'solid-empty-set': empty_set_svg_2.ReactComponent,
    'solid-engine-warning': engine_warning_svg_2.ReactComponent,
    'solid-engine': engine_svg_2.ReactComponent,
    'solid-envelope-dot': envelope_dot_svg_2.ReactComponent,
    'solid-envelope-open-dollar': envelope_open_dollar_svg_2.ReactComponent,
    'solid-envelope-open-text': envelope_open_text_svg_2.ReactComponent,
    'solid-envelope-open': envelope_open_svg_2.ReactComponent,
    'solid-envelope': envelope_svg_2.ReactComponent,
    'solid-envelopes-bulk': envelopes_bulk_svg_2.ReactComponent,
    'solid-envelopes': envelopes_svg_2.ReactComponent,
    'solid-equals': equals_svg_2.ReactComponent,
    'solid-eraser': eraser_svg_2.ReactComponent,
    'solid-escalator': escalator_svg_2.ReactComponent,
    'solid-ethernet': ethernet_svg_2.ReactComponent,
    'solid-euro-sign': euro_sign_svg_2.ReactComponent,
    'solid-exclamation': exclamation_svg_2.ReactComponent,
    'solid-expand-wide': expand_wide_svg_2.ReactComponent,
    'solid-expand': expand_svg_2.ReactComponent,
    'solid-eye-dropper-full': eye_dropper_full_svg_2.ReactComponent,
    'solid-eye-dropper-half': eye_dropper_half_svg_2.ReactComponent,
    'solid-eye-dropper': eye_dropper_svg_2.ReactComponent,
    'solid-eye-evil': eye_evil_svg_2.ReactComponent,
    'solid-eye-low-vision': eye_low_vision_svg_2.ReactComponent,
    'solid-eye-slash': eye_slash_svg_2.ReactComponent,
    'solid-eye': eye_svg_2.ReactComponent,
    'solid-f': f_svg_2.ReactComponent,
    'solid-face-angry': face_angry_svg_2.ReactComponent,
    'solid-face-dizzy': face_dizzy_svg_2.ReactComponent,
    'solid-face-flushed': face_flushed_svg_2.ReactComponent,
    'solid-face-frown-open': face_frown_open_svg_2.ReactComponent,
    'solid-face-frown': face_frown_svg_2.ReactComponent,
    'solid-face-grimace': face_grimace_svg_2.ReactComponent,
    'solid-face-grin-beam-sweat': face_grin_beam_sweat_svg_2.ReactComponent,
    'solid-face-grin-beam': face_grin_beam_svg_2.ReactComponent,
    'solid-face-grin-hearts': face_grin_hearts_svg_2.ReactComponent,
    'solid-face-grin-squint-tears': face_grin_squint_tears_svg_2.ReactComponent,
    'solid-face-grin-squint': face_grin_squint_svg_2.ReactComponent,
    'solid-face-grin-stars': face_grin_stars_svg_2.ReactComponent,
    'solid-face-grin-tears': face_grin_tears_svg_2.ReactComponent,
    'solid-face-grin-tongue-squint': face_grin_tongue_squint_svg_2.ReactComponent,
    'solid-face-grin-tongue-wink': face_grin_tongue_wink_svg_2.ReactComponent,
    'solid-face-grin-tongue': face_grin_tongue_svg_2.ReactComponent,
    'solid-face-grin-wide': face_grin_wide_svg_2.ReactComponent,
    'solid-face-grin-wink': face_grin_wink_svg_2.ReactComponent,
    'solid-face-grin': face_grin_svg_2.ReactComponent,
    'solid-face-kiss-beam': face_kiss_beam_svg_2.ReactComponent,
    'solid-face-kiss-wink-heart': face_kiss_wink_heart_svg_2.ReactComponent,
    'solid-face-kiss': face_kiss_svg_2.ReactComponent,
    'solid-face-laugh-beam': face_laugh_beam_svg_2.ReactComponent,
    'solid-face-laugh-squint': face_laugh_squint_svg_2.ReactComponent,
    'solid-face-laugh-wink': face_laugh_wink_svg_2.ReactComponent,
    'solid-face-laugh': face_laugh_svg_2.ReactComponent,
    'solid-face-meh-blank': face_meh_blank_svg_2.ReactComponent,
    'solid-face-meh': face_meh_svg_2.ReactComponent,
    'solid-face-rolling-eyes': face_rolling_eyes_svg_2.ReactComponent,
    'solid-face-sad-cry': face_sad_cry_svg_2.ReactComponent,
    'solid-face-sad-tear': face_sad_tear_svg_2.ReactComponent,
    'solid-face-smile-beam': face_smile_beam_svg_2.ReactComponent,
    'solid-face-smile-plus': face_smile_plus_svg_2.ReactComponent,
    'solid-face-smile-wink': face_smile_wink_svg_2.ReactComponent,
    'solid-face-smile': face_smile_svg_2.ReactComponent,
    'solid-face-surprise': face_surprise_svg_2.ReactComponent,
    'solid-face-tired': face_tired_svg_2.ReactComponent,
    'solid-fan-table': fan_table_svg_2.ReactComponent,
    'solid-fan': fan_svg_2.ReactComponent,
    'solid-farm': farm_svg_2.ReactComponent,
    'solid-faucet-drip': faucet_drip_svg_2.ReactComponent,
    'solid-faucet': faucet_svg_2.ReactComponent,
    'solid-fax': fax_svg_2.ReactComponent,
    'solid-feather-pointed': feather_pointed_svg_2.ReactComponent,
    'solid-feather': feather_svg_2.ReactComponent,
    'solid-fence': fence_svg_2.ReactComponent,
    'solid-field-hockey-stick-ball': field_hockey_stick_ball_svg_2.ReactComponent,
    'solid-file-arrow-down': file_arrow_down_svg_2.ReactComponent,
    'solid-file-arrow-up': file_arrow_up_svg_2.ReactComponent,
    'solid-file-audio': file_audio_svg_2.ReactComponent,
    'solid-file-binary': file_binary_svg_2.ReactComponent,
    'solid-file-certificate': file_certificate_svg_2.ReactComponent,
    'solid-file-chart-column': file_chart_column_svg_2.ReactComponent,
    'solid-file-chart-pie': file_chart_pie_svg_2.ReactComponent,
    'solid-file-check': file_check_svg_2.ReactComponent,
    'solid-file-code': file_code_svg_2.ReactComponent,
    'solid-file-contract': file_contract_svg_2.ReactComponent,
    'solid-file-csv': file_csv_svg_2.ReactComponent,
    'solid-file-dashed-line': file_dashed_line_svg_2.ReactComponent,
    'solid-file-excel': file_excel_svg_2.ReactComponent,
    'solid-file-exclamation': file_exclamation_svg_2.ReactComponent,
    'solid-file-export': file_export_svg_2.ReactComponent,
    'solid-file-heart': file_heart_svg_2.ReactComponent,
    'solid-file-image': file_image_svg_2.ReactComponent,
    'solid-file-import': file_import_svg_2.ReactComponent,
    'solid-file-invoice-dollar': file_invoice_dollar_svg_2.ReactComponent,
    'solid-file-invoice': file_invoice_svg_2.ReactComponent,
    'solid-file-lines': file_lines_svg_2.ReactComponent,
    'solid-file-magnifying-glass': file_magnifying_glass_svg_2.ReactComponent,
    'solid-file-medical': file_medical_svg_2.ReactComponent,
    'solid-file-minus': file_minus_svg_2.ReactComponent,
    'solid-file-music': file_music_svg_2.ReactComponent,
    'solid-file-pdf': file_pdf_svg_2.ReactComponent,
    'solid-file-pen': file_pen_svg_2.ReactComponent,
    'solid-file-plus-minus': file_plus_minus_svg_2.ReactComponent,
    'solid-file-plus': file_plus_svg_2.ReactComponent,
    'solid-file-powerpoint': file_powerpoint_svg_2.ReactComponent,
    'solid-file-prescription': file_prescription_svg_2.ReactComponent,
    'solid-file-signature': file_signature_svg_2.ReactComponent,
    'solid-file-spreadsheet': file_spreadsheet_svg_2.ReactComponent,
    'solid-file-user': file_user_svg_2.ReactComponent,
    'solid-file-video': file_video_svg_2.ReactComponent,
    'solid-file-waveform': file_waveform_svg_2.ReactComponent,
    'solid-file-word': file_word_svg_2.ReactComponent,
    'solid-file-xmark': file_xmark_svg_2.ReactComponent,
    'solid-file-zipper': file_zipper_svg_2.ReactComponent,
    'solid-file': file_svg_2.ReactComponent,
    'solid-files-medical': files_medical_svg_2.ReactComponent,
    'solid-files': files_svg_2.ReactComponent,
    'solid-fill-drip': fill_drip_svg_2.ReactComponent,
    'solid-fill': fill_svg_2.ReactComponent,
    'solid-film-canister': film_canister_svg_2.ReactComponent,
    'solid-film-simple': film_simple_svg_2.ReactComponent,
    'solid-film-slash': film_slash_svg_2.ReactComponent,
    'solid-film': film_svg_2.ReactComponent,
    'solid-films': films_svg_2.ReactComponent,
    'solid-filter-circle-dollar': filter_circle_dollar_svg_2.ReactComponent,
    'solid-filter-circle-xmark': filter_circle_xmark_svg_2.ReactComponent,
    'solid-filter-list': filter_list_svg_2.ReactComponent,
    'solid-filter-slash': filter_slash_svg_2.ReactComponent,
    'solid-filter': filter_svg_2.ReactComponent,
    'solid-filters': filters_svg_2.ReactComponent,
    'solid-fingerprint': fingerprint_svg_2.ReactComponent,
    'solid-fire-extinguisher': fire_extinguisher_svg_2.ReactComponent,
    'solid-fire-flame-curved': fire_flame_curved_svg_2.ReactComponent,
    'solid-fire-flame-simple': fire_flame_simple_svg_2.ReactComponent,
    'solid-fire-flame': fire_flame_svg_2.ReactComponent,
    'solid-fire-hydrant': fire_hydrant_svg_2.ReactComponent,
    'solid-fire-smoke': fire_smoke_svg_2.ReactComponent,
    'solid-fire': fire_svg_2.ReactComponent,
    'solid-fireplace': fireplace_svg_2.ReactComponent,
    'solid-fish-cooked': fish_cooked_svg_2.ReactComponent,
    'solid-fish': fish_svg_2.ReactComponent,
    'solid-flag-checkered': flag_checkered_svg_2.ReactComponent,
    'solid-flag-pennant': flag_pennant_svg_2.ReactComponent,
    'solid-flag-swallowtail': flag_swallowtail_svg_2.ReactComponent,
    'solid-flag-usa': flag_usa_svg_2.ReactComponent,
    'solid-flag': flag_svg_2.ReactComponent,
    'solid-flashlight': flashlight_svg_2.ReactComponent,
    'solid-flask-round-poison': flask_round_poison_svg_2.ReactComponent,
    'solid-flask-round-potion': flask_round_potion_svg_2.ReactComponent,
    'solid-flask': flask_svg_2.ReactComponent,
    'solid-floppy-disk-circle-arrow-right': floppy_disk_circle_arrow_right_svg_2.ReactComponent,
    'solid-floppy-disk-circle-xmark': floppy_disk_circle_xmark_svg_2.ReactComponent,
    'solid-floppy-disk-pen': floppy_disk_pen_svg_2.ReactComponent,
    'solid-floppy-disk': floppy_disk_svg_2.ReactComponent,
    'solid-floppy-disks': floppy_disks_svg_2.ReactComponent,
    'solid-florin-sign': florin_sign_svg_2.ReactComponent,
    'solid-flower-daffodil': flower_daffodil_svg_2.ReactComponent,
    'solid-flower-tulip': flower_tulip_svg_2.ReactComponent,
    'solid-flower': flower_svg_2.ReactComponent,
    'solid-flute': flute_svg_2.ReactComponent,
    'solid-flux-capacitor': flux_capacitor_svg_2.ReactComponent,
    'solid-folder-arrow-down': folder_arrow_down_svg_2.ReactComponent,
    'solid-folder-arrow-up': folder_arrow_up_svg_2.ReactComponent,
    'solid-folder-blank': folder_blank_svg_2.ReactComponent,
    'solid-folder-bookmark': folder_bookmark_svg_2.ReactComponent,
    'solid-folder-gear': folder_gear_svg_2.ReactComponent,
    'solid-folder-grid': folder_grid_svg_2.ReactComponent,
    'solid-folder-heart': folder_heart_svg_2.ReactComponent,
    'solid-folder-image': folder_image_svg_2.ReactComponent,
    'solid-folder-magnifying-glass': folder_magnifying_glass_svg_2.ReactComponent,
    'solid-folder-medical': folder_medical_svg_2.ReactComponent,
    'solid-folder-minus': folder_minus_svg_2.ReactComponent,
    'solid-folder-music': folder_music_svg_2.ReactComponent,
    'solid-folder-open': folder_open_svg_2.ReactComponent,
    'solid-folder-plus': folder_plus_svg_2.ReactComponent,
    'solid-folder-tree': folder_tree_svg_2.ReactComponent,
    'solid-folder-user': folder_user_svg_2.ReactComponent,
    'solid-folder-xmark': folder_xmark_svg_2.ReactComponent,
    'solid-folder': folder_svg_2.ReactComponent,
    'solid-folders': folders_svg_2.ReactComponent,
    'solid-font-awesome': font_awesome_svg_3.ReactComponent,
    'solid-font-case': font_case_svg_2.ReactComponent,
    'solid-font': font_svg_2.ReactComponent,
    'solid-football-ball': football_ball_svg_2.ReactComponent,
    'solid-football-helmet': football_helmet_svg_2.ReactComponent,
    'solid-fork-knife': fork_knife_svg_2.ReactComponent,
    'solid-fork': fork_svg_2.ReactComponent,
    'solid-forklift': forklift_svg_2.ReactComponent,
    'solid-forward-fast': forward_fast_svg_2.ReactComponent,
    'solid-forward-step': forward_step_svg_2.ReactComponent,
    'solid-forward': forward_svg_2.ReactComponent,
    'solid-franc-sign': franc_sign_svg_2.ReactComponent,
    'solid-french-fries': french_fries_svg_2.ReactComponent,
    'solid-frog': frog_svg_2.ReactComponent,
    'solid-function': function_svg_2.ReactComponent,
    'solid-futbol-ball': futbol_ball_svg_2.ReactComponent,
    'solid-g': g_svg_2.ReactComponent,
    'solid-galaxy': galaxy_svg_2.ReactComponent,
    'solid-game-board-simple': game_board_simple_svg_2.ReactComponent,
    'solid-game-board': game_board_svg_2.ReactComponent,
    'solid-game-console-handheld': game_console_handheld_svg_2.ReactComponent,
    'solid-gamepad-modern': gamepad_modern_svg_2.ReactComponent,
    'solid-gamepad': gamepad_svg_2.ReactComponent,
    'solid-garage-car': garage_car_svg_2.ReactComponent,
    'solid-garage-open': garage_open_svg_2.ReactComponent,
    'solid-garage': garage_svg_2.ReactComponent,
    'solid-gas-pump-slash': gas_pump_slash_svg_2.ReactComponent,
    'solid-gas-pump': gas_pump_svg_2.ReactComponent,
    'solid-gauge-low': gauge_low_svg_2.ReactComponent,
    'solid-gauge-max': gauge_max_svg_2.ReactComponent,
    'solid-gauge-med': gauge_med_svg_2.ReactComponent,
    'solid-gauge-min': gauge_min_svg_2.ReactComponent,
    'solid-gauge-simple-low': gauge_simple_low_svg_2.ReactComponent,
    'solid-gauge-simple-max': gauge_simple_max_svg_2.ReactComponent,
    'solid-gauge-simple-med': gauge_simple_med_svg_2.ReactComponent,
    'solid-gauge-simple-min': gauge_simple_min_svg_2.ReactComponent,
    'solid-gauge-simple': gauge_simple_svg_2.ReactComponent,
    'solid-gauge': gauge_svg_2.ReactComponent,
    'solid-gavel': gavel_svg_2.ReactComponent,
    'solid-gear': gear_svg_2.ReactComponent,
    'solid-gears': gears_svg_2.ReactComponent,
    'solid-gem': gem_svg_2.ReactComponent,
    'solid-genderless': genderless_svg_2.ReactComponent,
    'solid-ghost': ghost_svg_2.ReactComponent,
    'solid-gif': gif_svg_2.ReactComponent,
    'solid-gift-card': gift_card_svg_2.ReactComponent,
    'solid-gift': gift_svg_2.ReactComponent,
    'solid-gifts': gifts_svg_2.ReactComponent,
    'solid-gingerbread-man': gingerbread_man_svg_2.ReactComponent,
    'solid-glass-citrus': glass_citrus_svg_2.ReactComponent,
    'solid-glass-empty': glass_empty_svg_2.ReactComponent,
    'solid-glass-half': glass_half_svg_2.ReactComponent,
    'solid-glass': glass_svg_2.ReactComponent,
    'solid-glasses-round': glasses_round_svg_2.ReactComponent,
    'solid-glasses': glasses_svg_2.ReactComponent,
    'solid-globe-snow': globe_snow_svg_2.ReactComponent,
    'solid-globe-stand': globe_stand_svg_2.ReactComponent,
    'solid-globe': globe_svg_2.ReactComponent,
    'solid-golf-ball-tee': golf_ball_tee_svg_2.ReactComponent,
    'solid-golf-club': golf_club_svg_2.ReactComponent,
    'solid-gopuram': gopuram_svg_2.ReactComponent,
    'solid-graduation-cap': graduation_cap_svg_2.ReactComponent,
    'solid-gramophone': gramophone_svg_2.ReactComponent,
    'solid-grate-droplet': grate_droplet_svg_2.ReactComponent,
    'solid-grate': grate_svg_2.ReactComponent,
    'solid-greater-than-equal': greater_than_equal_svg_2.ReactComponent,
    'solid-greater-than': greater_than_svg_2.ReactComponent,
    'solid-grid-2-plus': grid_2_plus_svg_2.ReactComponent,
    'solid-grid-2': grid_2_svg_2.ReactComponent,
    'solid-grid-4': grid_4_svg_2.ReactComponent,
    'solid-grid-5': grid_5_svg_2.ReactComponent,
    'solid-grid': grid_svg_2.ReactComponent,
    'solid-grip-lines-vertical': grip_lines_vertical_svg_2.ReactComponent,
    'solid-grip-lines': grip_lines_svg_2.ReactComponent,
    'solid-grip-vertical': grip_vertical_svg_2.ReactComponent,
    'solid-grip': grip_svg_2.ReactComponent,
    'solid-guarani-sign': guarani_sign_svg_2.ReactComponent,
    'solid-guitar-electric': guitar_electric_svg_2.ReactComponent,
    'solid-guitar': guitar_svg_2.ReactComponent,
    'solid-guitars': guitars_svg_2.ReactComponent,
    'solid-gun-slash': gun_slash_svg_2.ReactComponent,
    'solid-gun-squirt': gun_squirt_svg_2.ReactComponent,
    'solid-gun': gun_svg_2.ReactComponent,
    'solid-h': h_svg_2.ReactComponent,
    'solid-h1': h1_svg_2.ReactComponent,
    'solid-h2': h2_svg_2.ReactComponent,
    'solid-h3': h3_svg_2.ReactComponent,
    'solid-h4': h4_svg_2.ReactComponent,
    'solid-hammer-war': hammer_war_svg_2.ReactComponent,
    'solid-hammer': hammer_svg_2.ReactComponent,
    'solid-hamsa': hamsa_svg_2.ReactComponent,
    'solid-hand-back-point-down': hand_back_point_down_svg_2.ReactComponent,
    'solid-hand-back-point-left': hand_back_point_left_svg_2.ReactComponent,
    'solid-hand-back-point-right': hand_back_point_right_svg_2.ReactComponent,
    'solid-hand-back-point-up': hand_back_point_up_svg_2.ReactComponent,
    'solid-hand-dots': hand_dots_svg_2.ReactComponent,
    'solid-hand-fingers-crossed': hand_fingers_crossed_svg_2.ReactComponent,
    'solid-hand-fist': hand_fist_svg_2.ReactComponent,
    'solid-hand-heart': hand_heart_svg_2.ReactComponent,
    'solid-hand-holding-box': hand_holding_box_svg_2.ReactComponent,
    'solid-hand-holding-dollar': hand_holding_dollar_svg_2.ReactComponent,
    'solid-hand-holding-droplet': hand_holding_droplet_svg_2.ReactComponent,
    'solid-hand-holding-heart': hand_holding_heart_svg_2.ReactComponent,
    'solid-hand-holding-magic': hand_holding_magic_svg_2.ReactComponent,
    'solid-hand-holding-medical': hand_holding_medical_svg_2.ReactComponent,
    'solid-hand-holding-seedling': hand_holding_seedling_svg_2.ReactComponent,
    'solid-hand-holding-skull': hand_holding_skull_svg_2.ReactComponent,
    'solid-hand-holding': hand_holding_svg_2.ReactComponent,
    'solid-hand-lizard': hand_lizard_svg_2.ReactComponent,
    'solid-hand-love': hand_love_svg_2.ReactComponent,
    'solid-hand-middle-finger': hand_middle_finger_svg_2.ReactComponent,
    'solid-hand-paper': hand_paper_svg_2.ReactComponent,
    'solid-hand-peace': hand_peace_svg_2.ReactComponent,
    'solid-hand-point-down': hand_point_down_svg_2.ReactComponent,
    'solid-hand-point-left': hand_point_left_svg_2.ReactComponent,
    'solid-hand-point-right': hand_point_right_svg_2.ReactComponent,
    'solid-hand-point-up': hand_point_up_svg_2.ReactComponent,
    'solid-hand-pointer': hand_pointer_svg_2.ReactComponent,
    'solid-hand-rock': hand_rock_svg_2.ReactComponent,
    'solid-hand-scissors': hand_scissors_svg_2.ReactComponent,
    'solid-hand-sparkles': hand_sparkles_svg_2.ReactComponent,
    'solid-hand-spock': hand_spock_svg_2.ReactComponent,
    'solid-hand-wave': hand_wave_svg_2.ReactComponent,
    'solid-hands-asl-interpreting': hands_asl_interpreting_svg_2.ReactComponent,
    'solid-hands-bubbles': hands_bubbles_svg_2.ReactComponent,
    'solid-hands-clapping': hands_clapping_svg_2.ReactComponent,
    'solid-hands-holding-diamond': hands_holding_diamond_svg_2.ReactComponent,
    'solid-hands-holding-dollar': hands_holding_dollar_svg_2.ReactComponent,
    'solid-hands-holding-heart': hands_holding_heart_svg_2.ReactComponent,
    'solid-hands-holding': hands_holding_svg_2.ReactComponent,
    'solid-hands-horns': hands_horns_svg_2.ReactComponent,
    'solid-hands-praying': hands_praying_svg_2.ReactComponent,
    'solid-hands': hands_svg_2.ReactComponent,
    'solid-handshake-angle': handshake_angle_svg_2.ReactComponent,
    'solid-handshake-simple-slash': handshake_simple_slash_svg_2.ReactComponent,
    'solid-handshake-simple': handshake_simple_svg_2.ReactComponent,
    'solid-handshake-slash': handshake_slash_svg_2.ReactComponent,
    'solid-handshake': handshake_svg_2.ReactComponent,
    'solid-hanukiah': hanukiah_svg_2.ReactComponent,
    'solid-hard-drive': hard_drive_svg_2.ReactComponent,
    'solid-hashtag': hashtag_svg_2.ReactComponent,
    'solid-hat-chef': hat_chef_svg_2.ReactComponent,
    'solid-hat-cowboy-side': hat_cowboy_side_svg_2.ReactComponent,
    'solid-hat-cowboy': hat_cowboy_svg_2.ReactComponent,
    'solid-hat-santa': hat_santa_svg_2.ReactComponent,
    'solid-hat-winter': hat_winter_svg_2.ReactComponent,
    'solid-hat-witch': hat_witch_svg_2.ReactComponent,
    'solid-hat-wizard': hat_wizard_svg_2.ReactComponent,
    'solid-head-side-brain': head_side_brain_svg_2.ReactComponent,
    'solid-head-side-cough-slash': head_side_cough_slash_svg_2.ReactComponent,
    'solid-head-side-cough': head_side_cough_svg_2.ReactComponent,
    'solid-head-side-goggles': head_side_goggles_svg_2.ReactComponent,
    'solid-head-side-headphones': head_side_headphones_svg_2.ReactComponent,
    'solid-head-side-heart': head_side_heart_svg_2.ReactComponent,
    'solid-head-side-mask': head_side_mask_svg_2.ReactComponent,
    'solid-head-side-medical': head_side_medical_svg_2.ReactComponent,
    'solid-head-side-virus': head_side_virus_svg_2.ReactComponent,
    'solid-head-side': head_side_svg_2.ReactComponent,
    'solid-heading': heading_svg_2.ReactComponent,
    'solid-headphones-simple': headphones_simple_svg_2.ReactComponent,
    'solid-headphones': headphones_svg_2.ReactComponent,
    'solid-headset': headset_svg_2.ReactComponent,
    'solid-heart-crack': heart_crack_svg_2.ReactComponent,
    'solid-heart-half-stroke': heart_half_stroke_svg_2.ReactComponent,
    'solid-heart-half': heart_half_svg_2.ReactComponent,
    'solid-heart-pulse': heart_pulse_svg_2.ReactComponent,
    'solid-heart': heart_svg_2.ReactComponent,
    'solid-heat': heat_svg_2.ReactComponent,
    'solid-helicopter': helicopter_svg_2.ReactComponent,
    'solid-helmet-battle': helmet_battle_svg_2.ReactComponent,
    'solid-helmet-safety': helmet_safety_svg_2.ReactComponent,
    'solid-hexagon-divide': hexagon_divide_svg_2.ReactComponent,
    'solid-hexagon-minus': hexagon_minus_svg_2.ReactComponent,
    'solid-hexagon-plus': hexagon_plus_svg_2.ReactComponent,
    'solid-hexagon-xmark': hexagon_xmark_svg_2.ReactComponent,
    'solid-hexagon': hexagon_svg_2.ReactComponent,
    'solid-high-definition': high_definition_svg_2.ReactComponent,
    'solid-highlighter-line': highlighter_line_svg_2.ReactComponent,
    'solid-highlighter': highlighter_svg_2.ReactComponent,
    'solid-hippo': hippo_svg_2.ReactComponent,
    'solid-hockey-mask': hockey_mask_svg_2.ReactComponent,
    'solid-hockey-puck': hockey_puck_svg_2.ReactComponent,
    'solid-hockey-sticks': hockey_sticks_svg_2.ReactComponent,
    'solid-holly-berry': holly_berry_svg_2.ReactComponent,
    'solid-home-heart': home_heart_svg_2.ReactComponent,
    'solid-home-simple': home_simple_svg_2.ReactComponent,
    'solid-home-user': home_user_svg_2.ReactComponent,
    'solid-home': home_svg_2.ReactComponent,
    'solid-hood-cloak': hood_cloak_svg_2.ReactComponent,
    'solid-horizontal-rule': horizontal_rule_svg_2.ReactComponent,
    'solid-horse-head': horse_head_svg_2.ReactComponent,
    'solid-horse-saddle': horse_saddle_svg_2.ReactComponent,
    'solid-horse': horse_svg_2.ReactComponent,
    'solid-hospital-user': hospital_user_svg_2.ReactComponent,
    'solid-hospital-wide': hospital_wide_svg_2.ReactComponent,
    'solid-hospital': hospital_svg_2.ReactComponent,
    'solid-hospitals': hospitals_svg_2.ReactComponent,
    'solid-hot-tub-person': hot_tub_person_svg_2.ReactComponent,
    'solid-hotdog': hotdog_svg_2.ReactComponent,
    'solid-hotel': hotel_svg_2.ReactComponent,
    'solid-hourglass-empty': hourglass_empty_svg_2.ReactComponent,
    'solid-hourglass-end': hourglass_end_svg_2.ReactComponent,
    'solid-hourglass-start': hourglass_start_svg_2.ReactComponent,
    'solid-hourglass': hourglass_svg_2.ReactComponent,
    'solid-house-building': house_building_svg_2.ReactComponent,
    'solid-house-crack': house_crack_svg_2.ReactComponent,
    'solid-house-day': house_day_svg_2.ReactComponent,
    'solid-house-flood': house_flood_svg_2.ReactComponent,
    'solid-house-heart': house_heart_svg_2.ReactComponent,
    'solid-house-laptop': house_laptop_svg_2.ReactComponent,
    'solid-house-medical': house_medical_svg_2.ReactComponent,
    'solid-house-night': house_night_svg_2.ReactComponent,
    'solid-house-person-leave': house_person_leave_svg_2.ReactComponent,
    'solid-house-person-return': house_person_return_svg_2.ReactComponent,
    'solid-house-signal': house_signal_svg_2.ReactComponent,
    'solid-house-tree': house_tree_svg_2.ReactComponent,
    'solid-house-turret': house_turret_svg_2.ReactComponent,
    'solid-house-user': house_user_svg_2.ReactComponent,
    'solid-house': house_svg_2.ReactComponent,
    'solid-hryvnia-sign': hryvnia_sign_svg_2.ReactComponent,
    'solid-hurricane': hurricane_svg_2.ReactComponent,
    'solid-i-cursor': i_cursor_svg_2.ReactComponent,
    'solid-i': i_svg_2.ReactComponent,
    'solid-ice-cream': ice_cream_svg_2.ReactComponent,
    'solid-ice-skate': ice_skate_svg_2.ReactComponent,
    'solid-icicles': icicles_svg_2.ReactComponent,
    'solid-icons': icons_svg_2.ReactComponent,
    'solid-id-badge': id_badge_svg_2.ReactComponent,
    'solid-id-card-clip': id_card_clip_svg_2.ReactComponent,
    'solid-id-card': id_card_svg_2.ReactComponent,
    'solid-igloo': igloo_svg_2.ReactComponent,
    'solid-image-landscape': image_landscape_svg_2.ReactComponent,
    'solid-image-polaroid-user': image_polaroid_user_svg_2.ReactComponent,
    'solid-image-polaroid': image_polaroid_svg_2.ReactComponent,
    'solid-image-portrait': image_portrait_svg_2.ReactComponent,
    'solid-image-slash': image_slash_svg_2.ReactComponent,
    'solid-image-user': image_user_svg_2.ReactComponent,
    'solid-image': image_svg_2.ReactComponent,
    'solid-images-user': images_user_svg_2.ReactComponent,
    'solid-images': images_svg_2.ReactComponent,
    'solid-inbox-full': inbox_full_svg_2.ReactComponent,
    'solid-inbox-in': inbox_in_svg_2.ReactComponent,
    'solid-inbox-out': inbox_out_svg_2.ReactComponent,
    'solid-inbox': inbox_svg_2.ReactComponent,
    'solid-inboxes': inboxes_svg_2.ReactComponent,
    'solid-indent': indent_svg_2.ReactComponent,
    'solid-indian-rupee-sign': indian_rupee_sign_svg_2.ReactComponent,
    'solid-industry-windows': industry_windows_svg_2.ReactComponent,
    'solid-industry': industry_svg_2.ReactComponent,
    'solid-infinity': infinity_svg_2.ReactComponent,
    'solid-info': info_svg_2.ReactComponent,
    'solid-inhaler': inhaler_svg_2.ReactComponent,
    'solid-input-numeric': input_numeric_svg_2.ReactComponent,
    'solid-input-pipe': input_pipe_svg_2.ReactComponent,
    'solid-input-text': input_text_svg_2.ReactComponent,
    'solid-integral': integral_svg_2.ReactComponent,
    'solid-intersection': intersection_svg_2.ReactComponent,
    'solid-island-tropical': island_tropical_svg_2.ReactComponent,
    'solid-italic': italic_svg_2.ReactComponent,
    'solid-j': j_svg_2.ReactComponent,
    'solid-jack-o-lantern': jack_o_lantern_svg_2.ReactComponent,
    'solid-jedi': jedi_svg_2.ReactComponent,
    'solid-jet-fighter': jet_fighter_svg_2.ReactComponent,
    'solid-joint': joint_svg_2.ReactComponent,
    'solid-joystick': joystick_svg_2.ReactComponent,
    'solid-jug': jug_svg_2.ReactComponent,
    'solid-k': k_svg_2.ReactComponent,
    'solid-kaaba': kaaba_svg_2.ReactComponent,
    'solid-kazoo': kazoo_svg_2.ReactComponent,
    'solid-kerning': kerning_svg_2.ReactComponent,
    'solid-key-skeleton': key_skeleton_svg_2.ReactComponent,
    'solid-key': key_svg_2.ReactComponent,
    'solid-keyboard-down': keyboard_down_svg_2.ReactComponent,
    'solid-keyboard-left': keyboard_left_svg_2.ReactComponent,
    'solid-keyboard': keyboard_svg_2.ReactComponent,
    'solid-keynote': keynote_svg_2.ReactComponent,
    'solid-khanda': khanda_svg_2.ReactComponent,
    'solid-kidneys': kidneys_svg_2.ReactComponent,
    'solid-kip-sign': kip_sign_svg_2.ReactComponent,
    'solid-kit-medical': kit_medical_svg_2.ReactComponent,
    'solid-kite': kite_svg_2.ReactComponent,
    'solid-kiwi-bird': kiwi_bird_svg_2.ReactComponent,
    'solid-knife-kitchen': knife_kitchen_svg_2.ReactComponent,
    'solid-knife': knife_svg_2.ReactComponent,
    'solid-l': l_svg_2.ReactComponent,
    'solid-lambda': lambda_svg_2.ReactComponent,
    'solid-lamp-desk': lamp_desk_svg_2.ReactComponent,
    'solid-lamp-floor': lamp_floor_svg_2.ReactComponent,
    'solid-lamp-street': lamp_street_svg_2.ReactComponent,
    'solid-lamp': lamp_svg_2.ReactComponent,
    'solid-landmark-dome': landmark_dome_svg_2.ReactComponent,
    'solid-landmark': landmark_svg_2.ReactComponent,
    'solid-language': language_svg_2.ReactComponent,
    'solid-laptop-arrow-down': laptop_arrow_down_svg_2.ReactComponent,
    'solid-laptop-code': laptop_code_svg_2.ReactComponent,
    'solid-laptop-medical': laptop_medical_svg_2.ReactComponent,
    'solid-laptop-mobile': laptop_mobile_svg_2.ReactComponent,
    'solid-laptop-slash': laptop_slash_svg_2.ReactComponent,
    'solid-laptop': laptop_svg_2.ReactComponent,
    'solid-lari-sign': lari_sign_svg_2.ReactComponent,
    'solid-lasso-sparkles': lasso_sparkles_svg_2.ReactComponent,
    'solid-lasso': lasso_svg_2.ReactComponent,
    'solid-layers-minus': layers_minus_svg_2.ReactComponent,
    'solid-layers-plus': layers_plus_svg_2.ReactComponent,
    'solid-layers': layers_svg_2.ReactComponent,
    'solid-leaf-heart': leaf_heart_svg_2.ReactComponent,
    'solid-leaf-maple': leaf_maple_svg_2.ReactComponent,
    'solid-leaf-oak': leaf_oak_svg_2.ReactComponent,
    'solid-leaf': leaf_svg_2.ReactComponent,
    'solid-left-from-line': left_from_line_svg_2.ReactComponent,
    'solid-left-long': left_long_svg_2.ReactComponent,
    'solid-left-right': left_right_svg_2.ReactComponent,
    'solid-left-to-line': left_to_line_svg_2.ReactComponent,
    'solid-left': left_svg_2.ReactComponent,
    'solid-lemon': lemon_svg_2.ReactComponent,
    'solid-less-than-equal': less_than_equal_svg_2.ReactComponent,
    'solid-less-than': less_than_svg_2.ReactComponent,
    'solid-life-ring': life_ring_svg_2.ReactComponent,
    'solid-light-ceiling': light_ceiling_svg_2.ReactComponent,
    'solid-light-switch-off': light_switch_off_svg_2.ReactComponent,
    'solid-light-switch-on': light_switch_on_svg_2.ReactComponent,
    'solid-light-switch': light_switch_svg_2.ReactComponent,
    'solid-lightbulb-dollar': lightbulb_dollar_svg_2.ReactComponent,
    'solid-lightbulb-exclamation': lightbulb_exclamation_svg_2.ReactComponent,
    'solid-lightbulb-on': lightbulb_on_svg_2.ReactComponent,
    'solid-lightbulb-slash': lightbulb_slash_svg_2.ReactComponent,
    'solid-lightbulb': lightbulb_svg_2.ReactComponent,
    'solid-lights-holiday': lights_holiday_svg_2.ReactComponent,
    'solid-line-columns': line_columns_svg_2.ReactComponent,
    'solid-line-height': line_height_svg_2.ReactComponent,
    'solid-link-horizontal-slash': link_horizontal_slash_svg_2.ReactComponent,
    'solid-link-horizontal': link_horizontal_svg_2.ReactComponent,
    'solid-link-simple-slash': link_simple_slash_svg_2.ReactComponent,
    'solid-link-simple': link_simple_svg_2.ReactComponent,
    'solid-link-slash': link_slash_svg_2.ReactComponent,
    'solid-link': link_svg_2.ReactComponent,
    'solid-lips': lips_svg_2.ReactComponent,
    'solid-lira-sign': lira_sign_svg_2.ReactComponent,
    'solid-list-check': list_check_svg_2.ReactComponent,
    'solid-list-dropdown': list_dropdown_svg_2.ReactComponent,
    'solid-list-music': list_music_svg_2.ReactComponent,
    'solid-list-ol': list_ol_svg_2.ReactComponent,
    'solid-list-radio': list_radio_svg_2.ReactComponent,
    'solid-list-timeline': list_timeline_svg_2.ReactComponent,
    'solid-list-tree': list_tree_svg_2.ReactComponent,
    'solid-list-ul': list_ul_svg_2.ReactComponent,
    'solid-list': list_svg_2.ReactComponent,
    'solid-litecoin-sign': litecoin_sign_svg_2.ReactComponent,
    'solid-loader': loader_svg_2.ReactComponent,
    'solid-location-arrow': location_arrow_svg_2.ReactComponent,
    'solid-location-check': location_check_svg_2.ReactComponent,
    'solid-location-crosshairs-slash': location_crosshairs_slash_svg_2.ReactComponent,
    'solid-location-crosshairs': location_crosshairs_svg_2.ReactComponent,
    'solid-location-dot-slash': location_dot_slash_svg_2.ReactComponent,
    'solid-location-dot': location_dot_svg_2.ReactComponent,
    'solid-location-exclamation': location_exclamation_svg_2.ReactComponent,
    'solid-location-minus': location_minus_svg_2.ReactComponent,
    'solid-location-pen': location_pen_svg_2.ReactComponent,
    'solid-location-plus': location_plus_svg_2.ReactComponent,
    'solid-location-question': location_question_svg_2.ReactComponent,
    'solid-location-slash': location_slash_svg_2.ReactComponent,
    'solid-location-smile': location_smile_svg_2.ReactComponent,
    'solid-location-xmark': location_xmark_svg_2.ReactComponent,
    'solid-location': location_svg_2.ReactComponent,
    'solid-lock-keyhole-open': lock_keyhole_open_svg_2.ReactComponent,
    'solid-lock-keyhole': lock_keyhole_svg_2.ReactComponent,
    'solid-lock-open': lock_open_svg_2.ReactComponent,
    'solid-lock': lock_svg_2.ReactComponent,
    'solid-loveseat': loveseat_svg_2.ReactComponent,
    'solid-luchador-mask': luchador_mask_svg_2.ReactComponent,
    'solid-lungs-virus': lungs_virus_svg_2.ReactComponent,
    'solid-lungs': lungs_svg_2.ReactComponent,
    'solid-m': m_svg_2.ReactComponent,
    'solid-mace': mace_svg_2.ReactComponent,
    'solid-magnet': magnet_svg_2.ReactComponent,
    'solid-magnifying-glass-dollar': magnifying_glass_dollar_svg_2.ReactComponent,
    'solid-magnifying-glass-location': magnifying_glass_location_svg_2.ReactComponent,
    'solid-magnifying-glass-minus': magnifying_glass_minus_svg_2.ReactComponent,
    'solid-magnifying-glass-plus': magnifying_glass_plus_svg_2.ReactComponent,
    'solid-magnifying-glass': magnifying_glass_svg_2.ReactComponent,
    'solid-mailbox': mailbox_svg_2.ReactComponent,
    'solid-manat-sign': manat_sign_svg_2.ReactComponent,
    'solid-mandolin': mandolin_svg_2.ReactComponent,
    'solid-manhole': manhole_svg_2.ReactComponent,
    'solid-map-location-dot': map_location_dot_svg_2.ReactComponent,
    'solid-map-location': map_location_svg_2.ReactComponent,
    'solid-map-pin': map_pin_svg_2.ReactComponent,
    'solid-map': map_svg_2.ReactComponent,
    'solid-marker': marker_svg_2.ReactComponent,
    'solid-mars-double': mars_double_svg_2.ReactComponent,
    'solid-mars-stroke-right': mars_stroke_right_svg_2.ReactComponent,
    'solid-mars-stroke-up': mars_stroke_up_svg_2.ReactComponent,
    'solid-mars-stroke': mars_stroke_svg_2.ReactComponent,
    'solid-mars': mars_svg_2.ReactComponent,
    'solid-martini-glass-citrus': martini_glass_citrus_svg_2.ReactComponent,
    'solid-martini-glass-empty': martini_glass_empty_svg_2.ReactComponent,
    'solid-martini-glass': martini_glass_svg_2.ReactComponent,
    'solid-mask-face': mask_face_svg_2.ReactComponent,
    'solid-mask': mask_svg_2.ReactComponent,
    'solid-masks-theater': masks_theater_svg_2.ReactComponent,
    'solid-maximize': maximize_svg_2.ReactComponent,
    'solid-meat': meat_svg_2.ReactComponent,
    'solid-medal': medal_svg_2.ReactComponent,
    'solid-megaphone': megaphone_svg_2.ReactComponent,
    'solid-memo-circle-check': memo_circle_check_svg_2.ReactComponent,
    'solid-memo': memo_svg_2.ReactComponent,
    'solid-memory': memory_svg_2.ReactComponent,
    'solid-menorah': menorah_svg_2.ReactComponent,
    'solid-mercury': mercury_svg_2.ReactComponent,
    'solid-message-arrow-down': message_arrow_down_svg_2.ReactComponent,
    'solid-message-arrow-up-right': message_arrow_up_right_svg_2.ReactComponent,
    'solid-message-arrow-up': message_arrow_up_svg_2.ReactComponent,
    'solid-message-captions': message_captions_svg_2.ReactComponent,
    'solid-message-check': message_check_svg_2.ReactComponent,
    'solid-message-code': message_code_svg_2.ReactComponent,
    'solid-message-dollar': message_dollar_svg_2.ReactComponent,
    'solid-message-dots': message_dots_svg_2.ReactComponent,
    'solid-message-exclamation': message_exclamation_svg_2.ReactComponent,
    'solid-message-image': message_image_svg_2.ReactComponent,
    'solid-message-lines': message_lines_svg_2.ReactComponent,
    'solid-message-medical': message_medical_svg_2.ReactComponent,
    'solid-message-middle-top': message_middle_top_svg_2.ReactComponent,
    'solid-message-middle': message_middle_svg_2.ReactComponent,
    'solid-message-minus': message_minus_svg_2.ReactComponent,
    'solid-message-music': message_music_svg_2.ReactComponent,
    'solid-message-pen': message_pen_svg_2.ReactComponent,
    'solid-message-plus': message_plus_svg_2.ReactComponent,
    'solid-message-question': message_question_svg_2.ReactComponent,
    'solid-message-quote': message_quote_svg_2.ReactComponent,
    'solid-message-slash': message_slash_svg_2.ReactComponent,
    'solid-message-smile': message_smile_svg_2.ReactComponent,
    'solid-message-sms': message_sms_svg_2.ReactComponent,
    'solid-message-text': message_text_svg_2.ReactComponent,
    'solid-message-xmark': message_xmark_svg_2.ReactComponent,
    'solid-message': message_svg_2.ReactComponent,
    'solid-messages-dollar': messages_dollar_svg_2.ReactComponent,
    'solid-messages-question': messages_question_svg_2.ReactComponent,
    'solid-messages': messages_svg_2.ReactComponent,
    'solid-meteor': meteor_svg_2.ReactComponent,
    'solid-meter-bolt': meter_bolt_svg_2.ReactComponent,
    'solid-meter-droplet': meter_droplet_svg_2.ReactComponent,
    'solid-meter-fire': meter_fire_svg_2.ReactComponent,
    'solid-meter': meter_svg_2.ReactComponent,
    'solid-microchip-ai': microchip_ai_svg_2.ReactComponent,
    'solid-microchip': microchip_svg_2.ReactComponent,
    'solid-microphone-lines-slash': microphone_lines_slash_svg_2.ReactComponent,
    'solid-microphone-lines': microphone_lines_svg_2.ReactComponent,
    'solid-microphone-slash': microphone_slash_svg_2.ReactComponent,
    'solid-microphone-stand': microphone_stand_svg_2.ReactComponent,
    'solid-microphone': microphone_svg_2.ReactComponent,
    'solid-microscope': microscope_svg_2.ReactComponent,
    'solid-microwave': microwave_svg_2.ReactComponent,
    'solid-mill-sign': mill_sign_svg_2.ReactComponent,
    'solid-minimize': minimize_svg_2.ReactComponent,
    'solid-minus': minus_svg_2.ReactComponent,
    'solid-mistletoe': mistletoe_svg_2.ReactComponent,
    'solid-mitten': mitten_svg_2.ReactComponent,
    'solid-mobile-button': mobile_button_svg_2.ReactComponent,
    'solid-mobile-notch': mobile_notch_svg_2.ReactComponent,
    'solid-mobile-screen-button': mobile_screen_button_svg_2.ReactComponent,
    'solid-mobile-screen': mobile_screen_svg_2.ReactComponent,
    'solid-mobile': mobile_svg_2.ReactComponent,
    'solid-money-bill-1-wave': money_bill_1_wave_svg_2.ReactComponent,
    'solid-money-bill-1': money_bill_1_svg_2.ReactComponent,
    'solid-money-bill-simple-wave': money_bill_simple_wave_svg_2.ReactComponent,
    'solid-money-bill-simple': money_bill_simple_svg_2.ReactComponent,
    'solid-money-bill-wave': money_bill_wave_svg_2.ReactComponent,
    'solid-money-bill': money_bill_svg_2.ReactComponent,
    'solid-money-bills-simple': money_bills_simple_svg_2.ReactComponent,
    'solid-money-bills': money_bills_svg_2.ReactComponent,
    'solid-money-check-dollar-pen': money_check_dollar_pen_svg_2.ReactComponent,
    'solid-money-check-dollar': money_check_dollar_svg_2.ReactComponent,
    'solid-money-check-pen': money_check_pen_svg_2.ReactComponent,
    'solid-money-check': money_check_svg_2.ReactComponent,
    'solid-monitor-waveform': monitor_waveform_svg_2.ReactComponent,
    'solid-monkey': monkey_svg_2.ReactComponent,
    'solid-monument': monument_svg_2.ReactComponent,
    'solid-moon-cloud': moon_cloud_svg_2.ReactComponent,
    'solid-moon-over-sun': moon_over_sun_svg_2.ReactComponent,
    'solid-moon-stars': moon_stars_svg_2.ReactComponent,
    'solid-moon': moon_svg_2.ReactComponent,
    'solid-mortar-pestle': mortar_pestle_svg_2.ReactComponent,
    'solid-mosque': mosque_svg_2.ReactComponent,
    'solid-motorcycle': motorcycle_svg_2.ReactComponent,
    'solid-mountain': mountain_svg_2.ReactComponent,
    'solid-mountains': mountains_svg_2.ReactComponent,
    'solid-mp3-player': mp3_player_svg_2.ReactComponent,
    'solid-mug-hot': mug_hot_svg_2.ReactComponent,
    'solid-mug-marshmallows': mug_marshmallows_svg_2.ReactComponent,
    'solid-mug-saucer': mug_saucer_svg_2.ReactComponent,
    'solid-mug-tea-saucer': mug_tea_saucer_svg_2.ReactComponent,
    'solid-mug-tea': mug_tea_svg_2.ReactComponent,
    'solid-mug': mug_svg_2.ReactComponent,
    'solid-music-note-slash': music_note_slash_svg_2.ReactComponent,
    'solid-music-note': music_note_svg_2.ReactComponent,
    'solid-music-slash': music_slash_svg_2.ReactComponent,
    'solid-music': music_svg_2.ReactComponent,
    'solid-n': n_svg_2.ReactComponent,
    'solid-naira-sign': naira_sign_svg_2.ReactComponent,
    'solid-narwhal': narwhal_svg_2.ReactComponent,
    'solid-network-wired': network_wired_svg_2.ReactComponent,
    'solid-neuter': neuter_svg_2.ReactComponent,
    'solid-newspaper': newspaper_svg_2.ReactComponent,
    'solid-not-equal': not_equal_svg_2.ReactComponent,
    'solid-notdef': notdef_svg_2.ReactComponent,
    'solid-note-medical': note_medical_svg_2.ReactComponent,
    'solid-note-sticky': note_sticky_svg_2.ReactComponent,
    'solid-note': note_svg_2.ReactComponent,
    'solid-notes-medical': notes_medical_svg_2.ReactComponent,
    'solid-notes': notes_svg_2.ReactComponent,
    'solid-o': o_svg_2.ReactComponent,
    'solid-object-group': object_group_svg_2.ReactComponent,
    'solid-object-ungroup': object_ungroup_svg_2.ReactComponent,
    'solid-octagon-divide': octagon_divide_svg_2.ReactComponent,
    'solid-octagon-exclamation': octagon_exclamation_svg_2.ReactComponent,
    'solid-octagon-minus': octagon_minus_svg_2.ReactComponent,
    'solid-octagon-plus': octagon_plus_svg_2.ReactComponent,
    'solid-octagon-xmark': octagon_xmark_svg_2.ReactComponent,
    'solid-octagon': octagon_svg_2.ReactComponent,
    'solid-oil-can-drip': oil_can_drip_svg_2.ReactComponent,
    'solid-oil-can': oil_can_svg_2.ReactComponent,
    'solid-oil-temperature': oil_temperature_svg_2.ReactComponent,
    'solid-om': om_svg_2.ReactComponent,
    'solid-omega': omega_svg_2.ReactComponent,
    'solid-option': option_svg_2.ReactComponent,
    'solid-ornament': ornament_svg_2.ReactComponent,
    'solid-otter': otter_svg_2.ReactComponent,
    'solid-outdent': outdent_svg_2.ReactComponent,
    'solid-outlet': outlet_svg_2.ReactComponent,
    'solid-oven': oven_svg_2.ReactComponent,
    'solid-overline': overline_svg_2.ReactComponent,
    'solid-p': p_svg_2.ReactComponent,
    'solid-pager': pager_svg_2.ReactComponent,
    'solid-paint-brush-fine': paint_brush_fine_svg_2.ReactComponent,
    'solid-paint-brush': paint_brush_svg_2.ReactComponent,
    'solid-paint-roller': paint_roller_svg_2.ReactComponent,
    'solid-paintbrush-pencil': paintbrush_pencil_svg_2.ReactComponent,
    'solid-palette-boxes': palette_boxes_svg_2.ReactComponent,
    'solid-palette': palette_svg_2.ReactComponent,
    'solid-pallet-box': pallet_box_svg_2.ReactComponent,
    'solid-pallet-boxes': pallet_boxes_svg_2.ReactComponent,
    'solid-pallet': pallet_svg_2.ReactComponent,
    'solid-panorama': panorama_svg_2.ReactComponent,
    'solid-paper-plane-top': paper_plane_top_svg_2.ReactComponent,
    'solid-paper-plane': paper_plane_svg_2.ReactComponent,
    'solid-paperclip': paperclip_svg_2.ReactComponent,
    'solid-parachute-box': parachute_box_svg_2.ReactComponent,
    'solid-paragraph-left': paragraph_left_svg_2.ReactComponent,
    'solid-paragraph': paragraph_svg_2.ReactComponent,
    'solid-passport': passport_svg_2.ReactComponent,
    'solid-paste': paste_svg_2.ReactComponent,
    'solid-pause': pause_svg_2.ReactComponent,
    'solid-paw-claws': paw_claws_svg_2.ReactComponent,
    'solid-paw-simple': paw_simple_svg_2.ReactComponent,
    'solid-paw': paw_svg_2.ReactComponent,
    'solid-peace': peace_svg_2.ReactComponent,
    'solid-peach': peach_svg_2.ReactComponent,
    'solid-pear': pear_svg_2.ReactComponent,
    'solid-pedestal': pedestal_svg_2.ReactComponent,
    'solid-pegasus': pegasus_svg_2.ReactComponent,
    'solid-pen-circle': pen_circle_svg_2.ReactComponent,
    'solid-pen-clip-slash': pen_clip_slash_svg_2.ReactComponent,
    'solid-pen-clip': pen_clip_svg_2.ReactComponent,
    'solid-pen-fancy-slash': pen_fancy_slash_svg_2.ReactComponent,
    'solid-pen-fancy': pen_fancy_svg_2.ReactComponent,
    'solid-pen-field': pen_field_svg_2.ReactComponent,
    'solid-pen-line': pen_line_svg_2.ReactComponent,
    'solid-pen-nib': pen_nib_svg_2.ReactComponent,
    'solid-pen-paintbrush': pen_paintbrush_svg_2.ReactComponent,
    'solid-pen-ruler': pen_ruler_svg_2.ReactComponent,
    'solid-pen-slash': pen_slash_svg_2.ReactComponent,
    'solid-pen-swirl': pen_swirl_svg_2.ReactComponent,
    'solid-pen-to-square': pen_to_square_svg_2.ReactComponent,
    'solid-pen': pen_svg_2.ReactComponent,
    'solid-pencil-slash': pencil_slash_svg_2.ReactComponent,
    'solid-pencil': pencil_svg_2.ReactComponent,
    'solid-people-arrows-left-right': people_arrows_left_right_svg_2.ReactComponent,
    'solid-people-carry-box': people_carry_box_svg_2.ReactComponent,
    'solid-pepper-hot': pepper_hot_svg_2.ReactComponent,
    'solid-percent': percent_svg_2.ReactComponent,
    'solid-person-biking-mountain': person_biking_mountain_svg_2.ReactComponent,
    'solid-person-biking': person_biking_svg_2.ReactComponent,
    'solid-person-booth': person_booth_svg_2.ReactComponent,
    'solid-person-carry-box': person_carry_box_svg_2.ReactComponent,
    'solid-person-digging': person_digging_svg_2.ReactComponent,
    'solid-person-dolly-empty': person_dolly_empty_svg_2.ReactComponent,
    'solid-person-dolly': person_dolly_svg_2.ReactComponent,
    'solid-person-dots-from-line': person_dots_from_line_svg_2.ReactComponent,
    'solid-person-dress-simple': person_dress_simple_svg_2.ReactComponent,
    'solid-person-dress': person_dress_svg_2.ReactComponent,
    'solid-person-from-portal': person_from_portal_svg_2.ReactComponent,
    'solid-person-hiking': person_hiking_svg_2.ReactComponent,
    'solid-person-pinball': person_pinball_svg_2.ReactComponent,
    'solid-person-praying': person_praying_svg_2.ReactComponent,
    'solid-person-running': person_running_svg_2.ReactComponent,
    'solid-person-seat-reclined': person_seat_reclined_svg_2.ReactComponent,
    'solid-person-seat': person_seat_svg_2.ReactComponent,
    'solid-person-sign': person_sign_svg_2.ReactComponent,
    'solid-person-simple': person_simple_svg_2.ReactComponent,
    'solid-person-skating': person_skating_svg_2.ReactComponent,
    'solid-person-ski-jumping': person_ski_jumping_svg_2.ReactComponent,
    'solid-person-ski-lift': person_ski_lift_svg_2.ReactComponent,
    'solid-person-skiing-nordic': person_skiing_nordic_svg_2.ReactComponent,
    'solid-person-skiing': person_skiing_svg_2.ReactComponent,
    'solid-person-sledding': person_sledding_svg_2.ReactComponent,
    'solid-person-snowboarding': person_snowboarding_svg_2.ReactComponent,
    'solid-person-snowmobiling': person_snowmobiling_svg_2.ReactComponent,
    'solid-person-swimming': person_swimming_svg_2.ReactComponent,
    'solid-person-to-portal': person_to_portal_svg_2.ReactComponent,
    'solid-person-walking-with-cane': person_walking_with_cane_svg_2.ReactComponent,
    'solid-person-walking': person_walking_svg_2.ReactComponent,
    'solid-person': person_svg_2.ReactComponent,
    'solid-peseta-sign': peseta_sign_svg_2.ReactComponent,
    'solid-peso-sign': peso_sign_svg_2.ReactComponent,
    'solid-phone-arrow-down-left': phone_arrow_down_left_svg_2.ReactComponent,
    'solid-phone-arrow-up-right': phone_arrow_up_right_svg_2.ReactComponent,
    'solid-phone-flip': phone_flip_svg_2.ReactComponent,
    'solid-phone-hangup': phone_hangup_svg_2.ReactComponent,
    'solid-phone-missed': phone_missed_svg_2.ReactComponent,
    'solid-phone-office': phone_office_svg_2.ReactComponent,
    'solid-phone-plus': phone_plus_svg_2.ReactComponent,
    'solid-phone-rotary': phone_rotary_svg_2.ReactComponent,
    'solid-phone-slash': phone_slash_svg_2.ReactComponent,
    'solid-phone-volume': phone_volume_svg_2.ReactComponent,
    'solid-phone-xmark': phone_xmark_svg_2.ReactComponent,
    'solid-phone': phone_svg_2.ReactComponent,
    'solid-photo-film-music': photo_film_music_svg_2.ReactComponent,
    'solid-photo-film': photo_film_svg_2.ReactComponent,
    'solid-pi': pi_svg_2.ReactComponent,
    'solid-piano-keyboard': piano_keyboard_svg_2.ReactComponent,
    'solid-piano': piano_svg_2.ReactComponent,
    'solid-pie': pie_svg_2.ReactComponent,
    'solid-pig': pig_svg_2.ReactComponent,
    'solid-piggy-bank': piggy_bank_svg_2.ReactComponent,
    'solid-pills': pills_svg_2.ReactComponent,
    'solid-pinball': pinball_svg_2.ReactComponent,
    'solid-pizza-slice': pizza_slice_svg_2.ReactComponent,
    'solid-pizza': pizza_svg_2.ReactComponent,
    'solid-place-of-worship': place_of_worship_svg_2.ReactComponent,
    'solid-plane-arrival': plane_arrival_svg_2.ReactComponent,
    'solid-plane-departure': plane_departure_svg_2.ReactComponent,
    'solid-plane-engines': plane_engines_svg_2.ReactComponent,
    'solid-plane-prop': plane_prop_svg_2.ReactComponent,
    'solid-plane-slash': plane_slash_svg_2.ReactComponent,
    'solid-plane-tail': plane_tail_svg_2.ReactComponent,
    'solid-plane-up-slash': plane_up_slash_svg_2.ReactComponent,
    'solid-plane-up': plane_up_svg_2.ReactComponent,
    'solid-plane': plane_svg_2.ReactComponent,
    'solid-planet-moon': planet_moon_svg_2.ReactComponent,
    'solid-planet-ringed': planet_ringed_svg_2.ReactComponent,
    'solid-play-pause': play_pause_svg_2.ReactComponent,
    'solid-play': play_svg_2.ReactComponent,
    'solid-plug': plug_svg_2.ReactComponent,
    'solid-plus-minus': plus_minus_svg_2.ReactComponent,
    'solid-plus': plus_svg_2.ReactComponent,
    'solid-podcast': podcast_svg_2.ReactComponent,
    'solid-podium-star': podium_star_svg_2.ReactComponent,
    'solid-podium': podium_svg_2.ReactComponent,
    'solid-police-box': police_box_svg_2.ReactComponent,
    'solid-poll-people': poll_people_svg_2.ReactComponent,
    'solid-poo-bolt': poo_bolt_svg_2.ReactComponent,
    'solid-poo': poo_svg_2.ReactComponent,
    'solid-poop': poop_svg_2.ReactComponent,
    'solid-popcorn': popcorn_svg_2.ReactComponent,
    'solid-power-off': power_off_svg_2.ReactComponent,
    'solid-prescription-bottle-medical': prescription_bottle_medical_svg_2.ReactComponent,
    'solid-prescription-bottle': prescription_bottle_svg_2.ReactComponent,
    'solid-prescription': prescription_svg_2.ReactComponent,
    'solid-presentation-screen': presentation_screen_svg_2.ReactComponent,
    'solid-print-magnifying-glass': print_magnifying_glass_svg_2.ReactComponent,
    'solid-print-slash': print_slash_svg_2.ReactComponent,
    'solid-print': print_svg_2.ReactComponent,
    'solid-projector': projector_svg_2.ReactComponent,
    'solid-pump-medical': pump_medical_svg_2.ReactComponent,
    'solid-pump-soap': pump_soap_svg_2.ReactComponent,
    'solid-pumpkin': pumpkin_svg_2.ReactComponent,
    'solid-puzzle-piece-simple': puzzle_piece_simple_svg_2.ReactComponent,
    'solid-puzzle-piece': puzzle_piece_svg_2.ReactComponent,
    'solid-q': q_svg_2.ReactComponent,
    'solid-qrcode': qrcode_svg_2.ReactComponent,
    'solid-question': question_svg_2.ReactComponent,
    'solid-quidditch-broom-ball': quidditch_broom_ball_svg_2.ReactComponent,
    'solid-quote-left-round': quote_left_round_svg_2.ReactComponent,
    'solid-quote-left': quote_left_svg_2.ReactComponent,
    'solid-quote-right-round': quote_right_round_svg_2.ReactComponent,
    'solid-quote-right': quote_right_svg_2.ReactComponent,
    'solid-r': r_svg_2.ReactComponent,
    'solid-rabbit-running': rabbit_running_svg_2.ReactComponent,
    'solid-rabbit': rabbit_svg_2.ReactComponent,
    'solid-racquet': racquet_svg_2.ReactComponent,
    'solid-radar': radar_svg_2.ReactComponent,
    'solid-radiation': radiation_svg_2.ReactComponent,
    'solid-radio-tuner': radio_tuner_svg_2.ReactComponent,
    'solid-radio': radio_svg_2.ReactComponent,
    'solid-rainbow': rainbow_svg_2.ReactComponent,
    'solid-raindrops': raindrops_svg_2.ReactComponent,
    'solid-ram': ram_svg_2.ReactComponent,
    'solid-ramp-loading': ramp_loading_svg_2.ReactComponent,
    'solid-raygun': raygun_svg_2.ReactComponent,
    'solid-receipt': receipt_svg_2.ReactComponent,
    'solid-record-vinyl': record_vinyl_svg_2.ReactComponent,
    'solid-rectangle-ad': rectangle_ad_svg_2.ReactComponent,
    'solid-rectangle-barcode': rectangle_barcode_svg_2.ReactComponent,
    'solid-rectangle-list': rectangle_list_svg_2.ReactComponent,
    'solid-rectangle-terminal': rectangle_terminal_svg_2.ReactComponent,
    'solid-rectangle-vertical-history': rectangle_vertical_history_svg_2.ReactComponent,
    'solid-rectangle-vertical': rectangle_vertical_svg_2.ReactComponent,
    'solid-rectangle-wide': rectangle_wide_svg_2.ReactComponent,
    'solid-rectangle-xmark': rectangle_xmark_svg_2.ReactComponent,
    'solid-rectangle': rectangle_svg_2.ReactComponent,
    'solid-recycle': recycle_svg_2.ReactComponent,
    'solid-refrigerator': refrigerator_svg_2.ReactComponent,
    'solid-registered': registered_svg_2.ReactComponent,
    'solid-repeat-1': repeat_1_svg_2.ReactComponent,
    'solid-repeat': repeat_svg_2.ReactComponent,
    'solid-reply-all': reply_all_svg_2.ReactComponent,
    'solid-reply-clock': reply_clock_svg_2.ReactComponent,
    'solid-reply': reply_svg_2.ReactComponent,
    'solid-republican': republican_svg_2.ReactComponent,
    'solid-restroom-simple': restroom_simple_svg_2.ReactComponent,
    'solid-restroom': restroom_svg_2.ReactComponent,
    'solid-retweet': retweet_svg_2.ReactComponent,
    'solid-rhombus': rhombus_svg_2.ReactComponent,
    'solid-ribbon': ribbon_svg_2.ReactComponent,
    'solid-right-from-bracket': right_from_bracket_svg_2.ReactComponent,
    'solid-right-from-line': right_from_line_svg_2.ReactComponent,
    'solid-right-left': right_left_svg_2.ReactComponent,
    'solid-right-long': right_long_svg_2.ReactComponent,
    'solid-right-to-bracket': right_to_bracket_svg_2.ReactComponent,
    'solid-right-to-line': right_to_line_svg_2.ReactComponent,
    'solid-right': right_svg_2.ReactComponent,
    'solid-ring': ring_svg_2.ReactComponent,
    'solid-rings-wedding': rings_wedding_svg_2.ReactComponent,
    'solid-road': road_svg_2.ReactComponent,
    'solid-robot': robot_svg_2.ReactComponent,
    'solid-rocket-launch': rocket_launch_svg_2.ReactComponent,
    'solid-rocket': rocket_svg_2.ReactComponent,
    'solid-rotate-exclamation': rotate_exclamation_svg_2.ReactComponent,
    'solid-rotate-forward': rotate_forward_svg_2.ReactComponent,
    'solid-rotate-left': rotate_left_svg_2.ReactComponent,
    'solid-rotate': rotate_svg_2.ReactComponent,
    'solid-route-highway': route_highway_svg_2.ReactComponent,
    'solid-route-interstate': route_interstate_svg_2.ReactComponent,
    'solid-route': route_svg_2.ReactComponent,
    'solid-router': router_svg_2.ReactComponent,
    'solid-rss': rss_svg_2.ReactComponent,
    'solid-ruble-sign': ruble_sign_svg_2.ReactComponent,
    'solid-ruler-combined': ruler_combined_svg_2.ReactComponent,
    'solid-ruler-horizontal': ruler_horizontal_svg_2.ReactComponent,
    'solid-ruler-triangle': ruler_triangle_svg_2.ReactComponent,
    'solid-ruler-vertical': ruler_vertical_svg_2.ReactComponent,
    'solid-ruler': ruler_svg_2.ReactComponent,
    'solid-rupee-sign': rupee_sign_svg_2.ReactComponent,
    'solid-rupiah-sign': rupiah_sign_svg_2.ReactComponent,
    'solid-rv': rv_svg_2.ReactComponent,
    'solid-s': s_svg_2.ReactComponent,
    'solid-sack-dollar': sack_dollar_svg_2.ReactComponent,
    'solid-sack': sack_svg_2.ReactComponent,
    'solid-salad': salad_svg_2.ReactComponent,
    'solid-sandwich': sandwich_svg_2.ReactComponent,
    'solid-satellite-dish': satellite_dish_svg_2.ReactComponent,
    'solid-satellite': satellite_svg_2.ReactComponent,
    'solid-sausage': sausage_svg_2.ReactComponent,
    'solid-saxophone-fire': saxophone_fire_svg_2.ReactComponent,
    'solid-saxophone': saxophone_svg_2.ReactComponent,
    'solid-scale-balanced': scale_balanced_svg_2.ReactComponent,
    'solid-scale-unbalanced-flip': scale_unbalanced_flip_svg_2.ReactComponent,
    'solid-scale-unbalanced': scale_unbalanced_svg_2.ReactComponent,
    'solid-scalpel-line-dashed': scalpel_line_dashed_svg_2.ReactComponent,
    'solid-scalpel': scalpel_svg_2.ReactComponent,
    'solid-scanner-gun': scanner_gun_svg_2.ReactComponent,
    'solid-scanner-keyboard': scanner_keyboard_svg_2.ReactComponent,
    'solid-scanner-touchscreen': scanner_touchscreen_svg_2.ReactComponent,
    'solid-scanner': scanner_svg_2.ReactComponent,
    'solid-scarecrow': scarecrow_svg_2.ReactComponent,
    'solid-scarf': scarf_svg_2.ReactComponent,
    'solid-school': school_svg_2.ReactComponent,
    'solid-scissors': scissors_svg_2.ReactComponent,
    'solid-screen-users': screen_users_svg_2.ReactComponent,
    'solid-screencast': screencast_svg_2.ReactComponent,
    'solid-screwdriver-wrench': screwdriver_wrench_svg_2.ReactComponent,
    'solid-screwdriver': screwdriver_svg_2.ReactComponent,
    'solid-scribble': scribble_svg_2.ReactComponent,
    'solid-scroll-old': scroll_old_svg_2.ReactComponent,
    'solid-scroll-torah': scroll_torah_svg_2.ReactComponent,
    'solid-scroll': scroll_svg_2.ReactComponent,
    'solid-scrubber': scrubber_svg_2.ReactComponent,
    'solid-scythe': scythe_svg_2.ReactComponent,
    'solid-sd-card': sd_card_svg_2.ReactComponent,
    'solid-sd-cards': sd_cards_svg_2.ReactComponent,
    'solid-seal-exclamation': seal_exclamation_svg_2.ReactComponent,
    'solid-seal-question': seal_question_svg_2.ReactComponent,
    'solid-seal': seal_svg_2.ReactComponent,
    'solid-seat-airline': seat_airline_svg_2.ReactComponent,
    'solid-section': section_svg_2.ReactComponent,
    'solid-seedling': seedling_svg_2.ReactComponent,
    'solid-send-back': send_back_svg_2.ReactComponent,
    'solid-send-backward': send_backward_svg_2.ReactComponent,
    'solid-sensor-cloud': sensor_cloud_svg_2.ReactComponent,
    'solid-sensor-fire': sensor_fire_svg_2.ReactComponent,
    'solid-sensor-on': sensor_on_svg_2.ReactComponent,
    'solid-sensor-triangle-exclamation': sensor_triangle_exclamation_svg_2.ReactComponent,
    'solid-sensor': sensor_svg_2.ReactComponent,
    'solid-server': server_svg_2.ReactComponent,
    'solid-shapes': shapes_svg_2.ReactComponent,
    'solid-share-all': share_all_svg_2.ReactComponent,
    'solid-share-from-square': share_from_square_svg_2.ReactComponent,
    'solid-share-nodes': share_nodes_svg_2.ReactComponent,
    'solid-share': share_svg_2.ReactComponent,
    'solid-sheep': sheep_svg_2.ReactComponent,
    'solid-shekel-sign': shekel_sign_svg_2.ReactComponent,
    'solid-shelves-empty': shelves_empty_svg_2.ReactComponent,
    'solid-shelves': shelves_svg_2.ReactComponent,
    'solid-shield-blank': shield_blank_svg_2.ReactComponent,
    'solid-shield-check': shield_check_svg_2.ReactComponent,
    'solid-shield-cross': shield_cross_svg_2.ReactComponent,
    'solid-shield-exclamation': shield_exclamation_svg_2.ReactComponent,
    'solid-shield-keyhole': shield_keyhole_svg_2.ReactComponent,
    'solid-shield-minus': shield_minus_svg_2.ReactComponent,
    'solid-shield-plus': shield_plus_svg_2.ReactComponent,
    'solid-shield-slash': shield_slash_svg_2.ReactComponent,
    'solid-shield-virus': shield_virus_svg_2.ReactComponent,
    'solid-shield-xmark': shield_xmark_svg_2.ReactComponent,
    'solid-shield': shield_svg_2.ReactComponent,
    'solid-ship': ship_svg_2.ReactComponent,
    'solid-shish-kebab': shish_kebab_svg_2.ReactComponent,
    'solid-shoe-prints': shoe_prints_svg_2.ReactComponent,
    'solid-shop-slash': shop_slash_svg_2.ReactComponent,
    'solid-shop': shop_svg_2.ReactComponent,
    'solid-shovel-snow': shovel_snow_svg_2.ReactComponent,
    'solid-shovel': shovel_svg_2.ReactComponent,
    'solid-shower-down': shower_down_svg_2.ReactComponent,
    'solid-shower': shower_svg_2.ReactComponent,
    'solid-shredder': shredder_svg_2.ReactComponent,
    'solid-shuffle': shuffle_svg_2.ReactComponent,
    'solid-shuttle-space': shuttle_space_svg_2.ReactComponent,
    'solid-shuttlecock': shuttlecock_svg_2.ReactComponent,
    'solid-sickle': sickle_svg_2.ReactComponent,
    'solid-sidebar-flip': sidebar_flip_svg_2.ReactComponent,
    'solid-sidebar': sidebar_svg_2.ReactComponent,
    'solid-sigma': sigma_svg_2.ReactComponent,
    'solid-sign-hanging': sign_hanging_svg_2.ReactComponent,
    'solid-signal-bars-fair': signal_bars_fair_svg_2.ReactComponent,
    'solid-signal-bars-good': signal_bars_good_svg_2.ReactComponent,
    'solid-signal-bars-slash': signal_bars_slash_svg_2.ReactComponent,
    'solid-signal-bars-weak': signal_bars_weak_svg_2.ReactComponent,
    'solid-signal-bars': signal_bars_svg_2.ReactComponent,
    'solid-signal-fair': signal_fair_svg_2.ReactComponent,
    'solid-signal-good': signal_good_svg_2.ReactComponent,
    'solid-signal-slash': signal_slash_svg_2.ReactComponent,
    'solid-signal-stream-slash': signal_stream_slash_svg_2.ReactComponent,
    'solid-signal-stream': signal_stream_svg_2.ReactComponent,
    'solid-signal-strong': signal_strong_svg_2.ReactComponent,
    'solid-signal-weak': signal_weak_svg_2.ReactComponent,
    'solid-signal': signal_svg_2.ReactComponent,
    'solid-signature': signature_svg_2.ReactComponent,
    'solid-signs-post': signs_post_svg_2.ReactComponent,
    'solid-sim-card': sim_card_svg_2.ReactComponent,
    'solid-sim-cards': sim_cards_svg_2.ReactComponent,
    'solid-sink': sink_svg_2.ReactComponent,
    'solid-siren-on': siren_on_svg_2.ReactComponent,
    'solid-siren': siren_svg_2.ReactComponent,
    'solid-sitemap': sitemap_svg_2.ReactComponent,
    'solid-skeleton': skeleton_svg_2.ReactComponent,
    'solid-skull-cow': skull_cow_svg_2.ReactComponent,
    'solid-skull-crossbones': skull_crossbones_svg_2.ReactComponent,
    'solid-skull': skull_svg_2.ReactComponent,
    'solid-slash': slash_svg_2.ReactComponent,
    'solid-sleigh': sleigh_svg_2.ReactComponent,
    'solid-slider': slider_svg_2.ReactComponent,
    'solid-sliders-up': sliders_up_svg_2.ReactComponent,
    'solid-sliders': sliders_svg_2.ReactComponent,
    'solid-smog': smog_svg_2.ReactComponent,
    'solid-smoke': smoke_svg_2.ReactComponent,
    'solid-smoking': smoking_svg_2.ReactComponent,
    'solid-snake': snake_svg_2.ReactComponent,
    'solid-snooze': snooze_svg_2.ReactComponent,
    'solid-snow-blowing': snow_blowing_svg_2.ReactComponent,
    'solid-snowflake': snowflake_svg_2.ReactComponent,
    'solid-snowflakes': snowflakes_svg_2.ReactComponent,
    'solid-snowman-head': snowman_head_svg_2.ReactComponent,
    'solid-snowman': snowman_svg_2.ReactComponent,
    'solid-snowplow': snowplow_svg_2.ReactComponent,
    'solid-soap': soap_svg_2.ReactComponent,
    'solid-socks': socks_svg_2.ReactComponent,
    'solid-solar-panel': solar_panel_svg_2.ReactComponent,
    'solid-solar-system': solar_system_svg_2.ReactComponent,
    'solid-sort-down': sort_down_svg_2.ReactComponent,
    'solid-sort-up': sort_up_svg_2.ReactComponent,
    'solid-sort': sort_svg_2.ReactComponent,
    'solid-spa': spa_svg_2.ReactComponent,
    'solid-space-station-moon-construction': space_station_moon_construction_svg_2.ReactComponent,
    'solid-space-station-moon': space_station_moon_svg_2.ReactComponent,
    'solid-spade': spade_svg_2.ReactComponent,
    'solid-spaghetti-monster-flying': spaghetti_monster_flying_svg_2.ReactComponent,
    'solid-sparkles': sparkles_svg_2.ReactComponent,
    'solid-speaker': speaker_svg_2.ReactComponent,
    'solid-speakers': speakers_svg_2.ReactComponent,
    'solid-spell-check': spell_check_svg_2.ReactComponent,
    'solid-spider-black-widow': spider_black_widow_svg_2.ReactComponent,
    'solid-spider-web': spider_web_svg_2.ReactComponent,
    'solid-spider': spider_svg_2.ReactComponent,
    'solid-spinner-third': spinner_third_svg_2.ReactComponent,
    'solid-spinner': spinner_svg_2.ReactComponent,
    'solid-split': split_svg_2.ReactComponent,
    'solid-splotch': splotch_svg_2.ReactComponent,
    'solid-spoon': spoon_svg_2.ReactComponent,
    'solid-spray-can': spray_can_svg_2.ReactComponent,
    'solid-sprinkler': sprinkler_svg_2.ReactComponent,
    'solid-square-0': square_0_svg_2.ReactComponent,
    'solid-square-1': square_1_svg_2.ReactComponent,
    'solid-square-2': square_2_svg_2.ReactComponent,
    'solid-square-3': square_3_svg_2.ReactComponent,
    'solid-square-4': square_4_svg_2.ReactComponent,
    'solid-square-5': square_5_svg_2.ReactComponent,
    'solid-square-6': square_6_svg_2.ReactComponent,
    'solid-square-7': square_7_svg_2.ReactComponent,
    'solid-square-8': square_8_svg_2.ReactComponent,
    'solid-square-9': square_9_svg_2.ReactComponent,
    'solid-square-a': square_a_svg_2.ReactComponent,
    'solid-square-ampersand': square_ampersand_svg_2.ReactComponent,
    'solid-square-arrow-down-left': square_arrow_down_left_svg_2.ReactComponent,
    'solid-square-arrow-down-right': square_arrow_down_right_svg_2.ReactComponent,
    'solid-square-arrow-down': square_arrow_down_svg_2.ReactComponent,
    'solid-square-arrow-left': square_arrow_left_svg_2.ReactComponent,
    'solid-square-arrow-right': square_arrow_right_svg_2.ReactComponent,
    'solid-square-arrow-up-left': square_arrow_up_left_svg_2.ReactComponent,
    'solid-square-arrow-up-right': square_arrow_up_right_svg_2.ReactComponent,
    'solid-square-arrow-up': square_arrow_up_svg_2.ReactComponent,
    'solid-square-b': square_b_svg_2.ReactComponent,
    'solid-square-bolt': square_bolt_svg_2.ReactComponent,
    'solid-square-c': square_c_svg_2.ReactComponent,
    'solid-square-caret-down': square_caret_down_svg_2.ReactComponent,
    'solid-square-caret-left': square_caret_left_svg_2.ReactComponent,
    'solid-square-caret-right': square_caret_right_svg_2.ReactComponent,
    'solid-square-caret-up': square_caret_up_svg_2.ReactComponent,
    'solid-square-check': square_check_svg_2.ReactComponent,
    'solid-square-chevron-down': square_chevron_down_svg_2.ReactComponent,
    'solid-square-chevron-left': square_chevron_left_svg_2.ReactComponent,
    'solid-square-chevron-right': square_chevron_right_svg_2.ReactComponent,
    'solid-square-chevron-up': square_chevron_up_svg_2.ReactComponent,
    'solid-square-code': square_code_svg_2.ReactComponent,
    'solid-square-d': square_d_svg_2.ReactComponent,
    'solid-square-dashed': square_dashed_svg_2.ReactComponent,
    'solid-square-divide': square_divide_svg_2.ReactComponent,
    'solid-square-dollar': square_dollar_svg_2.ReactComponent,
    'solid-square-down-left': square_down_left_svg_2.ReactComponent,
    'solid-square-down-right': square_down_right_svg_2.ReactComponent,
    'solid-square-down': square_down_svg_2.ReactComponent,
    'solid-square-e': square_e_svg_2.ReactComponent,
    'solid-square-envelope': square_envelope_svg_2.ReactComponent,
    'solid-square-exclamation': square_exclamation_svg_2.ReactComponent,
    'solid-square-f': square_f_svg_2.ReactComponent,
    'solid-square-fragile': square_fragile_svg_2.ReactComponent,
    'solid-square-full': square_full_svg_2.ReactComponent,
    'solid-square-g': square_g_svg_2.ReactComponent,
    'solid-square-h': square_h_svg_2.ReactComponent,
    'solid-square-heart': square_heart_svg_2.ReactComponent,
    'solid-square-i': square_i_svg_2.ReactComponent,
    'solid-square-info': square_info_svg_2.ReactComponent,
    'solid-square-j': square_j_svg_2.ReactComponent,
    'solid-square-k': square_k_svg_2.ReactComponent,
    'solid-square-l': square_l_svg_2.ReactComponent,
    'solid-square-left': square_left_svg_2.ReactComponent,
    'solid-square-m': square_m_svg_2.ReactComponent,
    'solid-square-minus': square_minus_svg_2.ReactComponent,
    'solid-square-n': square_n_svg_2.ReactComponent,
    'solid-square-o': square_o_svg_2.ReactComponent,
    'solid-square-p': square_p_svg_2.ReactComponent,
    'solid-square-parking-slash': square_parking_slash_svg_2.ReactComponent,
    'solid-square-parking': square_parking_svg_2.ReactComponent,
    'solid-square-pen': square_pen_svg_2.ReactComponent,
    'solid-square-phone-flip': square_phone_flip_svg_2.ReactComponent,
    'solid-square-phone-hangup': square_phone_hangup_svg_2.ReactComponent,
    'solid-square-phone': square_phone_svg_2.ReactComponent,
    'solid-square-plus': square_plus_svg_2.ReactComponent,
    'solid-square-poll-horizontal': square_poll_horizontal_svg_2.ReactComponent,
    'solid-square-poll-vertical': square_poll_vertical_svg_2.ReactComponent,
    'solid-square-q': square_q_svg_2.ReactComponent,
    'solid-square-question': square_question_svg_2.ReactComponent,
    'solid-square-r': square_r_svg_2.ReactComponent,
    'solid-square-right': square_right_svg_2.ReactComponent,
    'solid-square-root-variable': square_root_variable_svg_2.ReactComponent,
    'solid-square-root': square_root_svg_2.ReactComponent,
    'solid-square-rss': square_rss_svg_2.ReactComponent,
    'solid-square-s': square_s_svg_2.ReactComponent,
    'solid-square-share-nodes': square_share_nodes_svg_2.ReactComponent,
    'solid-square-sliders-vertical': square_sliders_vertical_svg_2.ReactComponent,
    'solid-square-sliders': square_sliders_svg_2.ReactComponent,
    'solid-square-small': square_small_svg_2.ReactComponent,
    'solid-square-star': square_star_svg_2.ReactComponent,
    'solid-square-t': square_t_svg_2.ReactComponent,
    'solid-square-this-way-up': square_this_way_up_svg_2.ReactComponent,
    'solid-square-u': square_u_svg_2.ReactComponent,
    'solid-square-up-left': square_up_left_svg_2.ReactComponent,
    'solid-square-up-right': square_up_right_svg_2.ReactComponent,
    'solid-square-up': square_up_svg_2.ReactComponent,
    'solid-square-user': square_user_svg_2.ReactComponent,
    'solid-square-v': square_v_svg_2.ReactComponent,
    'solid-square-w': square_w_svg_2.ReactComponent,
    'solid-square-x': square_x_svg_2.ReactComponent,
    'solid-square-xmark': square_xmark_svg_2.ReactComponent,
    'solid-square-y': square_y_svg_2.ReactComponent,
    'solid-square-z': square_z_svg_2.ReactComponent,
    'solid-square': square_svg_2.ReactComponent,
    'solid-squirrel': squirrel_svg_2.ReactComponent,
    'solid-staff': staff_svg_2.ReactComponent,
    'solid-stairs': stairs_svg_2.ReactComponent,
    'solid-stamp': stamp_svg_2.ReactComponent,
    'solid-standard-definition': standard_definition_svg_2.ReactComponent,
    'solid-star-and-crescent': star_and_crescent_svg_2.ReactComponent,
    'solid-star-christmas': star_christmas_svg_2.ReactComponent,
    'solid-star-exclamation': star_exclamation_svg_2.ReactComponent,
    'solid-star-half-stroke': star_half_stroke_svg_2.ReactComponent,
    'solid-star-half': star_half_svg_2.ReactComponent,
    'solid-star-of-david': star_of_david_svg_2.ReactComponent,
    'solid-star-of-life': star_of_life_svg_2.ReactComponent,
    'solid-star-sharp-half-stroke': star_sharp_half_stroke_svg_2.ReactComponent,
    'solid-star-sharp-half': star_sharp_half_svg_2.ReactComponent,
    'solid-star-sharp': star_sharp_svg_2.ReactComponent,
    'solid-star-shooting': star_shooting_svg_2.ReactComponent,
    'solid-star': star_svg_2.ReactComponent,
    'solid-starfighter-twin-ion-engine-advanced': starfighter_twin_ion_engine_advanced_svg_2.ReactComponent,
    'solid-starfighter-twin-ion-engine': starfighter_twin_ion_engine_svg_2.ReactComponent,
    'solid-starfighter': starfighter_svg_2.ReactComponent,
    'solid-stars': stars_svg_2.ReactComponent,
    'solid-starship-freighter': starship_freighter_svg_2.ReactComponent,
    'solid-starship': starship_svg_2.ReactComponent,
    'solid-steak': steak_svg_2.ReactComponent,
    'solid-steering-wheel': steering_wheel_svg_2.ReactComponent,
    'solid-sterling-sign': sterling_sign_svg_2.ReactComponent,
    'solid-stethoscope': stethoscope_svg_2.ReactComponent,
    'solid-stocking': stocking_svg_2.ReactComponent,
    'solid-stomach': stomach_svg_2.ReactComponent,
    'solid-stop': stop_svg_2.ReactComponent,
    'solid-stopwatch-20': stopwatch_20_svg_2.ReactComponent,
    'solid-stopwatch': stopwatch_svg_2.ReactComponent,
    'solid-store-slash': store_slash_svg_2.ReactComponent,
    'solid-store': store_svg_2.ReactComponent,
    'solid-street-view': street_view_svg_2.ReactComponent,
    'solid-stretcher': stretcher_svg_2.ReactComponent,
    'solid-strikethrough': strikethrough_svg_2.ReactComponent,
    'solid-stroopwafel': stroopwafel_svg_2.ReactComponent,
    'solid-subscript': subscript_svg_2.ReactComponent,
    'solid-suitcase-medical': suitcase_medical_svg_2.ReactComponent,
    'solid-suitcase-rolling': suitcase_rolling_svg_2.ReactComponent,
    'solid-suitcase': suitcase_svg_2.ReactComponent,
    'solid-sun-bright': sun_bright_svg_2.ReactComponent,
    'solid-sun-cloud': sun_cloud_svg_2.ReactComponent,
    'solid-sun-dust': sun_dust_svg_2.ReactComponent,
    'solid-sun-haze': sun_haze_svg_2.ReactComponent,
    'solid-sun': sun_svg_2.ReactComponent,
    'solid-sunglasses': sunglasses_svg_2.ReactComponent,
    'solid-sunrise': sunrise_svg_2.ReactComponent,
    'solid-sunset': sunset_svg_2.ReactComponent,
    'solid-superscript': superscript_svg_2.ReactComponent,
    'solid-swatchbook': swatchbook_svg_2.ReactComponent,
    'solid-sword-laser-alt': sword_laser_alt_svg_2.ReactComponent,
    'solid-sword-laser': sword_laser_svg_2.ReactComponent,
    'solid-sword': sword_svg_2.ReactComponent,
    'solid-swords-laser': swords_laser_svg_2.ReactComponent,
    'solid-swords': swords_svg_2.ReactComponent,
    'solid-symbols': symbols_svg_2.ReactComponent,
    'solid-synagogue': synagogue_svg_2.ReactComponent,
    'solid-syringe': syringe_svg_2.ReactComponent,
    'solid-t': t_svg_2.ReactComponent,
    'solid-table-cells-large': table_cells_large_svg_2.ReactComponent,
    'solid-table-cells': table_cells_svg_2.ReactComponent,
    'solid-table-columns': table_columns_svg_2.ReactComponent,
    'solid-table-layout': table_layout_svg_2.ReactComponent,
    'solid-table-list': table_list_svg_2.ReactComponent,
    'solid-table-pivot': table_pivot_svg_2.ReactComponent,
    'solid-table-rows': table_rows_svg_2.ReactComponent,
    'solid-table-tennis-paddle-ball': table_tennis_paddle_ball_svg_2.ReactComponent,
    'solid-table-tree': table_tree_svg_2.ReactComponent,
    'solid-table': table_svg_2.ReactComponent,
    'solid-tablet-button': tablet_button_svg_2.ReactComponent,
    'solid-tablet-rugged': tablet_rugged_svg_2.ReactComponent,
    'solid-tablet-screen-button': tablet_screen_button_svg_2.ReactComponent,
    'solid-tablet-screen': tablet_screen_svg_2.ReactComponent,
    'solid-tablet': tablet_svg_2.ReactComponent,
    'solid-tablets': tablets_svg_2.ReactComponent,
    'solid-tachograph-digital': tachograph_digital_svg_2.ReactComponent,
    'solid-taco': taco_svg_2.ReactComponent,
    'solid-tag': tag_svg_2.ReactComponent,
    'solid-tags': tags_svg_2.ReactComponent,
    'solid-tally-1': tally_1_svg_2.ReactComponent,
    'solid-tally-2': tally_2_svg_2.ReactComponent,
    'solid-tally-3': tally_3_svg_2.ReactComponent,
    'solid-tally-4': tally_4_svg_2.ReactComponent,
    'solid-tally': tally_svg_2.ReactComponent,
    'solid-tape': tape_svg_2.ReactComponent,
    'solid-taxi-bus': taxi_bus_svg_2.ReactComponent,
    'solid-taxi': taxi_svg_2.ReactComponent,
    'solid-teeth-open': teeth_open_svg_2.ReactComponent,
    'solid-teeth': teeth_svg_2.ReactComponent,
    'solid-telescope': telescope_svg_2.ReactComponent,
    'solid-temperature-arrow-down': temperature_arrow_down_svg_2.ReactComponent,
    'solid-temperature-arrow-up': temperature_arrow_up_svg_2.ReactComponent,
    'solid-temperature-empty': temperature_empty_svg_2.ReactComponent,
    'solid-temperature-full': temperature_full_svg_2.ReactComponent,
    'solid-temperature-half': temperature_half_svg_2.ReactComponent,
    'solid-temperature-high': temperature_high_svg_2.ReactComponent,
    'solid-temperature-list': temperature_list_svg_2.ReactComponent,
    'solid-temperature-low': temperature_low_svg_2.ReactComponent,
    'solid-temperature-quarter': temperature_quarter_svg_2.ReactComponent,
    'solid-temperature-snow': temperature_snow_svg_2.ReactComponent,
    'solid-temperature-sun': temperature_sun_svg_2.ReactComponent,
    'solid-temperature-three-quarters': temperature_three_quarters_svg_2.ReactComponent,
    'solid-tenge-sign': tenge_sign_svg_2.ReactComponent,
    'solid-tennis-ball': tennis_ball_svg_2.ReactComponent,
    'solid-terminal': terminal_svg_2.ReactComponent,
    'solid-text-height': text_height_svg_2.ReactComponent,
    'solid-text-size': text_size_svg_2.ReactComponent,
    'solid-text-slash': text_slash_svg_2.ReactComponent,
    'solid-text-width': text_width_svg_2.ReactComponent,
    'solid-text': text_svg_2.ReactComponent,
    'solid-thermometer': thermometer_svg_2.ReactComponent,
    'solid-theta': theta_svg_2.ReactComponent,
    'solid-thumbs-down': thumbs_down_svg_2.ReactComponent,
    'solid-thumbs-up': thumbs_up_svg_2.ReactComponent,
    'solid-thumbtack': thumbtack_svg_2.ReactComponent,
    'solid-ticket-airline': ticket_airline_svg_2.ReactComponent,
    'solid-ticket-simple': ticket_simple_svg_2.ReactComponent,
    'solid-ticket': ticket_svg_2.ReactComponent,
    'solid-tickets-airline': tickets_airline_svg_2.ReactComponent,
    'solid-tilde': tilde_svg_2.ReactComponent,
    'solid-timeline-arrow': timeline_arrow_svg_2.ReactComponent,
    'solid-timeline': timeline_svg_2.ReactComponent,
    'solid-timer': timer_svg_2.ReactComponent,
    'solid-tire-flat': tire_flat_svg_2.ReactComponent,
    'solid-tire-pressure-warning': tire_pressure_warning_svg_2.ReactComponent,
    'solid-tire-rugged': tire_rugged_svg_2.ReactComponent,
    'solid-tire': tire_svg_2.ReactComponent,
    'solid-toggle-off': toggle_off_svg_2.ReactComponent,
    'solid-toggle-on': toggle_on_svg_2.ReactComponent,
    'solid-toilet-paper-blank-under': toilet_paper_blank_under_svg_2.ReactComponent,
    'solid-toilet-paper-blank': toilet_paper_blank_svg_2.ReactComponent,
    'solid-toilet-paper-slash': toilet_paper_slash_svg_2.ReactComponent,
    'solid-toilet-paper-under-slash': toilet_paper_under_slash_svg_2.ReactComponent,
    'solid-toilet-paper-under': toilet_paper_under_svg_2.ReactComponent,
    'solid-toilet-paper': toilet_paper_svg_2.ReactComponent,
    'solid-toilet': toilet_svg_2.ReactComponent,
    'solid-tombstone-blank': tombstone_blank_svg_2.ReactComponent,
    'solid-tombstone': tombstone_svg_2.ReactComponent,
    'solid-toolbox': toolbox_svg_2.ReactComponent,
    'solid-tooth': tooth_svg_2.ReactComponent,
    'solid-toothbrush': toothbrush_svg_2.ReactComponent,
    'solid-torii-gate': torii_gate_svg_2.ReactComponent,
    'solid-tornado': tornado_svg_2.ReactComponent,
    'solid-tower-broadcast': tower_broadcast_svg_2.ReactComponent,
    'solid-tower-control': tower_control_svg_2.ReactComponent,
    'solid-tractor': tractor_svg_2.ReactComponent,
    'solid-trademark': trademark_svg_2.ReactComponent,
    'solid-traffic-cone': traffic_cone_svg_2.ReactComponent,
    'solid-traffic-light-go': traffic_light_go_svg_2.ReactComponent,
    'solid-traffic-light-slow': traffic_light_slow_svg_2.ReactComponent,
    'solid-traffic-light-stop': traffic_light_stop_svg_2.ReactComponent,
    'solid-traffic-light': traffic_light_svg_2.ReactComponent,
    'solid-trailer': trailer_svg_2.ReactComponent,
    'solid-train-subway-tunnel': train_subway_tunnel_svg_2.ReactComponent,
    'solid-train-subway': train_subway_svg_2.ReactComponent,
    'solid-train-tram': train_tram_svg_2.ReactComponent,
    'solid-train': train_svg_2.ReactComponent,
    'solid-transformer-bolt': transformer_bolt_svg_2.ReactComponent,
    'solid-transgender-alt': transgender_alt_svg_2.ReactComponent,
    'solid-transgender': transgender_svg_2.ReactComponent,
    'solid-transporter-1': transporter_1_svg_2.ReactComponent,
    'solid-transporter-2': transporter_2_svg_2.ReactComponent,
    'solid-transporter-3': transporter_3_svg_2.ReactComponent,
    'solid-transporter-4': transporter_4_svg_2.ReactComponent,
    'solid-transporter-5': transporter_5_svg_2.ReactComponent,
    'solid-transporter-6': transporter_6_svg_2.ReactComponent,
    'solid-transporter-7': transporter_7_svg_2.ReactComponent,
    'solid-transporter-empty': transporter_empty_svg_2.ReactComponent,
    'solid-transporter': transporter_svg_2.ReactComponent,
    'solid-trash-arrow-up': trash_arrow_up_svg_2.ReactComponent,
    'solid-trash-can-arrow-up': trash_can_arrow_up_svg_2.ReactComponent,
    'solid-trash-can-clock': trash_can_clock_svg_2.ReactComponent,
    'solid-trash-can-list': trash_can_list_svg_2.ReactComponent,
    'solid-trash-can-slash': trash_can_slash_svg_2.ReactComponent,
    'solid-trash-can-undo': trash_can_undo_svg_2.ReactComponent,
    'solid-trash-can': trash_can_svg_2.ReactComponent,
    'solid-trash-clock': trash_clock_svg_2.ReactComponent,
    'solid-trash-list': trash_list_svg_2.ReactComponent,
    'solid-trash-slash': trash_slash_svg_2.ReactComponent,
    'solid-trash-undo': trash_undo_svg_2.ReactComponent,
    'solid-trash': trash_svg_2.ReactComponent,
    'solid-treasure-chest': treasure_chest_svg_2.ReactComponent,
    'solid-tree-christmas': tree_christmas_svg_2.ReactComponent,
    'solid-tree-deciduous': tree_deciduous_svg_2.ReactComponent,
    'solid-tree-decorated': tree_decorated_svg_2.ReactComponent,
    'solid-tree-large': tree_large_svg_2.ReactComponent,
    'solid-tree-palm': tree_palm_svg_2.ReactComponent,
    'solid-tree': tree_svg_2.ReactComponent,
    'solid-trees': trees_svg_2.ReactComponent,
    'solid-triangle-exclamation': triangle_exclamation_svg_2.ReactComponent,
    'solid-triangle-instrument': triangle_instrument_svg_2.ReactComponent,
    'solid-triangle-person-digging': triangle_person_digging_svg_2.ReactComponent,
    'solid-triangle': triangle_svg_2.ReactComponent,
    'solid-trophy-star': trophy_star_svg_2.ReactComponent,
    'solid-trophy': trophy_svg_2.ReactComponent,
    'solid-truck-clock': truck_clock_svg_2.ReactComponent,
    'solid-truck-container-empty': truck_container_empty_svg_2.ReactComponent,
    'solid-truck-container': truck_container_svg_2.ReactComponent,
    'solid-truck-fast': truck_fast_svg_2.ReactComponent,
    'solid-truck-flatbed': truck_flatbed_svg_2.ReactComponent,
    'solid-truck-front': truck_front_svg_2.ReactComponent,
    'solid-truck-medical': truck_medical_svg_2.ReactComponent,
    'solid-truck-monster': truck_monster_svg_2.ReactComponent,
    'solid-truck-moving': truck_moving_svg_2.ReactComponent,
    'solid-truck-pickup': truck_pickup_svg_2.ReactComponent,
    'solid-truck-plow': truck_plow_svg_2.ReactComponent,
    'solid-truck-ramp-box': truck_ramp_box_svg_2.ReactComponent,
    'solid-truck-ramp-couch': truck_ramp_couch_svg_2.ReactComponent,
    'solid-truck-ramp': truck_ramp_svg_2.ReactComponent,
    'solid-truck-tow': truck_tow_svg_2.ReactComponent,
    'solid-truck': truck_svg_2.ReactComponent,
    'solid-trumpet': trumpet_svg_2.ReactComponent,
    'solid-tshirt': tshirt_svg_2.ReactComponent,
    'solid-tty-answer': tty_answer_svg_2.ReactComponent,
    'solid-tty': tty_svg_2.ReactComponent,
    'solid-tugrik-sign': tugrik_sign_svg_2.ReactComponent,
    'solid-turkey': turkey_svg_2.ReactComponent,
    'solid-turkish-lira-sign': turkish_lira_sign_svg_2.ReactComponent,
    'solid-turn-down': turn_down_svg_2.ReactComponent,
    'solid-turn-up': turn_up_svg_2.ReactComponent,
    'solid-turntable': turntable_svg_2.ReactComponent,
    'solid-turtle': turtle_svg_2.ReactComponent,
    'solid-tv-music': tv_music_svg_2.ReactComponent,
    'solid-tv-retro': tv_retro_svg_2.ReactComponent,
    'solid-tv': tv_svg_2.ReactComponent,
    'solid-typewriter': typewriter_svg_2.ReactComponent,
    'solid-u': u_svg_2.ReactComponent,
    'solid-ufo-beam': ufo_beam_svg_2.ReactComponent,
    'solid-ufo': ufo_svg_2.ReactComponent,
    'solid-umbrella-beach': umbrella_beach_svg_2.ReactComponent,
    'solid-umbrella-simple': umbrella_simple_svg_2.ReactComponent,
    'solid-umbrella': umbrella_svg_2.ReactComponent,
    'solid-underline': underline_svg_2.ReactComponent,
    'solid-unicorn': unicorn_svg_2.ReactComponent,
    'solid-union': union_svg_2.ReactComponent,
    'solid-universal-access': universal_access_svg_2.ReactComponent,
    'solid-unlock-keyhole': unlock_keyhole_svg_2.ReactComponent,
    'solid-unlock': unlock_svg_2.ReactComponent,
    'solid-up-down-left-right': up_down_left_right_svg_2.ReactComponent,
    'solid-up-down': up_down_svg_2.ReactComponent,
    'solid-up-from-line': up_from_line_svg_2.ReactComponent,
    'solid-up-left': up_left_svg_2.ReactComponent,
    'solid-up-long': up_long_svg_2.ReactComponent,
    'solid-up-right-and-down-left-from-center': up_right_and_down_left_from_center_svg_2.ReactComponent,
    'solid-up-right-from-square': up_right_from_square_svg_2.ReactComponent,
    'solid-up-right': up_right_svg_2.ReactComponent,
    'solid-up-to-line': up_to_line_svg_2.ReactComponent,
    'solid-up': up_svg_2.ReactComponent,
    'solid-upload': upload_svg_2.ReactComponent,
    'solid-usb-drive': usb_drive_svg_2.ReactComponent,
    'solid-user-alien': user_alien_svg_2.ReactComponent,
    'solid-user-astronaut': user_astronaut_svg_2.ReactComponent,
    'solid-user-bounty-hunter': user_bounty_hunter_svg_2.ReactComponent,
    'solid-user-check': user_check_svg_2.ReactComponent,
    'solid-user-clock': user_clock_svg_2.ReactComponent,
    'solid-user-cowboy': user_cowboy_svg_2.ReactComponent,
    'solid-user-crown': user_crown_svg_2.ReactComponent,
    'solid-user-doctor-message': user_doctor_message_svg_2.ReactComponent,
    'solid-user-doctor': user_doctor_svg_2.ReactComponent,
    'solid-user-gear': user_gear_svg_2.ReactComponent,
    'solid-user-graduate': user_graduate_svg_2.ReactComponent,
    'solid-user-group-crown': user_group_crown_svg_2.ReactComponent,
    'solid-user-group': user_group_svg_2.ReactComponent,
    'solid-user-headset': user_headset_svg_2.ReactComponent,
    'solid-user-helmet-safety': user_helmet_safety_svg_2.ReactComponent,
    'solid-user-injured': user_injured_svg_2.ReactComponent,
    'solid-user-large-slash': user_large_slash_svg_2.ReactComponent,
    'solid-user-large': user_large_svg_2.ReactComponent,
    'solid-user-lock': user_lock_svg_2.ReactComponent,
    'solid-user-minus': user_minus_svg_2.ReactComponent,
    'solid-user-music': user_music_svg_2.ReactComponent,
    'solid-user-ninja': user_ninja_svg_2.ReactComponent,
    'solid-user-nurse': user_nurse_svg_2.ReactComponent,
    'solid-user-pen': user_pen_svg_2.ReactComponent,
    'solid-user-pilot-tie': user_pilot_tie_svg_2.ReactComponent,
    'solid-user-pilot': user_pilot_svg_2.ReactComponent,
    'solid-user-plus': user_plus_svg_2.ReactComponent,
    'solid-user-robot': user_robot_svg_2.ReactComponent,
    'solid-user-secret': user_secret_svg_2.ReactComponent,
    'solid-user-shakespeare': user_shakespeare_svg_2.ReactComponent,
    'solid-user-shield': user_shield_svg_2.ReactComponent,
    'solid-user-slash': user_slash_svg_2.ReactComponent,
    'solid-user-tag': user_tag_svg_2.ReactComponent,
    'solid-user-tie': user_tie_svg_2.ReactComponent,
    'solid-user-unlock': user_unlock_svg_2.ReactComponent,
    'solid-user-visor': user_visor_svg_2.ReactComponent,
    'solid-user-xmark': user_xmark_svg_2.ReactComponent,
    'solid-user': user_svg_2.ReactComponent,
    'solid-users-gear': users_gear_svg_2.ReactComponent,
    'solid-users-medical': users_medical_svg_2.ReactComponent,
    'solid-users-slash': users_slash_svg_2.ReactComponent,
    'solid-users': users_svg_2.ReactComponent,
    'solid-utensils': utensils_svg_2.ReactComponent,
    'solid-utility-pole-double': utility_pole_double_svg_2.ReactComponent,
    'solid-utility-pole': utility_pole_svg_2.ReactComponent,
    'solid-v': v_svg_2.ReactComponent,
    'solid-vacuum-robot': vacuum_robot_svg_2.ReactComponent,
    'solid-vacuum': vacuum_svg_2.ReactComponent,
    'solid-value-absolute': value_absolute_svg_2.ReactComponent,
    'solid-van-shuttle': van_shuttle_svg_2.ReactComponent,
    'solid-vault': vault_svg_2.ReactComponent,
    'solid-vector-circle': vector_circle_svg_2.ReactComponent,
    'solid-vector-polygon': vector_polygon_svg_2.ReactComponent,
    'solid-vector-square': vector_square_svg_2.ReactComponent,
    'solid-venus-double': venus_double_svg_2.ReactComponent,
    'solid-venus-mars': venus_mars_svg_2.ReactComponent,
    'solid-venus': venus_svg_2.ReactComponent,
    'solid-vest-patches': vest_patches_svg_2.ReactComponent,
    'solid-vest': vest_svg_2.ReactComponent,
    'solid-vial': vial_svg_2.ReactComponent,
    'solid-vials': vials_svg_2.ReactComponent,
    'solid-video-arrow-down-left': video_arrow_down_left_svg_2.ReactComponent,
    'solid-video-arrow-up-right': video_arrow_up_right_svg_2.ReactComponent,
    'solid-video-plus': video_plus_svg_2.ReactComponent,
    'solid-video-slash': video_slash_svg_2.ReactComponent,
    'solid-video': video_svg_2.ReactComponent,
    'solid-vihara': vihara_svg_2.ReactComponent,
    'solid-violin': violin_svg_2.ReactComponent,
    'solid-virus-slash': virus_slash_svg_2.ReactComponent,
    'solid-virus': virus_svg_2.ReactComponent,
    'solid-viruses': viruses_svg_2.ReactComponent,
    'solid-voicemail': voicemail_svg_2.ReactComponent,
    'solid-volcano': volcano_svg_2.ReactComponent,
    'solid-volleyball-ball': volleyball_ball_svg_2.ReactComponent,
    'solid-volume-high': volume_high_svg_2.ReactComponent,
    'solid-volume-low': volume_low_svg_2.ReactComponent,
    'solid-volume-off': volume_off_svg_2.ReactComponent,
    'solid-volume-slash': volume_slash_svg_2.ReactComponent,
    'solid-volume-xmark': volume_xmark_svg_2.ReactComponent,
    'solid-volume': volume_svg_2.ReactComponent,
    'solid-vr-cardboard': vr_cardboard_svg_2.ReactComponent,
    'solid-w': w_svg_2.ReactComponent,
    'solid-wagon-covered': wagon_covered_svg_2.ReactComponent,
    'solid-walker': walker_svg_2.ReactComponent,
    'solid-walkie-talkie': walkie_talkie_svg_2.ReactComponent,
    'solid-wallet': wallet_svg_2.ReactComponent,
    'solid-wand-magic-sparkles': wand_magic_sparkles_svg_2.ReactComponent,
    'solid-wand-magic': wand_magic_svg_2.ReactComponent,
    'solid-wand-sparkles': wand_sparkles_svg_2.ReactComponent,
    'solid-wand': wand_svg_2.ReactComponent,
    'solid-warehouse-full': warehouse_full_svg_2.ReactComponent,
    'solid-warehouse': warehouse_svg_2.ReactComponent,
    'solid-washing-machine': washing_machine_svg_2.ReactComponent,
    'solid-watch-apple': watch_apple_svg_2.ReactComponent,
    'solid-watch-calculator': watch_calculator_svg_2.ReactComponent,
    'solid-watch-fitness': watch_fitness_svg_2.ReactComponent,
    'solid-watch-smart': watch_smart_svg_2.ReactComponent,
    'solid-watch': watch_svg_2.ReactComponent,
    'solid-water-arrow-down': water_arrow_down_svg_2.ReactComponent,
    'solid-water-arrow-up': water_arrow_up_svg_2.ReactComponent,
    'solid-water-ladder': water_ladder_svg_2.ReactComponent,
    'solid-water': water_svg_2.ReactComponent,
    'solid-wave-pulse': wave_pulse_svg_2.ReactComponent,
    'solid-wave-sine': wave_sine_svg_2.ReactComponent,
    'solid-wave-square': wave_square_svg_2.ReactComponent,
    'solid-wave-triangle': wave_triangle_svg_2.ReactComponent,
    'solid-waveform-lines': waveform_lines_svg_2.ReactComponent,
    'solid-waveform': waveform_svg_2.ReactComponent,
    'solid-weight-hanging': weight_hanging_svg_2.ReactComponent,
    'solid-weight-scale': weight_scale_svg_2.ReactComponent,
    'solid-whale': whale_svg_2.ReactComponent,
    'solid-wheat-awn': wheat_awn_svg_2.ReactComponent,
    'solid-wheat': wheat_svg_2.ReactComponent,
    'solid-wheelchair-move': wheelchair_move_svg_2.ReactComponent,
    'solid-wheelchair': wheelchair_svg_2.ReactComponent,
    'solid-whiskey-glass-ice': whiskey_glass_ice_svg_2.ReactComponent,
    'solid-whiskey-glass': whiskey_glass_svg_2.ReactComponent,
    'solid-whistle': whistle_svg_2.ReactComponent,
    'solid-wifi-exclamation': wifi_exclamation_svg_2.ReactComponent,
    'solid-wifi-fair': wifi_fair_svg_2.ReactComponent,
    'solid-wifi-slash': wifi_slash_svg_2.ReactComponent,
    'solid-wifi-weak': wifi_weak_svg_2.ReactComponent,
    'solid-wifi': wifi_svg_2.ReactComponent,
    'solid-wind-turbine': wind_turbine_svg_2.ReactComponent,
    'solid-wind-warning': wind_warning_svg_2.ReactComponent,
    'solid-wind': wind_svg_2.ReactComponent,
    'solid-window-flip': window_flip_svg_2.ReactComponent,
    'solid-window-frame-open': window_frame_open_svg_2.ReactComponent,
    'solid-window-frame': window_frame_svg_2.ReactComponent,
    'solid-window-maximize': window_maximize_svg_2.ReactComponent,
    'solid-window-minimize': window_minimize_svg_2.ReactComponent,
    'solid-window-restore': window_restore_svg_2.ReactComponent,
    'solid-window': window_svg_2.ReactComponent,
    'solid-windsock': windsock_svg_2.ReactComponent,
    'solid-wine-bottle': wine_bottle_svg_2.ReactComponent,
    'solid-wine-glass-crack': wine_glass_crack_svg_2.ReactComponent,
    'solid-wine-glass-empty': wine_glass_empty_svg_2.ReactComponent,
    'solid-wine-glass': wine_glass_svg_2.ReactComponent,
    'solid-won-sign': won_sign_svg_2.ReactComponent,
    'solid-wreath': wreath_svg_2.ReactComponent,
    'solid-wrench-simple': wrench_simple_svg_2.ReactComponent,
    'solid-wrench': wrench_svg_2.ReactComponent,
    'solid-x-ray': x_ray_svg_2.ReactComponent,
    'solid-x': x_svg_2.ReactComponent,
    'solid-xmark-to-slot': xmark_to_slot_svg_2.ReactComponent,
    'solid-xmark': xmark_svg_2.ReactComponent,
    'solid-y': y_svg_2.ReactComponent,
    'solid-yen-sign': yen_sign_svg_2.ReactComponent,
    'solid-yin-yang': yin_yang_svg_2.ReactComponent,
    'solid-z': z_svg_2.ReactComponent,
    'thin-0': _0_svg_3.ReactComponent,
    'thin-1': _1_svg_3.ReactComponent,
    'thin-2': _2_svg_3.ReactComponent,
    'thin-3': _3_svg_3.ReactComponent,
    'thin-4': _4_svg_3.ReactComponent,
    'thin-5': _5_svg_3.ReactComponent,
    'thin-6': _6_svg_3.ReactComponent,
    'thin-7': _7_svg_3.ReactComponent,
    'thin-8': _8_svg_3.ReactComponent,
    'thin-9': _9_svg_3.ReactComponent,
    'thin-a': a_svg_3.ReactComponent,
    'thin-abacus': abacus_svg_3.ReactComponent,
    'thin-acorn': acorn_svg_3.ReactComponent,
    'thin-address-book': address_book_svg_3.ReactComponent,
    'thin-address-card': address_card_svg_3.ReactComponent,
    'thin-air-conditioner': air_conditioner_svg_3.ReactComponent,
    'thin-air-freshener': air_freshener_svg_3.ReactComponent,
    'thin-airplay': airplay_svg_3.ReactComponent,
    'thin-alarm-clock': alarm_clock_svg_3.ReactComponent,
    'thin-alarm-exclamation': alarm_exclamation_svg_3.ReactComponent,
    'thin-alarm-plus': alarm_plus_svg_3.ReactComponent,
    'thin-alarm-snooze': alarm_snooze_svg_3.ReactComponent,
    'thin-album-collection': album_collection_svg_3.ReactComponent,
    'thin-album': album_svg_3.ReactComponent,
    'thin-alicorn': alicorn_svg_3.ReactComponent,
    'thin-alien-8bit': alien_8bit_svg_3.ReactComponent,
    'thin-alien': alien_svg_3.ReactComponent,
    'thin-align-center': align_center_svg_3.ReactComponent,
    'thin-align-justify': align_justify_svg_3.ReactComponent,
    'thin-align-left': align_left_svg_3.ReactComponent,
    'thin-align-right': align_right_svg_3.ReactComponent,
    'thin-align-slash': align_slash_svg_3.ReactComponent,
    'thin-alt': alt_svg_3.ReactComponent,
    'thin-amp-guitar': amp_guitar_svg_3.ReactComponent,
    'thin-ampersand': ampersand_svg_3.ReactComponent,
    'thin-anchor': anchor_svg_3.ReactComponent,
    'thin-angel': angel_svg_3.ReactComponent,
    'thin-angle-90': angle_90_svg_3.ReactComponent,
    'thin-angle-down': angle_down_svg_3.ReactComponent,
    'thin-angle-left': angle_left_svg_3.ReactComponent,
    'thin-angle-right': angle_right_svg_3.ReactComponent,
    'thin-angle-up': angle_up_svg_3.ReactComponent,
    'thin-angle': angle_svg_3.ReactComponent,
    'thin-angles-down': angles_down_svg_3.ReactComponent,
    'thin-angles-left': angles_left_svg_3.ReactComponent,
    'thin-angles-right': angles_right_svg_3.ReactComponent,
    'thin-angles-up': angles_up_svg_3.ReactComponent,
    'thin-ankh': ankh_svg_3.ReactComponent,
    'thin-aperture': aperture_svg_3.ReactComponent,
    'thin-apple-core': apple_core_svg_3.ReactComponent,
    'thin-apple-crate': apple_crate_svg_3.ReactComponent,
    'thin-apple-whole': apple_whole_svg_3.ReactComponent,
    'thin-archway': archway_svg_3.ReactComponent,
    'thin-arrow-down-1-9': arrow_down_1_9_svg_3.ReactComponent,
    'thin-arrow-down-9-1': arrow_down_9_1_svg_3.ReactComponent,
    'thin-arrow-down-a-z': arrow_down_a_z_svg_3.ReactComponent,
    'thin-arrow-down-arrow-up': arrow_down_arrow_up_svg_3.ReactComponent,
    'thin-arrow-down-big-small': arrow_down_big_small_svg_3.ReactComponent,
    'thin-arrow-down-from-dotted-line': arrow_down_from_dotted_line_svg_3.ReactComponent,
    'thin-arrow-down-from-line': arrow_down_from_line_svg_3.ReactComponent,
    'thin-arrow-down-left-and-arrow-up-right-to-center': arrow_down_left_and_arrow_up_right_to_center_svg_3.ReactComponent,
    'thin-arrow-down-left': arrow_down_left_svg_3.ReactComponent,
    'thin-arrow-down-long': arrow_down_long_svg_3.ReactComponent,
    'thin-arrow-down-right': arrow_down_right_svg_3.ReactComponent,
    'thin-arrow-down-short-wide': arrow_down_short_wide_svg_3.ReactComponent,
    'thin-arrow-down-small-big': arrow_down_small_big_svg_3.ReactComponent,
    'thin-arrow-down-square-triangle': arrow_down_square_triangle_svg_3.ReactComponent,
    'thin-arrow-down-to-bracket': arrow_down_to_bracket_svg_3.ReactComponent,
    'thin-arrow-down-to-dotted-line': arrow_down_to_dotted_line_svg_3.ReactComponent,
    'thin-arrow-down-to-line': arrow_down_to_line_svg_3.ReactComponent,
    'thin-arrow-down-to-square': arrow_down_to_square_svg_3.ReactComponent,
    'thin-arrow-down-triangle-square': arrow_down_triangle_square_svg_3.ReactComponent,
    'thin-arrow-down-wide-short': arrow_down_wide_short_svg_3.ReactComponent,
    'thin-arrow-down-z-a': arrow_down_z_a_svg_3.ReactComponent,
    'thin-arrow-down': arrow_down_svg_3.ReactComponent,
    'thin-arrow-left-from-line': arrow_left_from_line_svg_3.ReactComponent,
    'thin-arrow-left-long': arrow_left_long_svg_3.ReactComponent,
    'thin-arrow-left-rotate': arrow_left_rotate_svg_3.ReactComponent,
    'thin-arrow-left-to-line': arrow_left_to_line_svg_3.ReactComponent,
    'thin-arrow-left': arrow_left_svg_3.ReactComponent,
    'thin-arrow-pointer': arrow_pointer_svg_3.ReactComponent,
    'thin-arrow-right-arrow-left': arrow_right_arrow_left_svg_3.ReactComponent,
    'thin-arrow-right-from-bracket': arrow_right_from_bracket_svg_3.ReactComponent,
    'thin-arrow-right-from-line': arrow_right_from_line_svg_3.ReactComponent,
    'thin-arrow-right-long': arrow_right_long_svg_3.ReactComponent,
    'thin-arrow-right-to-bracket': arrow_right_to_bracket_svg_3.ReactComponent,
    'thin-arrow-right-to-line': arrow_right_to_line_svg_3.ReactComponent,
    'thin-arrow-right': arrow_right_svg_3.ReactComponent,
    'thin-arrow-rotate-forward': arrow_rotate_forward_svg_3.ReactComponent,
    'thin-arrow-trend-down': arrow_trend_down_svg_3.ReactComponent,
    'thin-arrow-trend-up': arrow_trend_up_svg_3.ReactComponent,
    'thin-arrow-turn-down': arrow_turn_down_svg_3.ReactComponent,
    'thin-arrow-turn-up': arrow_turn_up_svg_3.ReactComponent,
    'thin-arrow-up-1-9': arrow_up_1_9_svg_3.ReactComponent,
    'thin-arrow-up-9-1': arrow_up_9_1_svg_3.ReactComponent,
    'thin-arrow-up-a-z': arrow_up_a_z_svg_3.ReactComponent,
    'thin-arrow-up-arrow-down': arrow_up_arrow_down_svg_3.ReactComponent,
    'thin-arrow-up-big-small': arrow_up_big_small_svg_3.ReactComponent,
    'thin-arrow-up-from-bracket': arrow_up_from_bracket_svg_3.ReactComponent,
    'thin-arrow-up-from-dotted-line': arrow_up_from_dotted_line_svg_3.ReactComponent,
    'thin-arrow-up-from-line': arrow_up_from_line_svg_3.ReactComponent,
    'thin-arrow-up-from-square': arrow_up_from_square_svg_3.ReactComponent,
    'thin-arrow-up-left-from-circle': arrow_up_left_from_circle_svg_3.ReactComponent,
    'thin-arrow-up-left': arrow_up_left_svg_3.ReactComponent,
    'thin-arrow-up-long': arrow_up_long_svg_3.ReactComponent,
    'thin-arrow-up-right-and-arrow-down-left-from-center': arrow_up_right_and_arrow_down_left_from_center_svg_3.ReactComponent,
    'thin-arrow-up-right-from-square': arrow_up_right_from_square_svg_3.ReactComponent,
    'thin-arrow-up-right': arrow_up_right_svg_3.ReactComponent,
    'thin-arrow-up-short-wide': arrow_up_short_wide_svg_3.ReactComponent,
    'thin-arrow-up-small-big': arrow_up_small_big_svg_3.ReactComponent,
    'thin-arrow-up-square-triangle': arrow_up_square_triangle_svg_3.ReactComponent,
    'thin-arrow-up-to-dotted-line': arrow_up_to_dotted_line_svg_3.ReactComponent,
    'thin-arrow-up-to-line': arrow_up_to_line_svg_3.ReactComponent,
    'thin-arrow-up-triangle-square': arrow_up_triangle_square_svg_3.ReactComponent,
    'thin-arrow-up-wide-short': arrow_up_wide_short_svg_3.ReactComponent,
    'thin-arrow-up-z-a': arrow_up_z_a_svg_3.ReactComponent,
    'thin-arrow-up': arrow_up_svg_3.ReactComponent,
    'thin-arrows-cross': arrows_cross_svg_3.ReactComponent,
    'thin-arrows-from-dotted-line': arrows_from_dotted_line_svg_3.ReactComponent,
    'thin-arrows-from-line': arrows_from_line_svg_3.ReactComponent,
    'thin-arrows-left-right': arrows_left_right_svg_3.ReactComponent,
    'thin-arrows-maximize': arrows_maximize_svg_3.ReactComponent,
    'thin-arrows-minimize': arrows_minimize_svg_3.ReactComponent,
    'thin-arrows-repeat-1': arrows_repeat_1_svg_3.ReactComponent,
    'thin-arrows-repeat': arrows_repeat_svg_3.ReactComponent,
    'thin-arrows-retweet': arrows_retweet_svg_3.ReactComponent,
    'thin-arrows-rotate': arrows_rotate_svg_3.ReactComponent,
    'thin-arrows-to-dotted-line': arrows_to_dotted_line_svg_3.ReactComponent,
    'thin-arrows-to-line': arrows_to_line_svg_3.ReactComponent,
    'thin-arrows-up-down-left-right': arrows_up_down_left_right_svg_3.ReactComponent,
    'thin-arrows-up-down': arrows_up_down_svg_3.ReactComponent,
    'thin-asterisk': asterisk_svg_3.ReactComponent,
    'thin-at': at_svg_3.ReactComponent,
    'thin-atom-simple': atom_simple_svg_3.ReactComponent,
    'thin-atom': atom_svg_3.ReactComponent,
    'thin-audio-description-slash': audio_description_slash_svg_3.ReactComponent,
    'thin-audio-description': audio_description_svg_3.ReactComponent,
    'thin-austral-sign': austral_sign_svg_3.ReactComponent,
    'thin-avocado': avocado_svg_3.ReactComponent,
    'thin-award-simple': award_simple_svg_3.ReactComponent,
    'thin-award': award_svg_3.ReactComponent,
    'thin-axe-battle': axe_battle_svg_3.ReactComponent,
    'thin-axe': axe_svg_3.ReactComponent,
    'thin-b': b_svg_3.ReactComponent,
    'thin-baby-carriage': baby_carriage_svg_3.ReactComponent,
    'thin-baby': baby_svg_3.ReactComponent,
    'thin-backpack': backpack_svg_3.ReactComponent,
    'thin-backward-fast': backward_fast_svg_3.ReactComponent,
    'thin-backward-step': backward_step_svg_3.ReactComponent,
    'thin-backward': backward_svg_3.ReactComponent,
    'thin-bacon': bacon_svg_3.ReactComponent,
    'thin-bacteria': bacteria_svg_3.ReactComponent,
    'thin-bacterium': bacterium_svg_3.ReactComponent,
    'thin-badge-check': badge_check_svg_3.ReactComponent,
    'thin-badge-dollar': badge_dollar_svg_3.ReactComponent,
    'thin-badge-percent': badge_percent_svg_3.ReactComponent,
    'thin-badge-sheriff': badge_sheriff_svg_3.ReactComponent,
    'thin-badge': badge_svg_3.ReactComponent,
    'thin-badger-honey': badger_honey_svg_3.ReactComponent,
    'thin-bag-shopping': bag_shopping_svg_3.ReactComponent,
    'thin-bags-shopping': bags_shopping_svg_3.ReactComponent,
    'thin-bahai': bahai_svg_3.ReactComponent,
    'thin-baht-sign': baht_sign_svg_3.ReactComponent,
    'thin-ball-pile': ball_pile_svg_3.ReactComponent,
    'thin-ballot-check': ballot_check_svg_3.ReactComponent,
    'thin-ballot': ballot_svg_3.ReactComponent,
    'thin-ban-bug': ban_bug_svg_3.ReactComponent,
    'thin-ban-parking': ban_parking_svg_3.ReactComponent,
    'thin-ban-smoking': ban_smoking_svg_3.ReactComponent,
    'thin-ban': ban_svg_3.ReactComponent,
    'thin-bandage': bandage_svg_3.ReactComponent,
    'thin-banjo': banjo_svg_3.ReactComponent,
    'thin-bank': bank_svg_3.ReactComponent,
    'thin-barcode-read': barcode_read_svg_3.ReactComponent,
    'thin-barcode-scan': barcode_scan_svg_3.ReactComponent,
    'thin-barcode': barcode_svg_3.ReactComponent,
    'thin-bars-filter': bars_filter_svg_3.ReactComponent,
    'thin-bars-progress': bars_progress_svg_3.ReactComponent,
    'thin-bars-sort': bars_sort_svg_3.ReactComponent,
    'thin-bars-staggered': bars_staggered_svg_3.ReactComponent,
    'thin-bars': bars_svg_3.ReactComponent,
    'thin-baseball-ball': baseball_ball_svg_3.ReactComponent,
    'thin-baseball-bat-ball': baseball_bat_ball_svg_3.ReactComponent,
    'thin-basket-shopping-simple': basket_shopping_simple_svg_3.ReactComponent,
    'thin-basket-shopping': basket_shopping_svg_3.ReactComponent,
    'thin-basketball-ball': basketball_ball_svg_3.ReactComponent,
    'thin-basketball-hoop': basketball_hoop_svg_3.ReactComponent,
    'thin-bat': bat_svg_3.ReactComponent,
    'thin-bath': bath_svg_3.ReactComponent,
    'thin-battery-bolt': battery_bolt_svg_3.ReactComponent,
    'thin-battery-empty': battery_empty_svg_3.ReactComponent,
    'thin-battery-exclamation': battery_exclamation_svg_3.ReactComponent,
    'thin-battery-full': battery_full_svg_3.ReactComponent,
    'thin-battery-half': battery_half_svg_3.ReactComponent,
    'thin-battery-low': battery_low_svg_3.ReactComponent,
    'thin-battery-quarter': battery_quarter_svg_3.ReactComponent,
    'thin-battery-slash': battery_slash_svg_3.ReactComponent,
    'thin-battery-three-quarters': battery_three_quarters_svg_3.ReactComponent,
    'thin-bed-bunk': bed_bunk_svg_3.ReactComponent,
    'thin-bed-empty': bed_empty_svg_3.ReactComponent,
    'thin-bed-front': bed_front_svg_3.ReactComponent,
    'thin-bed-pulse': bed_pulse_svg_3.ReactComponent,
    'thin-bed': bed_svg_3.ReactComponent,
    'thin-bee': bee_svg_3.ReactComponent,
    'thin-beer-mug-empty': beer_mug_empty_svg_3.ReactComponent,
    'thin-beer-mug': beer_mug_svg_3.ReactComponent,
    'thin-bell-concierge': bell_concierge_svg_3.ReactComponent,
    'thin-bell-exclamation': bell_exclamation_svg_3.ReactComponent,
    'thin-bell-on': bell_on_svg_3.ReactComponent,
    'thin-bell-plus': bell_plus_svg_3.ReactComponent,
    'thin-bell-school-slash': bell_school_slash_svg_3.ReactComponent,
    'thin-bell-school': bell_school_svg_3.ReactComponent,
    'thin-bell-slash': bell_slash_svg_3.ReactComponent,
    'thin-bell': bell_svg_3.ReactComponent,
    'thin-bells': bells_svg_3.ReactComponent,
    'thin-bezier-curve': bezier_curve_svg_3.ReactComponent,
    'thin-bicycle': bicycle_svg_3.ReactComponent,
    'thin-binoculars': binoculars_svg_3.ReactComponent,
    'thin-biohazard': biohazard_svg_3.ReactComponent,
    'thin-bitcoin-sign': bitcoin_sign_svg_3.ReactComponent,
    'thin-blanket': blanket_svg_3.ReactComponent,
    'thin-blender-phone': blender_phone_svg_3.ReactComponent,
    'thin-blender': blender_svg_3.ReactComponent,
    'thin-blinds-open': blinds_open_svg_3.ReactComponent,
    'thin-blinds-raised': blinds_raised_svg_3.ReactComponent,
    'thin-blinds': blinds_svg_3.ReactComponent,
    'thin-block-quote': block_quote_svg_3.ReactComponent,
    'thin-blog': blog_svg_3.ReactComponent,
    'thin-bluetooth': bluetooth_svg_4.ReactComponent,
    'thin-bold': bold_svg_3.ReactComponent,
    'thin-bolt-auto': bolt_auto_svg_3.ReactComponent,
    'thin-bolt-lightning': bolt_lightning_svg_3.ReactComponent,
    'thin-bolt-slash': bolt_slash_svg_3.ReactComponent,
    'thin-bolt': bolt_svg_3.ReactComponent,
    'thin-bomb': bomb_svg_3.ReactComponent,
    'thin-bone-break': bone_break_svg_3.ReactComponent,
    'thin-bone': bone_svg_3.ReactComponent,
    'thin-bong': bong_svg_3.ReactComponent,
    'thin-book-arrow-right': book_arrow_right_svg_3.ReactComponent,
    'thin-book-arrow-up': book_arrow_up_svg_3.ReactComponent,
    'thin-book-atlas': book_atlas_svg_3.ReactComponent,
    'thin-book-bible': book_bible_svg_3.ReactComponent,
    'thin-book-blank': book_blank_svg_3.ReactComponent,
    'thin-book-bookmark': book_bookmark_svg_3.ReactComponent,
    'thin-book-circle-arrow-right': book_circle_arrow_right_svg_3.ReactComponent,
    'thin-book-circle-arrow-up': book_circle_arrow_up_svg_3.ReactComponent,
    'thin-book-copy': book_copy_svg_3.ReactComponent,
    'thin-book-font': book_font_svg_3.ReactComponent,
    'thin-book-heart': book_heart_svg_3.ReactComponent,
    'thin-book-journal-whills': book_journal_whills_svg_3.ReactComponent,
    'thin-book-law': book_law_svg_3.ReactComponent,
    'thin-book-medical': book_medical_svg_3.ReactComponent,
    'thin-book-open-cover': book_open_cover_svg_3.ReactComponent,
    'thin-book-open-reader': book_open_reader_svg_3.ReactComponent,
    'thin-book-open': book_open_svg_3.ReactComponent,
    'thin-book-quran': book_quran_svg_3.ReactComponent,
    'thin-book-section': book_section_svg_3.ReactComponent,
    'thin-book-skull': book_skull_svg_3.ReactComponent,
    'thin-book-sparkles': book_sparkles_svg_3.ReactComponent,
    'thin-book-tanakh': book_tanakh_svg_3.ReactComponent,
    'thin-book-user': book_user_svg_3.ReactComponent,
    'thin-book': book_svg_3.ReactComponent,
    'thin-bookmark-slash': bookmark_slash_svg_3.ReactComponent,
    'thin-bookmark': bookmark_svg_3.ReactComponent,
    'thin-books-medical': books_medical_svg_3.ReactComponent,
    'thin-books': books_svg_3.ReactComponent,
    'thin-boombox': boombox_svg_3.ReactComponent,
    'thin-boot': boot_svg_3.ReactComponent,
    'thin-booth-curtain': booth_curtain_svg_3.ReactComponent,
    'thin-border-all': border_all_svg_3.ReactComponent,
    'thin-border-bottom-right': border_bottom_right_svg_3.ReactComponent,
    'thin-border-bottom': border_bottom_svg_3.ReactComponent,
    'thin-border-center-h': border_center_h_svg_3.ReactComponent,
    'thin-border-center-v': border_center_v_svg_3.ReactComponent,
    'thin-border-inner': border_inner_svg_3.ReactComponent,
    'thin-border-left': border_left_svg_3.ReactComponent,
    'thin-border-none': border_none_svg_3.ReactComponent,
    'thin-border-outer': border_outer_svg_3.ReactComponent,
    'thin-border-right': border_right_svg_3.ReactComponent,
    'thin-border-top-left': border_top_left_svg_3.ReactComponent,
    'thin-border-top': border_top_svg_3.ReactComponent,
    'thin-bow-arrow': bow_arrow_svg_3.ReactComponent,
    'thin-bowl-hot': bowl_hot_svg_3.ReactComponent,
    'thin-bowling-ball-pin': bowling_ball_pin_svg_3.ReactComponent,
    'thin-bowling-ball': bowling_ball_svg_3.ReactComponent,
    'thin-bowling-pins': bowling_pins_svg_3.ReactComponent,
    'thin-box-archive': box_archive_svg_3.ReactComponent,
    'thin-box-ballot': box_ballot_svg_3.ReactComponent,
    'thin-box-check': box_check_svg_3.ReactComponent,
    'thin-box-circle-check': box_circle_check_svg_3.ReactComponent,
    'thin-box-dollar': box_dollar_svg_3.ReactComponent,
    'thin-box-heart': box_heart_svg_3.ReactComponent,
    'thin-box-open-full': box_open_full_svg_3.ReactComponent,
    'thin-box-open': box_open_svg_3.ReactComponent,
    'thin-box-taped': box_taped_svg_3.ReactComponent,
    'thin-box-tissue': box_tissue_svg_3.ReactComponent,
    'thin-box': box_svg_3.ReactComponent,
    'thin-boxes-stacked': boxes_stacked_svg_3.ReactComponent,
    'thin-boxing-glove': boxing_glove_svg_3.ReactComponent,
    'thin-bracket-curly-right': bracket_curly_right_svg_3.ReactComponent,
    'thin-bracket-curly': bracket_curly_svg_3.ReactComponent,
    'thin-bracket-round-right': bracket_round_right_svg_3.ReactComponent,
    'thin-bracket-round': bracket_round_svg_3.ReactComponent,
    'thin-bracket-square-right': bracket_square_right_svg_3.ReactComponent,
    'thin-bracket-square': bracket_square_svg_3.ReactComponent,
    'thin-brackets-curly': brackets_curly_svg_3.ReactComponent,
    'thin-brackets-round': brackets_round_svg_3.ReactComponent,
    'thin-brackets-square': brackets_square_svg_3.ReactComponent,
    'thin-braille': braille_svg_3.ReactComponent,
    'thin-brain-arrow-curved-right': brain_arrow_curved_right_svg_3.ReactComponent,
    'thin-brain-circuit': brain_circuit_svg_3.ReactComponent,
    'thin-brain': brain_svg_3.ReactComponent,
    'thin-brake-warning': brake_warning_svg_3.ReactComponent,
    'thin-bread-loaf': bread_loaf_svg_3.ReactComponent,
    'thin-bread-slice': bread_slice_svg_3.ReactComponent,
    'thin-briefcase-arrow-right': briefcase_arrow_right_svg_3.ReactComponent,
    'thin-briefcase-clock': briefcase_clock_svg_3.ReactComponent,
    'thin-briefcase-medical': briefcase_medical_svg_3.ReactComponent,
    'thin-briefcase': briefcase_svg_3.ReactComponent,
    'thin-bring-forward': bring_forward_svg_3.ReactComponent,
    'thin-bring-front': bring_front_svg_3.ReactComponent,
    'thin-broom': broom_svg_3.ReactComponent,
    'thin-browser': browser_svg_3.ReactComponent,
    'thin-browsers': browsers_svg_3.ReactComponent,
    'thin-brush': brush_svg_3.ReactComponent,
    'thin-bug': bug_svg_3.ReactComponent,
    'thin-building': building_svg_3.ReactComponent,
    'thin-buildings': buildings_svg_3.ReactComponent,
    'thin-bullhorn': bullhorn_svg_3.ReactComponent,
    'thin-bullseye-arrow': bullseye_arrow_svg_3.ReactComponent,
    'thin-bullseye-pointer': bullseye_pointer_svg_3.ReactComponent,
    'thin-bullseye': bullseye_svg_3.ReactComponent,
    'thin-burger-cheese': burger_cheese_svg_3.ReactComponent,
    'thin-burger-fries': burger_fries_svg_3.ReactComponent,
    'thin-burger-glass': burger_glass_svg_3.ReactComponent,
    'thin-burger-soda': burger_soda_svg_3.ReactComponent,
    'thin-burger': burger_svg_3.ReactComponent,
    'thin-burrito': burrito_svg_3.ReactComponent,
    'thin-bus-school': bus_school_svg_3.ReactComponent,
    'thin-bus-simple': bus_simple_svg_3.ReactComponent,
    'thin-bus': bus_svg_3.ReactComponent,
    'thin-c': c_svg_3.ReactComponent,
    'thin-cabinet-filing': cabinet_filing_svg_3.ReactComponent,
    'thin-cable-car': cable_car_svg_3.ReactComponent,
    'thin-cactus': cactus_svg_3.ReactComponent,
    'thin-cake-candles': cake_candles_svg_3.ReactComponent,
    'thin-calculator-simple': calculator_simple_svg_3.ReactComponent,
    'thin-calculator': calculator_svg_3.ReactComponent,
    'thin-calendar-arrow-down': calendar_arrow_down_svg_3.ReactComponent,
    'thin-calendar-arrow-up': calendar_arrow_up_svg_3.ReactComponent,
    'thin-calendar-check': calendar_check_svg_3.ReactComponent,
    'thin-calendar-clock': calendar_clock_svg_3.ReactComponent,
    'thin-calendar-day': calendar_day_svg_3.ReactComponent,
    'thin-calendar-days': calendar_days_svg_3.ReactComponent,
    'thin-calendar-exclamation': calendar_exclamation_svg_3.ReactComponent,
    'thin-calendar-heart': calendar_heart_svg_3.ReactComponent,
    'thin-calendar-image': calendar_image_svg_3.ReactComponent,
    'thin-calendar-lines': calendar_lines_svg_3.ReactComponent,
    'thin-calendar-minus': calendar_minus_svg_3.ReactComponent,
    'thin-calendar-pen': calendar_pen_svg_3.ReactComponent,
    'thin-calendar-plus': calendar_plus_svg_3.ReactComponent,
    'thin-calendar-range': calendar_range_svg_3.ReactComponent,
    'thin-calendar-star': calendar_star_svg_3.ReactComponent,
    'thin-calendar-week': calendar_week_svg_3.ReactComponent,
    'thin-calendar-xmark': calendar_xmark_svg_3.ReactComponent,
    'thin-calendar': calendar_svg_3.ReactComponent,
    'thin-calendars': calendars_svg_3.ReactComponent,
    'thin-camcorder': camcorder_svg_3.ReactComponent,
    'thin-camera-cctv': camera_cctv_svg_3.ReactComponent,
    'thin-camera-movie': camera_movie_svg_3.ReactComponent,
    'thin-camera-polaroid': camera_polaroid_svg_3.ReactComponent,
    'thin-camera-retro': camera_retro_svg_3.ReactComponent,
    'thin-camera-rotate': camera_rotate_svg_3.ReactComponent,
    'thin-camera-security': camera_security_svg_3.ReactComponent,
    'thin-camera-slash': camera_slash_svg_3.ReactComponent,
    'thin-camera-viewfinder': camera_viewfinder_svg_3.ReactComponent,
    'thin-camera-web-slash': camera_web_slash_svg_3.ReactComponent,
    'thin-camera-web': camera_web_svg_3.ReactComponent,
    'thin-camera': camera_svg_3.ReactComponent,
    'thin-campfire': campfire_svg_3.ReactComponent,
    'thin-campground': campground_svg_3.ReactComponent,
    'thin-candle-holder': candle_holder_svg_3.ReactComponent,
    'thin-candy-cane': candy_cane_svg_3.ReactComponent,
    'thin-candy-corn': candy_corn_svg_3.ReactComponent,
    'thin-cannabis': cannabis_svg_3.ReactComponent,
    'thin-capsules': capsules_svg_3.ReactComponent,
    'thin-car-battery': car_battery_svg_3.ReactComponent,
    'thin-car-building': car_building_svg_3.ReactComponent,
    'thin-car-bump': car_bump_svg_3.ReactComponent,
    'thin-car-bus': car_bus_svg_3.ReactComponent,
    'thin-car-crash': car_crash_svg_3.ReactComponent,
    'thin-car-garage': car_garage_svg_3.ReactComponent,
    'thin-car-rear': car_rear_svg_3.ReactComponent,
    'thin-car-side': car_side_svg_3.ReactComponent,
    'thin-car-tilt': car_tilt_svg_3.ReactComponent,
    'thin-car-wash': car_wash_svg_3.ReactComponent,
    'thin-car-wrench': car_wrench_svg_3.ReactComponent,
    'thin-car': car_svg_3.ReactComponent,
    'thin-caravan-simple': caravan_simple_svg_3.ReactComponent,
    'thin-caravan': caravan_svg_3.ReactComponent,
    'thin-caret-down': caret_down_svg_3.ReactComponent,
    'thin-caret-left': caret_left_svg_3.ReactComponent,
    'thin-caret-right': caret_right_svg_3.ReactComponent,
    'thin-caret-up': caret_up_svg_3.ReactComponent,
    'thin-carrot': carrot_svg_3.ReactComponent,
    'thin-cars': cars_svg_3.ReactComponent,
    'thin-cart-arrow-down': cart_arrow_down_svg_3.ReactComponent,
    'thin-cart-flatbed-boxes': cart_flatbed_boxes_svg_3.ReactComponent,
    'thin-cart-flatbed-empty': cart_flatbed_empty_svg_3.ReactComponent,
    'thin-cart-flatbed-suitcase': cart_flatbed_suitcase_svg_3.ReactComponent,
    'thin-cart-flatbed': cart_flatbed_svg_3.ReactComponent,
    'thin-cart-plus': cart_plus_svg_3.ReactComponent,
    'thin-cart-shopping-fast': cart_shopping_fast_svg_3.ReactComponent,
    'thin-cart-shopping': cart_shopping_svg_3.ReactComponent,
    'thin-casette-betamax': casette_betamax_svg_3.ReactComponent,
    'thin-casette-vhs': casette_vhs_svg_3.ReactComponent,
    'thin-cash-register': cash_register_svg_3.ReactComponent,
    'thin-cassette-tape': cassette_tape_svg_3.ReactComponent,
    'thin-castle': castle_svg_3.ReactComponent,
    'thin-cat-space': cat_space_svg_3.ReactComponent,
    'thin-cat': cat_svg_3.ReactComponent,
    'thin-cauldron': cauldron_svg_3.ReactComponent,
    'thin-cedi-sign': cedi_sign_svg_3.ReactComponent,
    'thin-cent-sign': cent_sign_svg_3.ReactComponent,
    'thin-certificate': certificate_svg_3.ReactComponent,
    'thin-chair-office': chair_office_svg_3.ReactComponent,
    'thin-chair': chair_svg_3.ReactComponent,
    'thin-chalkboard-user': chalkboard_user_svg_3.ReactComponent,
    'thin-chalkboard': chalkboard_svg_3.ReactComponent,
    'thin-champagne-glass': champagne_glass_svg_3.ReactComponent,
    'thin-champagne-glasses': champagne_glasses_svg_3.ReactComponent,
    'thin-charging-station': charging_station_svg_3.ReactComponent,
    'thin-chart-area': chart_area_svg_3.ReactComponent,
    'thin-chart-bar': chart_bar_svg_3.ReactComponent,
    'thin-chart-bullet': chart_bullet_svg_3.ReactComponent,
    'thin-chart-candlestick': chart_candlestick_svg_3.ReactComponent,
    'thin-chart-column': chart_column_svg_3.ReactComponent,
    'thin-chart-gantt': chart_gantt_svg_3.ReactComponent,
    'thin-chart-line-down': chart_line_down_svg_3.ReactComponent,
    'thin-chart-line-up': chart_line_up_svg_3.ReactComponent,
    'thin-chart-line': chart_line_svg_3.ReactComponent,
    'thin-chart-mixed': chart_mixed_svg_3.ReactComponent,
    'thin-chart-network': chart_network_svg_3.ReactComponent,
    'thin-chart-pie-simple': chart_pie_simple_svg_3.ReactComponent,
    'thin-chart-pie': chart_pie_svg_3.ReactComponent,
    'thin-chart-pyramid': chart_pyramid_svg_3.ReactComponent,
    'thin-chart-radar': chart_radar_svg_3.ReactComponent,
    'thin-chart-scatter-3d': chart_scatter_3d_svg_3.ReactComponent,
    'thin-chart-scatter-bubble': chart_scatter_bubble_svg_3.ReactComponent,
    'thin-chart-scatter': chart_scatter_svg_3.ReactComponent,
    'thin-chart-tree-map': chart_tree_map_svg_3.ReactComponent,
    'thin-chart-user': chart_user_svg_3.ReactComponent,
    'thin-chart-waterfall': chart_waterfall_svg_3.ReactComponent,
    'thin-check-double': check_double_svg_3.ReactComponent,
    'thin-check-to-slot': check_to_slot_svg_3.ReactComponent,
    'thin-check': check_svg_3.ReactComponent,
    'thin-cheese-swiss': cheese_swiss_svg_3.ReactComponent,
    'thin-cheese': cheese_svg_3.ReactComponent,
    'thin-cherries': cherries_svg_3.ReactComponent,
    'thin-chess-bishop-piece': chess_bishop_piece_svg_3.ReactComponent,
    'thin-chess-bishop': chess_bishop_svg_3.ReactComponent,
    'thin-chess-board': chess_board_svg_3.ReactComponent,
    'thin-chess-clock-flip': chess_clock_flip_svg_3.ReactComponent,
    'thin-chess-clock': chess_clock_svg_3.ReactComponent,
    'thin-chess-king-piece': chess_king_piece_svg_3.ReactComponent,
    'thin-chess-king': chess_king_svg_3.ReactComponent,
    'thin-chess-knight-piece': chess_knight_piece_svg_3.ReactComponent,
    'thin-chess-knight': chess_knight_svg_3.ReactComponent,
    'thin-chess-pawn-piece': chess_pawn_piece_svg_3.ReactComponent,
    'thin-chess-pawn': chess_pawn_svg_3.ReactComponent,
    'thin-chess-queen-piece': chess_queen_piece_svg_3.ReactComponent,
    'thin-chess-queen': chess_queen_svg_3.ReactComponent,
    'thin-chess-rook-piece': chess_rook_piece_svg_3.ReactComponent,
    'thin-chess-rook': chess_rook_svg_3.ReactComponent,
    'thin-chess': chess_svg_3.ReactComponent,
    'thin-chevron-down': chevron_down_svg_3.ReactComponent,
    'thin-chevron-left': chevron_left_svg_3.ReactComponent,
    'thin-chevron-right': chevron_right_svg_3.ReactComponent,
    'thin-chevron-up': chevron_up_svg_3.ReactComponent,
    'thin-chevrons-down': chevrons_down_svg_3.ReactComponent,
    'thin-chevrons-left': chevrons_left_svg_3.ReactComponent,
    'thin-chevrons-right': chevrons_right_svg_3.ReactComponent,
    'thin-chevrons-up': chevrons_up_svg_3.ReactComponent,
    'thin-child': child_svg_3.ReactComponent,
    'thin-chimney': chimney_svg_3.ReactComponent,
    'thin-church': church_svg_3.ReactComponent,
    'thin-circle-0': circle_0_svg_3.ReactComponent,
    'thin-circle-1': circle_1_svg_3.ReactComponent,
    'thin-circle-2': circle_2_svg_3.ReactComponent,
    'thin-circle-3': circle_3_svg_3.ReactComponent,
    'thin-circle-4': circle_4_svg_3.ReactComponent,
    'thin-circle-5': circle_5_svg_3.ReactComponent,
    'thin-circle-6': circle_6_svg_3.ReactComponent,
    'thin-circle-7': circle_7_svg_3.ReactComponent,
    'thin-circle-8': circle_8_svg_3.ReactComponent,
    'thin-circle-9': circle_9_svg_3.ReactComponent,
    'thin-circle-a': circle_a_svg_3.ReactComponent,
    'thin-circle-ampersand': circle_ampersand_svg_3.ReactComponent,
    'thin-circle-arrow-down-left': circle_arrow_down_left_svg_3.ReactComponent,
    'thin-circle-arrow-down-right': circle_arrow_down_right_svg_3.ReactComponent,
    'thin-circle-arrow-down': circle_arrow_down_svg_3.ReactComponent,
    'thin-circle-arrow-left': circle_arrow_left_svg_3.ReactComponent,
    'thin-circle-arrow-right': circle_arrow_right_svg_3.ReactComponent,
    'thin-circle-arrow-up-left': circle_arrow_up_left_svg_3.ReactComponent,
    'thin-circle-arrow-up-right': circle_arrow_up_right_svg_3.ReactComponent,
    'thin-circle-arrow-up': circle_arrow_up_svg_3.ReactComponent,
    'thin-circle-b': circle_b_svg_3.ReactComponent,
    'thin-circle-bolt': circle_bolt_svg_3.ReactComponent,
    'thin-circle-book-open': circle_book_open_svg_3.ReactComponent,
    'thin-circle-bookmark': circle_bookmark_svg_3.ReactComponent,
    'thin-circle-c': circle_c_svg_3.ReactComponent,
    'thin-circle-calendar': circle_calendar_svg_3.ReactComponent,
    'thin-circle-camera': circle_camera_svg_3.ReactComponent,
    'thin-circle-caret-down': circle_caret_down_svg_3.ReactComponent,
    'thin-circle-caret-left': circle_caret_left_svg_3.ReactComponent,
    'thin-circle-caret-right': circle_caret_right_svg_3.ReactComponent,
    'thin-circle-caret-up': circle_caret_up_svg_3.ReactComponent,
    'thin-circle-check': circle_check_svg_3.ReactComponent,
    'thin-circle-chevron-down': circle_chevron_down_svg_3.ReactComponent,
    'thin-circle-chevron-left': circle_chevron_left_svg_3.ReactComponent,
    'thin-circle-chevron-right': circle_chevron_right_svg_3.ReactComponent,
    'thin-circle-chevron-up': circle_chevron_up_svg_3.ReactComponent,
    'thin-circle-d': circle_d_svg_3.ReactComponent,
    'thin-circle-dashed': circle_dashed_svg_3.ReactComponent,
    'thin-circle-divide': circle_divide_svg_3.ReactComponent,
    'thin-circle-dollar-to-slot': circle_dollar_to_slot_svg_3.ReactComponent,
    'thin-circle-dollar': circle_dollar_svg_3.ReactComponent,
    'thin-circle-dot': circle_dot_svg_3.ReactComponent,
    'thin-circle-down-left': circle_down_left_svg_3.ReactComponent,
    'thin-circle-down-right': circle_down_right_svg_3.ReactComponent,
    'thin-circle-down': circle_down_svg_3.ReactComponent,
    'thin-circle-e': circle_e_svg_3.ReactComponent,
    'thin-circle-envelope': circle_envelope_svg_3.ReactComponent,
    'thin-circle-exclamation-check': circle_exclamation_check_svg_3.ReactComponent,
    'thin-circle-exclamation': circle_exclamation_svg_3.ReactComponent,
    'thin-circle-f': circle_f_svg_3.ReactComponent,
    'thin-circle-g': circle_g_svg_3.ReactComponent,
    'thin-circle-h': circle_h_svg_3.ReactComponent,
    'thin-circle-half-stroke': circle_half_stroke_svg_3.ReactComponent,
    'thin-circle-half': circle_half_svg_3.ReactComponent,
    'thin-circle-heart': circle_heart_svg_3.ReactComponent,
    'thin-circle-i': circle_i_svg_3.ReactComponent,
    'thin-circle-info': circle_info_svg_3.ReactComponent,
    'thin-circle-j': circle_j_svg_3.ReactComponent,
    'thin-circle-k': circle_k_svg_3.ReactComponent,
    'thin-circle-l': circle_l_svg_3.ReactComponent,
    'thin-circle-left': circle_left_svg_3.ReactComponent,
    'thin-circle-location-arrow': circle_location_arrow_svg_3.ReactComponent,
    'thin-circle-m': circle_m_svg_3.ReactComponent,
    'thin-circle-microphone-lines': circle_microphone_lines_svg_3.ReactComponent,
    'thin-circle-microphone': circle_microphone_svg_3.ReactComponent,
    'thin-circle-minus': circle_minus_svg_3.ReactComponent,
    'thin-circle-n': circle_n_svg_3.ReactComponent,
    'thin-circle-notch': circle_notch_svg_3.ReactComponent,
    'thin-circle-o': circle_o_svg_3.ReactComponent,
    'thin-circle-p': circle_p_svg_3.ReactComponent,
    'thin-circle-parking': circle_parking_svg_3.ReactComponent,
    'thin-circle-pause': circle_pause_svg_3.ReactComponent,
    'thin-circle-phone-flip': circle_phone_flip_svg_3.ReactComponent,
    'thin-circle-phone-hangup': circle_phone_hangup_svg_3.ReactComponent,
    'thin-circle-phone': circle_phone_svg_3.ReactComponent,
    'thin-circle-play': circle_play_svg_3.ReactComponent,
    'thin-circle-plus': circle_plus_svg_3.ReactComponent,
    'thin-circle-q': circle_q_svg_3.ReactComponent,
    'thin-circle-quarter': circle_quarter_svg_3.ReactComponent,
    'thin-circle-question': circle_question_svg_3.ReactComponent,
    'thin-circle-r': circle_r_svg_3.ReactComponent,
    'thin-circle-radiation': circle_radiation_svg_3.ReactComponent,
    'thin-circle-right': circle_right_svg_3.ReactComponent,
    'thin-circle-s': circle_s_svg_3.ReactComponent,
    'thin-circle-small': circle_small_svg_3.ReactComponent,
    'thin-circle-sort-down': circle_sort_down_svg_3.ReactComponent,
    'thin-circle-sort-up': circle_sort_up_svg_3.ReactComponent,
    'thin-circle-sort': circle_sort_svg_3.ReactComponent,
    'thin-circle-star': circle_star_svg_3.ReactComponent,
    'thin-circle-stop': circle_stop_svg_3.ReactComponent,
    'thin-circle-t': circle_t_svg_3.ReactComponent,
    'thin-circle-three-quarters': circle_three_quarters_svg_3.ReactComponent,
    'thin-circle-trash': circle_trash_svg_3.ReactComponent,
    'thin-circle-u': circle_u_svg_3.ReactComponent,
    'thin-circle-up-left': circle_up_left_svg_3.ReactComponent,
    'thin-circle-up-right': circle_up_right_svg_3.ReactComponent,
    'thin-circle-up': circle_up_svg_3.ReactComponent,
    'thin-circle-user': circle_user_svg_3.ReactComponent,
    'thin-circle-v': circle_v_svg_3.ReactComponent,
    'thin-circle-video': circle_video_svg_3.ReactComponent,
    'thin-circle-w': circle_w_svg_3.ReactComponent,
    'thin-circle-waveform-lines': circle_waveform_lines_svg_3.ReactComponent,
    'thin-circle-x': circle_x_svg_3.ReactComponent,
    'thin-circle-xmark': circle_xmark_svg_3.ReactComponent,
    'thin-circle-y': circle_y_svg_3.ReactComponent,
    'thin-circle-z': circle_z_svg_3.ReactComponent,
    'thin-circle': circle_svg_3.ReactComponent,
    'thin-city': city_svg_3.ReactComponent,
    'thin-clapperboard-play': clapperboard_play_svg_3.ReactComponent,
    'thin-clapperboard': clapperboard_svg_3.ReactComponent,
    'thin-clarinet': clarinet_svg_3.ReactComponent,
    'thin-claw-marks': claw_marks_svg_3.ReactComponent,
    'thin-clipboard-check': clipboard_check_svg_3.ReactComponent,
    'thin-clipboard-list-check': clipboard_list_check_svg_3.ReactComponent,
    'thin-clipboard-list': clipboard_list_svg_3.ReactComponent,
    'thin-clipboard-medical': clipboard_medical_svg_3.ReactComponent,
    'thin-clipboard-prescription': clipboard_prescription_svg_3.ReactComponent,
    'thin-clipboard-user': clipboard_user_svg_3.ReactComponent,
    'thin-clipboard': clipboard_svg_3.ReactComponent,
    'thin-clock-desk': clock_desk_svg_3.ReactComponent,
    'thin-clock-rotate-left': clock_rotate_left_svg_3.ReactComponent,
    'thin-clock': clock_svg_3.ReactComponent,
    'thin-clone': clone_svg_3.ReactComponent,
    'thin-closed-captioning-slash': closed_captioning_slash_svg_3.ReactComponent,
    'thin-closed-captioning': closed_captioning_svg_3.ReactComponent,
    'thin-clothes-hanger': clothes_hanger_svg_3.ReactComponent,
    'thin-cloud-arrow-down': cloud_arrow_down_svg_3.ReactComponent,
    'thin-cloud-arrow-up': cloud_arrow_up_svg_3.ReactComponent,
    'thin-cloud-bolt-moon': cloud_bolt_moon_svg_3.ReactComponent,
    'thin-cloud-bolt-sun': cloud_bolt_sun_svg_3.ReactComponent,
    'thin-cloud-bolt': cloud_bolt_svg_3.ReactComponent,
    'thin-cloud-drizzle': cloud_drizzle_svg_3.ReactComponent,
    'thin-cloud-fog': cloud_fog_svg_3.ReactComponent,
    'thin-cloud-hail-mixed': cloud_hail_mixed_svg_3.ReactComponent,
    'thin-cloud-hail': cloud_hail_svg_3.ReactComponent,
    'thin-cloud-meatball': cloud_meatball_svg_3.ReactComponent,
    'thin-cloud-moon-rain': cloud_moon_rain_svg_3.ReactComponent,
    'thin-cloud-moon': cloud_moon_svg_3.ReactComponent,
    'thin-cloud-music': cloud_music_svg_3.ReactComponent,
    'thin-cloud-rain': cloud_rain_svg_3.ReactComponent,
    'thin-cloud-rainbow': cloud_rainbow_svg_3.ReactComponent,
    'thin-cloud-showers-heavy': cloud_showers_heavy_svg_3.ReactComponent,
    'thin-cloud-showers': cloud_showers_svg_3.ReactComponent,
    'thin-cloud-slash': cloud_slash_svg_3.ReactComponent,
    'thin-cloud-sleet': cloud_sleet_svg_3.ReactComponent,
    'thin-cloud-snow': cloud_snow_svg_3.ReactComponent,
    'thin-cloud-sun-rain': cloud_sun_rain_svg_3.ReactComponent,
    'thin-cloud-sun': cloud_sun_svg_3.ReactComponent,
    'thin-cloud-word': cloud_word_svg_3.ReactComponent,
    'thin-cloud': cloud_svg_3.ReactComponent,
    'thin-clouds-moon': clouds_moon_svg_3.ReactComponent,
    'thin-clouds-sun': clouds_sun_svg_3.ReactComponent,
    'thin-clouds': clouds_svg_3.ReactComponent,
    'thin-clover': clover_svg_3.ReactComponent,
    'thin-club': club_svg_3.ReactComponent,
    'thin-code-branch': code_branch_svg_3.ReactComponent,
    'thin-code-commit': code_commit_svg_3.ReactComponent,
    'thin-code-compare': code_compare_svg_3.ReactComponent,
    'thin-code-fork': code_fork_svg_3.ReactComponent,
    'thin-code-merge': code_merge_svg_3.ReactComponent,
    'thin-code-pull-request': code_pull_request_svg_3.ReactComponent,
    'thin-code-simple': code_simple_svg_3.ReactComponent,
    'thin-code': code_svg_3.ReactComponent,
    'thin-coffee-bean': coffee_bean_svg_3.ReactComponent,
    'thin-coffee-beans': coffee_beans_svg_3.ReactComponent,
    'thin-coffee-pot': coffee_pot_svg_3.ReactComponent,
    'thin-coffin-cross': coffin_cross_svg_3.ReactComponent,
    'thin-coffin': coffin_svg_3.ReactComponent,
    'thin-coin': coin_svg_3.ReactComponent,
    'thin-coins': coins_svg_3.ReactComponent,
    'thin-colon-sign': colon_sign_svg_3.ReactComponent,
    'thin-comet': comet_svg_3.ReactComponent,
    'thin-command': command_svg_3.ReactComponent,
    'thin-comment-arrow-down': comment_arrow_down_svg_3.ReactComponent,
    'thin-comment-arrow-up-right': comment_arrow_up_right_svg_3.ReactComponent,
    'thin-comment-arrow-up': comment_arrow_up_svg_3.ReactComponent,
    'thin-comment-captions': comment_captions_svg_3.ReactComponent,
    'thin-comment-check': comment_check_svg_3.ReactComponent,
    'thin-comment-code': comment_code_svg_3.ReactComponent,
    'thin-comment-dollar': comment_dollar_svg_3.ReactComponent,
    'thin-comment-dots': comment_dots_svg_3.ReactComponent,
    'thin-comment-exclamation': comment_exclamation_svg_3.ReactComponent,
    'thin-comment-image': comment_image_svg_3.ReactComponent,
    'thin-comment-lines': comment_lines_svg_3.ReactComponent,
    'thin-comment-medical': comment_medical_svg_3.ReactComponent,
    'thin-comment-middle-top': comment_middle_top_svg_3.ReactComponent,
    'thin-comment-middle': comment_middle_svg_3.ReactComponent,
    'thin-comment-minus': comment_minus_svg_3.ReactComponent,
    'thin-comment-music': comment_music_svg_3.ReactComponent,
    'thin-comment-pen': comment_pen_svg_3.ReactComponent,
    'thin-comment-plus': comment_plus_svg_3.ReactComponent,
    'thin-comment-question': comment_question_svg_3.ReactComponent,
    'thin-comment-quote': comment_quote_svg_3.ReactComponent,
    'thin-comment-slash': comment_slash_svg_3.ReactComponent,
    'thin-comment-smile': comment_smile_svg_3.ReactComponent,
    'thin-comment-sms': comment_sms_svg_3.ReactComponent,
    'thin-comment-text': comment_text_svg_3.ReactComponent,
    'thin-comment-xmark': comment_xmark_svg_3.ReactComponent,
    'thin-comment': comment_svg_3.ReactComponent,
    'thin-comments-dollar': comments_dollar_svg_3.ReactComponent,
    'thin-comments-question-check': comments_question_check_svg_3.ReactComponent,
    'thin-comments-question': comments_question_svg_3.ReactComponent,
    'thin-comments': comments_svg_3.ReactComponent,
    'thin-compact-disc': compact_disc_svg_3.ReactComponent,
    'thin-compass-drafting': compass_drafting_svg_3.ReactComponent,
    'thin-compass-slash': compass_slash_svg_3.ReactComponent,
    'thin-compass': compass_svg_3.ReactComponent,
    'thin-compress-wide': compress_wide_svg_3.ReactComponent,
    'thin-compress': compress_svg_3.ReactComponent,
    'thin-computer-classic': computer_classic_svg_3.ReactComponent,
    'thin-computer-mouse-scrollwheel': computer_mouse_scrollwheel_svg_3.ReactComponent,
    'thin-computer-mouse': computer_mouse_svg_3.ReactComponent,
    'thin-computer-speaker': computer_speaker_svg_3.ReactComponent,
    'thin-container-storage': container_storage_svg_3.ReactComponent,
    'thin-conveyor-belt-boxes': conveyor_belt_boxes_svg_3.ReactComponent,
    'thin-conveyor-belt-empty': conveyor_belt_empty_svg_3.ReactComponent,
    'thin-conveyor-belt': conveyor_belt_svg_3.ReactComponent,
    'thin-cookie-bite': cookie_bite_svg_3.ReactComponent,
    'thin-cookie': cookie_svg_3.ReactComponent,
    'thin-copy': copy_svg_3.ReactComponent,
    'thin-copyright': copyright_svg_3.ReactComponent,
    'thin-corn': corn_svg_3.ReactComponent,
    'thin-couch': couch_svg_3.ReactComponent,
    'thin-cow': cow_svg_3.ReactComponent,
    'thin-cowbell-circle-plus': cowbell_circle_plus_svg_3.ReactComponent,
    'thin-cowbell': cowbell_svg_3.ReactComponent,
    'thin-credit-card-blank': credit_card_blank_svg_3.ReactComponent,
    'thin-credit-card-front': credit_card_front_svg_3.ReactComponent,
    'thin-credit-card': credit_card_svg_3.ReactComponent,
    'thin-cricket-bat-ball': cricket_bat_ball_svg_3.ReactComponent,
    'thin-croissant': croissant_svg_3.ReactComponent,
    'thin-crop-simple': crop_simple_svg_3.ReactComponent,
    'thin-crop': crop_svg_3.ReactComponent,
    'thin-cross': cross_svg_3.ReactComponent,
    'thin-crosshairs': crosshairs_svg_3.ReactComponent,
    'thin-crow': crow_svg_3.ReactComponent,
    'thin-crown': crown_svg_3.ReactComponent,
    'thin-crutch': crutch_svg_3.ReactComponent,
    'thin-crutches': crutches_svg_3.ReactComponent,
    'thin-cruzeiro-sign': cruzeiro_sign_svg_3.ReactComponent,
    'thin-cube': cube_svg_3.ReactComponent,
    'thin-cubes': cubes_svg_3.ReactComponent,
    'thin-cup-togo': cup_togo_svg_3.ReactComponent,
    'thin-curling-stone': curling_stone_svg_3.ReactComponent,
    'thin-d': d_svg_3.ReactComponent,
    'thin-dagger': dagger_svg_3.ReactComponent,
    'thin-database': database_svg_3.ReactComponent,
    'thin-deer-rudolph': deer_rudolph_svg_3.ReactComponent,
    'thin-deer': deer_svg_3.ReactComponent,
    'thin-delete-left': delete_left_svg_3.ReactComponent,
    'thin-delete-right': delete_right_svg_3.ReactComponent,
    'thin-democrat': democrat_svg_3.ReactComponent,
    'thin-desktop-arrow-down': desktop_arrow_down_svg_3.ReactComponent,
    'thin-desktop': desktop_svg_3.ReactComponent,
    'thin-dharmachakra': dharmachakra_svg_3.ReactComponent,
    'thin-diagram-lean-canvas': diagram_lean_canvas_svg_3.ReactComponent,
    'thin-diagram-nested': diagram_nested_svg_3.ReactComponent,
    'thin-diagram-project': diagram_project_svg_3.ReactComponent,
    'thin-diagram-sankey': diagram_sankey_svg_3.ReactComponent,
    'thin-diagram-stankey': diagram_stankey_svg_3.ReactComponent,
    'thin-diagram-venn': diagram_venn_svg_3.ReactComponent,
    'thin-dial-high': dial_high_svg_3.ReactComponent,
    'thin-dial-low': dial_low_svg_3.ReactComponent,
    'thin-dial-max': dial_max_svg_3.ReactComponent,
    'thin-dial-med-low': dial_med_low_svg_3.ReactComponent,
    'thin-dial-med': dial_med_svg_3.ReactComponent,
    'thin-dial-min': dial_min_svg_3.ReactComponent,
    'thin-dial': dial_svg_3.ReactComponent,
    'thin-diamond-turn-right': diamond_turn_right_svg_3.ReactComponent,
    'thin-diamond': diamond_svg_3.ReactComponent,
    'thin-dice-d10': dice_d10_svg_3.ReactComponent,
    'thin-dice-d12': dice_d12_svg_3.ReactComponent,
    'thin-dice-d20': dice_d20_svg_3.ReactComponent,
    'thin-dice-d4': dice_d4_svg_3.ReactComponent,
    'thin-dice-d6': dice_d6_svg_3.ReactComponent,
    'thin-dice-d8': dice_d8_svg_3.ReactComponent,
    'thin-dice-five': dice_five_svg_3.ReactComponent,
    'thin-dice-four': dice_four_svg_3.ReactComponent,
    'thin-dice-one': dice_one_svg_3.ReactComponent,
    'thin-dice-six': dice_six_svg_3.ReactComponent,
    'thin-dice-three': dice_three_svg_3.ReactComponent,
    'thin-dice-two': dice_two_svg_3.ReactComponent,
    'thin-dice': dice_svg_3.ReactComponent,
    'thin-diploma': diploma_svg_3.ReactComponent,
    'thin-disc-drive': disc_drive_svg_3.ReactComponent,
    'thin-disease': disease_svg_3.ReactComponent,
    'thin-display-arrow-down': display_arrow_down_svg_3.ReactComponent,
    'thin-display-code': display_code_svg_3.ReactComponent,
    'thin-display-medical': display_medical_svg_3.ReactComponent,
    'thin-display-slash': display_slash_svg_3.ReactComponent,
    'thin-display': display_svg_3.ReactComponent,
    'thin-divide': divide_svg_3.ReactComponent,
    'thin-dna': dna_svg_3.ReactComponent,
    'thin-do-not-enter': do_not_enter_svg_3.ReactComponent,
    'thin-dog-leashed': dog_leashed_svg_3.ReactComponent,
    'thin-dog': dog_svg_3.ReactComponent,
    'thin-dollar-sign': dollar_sign_svg_3.ReactComponent,
    'thin-dolly-empty': dolly_empty_svg_3.ReactComponent,
    'thin-dolly': dolly_svg_3.ReactComponent,
    'thin-dolphin': dolphin_svg_3.ReactComponent,
    'thin-dong-sign': dong_sign_svg_3.ReactComponent,
    'thin-door-closed': door_closed_svg_3.ReactComponent,
    'thin-door-open': door_open_svg_3.ReactComponent,
    'thin-dove': dove_svg_3.ReactComponent,
    'thin-down-from-line': down_from_line_svg_3.ReactComponent,
    'thin-down-left-and-up-right-to-center': down_left_and_up_right_to_center_svg_3.ReactComponent,
    'thin-down-left': down_left_svg_3.ReactComponent,
    'thin-down-long': down_long_svg_3.ReactComponent,
    'thin-down-right': down_right_svg_3.ReactComponent,
    'thin-down-to-line': down_to_line_svg_3.ReactComponent,
    'thin-down': down_svg_3.ReactComponent,
    'thin-download': download_svg_3.ReactComponent,
    'thin-dragon': dragon_svg_3.ReactComponent,
    'thin-draw-circle': draw_circle_svg_3.ReactComponent,
    'thin-draw-polygon': draw_polygon_svg_3.ReactComponent,
    'thin-draw-square': draw_square_svg_3.ReactComponent,
    'thin-dreidel': dreidel_svg_3.ReactComponent,
    'thin-drone-front': drone_front_svg_3.ReactComponent,
    'thin-drone': drone_svg_3.ReactComponent,
    'thin-droplet-degree': droplet_degree_svg_3.ReactComponent,
    'thin-droplet-percent': droplet_percent_svg_3.ReactComponent,
    'thin-droplet-slash': droplet_slash_svg_3.ReactComponent,
    'thin-droplet': droplet_svg_3.ReactComponent,
    'thin-drum-steelpan': drum_steelpan_svg_3.ReactComponent,
    'thin-drum': drum_svg_3.ReactComponent,
    'thin-drumstick-bite': drumstick_bite_svg_3.ReactComponent,
    'thin-drumstick': drumstick_svg_3.ReactComponent,
    'thin-dryer-heat': dryer_heat_svg_3.ReactComponent,
    'thin-dryer': dryer_svg_3.ReactComponent,
    'thin-duck': duck_svg_3.ReactComponent,
    'thin-dumbbell': dumbbell_svg_3.ReactComponent,
    'thin-dumpster-fire': dumpster_fire_svg_3.ReactComponent,
    'thin-dumpster': dumpster_svg_3.ReactComponent,
    'thin-dungeon': dungeon_svg_3.ReactComponent,
    'thin-e': e_svg_3.ReactComponent,
    'thin-ear-deaf': ear_deaf_svg_3.ReactComponent,
    'thin-ear-listen': ear_listen_svg_3.ReactComponent,
    'thin-ear-muffs': ear_muffs_svg_3.ReactComponent,
    'thin-ear': ear_svg_3.ReactComponent,
    'thin-earth-africa': earth_africa_svg_3.ReactComponent,
    'thin-earth-americas': earth_americas_svg_3.ReactComponent,
    'thin-earth-asia': earth_asia_svg_3.ReactComponent,
    'thin-earth-europa': earth_europa_svg_3.ReactComponent,
    'thin-eclipse': eclipse_svg_3.ReactComponent,
    'thin-egg-fried': egg_fried_svg_3.ReactComponent,
    'thin-egg': egg_svg_3.ReactComponent,
    'thin-eggplant': eggplant_svg_3.ReactComponent,
    'thin-eject': eject_svg_3.ReactComponent,
    'thin-elephant': elephant_svg_3.ReactComponent,
    'thin-elevator': elevator_svg_3.ReactComponent,
    'thin-ellipsis-stroke-vertical': ellipsis_stroke_vertical_svg_3.ReactComponent,
    'thin-ellipsis-stroke': ellipsis_stroke_svg_3.ReactComponent,
    'thin-ellipsis-vertical': ellipsis_vertical_svg_3.ReactComponent,
    'thin-ellipsis': ellipsis_svg_3.ReactComponent,
    'thin-empty-set': empty_set_svg_3.ReactComponent,
    'thin-engine-warning': engine_warning_svg_3.ReactComponent,
    'thin-engine': engine_svg_3.ReactComponent,
    'thin-envelope-dot': envelope_dot_svg_3.ReactComponent,
    'thin-envelope-open-dollar': envelope_open_dollar_svg_3.ReactComponent,
    'thin-envelope-open-text': envelope_open_text_svg_3.ReactComponent,
    'thin-envelope-open': envelope_open_svg_3.ReactComponent,
    'thin-envelope': envelope_svg_3.ReactComponent,
    'thin-envelopes-bulk': envelopes_bulk_svg_3.ReactComponent,
    'thin-envelopes': envelopes_svg_3.ReactComponent,
    'thin-equals': equals_svg_3.ReactComponent,
    'thin-eraser': eraser_svg_3.ReactComponent,
    'thin-escalator': escalator_svg_3.ReactComponent,
    'thin-ethernet': ethernet_svg_3.ReactComponent,
    'thin-euro-sign': euro_sign_svg_3.ReactComponent,
    'thin-exclamation': exclamation_svg_3.ReactComponent,
    'thin-expand-wide': expand_wide_svg_3.ReactComponent,
    'thin-expand': expand_svg_3.ReactComponent,
    'thin-eye-dropper-full': eye_dropper_full_svg_3.ReactComponent,
    'thin-eye-dropper-half': eye_dropper_half_svg_3.ReactComponent,
    'thin-eye-dropper': eye_dropper_svg_3.ReactComponent,
    'thin-eye-evil': eye_evil_svg_3.ReactComponent,
    'thin-eye-low-vision': eye_low_vision_svg_3.ReactComponent,
    'thin-eye-slash': eye_slash_svg_3.ReactComponent,
    'thin-eye': eye_svg_3.ReactComponent,
    'thin-f': f_svg_3.ReactComponent,
    'thin-face-angry': face_angry_svg_3.ReactComponent,
    'thin-face-dizzy': face_dizzy_svg_3.ReactComponent,
    'thin-face-flushed': face_flushed_svg_3.ReactComponent,
    'thin-face-frown-open': face_frown_open_svg_3.ReactComponent,
    'thin-face-frown': face_frown_svg_3.ReactComponent,
    'thin-face-grimace': face_grimace_svg_3.ReactComponent,
    'thin-face-grin-beam-sweat': face_grin_beam_sweat_svg_3.ReactComponent,
    'thin-face-grin-beam': face_grin_beam_svg_3.ReactComponent,
    'thin-face-grin-hearts': face_grin_hearts_svg_3.ReactComponent,
    'thin-face-grin-squint-tears': face_grin_squint_tears_svg_3.ReactComponent,
    'thin-face-grin-squint': face_grin_squint_svg_3.ReactComponent,
    'thin-face-grin-stars': face_grin_stars_svg_3.ReactComponent,
    'thin-face-grin-tears': face_grin_tears_svg_3.ReactComponent,
    'thin-face-grin-tongue-squint': face_grin_tongue_squint_svg_3.ReactComponent,
    'thin-face-grin-tongue-wink': face_grin_tongue_wink_svg_3.ReactComponent,
    'thin-face-grin-tongue': face_grin_tongue_svg_3.ReactComponent,
    'thin-face-grin-wide': face_grin_wide_svg_3.ReactComponent,
    'thin-face-grin-wink': face_grin_wink_svg_3.ReactComponent,
    'thin-face-grin': face_grin_svg_3.ReactComponent,
    'thin-face-kiss-beam': face_kiss_beam_svg_3.ReactComponent,
    'thin-face-kiss-wink-heart': face_kiss_wink_heart_svg_3.ReactComponent,
    'thin-face-kiss': face_kiss_svg_3.ReactComponent,
    'thin-face-laugh-beam': face_laugh_beam_svg_3.ReactComponent,
    'thin-face-laugh-squint': face_laugh_squint_svg_3.ReactComponent,
    'thin-face-laugh-wink': face_laugh_wink_svg_3.ReactComponent,
    'thin-face-laugh': face_laugh_svg_3.ReactComponent,
    'thin-face-meh-blank': face_meh_blank_svg_3.ReactComponent,
    'thin-face-meh': face_meh_svg_3.ReactComponent,
    'thin-face-rolling-eyes': face_rolling_eyes_svg_3.ReactComponent,
    'thin-face-sad-cry': face_sad_cry_svg_3.ReactComponent,
    'thin-face-sad-tear': face_sad_tear_svg_3.ReactComponent,
    'thin-face-smile-beam': face_smile_beam_svg_3.ReactComponent,
    'thin-face-smile-plus': face_smile_plus_svg_3.ReactComponent,
    'thin-face-smile-wink': face_smile_wink_svg_3.ReactComponent,
    'thin-face-smile': face_smile_svg_3.ReactComponent,
    'thin-face-surprise': face_surprise_svg_3.ReactComponent,
    'thin-face-tired': face_tired_svg_3.ReactComponent,
    'thin-fan-table': fan_table_svg_3.ReactComponent,
    'thin-fan': fan_svg_3.ReactComponent,
    'thin-farm': farm_svg_3.ReactComponent,
    'thin-faucet-drip': faucet_drip_svg_3.ReactComponent,
    'thin-faucet': faucet_svg_3.ReactComponent,
    'thin-fax': fax_svg_3.ReactComponent,
    'thin-feather-pointed': feather_pointed_svg_3.ReactComponent,
    'thin-feather': feather_svg_3.ReactComponent,
    'thin-fence': fence_svg_3.ReactComponent,
    'thin-field-hockey-stick-ball': field_hockey_stick_ball_svg_3.ReactComponent,
    'thin-file-arrow-down': file_arrow_down_svg_3.ReactComponent,
    'thin-file-arrow-up': file_arrow_up_svg_3.ReactComponent,
    'thin-file-audio': file_audio_svg_3.ReactComponent,
    'thin-file-binary': file_binary_svg_3.ReactComponent,
    'thin-file-certificate': file_certificate_svg_3.ReactComponent,
    'thin-file-chart-column': file_chart_column_svg_3.ReactComponent,
    'thin-file-chart-pie': file_chart_pie_svg_3.ReactComponent,
    'thin-file-check': file_check_svg_3.ReactComponent,
    'thin-file-code': file_code_svg_3.ReactComponent,
    'thin-file-contract': file_contract_svg_3.ReactComponent,
    'thin-file-csv': file_csv_svg_3.ReactComponent,
    'thin-file-dashed-line': file_dashed_line_svg_3.ReactComponent,
    'thin-file-excel': file_excel_svg_3.ReactComponent,
    'thin-file-exclamation': file_exclamation_svg_3.ReactComponent,
    'thin-file-export': file_export_svg_3.ReactComponent,
    'thin-file-heart': file_heart_svg_3.ReactComponent,
    'thin-file-image': file_image_svg_3.ReactComponent,
    'thin-file-import': file_import_svg_3.ReactComponent,
    'thin-file-invoice-dollar': file_invoice_dollar_svg_3.ReactComponent,
    'thin-file-invoice': file_invoice_svg_3.ReactComponent,
    'thin-file-lines': file_lines_svg_3.ReactComponent,
    'thin-file-magnifying-glass': file_magnifying_glass_svg_3.ReactComponent,
    'thin-file-medical': file_medical_svg_3.ReactComponent,
    'thin-file-minus': file_minus_svg_3.ReactComponent,
    'thin-file-music': file_music_svg_3.ReactComponent,
    'thin-file-pdf': file_pdf_svg_3.ReactComponent,
    'thin-file-pen': file_pen_svg_3.ReactComponent,
    'thin-file-plus-minus': file_plus_minus_svg_3.ReactComponent,
    'thin-file-plus': file_plus_svg_3.ReactComponent,
    'thin-file-powerpoint': file_powerpoint_svg_3.ReactComponent,
    'thin-file-prescription': file_prescription_svg_3.ReactComponent,
    'thin-file-signature': file_signature_svg_3.ReactComponent,
    'thin-file-spreadsheet': file_spreadsheet_svg_3.ReactComponent,
    'thin-file-user': file_user_svg_3.ReactComponent,
    'thin-file-video': file_video_svg_3.ReactComponent,
    'thin-file-waveform': file_waveform_svg_3.ReactComponent,
    'thin-file-word': file_word_svg_3.ReactComponent,
    'thin-file-xmark': file_xmark_svg_3.ReactComponent,
    'thin-file-zipper': file_zipper_svg_3.ReactComponent,
    'thin-file': file_svg_3.ReactComponent,
    'thin-files-medical': files_medical_svg_3.ReactComponent,
    'thin-files': files_svg_3.ReactComponent,
    'thin-fill-drip': fill_drip_svg_3.ReactComponent,
    'thin-fill': fill_svg_3.ReactComponent,
    'thin-film-canister': film_canister_svg_3.ReactComponent,
    'thin-film-simple': film_simple_svg_3.ReactComponent,
    'thin-film-slash': film_slash_svg_3.ReactComponent,
    'thin-film': film_svg_3.ReactComponent,
    'thin-films': films_svg_3.ReactComponent,
    'thin-filter-circle-dollar': filter_circle_dollar_svg_3.ReactComponent,
    'thin-filter-circle-xmark': filter_circle_xmark_svg_3.ReactComponent,
    'thin-filter-list': filter_list_svg_3.ReactComponent,
    'thin-filter-slash': filter_slash_svg_3.ReactComponent,
    'thin-filter': filter_svg_3.ReactComponent,
    'thin-filters': filters_svg_3.ReactComponent,
    'thin-fingerprint': fingerprint_svg_3.ReactComponent,
    'thin-fire-extinguisher': fire_extinguisher_svg_3.ReactComponent,
    'thin-fire-flame-curved': fire_flame_curved_svg_3.ReactComponent,
    'thin-fire-flame-simple': fire_flame_simple_svg_3.ReactComponent,
    'thin-fire-flame': fire_flame_svg_3.ReactComponent,
    'thin-fire-hydrant': fire_hydrant_svg_3.ReactComponent,
    'thin-fire-smoke': fire_smoke_svg_3.ReactComponent,
    'thin-fire': fire_svg_3.ReactComponent,
    'thin-fireplace': fireplace_svg_3.ReactComponent,
    'thin-fish-cooked': fish_cooked_svg_3.ReactComponent,
    'thin-fish': fish_svg_3.ReactComponent,
    'thin-flag-checkered': flag_checkered_svg_3.ReactComponent,
    'thin-flag-pennant': flag_pennant_svg_3.ReactComponent,
    'thin-flag-swallowtail': flag_swallowtail_svg_3.ReactComponent,
    'thin-flag-usa': flag_usa_svg_3.ReactComponent,
    'thin-flag': flag_svg_3.ReactComponent,
    'thin-flashlight': flashlight_svg_3.ReactComponent,
    'thin-flask-round-poison': flask_round_poison_svg_3.ReactComponent,
    'thin-flask-round-potion': flask_round_potion_svg_3.ReactComponent,
    'thin-flask': flask_svg_3.ReactComponent,
    'thin-floppy-disk-circle-arrow-right': floppy_disk_circle_arrow_right_svg_3.ReactComponent,
    'thin-floppy-disk-circle-xmark': floppy_disk_circle_xmark_svg_3.ReactComponent,
    'thin-floppy-disk-pen': floppy_disk_pen_svg_3.ReactComponent,
    'thin-floppy-disk': floppy_disk_svg_3.ReactComponent,
    'thin-floppy-disks': floppy_disks_svg_3.ReactComponent,
    'thin-florin-sign': florin_sign_svg_3.ReactComponent,
    'thin-flower-daffodil': flower_daffodil_svg_3.ReactComponent,
    'thin-flower-tulip': flower_tulip_svg_3.ReactComponent,
    'thin-flower': flower_svg_3.ReactComponent,
    'thin-flute': flute_svg_3.ReactComponent,
    'thin-flux-capacitor': flux_capacitor_svg_3.ReactComponent,
    'thin-folder-arrow-down': folder_arrow_down_svg_3.ReactComponent,
    'thin-folder-arrow-up': folder_arrow_up_svg_3.ReactComponent,
    'thin-folder-blank': folder_blank_svg_3.ReactComponent,
    'thin-folder-bookmark': folder_bookmark_svg_3.ReactComponent,
    'thin-folder-gear': folder_gear_svg_3.ReactComponent,
    'thin-folder-grid': folder_grid_svg_3.ReactComponent,
    'thin-folder-heart': folder_heart_svg_3.ReactComponent,
    'thin-folder-image': folder_image_svg_3.ReactComponent,
    'thin-folder-magnifying-glass': folder_magnifying_glass_svg_3.ReactComponent,
    'thin-folder-medical': folder_medical_svg_3.ReactComponent,
    'thin-folder-minus': folder_minus_svg_3.ReactComponent,
    'thin-folder-music': folder_music_svg_3.ReactComponent,
    'thin-folder-open': folder_open_svg_3.ReactComponent,
    'thin-folder-plus': folder_plus_svg_3.ReactComponent,
    'thin-folder-tree': folder_tree_svg_3.ReactComponent,
    'thin-folder-user': folder_user_svg_3.ReactComponent,
    'thin-folder-xmark': folder_xmark_svg_3.ReactComponent,
    'thin-folder': folder_svg_3.ReactComponent,
    'thin-folders': folders_svg_3.ReactComponent,
    'thin-font-awesome': font_awesome_svg_4.ReactComponent,
    'thin-font-case': font_case_svg_3.ReactComponent,
    'thin-font': font_svg_3.ReactComponent,
    'thin-football-ball': football_ball_svg_3.ReactComponent,
    'thin-football-helmet': football_helmet_svg_3.ReactComponent,
    'thin-fork-knife': fork_knife_svg_3.ReactComponent,
    'thin-fork': fork_svg_3.ReactComponent,
    'thin-forklift': forklift_svg_3.ReactComponent,
    'thin-forward-fast': forward_fast_svg_3.ReactComponent,
    'thin-forward-step': forward_step_svg_3.ReactComponent,
    'thin-forward': forward_svg_3.ReactComponent,
    'thin-franc-sign': franc_sign_svg_3.ReactComponent,
    'thin-french-fries': french_fries_svg_3.ReactComponent,
    'thin-frog': frog_svg_3.ReactComponent,
    'thin-function': function_svg_3.ReactComponent,
    'thin-futbol-ball': futbol_ball_svg_3.ReactComponent,
    'thin-g': g_svg_3.ReactComponent,
    'thin-galaxy': galaxy_svg_3.ReactComponent,
    'thin-game-board-simple': game_board_simple_svg_3.ReactComponent,
    'thin-game-board': game_board_svg_3.ReactComponent,
    'thin-game-console-handheld': game_console_handheld_svg_3.ReactComponent,
    'thin-gamepad-modern': gamepad_modern_svg_3.ReactComponent,
    'thin-gamepad': gamepad_svg_3.ReactComponent,
    'thin-garage-car': garage_car_svg_3.ReactComponent,
    'thin-garage-open': garage_open_svg_3.ReactComponent,
    'thin-garage': garage_svg_3.ReactComponent,
    'thin-gas-pump-slash': gas_pump_slash_svg_3.ReactComponent,
    'thin-gas-pump': gas_pump_svg_3.ReactComponent,
    'thin-gauge-low': gauge_low_svg_3.ReactComponent,
    'thin-gauge-max': gauge_max_svg_3.ReactComponent,
    'thin-gauge-med': gauge_med_svg_3.ReactComponent,
    'thin-gauge-min': gauge_min_svg_3.ReactComponent,
    'thin-gauge-simple-low': gauge_simple_low_svg_3.ReactComponent,
    'thin-gauge-simple-max': gauge_simple_max_svg_3.ReactComponent,
    'thin-gauge-simple-med': gauge_simple_med_svg_3.ReactComponent,
    'thin-gauge-simple-min': gauge_simple_min_svg_3.ReactComponent,
    'thin-gauge-simple': gauge_simple_svg_3.ReactComponent,
    'thin-gauge': gauge_svg_3.ReactComponent,
    'thin-gavel': gavel_svg_3.ReactComponent,
    'thin-gear': gear_svg_3.ReactComponent,
    'thin-gears': gears_svg_3.ReactComponent,
    'thin-gem': gem_svg_3.ReactComponent,
    'thin-genderless': genderless_svg_3.ReactComponent,
    'thin-ghost': ghost_svg_3.ReactComponent,
    'thin-gif': gif_svg_3.ReactComponent,
    'thin-gift-card': gift_card_svg_3.ReactComponent,
    'thin-gift': gift_svg_3.ReactComponent,
    'thin-gifts': gifts_svg_3.ReactComponent,
    'thin-gingerbread-man': gingerbread_man_svg_3.ReactComponent,
    'thin-glass-citrus': glass_citrus_svg_3.ReactComponent,
    'thin-glass-empty': glass_empty_svg_3.ReactComponent,
    'thin-glass-half': glass_half_svg_3.ReactComponent,
    'thin-glass': glass_svg_3.ReactComponent,
    'thin-glasses-round': glasses_round_svg_3.ReactComponent,
    'thin-glasses': glasses_svg_3.ReactComponent,
    'thin-globe-snow': globe_snow_svg_3.ReactComponent,
    'thin-globe-stand': globe_stand_svg_3.ReactComponent,
    'thin-globe': globe_svg_3.ReactComponent,
    'thin-golf-ball-tee': golf_ball_tee_svg_3.ReactComponent,
    'thin-golf-club': golf_club_svg_3.ReactComponent,
    'thin-gopuram': gopuram_svg_3.ReactComponent,
    'thin-graduation-cap': graduation_cap_svg_3.ReactComponent,
    'thin-gramophone': gramophone_svg_3.ReactComponent,
    'thin-grate-droplet': grate_droplet_svg_3.ReactComponent,
    'thin-grate': grate_svg_3.ReactComponent,
    'thin-greater-than-equal': greater_than_equal_svg_3.ReactComponent,
    'thin-greater-than': greater_than_svg_3.ReactComponent,
    'thin-grid-2-plus': grid_2_plus_svg_3.ReactComponent,
    'thin-grid-2': grid_2_svg_3.ReactComponent,
    'thin-grid-4': grid_4_svg_3.ReactComponent,
    'thin-grid-5': grid_5_svg_3.ReactComponent,
    'thin-grid': grid_svg_3.ReactComponent,
    'thin-grip-lines-vertical': grip_lines_vertical_svg_3.ReactComponent,
    'thin-grip-lines': grip_lines_svg_3.ReactComponent,
    'thin-grip-vertical': grip_vertical_svg_3.ReactComponent,
    'thin-grip': grip_svg_3.ReactComponent,
    'thin-guarani-sign': guarani_sign_svg_3.ReactComponent,
    'thin-guitar-electric': guitar_electric_svg_3.ReactComponent,
    'thin-guitar': guitar_svg_3.ReactComponent,
    'thin-guitars': guitars_svg_3.ReactComponent,
    'thin-gun-slash': gun_slash_svg_3.ReactComponent,
    'thin-gun-squirt': gun_squirt_svg_3.ReactComponent,
    'thin-gun': gun_svg_3.ReactComponent,
    'thin-h': h_svg_3.ReactComponent,
    'thin-h1': h1_svg_3.ReactComponent,
    'thin-h2': h2_svg_3.ReactComponent,
    'thin-h3': h3_svg_3.ReactComponent,
    'thin-h4': h4_svg_3.ReactComponent,
    'thin-hammer-war': hammer_war_svg_3.ReactComponent,
    'thin-hammer': hammer_svg_3.ReactComponent,
    'thin-hamsa': hamsa_svg_3.ReactComponent,
    'thin-hand-back-point-down': hand_back_point_down_svg_3.ReactComponent,
    'thin-hand-back-point-left': hand_back_point_left_svg_3.ReactComponent,
    'thin-hand-back-point-right': hand_back_point_right_svg_3.ReactComponent,
    'thin-hand-back-point-up': hand_back_point_up_svg_3.ReactComponent,
    'thin-hand-dots': hand_dots_svg_3.ReactComponent,
    'thin-hand-fingers-crossed': hand_fingers_crossed_svg_3.ReactComponent,
    'thin-hand-fist': hand_fist_svg_3.ReactComponent,
    'thin-hand-heart': hand_heart_svg_3.ReactComponent,
    'thin-hand-holding-box': hand_holding_box_svg_3.ReactComponent,
    'thin-hand-holding-dollar': hand_holding_dollar_svg_3.ReactComponent,
    'thin-hand-holding-droplet': hand_holding_droplet_svg_3.ReactComponent,
    'thin-hand-holding-heart': hand_holding_heart_svg_3.ReactComponent,
    'thin-hand-holding-magic': hand_holding_magic_svg_3.ReactComponent,
    'thin-hand-holding-medical': hand_holding_medical_svg_3.ReactComponent,
    'thin-hand-holding-seedling': hand_holding_seedling_svg_3.ReactComponent,
    'thin-hand-holding-skull': hand_holding_skull_svg_3.ReactComponent,
    'thin-hand-holding': hand_holding_svg_3.ReactComponent,
    'thin-hand-lizard': hand_lizard_svg_3.ReactComponent,
    'thin-hand-love': hand_love_svg_3.ReactComponent,
    'thin-hand-middle-finger': hand_middle_finger_svg_3.ReactComponent,
    'thin-hand-paper': hand_paper_svg_3.ReactComponent,
    'thin-hand-peace': hand_peace_svg_3.ReactComponent,
    'thin-hand-point-down': hand_point_down_svg_3.ReactComponent,
    'thin-hand-point-left': hand_point_left_svg_3.ReactComponent,
    'thin-hand-point-right': hand_point_right_svg_3.ReactComponent,
    'thin-hand-point-up': hand_point_up_svg_3.ReactComponent,
    'thin-hand-pointer': hand_pointer_svg_3.ReactComponent,
    'thin-hand-rock': hand_rock_svg_3.ReactComponent,
    'thin-hand-scissors': hand_scissors_svg_3.ReactComponent,
    'thin-hand-sparkles': hand_sparkles_svg_3.ReactComponent,
    'thin-hand-spock': hand_spock_svg_3.ReactComponent,
    'thin-hand-wave': hand_wave_svg_3.ReactComponent,
    'thin-hands-asl-interpreting': hands_asl_interpreting_svg_3.ReactComponent,
    'thin-hands-bubbles': hands_bubbles_svg_3.ReactComponent,
    'thin-hands-clapping': hands_clapping_svg_3.ReactComponent,
    'thin-hands-holding-diamond': hands_holding_diamond_svg_3.ReactComponent,
    'thin-hands-holding-dollar': hands_holding_dollar_svg_3.ReactComponent,
    'thin-hands-holding-heart': hands_holding_heart_svg_3.ReactComponent,
    'thin-hands-holding': hands_holding_svg_3.ReactComponent,
    'thin-hands-horns': hands_horns_svg_3.ReactComponent,
    'thin-hands-praying': hands_praying_svg_3.ReactComponent,
    'thin-hands': hands_svg_3.ReactComponent,
    'thin-handshake-angle': handshake_angle_svg_3.ReactComponent,
    'thin-handshake-simple-slash': handshake_simple_slash_svg_3.ReactComponent,
    'thin-handshake-simple': handshake_simple_svg_3.ReactComponent,
    'thin-handshake-slash': handshake_slash_svg_3.ReactComponent,
    'thin-handshake': handshake_svg_3.ReactComponent,
    'thin-hanukiah': hanukiah_svg_3.ReactComponent,
    'thin-hard-drive': hard_drive_svg_3.ReactComponent,
    'thin-hashtag': hashtag_svg_3.ReactComponent,
    'thin-hat-chef': hat_chef_svg_3.ReactComponent,
    'thin-hat-cowboy-side': hat_cowboy_side_svg_3.ReactComponent,
    'thin-hat-cowboy': hat_cowboy_svg_3.ReactComponent,
    'thin-hat-santa': hat_santa_svg_3.ReactComponent,
    'thin-hat-winter': hat_winter_svg_3.ReactComponent,
    'thin-hat-witch': hat_witch_svg_3.ReactComponent,
    'thin-hat-wizard': hat_wizard_svg_3.ReactComponent,
    'thin-head-side-brain': head_side_brain_svg_3.ReactComponent,
    'thin-head-side-cough-slash': head_side_cough_slash_svg_3.ReactComponent,
    'thin-head-side-cough': head_side_cough_svg_3.ReactComponent,
    'thin-head-side-goggles': head_side_goggles_svg_3.ReactComponent,
    'thin-head-side-headphones': head_side_headphones_svg_3.ReactComponent,
    'thin-head-side-heart': head_side_heart_svg_3.ReactComponent,
    'thin-head-side-mask': head_side_mask_svg_3.ReactComponent,
    'thin-head-side-medical': head_side_medical_svg_3.ReactComponent,
    'thin-head-side-virus': head_side_virus_svg_3.ReactComponent,
    'thin-head-side': head_side_svg_3.ReactComponent,
    'thin-heading': heading_svg_3.ReactComponent,
    'thin-headphones-simple': headphones_simple_svg_3.ReactComponent,
    'thin-headphones': headphones_svg_3.ReactComponent,
    'thin-headset': headset_svg_3.ReactComponent,
    'thin-heart-crack': heart_crack_svg_3.ReactComponent,
    'thin-heart-half-stroke': heart_half_stroke_svg_3.ReactComponent,
    'thin-heart-half': heart_half_svg_3.ReactComponent,
    'thin-heart-pulse': heart_pulse_svg_3.ReactComponent,
    'thin-heart': heart_svg_3.ReactComponent,
    'thin-heat': heat_svg_3.ReactComponent,
    'thin-helicopter': helicopter_svg_3.ReactComponent,
    'thin-helmet-battle': helmet_battle_svg_3.ReactComponent,
    'thin-helmet-safety': helmet_safety_svg_3.ReactComponent,
    'thin-hexagon-divide': hexagon_divide_svg_3.ReactComponent,
    'thin-hexagon-minus': hexagon_minus_svg_3.ReactComponent,
    'thin-hexagon-plus': hexagon_plus_svg_3.ReactComponent,
    'thin-hexagon-xmark': hexagon_xmark_svg_3.ReactComponent,
    'thin-hexagon': hexagon_svg_3.ReactComponent,
    'thin-high-definition': high_definition_svg_3.ReactComponent,
    'thin-highlighter-line': highlighter_line_svg_3.ReactComponent,
    'thin-highlighter': highlighter_svg_3.ReactComponent,
    'thin-hippo': hippo_svg_3.ReactComponent,
    'thin-hockey-mask': hockey_mask_svg_3.ReactComponent,
    'thin-hockey-puck': hockey_puck_svg_3.ReactComponent,
    'thin-hockey-sticks': hockey_sticks_svg_3.ReactComponent,
    'thin-holly-berry': holly_berry_svg_3.ReactComponent,
    'thin-home-heart': home_heart_svg_3.ReactComponent,
    'thin-home-simple': home_simple_svg_3.ReactComponent,
    'thin-home-user': home_user_svg_3.ReactComponent,
    'thin-home': home_svg_3.ReactComponent,
    'thin-hood-cloak': hood_cloak_svg_3.ReactComponent,
    'thin-horizontal-rule': horizontal_rule_svg_3.ReactComponent,
    'thin-horse-head': horse_head_svg_3.ReactComponent,
    'thin-horse-saddle': horse_saddle_svg_3.ReactComponent,
    'thin-horse': horse_svg_3.ReactComponent,
    'thin-hospital-user': hospital_user_svg_3.ReactComponent,
    'thin-hospital-wide': hospital_wide_svg_3.ReactComponent,
    'thin-hospital': hospital_svg_3.ReactComponent,
    'thin-hospitals': hospitals_svg_3.ReactComponent,
    'thin-hot-tub-person': hot_tub_person_svg_3.ReactComponent,
    'thin-hotdog': hotdog_svg_3.ReactComponent,
    'thin-hotel': hotel_svg_3.ReactComponent,
    'thin-hourglass-empty': hourglass_empty_svg_3.ReactComponent,
    'thin-hourglass-end': hourglass_end_svg_3.ReactComponent,
    'thin-hourglass-start': hourglass_start_svg_3.ReactComponent,
    'thin-hourglass': hourglass_svg_3.ReactComponent,
    'thin-house-building': house_building_svg_3.ReactComponent,
    'thin-house-crack': house_crack_svg_3.ReactComponent,
    'thin-house-day': house_day_svg_3.ReactComponent,
    'thin-house-flood': house_flood_svg_3.ReactComponent,
    'thin-house-heart': house_heart_svg_3.ReactComponent,
    'thin-house-laptop': house_laptop_svg_3.ReactComponent,
    'thin-house-medical': house_medical_svg_3.ReactComponent,
    'thin-house-night': house_night_svg_3.ReactComponent,
    'thin-house-person-leave': house_person_leave_svg_3.ReactComponent,
    'thin-house-person-return': house_person_return_svg_3.ReactComponent,
    'thin-house-signal': house_signal_svg_3.ReactComponent,
    'thin-house-tree': house_tree_svg_3.ReactComponent,
    'thin-house-turret': house_turret_svg_3.ReactComponent,
    'thin-house-user': house_user_svg_3.ReactComponent,
    'thin-house': house_svg_3.ReactComponent,
    'thin-hryvnia-sign': hryvnia_sign_svg_3.ReactComponent,
    'thin-hurricane': hurricane_svg_3.ReactComponent,
    'thin-i-cursor': i_cursor_svg_3.ReactComponent,
    'thin-i': i_svg_3.ReactComponent,
    'thin-ice-cream': ice_cream_svg_3.ReactComponent,
    'thin-ice-skate': ice_skate_svg_3.ReactComponent,
    'thin-icicles': icicles_svg_3.ReactComponent,
    'thin-icons': icons_svg_3.ReactComponent,
    'thin-id-badge': id_badge_svg_3.ReactComponent,
    'thin-id-card-clip': id_card_clip_svg_3.ReactComponent,
    'thin-id-card': id_card_svg_3.ReactComponent,
    'thin-igloo': igloo_svg_3.ReactComponent,
    'thin-image-landscape': image_landscape_svg_3.ReactComponent,
    'thin-image-polaroid-user': image_polaroid_user_svg_3.ReactComponent,
    'thin-image-polaroid': image_polaroid_svg_3.ReactComponent,
    'thin-image-portrait': image_portrait_svg_3.ReactComponent,
    'thin-image-slash': image_slash_svg_3.ReactComponent,
    'thin-image-user': image_user_svg_3.ReactComponent,
    'thin-image': image_svg_3.ReactComponent,
    'thin-images-user': images_user_svg_3.ReactComponent,
    'thin-images': images_svg_3.ReactComponent,
    'thin-inbox-full': inbox_full_svg_3.ReactComponent,
    'thin-inbox-in': inbox_in_svg_3.ReactComponent,
    'thin-inbox-out': inbox_out_svg_3.ReactComponent,
    'thin-inbox': inbox_svg_3.ReactComponent,
    'thin-inboxes': inboxes_svg_3.ReactComponent,
    'thin-indent': indent_svg_3.ReactComponent,
    'thin-indian-rupee-sign': indian_rupee_sign_svg_3.ReactComponent,
    'thin-industry-windows': industry_windows_svg_3.ReactComponent,
    'thin-industry': industry_svg_3.ReactComponent,
    'thin-infinity': infinity_svg_3.ReactComponent,
    'thin-info': info_svg_3.ReactComponent,
    'thin-inhaler': inhaler_svg_3.ReactComponent,
    'thin-input-numeric': input_numeric_svg_3.ReactComponent,
    'thin-input-pipe': input_pipe_svg_3.ReactComponent,
    'thin-input-text': input_text_svg_3.ReactComponent,
    'thin-integral': integral_svg_3.ReactComponent,
    'thin-intersection': intersection_svg_3.ReactComponent,
    'thin-island-tropical': island_tropical_svg_3.ReactComponent,
    'thin-italic': italic_svg_3.ReactComponent,
    'thin-j': j_svg_3.ReactComponent,
    'thin-jack-o-lantern': jack_o_lantern_svg_3.ReactComponent,
    'thin-jedi': jedi_svg_3.ReactComponent,
    'thin-jet-fighter': jet_fighter_svg_3.ReactComponent,
    'thin-joint': joint_svg_3.ReactComponent,
    'thin-joystick': joystick_svg_3.ReactComponent,
    'thin-jug': jug_svg_3.ReactComponent,
    'thin-k': k_svg_3.ReactComponent,
    'thin-kaaba': kaaba_svg_3.ReactComponent,
    'thin-kazoo': kazoo_svg_3.ReactComponent,
    'thin-kerning': kerning_svg_3.ReactComponent,
    'thin-key-skeleton': key_skeleton_svg_3.ReactComponent,
    'thin-key': key_svg_3.ReactComponent,
    'thin-keyboard-down': keyboard_down_svg_3.ReactComponent,
    'thin-keyboard-left': keyboard_left_svg_3.ReactComponent,
    'thin-keyboard': keyboard_svg_3.ReactComponent,
    'thin-keynote': keynote_svg_3.ReactComponent,
    'thin-khanda': khanda_svg_3.ReactComponent,
    'thin-kidneys': kidneys_svg_3.ReactComponent,
    'thin-kip-sign': kip_sign_svg_3.ReactComponent,
    'thin-kit-medical': kit_medical_svg_3.ReactComponent,
    'thin-kite': kite_svg_3.ReactComponent,
    'thin-kiwi-bird': kiwi_bird_svg_3.ReactComponent,
    'thin-knife-kitchen': knife_kitchen_svg_3.ReactComponent,
    'thin-knife': knife_svg_3.ReactComponent,
    'thin-l': l_svg_3.ReactComponent,
    'thin-lambda': lambda_svg_3.ReactComponent,
    'thin-lamp-desk': lamp_desk_svg_3.ReactComponent,
    'thin-lamp-floor': lamp_floor_svg_3.ReactComponent,
    'thin-lamp-street': lamp_street_svg_3.ReactComponent,
    'thin-lamp': lamp_svg_3.ReactComponent,
    'thin-landmark-dome': landmark_dome_svg_3.ReactComponent,
    'thin-landmark': landmark_svg_3.ReactComponent,
    'thin-language': language_svg_3.ReactComponent,
    'thin-laptop-arrow-down': laptop_arrow_down_svg_3.ReactComponent,
    'thin-laptop-code': laptop_code_svg_3.ReactComponent,
    'thin-laptop-medical': laptop_medical_svg_3.ReactComponent,
    'thin-laptop-mobile': laptop_mobile_svg_3.ReactComponent,
    'thin-laptop-slash': laptop_slash_svg_3.ReactComponent,
    'thin-laptop': laptop_svg_3.ReactComponent,
    'thin-lari-sign': lari_sign_svg_3.ReactComponent,
    'thin-lasso-sparkles': lasso_sparkles_svg_3.ReactComponent,
    'thin-lasso': lasso_svg_3.ReactComponent,
    'thin-layers-minus': layers_minus_svg_3.ReactComponent,
    'thin-layers-plus': layers_plus_svg_3.ReactComponent,
    'thin-layers': layers_svg_3.ReactComponent,
    'thin-leaf-heart': leaf_heart_svg_3.ReactComponent,
    'thin-leaf-maple': leaf_maple_svg_3.ReactComponent,
    'thin-leaf-oak': leaf_oak_svg_3.ReactComponent,
    'thin-leaf': leaf_svg_3.ReactComponent,
    'thin-left-from-line': left_from_line_svg_3.ReactComponent,
    'thin-left-long': left_long_svg_3.ReactComponent,
    'thin-left-right': left_right_svg_3.ReactComponent,
    'thin-left-to-line': left_to_line_svg_3.ReactComponent,
    'thin-left': left_svg_3.ReactComponent,
    'thin-lemon': lemon_svg_3.ReactComponent,
    'thin-less-than-equal': less_than_equal_svg_3.ReactComponent,
    'thin-less-than': less_than_svg_3.ReactComponent,
    'thin-life-ring': life_ring_svg_3.ReactComponent,
    'thin-light-ceiling': light_ceiling_svg_3.ReactComponent,
    'thin-light-switch-off': light_switch_off_svg_3.ReactComponent,
    'thin-light-switch-on': light_switch_on_svg_3.ReactComponent,
    'thin-light-switch': light_switch_svg_3.ReactComponent,
    'thin-lightbulb-dollar': lightbulb_dollar_svg_3.ReactComponent,
    'thin-lightbulb-exclamation': lightbulb_exclamation_svg_3.ReactComponent,
    'thin-lightbulb-on': lightbulb_on_svg_3.ReactComponent,
    'thin-lightbulb-slash': lightbulb_slash_svg_3.ReactComponent,
    'thin-lightbulb': lightbulb_svg_3.ReactComponent,
    'thin-lights-holiday': lights_holiday_svg_3.ReactComponent,
    'thin-line-columns': line_columns_svg_3.ReactComponent,
    'thin-line-height': line_height_svg_3.ReactComponent,
    'thin-link-horizontal-slash': link_horizontal_slash_svg_3.ReactComponent,
    'thin-link-horizontal': link_horizontal_svg_3.ReactComponent,
    'thin-link-simple-slash': link_simple_slash_svg_3.ReactComponent,
    'thin-link-simple': link_simple_svg_3.ReactComponent,
    'thin-link-slash': link_slash_svg_3.ReactComponent,
    'thin-link': link_svg_3.ReactComponent,
    'thin-lips': lips_svg_3.ReactComponent,
    'thin-lira-sign': lira_sign_svg_3.ReactComponent,
    'thin-list-check': list_check_svg_3.ReactComponent,
    'thin-list-dropdown': list_dropdown_svg_3.ReactComponent,
    'thin-list-music': list_music_svg_3.ReactComponent,
    'thin-list-ol': list_ol_svg_3.ReactComponent,
    'thin-list-radio': list_radio_svg_3.ReactComponent,
    'thin-list-timeline': list_timeline_svg_3.ReactComponent,
    'thin-list-tree': list_tree_svg_3.ReactComponent,
    'thin-list-ul': list_ul_svg_3.ReactComponent,
    'thin-list': list_svg_3.ReactComponent,
    'thin-litecoin-sign': litecoin_sign_svg_3.ReactComponent,
    'thin-loader': loader_svg_3.ReactComponent,
    'thin-location-arrow': location_arrow_svg_3.ReactComponent,
    'thin-location-check': location_check_svg_3.ReactComponent,
    'thin-location-crosshairs-slash': location_crosshairs_slash_svg_3.ReactComponent,
    'thin-location-crosshairs': location_crosshairs_svg_3.ReactComponent,
    'thin-location-dot-slash': location_dot_slash_svg_3.ReactComponent,
    'thin-location-dot': location_dot_svg_3.ReactComponent,
    'thin-location-exclamation': location_exclamation_svg_3.ReactComponent,
    'thin-location-minus': location_minus_svg_3.ReactComponent,
    'thin-location-pen': location_pen_svg_3.ReactComponent,
    'thin-location-plus': location_plus_svg_3.ReactComponent,
    'thin-location-question': location_question_svg_3.ReactComponent,
    'thin-location-slash': location_slash_svg_3.ReactComponent,
    'thin-location-smile': location_smile_svg_3.ReactComponent,
    'thin-location-xmark': location_xmark_svg_3.ReactComponent,
    'thin-location': location_svg_3.ReactComponent,
    'thin-lock-keyhole-open': lock_keyhole_open_svg_3.ReactComponent,
    'thin-lock-keyhole': lock_keyhole_svg_3.ReactComponent,
    'thin-lock-open': lock_open_svg_3.ReactComponent,
    'thin-lock': lock_svg_3.ReactComponent,
    'thin-loveseat': loveseat_svg_3.ReactComponent,
    'thin-luchador-mask': luchador_mask_svg_3.ReactComponent,
    'thin-lungs-virus': lungs_virus_svg_3.ReactComponent,
    'thin-lungs': lungs_svg_3.ReactComponent,
    'thin-m': m_svg_3.ReactComponent,
    'thin-mace': mace_svg_3.ReactComponent,
    'thin-magnet': magnet_svg_3.ReactComponent,
    'thin-magnifying-glass-dollar': magnifying_glass_dollar_svg_3.ReactComponent,
    'thin-magnifying-glass-location': magnifying_glass_location_svg_3.ReactComponent,
    'thin-magnifying-glass-minus': magnifying_glass_minus_svg_3.ReactComponent,
    'thin-magnifying-glass-plus': magnifying_glass_plus_svg_3.ReactComponent,
    'thin-magnifying-glass': magnifying_glass_svg_3.ReactComponent,
    'thin-mailbox': mailbox_svg_3.ReactComponent,
    'thin-manat-sign': manat_sign_svg_3.ReactComponent,
    'thin-mandolin': mandolin_svg_3.ReactComponent,
    'thin-manhole': manhole_svg_3.ReactComponent,
    'thin-map-location-dot': map_location_dot_svg_3.ReactComponent,
    'thin-map-location': map_location_svg_3.ReactComponent,
    'thin-map-pin': map_pin_svg_3.ReactComponent,
    'thin-map': map_svg_3.ReactComponent,
    'thin-marker': marker_svg_3.ReactComponent,
    'thin-mars-double': mars_double_svg_3.ReactComponent,
    'thin-mars-stroke-right': mars_stroke_right_svg_3.ReactComponent,
    'thin-mars-stroke-up': mars_stroke_up_svg_3.ReactComponent,
    'thin-mars-stroke': mars_stroke_svg_3.ReactComponent,
    'thin-mars': mars_svg_3.ReactComponent,
    'thin-martini-glass-citrus': martini_glass_citrus_svg_3.ReactComponent,
    'thin-martini-glass-empty': martini_glass_empty_svg_3.ReactComponent,
    'thin-martini-glass': martini_glass_svg_3.ReactComponent,
    'thin-mask-face': mask_face_svg_3.ReactComponent,
    'thin-mask': mask_svg_3.ReactComponent,
    'thin-masks-theater': masks_theater_svg_3.ReactComponent,
    'thin-maximize': maximize_svg_3.ReactComponent,
    'thin-meat': meat_svg_3.ReactComponent,
    'thin-medal': medal_svg_3.ReactComponent,
    'thin-megaphone': megaphone_svg_3.ReactComponent,
    'thin-memo-circle-check': memo_circle_check_svg_3.ReactComponent,
    'thin-memo': memo_svg_3.ReactComponent,
    'thin-memory': memory_svg_3.ReactComponent,
    'thin-menorah': menorah_svg_3.ReactComponent,
    'thin-mercury': mercury_svg_3.ReactComponent,
    'thin-message-arrow-down': message_arrow_down_svg_3.ReactComponent,
    'thin-message-arrow-up-right': message_arrow_up_right_svg_3.ReactComponent,
    'thin-message-arrow-up': message_arrow_up_svg_3.ReactComponent,
    'thin-message-captions': message_captions_svg_3.ReactComponent,
    'thin-message-check': message_check_svg_3.ReactComponent,
    'thin-message-code': message_code_svg_3.ReactComponent,
    'thin-message-dollar': message_dollar_svg_3.ReactComponent,
    'thin-message-dots': message_dots_svg_3.ReactComponent,
    'thin-message-exclamation': message_exclamation_svg_3.ReactComponent,
    'thin-message-image': message_image_svg_3.ReactComponent,
    'thin-message-lines': message_lines_svg_3.ReactComponent,
    'thin-message-medical': message_medical_svg_3.ReactComponent,
    'thin-message-middle-top': message_middle_top_svg_3.ReactComponent,
    'thin-message-middle': message_middle_svg_3.ReactComponent,
    'thin-message-minus': message_minus_svg_3.ReactComponent,
    'thin-message-music': message_music_svg_3.ReactComponent,
    'thin-message-pen': message_pen_svg_3.ReactComponent,
    'thin-message-plus': message_plus_svg_3.ReactComponent,
    'thin-message-question': message_question_svg_3.ReactComponent,
    'thin-message-quote': message_quote_svg_3.ReactComponent,
    'thin-message-slash': message_slash_svg_3.ReactComponent,
    'thin-message-smile': message_smile_svg_3.ReactComponent,
    'thin-message-sms': message_sms_svg_3.ReactComponent,
    'thin-message-text': message_text_svg_3.ReactComponent,
    'thin-message-xmark': message_xmark_svg_3.ReactComponent,
    'thin-message': message_svg_3.ReactComponent,
    'thin-messages-dollar': messages_dollar_svg_3.ReactComponent,
    'thin-messages-question': messages_question_svg_3.ReactComponent,
    'thin-messages': messages_svg_3.ReactComponent,
    'thin-meteor': meteor_svg_3.ReactComponent,
    'thin-meter-bolt': meter_bolt_svg_3.ReactComponent,
    'thin-meter-droplet': meter_droplet_svg_3.ReactComponent,
    'thin-meter-fire': meter_fire_svg_3.ReactComponent,
    'thin-meter': meter_svg_3.ReactComponent,
    'thin-microchip-ai': microchip_ai_svg_3.ReactComponent,
    'thin-microchip': microchip_svg_3.ReactComponent,
    'thin-microphone-lines-slash': microphone_lines_slash_svg_3.ReactComponent,
    'thin-microphone-lines': microphone_lines_svg_3.ReactComponent,
    'thin-microphone-slash': microphone_slash_svg_3.ReactComponent,
    'thin-microphone-stand': microphone_stand_svg_3.ReactComponent,
    'thin-microphone': microphone_svg_3.ReactComponent,
    'thin-microscope': microscope_svg_3.ReactComponent,
    'thin-microwave': microwave_svg_3.ReactComponent,
    'thin-mill-sign': mill_sign_svg_3.ReactComponent,
    'thin-minimize': minimize_svg_3.ReactComponent,
    'thin-minus': minus_svg_3.ReactComponent,
    'thin-mistletoe': mistletoe_svg_3.ReactComponent,
    'thin-mitten': mitten_svg_3.ReactComponent,
    'thin-mobile-button': mobile_button_svg_3.ReactComponent,
    'thin-mobile-notch': mobile_notch_svg_3.ReactComponent,
    'thin-mobile-screen-button': mobile_screen_button_svg_3.ReactComponent,
    'thin-mobile-screen': mobile_screen_svg_3.ReactComponent,
    'thin-mobile': mobile_svg_3.ReactComponent,
    'thin-money-bill-1-wave': money_bill_1_wave_svg_3.ReactComponent,
    'thin-money-bill-1': money_bill_1_svg_3.ReactComponent,
    'thin-money-bill-simple-wave': money_bill_simple_wave_svg_3.ReactComponent,
    'thin-money-bill-simple': money_bill_simple_svg_3.ReactComponent,
    'thin-money-bill-wave': money_bill_wave_svg_3.ReactComponent,
    'thin-money-bill': money_bill_svg_3.ReactComponent,
    'thin-money-bills-simple': money_bills_simple_svg_3.ReactComponent,
    'thin-money-bills': money_bills_svg_3.ReactComponent,
    'thin-money-check-dollar-pen': money_check_dollar_pen_svg_3.ReactComponent,
    'thin-money-check-dollar': money_check_dollar_svg_3.ReactComponent,
    'thin-money-check-pen': money_check_pen_svg_3.ReactComponent,
    'thin-money-check': money_check_svg_3.ReactComponent,
    'thin-monitor-waveform': monitor_waveform_svg_3.ReactComponent,
    'thin-monkey': monkey_svg_3.ReactComponent,
    'thin-monument': monument_svg_3.ReactComponent,
    'thin-moon-cloud': moon_cloud_svg_3.ReactComponent,
    'thin-moon-over-sun': moon_over_sun_svg_3.ReactComponent,
    'thin-moon-stars': moon_stars_svg_3.ReactComponent,
    'thin-moon': moon_svg_3.ReactComponent,
    'thin-mortar-pestle': mortar_pestle_svg_3.ReactComponent,
    'thin-mosque': mosque_svg_3.ReactComponent,
    'thin-motorcycle': motorcycle_svg_3.ReactComponent,
    'thin-mountain': mountain_svg_3.ReactComponent,
    'thin-mountains': mountains_svg_3.ReactComponent,
    'thin-mp3-player': mp3_player_svg_3.ReactComponent,
    'thin-mug-hot': mug_hot_svg_3.ReactComponent,
    'thin-mug-marshmallows': mug_marshmallows_svg_3.ReactComponent,
    'thin-mug-saucer': mug_saucer_svg_3.ReactComponent,
    'thin-mug-tea-saucer': mug_tea_saucer_svg_3.ReactComponent,
    'thin-mug-tea': mug_tea_svg_3.ReactComponent,
    'thin-mug': mug_svg_3.ReactComponent,
    'thin-music-note-slash': music_note_slash_svg_3.ReactComponent,
    'thin-music-note': music_note_svg_3.ReactComponent,
    'thin-music-slash': music_slash_svg_3.ReactComponent,
    'thin-music': music_svg_3.ReactComponent,
    'thin-n': n_svg_3.ReactComponent,
    'thin-naira-sign': naira_sign_svg_3.ReactComponent,
    'thin-narwhal': narwhal_svg_3.ReactComponent,
    'thin-network-wired': network_wired_svg_3.ReactComponent,
    'thin-neuter': neuter_svg_3.ReactComponent,
    'thin-newspaper': newspaper_svg_3.ReactComponent,
    'thin-not-equal': not_equal_svg_3.ReactComponent,
    'thin-notdef': notdef_svg_3.ReactComponent,
    'thin-note-medical': note_medical_svg_3.ReactComponent,
    'thin-note-sticky': note_sticky_svg_3.ReactComponent,
    'thin-note': note_svg_3.ReactComponent,
    'thin-notes-medical': notes_medical_svg_3.ReactComponent,
    'thin-notes': notes_svg_3.ReactComponent,
    'thin-o': o_svg_3.ReactComponent,
    'thin-object-group': object_group_svg_3.ReactComponent,
    'thin-object-ungroup': object_ungroup_svg_3.ReactComponent,
    'thin-octagon-divide': octagon_divide_svg_3.ReactComponent,
    'thin-octagon-exclamation': octagon_exclamation_svg_3.ReactComponent,
    'thin-octagon-minus': octagon_minus_svg_3.ReactComponent,
    'thin-octagon-plus': octagon_plus_svg_3.ReactComponent,
    'thin-octagon-xmark': octagon_xmark_svg_3.ReactComponent,
    'thin-octagon': octagon_svg_3.ReactComponent,
    'thin-oil-can-drip': oil_can_drip_svg_3.ReactComponent,
    'thin-oil-can': oil_can_svg_3.ReactComponent,
    'thin-oil-temperature': oil_temperature_svg_3.ReactComponent,
    'thin-om': om_svg_3.ReactComponent,
    'thin-omega': omega_svg_3.ReactComponent,
    'thin-option': option_svg_3.ReactComponent,
    'thin-ornament': ornament_svg_3.ReactComponent,
    'thin-otter': otter_svg_3.ReactComponent,
    'thin-outdent': outdent_svg_3.ReactComponent,
    'thin-outlet': outlet_svg_3.ReactComponent,
    'thin-oven': oven_svg_3.ReactComponent,
    'thin-overline': overline_svg_3.ReactComponent,
    'thin-p': p_svg_3.ReactComponent,
    'thin-pager': pager_svg_3.ReactComponent,
    'thin-paint-brush-fine': paint_brush_fine_svg_3.ReactComponent,
    'thin-paint-brush': paint_brush_svg_3.ReactComponent,
    'thin-paint-roller': paint_roller_svg_3.ReactComponent,
    'thin-paintbrush-pencil': paintbrush_pencil_svg_3.ReactComponent,
    'thin-palette-boxes': palette_boxes_svg_3.ReactComponent,
    'thin-palette': palette_svg_3.ReactComponent,
    'thin-pallet-box': pallet_box_svg_3.ReactComponent,
    'thin-pallet-boxes': pallet_boxes_svg_3.ReactComponent,
    'thin-pallet': pallet_svg_3.ReactComponent,
    'thin-panorama': panorama_svg_3.ReactComponent,
    'thin-paper-plane-top': paper_plane_top_svg_3.ReactComponent,
    'thin-paper-plane': paper_plane_svg_3.ReactComponent,
    'thin-paperclip': paperclip_svg_3.ReactComponent,
    'thin-parachute-box': parachute_box_svg_3.ReactComponent,
    'thin-paragraph-left': paragraph_left_svg_3.ReactComponent,
    'thin-paragraph': paragraph_svg_3.ReactComponent,
    'thin-passport': passport_svg_3.ReactComponent,
    'thin-paste': paste_svg_3.ReactComponent,
    'thin-pause': pause_svg_3.ReactComponent,
    'thin-paw-claws': paw_claws_svg_3.ReactComponent,
    'thin-paw-simple': paw_simple_svg_3.ReactComponent,
    'thin-paw': paw_svg_3.ReactComponent,
    'thin-peace': peace_svg_3.ReactComponent,
    'thin-peach': peach_svg_3.ReactComponent,
    'thin-pear': pear_svg_3.ReactComponent,
    'thin-pedestal': pedestal_svg_3.ReactComponent,
    'thin-pegasus': pegasus_svg_3.ReactComponent,
    'thin-pen-circle': pen_circle_svg_3.ReactComponent,
    'thin-pen-clip-slash': pen_clip_slash_svg_3.ReactComponent,
    'thin-pen-clip': pen_clip_svg_3.ReactComponent,
    'thin-pen-fancy-slash': pen_fancy_slash_svg_3.ReactComponent,
    'thin-pen-fancy': pen_fancy_svg_3.ReactComponent,
    'thin-pen-field': pen_field_svg_3.ReactComponent,
    'thin-pen-line': pen_line_svg_3.ReactComponent,
    'thin-pen-nib': pen_nib_svg_3.ReactComponent,
    'thin-pen-paintbrush': pen_paintbrush_svg_3.ReactComponent,
    'thin-pen-ruler': pen_ruler_svg_3.ReactComponent,
    'thin-pen-slash': pen_slash_svg_3.ReactComponent,
    'thin-pen-swirl': pen_swirl_svg_3.ReactComponent,
    'thin-pen-to-square': pen_to_square_svg_3.ReactComponent,
    'thin-pen': pen_svg_3.ReactComponent,
    'thin-pencil-slash': pencil_slash_svg_3.ReactComponent,
    'thin-pencil': pencil_svg_3.ReactComponent,
    'thin-people-arrows-left-right': people_arrows_left_right_svg_3.ReactComponent,
    'thin-people-carry-box': people_carry_box_svg_3.ReactComponent,
    'thin-pepper-hot': pepper_hot_svg_3.ReactComponent,
    'thin-percent': percent_svg_3.ReactComponent,
    'thin-person-biking-mountain': person_biking_mountain_svg_3.ReactComponent,
    'thin-person-biking': person_biking_svg_3.ReactComponent,
    'thin-person-booth': person_booth_svg_3.ReactComponent,
    'thin-person-carry-box': person_carry_box_svg_3.ReactComponent,
    'thin-person-digging': person_digging_svg_3.ReactComponent,
    'thin-person-dolly-empty': person_dolly_empty_svg_3.ReactComponent,
    'thin-person-dolly': person_dolly_svg_3.ReactComponent,
    'thin-person-dots-from-line': person_dots_from_line_svg_3.ReactComponent,
    'thin-person-dress-simple': person_dress_simple_svg_3.ReactComponent,
    'thin-person-dress': person_dress_svg_3.ReactComponent,
    'thin-person-from-portal': person_from_portal_svg_3.ReactComponent,
    'thin-person-hiking': person_hiking_svg_3.ReactComponent,
    'thin-person-pinball': person_pinball_svg_3.ReactComponent,
    'thin-person-praying': person_praying_svg_3.ReactComponent,
    'thin-person-running': person_running_svg_3.ReactComponent,
    'thin-person-seat-reclined': person_seat_reclined_svg_3.ReactComponent,
    'thin-person-seat': person_seat_svg_3.ReactComponent,
    'thin-person-sign': person_sign_svg_3.ReactComponent,
    'thin-person-simple': person_simple_svg_3.ReactComponent,
    'thin-person-skating': person_skating_svg_3.ReactComponent,
    'thin-person-ski-jumping': person_ski_jumping_svg_3.ReactComponent,
    'thin-person-ski-lift': person_ski_lift_svg_3.ReactComponent,
    'thin-person-skiing-nordic': person_skiing_nordic_svg_3.ReactComponent,
    'thin-person-skiing': person_skiing_svg_3.ReactComponent,
    'thin-person-sledding': person_sledding_svg_3.ReactComponent,
    'thin-person-snowboarding': person_snowboarding_svg_3.ReactComponent,
    'thin-person-snowmobiling': person_snowmobiling_svg_3.ReactComponent,
    'thin-person-swimming': person_swimming_svg_3.ReactComponent,
    'thin-person-to-portal': person_to_portal_svg_3.ReactComponent,
    'thin-person-walking-with-cane': person_walking_with_cane_svg_3.ReactComponent,
    'thin-person-walking': person_walking_svg_3.ReactComponent,
    'thin-person': person_svg_3.ReactComponent,
    'thin-peseta-sign': peseta_sign_svg_3.ReactComponent,
    'thin-peso-sign': peso_sign_svg_3.ReactComponent,
    'thin-phone-arrow-down-left': phone_arrow_down_left_svg_3.ReactComponent,
    'thin-phone-arrow-up-right': phone_arrow_up_right_svg_3.ReactComponent,
    'thin-phone-flip': phone_flip_svg_3.ReactComponent,
    'thin-phone-hangup': phone_hangup_svg_3.ReactComponent,
    'thin-phone-missed': phone_missed_svg_3.ReactComponent,
    'thin-phone-office': phone_office_svg_3.ReactComponent,
    'thin-phone-plus': phone_plus_svg_3.ReactComponent,
    'thin-phone-rotary': phone_rotary_svg_3.ReactComponent,
    'thin-phone-slash': phone_slash_svg_3.ReactComponent,
    'thin-phone-volume': phone_volume_svg_3.ReactComponent,
    'thin-phone-xmark': phone_xmark_svg_3.ReactComponent,
    'thin-phone': phone_svg_3.ReactComponent,
    'thin-photo-film-music': photo_film_music_svg_3.ReactComponent,
    'thin-photo-film': photo_film_svg_3.ReactComponent,
    'thin-pi': pi_svg_3.ReactComponent,
    'thin-piano-keyboard': piano_keyboard_svg_3.ReactComponent,
    'thin-piano': piano_svg_3.ReactComponent,
    'thin-pie': pie_svg_3.ReactComponent,
    'thin-pig': pig_svg_3.ReactComponent,
    'thin-piggy-bank': piggy_bank_svg_3.ReactComponent,
    'thin-pills': pills_svg_3.ReactComponent,
    'thin-pinball': pinball_svg_3.ReactComponent,
    'thin-pizza-slice': pizza_slice_svg_3.ReactComponent,
    'thin-pizza': pizza_svg_3.ReactComponent,
    'thin-place-of-worship': place_of_worship_svg_3.ReactComponent,
    'thin-plane-arrival': plane_arrival_svg_3.ReactComponent,
    'thin-plane-departure': plane_departure_svg_3.ReactComponent,
    'thin-plane-engines': plane_engines_svg_3.ReactComponent,
    'thin-plane-prop': plane_prop_svg_3.ReactComponent,
    'thin-plane-slash': plane_slash_svg_3.ReactComponent,
    'thin-plane-tail': plane_tail_svg_3.ReactComponent,
    'thin-plane-up-slash': plane_up_slash_svg_3.ReactComponent,
    'thin-plane-up': plane_up_svg_3.ReactComponent,
    'thin-plane': plane_svg_3.ReactComponent,
    'thin-planet-moon': planet_moon_svg_3.ReactComponent,
    'thin-planet-ringed': planet_ringed_svg_3.ReactComponent,
    'thin-play-pause': play_pause_svg_3.ReactComponent,
    'thin-play': play_svg_3.ReactComponent,
    'thin-plug': plug_svg_3.ReactComponent,
    'thin-plus-minus': plus_minus_svg_3.ReactComponent,
    'thin-plus': plus_svg_3.ReactComponent,
    'thin-podcast': podcast_svg_3.ReactComponent,
    'thin-podium-star': podium_star_svg_3.ReactComponent,
    'thin-podium': podium_svg_3.ReactComponent,
    'thin-police-box': police_box_svg_3.ReactComponent,
    'thin-poll-people': poll_people_svg_3.ReactComponent,
    'thin-poo-bolt': poo_bolt_svg_3.ReactComponent,
    'thin-poo': poo_svg_3.ReactComponent,
    'thin-poop': poop_svg_3.ReactComponent,
    'thin-popcorn': popcorn_svg_3.ReactComponent,
    'thin-power-off': power_off_svg_3.ReactComponent,
    'thin-prescription-bottle-medical': prescription_bottle_medical_svg_3.ReactComponent,
    'thin-prescription-bottle': prescription_bottle_svg_3.ReactComponent,
    'thin-prescription': prescription_svg_3.ReactComponent,
    'thin-presentation-screen': presentation_screen_svg_3.ReactComponent,
    'thin-print-magnifying-glass': print_magnifying_glass_svg_3.ReactComponent,
    'thin-print-slash': print_slash_svg_3.ReactComponent,
    'thin-print': print_svg_3.ReactComponent,
    'thin-projector': projector_svg_3.ReactComponent,
    'thin-pump-medical': pump_medical_svg_3.ReactComponent,
    'thin-pump-soap': pump_soap_svg_3.ReactComponent,
    'thin-pumpkin': pumpkin_svg_3.ReactComponent,
    'thin-puzzle-piece-simple': puzzle_piece_simple_svg_3.ReactComponent,
    'thin-puzzle-piece': puzzle_piece_svg_3.ReactComponent,
    'thin-q': q_svg_3.ReactComponent,
    'thin-qrcode': qrcode_svg_3.ReactComponent,
    'thin-question': question_svg_3.ReactComponent,
    'thin-quidditch-broom-ball': quidditch_broom_ball_svg_3.ReactComponent,
    'thin-quote-left-round': quote_left_round_svg_3.ReactComponent,
    'thin-quote-left': quote_left_svg_3.ReactComponent,
    'thin-quote-right-round': quote_right_round_svg_3.ReactComponent,
    'thin-quote-right': quote_right_svg_3.ReactComponent,
    'thin-r': r_svg_3.ReactComponent,
    'thin-rabbit-running': rabbit_running_svg_3.ReactComponent,
    'thin-rabbit': rabbit_svg_3.ReactComponent,
    'thin-racquet': racquet_svg_3.ReactComponent,
    'thin-radar': radar_svg_3.ReactComponent,
    'thin-radiation': radiation_svg_3.ReactComponent,
    'thin-radio-tuner': radio_tuner_svg_3.ReactComponent,
    'thin-radio': radio_svg_3.ReactComponent,
    'thin-rainbow': rainbow_svg_3.ReactComponent,
    'thin-raindrops': raindrops_svg_3.ReactComponent,
    'thin-ram': ram_svg_3.ReactComponent,
    'thin-ramp-loading': ramp_loading_svg_3.ReactComponent,
    'thin-raygun': raygun_svg_3.ReactComponent,
    'thin-receipt': receipt_svg_3.ReactComponent,
    'thin-record-vinyl': record_vinyl_svg_3.ReactComponent,
    'thin-rectangle-ad': rectangle_ad_svg_3.ReactComponent,
    'thin-rectangle-barcode': rectangle_barcode_svg_3.ReactComponent,
    'thin-rectangle-list': rectangle_list_svg_3.ReactComponent,
    'thin-rectangle-terminal': rectangle_terminal_svg_3.ReactComponent,
    'thin-rectangle-vertical-history': rectangle_vertical_history_svg_3.ReactComponent,
    'thin-rectangle-vertical': rectangle_vertical_svg_3.ReactComponent,
    'thin-rectangle-wide': rectangle_wide_svg_3.ReactComponent,
    'thin-rectangle-xmark': rectangle_xmark_svg_3.ReactComponent,
    'thin-rectangle': rectangle_svg_3.ReactComponent,
    'thin-recycle': recycle_svg_3.ReactComponent,
    'thin-refrigerator': refrigerator_svg_3.ReactComponent,
    'thin-registered': registered_svg_3.ReactComponent,
    'thin-repeat-1': repeat_1_svg_3.ReactComponent,
    'thin-repeat': repeat_svg_3.ReactComponent,
    'thin-reply-all': reply_all_svg_3.ReactComponent,
    'thin-reply-clock': reply_clock_svg_3.ReactComponent,
    'thin-reply': reply_svg_3.ReactComponent,
    'thin-republican': republican_svg_3.ReactComponent,
    'thin-restroom-simple': restroom_simple_svg_3.ReactComponent,
    'thin-restroom': restroom_svg_3.ReactComponent,
    'thin-retweet': retweet_svg_3.ReactComponent,
    'thin-rhombus': rhombus_svg_3.ReactComponent,
    'thin-ribbon': ribbon_svg_3.ReactComponent,
    'thin-right-from-bracket': right_from_bracket_svg_3.ReactComponent,
    'thin-right-from-line': right_from_line_svg_3.ReactComponent,
    'thin-right-left': right_left_svg_3.ReactComponent,
    'thin-right-long': right_long_svg_3.ReactComponent,
    'thin-right-to-bracket': right_to_bracket_svg_3.ReactComponent,
    'thin-right-to-line': right_to_line_svg_3.ReactComponent,
    'thin-right': right_svg_3.ReactComponent,
    'thin-ring': ring_svg_3.ReactComponent,
    'thin-rings-wedding': rings_wedding_svg_3.ReactComponent,
    'thin-road': road_svg_3.ReactComponent,
    'thin-robot': robot_svg_3.ReactComponent,
    'thin-rocket-launch': rocket_launch_svg_3.ReactComponent,
    'thin-rocket': rocket_svg_3.ReactComponent,
    'thin-rotate-exclamation': rotate_exclamation_svg_3.ReactComponent,
    'thin-rotate-forward': rotate_forward_svg_3.ReactComponent,
    'thin-rotate-left': rotate_left_svg_3.ReactComponent,
    'thin-rotate': rotate_svg_3.ReactComponent,
    'thin-route-highway': route_highway_svg_3.ReactComponent,
    'thin-route-interstate': route_interstate_svg_3.ReactComponent,
    'thin-route': route_svg_3.ReactComponent,
    'thin-router': router_svg_3.ReactComponent,
    'thin-rss': rss_svg_3.ReactComponent,
    'thin-ruble-sign': ruble_sign_svg_3.ReactComponent,
    'thin-ruler-combined': ruler_combined_svg_3.ReactComponent,
    'thin-ruler-horizontal': ruler_horizontal_svg_3.ReactComponent,
    'thin-ruler-triangle': ruler_triangle_svg_3.ReactComponent,
    'thin-ruler-vertical': ruler_vertical_svg_3.ReactComponent,
    'thin-ruler': ruler_svg_3.ReactComponent,
    'thin-rupee-sign': rupee_sign_svg_3.ReactComponent,
    'thin-rupiah-sign': rupiah_sign_svg_3.ReactComponent,
    'thin-rv': rv_svg_3.ReactComponent,
    'thin-s': s_svg_3.ReactComponent,
    'thin-sack-dollar': sack_dollar_svg_3.ReactComponent,
    'thin-sack': sack_svg_3.ReactComponent,
    'thin-salad': salad_svg_3.ReactComponent,
    'thin-sandwich': sandwich_svg_3.ReactComponent,
    'thin-satellite-dish': satellite_dish_svg_3.ReactComponent,
    'thin-satellite': satellite_svg_3.ReactComponent,
    'thin-sausage': sausage_svg_3.ReactComponent,
    'thin-saxophone-fire': saxophone_fire_svg_3.ReactComponent,
    'thin-saxophone': saxophone_svg_3.ReactComponent,
    'thin-scale-balanced': scale_balanced_svg_3.ReactComponent,
    'thin-scale-unbalanced-flip': scale_unbalanced_flip_svg_3.ReactComponent,
    'thin-scale-unbalanced': scale_unbalanced_svg_3.ReactComponent,
    'thin-scalpel-line-dashed': scalpel_line_dashed_svg_3.ReactComponent,
    'thin-scalpel': scalpel_svg_3.ReactComponent,
    'thin-scanner-gun': scanner_gun_svg_3.ReactComponent,
    'thin-scanner-keyboard': scanner_keyboard_svg_3.ReactComponent,
    'thin-scanner-touchscreen': scanner_touchscreen_svg_3.ReactComponent,
    'thin-scanner': scanner_svg_3.ReactComponent,
    'thin-scarecrow': scarecrow_svg_3.ReactComponent,
    'thin-scarf': scarf_svg_3.ReactComponent,
    'thin-school': school_svg_3.ReactComponent,
    'thin-scissors': scissors_svg_3.ReactComponent,
    'thin-screen-users': screen_users_svg_3.ReactComponent,
    'thin-screencast': screencast_svg_3.ReactComponent,
    'thin-screwdriver-wrench': screwdriver_wrench_svg_3.ReactComponent,
    'thin-screwdriver': screwdriver_svg_3.ReactComponent,
    'thin-scribble': scribble_svg_3.ReactComponent,
    'thin-scroll-old': scroll_old_svg_3.ReactComponent,
    'thin-scroll-torah': scroll_torah_svg_3.ReactComponent,
    'thin-scroll': scroll_svg_3.ReactComponent,
    'thin-scrubber': scrubber_svg_3.ReactComponent,
    'thin-scythe': scythe_svg_3.ReactComponent,
    'thin-sd-card': sd_card_svg_3.ReactComponent,
    'thin-sd-cards': sd_cards_svg_3.ReactComponent,
    'thin-seal-exclamation': seal_exclamation_svg_3.ReactComponent,
    'thin-seal-question': seal_question_svg_3.ReactComponent,
    'thin-seal': seal_svg_3.ReactComponent,
    'thin-seat-airline': seat_airline_svg_3.ReactComponent,
    'thin-section': section_svg_3.ReactComponent,
    'thin-seedling': seedling_svg_3.ReactComponent,
    'thin-send-back': send_back_svg_3.ReactComponent,
    'thin-send-backward': send_backward_svg_3.ReactComponent,
    'thin-sensor-cloud': sensor_cloud_svg_3.ReactComponent,
    'thin-sensor-fire': sensor_fire_svg_3.ReactComponent,
    'thin-sensor-on': sensor_on_svg_3.ReactComponent,
    'thin-sensor-triangle-exclamation': sensor_triangle_exclamation_svg_3.ReactComponent,
    'thin-sensor': sensor_svg_3.ReactComponent,
    'thin-server': server_svg_3.ReactComponent,
    'thin-shapes': shapes_svg_3.ReactComponent,
    'thin-share-all': share_all_svg_3.ReactComponent,
    'thin-share-from-square': share_from_square_svg_3.ReactComponent,
    'thin-share-nodes': share_nodes_svg_3.ReactComponent,
    'thin-share': share_svg_3.ReactComponent,
    'thin-sheep': sheep_svg_3.ReactComponent,
    'thin-shekel-sign': shekel_sign_svg_3.ReactComponent,
    'thin-shelves-empty': shelves_empty_svg_3.ReactComponent,
    'thin-shelves': shelves_svg_3.ReactComponent,
    'thin-shield-blank': shield_blank_svg_3.ReactComponent,
    'thin-shield-check': shield_check_svg_3.ReactComponent,
    'thin-shield-cross': shield_cross_svg_3.ReactComponent,
    'thin-shield-exclamation': shield_exclamation_svg_3.ReactComponent,
    'thin-shield-keyhole': shield_keyhole_svg_3.ReactComponent,
    'thin-shield-minus': shield_minus_svg_3.ReactComponent,
    'thin-shield-plus': shield_plus_svg_3.ReactComponent,
    'thin-shield-slash': shield_slash_svg_3.ReactComponent,
    'thin-shield-virus': shield_virus_svg_3.ReactComponent,
    'thin-shield-xmark': shield_xmark_svg_3.ReactComponent,
    'thin-shield': shield_svg_3.ReactComponent,
    'thin-ship': ship_svg_3.ReactComponent,
    'thin-shish-kebab': shish_kebab_svg_3.ReactComponent,
    'thin-shoe-prints': shoe_prints_svg_3.ReactComponent,
    'thin-shop-slash': shop_slash_svg_3.ReactComponent,
    'thin-shop': shop_svg_3.ReactComponent,
    'thin-shovel-snow': shovel_snow_svg_3.ReactComponent,
    'thin-shovel': shovel_svg_3.ReactComponent,
    'thin-shower-down': shower_down_svg_3.ReactComponent,
    'thin-shower': shower_svg_3.ReactComponent,
    'thin-shredder': shredder_svg_3.ReactComponent,
    'thin-shuffle': shuffle_svg_3.ReactComponent,
    'thin-shuttle-space': shuttle_space_svg_3.ReactComponent,
    'thin-shuttlecock': shuttlecock_svg_3.ReactComponent,
    'thin-sickle': sickle_svg_3.ReactComponent,
    'thin-sidebar-flip': sidebar_flip_svg_3.ReactComponent,
    'thin-sidebar': sidebar_svg_3.ReactComponent,
    'thin-sigma': sigma_svg_3.ReactComponent,
    'thin-sign-hanging': sign_hanging_svg_3.ReactComponent,
    'thin-signal-bars-fair': signal_bars_fair_svg_3.ReactComponent,
    'thin-signal-bars-good': signal_bars_good_svg_3.ReactComponent,
    'thin-signal-bars-slash': signal_bars_slash_svg_3.ReactComponent,
    'thin-signal-bars-weak': signal_bars_weak_svg_3.ReactComponent,
    'thin-signal-bars': signal_bars_svg_3.ReactComponent,
    'thin-signal-fair': signal_fair_svg_3.ReactComponent,
    'thin-signal-good': signal_good_svg_3.ReactComponent,
    'thin-signal-slash': signal_slash_svg_3.ReactComponent,
    'thin-signal-stream-slash': signal_stream_slash_svg_3.ReactComponent,
    'thin-signal-stream': signal_stream_svg_3.ReactComponent,
    'thin-signal-strong': signal_strong_svg_3.ReactComponent,
    'thin-signal-weak': signal_weak_svg_3.ReactComponent,
    'thin-signal': signal_svg_3.ReactComponent,
    'thin-signature': signature_svg_3.ReactComponent,
    'thin-signs-post': signs_post_svg_3.ReactComponent,
    'thin-sim-card': sim_card_svg_3.ReactComponent,
    'thin-sim-cards': sim_cards_svg_3.ReactComponent,
    'thin-sink': sink_svg_3.ReactComponent,
    'thin-siren-on': siren_on_svg_3.ReactComponent,
    'thin-siren': siren_svg_3.ReactComponent,
    'thin-sitemap': sitemap_svg_3.ReactComponent,
    'thin-skeleton': skeleton_svg_3.ReactComponent,
    'thin-skull-cow': skull_cow_svg_3.ReactComponent,
    'thin-skull-crossbones': skull_crossbones_svg_3.ReactComponent,
    'thin-skull': skull_svg_3.ReactComponent,
    'thin-slash': slash_svg_3.ReactComponent,
    'thin-sleigh': sleigh_svg_3.ReactComponent,
    'thin-slider': slider_svg_3.ReactComponent,
    'thin-sliders-up': sliders_up_svg_3.ReactComponent,
    'thin-sliders': sliders_svg_3.ReactComponent,
    'thin-smog': smog_svg_3.ReactComponent,
    'thin-smoke': smoke_svg_3.ReactComponent,
    'thin-smoking': smoking_svg_3.ReactComponent,
    'thin-snake': snake_svg_3.ReactComponent,
    'thin-snooze': snooze_svg_3.ReactComponent,
    'thin-snow-blowing': snow_blowing_svg_3.ReactComponent,
    'thin-snowflake': snowflake_svg_3.ReactComponent,
    'thin-snowflakes': snowflakes_svg_3.ReactComponent,
    'thin-snowman-head': snowman_head_svg_3.ReactComponent,
    'thin-snowman': snowman_svg_3.ReactComponent,
    'thin-snowplow': snowplow_svg_3.ReactComponent,
    'thin-soap': soap_svg_3.ReactComponent,
    'thin-socks': socks_svg_3.ReactComponent,
    'thin-solar-panel': solar_panel_svg_3.ReactComponent,
    'thin-solar-system': solar_system_svg_3.ReactComponent,
    'thin-sort-down': sort_down_svg_3.ReactComponent,
    'thin-sort-up': sort_up_svg_3.ReactComponent,
    'thin-sort': sort_svg_3.ReactComponent,
    'thin-spa': spa_svg_3.ReactComponent,
    'thin-space-station-moon-construction': space_station_moon_construction_svg_3.ReactComponent,
    'thin-space-station-moon': space_station_moon_svg_3.ReactComponent,
    'thin-spade': spade_svg_3.ReactComponent,
    'thin-spaghetti-monster-flying': spaghetti_monster_flying_svg_3.ReactComponent,
    'thin-sparkles': sparkles_svg_3.ReactComponent,
    'thin-speaker': speaker_svg_3.ReactComponent,
    'thin-speakers': speakers_svg_3.ReactComponent,
    'thin-spell-check': spell_check_svg_3.ReactComponent,
    'thin-spider-black-widow': spider_black_widow_svg_3.ReactComponent,
    'thin-spider-web': spider_web_svg_3.ReactComponent,
    'thin-spider': spider_svg_3.ReactComponent,
    'thin-spinner-third': spinner_third_svg_3.ReactComponent,
    'thin-spinner': spinner_svg_3.ReactComponent,
    'thin-split': split_svg_3.ReactComponent,
    'thin-splotch': splotch_svg_3.ReactComponent,
    'thin-spoon': spoon_svg_3.ReactComponent,
    'thin-spray-can': spray_can_svg_3.ReactComponent,
    'thin-sprinkler': sprinkler_svg_3.ReactComponent,
    'thin-square-0': square_0_svg_3.ReactComponent,
    'thin-square-1': square_1_svg_3.ReactComponent,
    'thin-square-2': square_2_svg_3.ReactComponent,
    'thin-square-3': square_3_svg_3.ReactComponent,
    'thin-square-4': square_4_svg_3.ReactComponent,
    'thin-square-5': square_5_svg_3.ReactComponent,
    'thin-square-6': square_6_svg_3.ReactComponent,
    'thin-square-7': square_7_svg_3.ReactComponent,
    'thin-square-8': square_8_svg_3.ReactComponent,
    'thin-square-9': square_9_svg_3.ReactComponent,
    'thin-square-a': square_a_svg_3.ReactComponent,
    'thin-square-ampersand': square_ampersand_svg_3.ReactComponent,
    'thin-square-arrow-down-left': square_arrow_down_left_svg_3.ReactComponent,
    'thin-square-arrow-down-right': square_arrow_down_right_svg_3.ReactComponent,
    'thin-square-arrow-down': square_arrow_down_svg_3.ReactComponent,
    'thin-square-arrow-left': square_arrow_left_svg_3.ReactComponent,
    'thin-square-arrow-right': square_arrow_right_svg_3.ReactComponent,
    'thin-square-arrow-up-left': square_arrow_up_left_svg_3.ReactComponent,
    'thin-square-arrow-up-right': square_arrow_up_right_svg_3.ReactComponent,
    'thin-square-arrow-up': square_arrow_up_svg_3.ReactComponent,
    'thin-square-b': square_b_svg_3.ReactComponent,
    'thin-square-bolt': square_bolt_svg_3.ReactComponent,
    'thin-square-c': square_c_svg_3.ReactComponent,
    'thin-square-caret-down': square_caret_down_svg_3.ReactComponent,
    'thin-square-caret-left': square_caret_left_svg_3.ReactComponent,
    'thin-square-caret-right': square_caret_right_svg_3.ReactComponent,
    'thin-square-caret-up': square_caret_up_svg_3.ReactComponent,
    'thin-square-check': square_check_svg_3.ReactComponent,
    'thin-square-chevron-down': square_chevron_down_svg_3.ReactComponent,
    'thin-square-chevron-left': square_chevron_left_svg_3.ReactComponent,
    'thin-square-chevron-right': square_chevron_right_svg_3.ReactComponent,
    'thin-square-chevron-up': square_chevron_up_svg_3.ReactComponent,
    'thin-square-code': square_code_svg_3.ReactComponent,
    'thin-square-d': square_d_svg_3.ReactComponent,
    'thin-square-dashed': square_dashed_svg_3.ReactComponent,
    'thin-square-divide': square_divide_svg_3.ReactComponent,
    'thin-square-dollar': square_dollar_svg_3.ReactComponent,
    'thin-square-down-left': square_down_left_svg_3.ReactComponent,
    'thin-square-down-right': square_down_right_svg_3.ReactComponent,
    'thin-square-down': square_down_svg_3.ReactComponent,
    'thin-square-e': square_e_svg_3.ReactComponent,
    'thin-square-envelope': square_envelope_svg_3.ReactComponent,
    'thin-square-exclamation': square_exclamation_svg_3.ReactComponent,
    'thin-square-f': square_f_svg_3.ReactComponent,
    'thin-square-fragile': square_fragile_svg_3.ReactComponent,
    'thin-square-full': square_full_svg_3.ReactComponent,
    'thin-square-g': square_g_svg_3.ReactComponent,
    'thin-square-h': square_h_svg_3.ReactComponent,
    'thin-square-heart': square_heart_svg_3.ReactComponent,
    'thin-square-i': square_i_svg_3.ReactComponent,
    'thin-square-info': square_info_svg_3.ReactComponent,
    'thin-square-j': square_j_svg_3.ReactComponent,
    'thin-square-k': square_k_svg_3.ReactComponent,
    'thin-square-l': square_l_svg_3.ReactComponent,
    'thin-square-left': square_left_svg_3.ReactComponent,
    'thin-square-m': square_m_svg_3.ReactComponent,
    'thin-square-minus': square_minus_svg_3.ReactComponent,
    'thin-square-n': square_n_svg_3.ReactComponent,
    'thin-square-o': square_o_svg_3.ReactComponent,
    'thin-square-p': square_p_svg_3.ReactComponent,
    'thin-square-parking-slash': square_parking_slash_svg_3.ReactComponent,
    'thin-square-parking': square_parking_svg_3.ReactComponent,
    'thin-square-pen': square_pen_svg_3.ReactComponent,
    'thin-square-phone-flip': square_phone_flip_svg_3.ReactComponent,
    'thin-square-phone-hangup': square_phone_hangup_svg_3.ReactComponent,
    'thin-square-phone': square_phone_svg_3.ReactComponent,
    'thin-square-plus': square_plus_svg_3.ReactComponent,
    'thin-square-poll-horizontal': square_poll_horizontal_svg_3.ReactComponent,
    'thin-square-poll-vertical': square_poll_vertical_svg_3.ReactComponent,
    'thin-square-q': square_q_svg_3.ReactComponent,
    'thin-square-question': square_question_svg_3.ReactComponent,
    'thin-square-r': square_r_svg_3.ReactComponent,
    'thin-square-right': square_right_svg_3.ReactComponent,
    'thin-square-root-variable': square_root_variable_svg_3.ReactComponent,
    'thin-square-root': square_root_svg_3.ReactComponent,
    'thin-square-rss': square_rss_svg_3.ReactComponent,
    'thin-square-s': square_s_svg_3.ReactComponent,
    'thin-square-share-nodes': square_share_nodes_svg_3.ReactComponent,
    'thin-square-sliders-vertical': square_sliders_vertical_svg_3.ReactComponent,
    'thin-square-sliders': square_sliders_svg_3.ReactComponent,
    'thin-square-small': square_small_svg_3.ReactComponent,
    'thin-square-star': square_star_svg_3.ReactComponent,
    'thin-square-t': square_t_svg_3.ReactComponent,
    'thin-square-this-way-up': square_this_way_up_svg_3.ReactComponent,
    'thin-square-u': square_u_svg_3.ReactComponent,
    'thin-square-up-left': square_up_left_svg_3.ReactComponent,
    'thin-square-up-right': square_up_right_svg_3.ReactComponent,
    'thin-square-up': square_up_svg_3.ReactComponent,
    'thin-square-user': square_user_svg_3.ReactComponent,
    'thin-square-v': square_v_svg_3.ReactComponent,
    'thin-square-w': square_w_svg_3.ReactComponent,
    'thin-square-x': square_x_svg_3.ReactComponent,
    'thin-square-xmark': square_xmark_svg_3.ReactComponent,
    'thin-square-y': square_y_svg_3.ReactComponent,
    'thin-square-z': square_z_svg_3.ReactComponent,
    'thin-square': square_svg_3.ReactComponent,
    'thin-squirrel': squirrel_svg_3.ReactComponent,
    'thin-staff': staff_svg_3.ReactComponent,
    'thin-stairs': stairs_svg_3.ReactComponent,
    'thin-stamp': stamp_svg_3.ReactComponent,
    'thin-standard-definition': standard_definition_svg_3.ReactComponent,
    'thin-star-and-crescent': star_and_crescent_svg_3.ReactComponent,
    'thin-star-christmas': star_christmas_svg_3.ReactComponent,
    'thin-star-exclamation': star_exclamation_svg_3.ReactComponent,
    'thin-star-half-stroke': star_half_stroke_svg_3.ReactComponent,
    'thin-star-half': star_half_svg_3.ReactComponent,
    'thin-star-of-david': star_of_david_svg_3.ReactComponent,
    'thin-star-of-life': star_of_life_svg_3.ReactComponent,
    'thin-star-sharp-half-stroke': star_sharp_half_stroke_svg_3.ReactComponent,
    'thin-star-sharp-half': star_sharp_half_svg_3.ReactComponent,
    'thin-star-sharp': star_sharp_svg_3.ReactComponent,
    'thin-star-shooting': star_shooting_svg_3.ReactComponent,
    'thin-star': star_svg_3.ReactComponent,
    'thin-starfighter-twin-ion-engine-advanced': starfighter_twin_ion_engine_advanced_svg_3.ReactComponent,
    'thin-starfighter-twin-ion-engine': starfighter_twin_ion_engine_svg_3.ReactComponent,
    'thin-starfighter': starfighter_svg_3.ReactComponent,
    'thin-stars': stars_svg_3.ReactComponent,
    'thin-starship-freighter': starship_freighter_svg_3.ReactComponent,
    'thin-starship': starship_svg_3.ReactComponent,
    'thin-steak': steak_svg_3.ReactComponent,
    'thin-steering-wheel': steering_wheel_svg_3.ReactComponent,
    'thin-sterling-sign': sterling_sign_svg_3.ReactComponent,
    'thin-stethoscope': stethoscope_svg_3.ReactComponent,
    'thin-stocking': stocking_svg_3.ReactComponent,
    'thin-stomach': stomach_svg_3.ReactComponent,
    'thin-stop': stop_svg_3.ReactComponent,
    'thin-stopwatch-20': stopwatch_20_svg_3.ReactComponent,
    'thin-stopwatch': stopwatch_svg_3.ReactComponent,
    'thin-store-slash': store_slash_svg_3.ReactComponent,
    'thin-store': store_svg_3.ReactComponent,
    'thin-street-view': street_view_svg_3.ReactComponent,
    'thin-stretcher': stretcher_svg_3.ReactComponent,
    'thin-strikethrough': strikethrough_svg_3.ReactComponent,
    'thin-stroopwafel': stroopwafel_svg_3.ReactComponent,
    'thin-subscript': subscript_svg_3.ReactComponent,
    'thin-suitcase-medical': suitcase_medical_svg_3.ReactComponent,
    'thin-suitcase-rolling': suitcase_rolling_svg_3.ReactComponent,
    'thin-suitcase': suitcase_svg_3.ReactComponent,
    'thin-sun-bright': sun_bright_svg_3.ReactComponent,
    'thin-sun-cloud': sun_cloud_svg_3.ReactComponent,
    'thin-sun-dust': sun_dust_svg_3.ReactComponent,
    'thin-sun-haze': sun_haze_svg_3.ReactComponent,
    'thin-sun': sun_svg_3.ReactComponent,
    'thin-sunglasses': sunglasses_svg_3.ReactComponent,
    'thin-sunrise': sunrise_svg_3.ReactComponent,
    'thin-sunset': sunset_svg_3.ReactComponent,
    'thin-superscript': superscript_svg_3.ReactComponent,
    'thin-swatchbook': swatchbook_svg_3.ReactComponent,
    'thin-sword-laser-alt': sword_laser_alt_svg_3.ReactComponent,
    'thin-sword-laser': sword_laser_svg_3.ReactComponent,
    'thin-sword': sword_svg_3.ReactComponent,
    'thin-swords-laser': swords_laser_svg_3.ReactComponent,
    'thin-swords': swords_svg_3.ReactComponent,
    'thin-symbols': symbols_svg_3.ReactComponent,
    'thin-synagogue': synagogue_svg_3.ReactComponent,
    'thin-syringe': syringe_svg_3.ReactComponent,
    'thin-t': t_svg_3.ReactComponent,
    'thin-table-cells-large': table_cells_large_svg_3.ReactComponent,
    'thin-table-cells': table_cells_svg_3.ReactComponent,
    'thin-table-columns': table_columns_svg_3.ReactComponent,
    'thin-table-layout': table_layout_svg_3.ReactComponent,
    'thin-table-list': table_list_svg_3.ReactComponent,
    'thin-table-pivot': table_pivot_svg_3.ReactComponent,
    'thin-table-rows': table_rows_svg_3.ReactComponent,
    'thin-table-tennis-paddle-ball': table_tennis_paddle_ball_svg_3.ReactComponent,
    'thin-table-tree': table_tree_svg_3.ReactComponent,
    'thin-table': table_svg_3.ReactComponent,
    'thin-tablet-button': tablet_button_svg_3.ReactComponent,
    'thin-tablet-rugged': tablet_rugged_svg_3.ReactComponent,
    'thin-tablet-screen-button': tablet_screen_button_svg_3.ReactComponent,
    'thin-tablet-screen': tablet_screen_svg_3.ReactComponent,
    'thin-tablet': tablet_svg_3.ReactComponent,
    'thin-tablets': tablets_svg_3.ReactComponent,
    'thin-tachograph-digital': tachograph_digital_svg_3.ReactComponent,
    'thin-taco': taco_svg_3.ReactComponent,
    'thin-tag': tag_svg_3.ReactComponent,
    'thin-tags': tags_svg_3.ReactComponent,
    'thin-tally-1': tally_1_svg_3.ReactComponent,
    'thin-tally-2': tally_2_svg_3.ReactComponent,
    'thin-tally-3': tally_3_svg_3.ReactComponent,
    'thin-tally-4': tally_4_svg_3.ReactComponent,
    'thin-tally': tally_svg_3.ReactComponent,
    'thin-tape': tape_svg_3.ReactComponent,
    'thin-taxi-bus': taxi_bus_svg_3.ReactComponent,
    'thin-taxi': taxi_svg_3.ReactComponent,
    'thin-teeth-open': teeth_open_svg_3.ReactComponent,
    'thin-teeth': teeth_svg_3.ReactComponent,
    'thin-telescope': telescope_svg_3.ReactComponent,
    'thin-temperature-arrow-down': temperature_arrow_down_svg_3.ReactComponent,
    'thin-temperature-arrow-up': temperature_arrow_up_svg_3.ReactComponent,
    'thin-temperature-empty': temperature_empty_svg_3.ReactComponent,
    'thin-temperature-full': temperature_full_svg_3.ReactComponent,
    'thin-temperature-half': temperature_half_svg_3.ReactComponent,
    'thin-temperature-high': temperature_high_svg_3.ReactComponent,
    'thin-temperature-list': temperature_list_svg_3.ReactComponent,
    'thin-temperature-low': temperature_low_svg_3.ReactComponent,
    'thin-temperature-quarter': temperature_quarter_svg_3.ReactComponent,
    'thin-temperature-snow': temperature_snow_svg_3.ReactComponent,
    'thin-temperature-sun': temperature_sun_svg_3.ReactComponent,
    'thin-temperature-three-quarters': temperature_three_quarters_svg_3.ReactComponent,
    'thin-tenge-sign': tenge_sign_svg_3.ReactComponent,
    'thin-tennis-ball': tennis_ball_svg_3.ReactComponent,
    'thin-terminal': terminal_svg_3.ReactComponent,
    'thin-text-height': text_height_svg_3.ReactComponent,
    'thin-text-size': text_size_svg_3.ReactComponent,
    'thin-text-slash': text_slash_svg_3.ReactComponent,
    'thin-text-width': text_width_svg_3.ReactComponent,
    'thin-text': text_svg_3.ReactComponent,
    'thin-thermometer': thermometer_svg_3.ReactComponent,
    'thin-theta': theta_svg_3.ReactComponent,
    'thin-thumbs-down': thumbs_down_svg_3.ReactComponent,
    'thin-thumbs-up': thumbs_up_svg_3.ReactComponent,
    'thin-thumbtack': thumbtack_svg_3.ReactComponent,
    'thin-ticket-airline': ticket_airline_svg_3.ReactComponent,
    'thin-ticket-simple': ticket_simple_svg_3.ReactComponent,
    'thin-ticket': ticket_svg_3.ReactComponent,
    'thin-tickets-airline': tickets_airline_svg_3.ReactComponent,
    'thin-tilde': tilde_svg_3.ReactComponent,
    'thin-timeline-arrow': timeline_arrow_svg_3.ReactComponent,
    'thin-timeline': timeline_svg_3.ReactComponent,
    'thin-timer': timer_svg_3.ReactComponent,
    'thin-tire-flat': tire_flat_svg_3.ReactComponent,
    'thin-tire-pressure-warning': tire_pressure_warning_svg_3.ReactComponent,
    'thin-tire-rugged': tire_rugged_svg_3.ReactComponent,
    'thin-tire': tire_svg_3.ReactComponent,
    'thin-toggle-off': toggle_off_svg_3.ReactComponent,
    'thin-toggle-on': toggle_on_svg_3.ReactComponent,
    'thin-toilet-paper-blank-under': toilet_paper_blank_under_svg_3.ReactComponent,
    'thin-toilet-paper-blank': toilet_paper_blank_svg_3.ReactComponent,
    'thin-toilet-paper-slash': toilet_paper_slash_svg_3.ReactComponent,
    'thin-toilet-paper-under-slash': toilet_paper_under_slash_svg_3.ReactComponent,
    'thin-toilet-paper-under': toilet_paper_under_svg_3.ReactComponent,
    'thin-toilet-paper': toilet_paper_svg_3.ReactComponent,
    'thin-toilet': toilet_svg_3.ReactComponent,
    'thin-tombstone-blank': tombstone_blank_svg_3.ReactComponent,
    'thin-tombstone': tombstone_svg_3.ReactComponent,
    'thin-toolbox': toolbox_svg_3.ReactComponent,
    'thin-tooth': tooth_svg_3.ReactComponent,
    'thin-toothbrush': toothbrush_svg_3.ReactComponent,
    'thin-torii-gate': torii_gate_svg_3.ReactComponent,
    'thin-tornado': tornado_svg_3.ReactComponent,
    'thin-tower-broadcast': tower_broadcast_svg_3.ReactComponent,
    'thin-tower-control': tower_control_svg_3.ReactComponent,
    'thin-tractor': tractor_svg_3.ReactComponent,
    'thin-trademark': trademark_svg_3.ReactComponent,
    'thin-traffic-cone': traffic_cone_svg_3.ReactComponent,
    'thin-traffic-light-go': traffic_light_go_svg_3.ReactComponent,
    'thin-traffic-light-slow': traffic_light_slow_svg_3.ReactComponent,
    'thin-traffic-light-stop': traffic_light_stop_svg_3.ReactComponent,
    'thin-traffic-light': traffic_light_svg_3.ReactComponent,
    'thin-trailer': trailer_svg_3.ReactComponent,
    'thin-train-subway-tunnel': train_subway_tunnel_svg_3.ReactComponent,
    'thin-train-subway': train_subway_svg_3.ReactComponent,
    'thin-train-tram': train_tram_svg_3.ReactComponent,
    'thin-train': train_svg_3.ReactComponent,
    'thin-transformer-bolt': transformer_bolt_svg_3.ReactComponent,
    'thin-transgender-alt': transgender_alt_svg_3.ReactComponent,
    'thin-transgender': transgender_svg_3.ReactComponent,
    'thin-transporter-1': transporter_1_svg_3.ReactComponent,
    'thin-transporter-2': transporter_2_svg_3.ReactComponent,
    'thin-transporter-3': transporter_3_svg_3.ReactComponent,
    'thin-transporter-4': transporter_4_svg_3.ReactComponent,
    'thin-transporter-5': transporter_5_svg_3.ReactComponent,
    'thin-transporter-6': transporter_6_svg_3.ReactComponent,
    'thin-transporter-7': transporter_7_svg_3.ReactComponent,
    'thin-transporter-empty': transporter_empty_svg_3.ReactComponent,
    'thin-transporter': transporter_svg_3.ReactComponent,
    'thin-trash-arrow-up': trash_arrow_up_svg_3.ReactComponent,
    'thin-trash-can-arrow-up': trash_can_arrow_up_svg_3.ReactComponent,
    'thin-trash-can-clock': trash_can_clock_svg_3.ReactComponent,
    'thin-trash-can-list': trash_can_list_svg_3.ReactComponent,
    'thin-trash-can-slash': trash_can_slash_svg_3.ReactComponent,
    'thin-trash-can-undo': trash_can_undo_svg_3.ReactComponent,
    'thin-trash-can': trash_can_svg_3.ReactComponent,
    'thin-trash-clock': trash_clock_svg_3.ReactComponent,
    'thin-trash-list': trash_list_svg_3.ReactComponent,
    'thin-trash-slash': trash_slash_svg_3.ReactComponent,
    'thin-trash-undo': trash_undo_svg_3.ReactComponent,
    'thin-trash': trash_svg_3.ReactComponent,
    'thin-treasure-chest': treasure_chest_svg_3.ReactComponent,
    'thin-tree-christmas': tree_christmas_svg_3.ReactComponent,
    'thin-tree-deciduous': tree_deciduous_svg_3.ReactComponent,
    'thin-tree-decorated': tree_decorated_svg_3.ReactComponent,
    'thin-tree-large': tree_large_svg_3.ReactComponent,
    'thin-tree-palm': tree_palm_svg_3.ReactComponent,
    'thin-tree': tree_svg_3.ReactComponent,
    'thin-trees': trees_svg_3.ReactComponent,
    'thin-triangle-exclamation': triangle_exclamation_svg_3.ReactComponent,
    'thin-triangle-instrument': triangle_instrument_svg_3.ReactComponent,
    'thin-triangle-person-digging': triangle_person_digging_svg_3.ReactComponent,
    'thin-triangle': triangle_svg_3.ReactComponent,
    'thin-trophy-star': trophy_star_svg_3.ReactComponent,
    'thin-trophy': trophy_svg_3.ReactComponent,
    'thin-truck-clock': truck_clock_svg_3.ReactComponent,
    'thin-truck-container-empty': truck_container_empty_svg_3.ReactComponent,
    'thin-truck-container': truck_container_svg_3.ReactComponent,
    'thin-truck-fast': truck_fast_svg_3.ReactComponent,
    'thin-truck-flatbed': truck_flatbed_svg_3.ReactComponent,
    'thin-truck-front': truck_front_svg_3.ReactComponent,
    'thin-truck-medical': truck_medical_svg_3.ReactComponent,
    'thin-truck-monster': truck_monster_svg_3.ReactComponent,
    'thin-truck-moving': truck_moving_svg_3.ReactComponent,
    'thin-truck-pickup': truck_pickup_svg_3.ReactComponent,
    'thin-truck-plow': truck_plow_svg_3.ReactComponent,
    'thin-truck-ramp-box': truck_ramp_box_svg_3.ReactComponent,
    'thin-truck-ramp-couch': truck_ramp_couch_svg_3.ReactComponent,
    'thin-truck-ramp': truck_ramp_svg_3.ReactComponent,
    'thin-truck-tow': truck_tow_svg_3.ReactComponent,
    'thin-truck': truck_svg_3.ReactComponent,
    'thin-trumpet': trumpet_svg_3.ReactComponent,
    'thin-tshirt': tshirt_svg_3.ReactComponent,
    'thin-tty-answer': tty_answer_svg_3.ReactComponent,
    'thin-tty': tty_svg_3.ReactComponent,
    'thin-tugrik-sign': tugrik_sign_svg_3.ReactComponent,
    'thin-turkey': turkey_svg_3.ReactComponent,
    'thin-turkish-lira-sign': turkish_lira_sign_svg_3.ReactComponent,
    'thin-turn-down': turn_down_svg_3.ReactComponent,
    'thin-turn-up': turn_up_svg_3.ReactComponent,
    'thin-turntable': turntable_svg_3.ReactComponent,
    'thin-turtle': turtle_svg_3.ReactComponent,
    'thin-tv-music': tv_music_svg_3.ReactComponent,
    'thin-tv-retro': tv_retro_svg_3.ReactComponent,
    'thin-tv': tv_svg_3.ReactComponent,
    'thin-typewriter': typewriter_svg_3.ReactComponent,
    'thin-u': u_svg_3.ReactComponent,
    'thin-ufo-beam': ufo_beam_svg_3.ReactComponent,
    'thin-ufo': ufo_svg_3.ReactComponent,
    'thin-umbrella-beach': umbrella_beach_svg_3.ReactComponent,
    'thin-umbrella-simple': umbrella_simple_svg_3.ReactComponent,
    'thin-umbrella': umbrella_svg_3.ReactComponent,
    'thin-underline': underline_svg_3.ReactComponent,
    'thin-unicorn': unicorn_svg_3.ReactComponent,
    'thin-union': union_svg_3.ReactComponent,
    'thin-universal-access': universal_access_svg_3.ReactComponent,
    'thin-unlock-keyhole': unlock_keyhole_svg_3.ReactComponent,
    'thin-unlock': unlock_svg_3.ReactComponent,
    'thin-up-down-left-right': up_down_left_right_svg_3.ReactComponent,
    'thin-up-down': up_down_svg_3.ReactComponent,
    'thin-up-from-line': up_from_line_svg_3.ReactComponent,
    'thin-up-left': up_left_svg_3.ReactComponent,
    'thin-up-long': up_long_svg_3.ReactComponent,
    'thin-up-right-and-down-left-from-center': up_right_and_down_left_from_center_svg_3.ReactComponent,
    'thin-up-right-from-square': up_right_from_square_svg_3.ReactComponent,
    'thin-up-right': up_right_svg_3.ReactComponent,
    'thin-up-to-line': up_to_line_svg_3.ReactComponent,
    'thin-up': up_svg_3.ReactComponent,
    'thin-upload': upload_svg_3.ReactComponent,
    'thin-usb-drive': usb_drive_svg_3.ReactComponent,
    'thin-user-alien': user_alien_svg_3.ReactComponent,
    'thin-user-astronaut': user_astronaut_svg_3.ReactComponent,
    'thin-user-bounty-hunter': user_bounty_hunter_svg_3.ReactComponent,
    'thin-user-check': user_check_svg_3.ReactComponent,
    'thin-user-clock': user_clock_svg_3.ReactComponent,
    'thin-user-cowboy': user_cowboy_svg_3.ReactComponent,
    'thin-user-crown': user_crown_svg_3.ReactComponent,
    'thin-user-doctor-message': user_doctor_message_svg_3.ReactComponent,
    'thin-user-doctor': user_doctor_svg_3.ReactComponent,
    'thin-user-gear': user_gear_svg_3.ReactComponent,
    'thin-user-graduate': user_graduate_svg_3.ReactComponent,
    'thin-user-group-crown': user_group_crown_svg_3.ReactComponent,
    'thin-user-group': user_group_svg_3.ReactComponent,
    'thin-user-headset': user_headset_svg_3.ReactComponent,
    'thin-user-helmet-safety': user_helmet_safety_svg_3.ReactComponent,
    'thin-user-injured': user_injured_svg_3.ReactComponent,
    'thin-user-large-slash': user_large_slash_svg_3.ReactComponent,
    'thin-user-large': user_large_svg_3.ReactComponent,
    'thin-user-lock': user_lock_svg_3.ReactComponent,
    'thin-user-minus': user_minus_svg_3.ReactComponent,
    'thin-user-music': user_music_svg_3.ReactComponent,
    'thin-user-ninja': user_ninja_svg_3.ReactComponent,
    'thin-user-nurse': user_nurse_svg_3.ReactComponent,
    'thin-user-pen': user_pen_svg_3.ReactComponent,
    'thin-user-pilot-tie': user_pilot_tie_svg_3.ReactComponent,
    'thin-user-pilot': user_pilot_svg_3.ReactComponent,
    'thin-user-plus': user_plus_svg_3.ReactComponent,
    'thin-user-robot': user_robot_svg_3.ReactComponent,
    'thin-user-secret': user_secret_svg_3.ReactComponent,
    'thin-user-shakespeare': user_shakespeare_svg_3.ReactComponent,
    'thin-user-shield': user_shield_svg_3.ReactComponent,
    'thin-user-slash': user_slash_svg_3.ReactComponent,
    'thin-user-tag': user_tag_svg_3.ReactComponent,
    'thin-user-tie': user_tie_svg_3.ReactComponent,
    'thin-user-unlock': user_unlock_svg_3.ReactComponent,
    'thin-user-visor': user_visor_svg_3.ReactComponent,
    'thin-user-xmark': user_xmark_svg_3.ReactComponent,
    'thin-user': user_svg_3.ReactComponent,
    'thin-users-gear': users_gear_svg_3.ReactComponent,
    'thin-users-medical': users_medical_svg_3.ReactComponent,
    'thin-users-slash': users_slash_svg_3.ReactComponent,
    'thin-users': users_svg_3.ReactComponent,
    'thin-utensils': utensils_svg_3.ReactComponent,
    'thin-utility-pole-double': utility_pole_double_svg_3.ReactComponent,
    'thin-utility-pole': utility_pole_svg_3.ReactComponent,
    'thin-v': v_svg_3.ReactComponent,
    'thin-vacuum-robot': vacuum_robot_svg_3.ReactComponent,
    'thin-vacuum': vacuum_svg_3.ReactComponent,
    'thin-value-absolute': value_absolute_svg_3.ReactComponent,
    'thin-van-shuttle': van_shuttle_svg_3.ReactComponent,
    'thin-vault': vault_svg_3.ReactComponent,
    'thin-vector-circle': vector_circle_svg_3.ReactComponent,
    'thin-vector-polygon': vector_polygon_svg_3.ReactComponent,
    'thin-vector-square': vector_square_svg_3.ReactComponent,
    'thin-venus-double': venus_double_svg_3.ReactComponent,
    'thin-venus-mars': venus_mars_svg_3.ReactComponent,
    'thin-venus': venus_svg_3.ReactComponent,
    'thin-vest-patches': vest_patches_svg_3.ReactComponent,
    'thin-vest': vest_svg_3.ReactComponent,
    'thin-vial': vial_svg_3.ReactComponent,
    'thin-vials': vials_svg_3.ReactComponent,
    'thin-video-arrow-down-left': video_arrow_down_left_svg_3.ReactComponent,
    'thin-video-arrow-up-right': video_arrow_up_right_svg_3.ReactComponent,
    'thin-video-plus': video_plus_svg_3.ReactComponent,
    'thin-video-slash': video_slash_svg_3.ReactComponent,
    'thin-video': video_svg_3.ReactComponent,
    'thin-vihara': vihara_svg_3.ReactComponent,
    'thin-violin': violin_svg_3.ReactComponent,
    'thin-virus-slash': virus_slash_svg_3.ReactComponent,
    'thin-virus': virus_svg_3.ReactComponent,
    'thin-viruses': viruses_svg_3.ReactComponent,
    'thin-voicemail': voicemail_svg_3.ReactComponent,
    'thin-volcano': volcano_svg_3.ReactComponent,
    'thin-volleyball-ball': volleyball_ball_svg_3.ReactComponent,
    'thin-volume-high': volume_high_svg_3.ReactComponent,
    'thin-volume-low': volume_low_svg_3.ReactComponent,
    'thin-volume-off': volume_off_svg_3.ReactComponent,
    'thin-volume-slash': volume_slash_svg_3.ReactComponent,
    'thin-volume-xmark': volume_xmark_svg_3.ReactComponent,
    'thin-volume': volume_svg_3.ReactComponent,
    'thin-vr-cardboard': vr_cardboard_svg_3.ReactComponent,
    'thin-w': w_svg_3.ReactComponent,
    'thin-wagon-covered': wagon_covered_svg_3.ReactComponent,
    'thin-walker': walker_svg_3.ReactComponent,
    'thin-walkie-talkie': walkie_talkie_svg_3.ReactComponent,
    'thin-wallet': wallet_svg_3.ReactComponent,
    'thin-wand-magic-sparkles': wand_magic_sparkles_svg_3.ReactComponent,
    'thin-wand-magic': wand_magic_svg_3.ReactComponent,
    'thin-wand-sparkles': wand_sparkles_svg_3.ReactComponent,
    'thin-wand': wand_svg_3.ReactComponent,
    'thin-warehouse-full': warehouse_full_svg_3.ReactComponent,
    'thin-warehouse': warehouse_svg_3.ReactComponent,
    'thin-washing-machine': washing_machine_svg_3.ReactComponent,
    'thin-watch-apple': watch_apple_svg_3.ReactComponent,
    'thin-watch-calculator': watch_calculator_svg_3.ReactComponent,
    'thin-watch-fitness': watch_fitness_svg_3.ReactComponent,
    'thin-watch-smart': watch_smart_svg_3.ReactComponent,
    'thin-watch': watch_svg_3.ReactComponent,
    'thin-water-arrow-down': water_arrow_down_svg_3.ReactComponent,
    'thin-water-arrow-up': water_arrow_up_svg_3.ReactComponent,
    'thin-water-ladder': water_ladder_svg_3.ReactComponent,
    'thin-water': water_svg_3.ReactComponent,
    'thin-wave-pulse': wave_pulse_svg_3.ReactComponent,
    'thin-wave-sine': wave_sine_svg_3.ReactComponent,
    'thin-wave-square': wave_square_svg_3.ReactComponent,
    'thin-wave-triangle': wave_triangle_svg_3.ReactComponent,
    'thin-waveform-lines': waveform_lines_svg_3.ReactComponent,
    'thin-waveform': waveform_svg_3.ReactComponent,
    'thin-weight-hanging': weight_hanging_svg_3.ReactComponent,
    'thin-weight-scale': weight_scale_svg_3.ReactComponent,
    'thin-whale': whale_svg_3.ReactComponent,
    'thin-wheat-awn': wheat_awn_svg_3.ReactComponent,
    'thin-wheat': wheat_svg_3.ReactComponent,
    'thin-wheelchair-move': wheelchair_move_svg_3.ReactComponent,
    'thin-wheelchair': wheelchair_svg_3.ReactComponent,
    'thin-whiskey-glass-ice': whiskey_glass_ice_svg_3.ReactComponent,
    'thin-whiskey-glass': whiskey_glass_svg_3.ReactComponent,
    'thin-whistle': whistle_svg_3.ReactComponent,
    'thin-wifi-exclamation': wifi_exclamation_svg_3.ReactComponent,
    'thin-wifi-fair': wifi_fair_svg_3.ReactComponent,
    'thin-wifi-slash': wifi_slash_svg_3.ReactComponent,
    'thin-wifi-weak': wifi_weak_svg_3.ReactComponent,
    'thin-wifi': wifi_svg_3.ReactComponent,
    'thin-wind-turbine': wind_turbine_svg_3.ReactComponent,
    'thin-wind-warning': wind_warning_svg_3.ReactComponent,
    'thin-wind': wind_svg_3.ReactComponent,
    'thin-window-flip': window_flip_svg_3.ReactComponent,
    'thin-window-frame-open': window_frame_open_svg_3.ReactComponent,
    'thin-window-frame': window_frame_svg_3.ReactComponent,
    'thin-window-maximize': window_maximize_svg_3.ReactComponent,
    'thin-window-minimize': window_minimize_svg_3.ReactComponent,
    'thin-window-restore': window_restore_svg_3.ReactComponent,
    'thin-window': window_svg_3.ReactComponent,
    'thin-windsock': windsock_svg_3.ReactComponent,
    'thin-wine-bottle': wine_bottle_svg_3.ReactComponent,
    'thin-wine-glass-crack': wine_glass_crack_svg_3.ReactComponent,
    'thin-wine-glass-empty': wine_glass_empty_svg_3.ReactComponent,
    'thin-wine-glass': wine_glass_svg_3.ReactComponent,
    'thin-won-sign': won_sign_svg_3.ReactComponent,
    'thin-wreath': wreath_svg_3.ReactComponent,
    'thin-wrench-simple': wrench_simple_svg_3.ReactComponent,
    'thin-wrench': wrench_svg_3.ReactComponent,
    'thin-x-ray': x_ray_svg_3.ReactComponent,
    'thin-x': x_svg_3.ReactComponent,
    'thin-xmark-to-slot': xmark_to_slot_svg_3.ReactComponent,
    'thin-xmark': xmark_svg_3.ReactComponent,
    'thin-y': y_svg_3.ReactComponent,
    'thin-yen-sign': yen_sign_svg_3.ReactComponent,
    'thin-yin-yang': yin_yang_svg_3.ReactComponent,
    'thin-z': z_svg_3.ReactComponent,
};
exports.default = iconMap;
